(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [];


// symbols:



(lib.Bitmap5 = function() {
	this.initialize(img.Bitmap5);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,305,166);


(lib.Bitmap9 = function() {
	this.initialize(img.Bitmap9);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,307,260);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.YesText = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("Ah5A+IgDgBQgGAAABgHIACgTIAAgBIAAgFIAAgEIABgHQAAgMgHgBQABgEgDAAQAAAAAAgBQgBAAAAAAQAAAAAAgBQAAAAAAgBIAAgBQAAAAgBAAQAAAAgBgBQAAAAAAgBQgBAAABAAIgBgCQgDgFgCgCIAAgBIgCgFQgEgDAAgCQgDgIgDgDIgEgFIgCgEIgDgDIgCgEIAEgEIACgBIAGABQAAABABAAQAAAAABAAQAAAAABAAQAAAAABAAIACgBIAHAAIACgBIAEACIABgBQAAABAAAAQABAAAAAAQAAAAAAABQAAAAAAAAQAFABADAKQAIAGACAIIAAAAQgBACAIAKQAAABAAAAQAAAAAAABQAAAAAAAAQAAAAABAAQABAFAHAKIACAEQADAEgBACQADAIgCAPIAAABIAAAQIAAACIAAAFIAAACIgCABIgDgBIgCABQgBAAAAAAQgBgBAAABQAAAAgBAAQAAAAAAAAIgDgBIgBAAIgBABIgBAAIgEgBIgBACIgCgBIgDACgABjA9IgCgBIgBAAIgFgBQgEgBgBgCQgEgEgDAAQgDgBgBgEIABgEQAHgGADAAQABAAADADIACACIAMAGQAAAAAAAAQABAAAAAAQABAAAAAAQABABABAAQAAAAAAAAQABAAAAABQAAAAAAABQAAAAAAABIAAABIgBACIAAABQAAADgDABQAAABgFABIgBgBgACCA8IgDgCIAAgBIgBgCIAAgBIABgFIAAgBQABgBAAAAQAAAAAAAAQAAgBAAAAQAAAAAAgBQADgFADgBQAGgEAAgJIgBgFQgEgIgCABIgDgCIAAgCIgDAAIgBgBIgDABQgHgDgFAAIgCAAQgEgBgBgCQgLgDgBgBIgJgEIAAAAIgEgBQgBgBAAgBQAAgBgBAAQAAgBgBAAQAAAAgBAAQAAgBAAAAQAAgBAAAAQgBgBAAAAQAAgBgBAAQgBgIgBgBIABgGIABgGIAEgHQACgBACgEIAMgGIAHAAIAIgBIADABIADAHIAAAGQgCAEgCABQgBACgDAAIgCACIgBAGQAAAAAAABQAAAAABABQAAAAAAABQABAAAAABQAEAEANAAIALABIAOAFQABADAFABIAFADQAAADAFABIAFATIgBAIIgCAMQgBAFgHAEIgEAGQgNAGgIAAgAAvA7IgIgDIgEAAIgHABIgFgCIAAgCIgBgBQACgDgDgEIAAgCQACgJACgCIAHgBIACAAIAVACIAEABQABACgBAFQgBADABAGIABACIgCACIgCAEIgCgBIgCACQgBgEgCAAIAAABIAAABQAAAAAAABQAAAAAAAAQAAAAgBAAQAAABgBAAIAAAAgAghAxQABgFgBgPIABgBIABAJIgBAKIABADIABgBQAAAAAAgBQAAAAAAgBQAAAAAAAAQAAgBAAAAIACgFIgBgBQACgEABgCIgBgCQAAAAAAgBQgBAAAAgBQAAAAgBAAQAAgBAAAAIgBgPIAAgGQAAgBAAgBQAAAAAAgBQAAgBAAAAQgBAAAAAAIgBABIgBgBIAAgCIAAgCIABgBIABABIABAAIAAgCIgDgCIAAgEIAAgCIABgDIgBgYIABgCQAAAAAAAAQAAgBAAAAQAAgBAAAAQABgBAAAAQAAAAAAAAQABgBAAAAQAAAAAAgBQAAAAAAgBIgBgBIgBACIAAgBIAAgDIgBgJQAEgEACAAIAEABIAPgBIAIABQAEABAAALIgBAGQABAEgCAIQABAJABABIAAAFQAAAFAFAAQABgBANAAIALAAQAEgBAIAAIAHABQAFAFgCAKIgCAIIgJACIgEAAQgBAAgBAAQgBAAAAAAQgBAAAAgBQgBAAAAAAIgCABIgRAAIgCgBQgCAAgHgBQAAABgBAAQAAAAgBABQAAAAgBAAQAAAAgBAAQgDACAAAFIABAFQgBAOABAFIAAAHIgBAEIgOABIgBAAIgCAAIgBAAQAAAAAAAAQAAAAgBAAQAAAAAAAAQAAAAgBABIgEAAIAAAAQgHAAgBgJgAgNA1IgBACIADAAQAKAAAAgDIgBgEIgBgDQAAAAAAABQgBAAAAAAQAAABAAABQAAAAAAABIgBAAQAAAHgFgEgAgVAxIABABQAAAAAAAAQAAAAABgBQAAAAAAAAQAAgBAAAAIAAgDIgBgBgAAVAMIACgBIACAAIgCgBQgEgDgDAAIgCAAIAAABQAAABAAABQAAAAABABQAAAAABAAQABAAABAAIABAAIACABgAAvALIAEAAQAAAAABAAQAAAAABAAQAAAAAAgBQAAAAAAAAIAAgDIgBAAQgBACgEACgAAJgHIAAABIADABIAAAAIAAgBIgBgBgAhQgMQgCgEgCAAIgCgEIgCgEIgBgCQgCgEAAgCIAAgDQABgDAEgDQAFgDABgDIACgCIAIgFIAIAAIASAGIgJANQgBACgFADIgCADIgEADQgHAJgGACQAAAAAAAAQAAAAAAAAQAAABgBAAQAAAAgBAAIAAAAgAgzgwIAAABQAAAAAAAAQgBABAAAAQAAAAABABQAAAAAAAAQAAABgBAAQAAABAAAAQAAABgBABQAAAAAAABIABAAIADgCQAAgBABAAQAAgBAAAAQAAgBAAAAQAAAAAAgBIAAAAIgCgCIgBAAgACZgkQgBgEgLgBIgEgBQgDgFAAgDIAAgBIAHgGIACABQACAAAPAHQABADAEADIABAEQAAAGgHAAIAAAAIgGgDgAAzgjIgFAAIgCgBIgCACIgLgCIgBAAIgEgCIgBgHIAAgCIACgKQAGgGAEADIADABIAGgBIAFgBIAIABQACACAAAFIgCAFIACABIABAEIgCAHIgIACgAA4gmIAAAAIABABIABgCIAAgCIgCAAgAAbgsQABADAEACIAAgDIgEgDg");
	this.shape.setTransform(2.7499,-0.225);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-14,-6.4,33.6,12.4);


(lib.Tween8 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("Ah1BRIAAihIDrAAIAAChg");
	this.shape.setTransform(0,-0.025);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.8,-8.1,23.6,16.2);


(lib.Tween3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FF0000").s().p("AgQAAQAAgRAQAAQARAAAAARQAAASgRAAQgQAAAAgSg");
	this.shape.setTransform(6.5375,-0.375);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FF0000").s().p("AgaAAQAAgYAaAAQAbAAAAAYQAAAZgbAAQgaAAAAgZg");
	this.shape_1.setTransform(-6.2859,0.376,0.7124,0.7124);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.2,-2.1,16.4,4.300000000000001);


(lib.Symbol75 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("AnpB4IAAjvIPTAAIAADvg");
	this.shape.setTransform(0.025,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-48.9,-12,97.9,24);


(lib.Symbol66 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgaAbIAAg1IA1AAIAAA1g");
	this.shape.setTransform(-5.5625,5.7125);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AgWAWIAAgsIAtAAIAAAsg");
	this.shape_1.setTransform(5.514,-5.7345,1.1831,1.1831);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgaAbIAAg1IA1AAIAAA1g");
	this.shape_2.setTransform(-0.0625,-0.225);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.2,-8.4,16.4,16.8);


(lib.Symbol4 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(0,0,0,0.988)").s().p("A7GW5MAAAgtxMA2NAAAMAAAAtxg");
	this.shape.setTransform(173.5,146.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Symbol4, new cjs.Rectangle(0,0,347,293.1), null);


(lib.SubmitScoreButton = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AATAwIgBAAIgBAAIgBgDIABgBIAAgBIgBgCIAAgBIgCgBIgBAAIgBAAIgBABIAAAAIAAgBIAAgBIgBAAIgCgCQAAAAgBgBQAAAAAAAAQAAAAAAgBQAAAAAAgBIAAAAIAAgBIABABIABABIAAAAIAAgBIAAgBIAAgBIgDgCIgDgBIgCgEIgBgDIAAAAIgBAAIAAgCIgBgCQAAAAAAAAQgBAAAAAAQAAAAAAgBQAAAAABAAIgBgBIgBABIgBgDIACAAIgBgBIAAgBQAAgBAAAAQAAgBAAAAQABgBAAAAQAAAAABgBIACgBIADgBQAAAAABAAQAAAAAAgBQABAAAAAAQABgBAAAAIADgDIABgEIABAAIABgBIAAgCIABgCQAAAAAAAAQABAAAAgBQAAAAAAAAQAAgBAAAAIAAgBIAAAAIAAgBIgCgBIAAgEIgBgCIgCgCIgBgDIgDgBIAAgBIgBgBIgBAAIAAABIgBAAIgCgBIAAgBIgCgBIgDgBIgBgBIAAgBIAAgCIAAgCIAAgCIAAgCIgBgCIACgDIACgBIACAAIABAAIAAAAIACAAIAFAAIAEgBIABAAIACABIACAAIADAAIABAAIACgBIADABIADABIAGAAIAEACIAAACIgBABIgBAAIAAAAIAAABIACAAIABABIABABIABACIAAABIACAAIABADIABACIABAEIACAEIABAEIgBAFIAAAFIgGAFIgBABIgBABIgBABIgCABIgCAAIgBACIgCACIAAgBIgBAAIgCABIgBABIgBACIgBAAIgCACQAAAAgBAAQAAAAAAAAQAAAAAAAAQAAAAAAABIAAAAIAAAAQAAAAAAAAQABAAAAAAQAAABAAAAQAAAAAAABIABAAIABAAIAAgCIABACIABABIgBACIACABIAAAAIABAAIACAAIAAABIgBABIgBAAIACACIABABIACABIAAACIACACIABADIABACIAAAAIgBAAIgBAAIAAAAIgBAAIAAABIAAAAIAAABIABACIACACIABABIAAAAIAAABIABABIABABIAAABIgBABIgCABIgCAAIgCABIgBgBIgBgBIgBABIgCABIgCAAIgBACIAAAAIgBgBIgBgBIgCABIAAABIgCAAIgBABgAAdAoIAAABIACAAIABAAIABAAIABgBIgBAAIgBgBgAgnAvIgDABIgCgCIgBgCIAAABIAAABIAAABIgCgBIAAgCIAAgDIABgDIgBgFIAAgEIAAgBIAAgCIAAgCIABgBIAAAAIAAgBIgBAAIAAgCIgBgCIAAgBIABgBIgBgDIABgEIABABIAAACIAAAAIAAABIABgDIAAgEIAAgDIAAgBIABgCIgBgBIgCAAIAAgBIABgBIAAgBIAAgBIAAgBIAAgDIgBgCIABgDIAAgDIAAgDIgBgJIABgKIgBAAIAAgBQAAgBAAAAQAAgBAAAAQAAAAAAAAQABgBAAAAIADgCIAEAAIAFAAIAHAAIADACIADACIABACIAAAAIgBAEIAAAEIAAAAIgBABIgBACIABAAIABABIAAABIAAAEIgCAGIgBAEIAAACIAAACIAAADIgBADIABABIABABIgBAAIAAACQAAAAAAAAQAAAAAAAAQAAABAAAAQAAAAgBAAIABACIgBACIAAAEIAAABIAAABIAAADIAAADIABACIAAABIAAAAIAAADIgBADIAAADQAAAAAAAAQAAABAAAAQAAABAAAAQAAABAAAAIgBADIAAADIAAABIAAABIgBABIgBAAIgBACIABABIgBABIAAAAIgCAAIgBgBIgBAAIgBABIgCABIgDgBgAAtArIAAgDIgCgCIABgBIAAAAIABABIABACIABABIAAACIAAABIAAAAIgBABIgBgCg");
	this.shape.setTransform(122.9,12.6);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AA2AxIgBgBIgBABIgBABIgBAAIgBAAIgCAAIgCAAIgBgBIgCAAIgBgBIgCAAIgBACIgBAAIgCgBIgCgCIAAAAIgBgBIAAgBIAAgBIgBgCIgBgBIAAgCIgBgCIgCgCIgBgDIAAgBIgBgCIgCgDIgBgDIAAgBIABgBIgBgBIgBAAIgBgBIABgCIAAgBIgBAAIgCgBIAAgCIgCgBIgBgCIAAgCIgBgBIAAgCIgCgDIgBgCIAAgBIgBgBIAAgBIgBgCQAAAAAAgBQgBAAAAAAQAAgBAAAAQAAAAAAgBIgBgCIAAgCIgBAAIgBgCIABgBIgBgBIgBAAIAAgCIAAgBIgBgBIAAgBIgCgDIAAgDIgBgBIAAgCIgBgBIgBgDIAAgCIgBgDIgBgCQAAAAAAAAQAAAAAAgBQAAAAAAAAQAAAAgBAAQAAgBABAAQAAgBAAAAQAAAAABgBQAAAAABgBIADgCIAEgBIACAAIACABIADgBIAEAAIADABIAEAAIACABIAAABIABACIABACIACADIABAEIACADIAAABIABACIACAEIACAEIADAGIABAEIACADIACAFIADAFIABADIADAGIAEAJIABAHIAAABIABAAIABACIAAACIgBACIgBACIABACIABAEIABADIAAABIgBACIgCABIgCABIgBgBgAgCgrIAAAAIABACIABABIAAAAIAAgCIAAgBIgBgBgAggAyIgBgBIgCAAIAAABIgBAAIgBAAIgCgBIgEAAIgDgBIgCAAIgBAAIgCABIgCAAIgCAAIgCAAIgCgBIAAgBIABgDIABgCIACgDIABgDIACgCIABgCQAAAAAAAAQABAAAAAAQAAAAABAAQAAAAAAAAIABgDIABgCIABgBIAAgBIAAgBIABgBIACgDIABgCIABgDIACgDIABgCIAAgCIADgFIADgFIABgBIABgCIABgCIABgCIAEgFIADgGIABgDIACgDIABgBIABAAIABABIABADIACADIABADIABACIACAFIACAEIABACIABACIAAABIABABIABABIABADIABAEIABAFIACAEIABAEIABADIABABIABABIABADIABADIgBABIAAABIgCAAIgBABIgFgBIgFAAIgEgBIgBgBIAAgBIgBABIAAAAIAAABIgBABIgCAAIgDAAIgCACIgBABIgBAAIgBADIgBABIgBADIAAABIgCAAIAAACIgBABIgBAAIgBABIgBABIgCAAgAgyAkIgCADIgBACIgBADIgBAAIgBACIABABIACAAIABAAIgBgBIgBgBIACgEIADgFIABgEIAAAAIgCAEgAgsAmIgBABIAAACIABAAIABAAIAAgBIAAgBIAAgBIAAgCIgBACgAgOAhIAAAAIgBgBIAAABIABAAIAAAAIAAAAIAAAAgAgDAeIgBABIABABIACABIABgCIgBgBIgCAAgAACAfIADABIAAgBIAAgBIgCgBg");
	this.shape_1.setTransform(111.075,12.2667);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AAWAyIgCAAIgCAAIgDgCIgCgBIgBgCIAAgCIAAgDIABgCIAAgCIAGgDIAFgEIADgBIACgCIABgBIABgBIACgEIABgCIABgDQAAAAAAAAQABgBAAAAQAAAAABAAQAAAAABAAIACABIACAAIABAAIACABIABABIAAABIAAACIAAADIAAACIgBABIAAAAIgBAEIgCAEIgCACIgBADIgBAAIgBACIgBACIgCABIgDABIgBABIgDABIgBADIgCAAIgCAAgAAYAwIgBAAIABAAIABgBgAgMAvIgCgBIAAAAIgBAAIgBAAIgDAAIgEgDIgFgFIgDgCIgBAAIAAABIgBAAIAAAAIgBgBIgCgCIABAAIgCgBIAAgBIgCgDIgBgDIAAAAIAAgBIAAgBIgBgBIAAgDIgCgCIAAgBIgBgCIAAgBIAAgHIAAgHIgBAAIAAgBIABgDIAAgDIABgBIAAgCIgBgBIgCABIAAAAIACgCIABgCIAAgBIgBAAIABgCIACABIABgCIABgFIACgCIgBgBIgBAAIABgCIABgBIACgDIACgCIABgBIABAAIACgCIACgCIAAgBIABgCIACAAIACgCIAFgBIAFgCIACgBIAEAAIAAgBIABAAIADABIAAABIABACIAAABIAAAAIAAABIAAAAIABAAIAAADIgDAEIgBACIgCACIgDABIgCACIgBABIgBABIgBABIgBABIgCADIgCAEIgCACIgBACIgBADIAAAGIgBAGIAAAGIABAHIABADIACADIACADIABACIACABQAAABABAAQAAAAAAAAQAAAAAAAAQAAABAAAAIADACIAEADQAAAAAAABQAAAAABABQAAAAAAABQAAABAAAAIABAFIgBACIAAABIgBACIgDABIgCgBgAgMArIAAADIACAAIACgBIAAgBIgBgCIgBAAIgBAAIgBABgAgugIIAAAAIAAAAgAAngUIgCAAIgDAAIgCABIgCgBIgCgDIgCgCIgCgCIgDgCIgCgDIgBgDIgBgCIABgFIAAgDIACgDIABAAIABAAIABAAIAGABIAEACIADACIACACIABACQAAAAAAABQAAAAAAAAQABAAAAAAQAAABAAAAIABACIACAAIACACIABACIAAACIABACIAAACIAAAEIgBABIgBABIgFAAIgBgBgAAsgYIAAABIgBACIABABIABgCIABgCIAAgBIgBgBgAAcgYIACADIACABIABAAIAAgBIgBAAIgBgBIgBgCIgCgBgAgogXIAAgBIABgBIAAABIgBABIAAAAIAAACg");
	this.shape_2.setTransform(99.55,12.2);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("AgSAxIAAABIgDgBIgCgBIgBgBIgBgBIgCgBIgDgCIgDgBIgBgBIgBgBIgBgCIAAgBIABgCIACgDQABgBABAAQAAAAABgBQAAAAABAAQAAAAABAAIADAAIABACIABABIABABIADACIADABIAEABIACABIABAAIABABIABACIgBABIAAABIAAABIAAAAIAAABIgBACIgDABIgCABIgCABgAAKAyIgCgBIgBgCIAAAAIAAgBIAAgBIgBgBIABgCIAAgCIAAgCIABAAIAAgBIACgDIACgDQADgCACgDQABgCAAgEIAAgCIgBgCIgBgCIgDgDQAAAAAAAAQAAgBgBAAQAAAAAAAAQAAAAgBAAIgBgBIgBgBIABgCIgDABIgCgBIgBAAIgBAAIgDgBIgGgBIgBAAIAAAAIgCgBIgBAAIgDgBIgFgBQgDgBgCgBIgDgCIgEgCIgCgBIgBAAIgBgCIgCgBIgBgCIgBgCIgBgEQAAAAAAgBQAAAAAAgBQAAAAAAgBQgBAAAAgBIAAgCIAAgDIABgCIAAgDQABAAAAAAQABgBAAAAQAAAAABgBQAAAAAAgBIACgDIABgCQAAAAAAAAQABgBAAAAQAAAAAAAAQABAAAAAAIADgCIADgDIADgCIAEABIACAAIAEgBIAEAAIABAAIABABIABADIABADIAAADIAAACIgBADIgCABIgBACIgCAAIgDACIAAABIAAACIAAABIAAABIABACIABABIAEADIAGABIADAAIAFAAIAEABIAEABIAFACIAEABIACABIACABIABABIABACIACABIACACIACABIABABIACAHIACAIIAAADIAAADIgCAGIAAAFIgCAEIgFAEIgCADIgBACIgJADQgEACgFAAgAAfgeIgCgCIgCgDIgFgBIgDgBIgCgBIgBAAIgDgDIgBgDIAAgBIAEgDQAAgBAAAAQAAAAABAAQAAgBABAAQAAAAABAAIAAAAIABABIAFAAIAFADIAFACIACADIACACIAAACIABACIgCAEIgEABIgDAAg");
	this.shape_3.setTransform(89.85,12.475);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgIAwIAAAAIgBAAIAAgBIADgBIACgCIgBAAIgBgBIgBACIgCABIgBABIgCAAIgCABIgBgBIAAAAIgBgCIAAgDIAAgCIABgCIAAgBIAAgCIAAgFIgBgEIAAgEIABgCIAAgDIAAgDIAAgFIAAgGIAAgDIAAgDIAAgCIAAgDIABgCIAAgGQAAgDgBgDIgBgBIAAgBIgBAAIgCAAIgEABIgDgBIgDABIgCAAIgBAAIgCAAIgBgBIgCgBIAAgBIAAgBIAAgEIAAgCIABgJQAAAAAAgBQAAAAABgBQAAAAABAAQAAAAABAAIAIAAIACgBIADAAIACAAIACgBIADAAIADAAIAGAAIAEAAIAGAAIAGAAIADAAIAEAAIADgBIACABIACAAIADAAIADAAIADABIACADIABADIAAAJIAAAEQAAAAAAAAQAAABgBAAQAAAAAAAAQAAAAgBAAIAAACIgBAAIAAgBIAAgBIgBAAIgBAAIAAACIAAACIAAACIgCABIgCAAIgDgBIgDgDIgCgBIgBgBIAAgBIAAAAIgBABIgBAAIgBAAIgCAAIgCAFIgBAHIAAAGIAAAFIAAADIgDAHIgBAFIgBAHIAAACIABADIgBACIABABIACgBIAAgCIABABIAAABIgBACIAAAEIAAADIAAAEIAAAEIgBABIAAgBIAAgBIgBgBIgBABIgBAAIgCACIgCAAIgCAAIgBAAIgBAAQAAAAAAAAQAAABgBAAQAAAAAAAAQAAAAgBAAIgCAAIgBABIgBAAgAgNAGIAAACIAAADIAAAJIgBAJIABAAIAAAAIAAgCIABAAIABAAIAAAAIAAgDIgBgBIAAgCQgBgDABgCIAAgHQABgDgBgDIgBADg");
	this.shape_4.setTransform(76.825,12.45);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AgNAvQgDgCAAgGIgBgBIgBgBIABgCIAAgCIgBgFIABgIIABgIIAAgFIAAgBIAAgCIAAgCIAAgCQAAAAAAAAQAAAAAAAAQAAgBAAAAQAAAAAAgBIABgCIAAgGIAAgGIABgDIAAgFIABgDIgBgCIAAgDIAAgBIABgCIAAgBIgBgCIABgEIAAgFIABgBIACgBIABABIACAAIACAAQAAAAAAAAQAAAAAAAAQABAAAAAAQAAAAABAAIABAAIACAAIACABIADgBIADAAIACAAIABAAIACABIAAgBQABAAABAAQAAAAAAABQABAAAAAAQAAABAAAAIACAEIAAACIAAACIABADIAAABIgBAEIABADIgBACIgBADIgBAIIAAAIIAAADIgBADIAAACIAAAEIAAAEIgBACIABABIgBADIAAAEIgBACIAAADIAAACIAAACIAAAAIAAAGIgBAGIAAACIgBADIgBABIgCACIgDAAIgDAAIgIABQgFgBgCgCgAgPAOIAAAEIAAAFIAAAGIABAHIAAABIAAgCIAAAAIABgCIABgCIgBgBIAAAAIAAgCIAAgBIgBgBIABgFIAAgFIAAgBIgBgBg");
	this.shape_5.setTransform(70.2,12.375);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("Ag4AyIgCgBIAAgCIAAgDIAAgDIABgDIgBgEIAAgFIABgGIAAgBIAAgBIABgBIAAAAIABAAIABAAIADAEIADADIACAEIACAEIABACIAAACIAAACIAAACIAAACIAAADIgBABIgBAAIgDAAIgDAAIgDABIgCAAgAgFAwIgBAAIgBAAIgBgBIgDgEIgDgDIgCgEIgDgDIgCgDIgCgEIgCgCIgDgFQgCgCgBgCIgBgCQAAgBgBAAQAAAAAAgBQAAAAAAAAQgBgBAAAAQAAAAAAAAQAAgBAAAAQgBAAAAgBQAAAAAAAAIgCgDIgCgCIgCgDIgBgBIgBgCIgBgCIgCgCIgBgCIgCgDIgCgDIgBgCIgCgDIgBgFIAAgBIABgBIABgEIAAgEIAAgEIAAgFQAAAAAAgBQAAgBAAAAQABAAAAgBQAAAAABgBQAAAAAAAAQAAgBABAAQAAAAABAAQAAAAABAAIAEAAQAAABABAAQABAAAAAAQABAAAAAAQABAAAAAAIACABIAEADIABACIACAFIADAEIABADIABACIADAEIACAFIACADIACACIABACIABACIABADIABACIACACIABADIACACIACACIAAABIABAAIABABIABABIACgBIABgBIAAgBIABgBIABgCIABgBIAAAAIADgDIACgDIABAAIABgBIACgCIAEgCIACADIABADIgBACIAAABIAAABIAAAEIAAAFIABACIAAACIgBACIABABIAAAAIAAAEIgBAFIgCADIgBABIgBACIgCACQgBAAAAAAQAAABAAAAQAAAAAAABQAAAAAAAAIgCABIgCACIgBABIgBABIgCABIAAABIgBABIgBACIgBAAIgBABIgCACIgBABIgBAAgAgzggIAAACIgBACIAAACIAAABIABABIABgCIABgDIAAgDIAAgBIgBgCIgBAAIAAADgAgpgsIABABIABACIABABIABABIACABIABACIAAAAIABAAIAAgBIgBgCIgBgBIgCgBIgBgCIgCgBgAAmAwIgCgFIgCgFIAAgDIgBgEIAAgDIAAAAIAAgDIAAgDIAAgDIAAgDIAAgCIAAgDIgBgEIABgBIABAAIAAAAIAAgBIgBAAIAAgBIAAgDIAAgCIAAgCIAAgCIAAgCIAAgEIAAgFIAAgEIAAgHIAAgGIgBgCIAAgBIABgDIABgEIAEgBIACABIACAAIAFAAIAEgBIAEABIADAAIABABIAAAAIgBADIAAADIAAACIAAACIAAACIAAACIgBABIAAACIABABIAAACIAAABIgBABIABABIAAACIgBABIAAAAIAAABIAAABIAAABIABABIAAABIgBACQAAAAAAAAQAAAAAAAAQAAABAAAAQAAAAAAAAIAAADIAAACIAAACIAAABIAAACIAAACIAAADIAAADIAAABIAAABIAAAAIAAABIAAABIAAAAIAAACIAAADIgBAAIAAABIABABIAAACIAAAAIAAABIAAACIgBACIAAACIAAACIABACIAAABIAAAAIgBABIABACIAAACIAAAEQAAAAgBAAQAAABAAAAQAAAAAAABQgBAAAAAAIgBAAIgBAAIgCAAIgCAAIgBABIgFAAIgDABgAA1AqIAAABIABABIABgBIAAgCIAAAAIgCAAgAArApIAAABIABABIACAAIADAAIAAAAIABgBIAAgBIAAgBIgBAAIAAAAIgBABIgCAAIgDAAg");
	this.shape_6.setTransform(61.3,12.325);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFFF").s().p("AAKAwIgBgBIgBgBIgCAAIgBABIgCgBIAAgCQAAAAAAAAQAAgBAAAAQgBAAAAAAQAAAAAAAAIAAAAIAAABIAAACIgBAAIAAgEIAAgFIgBgBIAAgBIAAgCIACgBIACgBIADgDQABgBAAAAQABAAAAgBQAAAAABgBQAAAAAAgBIACgCIACgDIABgDIgDgBIAAgDIgBgBIgBgBIAAgCIgBgCIgCgBIgCAAIgBgCIgBAAIgBABIAAAAIgCgBIAAgBIABgCIgBAAIAAAAIAAABIgBgBIABgBIACAAIABgBIACgBIABgCIACgCIAAgBIABgCIAAgBIgBgBIAAAAIAAgBIABgBIAAgBIAAgBIAAgCIAAgCIgBgBIAAgDIABgDIgBgCIgBgBIgBgBIgBAAIAAACIABABIAAABIgCgBIAAgDIgCgBIAAgCIgBAAIgBgBIgBgDIgBgDQAAgBAAgBQAAgBABAAQAAgBAAAAQABAAAAgBIAEgBIACAAIABABIABAAIABAAIABAAIAFAAIAFABIABgBIACAAIADAAIAEAAIADABQAAAAAAAAQAAAAAAAAQABAAAAAAQAAAAAAAAIACAAIABgBIAAAAQABAAAAABQABAAAAAAQAAABABAAQAAABAAAAIADAGQACACACABIABADIABAEIAAACIAAAEIgBADIABADIgCACIgBACIABABIAAABIgBABIgCACIAAABIAAABIAAAAIAAABIgBABIgBACIAAAAIABADIACACIABADIABABIABACIABACQACACAAAEIAAABIgBABIABABIABACIAAACIgBABIgBgBIAAADIgBADIAAAAIABAAIABAAIgBACIgCACIAAAAIABABIAAAAIAAABIAAAAIgCABIAAABIgBABIAAgBIgBgCIgCABIgBAAIgBABIABABIgBABIgCABQgBAAAAAAQAAAAAAAAQgBAAAAAAQAAAAAAABIgDABIgDAAIgBABIgBAAIgBAAIgCAAIgCAAQgBAAAAAAQAAAAgBAAQAAAAAAAAQgBABAAAAIgCAAQAAAAAAAAQgBAAAAAAQAAAAgBAAQAAgBAAAAIgBABIgBAAIgCABQAAAAAAAAQAAAAgBAAQAAAAAAAAQAAgBAAAAIgBABIgBAAgAgnAvIAAAAIgDgBIgCAAIgCAAQgBAAAAAAQgBAAAAAAQAAAAAAgBQgBAAAAAAIgBgEIAAgEIAAgFIAAgDIAAgDIABgGIAAgFIAAgBIgBgCIABgGIgBgGIAAgGIAAgFIAAgLIgBgLIAAgFIABgFIABgCIABABIACgBIACAAIABgBIABABIACAAIACAAIADAAIAEgBIACAAIABABIABAAIACAAIABgBIACABIACAAIACAAIACAAIABABIABACIgBAGIABADIgBACIABAHQAAAEgBADIABAFIAAAHIAAAFIAAAEIAAADIAAAKIgBAKIAAABIAAABIAAADIAAACIAAADIAAAEIAAABIAAABIgBACIgEABIgDgBIgBABIgBgBIgBAAIgBABIgBAAIgCAAIgDAAIgDAAIgCABIgBAAgAgwAWIAAAJIAAAKIABACIAAACIABAAIACgBIAAgCIABgCIAAgBIAAgCIAAAAIAAgBQgBAAAAAAQAAAAgBgBQAAAAAAAAQAAgBAAAAIABgEIgBAAIAAgBIAAgCIgBgBIgBgCIAAgBIgBgBIAAgBgAgRArIAAAAg");
	this.shape_7.setTransform(49.275,12.475);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FFFFFF").s().p("AgPAxIgCgBIgBgBIgEgBIgDgBQgEgCgCgDIgFgFIgDgEIAAgBIgBAAIAAgCIgBABIgDgCIAAgEIgBgCIgCgGQgBgCAAgDIAAgOIABgNIAAgCIAAgCIAAgCIAAgCIAAgBIAAgDIAAgDIABgBIgBgCIABgCIAAgCIAAgBIAAgCIAAgCIAAgCIAAgCIABgBIACABIACgBIACAAIAFABIAGABIAFAAIACAAIACABIACABIAAADQAAAGgBAGIAAANIgBADIAAADIAAAEIgBADIAAADIAAAFIAAAGIgBABIAAABIAAACIABACIACAEIACAEIADACIABADIADACIABABIAAACIAAACIAAABIAAABIAAABIAAACIgCADIAAABIAAABIgBABIgCABIgCABgAgkAiIACADIADACIABABIACABIABgBIgCgBIgCgBIgBgCIAAgCQAAAAAAAAQAAgBgBAAQAAAAAAAAQAAAAgBAAgAAGAuIAAgEIgBgDIABgEIAAgEIADgBIADgCIABgBQABAAAAgBQAAAAAAAAQAAAAAAAAQAAgBAAAAIADgEIACgGIABgEIAAgGIABgEIAAgBIAAgCIABgDIAAgCIAAgDIAAgDIgBgBIAAgBIABAAIAAgBIgBgBIAAgCIAAgBIAAAAIgBgDIAAgDIAAgHIAAgHIAAAAIAAgBIAAgCIAAgCIADgBIAEgBIADgBIACABIACABIABAAIABAAIABABIACgBIADAAIABgBIACAAIABAAIABABIACACIAAABIAAADIgBABIAAABIABABIAAABIgBABIABADIAAADIAAAEIAAADIgBABIAAACIAAACIAAACIgBACIAAgBIgBABIgBACIABADIgBACIABACIgBABIABAAIAAABIAAAAIABgBIAAABIABAAIgBABIAAABIAAABIABACIgBACIABABIgBADIAAADIAAADIgBADIgBADIAAAAIAAABIgBABIgBACIgBACIgBACIgCACIgBAAIgBAAIgDACIgEADIgBABIgBACIgCAAIAAABIgBAAIgCgBIgCABIgCACIgBAAIgBABIgCAAIAAABIgCAAIAAABIgBACIgCAAIgBABIgDgCgAATAuIACgBIACgCIACgBIADgBIAAABIgDACIgCACIgEAAg");
	this.shape_8.setTransform(38.075,12.7);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#FFFFFF").s().p("AgSAxIAAABIgDgBIgCgBIgBgBIgBgBIgCgBIgDgCIgDgBIgBgBIgBgBIgBgCIAAgBIABgCIACgDQABgBABAAQAAAAABgBQAAAAABAAQAAAAABAAIADAAIABACIABABIABABIADACIADABIAEABIABABIACAAIABABIABACIgBABIAAABIAAABIAAAAIAAABIgBACIgDABIgCABIgCABgAAKAyIgCgBIgCgCIABAAIAAgBIgBgBIAAgBIAAgCIAAgCIABgCIABAAIAAgBIACgDIACgDQADgCACgDQABgCAAgEIAAgCIgBgCIgCgCIgCgDQAAAAAAAAQAAgBgBAAQAAAAAAAAQAAAAgBAAIgBgBIgBgBIABgCIgDABIgCgBIgBAAIgBAAIgDgBIgGgBIAAAAIgBAAIgCgBIgCAAIgCgBIgFgBQgDgBgCgBIgDgCIgEgCIgCgBIgBAAIgBgCIgCgBIgBgCIgBgCIgBgEQAAAAAAgBQAAAAAAgBQAAAAAAgBQgBAAAAgBIAAgCIAAgDIABgCIAAgDQABAAAAAAQABgBAAAAQAAAAABgBQAAAAAAgBIACgDIABgCQAAAAAAAAQAAgBABAAQAAAAAAAAQABAAAAAAIACgCIAFgDIACgCIAEABIACAAIAEgBIAEAAIABAAIABABIABADIABADIAAADIAAACIgBADIgBABIgCACIgDAAIgCACIAAABIAAACIAAABIAAABIABACIABABIAFADIAEABIAFAAIAEAAIAEABIAEABIAFACIAEABIACABIACABIABABIABACIACABIABACIADABIABABIACAHIACAIIAAADIAAADIgCAGIAAAFIgBAEIgGAEIgCADIgBACIgJADQgEACgFAAgAAfgeIgCgCIgCgDIgFgBIgDgBIgCgBIgCAAIgCgDIgBgDIAAgBIADgDQABgBAAAAQAAAAABAAQAAgBABAAQAAAAABAAIABAAIAAABIAFAAIAFADIAFACIACADIACACIAAACIABACIgCAEIgEABIgDAAg");
	this.shape_9.setTransform(28.1,12.475);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	// back
	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("rgba(255,255,255,0.008)").s().p("AroAyIAAj6IXRAAIAAAZIkTAAIAAD+IDrAAQgjAXgoASQhEAfhSAUQiDAeioAAQlzAAoqiXg");
	this.shape_10.setTransform(74.5,20.1339);

	this.timeline.addTween(cjs.Tween.get(this.shape_10).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SubmitScoreButton, new cjs.Rectangle(0,0,149,40.3), null);


(lib.square_7 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("AhFBGIAAiLICLAAIAACLg");
	this.shape.setTransform(10.95,10.95);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#999999").s().p("ABFBFIAAiKIiKAAIgUgUICzAAIAACzg");
	this.shape_1.setTransform(11,11);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#000000").s().p("AhtBuIAAjbIDbAAIAADbgAhFhFIAACKICKAAIAVAVIAAizIizAAg");
	this.shape_2.setTransform(11,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.square_7, new cjs.Rectangle(0,0,22,22), null);


(lib.square_6 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#999999").s().p("AhFBGIAAiLICLAAIAACLg");
	this.shape.setTransform(10.95,10.95);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#666666").s().p("AhZBaIAAizIAUAUIAACKICKAAIAVAVg");
	this.shape_1.setTransform(11,11);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("ABFBFIAAiKIiKAAIgUgUICzAAIAACzg");
	this.shape_2.setTransform(11,11);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#333333").s().p("AhtBuIAAjbIDbAAIAADbgAhZBaICzAAIAAizIizAAg");
	this.shape_3.setTransform(11,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.square_6, new cjs.Rectangle(0,0,22,22), null);


(lib.square_5 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#666666").s().p("AhFBGIAAiLICLAAIAACLg");
	this.shape.setTransform(10.95,10.95);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#333333").s().p("AhZBaIAAizIAUAUIAACKICKAAIAVAVg");
	this.shape_1.setTransform(11,11);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#CCCCCC").s().p("ABFBFIAAiKIiKAAIgUgUICzAAIAACzg");
	this.shape_2.setTransform(11,11);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#000000").s().p("AhtBuIAAjbIDbAAIAADbgAhZBaICzAAIAAizIizAAg");
	this.shape_3.setTransform(11,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.square_5, new cjs.Rectangle(0,0,22,22), null);


(lib.square_4 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#CCCCCC").ss(1,1,1,3,true).p("AhFhFICLAAIAACL");
	this.shape.setTransform(10.9,10.975);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#999999").s().p("AhZBaIAAizIAUAUIAAAAIAACKICJAAIABAAIAVAVg");
	this.shape_1.setTransform(11,11);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("ABFBFIgBAAIAAiKIiJAAICJAAIAACKIiJAAIAAiKIAAAAIgUgUICzAAIAACzg");
	this.shape_2.setTransform(11,11);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#333333").s().p("AhtBuIAAjbIDbAAIAADbgAhZBaICzAAIAAizIizAAg");
	this.shape_3.setTransform(11,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.square_4, new cjs.Rectangle(0,0,22,22), null);


(lib.square_3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#990000").s().p("AhFBGIAAiLICLAAIAACLg");
	this.shape.setTransform(10.95,10.95);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#660000").s().p("AhZBaIAAizIAUAUIAACKICKAAIAVAVg");
	this.shape_1.setTransform(11,11);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FF0000").s().p("ABFBFIAAiKIiKAAIgUgUICzAAIAACzg");
	this.shape_2.setTransform(11,11);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#330000").s().p("AhtBuIAAjbIDbAAIAADbgAhZBaICzAAIAAizIizAAg");
	this.shape_3.setTransform(11,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.square_3, new cjs.Rectangle(0,0,22,22), null);


(lib.square_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFCCFF").s().p("AhFBGIAAiLICLAAIAACLg");
	this.shape.setTransform(10.95,10.95);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#CC6699").s().p("AhZBaIAAizIAUAUIAACKICKAAIAVAVg");
	this.shape_1.setTransform(11,11);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("ABFBFIAAiKIiKAAIgUgUICzAAIAACzg");
	this.shape_2.setTransform(11,11);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#663333").s().p("AhtBuIAAjbIDbAAIAADbgAhZBaICzAAIAAizIizAAg");
	this.shape_3.setTransform(11,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.square_2, new cjs.Rectangle(0,0,22,22), null);


(lib.square_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FF0000").s().p("AhFBGIAAiLICLAAIAACLg");
	this.shape.setTransform(10.95,10.95);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#CC0000").s().p("AhZBaIAAizIAUAUIAACKICKAAIAVAVg");
	this.shape_1.setTransform(11,11);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FF6666").s().p("ABFBFIAAiKIiKAAIgUgUICzAAIAACzg");
	this.shape_2.setTransform(11,11);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#330000").s().p("AhtBuIAAjbIDbAAIAADbgAhZBaICzAAIAAizIizAAg");
	this.shape_3.setTransform(11,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.square_1, new cjs.Rectangle(0,0,22,22), null);


(lib.Square = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("AgxAyIAAhjIBjAAIAABjg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5,-5,10,10);


(lib.ScrollBtn = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FF0000").s().p("AhNgGICah+IAAEIg");
	this.shape.setTransform(7.75,13.25);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ScrollBtn, new cjs.Rectangle(0,0,15.5,26.5), null);


(lib.QuitText = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#404040").s().p("AAUBZIgCAAIgKgFQgIABAAgEIgCgBQgFgGgFgCQgGgCgBgFIgCgCIAAgCQgFgBAAgCIAAgBQgFgCABgDQgEgBgCgFIgBgDIACgFQgBgBgCgDIgBAAIgBADIgDgCIABgCIADgCQgEgKAAgGIAAgCQgEgFAEgCIgFgFQABgHgEgCIAAgBQADgIAAgDQABgIADgEQAAgGADgDIAAgCQAEgEABgGQAEgBAAgEQAFgCAAgCQAJgKAFgBQAGgGAEgBIACAAQAEgCADABQAQgGABgCQAIgDAFAAQADACAHACQAHADgCAIIABAGQAAAKgIAJQgaAEgGAFIgBAAQgDAAgCAFQgBADgEAEQgHAHgFAdQAAAAAAABQgBAAAAAAQAAAAAAABQAAAAAAABIABAEIABACQAAACgCAEIAAAFIACAAIAAgDQADAAAAAFQAAAEAEABQADAKAGAEQABADAeANIAIAIIACALIgCAGQAAAEgDAAIgBAAQAAAAgBAAQAAAAAAABQgBAAAAAAQAAABgBAAQgNABgFgFg");
	this.shape.setTransform(-5.7952,-0.4245,0.5348,0.5348);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AgUAVIAAgpIApAAIAAApg");
	this.shape_1.setTransform(-17.1125,0.4125);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#404040").s().p("AgRBgIAAgBQAJgCAAgEIgBgBIgDgBQAAAEgGABIgDADIgIABIgCAAIgBgMQAAgEABgCIAAgHIgCgUQAAgIABgCQACgIgCgEQgBgPACgIIgBgHQABgDgBgHIABAAQgBgHADgDQAAgQgDgHQgBAAAAgBQAAAAAAgBQgBAAAAgBQAAgBAAgBIgDABIgDgBQgIAEgPgBQgCgBgDAAIgEABIgGgDQgBgFABgCIgCgLQAAgSAFgDQADgCASAAQAGgCAEABIAKgDIANAAIAVABIAbgCQAJAFALgGQADADAFgCIAOAAQADAAAFAGQAEAFAAAEIAAATQgCADgBAIIgCACIgBAAQAAAAAAAAQAAAAgBgBQAAAAAAgBQAAAAAAgBQAAAAAAgBQAAAAgBAAQAAgBgBAAQAAAAgBAAIABALQgCADgDABIgEAAQgLgCgCgEQgFgCgBgEIgCAAIgCABIgIAAQgFAEAAAgIgBARQgIAQgBAWQgCADADAHIgBAEIACACQADAAABgHQABABAAAAQABABAAAAQAAABAAAAQAAABAAABQgBABAAARIAAARIgEABIAAgEIAAgCQgBAAAAAAQgBAAAAABQgBAAgBAAQAAABgBAAQAAACgJACIgEAAQgCgBgEACQAAAEgHgBQAAAAAAAAQgBABAAAAQgBAAgBAAQAAAAgBAAg");
	this.shape_2.setTransform(26.6471,-0.3978,0.5349,0.5349);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#404040").s().p("AgWBjQgMgDgCgQIgBgFQABgCAAgGQADgsgDgIQAAgEABgCIgBgJQAAgGACgEIABgWQAAgSADgEIgCgLQAAgDACgDIgBgFIABgTQAEgEACAAIAGACIAEgBQABACAIgCQAFACADAAQAJgCAFAAIAFABIAGgBQAEAAAFAMIAAAEIABANIAAANIgCAJIgBAiIgDAMIABAFIgBAQIAAAGQAAANgDAFQAAAJgCACIABADIAAAAIgCAYIAAABIgCAIQAAACgFAFIgPACQgXAAgDgBg");
	this.shape_3.setTransform(18.8908,-0.3844,0.5349,0.5349);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#404040").s().p("AAcBiQgFgBgBgCQgMgCgEgEQgJgDgIgJQgIgLgEgEIAAAAQgBgBAAgBQAAAAgBgBQAAAAAAgBQAAAAABgBIgCABQgLgBABgPQgHgNABgJIABg4IAAgCQgBgGACgDQgBgCABgFQACgHgBgDIAAgIQABgEgBgCIAAgJIAAgGQAAgBABgBQAAAAAAgBQAAAAAAgBQABAAAAgBIANAAQAFACAcAAIAEAAIAIAFIAAAGQABAQgCAgIgBAPQgCAEAAAPIAAAXQAAABgBAAQAAABAAAAQgBABAAABQAAAAAAABIABAIQAGAEADAMQAIAKAIACQACAGgBACIABAEIgBAFQAAAGgDAEIAAACIgBAFQgGAEgDAAg");
	this.shape_4.setTransform(6.6815,0.1104,0.5349,0.5349);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#404040").s().p("AgsBQIABgQQAHgFAEgCQAGgCAAgDQAOgXgDgHQABgNACgGIAAgDQAAgNACgCIgBgKIgDgEIADgCIgBgCQgCABAAgGIAAgDQgCgJACgDIgBgbIgBgDIABgHQAEgGAPAAQAHABACACIABgBQACAAADADQAHAAADgCIAIgCIAEACQACAAADAGQgCAIgCABQAAABABAAQAAAAAAABQAAAAABAAQAAAAABAAIgCAFQADAEAAAIQgCAFABAJQgCABABAGIgBAGIgCAFIgBgCIgCADIABAJQgDACADAGIgCACQABAAAAABQABAAAAAAQAAABAAAAQAAABAAAAIACgCQABAAAAABQAAAAABAAQAAAAAAAAQAAABAAAAIgBAEIABAGIAAAHIgBARQgBAIgDAFIAAABQAAAAgBABQAAAAAAABQAAAAgBABQAAAAAAAAIgEAHQgBAEgGAGIgEgBQgHAGgHADQAAADgEAEIgDACIAAABQgDAAgEgEQgHAEgBADIgDAAIgFAEQgBACgFABIgCADIgHACQgGAAAAgRg");
	this.shape_5.setTransform(13.0469,0.0034,0.5349,0.5349);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#404040").s().p("AgPBmIAAgCQgBAAgEgHIgFgCIAAAAQgBAAgBgBQAAAAAAgBQgBAAAAgBQAAAAAAgBIgCgCIADAAIAAgBQgCAAAAgFQAAgDgFAAIgEgDQgEAAgCAGIgEgCQgDgEAAgDIAAAAQACgDAAgJIABgIIALgJIAVgMQAHgGACgGIADgGIACAAIACgCIgBgEQABgCAAgDIAAgFQgDgGABgDIgCgJIABgCQAAAAAAgBQgBAAAAgBQAAAAgBgBQAAAAgBgBIABgFIgCgDQgCAAgLgQIgCgFIgRgJQgHgGAAgEIABgDIADgVIAIgFIACAAIAGAAQAEgBAEAAIAGABQAAADAEAEIAIAEIAGgCQAEAAABAEQABAGABABQAAAFAIADQAEACADAFQAAAAABAAQAAABAAAAQABABAAABQAAAAAAABQADAJAFABIABAFQACAFAEACQAEAHAAAJQAAAFABAFIAAAJQABAAAAAAQAAABAAAAQABABAAAAQAAABAAAAIgBACQAAAAAAgBQgBAAAAgBQAAAAgBAAQAAAAgBAAIgBAAIgBAIIABAGQABAAAAAAQABAAAAABQAAAAABABQAAAAAAABQAAADgDAHQgDABgCACIgDAFIACADIAAAAIgEAHQgFACgDAGQgBAFgHAEQgEABgDAGIgCAEIAAABIAEAJQADAAACADIgCAFIgEAAQAAABAAAAQAAABAAAAQAAABAAABQABAAAAABQAAACgIAAQgCAFgCgEIgCAFIgCAAIgHAEIgBAEIgDAEQgBgBgDgGg");
	this.shape_6.setTransform(0.5166,0.4313,0.5349,0.5349);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-19.2,-5.7,50.2,12);


(lib.PlayText = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FF0000").s().p("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");
	this.shape.setTransform(15.6016,1.7806);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-41.9,-9.9,115,23.4);


(lib.pauseMenu = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FF0000").s().p("AgKBuQgEgBACgHIgBgDIAAgEIgBgCIAAgBQAAgBAAAAQAAgBAAAAQAAgBABAAQAAgBAAAAIADgFQAEgCAFgBIAIgCQAFgCADgEQAGgGAHgGQAHgFAFgHIADgGQAAgEADgDIAAgBIABgFIABgFIABgGQABgDgBgDIABgDIAAgEQAAgIgCgJIgDgSQAAAAgBAAQAAgBAAAAQgBAAAAgBQAAAAAAgBIgDgEIAAgBIgBgEIgCgDQAAAAgBAAQAAgBAAAAQAAgBAAAAQABgBAAAAQAAgBAAAAQAAgBgBAAQAAgBAAAAQgBAAAAgBIgDgBQAAAAgBgBQAAAAAAAAQAAgBAAAAQAAgBAAAAIgDgEQAAAAAAAAQgBgBAAAAQAAgBgBAAQgBAAAAgBIgDgFIgDgFQgCgCgDAAIgDACQAAAAAAAAQAAABAAAAQgBAAAAABQAAAAgBAAIgDgBIgDgCIgBABQgCAAgCgCQgCgDgDACQAAgBgBAAQAAgBAAAAQgBAAAAAAQAAgBgBAAIgDgCQgBgBAAgGIAAgDIACgDIgBgCIAAgBQAAgEABgBQABgBAAAAQABAAAAgBQAAAAABAAQAAAAABgBIADgDIADACIAJgCIADAAIAEAAIADABIADABIABgBIAAAAIAEABIADgCQACACADgBIAHAAQACAAAFABIAJAEIAIADIAFABQADABABACIABAAQADAAAEADIAHAEIAEADIADAEIABAGIAEAGQACAEADACIAAAAIAAADIACACIAEAKQACADAAAIQADABAAAEQAAAEABADIgBADQABAEACAGIADAKIgCAFIAAAGIAAAFIABAEIAAACIgBACIgBAFIgCAGIgCAHIAAAHIgBAEIgDAFIgCAFIgEAEIgDAGIgEACIgEAEIABADIgFAGQgCACgDABQgBAEgDACIgHADQAAADgEABIgIAEIgHABQAAAAgBABQAAAAgBAAQgBAAAAAAQgBAAAAAAIgFgBIgFACIgEABQgBAAAAAAQgBAAAAAAQgBAAAAAAQgBAAAAAAQgBAAAAABQgBAAgBAAQAAAAgBAAQAAAAgBgBQgCABgDgBIgFgBIgDABIgJABIgIABQgFAAgDgCgAgKBqQACABADAAIAFABIACgBIABgBIgIgCIgBgCIgCAAIgCAAgAAlBqIADAAIAAgBIgDAAgAA8BfIgCADIgFACIgFACIAAAAIAKgBIAHgBIAJgDIgFgDQAAAAAAABQgBAAAAAAQgBAAAAAAQgBABAAAAIgDgCIgDABgAhlBuIgDAAIgGgBIgHgBIgCgCQgBAAAAgBQAAAAAAAAQAAgBAAAAQAAgBAAAAIgBgDIABgCIgBgDIACgCIAAgEIgBgCIAAgDIAAgGIACgGQgCgDABgCIAAgEIABgKIgBgMQAAgHABAAIAAgQQAAgIABgHIgBgDIABgHQAAgDgBgEIABgIIAAgJQAAAAAAgBQAAAAAAgBQAAAAAAgBQAAAAAAgBIABgDIAAgGIgBgGIABgVIAAgVIABgGIAAgGIACgDIAHgBIAIgBIAEgBIAFgBIABABIACAAIAFAAIAJABIAEAAQADABADAAIAGgCQADAAAAAEIABAHIAAAFQgCAEABAFIABAJIgBADIAAACQAAAHgBAFIAAAMIAAACIABABIgBALIgBAMIgBAbQgBAOABAOIgBAEQAAABgBAAQAAABAAAAQAAAAAAABQABAAAAABIAAAIIgBAHQABAGgBAGIgBALIACACIAAAEIgBAKIgBAKQgDAEgHAAIgLAAIgDgBIgCAAIgCAAIgBABQgBAAAAABQAAAAgBAAQgBAAAAAAQgBAAgBAAQgDgBgCACIgDgCgAhGBkQABAAAAABQAAAAAAABQAAAAAAABQAAAAAAABQAAAAAAAAQAAABABAAQAAAAAAABQABAAAAAAIADgCIAAgDIAAgBIgDgDgAhyBVIgBACQABADAAADIgBAGIAAADIABADIAEAAQgDgDAAgDIAAgIQAAAAAAAAQAAgBAAAAQAAgBAAAAQAAgBAAAAIgBgDIACgLIgBgCIgBgEQgBAIABAJgAhxgbIgBAYIABAJIAAAKIACgCIAAgOIABgMIACgGIAAgIIAAgFIAAgBIABgBIgBgDIgBgDIgBgGIAAgHIgBAAQgCAMAAANg");
	this.shape.setTransform(59.9667,1.4);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FF0000").s().p("ABJB0QgBgDgCgBIgBACIABABIABABQAAABAAAAQAAABgBAAQAAAAAAAAQAAABgBAAIgDABIgIgCIgIgEQgBABAAAAQAAAAgBAAQAAABgBAAQgBAAAAgBIgEAAIgHAAIgHABIgFgCIgFgCIAAgCIgBgBIAAgCQABgDgBgDQAAgEgDgDIAAgFIADgLQABgFAEgGIAHAAIAHAAIACgBIACAAIAVACQALACAKAAIAEAAQAAAAABABQAAAAABAAQAAAAABABQAAAAAAABQACACAAAEQgBAEAAADQgBAEABAFIAAAIIABAEIgBADIgCABQAAABAAAAQAAABgBAAQAAABAAAAQAAABgBAAIgDAEIgBgBIgBAAIgCABIgDABQAAgBgBAAQAAAAgBgBQAAAAgBgBQAAAAAAgBgAhYB0QgEgBgBgFIgBgKQACgJgBgLIgBgTIACgCIABAJIACAJIgBAGIgBAJIAAAEIAAAEQABAAAAABQAAAAAAAAQAAAAAAABQAAAAAAABIABgBIABgEQAAAAAAAAQAAgBAAAAQAAgBAAAAQAAgBgBAAIABgFQAAgBABAAQAAgBAAAAQABgBAAAAQABAAAAgBIAAgCIACgHQACgCAAgEIAAgCIgBgBQgBAAAAAAQgBgBAAAAQAAAAgBgBQAAAAAAAAQAAgBAAgBQAAAAAAgBQgBAAAAAAQAAgBgBAAIAAgKIgBgNIAAgIIAAgGIAAgFQgBgCABgDQAAgBAAAAQAAgBAAAAQgBgBAAAAQgBAAAAAAIgBACIgCABIgBgBIAAgCIAAgCIABgCIgBgEIACgCIACACIABgBIAAgEIgEgEIgBgFIABgDIgBgCIAAgDIABgDIACgDIgBgGIAAgMIgBgOIAAgIQAAAAAAgBQAAAAAAgBQAAAAAAgBQAAAAAAAAIAAgEIAAgCIABgBIAAgDIACgDIACgDIAAgDIgCgCIgBAEIgBgCIABgGQgCgBAAgDIgBgHIAAgGIAEgDIAFgDIADgDIAEABIAEAAIAJgBIAMAAIAJAAIAFABIAIAAIAEAAQAEACACAEIACAKIABAIIAAADIgCAFIgBAEQABAGgBAHIAAAMIAAAHIAAAIQABAEABABIABAFIgBADQAAAFACADQACAEAFAAQAHgEAHABIAOAAIAVAAIAJgBIAIAAIAIgBIAHABIAGACQAFAFABAFIAAAJQgBAGACAFIgDANQgBAEgDAAIgPACIgFgBIgEABQgBgBAAAAQAAAAAAAAQgBgBAAAAQAAAAgBABIgDABIgDgBIgCABIgCAAIgEAAIgFAAQgGgCgGABIgNABIgCgBIgCAAIgIAAIgJgCQAAAAgBABQAAAAgBAAQAAABgBAAQgBAAAAAAQgBAAgBAAQAAAAgBABQAAAAAAAAQgBABAAAAQgDACgCAFIgCAHIAAAFIACAFIgBAMIAAAOIABAMIAAAHIAAAGIAAAEIgCADIgOACQgHACgIgCIgCACIgCgCIgDACIgCgBIgCABIgDABIgEAAQgIAAgDgDgAg2BuIgBADIACAAIACAAIAHgBIAIgCQAEgCAAgCIAAgEIgBgEIgBgEQgBAAAAAAQgBAAAAAAQAAABgBAAQAAABAAAAIAAAGIgBAAQgBAAAAAAQgBAAAAABQAAAAAAAAQgBABAAAAQAAABAAABQAAABgBAAQAAABAAAAQAAABgBAAQgBACgFgDgAhGBfIgBAFIACADQABAAAAAAQAAAAABAAQAAgBAAAAQAAgBAAAAIABgDIAAgEIgCgCQgBAAAAAAQAAABgBAAQAAABAAAAQAAABAAAAgAALAaIAEACIABgBIACgBIAFAAQAAAAgBgBQAAAAAAAAQAAgBgBAAQAAAAAAAAIgDAAIgDgCIgFgCQgCgCgEgBIgBABIgCAAIgBACIAAABQAAAEACAAIAFABIACAAIACAAgABLARQgBADgDACQgDABgBADIADAAIADAAIADgBQABAAAAAAQABAAAAgBQAAAAAAAAQAAgBAAAAIAAgCIAAgCIgDgDgAgHgLIgCAAIAAACIADABIADAAIABAAIAAgDIgBAAIgCgBIgCABgABLhBIgBgBQgBAAAAgBQgBAAAAAAQgBAAgBAAQAAAAgBAAIgFABIgCgBIgCgBIgCABIgDACIgKgCIgLgBIgBAAQAAAAgBgBQgBAAAAAAQgBAAAAAAQgBgBAAAAIgEgCIgCgHIgBgHIAAgCIAAgDIABgKIADgKIAGgDIAIgDQAEgBADADIACAAIACAAIAHAAIAGgCIAEgBIAFgBIAIABIAJABIACAHIABAHIgBAFIgCAFIABACIACABIABAEIABADIgBAHIgDAIIgEABIgGABIgFABIgBAAgABUhMIgBADIAAABIADABIACgBIAAgCIAAgCIAAgCIgEgBIAAADgAAbhVQABAEACADIAGAEIABgHQAAAAgBAAQAAgBAAAAQgBAAAAgBQgBAAgBgBQgDAAgBgCg");
	this.shape_1.setTransform(35.625,1.35);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FF0000").s().p("AgnB2IgEgCIgCAAIgFgCIgFgBQAAgBAAAAQAAgBAAAAQgBgBAAAAQAAgBgBAAIgFgBQAAAAgBAAQAAAAgBAAQAAAAAAgBQgBAAAAgBQgEgBgDgDQgDgDgEAAQAAAAAAgBQAAAAAAAAQgBgBAAAAQAAAAgBAAIgDgCQgCgBAAgFIABgDIAAgEIAIgIQAEgEAHAAIAFABIAFAEIABACIACADIAHAEIAHAEIAJACIADACIAEABIACACIACADIgBADQAAAAAAAAQgBAAAAABQAAAAAAAAQAAAAAAABIAAACIAAABIgBACQAAAAAAABQAAABAAAAQgBABAAAAQAAABgBAAQgBACgDABQgBADgEAAIgGAAgAAVB0IgDgCIgDgEIABAAIAAgBIgBgDIgCgCIAAgBQABAAAAgBQAAgBABAAQAAgBAAAAQAAgBAAAAIAAgFIABgEIABgCIABgCIAGgGQACgEADgCQAHgFADgHQACgHAAgIIgBgFIAAgFQgCgBgCgDIgFgHQAAAAgBgBQAAAAgBAAQAAgBgBAAQgBAAAAABQgBAAAAgBQgBAAAAAAQgBAAAAgBQAAAAAAgBIgDgDIAAgEIgFABIgEgDIgDABIgCABIgKgCQgGgCgGAAIgCgBIgCgBQAAAAAAgBQgBAAAAAAQgBAAAAgBQgBAAAAAAIgEgBQgBAAAAAAQgBAAAAAAQgBAAAAgBQgBAAAAAAIgNgDQgHgBgEgFIgJgEIgIgFIgBAAIgEgBIgEgCIgDgEQAAgBAAAAQAAgBgBAAQAAAAgBAAQgBgBAAAAQgBAAAAgBQgBAAAAgBQAAAAAAgBQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAAAAAAAQgBgBAAAAIgBgKQgBgFgDgEIABgGIAAgFIACgGIAAgGQAFgDABgFQABgEADgDQADgCABgDQABgCADgBQABgCAEgDIAKgFIAIgEIAGAAIAHAAIAIgBIAJAAIADABIADABIADAHQACAEAAAEIAAAFIAAAGIgDAFQgBADgDABQgCACgCABIgFACIgEAEIAAADIAAADIgBADIAAACQAAADACABQABABAAAAQAAAAABABQAAABAAAAQAAABAAAAQAEAFAGACQAFACAGAAIALAAIALABIAKABIAIACIANAEIAJAEQAAABABAAQAAABAAAAQABABAAAAQABAAAAAAIAFABQADABABADQABADACABIAFACQAAAAAAABQAAABABAAQAAABAAAAQABABAAAAIAFACQAAAAABAAQAAABABAAQAAABABAAQAAABAAAAIAGASQADAJABAJIgBAIIAAAIQgDAIgBAFIAAALQgBAEgDAFQgDAEgJAGIgEAGIgEAFQgLADgJAEQgKAEgMABgABJhIIgGgDQgBgFgFgCQgEgDgFAAIgKgCQAAAAAAAAQAAgBgBAAQAAAAAAAAQgBAAAAAAIgEgBIgEgHQgDgEAAgEIAAgDIAHgGQACgEAFAAIACAAIACABQAEgBAHADIAMAGIALAGQACADADADQAEABABAEIABAFIABAFQgBAEgEADQgFAEgEAAQgDAAgDgCg");
	this.shape_2.setTransform(14.075,2.125);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FF0000").s().p("AgkBzIgEgCQgBAAAAgBQgBAAAAAAQgBAAAAgBQAAAAgBgBIgIgCQgFgBgDgDQgJgDgGgGQgGgGgEgHIgIgKIAAgBIgBgCQgBgBAAAAQAAAAAAAAQAAgBAAAAQAAgBAAAAIgCAAQgFAAgCgDIgBgIQAAgEgCgDQgBgGgDgGQgDgGAAgHIABggIABghIAAgCQABgDAAgDQAAAAgBgBQAAgBAAAAQAAgBAAAAQABgBAAgBIgBgEIABgEIABgGIAAgGIABgEIgBgFIABgDQAAgBAAAAQAAgBAAAAQAAgBAAAAQAAAAAAgBIAAgFIAAgFIABgEIAAgEIAAgCIABgDIAEAAIAGAAIAEAAQAFACAHABIAOAAIAMAAIAEAAIAFADIAEACIAAAHQABAOgBAOQgCAOAAAPIgBAIQgBAEABAFIgBAGIgBAJIAAAHIAAANIgBAOIgBACIgBADIABAFIAAAFQAEADACAFIAEAKQAEABADADIAEAGQACADADACIADAEQAAAAAAABQAAAAAAABQAAABAAAAQAAABAAABIAAACIABADIgBACIgBACQABAEgBADIgEAGIABACIgBADIgBACIgFAEQgCABgDAAgAhVBQIAFAGIAGAEQAAABABAAQAAABAAAAQABABAAAAQABABAAAAIAEADIADgDQgCgDgDgBIgFgDQAAAAAAgBQgBAAAAAAQAAgBAAgBQAAAAAAgBIgBgEQAAAAgBgBQAAAAgBAAQAAAAgBgBQgBAAAAAAgAAPBrIgCgJIAAgHIAAgJIACgIIAFgFIAHgDIADgDQADgBAAgDIAGgKQADgHACgHQADgGgCgEIACgMQABgFACgFIAAgDIAAgFIABgIIABgFIgCgGQgBgCACgEIgDgFIACgBIABgBIAAgBIgBAAQAAAAgBAAQAAgBgBAAQAAAAAAgBQAAAAAAgBIAAgEIAAgCIAAgBIgBgHQgBgEABgDIAAgQIgBgQIAAgCIAAgCIAAgEIABgEQABgBAFgCIAKgCIAHgBIAFABIAFADIAAgBIADABIACACQADgBADAAQADAAADgBIAEgBIAEgBIADABIACABQABABAAAAQABAAAAAAQABABAAAAQAAABAAAAIACAEIgBAGQAAADgDABQAAABAAAAQAAABABAAQAAAAAAAAQAAAAABAAIABACIgBACIgBACQACAEgBAEIABAHIgBAIIABAIQAAAAgBABQAAAAgBAAQAAABAAAAQAAABAAAAIABAEIgCAEIAAAEIgCAFIAAgCIgDADIAAAGQAAADABACQgDACAAACIACAFIgCADIACABIAAACIACgBIABgBIACABIAAABIgBADIAAACIABADIAAADIAAAFQAAABgBAAQAAABAAABQAAAAABABQAAAAAAABIgBAGIgBAHIAAAGIgBAHIgEAHIAAABIAAADIgCACIgBAEQAAAAgBABQAAAAAAAAQAAABgBAAQAAAAgBABQgBAEgCACIgFAGIgCAAIgCgBIgIAFIgHAFIgDAEIgCAEIgFACIAAACIgEgCIgDgDIgFADIgEAFIgDAAIgDACIgDACQAAAAgBAAQAAABAAAAQAAAAgBAAQAAAAAAAAIgDAAQAAAAAAAAQgBABAAAAQAAAAAAABQAAAAAAABIgCADIgEABIgEABQgEgBgBgDgAAsBrQACgCADgBQACAAACgCIAGgCIAGgDIABACQgEABgDADIgGADQgDACgGAAg");
	this.shape_3.setTransform(-9.125,2.675);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FF0000").s().p("AB+ByIgDgCIgBACIgDACIgCAAIgDgBIgEABIgEAAIgEgBIgEAAIgCgEIgFACQAAAAgBAAQAAAAgBABQAAAAgBABQAAAAAAABIgCAAQgDAAgCgCQgCgDgCgBIAAgBQAAAAAAAAQAAgBAAAAQAAAAgBgBQAAAAAAAAIgCgDQAAAAAAAAQAAgBAAAAQAAAAABgBQAAAAAAAAIgCgEIgCgDQgBAAAAgBQAAAAAAAAQAAgBAAAAQAAgBABAAIgEgFIgEgHIgBgEIgCgFIgBgEQgEgCAAgFIgDgHIAAgCIABgCIgBgCIgDAAIgCgEQAAAAAAgBQAAAAAAgBQAAAAAAAAQABgBAAAAIAAgDIgBAAQgDAAgBgCIgCgFQAAAAgBgBQAAAAAAgBQgBAAAAgBQgBAAAAAAIgCgEQAAAAAAgBQgBAAAAAAQAAgBAAgBQAAAAAAgBQAAAAgBgBQAAAAAAgBQAAAAgBgBQAAAAAAgBQAAgBAAAAQAAgBAAAAQAAgBAAAAQgBAAAAgBIgEgGIgCgFIgBgDIgBgDIAAgEIgDgEQgCgCAAgEQAAgDgCgDQAAAAAAAAQAAgBgBAAQAAAAAAgBQAAAAgBAAIgCgCIAAgDIAAgEIgBgCIgCAAIgCgEIAAgDIAAgDIgCgBIgDgHQgBgDAAgEQgBAAAAgBQgBAAAAAAQAAgBAAAAQAAgBAAAAIAAgFQAAAAgBgBQAAAAAAAAQgBgBAAAAQgBAAAAAAQgCgDgBgDIAAgGIgCgGQAAgBgBAAQAAgBAAAAQAAgBgBAAQAAgBAAAAQAAgBAAgBQAAAAAAgBQAAAAgBgBQAAAAgBgBQABgEAEgDQAEgDAFgCQAFgCAEAAIAGAAIAEABQAEgCAEABQAEABAEgBIAIABIAJABIAEACIABADIABADIAEAGQABAEADADIADAIIAEAIIAAABIADAGQADAFAAAFIAFAIIAGAOIAEAJIADAHIAHANIAGAMIACAHIAIAQIAIAVQADAKAAAGIABABIABABQAAABAAAAQAAABABABQAAAAAAABQAAAAABABIACAEQgBADgCABQAAAAgBABQAAAAgBABQAAAAgBABQAAAAAAABIACAGIADAJIABAGIAAAEIgBAEIgFACIgFACIgCgCgAgFhmIAAABIABAEQAAAAAAABQAAAAABAAQAAAAAAABQABAAAAAAIABgBIABgCIgBgEQgBAAAAAAQAAgBAAAAQgBAAAAAAQgBAAAAAAIgBABgAhMB0QAAAAgBAAQAAAAgBAAQAAAAAAAAQgBgBAAAAIgDAAIgBABIgCAAIgDAAIgEgBQgEgBgFAAIgJgCIgEAAIgCABIgDABIgGgBIgGABIgEgBIgDgCIAAgCQAAgDABgDIADgFIAEgHIADgIQADgBABgDIACgEQACgCAEABQAAgFACgCIACgDIACgDIABgCIAAgCIABgEIAFgHIADgEQAAgEACgDIAFgGIABgFIABgFQAFgGADgHIAGgNQABAAAAgBQABAAAAAAQAAAAAAgBQABAAAAgBIABgDIADgFIACgFQAGgEADgIIAIgOQACgCABgEIADgHQAAgBAAgBQABAAAAAAQAAgBABAAQAAAAABAAIADABIADADIACAHIAEAHQAAADACACQACACAAAEIAFAKIAFALQABABAAAAQABAAAAABQABAAAAABQAAAAAAABQAAADACACIAAABIACADIABADQACACACAGIADAIQAAAHADAFQADAGABAFIACAIQABAEACADIABAEIADADIADAGIABAGIgBADIgBADIgDAAIgDABIgLgBIgOgBIgKgBQAAAAAAgBQgBAAAAAAQAAAAAAgBQAAAAAAgBIgBgCIgBAAIgBABIAAABQAAAAAAAAQAAABAAAAQAAAAgBABQAAAAAAAAQgBAAAAABQAAAAAAAAQAAAAAAABQAAAAABAAIgGAAIgHABIgGADQAAAAAAABQgBAAAAAAQAAAAAAABQAAAAAAABQAAAAgBAAQAAABAAAAQAAAAgBAAQAAAAgBAAIgCAGQgCABgBADIgBAFQAAAAAAAAQAAABAAAAQAAAAgBABQAAAAAAAAIgDACQAAAAAAABQgBAAAAAAQAAABAAAAQAAABAAAAQAAABAAAAQgBABAAAAQAAAAgBABQAAAAgBAAIgCgBIgCADQAAAAgBABQAAAAAAAAQAAABgBAAQAAAAgBAAQAAAAgBAAQAAgBgBAAQAAAAgBAAQAAABgBAAgAh3BTIgEAHQgBADgCADQgCACAAAEIgDACIgBADIABADIAHAAIAAgBQAAgBAAAAQAAAAAAgBQAAAAgBAAQAAgBAAAAIgCgCQAAgFAEgEIAGgKQADgFABgFIAAAAIgGAIgAhoBYIgDAEIAAADIACAAIADAAQAAAAAAAAQABAAAAAAQAAgBAAAAQAAAAAAgBIAAgBIAAgEIAAgDIgDADgAgiBNIAAgBIgBgBIgBABIABABIABAAIAAAAIAAAAgAgIBGIgDADQAAAAAAABQAAAAABABQAAAAABAAQAAAAABAAIADABIAFgDIAAAAIAAgBIgEgDQAAAAgBAAQgBAAAAAAQgBAAAAABQAAAAgBAAgAAGBJIAFACIABgCIgBgDQAAgBgBAAQAAgBAAAAQAAAAgBAAQAAgBgBAAg");
	this.shape_4.setTransform(-36.575,1.725);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FF0000").s().p("AhOBwQAAAAgBAAQgBAAAAAAQgBAAAAgBQgBAAAAAAIgKgBQgDgBAAgDIgBgMIAAgBIABgBQAAgBAAAAQAAAAAAgBQAAAAAAAAQABgBAAAAIAEgCQACgCAAgFIAAgBIgCAAIgBABIgCABIgBAAIgBAAIAAgIIABgHQgBgBAAAAQAAgBAAAAQAAgBAAAAQAAgBAAAAQAAgBABAAQAAgBAAgBQAAAAgBgBQAAAAAAgBIAAgEIAAgFIAAgDQAAAAAAgBQAAAAABAAQAAgBAAAAQAAAAABAAIgBgFIAAgDIACgDQAAgBAAAAQABAAAAAAQAAgBAAAAQAAAAAAgBIAAgBIgBgBIAAgDQAAgBAAAAQAAAAgBgBQAAAAAAAAQgBgBAAAAIAAgFIABgFIgBAAIgBgCIABgDQAAAAAAAAQAAgBAAAAQAAAAAAAAQgBgBAAAAQAAAAAAgBQAAAAABgBQAAAAAAAAQAAgBABAAIACgCIgBgCIgBgBQABAAAAgBQAAgBAAAAQAAgBAAAAQAAgBgBAAIgBgFIAAgBIABgDQAAgBAAAAQAAgBAAAAQAAAAAAgBQgBAAAAAAIABgDIACgDIgBgBIgBgBIgBgCIAAgDQAAAAAAgBQAAAAABgBQAAAAAAAAQAAgBABAAIACgEIgBgJIABgEIABgEIgCgEQgBAAAAAAQgBAAAAAAQAAAAAAgBQgBAAAAAAIgBgEQABAAAAAAQAAgBAAAAQAAAAAAgBQAAAAAAgBIgBgDIABgIIAAgHQAAgBABAAQAAAAAAgBQAAAAAAgBQAAAAAAgBIAAgEIABgEQAAAAAAgBQAAAAAAgBQAAAAAAgBQAAAAAAgBQACgCAEgBIAHAAIADgBIACgDIALAAIAKAAIAFABIAFgBQABAAAAAAQABABAAAAQABAAAAABQABAAAAABIABALIABANIAAALIgBARQgBAJABAIIAAAEIAAAGIAAAEIAAAxQAAAZgCAYQABAEAAAEQgBAFABAEQgBADAAADIAAAGQAAABAAAAQAAABgBAAQAAABgBAAQgBAAAAABIAAgKIAAgJQAAgDgBgDIgDgEIgDADIACAFIABAFIAAAEIAAAEIgBADIgBAEIACADIgEADQAAgBAAAAQgBgBAAAAQgBAAAAAAQgBAAAAAAIgEABIgCgBIgBgBIAAAAIgDgBIgCgBIgCAAIAAACIgCADIgEAAIgEAAgAAJA0IgFgCIgDgBIgBgEIAAgFIABgFIgCgEQABgDABgCQACgCADgBIAEgDIAFgCQACgEAEgCQAEgDAAgFQAEgCADgEIAFgLQACgGAAgEIgCgOIgFgQIgFgMIgDgCIgCgDIgGgGQgEgEgFAAQgHAAgCgFQgDgFAAgHIABgDQAAgBABAAQAAAAAAgBQAAAAAAAAQAAgBAAAAIACgDIACgDQABgCAEAAIADAAIADABQADADAEABIAIABIAFADQADACADAAIACAAIACABQAEADAEABQAEACAEADQACAAACACIADAEIAFABIAGAHQADADABAFQADABABAEQABAEAEADQACACACAGIACAMIACAJIgBAJIgBAIQgBADAAAEQgBADgCACQgEAEAAADIgCAEQAAADgDADIgKAIIgCACQAAAAAAABQgBAAAAAAQAAAAgBAAQAAgBAAAAIgDADIgEABIgBAAIgCgBIgEACIgGAEIgDACIACACIACgBIAAACIgHAAIgHABIgDgDIgEADQgBABAAAAQgBABAAAAQAAABAAAAQAAABAAABIgDABIgEABIgBgBIgBgBIgCACIgCABIgEAAg");
	this.shape_5.setTransform(-62.225,2.775);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.pauseMenu, new cjs.Rectangle(-83.2,-24.3,166.4,48.6), null);


(lib.PauseText = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#404040").s().p("AgnBFIgCgJIACgDIgCgEQADgGAEgBIAIgEQAJgHABgGQAMgGAAgSQAAgPgMgUQgEgBAAgDQgLgJgDAAQgMAAAAgOQACgEAAgCQABgHAIAAQAEAAABACQAEAEAKgBQAGAEAEAAIADABQAEAEAKAEIAHAFIADABIAKAMQAEAIAEADQAFACADAWIgBAPQgDADgBAIQgEAEgBAGQgCAFgKAHQAAAAgBABQgBAAAAABQgBAAAAAAQgBAAAAAAIgGADIgDAAQgJAAgCAHQAAAAAAAAQABABAAAAQABAAAAAAQABgBAAAAIAAABIgLABIgDgCQgHAEABADIgGACIgCgCQAAAAgBAAQAAABgBAAQAAAAgBABQAAAAgBABQgJAAgCgCg");
	this.shape.setTransform(-6.8741,-1.5039,0.5795,0.5795);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#404040").s().p("AAUBhQgEgCgBgCIAAgBQgCgDAAgCIAAgBQABgCAAgGIABgCQABgBAAAAQAAAAAAgBQABAAAAgBQAAgBAAgBQAEgCAGgIQALgHAAgQIgBgJQgIgNgFADIgEgGIAAgDIgGACIgDgDIgFACQgLgEgJAAIgDgBQgIgBgCgDIgWgGIgQgJIgBAAIgHgCQgCgGgDAAQgBgFgEgCIgEgQIACgUIAJgNQAEgBAEgGIAUgMIAMABQAFgCALAAQADAAADACQAEAIAAAEIAAAKQgDAGgDACQgEAEgEAAIgEAEIAAAGIgBADQAAAEAEAEQAGAGAXABIATABQAHAAAUAJQACAEAKACIAGAFQABAFAJADQADAJAGAVIAAAOIgEAVQgBAJgNAIQgEAGgDADQgYALgOAAg");
	this.shape_1.setTransform(29.6109,-0.6202,0.5795,0.5795);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#404040").s().p("AAdBjQgGgCgBgCQgLgCgFgDQgJgDgIgLIgLgOIAAgBQgBAAgBgBQAAAAAAgBQgBAAAAgBQAAAAABgBIgCAAQgLAAABgPQgGgOAAgHQAAgcABgcIAAgDQgBgFACgEIAAgGQACgIgCgDIAAgHQACgFgBgBIAAgJIABgHIABgEQAFABAIgCQAFACAdABIADAAIAIAEIABAGQAAAQgCAgIgBAPQgCAEAAAPIAAAYQAAAAgBAAQAAABAAAAQAAABAAAAQgBABAAABIABAIQAGAEADAMQAIAKAHACQADAGgBACIABAFIgBADQABAIgEAEIABABIgCAFIgJAEg");
	this.shape_2.setTransform(13.8481,-0.4014,0.5795,0.5795);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("AgWAWIAAgsIAtAAIAAAsg");
	this.shape_3.setTransform(-28.5375,4.025);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgWAWIAAgsIAtAAIAAAsg");
	this.shape_4.setTransform(-19.1875,-5.675);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AgWAXIAAgtIAtAAIAAAtg");
	this.shape_5.setTransform(-23.8875,-0.9875);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#404040").s().p("AnzBvQgKgBgBgBQgCgCAAgLIAAgCQAHgBAAgJIgCgBQAAABAAAAQgBABAAAAQAAAAgBAAQAAAAgBAAIgBAAQgBgJABgEQACgFgDgCIAAgIQAAgEACgBIgBgHQADgDAAgCIgBgBQAAgFgCgBIAAgIIgBgCIAAgEQADgEAAgCIgBgCQgCgFAAgDIAAgBQACgEgBAAQACgDAAgDIgCgBIAAgEQAFgDgDgLIABgGIgBgEQgEAAAAgEQADgCgDgEIABgNIAAgGQADgFgCgCQADgDAKAAIAEgEQAMABAHgBQADACAKAAQACAHAAAYIgBAdIABAMQABA8gDAYQACAFAAAKQgBACAAAGQAAAFgDABIAAgRQAAgFgEgDIgCADIADAIIgBAHIgBAGIABADIgDACIgHAAQAAAAgBAAQAAAAAAgBQgBAAAAAAQAAgBAAAAIgBAAIgEgCIgCACQAAADgFAAIgCAAQgEAAgBgBgAk3BnQgFgCgLAAIgDAAIgFABIgLABQgEAAgCgDIgBgCIAEgJIAHgNQADgJAHABQAFgJAAgDIABgDQAAgFAIgIQABgEAFgIIADgIQAHgQAFgGQACgEACgBIAEgJQADgCAMgVQAEgOAEAAQACAAADADQABAFAFAHQAAAEAEAGIAJASQACAGADACIAAABQAAABADAEIAGAOQABAHAGANQADADADAJQAAAEADACIAEALQAAABAAAAQAAABgBAAQAAABAAAAQgBABAAAAIgGABQgaAAgGgCQAAAAgBAAQAAAAAAgBQAAAAgBgBQAAgBAAgBIgCABIABABIgCAEIgFgBQgGAAgGAEQAAABgBAAQAAAAgBABQAAAAAAABQgBAAAAABIgCAEQgEADAAAFIgDAEQgCABgCAEIgBAAQgDAAgCAEQgFABgCgCIgDAAQAAAAAAABQAAAAAAAAQgBAAAAAAQAAAAgBAAIgHgBgAlFBTIABADIABAAQABAAABAAQABAAAAAAQABAAAAgBQAAAAAAgBIAAgBIAAgGQgDABgDAFgAkCBFIgBgBIgBABIACAAgAjuBCQABADAGgBIAEgCIAAgBIgEgDIgHAEgADBBlIgCABQgFgDgDAAQgIgCgCgEQgHgGgFAAQgHgBAAgHIABgGQALgLAGAAQADAAAGAEIACAFIAWAIQACACAEAAQAEACAAADIgBACQAAABAAAAQAAAAgBABQAAAAAAABQAAABAAAAIAAACQgBAEgFADQgBACgJAAgAAiBXIACgQQAFgFAGgCQAFgCAAgDQAOgWgDgIQABgNADgGIAAgDQgDgLAEgEIgBgKIgCgEQAAAAABAAQAAAAABgBQAAAAAAAAQAAgBAAAAIAAgBQgCAAAAgGIAAgDQgDgJACgDIgBgbIgBgEIABgGQAEgGARAAQAGAAADADIAAAAQABAAAAAAQABAAABAAQAAABABAAQAAAAABABQAIAAACgCIAIgCQABAAAAABQABAAABAAQAAAAABABQAAAAABAAQACABACAFIgDAJQAAABAAAAQAAABAAAAQABAAAAABQABAAABAAQAAAAAAABQgBAAAAABQAAAAgBABQAAAAgBABQADAEAAAJQgDAFADAIQgDACABAEIgBAHIgCAFIAAgCIgCACQAAAJABABQgEACADAGIgCACQABAAAAAAQABABAAAAQAAAAABABQAAAAAAAAQAAAAAAAAQAAgBAAAAQABAAAAAAQAAgBABAAIACACIgCAFIACAFIAAAJIgCAQQgBAIgDAEIAAACQAAABAAAAQAAABAAAAQgBABAAAAQgBAAAAAAIgEAGQAAAFgHAGIgEgBIgNAJIgFAHIgEACIAAACQgDgBgEgEQgHAGgBABIgCAAQgDADgDAAQgBADgEABIgCADIgHABQgHAAAAgQgAicBhIAAgBQgFgEADgCQgGgFACgEQgJgIABgGQgCgCgBgFQgEgCgDgKIABgEQAAAAAAAAQAAgBAAAAQAAAAAAAAQgBAAAAAAIgCAAQgEgDADgDIAAgDIgBAAQgGABgDgJQgCgEAAgDQgDgBAAgGQgFgGAAgFQgCgBgBgCIABgEIgDgEQgCgHgCgCQAAgCgEgCIAAgGQAAgBAAAAQAAAAgBgBQAAAAAAAAQgBAAgBAAQgBgBAAgFQAAgBAAAAQAAAAAAgBQAAAAgBAAQAAgBgBAAQgEgIAAgEQgFgBgBgIQgBgLgDgFQgDgBgBgGQABgNAVAAIAJABQAJABAFgCIAPACIAFACQgBACADADQADADADAIQADAIAFAGIgBABIAGANQANAQAAALIASAhQASAcAAASQAAAAAAABQAAAAAAAAQAAAAABABQAAAAAAAAQAAACAEAFQAAAEgGADQAHAIAAAKIgCAHIgIAEIgFgEIgDAEIgGgBIgHABQgBgBgGAAIgCgDIgHAEIgCAAQgDAAgFgFgAFWBPQACgGgBgcIABgBIADAQQgCADAAANIABAFIABAAQACgFgCgBIAEgIIgBgCQAEgHAAgEIgBgDQgBgEgDgBQgDgZABgCIABgJQAAgHgDAAQAAABAAAAQAAABAAAAQAAAAgBABQAAAAgBAAQAAAAAAAAQgBgBAAAAQAAAAAAgBQAAAAAAgBIABgDIgBgCIABgDIACADIABgCIAAgEIgDgEQgCgEABgDIgBgDQAAgDADgDIgCgiIAAgHIABgCQgBgBACgEQACgBAAgEIAAgBIgCgBIAAADIgCgCIACgFIgDgOQAHgIAEAAIAHABQAEgBAXAAQAFAEALgEQAIAEAAARIgCAKQABAHgCAPQAAAOADADIAAAHQAAAKAIAAQAEgCAWAAIATAAQAJgEAOABIAMADQAJAIgDARIgDAOIgQACQgDgBgFABQgGACgDgCIgDABIgJAAIgWAAIgEgBIgQgBQgBADgGABQgHADAAAJQAAAGACACQgCAWACALQAAAEABAIQAAAEgCACIgaACIgCABIgCgBIgCABQAAAAgBAAQAAAAgBAAQAAAAgBAAQAAAAgBAAIgGABQgOAAgDgQgAF8BXIgCADIAEAAQASAAAAgGQgCgFAAgCIgBgEQgCAAAAAHIgBAAQgBALgJgFgAG6APIACgBIAFAAQAAAAAAAAQAAgBgBAAQAAAAgBAAQgBAAgBAAQgHgGgGAAIgDAAIgBADQAAAEAHABIACgBIAFABgAHwAGQABAEgIADIAFABQAGAAAAgDIgBgEIgDgCgAGjgRIAAACIAFAAIACAAIAAgCIgDgBgAHtBYIgBACIACABQAAADgEAAIgPgEIgIABIgMABQgDAAgHgEIAAgCIgBgCQADgFgFgGIAAgEIAAAAQADgPAEgEIAMgBIAEgBQAMAAAaADIAHACQADADgCAJQgCAFACAKIABADQAAABAAAAQAAABgBAAQAAABAAAAQgBAAgBABQgBAEgDACIgCgBIgEACQgDgGgDAAgAElhBQgDgGgUgDIgGgCIgGgNIAAgDQAEgCAIgHIAEACQAEgCAbANQABAFAIAFIACAIQAAAKgMAAQgDAAgIgFgAHvhCIgJAAIgEgBQgBABAAAAQgBABAAAAQgBAAAAAAQgBAAAAAAIgTgDIgCAAIgHgDQgDgGAAgGIAAgDIADgSQAMgJAHAFIAFAAIALgCQADABAFgCQAJAAAHABQACADAAAJQABADgDAGQAAABAAAAQABAAAAABQAAAAABAAQAAAAABAAIACAGQAAAFgDAIQgHADgHAAIgCgBgAH3hIIAAABIADABIABgDIAAgEIgDAAIgBAFgAHEhRQABAFAHAEIAAgGQgFgCgCgDg");
	this.shape_6.setTransform(15.951,-0.782,0.5796,0.5796);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-30.8,-7.9,76.6,14.2);


(lib.PageNumberBack = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(2));

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0.098)").s().p("Ak9E+IAAp7IJ7AAIAAJ7g");
	this.shape.setTransform(31.75,31.75);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(255,0,0,0.329)").s().p("Ak9E+IAAp7IJ7AAIAAJ7g");
	this.shape_1.setTransform(31.75,31.75);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,63.5,63.5);


(lib.NoText = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("Ah4A1QAAgBAAAAQAAgBAAAAQAAgBAAAAQAAgBgBAAIAAgLIAAgGIABgFIgBgFIABgJIAAgBQAAgBABAAQAAgBAAAAQABAAAAgBQABAAAAAAQABAAAAAAQAAAAABABQAAAAAAAAQABABAAAAIAHAIIAGAEIADAEIAAACIABANIAAABQAAADABAGIgBACIgBAAIAAgCIgBgFIgCABIABACIAAAAIgCADQAAABABAAQAAAAAAAAQAAAAABAAQAAABAAgBIgBABQgJAAgBgCIgCAAIgBADQgGgCAAgBgAh3AtQACADAAAFIACAAQAAAAgBAAQAAAAAAAAQAAAAAAgBQgBAAAAAAIACgEIAAAAIgCgCQAAgBAAAAQAAAAgBgBQAAAAAAAAQAAAAAAAAgAAzA1IgDgBIgCABQgEgCgDABIgFgBQAAgBgBAAQAAAAgBAAQAAgBgBAAQAAAAgBAAIgJgFIgEgDIAAgCQgEgBgCgCQgBgGgDAAIgBgCIACgBIgBgCIAAAAIgCABIgDgEIAAgCIAAgCIgCgDIAAgDIgBgNIAAAAQAAgNADgEQABgKAMgJQADgCAAgCIAGgEIAGgCIAIgCIABgBIALgCQAEAAAEAIIAAAGIgBADIgYALIgDAEIgEAGIAAAAIgBACIgBAHIAAADIAAAEIABAFQABAFACADIAEAHIACADIAHAFIAEgBIABABIAAACIAGAEQABABAAAAQAAABAAAAQAAABAAAAQAAABAAAAIAAAAIAAAEIABAGQAAABAAABQgBAAAAABQgBAAAAAAQgBAAAAAAIAAAAgAAFgXIAAABIADgFIACgCIABgBIABgBIAAgBQgDACgEAHgAgiA0IABAAQgDgCgDAAQAAgBgBAAQAAAAAAgBQAAAAAAAAQAAgBAAAAIgGgEIgBAAIgBAAIgGgHIgBAAIAAgBIgBgCIgBAAQAAAAAAAAQgBAAAAgBQgBAAAAAAQAAAAgBAAIAAgBQAAgBgBgBQAAAAAAgBQAAAAgBAAQgBgBAAAAQgCgDgDAAIgCgDIAAgBIgDgEQgBAAAAAAQgBgBAAAAQgBgBAAAAQAAgBAAAAIAAAAIgBgDQgBAAAAgBQAAAAgBAAQAAgBgBAAQAAAAgBAAIAAAAIgCACQgEgDAAgCIABgDIgDAAQgBAAAAAAQgBgBgBAAQAAAAAAgBQgBAAAAAAIgCgCQAAgBAAAAQgBgBAAAAQAAAAgBAAQAAAAgBAAQgDgDAAgCIgDgBIgCgEIgBgBIAAgBIABAAIAAAAIgBAAIgBAAQgBgBgBAAQgBAAAAAAQgBgBAAAAQAAgBAAAAQgHgHgBgBQABgHgCgDIADgLIACAAIAKAAIADAAIACAAIAGgBQADAAAFAEIAGAIQABAAABABQAAAAABABQAAAAAAABQABAAAAABIAFAFIAPANIACADIAFAFQAJAKAUAUQACABADAFIABAGIgBABIAAAAIgBgEIgEgFIAAAAIgDgDIAAABQAAAFAEABIABAEIgBAEIABABIABAAIAAgBQAAAAAAgBQAAAAABAAQAAAAAAAAQAAAAABAAIAAAJIAAADQAAABAAABQAAAAAAABQgBAAAAAAQgBAAAAAAQAAAAAAgBQAAAAAAAAQAAAAAAgBQAAAAgBgBIABgCIAAgBIgCABIAAABQAAAAAAABQAAAAgBAAQAAABAAAAQgBABAAAAIgFgBIgEABIgCABgAhqgOIABgCIAAABIgBgBgABTAxIgBgBIgDACIgEgBQgDgBAAgFIACgGQgDAAgBAFIAAAAQAAAAAAAAQgBAAAAAAQAAAAAAAAQAAgBAAAAIABgEQAMgFADgDQAGgEABgHIAEgFQADgJAAgGIgBgJIgBgDIAAgCIAAgCIgCgBIAAABIAAABIgCgDQAAgBAAAAQAAAAAAgBQgBAAAAAAQAAgBgBAAIgBgCIAAAAIgDgFIgCABIgHgCQgEgCgBgCQAAAAgBAAQAAgBAAAAQgBAAAAAAQgBAAAAAAQgBgBAAgEIABgJQACgCAEgCIAEgBIABABQAJAAANAMQABACAEACIACACQABABAAABQAAAAABABQAAAAABABQAAAAAAAAIACACQAAAEACABIAAADIAAABQADAAAAAHQAAABAAAAQAAAAAAAAQAAABAAAAQAAAAABAAIAAAEIABADIAAABIgCABIAAACIABgBIABABIAAAHIgBAFQAAABAAAAQAAABAAABQAAAAAAAAQAAABgBAAIgBgCIgBABIAAACIABABQgCABgBAFQAAAAAAABQAAAAgBAAQAAABAAAAQAAAAAAAAIgBADIABABIABAAIgCADQgCACgCADIgCADIgCgCQAAAAgBABQAAAAgBABQAAAAgBABQAAAAgBAAQgCAFgEAAQgEADgCABIgCgBIgFABgAgRgGIABgBQgGAAABgDIgBgCIgCABQgBAAAAAAQAAAAgBAAQAAgBAAAAQgBAAAAAAIgCgEIgGgFIgCgDIADgCIABAAIgCgCIgBgBIAAgBIAAgCQABAAAAgBQAAAAABAAQAAAAAAgBQAAAAAAgBQAAAAAAAAQAAgBAAAAQgBAAAAAAQAAAAgBAAIABgIIAAgCIAAgDQAGAAgBgDIAEgBIACABIAFAAIADAAIAFACIgCAFIABAEIgBADIABACIgBADIAAACIgBACIgBAAIABAEIABADIAAAAIgBAAIgBABQAAAAAAAAQABABAAAAQAAABAAAAQAAABAAAAIABAFQAAAHgCABg");
	this.shape.setTransform(6.5342,0.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.6,-4.7,24.4,11.100000000000001);


(lib.NextText = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AggA6QgNgSAAgoQAAgZAEgPQAGgPAKgJQAKgIAPAAQAMAAAIAFQAJAEAGAJQAFAIAEANQADAMAAAVQAAAZgGAQQgEAPgLAIQgLAJgPAAQgTAAgNgPgAgSgvQgJANAAAiQAAAjAHAMQAJAMALAAQAMAAAJgMQAIgMAAgjQAAgjgIgLQgJgLgMAAQgMAAgGAKg");
	this.shape.setTransform(34.4,1.05);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AAJBIIAAhvQgHAGgJAGQgKAGgIADIAAgRQAOgHALgKQAKgKAFgJIALAAIAACPg");
	this.shape_1.setTransform(22.625,0.925);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgIBHIAAh9IgwAAIAAgRIBxAAIAAARIgvAAIAAB9g");
	this.shape_2.setTransform(6.175,0.95);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("AAqBHIgkgzIgGgJIgGAKIgkAyIgXAAIA4hJIgxhFIAXAAIAZAlIALARIALgQIAdgmIAUAAIgxBEIA2BKg");
	this.shape_3.setTransform(-6.65,0.95);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("Ag0BHIAAiOIBmAAIAAARIhTAAIAAAsIBOAAIAAAQIhOAAIAAAwIBWAAIAAARg");
	this.shape_4.setTransform(-19.725,0.95);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AAlBHIhKhvIAABvIgTAAIAAiOIAUAAIBLBwIAAhwIASAAIAACOg");
	this.shape_5.setTransform(-33.95,0.95);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-43.1,-12,85.30000000000001,26.4);


(lib.MainMenuButton = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgPAxIgCgBIgBgBIgEgBIgDgCQgEgBgCgCIgFgGIgDgEIAAgBIgBAAIAAgCIgBAAIgDgBIAAgDIgBgDIgCgGQgBgCAAgEIAAgMIABgPIAAgBIAAgCIAAgCIAAgCIAAgCIAAgCIAAgCIABgDIgBgCIABgBIAAgBIAAgCIAAgDIAAgCIAAgBIAAgBIABgBIACAAIACAAIACAAIAFABIAGAAIAFAAIACAAIACABIACABIAAADQAAAGgBAGIAAAMIgBAEIAAADIAAADIgBAEIAAADIAAAFIAAAGIgBABIAAACIAAACIABABIACAEIACAFIADABIABACIADADIABACIAAABIAAABIAAABIAAABIAAACIAAADIgCACIAAABIAAABIgBABIgCACIgCABgAgkAiIACACIADADIABABIACACIABgBIgCgCIgCgCIgBgCIAAgBQAAAAAAAAQAAgBgBAAQAAAAAAAAQAAAAgBAAgAAGAtIAAgDIgBgDIABgEIAAgDIADgCIADgCIABgCQABAAAAAAQAAAAAAAAQAAAAAAAAQAAgBAAAAIADgEIACgGIABgFIAAgEIABgFIAAgBIAAgCIABgDIAAgDIAAgCIAAgCIgBgCIAAgBIABgBIAAAAIgBgBIAAgCIAAAAIAAgBIgBgDIAAgDIAAgHIAAgHIAAAAIAAgBIAAgCIAAgCIADgBIAEgBIADAAIACAAIACABIABAAIABAAIABABIACgBIADAAIABgBIACAAIABAAIABABIACABIAAACIAAADIgBACIAAAAIABABIAAABIgBABIABAEIAAACIAAADIAAAEIgBACIAAABIAAACIAAABIgBADIAAgBIgBABIgBACIABADIgBABIABADIgBABIABABIAAAAIAAAAIABAAIAAAAIABAAIgBABIAAABIAAABIABACIgBACIABABIgBADIAAAEIAAACIgBADIgBADIAAABIAAABIgBABIgBABIgBABIgBADIgCADIgBAAIgBgBIgDACIgEACIgBACIgBACIgCABIAAABIgBgBIgCgBIgCABIgCACIgBAAIgBABIgCAAIAAABIgCAAIAAABIgBABIgCABIgBABIgDgDgAATAtIACgBIACgBIACAAIADgBIAAABIgDABIgCABIgEABg");
	this.shape.setTransform(116.625,12.85);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AgsAwIgDgCIAAgCIAAgBIAAgFIgBgFIABgDIAAgDIAAgCIAAgCIAAgCIAAgCIAAgEIABgFIgBAAIABgCIADgBIABABIABABIABACIADADIACACIADACIACABIABACIACACIAAABIABAGIAAAGIABACIAAADIAAAEIgBACIgCAAIABgBIAAgBIAAgCIgBgCIgCAAIABABIAAACIgBABIgBABIABABIABAAIgBABIgCAAIgEgBIgDgBIgBAAIgBACIgDAAgAgqAuIgBAAIAAgBIABgBIAAgCIgBgCIgBAAIAAgBIgBgBIgBABIABADIAAADIABABIACAAIAAAAgAAqAtIAAgBIAAgBIABgCIAAgBIgDABIAAABIAAACIgBABIgCAAIgCAAIgCAAIgCAAIgBABIgBgBIABAAIgDgBQAAAAgBgBQAAAAAAAAQAAAAgBAAQAAAAgBAAIgBgBIAAgBIgCgCIgDgBQAAgBAAAAIgCAAIAAAAQAAAAAAgBQAAAAAAgBQgBAAAAAAQAAgBgBAAIgCgCIgCgBIAAgBIAAAAIgBgBIAAAAIgCgBIgBAAIgBgBIAAgBIgBgCIgBgBIAAAAIgCgBIgBgCIgBgBIgCgCIABgBIgCgBIgBgCIgBgBIgBgBIAAgBIgBgBIAAgBIgCgBIgCgBIgBAAIAAACIgCgCIgCgDIAAgBIABgBIgBgBIgCABIgCgBIgBgBIgBgBQAAgBAAAAQAAAAgBAAQAAAAAAAAQAAAAAAAAIgBgBQAAAAgBAAQAAAAAAAAQAAAAAAAAQAAAAAAAAIgCgCIgCgCIgCgBIgBgCIgBgCIgBgBIABgBIAAACIABgCIAAAAIgCAAIgCAAIgCgBIgBgBIgBgCIgDgDIgDgCIAAgFIAAgFIAAgEIAAgDIADgDIACAAIADABIAFAAIABAAIABAAIABAAIABgBIADAAIADAAQAAAAAAAAQABAAAAABQABAAAAAAQABAAAAABIAEACIADADIACAEIACABIACACIACACIACACIADAEIAEADIACACIADADIABACIACABIABACIACADIANAMIANANIACADIACACIABADIAAADIAAABIAAABIgCgDIAAgCIgBgCIgCgCIAAAAIgBgCIgBgBIgBACIABADQAAAAAAABQAAAAABAAQAAAAAAAAQABABAAAAIABACIAAABIAAACIAAABIAAABIABABIABAAIAAgBIAAgBIABAAIAAAEIABADIAAACIAAACIgBABIgCABIAAgBgAArgGIABAAIABgBIgCgBIgCAAQAAAAAAgBQgBAAAAAAQAAAAAAAAQAAgBAAAAIgBgBIgCABIgBgBIgBAAIgBgCIgBgCIgCgCIgDgCIgBgBIAAgCIABgBIABAAIABAAIgCgCIgBAAIAAgBIAAgBIAAAAIAAgCIACgBIAAgBIAAgBIgCAAIABgEIAAgDIAAgBIAAgCIAAgBIAAgCIADAAQAAAAABAAQAAAAAAgBQAAAAAAAAQAAAAAAgBIACAAIACAAIACABIACgBIACAAIACAAIADABIABAAIAAADIgBADIABACIAAABIgBABIAAABIABABIAAABIAAACIgBABIAAABIABABIgBAAIgBABIAAABIABACIAAABIAAABIABABIgBABIAAAAIgBAAIAAAAIAAABIAAABIABACIAAACIAAACIAAADQAAABgBAAQAAABAAAAQAAABAAAAQgBABAAAAg");
	this.shape_1.setTransform(105.85,12.775);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AAgAyIgCgCIgBABIABAAIAAABIgBABIgBAAIgDgBIgEgBIgCABIgBgBIgDABIgDAAIgCgBIgCgBIAAgBIAAgBIgBAAQAAgBAAAAQABAAAAgBQAAAAAAAAQAAgBAAAAIgCgDIAAgCIABgFIACgEIADAAIAEAAIAAgBIABAAIAJABIAJABIACAAIABABIABADIAAADIgBAEIAAADIABACIgBABIgBABIAAABIgCACIAAgBIAAAAIgBABIgBAAQAAAAgBAAQAAAAAAAAQAAAAAAgBQAAAAAAAAgAgeAzIgCAAIgFgBQAAAAgBgBQAAAAAAAAQgBAAAAgBQAAAAAAgBIgBgEIABgJIAAgIIAAgBIABAEIABAEIgBADIAAADIAAACIAAACIAAABIABAAIAAgCIAAgBIAAgCIABgCIAAgBIABgDIABgCIgBgBIAAgBIgBgBIAAgCIgBgEIAAgGIAAgDIAAgCIAAgDIAAgCIgBgBIAAABIgBABIAAgBIAAgBIAAgBIAAgBIAAgBIAAgBIABABIABgBIAAgBIgCgCIAAgBIAAgCIAAgBIgBgBIABgBIABgCIAAgCIgBgGIAAgFIAAgEIAAgBIAAgCIAAgBIAAAAIAAgBIABgCIABgBIAAgBIgBgBIAAABIgBAAIABgDIgBgCIAAgDIAAgCIABgBIACgCIABgBIACAAIACABIAEgBIAFAAIAEAAIACABIADAAIACgBIACADIABAEIABAEIgBABIAAACIAAACIAAAFIgBAGIAAACIAAAEIABACIAAACIAAACIABADIAEACIAEgCIAHABIAJAAIADgBIAEAAIADAAIADAAIADABQACACAAACIAAADIABAFIgBAGQAAAAgBAAQAAABAAAAQAAAAAAAAQgBAAAAAAIgHABIgBAAIgCAAIgCAAIgBAAIgBAAIgBAAIAAAAIgCAAIgDAAIgFAAIgFAAIgBAAIgCAAIgCAAIgEgBIgCABQAAAAAAAAQAAAAgBAAQAAAAAAAAQAAABAAAAIgCACIgBAEIAAACIABACIgBAFIAAAGIABAFIAAADIAAADIAAACIgBABIgGABIgHAAIgBAAIAAAAIgBAAIgBAAIgBABIgBAAgAgXAvIAAABIABAAIABABIADgBIADgBIACgBIgBgCIAAgCIAAgCIgBABIgBADIAAAAIgBABIgBACIgCgBgAgdApIAAACIAAABIABgBIABgBIAAgCIgBgBIgBACgAAFALIACABIAAAAIABgBIACAAIgBgBIgBAAIgBAAIgCgCIgDgBIgBABIgBAAIAAAAIAAABIABACIACAAIABAAIABAAgAAgAHQAAABAAAAQAAAAAAABQgBAAAAAAQAAAAgBAAIgCACIACAAIABAAIACAAIABgBIAAgBIAAgBIgCgBgAgDgDIABAAIACAAIAAAAIAAgBIAAAAIgBAAIgBAAIgBAAgAAggbIAAgBIgDAAIgCAAIgBAAIAAgBIgBABIgBABIgFgBIgEgBIgBAAIgCgBIgCAAIAAgDIgBgEIAAAAIAAgBIABgFIABgEIADgBIADgBQAAAAABAAQAAAAABAAQAAAAAAAAQABAAAAAAIABAAIABAAIADAAIACgBIACAAIACAAIAEAAIADABIABACIABADIgBACIAAADIAAABIABAAIABACIAAABIAAADIgCADIgCABIgCAAIgCABIgBAAgAAkggIgBABIABABIABAAIAAAAIAAgBIAAgBIAAgBIgBAAIAAABgAALgkIACADIADACIAAgDIgBgBIgDgBg");
	this.shape_2.setTransform(95.9,12.275);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ag4AyIgBgBIgBgCIABgDIAAgDIAAgDIAAgEIAAgFIAAgGIAAgBIABgBIAAgBIABAAIAAAAIABAAIADAEIADADIACAEIACAEIABACIAAACIAAACIAAACIAAACIAAADIgCABIAAAAIgDAAIgDAAIgDABIgCAAgAgFAwIgBAAIgBAAIgCgBIgBgEIgDgDIgEgEIgCgDIgBgDIgDgEIgCgCIgDgFQgCgCAAgCIgDgCQAAgBAAAAQAAAAAAgBQAAAAAAAAQgBgBAAAAQAAAAAAAAQAAgBAAAAQgBAAAAgBQAAAAgBAAIgBgDIgCgCIgCgDIgCgBIAAgCIgCgCIgBgCIgBgCIgCgDIgDgDIgBgCIgBgDIgBgFIAAgBIABgBIAAgEIAAgEIABgEIAAgFQAAAAAAgBQAAAAAAgBQABAAAAgBQAAAAAAgBQABAAAAAAQAAgBABAAQAAAAABAAQAAAAABAAIAEAAQABAAAAABQABAAAAAAQABAAAAAAQABAAABAAIACABIACADIABACIADAFIADAEIABADIABACIADAEIACAFIACADIACACIAAACIABACIADADIABACIABACIABADIABACIACACIABABIAAAAIACABIACABIABgBIABgBIAAgBIABgBIABgCIABgBIABAAIADgDIABgDIABAAIAAgBIAEgCIAEgCIABADIAAADIAAACIAAABIgBABIABAEIAAAFIAAACIAAACIAAACIAAABIAAAAIAAAEIgBAFIAAADIgCABIgBACIgDACQAAAAAAAAQAAABAAAAQAAAAAAABQAAAAAAAAIgCABIgBACIgCABIgBABIgDABIABABIgBABIgCACIAAAAIgBABIgCACIgBABIgBAAgAgzggIgBACIAAACIAAACIAAABIAAABIABgCIACgDIAAgDIAAgBIgBgCIgBAAIAAADgAgpgsIABABIACACIABABIAAABIACABIAAACIABAAIAAAAIAAgBIAAgCIgBgBIgCgBIAAgCIgDgBgAAlAwIgCgFIgBgFIAAgDIAAgEIgBgDIAAAAIABgDIAAgDIAAgDIgBgDIAAgCIAAgDIAAgEIAAgBIABAAIAAAAIAAgBIAAAAIgBgBIABgDIAAgCIAAgCIAAgCIAAgCIgBgEIAAgFIABgEIgBgHIAAgGIAAgCIAAgBIAAgDIABgEIADgBIADABIACAAIAFAAIAFgBIADABIAEAAIAAABIAAAAIAAADIgBADIABACIAAACIAAACIgBACIAAABIAAACIAAABIABACIgBABIAAABIAAABIAAACIAAABIgCAAIAAABIAAABIAAABIACABIAAABIAAACQgBAAAAAAQAAAAAAAAQAAABAAAAQAAAAABAAIgBADIgBACIACACIAAABIAAACIgCACIABADIABADIgBABIgBABIAAAAIABABIABABIAAAAIgCACIABADIgCAAIAAABIABABIABACIAAAAIgBABIAAACIAAACIAAACIAAACIAAACIABABIgBAAIAAABIAAACIABACIgBAEQAAAAAAAAQAAABAAAAQAAAAAAABQgBAAAAAAIgBAAIgBAAIgBAAIgDAAIgCABIgEAAIgDABgAA1AqIAAABIABABIAAgBIAAgCIAAAAIgBAAgAArApIAAABIABABIACAAIADAAIABAAIABgBIgBgBIABgBIgCAAIAAAAIgCABIgCAAIgCAAg");
	this.shape_3.setTransform(84.75,12.475);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgsAwIgDgCIAAgCIAAgBIAAgFIgBgFIABgDIAAgDIAAgCIAAgCIAAgCIAAgCIAAgEIABgFIgBAAIABgCIADgBIABABIABABIABACIADADIACACIADACIACABIABACIACACIAAABIABAGIAAAGIABACIAAADIAAAEIgBACIgCAAIABgBIAAgBIAAgCIgBgCIgCAAIABABIAAACIgBABIgBABIABABIABAAIgBABIgCAAIgEgBIgDgBIgBAAIgBACIgDAAgAgqAuIgBAAIAAgBIABgBIAAgCIgBgCIgBAAIAAgBIgBgBIgBABIABADIAAADIABABIACAAIAAAAgAAqAtIAAgBIAAgBIABgCIAAgBIgDABIAAABIAAACIgBABIgCAAIgCAAIgCAAIgCAAIgBABIgBgBIABAAIgDgBQAAAAgBgBQAAAAAAAAQAAAAgBAAQAAAAgBAAIgBgBIAAgBIgCgCIgDgBQAAgBAAAAIgCAAIAAAAQAAAAAAgBQAAAAAAgBQgBAAAAAAQAAgBgBAAIgCgCIgCgBIAAgBIAAAAIgBgBIAAAAIgCgBIgBAAIgBgBIAAgBIgBgCIgBgBIAAAAIgCgBIgBgCIgBgBIgCgCIABgBIgCgBIgBgCIgBgBIgBgBIAAgBIgBgBIAAgBIgCgBIgCgBIgBAAIgBACIgBgCIgCgDIAAgBIABgBIgBgBIgCABIgCgBIgCgBIAAgBQAAgBAAAAQAAAAgBAAQAAAAAAAAQAAAAAAAAIgBgBQAAAAgBAAQAAAAAAAAQAAAAAAAAQAAAAAAAAIgCgCIgCgCIgCgBIgBgCIgBgCIgBgBIABgBIAAACIABgCIAAAAIgCAAIgCAAIgCgBIgBgBIgBgCIgDgDIgDgCIAAgFIAAgFIAAgEIAAgDIADgDIACAAIADABIAFAAIABAAIACAAIAAAAIABgBIADAAIADAAQAAAAAAAAQABAAAAABQABAAAAAAQABAAAAABIAEACIADADIACAEIACABIACACIACACIACACIADAEIAEADIACACIADADIABACIACABIABACIACADIANAMIANANIACADIACACIABADIAAADIAAABIAAABIgCgDIAAgCIgBgCIgCgCIAAAAIgBgCIgBgBIgBACIABADQAAAAAAABQAAAAABAAQAAAAAAAAQABABAAAAIABACIAAABIAAACIAAABIAAABIABABIABAAIAAgBIAAgBIABAAIAAAEIABADIAAACIAAACIgBABIgCABIAAgBgAArgGIABAAIABgBIgCgBIgCAAQAAAAAAgBQgBAAAAAAQAAAAAAAAQAAgBAAAAIAAgBIgDABIgBgBIgBAAIgBgCIgBgCIgDgCIgCgCIgBgBIAAgCIABgBIABAAIABAAIgCgCIgBAAIAAgBIAAgBIAAAAIAAgCIACgBIAAgBIAAgBIgCAAIABgEIAAgDIAAgBIAAgCIAAgBIAAgCIADAAQAAAAABAAQAAAAAAgBQAAAAAAAAQAAAAAAgBIACAAIACAAIACABIACgBIACAAIACAAIADABIABAAIAAADIgBADIABACIAAABIgBABIAAABIABABIAAABIAAACIgBABIAAABIABABIgBAAIgBABIAAABIABACIAAABIAAABIABABIgBABIAAAAIgBAAIAAAAIAAABIAAABIABACIAAACIAAACIAAADQAAABgBAAQAAABAAAAQAAABAAAAQgBABAAAAg");
	this.shape_4.setTransform(64.45,12.775);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AgNAvQgDgCAAgGIgBgBIgBgBIABgCIAAgCIgBgFIABgIIABgIIAAgFIAAgBIAAgCIAAgCIAAgCQAAAAAAAAQAAAAAAAAQAAgBAAAAQAAAAAAgBIABgCIAAgGIAAgGIABgDIAAgFIABgDIgBgCIAAgDIAAgBIABgCIAAgBIgBgCIABgEIAAgFIABgBIACgBIABABIACAAIACAAQAAAAAAAAQAAAAAAAAQABAAAAAAQAAAAAAAAIACAAIACAAIACABIADgBIADAAIACAAIABAAIACABIAAgBQABAAABAAQAAAAAAABQABAAAAAAQAAABAAAAIACAEIAAACIAAACIABADIAAABIgBAEIABADIgBACIgBADIgBAIIAAAIIAAADIgBADIAAACIAAAEIAAAEIgBACIABABIgBADIAAAEIgBACIAAADIAAACIAAACIAAAAIAAAGIgBAGIAAACIgBADIgBABIgCACIgDAAIgDAAIgIABQgFgBgCgCgAgPAOIAAAEIAAAFIAAAGIABAHIAAABIAAgCIAAAAIABgCIABgCIgBgBIAAAAIAAgCIAAgBIgBgBIABgFIAAgFIAAgBIgBgBg");
	this.shape_5.setTransform(56.7,12.525);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("AA2AxIgBgBIgBABIgBABIgBAAIgBAAIgCAAIgCAAIgBgBIgCAAIgBgBIgCAAIgBACIgBAAIgCgBIgCgCIAAAAIgBgBIAAgBIAAgBIgBgCIgBgBIAAgCIgBgCIgCgCIgBgDIAAgBIgBgCIgCgDIgBgDIAAgBIABgBIgBgBIgBAAIgBgBIABgCIAAgBIgBAAIgCgBIAAgCIgCgBIgBgCIAAgCIgBgBIAAgCIgCgDIgBgCIAAgBIgBgBIAAgBIgBgCQAAAAAAgBQgBAAAAAAQAAgBAAAAQAAAAAAgBIgBgCIAAgCIgBAAIgBgCIABgBIgBgBIgBAAIAAgCIAAgBIgBgBIAAgBIgCgDIAAgDIgBgBIAAgCIgBgBIgBgDIAAgCIgBgDIgBgCQAAAAAAAAQAAAAAAgBQAAAAAAAAQAAAAgBAAQAAgBABAAQAAgBAAAAQAAAAABgBQAAAAABgBIADgCIAEgBIACAAIACABIADgBIAEAAIADABIAEAAIACABIAAABIABACIABACIACADIABAEIACADIAAABIABACIACAEIACAEIADAGIABAEIACADIACAFIADAFIABADIADAGIAEAJIABAHIAAABIABAAIABACIAAACIgBACIgBACIABACIABAEIABADIAAABIgBACIgCABIgCABIgBgBgAgCgrIAAAAIABACIABABIAAAAIAAgCIAAgBIgBgBgAggAyIgBgBIgCAAIAAABIgBAAIgBAAIgCgBIgEAAIgDgBIgCAAIgBAAIgCABIgCAAIgCAAIgCAAIgCgBIAAgBIABgDIABgCIACgDIABgDIACgCIABgCQAAAAAAAAQABAAAAAAQAAAAABAAQAAAAAAAAIABgDIABgCIABgBIAAgBIAAgBIABgBIACgDIABgCIABgDIACgDIABgCIAAgCIADgFIADgFIABgBIABgCIABgCIABgCIAEgFIADgGIABgDIACgDIABgBIABAAIABABIABADIACADIABADIABACIACAFIACAEIABACIABACIAAABIABABIABABIABADIABAEIABAFIACAEIABAEIABADIABABIABABIABADIABADIgBABIAAABIgCAAIgBABIgFgBIgFAAIgEgBIgBgBIAAgBIgBABIAAAAIAAABIgBABIgCAAIgDAAIgCACIgBABIgBAAIgBADIgBABIgBADIAAABIgCAAIAAACIgBABIgBAAIgBABIgBABIgCAAgAgyAkIgCADIgBACIgBADIgBAAIgBACIABABIACAAIABAAIgBgBIgBgBIACgEIADgFIABgEIAAAAIgCAEgAgsAmIgBABIAAACIABAAIABAAIAAgBIAAgBIAAgBIAAgCIgBACgAgOAhIAAAAIgBgBIAAABIABAAIAAAAIAAAAIAAAAgAgDAeIgBABIABABIACABIABgCIgBgBIgCAAgAACAfIADABIAAgBIAAgBIgCgBg");
	this.shape_6.setTransform(47.925,12.4167);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFFF").s().p("Ag4AyIgCgBIAAgCIAAgDIAAgDIABgDIgBgEIAAgFIABgGIAAgBIAAgBIABgBIAAAAIABAAIABAAIADAEIADADIACAEIACAEIABACIAAACIAAACIAAACIAAACIAAADIgCABIAAAAIgDAAIgDAAIgDABIgCAAgAgFAwIgBAAIgBAAIgCgBIgCgEIgCgDIgDgEIgDgDIgCgDIgCgEIgCgCIgDgFQgCgCAAgCIgCgCQAAgBgBAAQAAAAAAgBQAAAAAAAAQgBgBAAAAQAAAAAAAAQAAgBAAAAQgBAAAAgBQAAAAgBAAIgBgDIgCgCIgCgDIgBgBIgBgCIgCgCIgBgCIgBgCIgCgDIgCgDIgBgCIgCgDIgBgFIAAgBIABgBIAAgEIAAgEIABgEIAAgFQAAAAAAgBQAAAAAAgBQABAAAAgBQAAAAABgBQAAAAAAAAQAAgBABAAQAAAAABAAQAAAAABAAIAEAAQAAAAABABQABAAAAAAQABAAAAAAQABAAAAAAIACABIAEADIABACIACAFIADAEIABADIABACIADAEIACAFIACADIACACIABACIABACIACADIAAACIACACIABADIABACIADACIAAABIABAAIABABIABABIACgBIABgBIAAgBIABgBIABgCIABgBIABAAIACgDIACgDIABAAIABgBIADgCIADgCIACADIABADIgBACIAAABIgBABIABAEIAAAFIABACIAAACIgBACIABABIAAAAIAAAEIgCAFIgBADIgBABIgBACIgCACQgBAAAAAAQAAABAAAAQAAAAAAABQAAAAAAAAIgCABIgCACIgBABIgBABIgCABIAAABIgBABIgBACIgBAAIgBABIgCACIgBABIgBAAgAgzggIAAACIgBACIAAACIAAABIABABIABgCIABgDIAAgDIAAgBIgBgCIgBAAIAAADgAgpgsIABABIABACIABABIABABIACABIABACIAAAAIABAAIAAgBIgBgCIgBgBIgCgBIgBgCIgCgBgAAmAwIgDgFIgBgFIAAgDIgBgEIAAgDIAAAAIAAgDIAAgDIAAgDIAAgDIAAgCIAAgDIgBgEIABgBIABAAIAAAAIAAgBIgBAAIAAgBIAAgDIAAgCIAAgCIAAgCIAAgCIAAgEIAAgFIAAgEIAAgHIAAgGIgBgCIAAgBIABgDIABgEIAEgBIACABIACAAIAFAAIAEgBIAEABIAEAAIAAABIAAAAIAAADIgBADIABACIAAACIAAACIgBACIAAABIAAACIAAABIABACIgBABIAAABIAAABIAAACIAAABIgBAAIAAABIAAABIAAABIABABIAAABIAAACQgBAAAAAAQAAAAAAAAQAAABAAAAQAAAAABAAIgBADIAAACIABACIAAABIAAACIgBACIAAADIABADIgBABIAAABIAAAAIAAABIABABIAAAAIgBACIAAADIgBAAIAAABIABABIAAACIAAAAIAAABIAAACIgBACIAAACIAAACIABACIAAABIAAAAIgBABIABACIAAACIAAAEQAAAAgBAAQAAABAAAAQAAAAAAABQgBAAAAAAIgBAAIgBAAIgCAAIgCAAIgBABIgFAAIgDABgAA1AqIAAABIABABIABgBIAAgCIAAAAIgCAAgAArApIAAABIABABIACAAIADAAIAAAAIABgBIAAgBIAAgBIgBAAIAAAAIgBABIgCAAIgDAAg");
	this.shape_7.setTransform(35.1,12.475);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	// back
	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("rgba(255,255,255,0.008)").s().p("AroB+IAAj7IXRAAIAAD7g");
	this.shape_8.setTransform(74.5,12.575);

	this.timeline.addTween(cjs.Tween.get(this.shape_8).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.MainMenuButton, new cjs.Rectangle(0,0,149,25.2), null);


(lib.LastText = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgfA6QgOgSgBgoQAAgZAGgPQAFgPAKgJQALgIAOAAQALAAAJAFQAJAEAFAJQAGAIADANQADAMAAAVQAAAZgEAQQgGAPgKAIQgLAJgPAAQgUAAgLgPgAgTgvQgJANAAAiQAAAjAIAMQAJAMALAAQAMAAAJgMQAHgMAAgjQAAgjgHgLQgJgLgMAAQgLAAgIAKg");
	this.shape.setTransform(37.6,1.05);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AAJBIIAAhvQgHAGgJAGQgKAGgIADIAAgRQAOgHALgKQAKgKAFgJIALAAIAACPg");
	this.shape_1.setTransform(25.825,0.925);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgIBHIAAh9IgwAAIAAgRIBxAAIAAARIgvAAIAAB9g");
	this.shape_2.setTransform(9.375,0.95);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("AgcBFQgNgHgHgKQgIgMAAgOIASgCQABAKAFAIQAFAGAJAFQAKAEALAAQALAAAIgEQAJgCADgGQAFgGAAgGQgBgHgDgFQgEgFgJgEQgGgCgTgEQgUgGgHgCQgKgGgGgIQgEgIAAgKQgBgLAHgJQAGgJAMgFQALgFAPAAQAPAAAMAFQAMAFAHAKQAGAKAAANIgSABQgBgNgJgIQgIgGgQAAQgRgBgHAHQgJAGABAJQgBAIAHAFQAFAFAWAFQAXAFAIAEQANAFAGAJQAGAIAAAMQAAALgHALQgGAJgNAHQgMAFgPAAQgTAAgNgFg");
	this.shape_3.setTransform(-3.5,0.95);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AAuBHIgRgrIg7AAIgPArIgVAAIA3iOIAUAAIA6COgAgJgcIgQAoIAwAAIgPgmIgJgdQgDANgFAOg");
	this.shape_4.setTransform(-16.8,0.95);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AgsBHIAAiOIATAAIAAB9IBGAAIAAARg");
	this.shape_5.setTransform(-28.625,0.95);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-42.1,-12,87.5,26.4);


(lib.GameArea = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(0,255,255,0.318)").s().p("AwZcIMAAAg4PMAgzAAAMAAAA4Pg");
	this.shape.setTransform(105,-180);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GameArea, new cjs.Rectangle(0,-360,210,360), null);


(lib.Empty = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.EmilyLink = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		if(!this.hasEventListener("click"))
			this.addEventListener("click", onLinkClicked);
		
		function onLinkClicked(){
			var URL = "http://emilystrange.com";
			window.open(URL, '_blank');
		}
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AhKBCIgDgBIgBgCIABgEIAAgFIAAgEIAAgEIAAgIIABgIIAAgBIABgBIABgBIAAAAIABAAIABAAIAEAFQABADADABIADAGQACACAAADIACADIAAADIAAACIAAACIAAAEIAAACIgDACIgBAAIgDAAIgEABIgEABIgCgBgAAzA/IgEgGQgCgDAAgDIAAgEIAAgFIgBgEIAAgBIAAgEIABgEIAAgDIgBgEIAAgEIAAgDIAAgGIAAgBIABAAIABAAIAAAAIgBgBIgBgBIAAgBIAAgEIABgCIgBgEIAAgCIABgDIgBgFIAAgIIAAgEIAAgJIAAgJIAAgBIAAgDIAAgEIACgEQABgBAAAAQABAAAAAAQABgBAAAAQAAAAABAAIADABIADABIAHgBIAGgBIAEABIAGABIAAABIAAAAIAAADIgBAEIAAADIABACIgBADQAAABAAAAQAAABAAAAQAAAAAAAAQAAABAAAAIgBACIAAACIABACIABACIgBACIgBACIABABIAAACIgBACIgBAAIgBAAIAAABIAAABIAAABIADACIAAABIgBACIAAADIAAADIgBADIABADIAAABIAAACIgCADQABAAAAABQAAAAAAABQAAAAAAABQAAABAAAAIABAFIgBABIgBABIABABQAAAAAAAAQAAAAAAAAQAAAAAAAAQAAAAABAAIAAABIAAABIAAAAIgBACIABAEIgDABIAAABIABABIABACIAAABIgBABIAAADIAAADIAAADIAAACIAAACIABABIgBABIAAABIAAADIACACIgBAFQAAABAAAAQgBABAAAAQAAABgBAAQAAABgBAAIgBgBIgBAAIgCAAIgEABIgCABIgFAAIgFABgABHA2IAAACIAAABIABACIAAAAIABgCIAAgCIAAgBgABAA6IACgBIACgCIgBgBIABgBIgDAAIgBAAIgBACIgCgBIgDAAIAAABIAAABIABACIADgBIACABgAgIBAIgBgBIgCgBIgEgFIgDgEIgFgFIgCgEIgCgEIgEgFIgDgDIgDgGIgEgGIgCgDIgCgDQAAgBgBAAQAAAAAAgBQAAAAgBgBQAAAAAAgBIgDgDIgCgEIgCgDQgBAAAAAAQgBAAAAAAQAAAAAAgBQAAAAAAAAIgBgEIgDgCIgCgCIgBgDIgDgEIgDgEIgBgDIgCgEIgBgGIABgCIAAgBIAAgGIAAgFIABgGIAAgGQABgDABgCQAAgBABAAQAAAAABgBQAAAAABAAQABAAABAAIAFABQACABAEAAIADABIAEADQAAABAAAAQAAABABAAQAAABAAAAQAAAAAAABIADAGIAFAGQAAABAAAAQAAAAAAABQAAAAAAAAQABABAAAAIABAEIAEAFIADAGQAAABABAAQAAAAABABQAAAAAAABQAAAAAAABIADAEIABACIACACIACAEIABADQABABAAAAQAAAAABABQAAAAAAABQAAAAAAABIACADIACACIADADIAAACIAAAAIACABIADABIACgBIABgBIAAgBIABgDQABAAAAAAQAAAAABAAQAAAAAAAAQAAgBAAAAIACgCIAAAAIADgEQABAAAAgBQABAAAAgBQAAAAAAgBQAAAAAAgBIACgBIABgBIAEgCIAGgEQAAABAAAAQABAAAAABQAAAAAAABQAAABABABIAAAEIAAACIgBACIAAABIAAAFIAAAHIABADIAAADIAAACIAAABIAAABIAAAFIgBAHIgCAEIgCACIgBACQAAAAgBAAQAAAAAAAAQgBABAAAAQgBAAAAABIgBAEIgDABIgCACIgCACIgBACIgEABIABAAQAAABAAAAQAAAAAAABQgBAAAAAAQAAAAgBAAIgBADIgBABIgBABIgDACIgDABgAhFgsIAAAEIAAADIgBACIAAABIABABIABgDIACgDIAAgEIAAgCIgBgBIgBAAIgBACgAg3g7IACACIABACIABABIADABIABACIABADIABAAIAAgBIAAgBIAAgCIgBgCIgDgBIgBgDIgDgCg");
	this.shape.setTransform(209.75,15.8);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AgMBAIgBAAIgBAAIgCAAIgEgBIgEAAIgDgBIgDAAIgCgCIgCgBIgFgDIgGgCIgDgDIgCgCIAAgCIgEgBIgCgCIgCgCIgBgEQAAAAgBAAQAAgBgBAAQAAAAAAgBQgBAAAAAAIgBgCIADgBIgBgCIAAAAIgCABIgBAAIgBgBIgBgCIgBgBIgBgCIABgCIAAAAIgBgBIgBgCIgBgCIAAgEQgBAAAAgBQAAAAAAgBQgBAAAAgBQAAAAAAgBIAAgGIAAgFIAAAAIAAgGIACgJIADgGQAAgDACgFIAGgHIAGgGIADgCIACgDIADgCQABAAAAAAQABgBAAAAQAAAAABgBQAAAAAAAAIAEgCIAEgBIAEgCIAFgBIABgBIAHgCIAGAAQAFgBABACIACAEIACAFIgBADIABAEIgBABIgBACIgEADIgKAEIgJAEIgFACIgCACIgBADIgCAEIgDACIABABIgBABIgBABIgBAFIAAADIAAACIAAABIAAADIAAADIABAEIAAADIABAEIACAEIACADIADAFIABACIABABIADACIADAEIACABIADgBIACgBIACACIAAACIADADIAEACIABACIgBACIABADIAAADIAAADIABADIgCADIgCACIgCgBgAg8ggIgEAGIAAACIACgDIACgDIABgCQAAAAAAAAQAAAAABgBQAAAAAAAAQAAAAABAAIAAgBIABgBIABgBIAAAAIgBAAIgEAEgAAbA7IgBgCIgCABIgBABIgDAAIgDgBIgBgBIgBgCIgBgDIABgEIABgDQAAAAgBAAQAAAAgBABQAAAAAAAAQgBABAAAAIgBAEIAAAAIgBAAIAAgCIAAgCIABgBIAFgEIAHgDIAFgDIADgEIAEgFIACgFIADgCIABgDIADgJIABgIIgBgGIAAgFIgBgDIgBgCIABgBIAAAAIAAgCIAAgBIgDgBIAAAAIAAABIAAAAIgCgDIgBgBIgBgCIgBgDIgBAAQAAAAAAAAQgBAAAAAAQAAAAAAgBQgBAAAAgBIgBgDIgBABIgCAAIgEgBIgDgCIgDgCIgDgCIgCgBIgCAAIgCgDIAAgEIABgEIABgGIADgCIAEgDIACAAIACAAIABAAIABAAQAFAAAEADIAIAGIAJAFIACACQABABAAAAQABAAAAAAQAAABABAAQAAAAAAABIACACIABABIACADIACACIABACIABADIACADIABACIgBABIAAABIABAAQAAAAAAAAQAAAAABAAQAAABAAAAQAAABAAAAIABAEIAAADIABABIABABIAAAGIAAABIABABIAAABIgCABIAAADIABAAIABAAIAAADIAAADIAAADIgBADQAAAAAAAAQAAABAAAAQAAAAAAAAQAAABABAAIgBADIgBACIgBgCIgBABIAAADIAAAAIgBADIgCAEIAAACIgBABIgBACIAAACIABABIABAAIgBACIgBABQAAABgBAAQAAAAAAABQgBAAAAABQAAAAAAAAIgDAEIgCACIgBgBIgCgBQAAAAgBAAQAAAAAAAAQAAABgBAAQAAAAAAAAQAAABAAAAQAAAAgBABQAAAAAAAAQgBAAAAAAIgCAEIgBACIgEABIgDABIgFADIgBgBIgBAAIgDABIgDABg");
	this.shape_1.setTransform(193.375,15.95);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AAeBDIgEAAIgDAAIgCgCIgDgCIgBgCIgBgEIAAgDIABgDIABgDQADgDAEgCIAHgEQABAAAAAAQABAAAAAAQAAAAABgBQAAAAAAAAIADgCIACgCIABgDIADgDIACgEIABgEQAAAAAAAAQAAgBABAAQAAAAABAAQABAAAAAAIAEAAIADABIAAAAIACABIACABIAAADIABADIgBACIAAADIgBACIAAAAIAAABIgCAFIgCAEIgCADIgCAEIgCABIgBABIAAABQAAAAAAAAQAAABgBAAQAAAAAAAAQAAABgBAAIgCACIgDABQAAAAgBAAQAAAAAAABQgBAAAAAAQgBAAAAABIgDABIgCADIgCABIgCAAgAAfBBIADgBIgCAAIgBABgAgQA/IgDgBIgBAAIgBAAIgCAAIgCgBIgFgDIgIgHIgEgDIgBAAIgBABIgBABIAAAAIgBgDIgCgBIAAgBIgBgBIgBgCQgBAAAAAAQAAAAgBgBQAAAAAAgBQAAAAAAgBIgCgDIAAgCIAAgBIAAgBIgBgBIgBgDIgCgDIAAgCIgBgDIAAgCIgBgJQgBgEABgEIAAgBIAAgBIAAgEIABgEIABgCIAAgDIgBgBIgCACIAAgBIABgCIADgDIAAgBIgCABIABgDIACAAIACgDIADgFIABgDIgBgBIgBgBIABgCIACgDIABgDIADgCIACgBIACgCIACgCIADgCIAAgCIABgBIADgBIADgCIAGgDQADgCAEAAIADgBQABgBAAAAQAAAAABAAQAAAAABAAQAAAAABAAIABAAIABgBIAEABIAAACIABACIAAABIAAACIAAABIABAAIABAAIgBADIgDAGIgCACIgCADIgEACIgDACIgBABIgCABIgBACIgBACQgBAAAAABQAAAAgBAAQAAABAAAAQgBABAAAAIgDAFIgCAEIgBACIgCADIgBAJIAAAIIAAAJIACAIIABAEIACAFIADADQAAAAAAABQAAAAAAABQAAAAABAAQAAABAAAAQAAABABAAQAAAAAAABQAAAAABAAQAAAAABAAIACACIADAEIAEADQACACABAEIAAAGIgBACIAAACIgCADQAAAAAAAAQAAABgBAAQAAAAgBAAQAAAAgBAAIgCgBgAgQA5IAAAFIACAAQABAAAAAAQAAAAABgBQAAAAAAAAQAAAAAAgBIABgCIgBgCIgBAAIAAAAIgCAAIgBABgAg+gLIABAAIAAABgAAzgbIgCAAIgDAAIgDABIgDgCIgDgCIgCgDIgCgCIgEgEIgEgEIgCgDIgBgEIABgFIABgGQAAAAAAgBQAAAAABgBQAAAAABAAQAAgBABAAIAAAAIACgBIACAAQAEAAADACIAGADIADADIADACIACADIACACQAAABAAAAQAAAAAAABQAAAAABAAQAAABAAAAIADABQABAAAAAAQAAABAAAAQABAAAAABQAAAAAAAAIABADIABACIAAADIABADIgBAEIgBACIgCABIgGAAIgCgBgAA6ggIAAACIAAACIAAAAIACgCIABgCIgBgBIAAgCgAAlggIADADQAAAAABAAQAAABAAAAQABAAAAAAQABAAAAAAIABAAIAAAAIgBgBIgCgBQAAAAAAAAQAAgBAAAAQAAAAgBAAQAAgBAAAAIgDgBgAg2geQAAAAAAgBQAAAAAAAAQAAAAAAAAQAAgBAAAAIABgBIAAABIAAABIAAABIgBABg");
	this.shape_2.setTransform(178.625,15.625);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("AgIAJIAAgDIAAgEIAAgBIAAgBIAAgDIABgFIACgBIABABIABgBIABAAIAAAAIACAAIAAAAIACABIABgBIABAAIABAAIAAAAIACABIACABIABADIAAACIAAACIAAADIAAADQAAAAgBAAQAAABAAAAQAAABgBAAQAAAAgBAAIgDABIgEAAIgBAAIgBgBIgCgBIgBAAIgBADg");
	this.shape_3.setTransform(170.2,20.95);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AAqBCIgCgCIgBACIACAAIAAABIgCABIgBAAIgEgBIgGgBIgCAAIgCAAIgEAAIgEABIgDgBIgDgCIAAgBIAAgBIgBgBQABAAAAgBQAAAAAAgBQAAAAAAgBQAAAAAAgBQAAAAAAgBQAAAAAAgBQgBAAAAAAQAAgBgBAAIAAgDIACgGQABgDACgDIAEgBIADAAIABAAIACAAIANABIALABIADAAIACABIAAAEIAAAEIAAAFIAAAFIAAACIAAACIgBABIgBACIgDACIAAgBIgBAAIgBABIgBAAQAAAAgBAAQAAAAAAAAQgBgBAAAAQAAAAAAgBgAgpBEIgCAAIgHgBIgCgEIgBgGQABgFgBgGIAAgLIABgBIABAFIAAAFIAAADIgBAFIAAADIABACIAAACIABgBIAAgCIAAgCIAAgCIACgDIAAgBIABgEIACgDIgBgBIAAgBIgCgCIgBgCIgBgFIAAgIIAAgFIAAgDIAAgDIAAgCQAAgBAAAAQAAAAAAgBQAAAAAAAAQgBAAAAAAIAAABIgCABIAAgBIAAgBIAAgBIAAgBIAAgCIABgCIABACIABgBIgBgCIgCgDIAAgCIAAgCIAAgBIAAgBIAAgCIACgCIgBgEIAAgHIgBgHIAAgFIAAgCIAAgCIAAgBIABgBIAAgCIABgBIABgCIAAgCIgBgBIAAACIgBgBIABgDIgCgDIAAgEIAAgDIACgCIADgCIACgBIACABIACAAIAGgBIAHAAIAEAAIAEABIADAAIADAAIAEADIABAGIABAFIgBABIAAADIgBACIAAAHIAAAIIAAADIAAAFIABADIAAACIAAADIABAEIAEACQAEgCADABIAIAAIANAAIAEgBIAFAAIAFAAIAEAAIADABQADADAAADIAAAFIABAGIgCAHQAAABAAAAQAAABAAAAQgBAAAAAAQgBABAAAAIgIAAIgDAAIgDAAIgBAAIgCAAIgBAAIgBABIgCAAIgDgBIgCABQgDgBgEAAIgHABIgCgBIgBAAIgEAAIgFgBIgCABQgBAAAAAAQAAAAgBABQAAAAAAAAQAAAAAAABQgBAAAAAAQgBAAAAABQgBAAAAABQAAAAgBABIgBAEIAAADIABADIAAAHIAAAIIAAAGIAAAEIABAFIgBACIgBABIgIACIgIAAIgBAAIgCAAIgBAAIgBAAIgBABIgCAAgAgeA/IAAACIABAAIABAAIADgBIAGgBQAAAAAAAAQABgBAAAAQAAAAAAgBQAAAAAAAAIAAgDIAAgCIgBgCQAAAAgBAAQAAAAAAAAQAAAAAAABQAAAAAAAAIAAADIgBAAQAAAAgBAAQAAAAAAABQAAAAAAAAQgBAAAAABIgBACQAAABAAAAQAAAAgBAAQAAAAgBgBQAAAAgBAAgAgnA3IAAACIABACIABgBIAAgCIAAgDIgBgBIgBADgAAHAPIACABIAAAAIABgBIAEAAIgCgBIgCAAIgCgBIgCgCIgEgBIgBAAIgBAAIAAABIAAABQAAAAAAABQAAAAAAABQABAAAAAAQAAABAAAAIAEAAIABAAIABAAgAArAKQAAAAAAABQAAAAgBAAQAAABAAAAQgBAAAAAAIgDADIACAAIACAAIACAAIABgCIAAgBIAAgBIgCgCgAgFgEIACAAIACAAIABAAIAAgBIgBgBIgBAAIgBAAIgCAAgAAsglIgBAAIAAAAIgEgBIgCABIgBgBIgBAAIgCAAIgBABIgGAAIgGgCIgBAAIgCgBIgCgBIgBgEIgCgEIABgBIgBgBIACgGIABgGIADgCIAFgBQABAAAAAAQABAAAAAAQABAAAAAAQABAAAAAAIABABIABAAIAEgBIAEAAIACgBIADAAIAFAAIAFABIABAEIAAAEIAAACIgBADIABABIAAABIABACIAAACIAAAEIgBAEIgDABIgEABIgCAAgAAwgrIgBACIABAAIACABIABgBIAAgBIAAgBIAAgBIgDgBIAAACgAAQgwIACAEIADACIAAgEQAAAAAAAAQAAAAAAgBQgBAAAAAAQAAAAgBAAIgCgCg");
	this.shape_4.setTransform(162.5,15.525);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AgTBEIgEAAQgCgDgCAAIgFgBIgCgCIgCgBIgFgCIgEgEQgDgBgCgCIgEgEIgEgEIgDgGIAAgCIgBgBIAAgCIgFgGIAAgBIgBgCIAAAAIgBgDIAAgDIgBgCIAAgBIgBgHIAAgHIAAgBIAAAAQgBgFACgEIABgIIACgIIAAgCIAAgBIAAAAIAFgJIAEgFIAFgFIACgDIACgCIAFgDIAEgEIAEgBIACgBQABAAAAgBQAAAAAAAAQABAAAAAAQABAAAAAAIAEgCIABAAIAEAAIAFAAIADgBIAEgBIABABIAAACIACADIAAAEIAAACIAAAEIgBAFQgBAAAAAAQAAAAgBAAQAAAAgBAAQAAAAgBAAIgDAAQgEAAgDABIgEAEQgCACgEABIgCACIgCACIgCAEIgCADIgCAGIgCAGIgBADIAAADIAAABIAAACIAAADIgBACIAAACIAAAEIABACIAAACIAAADIAAABIABABIAAADIACACIACAGIADAHQAAAAABAAQAAAAABAAQAAABAAAAQAAAAABABIACACIAIAFIAIAEQAEADACAFIAAACIAAADIAAADIgCACIAAABIgBACIgCACIgEgBgAA8A/IgCgBIgCAAIgBAAIgBAAIgDAAIgCgBIAAgDIgBgBIAAgBIAAgCIgCAAIgCAAIgDAAIgBABQAAABgBAAQAAAAAAAAQgBAAAAAAQgBAAAAgBIgEACIgFACIgBgBIgCgBIgDABIgDABIAAABIACABIACgBIABABIABAAIgCABIgDAAQAAAAgBAAQAAAAgBAAQAAAAAAAAQgBAAAAAAIgCgFIgBgDIAAgEIgBgFIAAgBQAAAAAAgBQAAAAAAAAQAAAAAAgBQABAAAAAAIAAgDIACgDIAKgEQADgDACgEQACgEABgGIgCgCIgBgDIgDgBIgCgBIgEAAIgDABIgFABIgEgBIgCABQAAAAgBAAQAAAAAAgBQgBAAAAgBQAAAAgBgBIgBgHIgBgFIACgEQABgCAEAAIACAAIACABIACgBIABAAIACABIABAAIADAAIAEgBIADAAIAEABIADABIAEAAIAFAAIACAAQAAAAABAAQAAAAAAAAQABAAAAAAQAAAAAAAAIAHAAQAFAAADgBIAFABQACACAAADIAAAFIABABIgBAEIAAAEIAAAAQAAABAAABQgBAAAAABQAAAAAAABQAAAAABABIAAAEIgBAEIAAADIAAADIAAAEIAAADIAAAEIABADIAAADIAAAHIAAAFIgCAEIgCAAIgDABIgDAAIgBAAIgBAAgAAggoIgGgFIgHgFIgDgDIACgHQAAgDADgCQAAgBABAAQAAgBAAAAQABAAAAgBQABAAAAAAIAEAAIAEACIAEAAIAFAEIAGAEQADACAAADIgBAEIgCAEIgCAAIAAAAIABgBIAAgBIAAAAIgDABIAAABIAAACQAAABAAAAQAAAAgBABQAAAAAAABQgBAAgBABIgDABIgFgCg");
	this.shape_5.setTransform(148.35,14.9);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("Ag7BAIgEgDIAAgCQAAAAAAAAQAAgBAAAAQAAAAAAAAQAAgBAAAAIAAgHIAAgGIAAgEIAAgEIAAgDIAAgCIAAgDIAAgDIAAgFIABgGIAAgBIABgCIADgBIABABIACABIACACIAEAFIACADIAEABIADACIABAEIADACIAAABQgBAEABAFIABAHIABACIgBAFIABAFIgBACIgCABIABgCIAAgBIAAgDIgBgDIgDABIABACIABABIAAAAIgCACIgBABIABABIABABIAAABIgEAAIgFAAIgDgDIgCABIgBADIgFgBgAg5A9IgBAAIAAgBIABgCIABgCIAAAAIgCgCIgBgBIAAgCIgBAAIgBABIABAEIAAADQAAABAAAAQAAAAAAABQAAAAAAAAQABAAAAAAIACAAIAAAAgAA5A7IgBgBIABgBIAAgCIAAgBIgDABIAAABIAAACIgCACIgDAAIgCAAIgDAAIgCAAIgCABIgBgBIAAAAIgDgCQAAAAgBAAQAAgBAAAAQgBAAAAAAQgBAAAAABIgCgCIABgCIgEgCIgEgCIgBgBIgBABIAAgBQgBgCgCgBIgEgEIgCgBIAAAAIAAgBIgBgBIgBAAIgBgBIgCgBIgBgBIAAgBIgBgDIgCgBQgBgBAAABIgCgCQAAAAAAgBQAAAAgBAAQAAgBAAAAQAAAAAAAAIgBgCIgCgCIAAgBIgCgCIgCgCQAAAAAAgBQgBAAAAAAQAAAAAAgBQAAAAgBAAIgBgCIAAAAIgBgBIgBgCIgCgBIgCgCIgBAAIgBACIgDgDQgBAAAAAAQAAAAgBgBQAAAAAAgBQAAAAAAgBIAAgBIABgCIgCAAIgCAAIgCgBIgCgBIgBgCQAAgBAAAAQAAAAgBAAQAAAAAAAAQgBAAAAAAIgBgBQAAgBAAAAQgBAAAAAAQAAAAAAAAQAAAAgBAAQAAgBAAAAQAAAAgBgBQAAAAAAAAQgBAAAAgBIgCgDIgDgBIgBgCIgBgDIgCgBIABgBIABABIABgBIgBAAIgCgBIgCAAIgCAAIgCgCIgDgDIgEgEIgDgCIAAgHIAAgGIAAgFIABgFQAAAAAAgBQAAAAABgBQAAAAAAgBQABAAABAAIACAAIAGAAIAFAAIACAAIACAAIABAAIACAAIADAAIADgBIAFACQABACADABIAEAFIAEAEIADACIABADIAEACQAAAAABABQAAAAAAABQABAAAAABQAAAAAAABIAFAEIAEAEIAEAEIAEACIABADQAAAAAAABQAAAAABAAQAAAAAAABQAAAAABAAIACADIAEADQAHAJAJAIIARARIADAEIADADIABAFIAAADIAAACIgBAAIgBgCIAAgEIgCgDIgDgCIAAAAQAAgBAAAAQAAAAAAgBQAAAAgBAAQAAAAAAAAIgCgCIAAACIAAAEIAEADIABACIABACIgBACIAAACIAAACIABAAIACAAIgBgCIABAAIABgBIAAAGIABAFIAAACIAAACIgBACIgCABIAAgCgAA6gIIABgBIAAgBQAAAAAAAAQAAAAAAgBQgBAAAAAAQAAAAgBAAIgCgBQgBAAAAAAQAAAAAAAAQAAgBAAAAQAAAAAAAAIgBgCIgDACIgCgCIgBAAIgBgDIgBgCIgEgDIgEgDIgBgCIgBgCQAAAAAAAAQAAAAABAAQAAAAAAAAQAAAAABAAIACgBIAAAAIgCgCIgBgBIAAAAIAAgCIAAgBIAAgDIACAAIABgCIgBgBIgCAAIABgFIABgEIgBgCIAAgCIAAgCIABgBIADgBQABAAAAgBQAAAAABAAQAAAAAAgBQAAAAAAgBIADAAIACgBIACACIADgBIADAAIADAAIADAAQAAAAABABQAAAAAAAAQABAAAAAAQAAABABAAIgBADIgBAEIAAADIABACIgBABIAAABIAAACIABABIgBACIAAACIAAABIAAABIAAABIgCABIAAACIABABIAAADIABAAIAAACIAAABIgBAAIgBgBIAAABIgBABIACACIAAACIAAACIABADIgBAFQAAADgCACg");
	this.shape_6.setTransform(133.3375,16.2);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFFF").s().p("ABIBBIgBgBIgBACIgCAAIgBAAIgCAAIgCAAIgCAAIgDAAIgCAAIgBgCIgDABQAAAAgBAAQAAAAAAAAQAAAAAAAAQgBABAAAAIgBAAIgCgBIgDgCIAAAAIAAgCIgBgBIAAgCIgBgCIgCgBIAAgCIgCgDIgCgEIgBgDIgBgCIAAgDQgBAAAAgBQgBAAAAAAQAAgBgBAAQAAgBAAAAIgCgFIABgBIAAgBIgBgBIgBAAIgBgCIABgCIAAgCIgBAAIgCgBIgCgDQAAAAAAgBQAAAAAAAAQgBAAAAAAQAAAAgBAAIgBgDIAAgCIgBgCIgBgCIgBgEQgBAAAAgBQAAAAgBgBQAAAAAAgBQAAAAAAAAIgBgBIgBgCIABgCIgCgDQAAAAgBAAQAAgBAAAAQAAgBAAAAQgBAAAAgBIAAgDIgBgCIgBgBIgBgBIABgDIgBgBIgCAAIAAgCIAAgCIgBgBIgBgBIgBgEIgBgEQAAAAgBgBQAAAAAAAAQAAAAAAAAQAAgBAAAAIAAgCQAAgBAAAAQAAAAAAgBQgBAAAAAAQAAAAAAAAIgCgDIAAgEIgBgDIgBgCQAAgBAAAAQAAgBAAAAQgBAAAAgBQAAAAgBAAQABgCACgCIAFgDIAGgBIADAAIACAAQABAAAAAAQABAAAAgBQABAAAAAAQABAAABABQAAAAABAAQAAAAABAAQAAAAABAAQAAAAABAAIAFABIAEAAIAEABQgBAAAAABQAAAAAAAAQAAAAABAAQAAAAAAABIABACIACADIABAEIACAFIADAEIAAABIACADIACAGIACAFIAEAHIACAGIABADIAFAIIADAHIABADIAFAJIAEAMIACAKIAAAAIABABIACADIABACIgCACIgCADIABADIACAFIABAEIAAACIgBACIgDACIgDABIgBgCgAgDg6IAAABIABACIACABIAAAAIAAgCIAAgBIgCgBIgBAAgAgyBCIgCAAIgFgBIgFgBIgCAAIgCABIgCAAIgDAAIgEAAIgCAAIgCgBIAAgCIABgDIABgDIADgEIACgEIACgCIABgDIADgBIACgEIABgBIABgCIABgBIAAgBIAAgDIADgDIABgDIACgEIADgEIAAgCIABgDQADgDACgFIADgHQAAAAABAAQAAAAAAAAQAAAAAAAAQAAgBAAAAIABgCIACgCIACgDIAEgHIAFgIIACgEIABgEIACgCIACABIACACIABAEIACAEIABADQAAAAABAAQAAAAAAABQAAAAAAABQAAAAAAABIADAGIADAGQAAAAABAAQAAABAAAAQAAAAAAABQAAAAAAABIACACIAAABIAAACIABABIADAEIABAFIACAHIACAGIABAFIACAEIABACIABABIABAEIABAEIAAABIgBACIgBAAIgCAAIgGAAIgIAAIgGgBQAAgBAAAAQAAAAAAAAQAAAAAAAAQAAgBAAAAIgBgBIgBAAIAAAAIAAABIgBABQAAAAAAAAQAAAAAAABQAAAAAAAAQAAAAAAAAIgDAAIgEABIgDACIgBABIgBABIgCADIgCACIAAADIgBACIgBABIgBACIgBABIgBAAIgCABIgCABIgCAAIgCAAIgBAAIgBAAIgBABIgCgBgAhEAwIgCAEIgBADQgBAAAAAAQAAABgBAAQAAABAAAAQAAABAAAAIgBABIgBACIAAACIAFAAIAAgBIgBgBIgBgBQAAgDACgDIADgFIADgGIAAAAIgEAFgAg7AyIgCADIAAACIABAAIACgBIABgBIgBAAIAAgCIABgCIgCABgAgUAsIABAAIAAAAIAAAAIAAgBgAgEAoIgCACQAAAAAAAAQAAABAAAAQABAAAAAAQAAAAAAAAIADABIACgCIAAAAIAAgBIgBgBIgDAAgAADAqIADABIABgBIgBgCQAAAAAAgBQAAAAAAAAQgBAAAAAAQAAAAgBAAg");
	this.shape_7.setTransform(117.75,15.7417);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FFFFFF").s().p("AAbBAIgBAAIgCAAIgCgBQAAAAAAAAQAAAAgBgBQAAAAAAAAQAAgBAAAAIABgCIAAgBIgBgCIAAgCIgCgBIgCgBIgBAAIgBACIAAgBIAAgBIAAgBIgBAAIgDgDIgCgDIAAAAIAAgBIACABIABABIABAAIAAgBIgBgCIAAgDIgEgBQAAAAgBAAQgBAAAAgBQgBAAAAAAQgBgBAAAAIgCgEIgCgFIgBAAIgBgBIAAgBIgBgCIgBgDIAAgBIgCABIAAgCIABgBIgBgCIAAgBQAAgBAAgBQAAgBABAAQAAgBAAAAQABAAAAgBIAEgBIAEgCQACgBACgCIAEgEIACgFIACgCIAAAAIAAgCIACgDQAAAAAAgBQAAAAAAAAQAAgBAAAAQAAAAAAgBIAAgBIABgBIgBgBIgBgBIgBgFQAAAAAAAAQAAgBAAAAQAAgBgBAAQAAgBAAAAIgCgDQgBAAAAgBQAAAAAAgBQgBAAAAgBQAAAAAAgBIgEgBIgBgBIgBgBIAAAAIgBABIgBAAIgCgBIgCgCIgDgBIgCgBIgCgDIAAgBIAAgCIABgCIgBgDIAAgDIgBgDIACgDIACgBIADAAIACAAIABAAIACAAIAGgBIAGAAIACAAIABABIAEAAIADgBIACAAIACAAIAEABIAEAAIAHAAQAEABADACIAAADQAAAAAAAAQAAAAgBAAQAAAAAAAAQAAABgBAAIAAAAIAAAAIAAABIACABIABABIAAAAIABACIABACIAAABIADABIABACIACADQAAAEACACIACAGIABAFIgBAHIAAAGIgIAHIgCABIAAACQAAAAAAAAQAAABgBAAQAAAAAAAAQAAAAgBAAIgCAAIgDABIgCACQgBABAAAAQAAAAgBAAQAAABAAAAQAAAAAAABIgBAAIgBAAIgCABIgBACQAAAAAAAAQAAAAgBABQAAAAAAAAQAAAAgBAAIgCABIgCABQgBABAAAAQAAAAAAAAQgBAAAAABQAAAAAAABIAAAAIABAAQAAAAAAAAQAAAAABAAQAAABAAAAQAAAAAAABQAAAAAAAAQAAABAAAAQAAAAABAAQAAAAAAABIABgBIABgDIABADIACABIgCADIADABIAAgBIABAAIABABIABABIAAAAIAAABIgBABIABABIACACIACACIABADIACACIACADIACAEIgBABIgBgBIgBgBIgBABIAAABIAAABIAAAAIAAAAIABADQAAABAAAAQABAAAAAAQAAABAAAAQABAAAAABIACABIgBABIABABIAAABIACABIAAABIgBADIgDABIgCAAIgCAAIgCAAIgDgBIgBAAIgCACIgDAAIAAACIgBAAIgCgBIgBgCIgDABIAAACIgBAAIgCAAgAAoA3IABAAIACAAIABAAIABAAIgBgBIgCgBIgDAAgAg0A/IgEABIgCgDIgDgBIAAAAIAAAAIAAAAIAAACIAAAAIAAAAIgCgBIAAgBIAAgFIABgEIgBgGIgBgGIAAgCIABgBIAAgDQAAAAAAgBQAAAAABAAQAAAAAAAAQAAgBAAAAIAAAAIAAgBIgBgBIgBgCIAAgDIAAgBIAAgBIAAgEIABgGIAAAAQABAAAAAAQAAAAAAAAQAAABAAAAQAAAAAAAAIAAADIAAABIAAAAIABgEIAAgFIABgEIABgCIAAgCIgBAAIgDgBIAAgBIABgCIAAgDIAAAAIAAgCIAAgEIgBgCIABgDIAAgFIAAgDIgBgNQAAgGABgHIgBAAIAAgCQAAgBAAAAQAAAAAAgBQAAAAABgBQAAAAABgBIAEgCIAEAAIAIAAIAIAAQABAAABABQAAAAABAAQAAAAABAAQAAABABAAIAEAEIAAABIAAABIAAAFIgBAFIAAAAIgBACIAAADIAAAAIABABIAAABIAAAGIgCAHIgBAFIAAADIAAAEIAAADIgBAEIABACIABABIAAAAQAAAAgBAAQAAAAAAABQAAAAAAAAQAAABAAAAIgBACIABACIgBAEIgBAFIAAABIABABIAAAEIAAAFIABABIAAACIAAABIAAAEIgBADIAAAEIAAAFIgBADIgBAFIAAABIAAABIgBABIgCABIgBACIABACIgBABIgBAAIgBgBIgCAAIgBAAIgCABIgCABIgEgBgAA9A5IgBgDQgBgBAAgBQAAAAAAAAQgBgBAAAAQAAAAgBAAIABgCIABAAIACACIAAADIACABIAAACIAAACIAAABIgBABIgBgEg");
	this.shape_8.setTransform(102.125,16.15);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#FFFFFF").s().p("AgKBAIgBAAIAAAAIAAgBIADgCQABAAAAAAQAAgBABAAQAAAAAAgBQAAAAAAAAIAAgBIgCgBIgBACIgCACIgDABIgDABIgCABIAAgBIgBAAIgBgEIAAgDIAAgDIABgCIAAgCQgBgBAAAAQAAAAAAgBQAAAAABAAQAAAAAAAAIAAgHIgBgGIAAgEIABgDIAAgEIAAgEQAAgEAAgEQAAgEABgDIgBgEIABgEIgBgDIABAAIAAgEQAAAAAAgBQAAAAAAgBQAAAAAAAAQABgBAAAAIgBgIQAAgEgBgDIgBgCIAAgBIgDAAIgBAAIgFABIgFAAQgBAAAAAAQgBAAAAAAQgBAAAAAAQgBAAAAAAIgCAAIgCAAIgCAAIgCgBIgCgBIgBgCIABgCIgBgEIAAgEQAAgIACgDQAAgDAEgBIALAAIADgBIADAAIADAAIADgBIAEAAIAFAAIAGAAIAGAAIAIAAIAJgBIADABIAGAAIAEgBIADABIACgBIAEABIAFAAQAAAAAAAAQABAAAAAAQABAAAAABQABAAAAABIADAEIABADIAAANIAAAEQAAABgBAAQAAABAAAAQAAAAAAABQgBAAAAAAIgBACIgBAAIgBgBIAAgBIAAgBIgCgBIAAAEIABADIgBACIgCACIgDAAIgEgCQgBAAAAgBQgBAAAAAAQgBAAAAgBQgBAAAAgBIgCgBIgCgDIAAAAIgBAAIAAABIgBAAIgCAAIgDAAQgBACgBAFIgBAJIAAAIIAAAGIgBAFIgEAIIgBAIIgBAJIAAADIAAAEIgBACIACACQABAAAAAAQAAAAABgBQAAAAAAAAQAAgBAAAAIABgDIABABIAAACIgBADIAAAFIAAAEIABAFIgBAGIgCABIgBgCIABgBIgBAAIAAgBIgBABIgCABQAAAAAAAAQAAABAAAAQAAAAgBAAQAAAAgBAAIgEABIgCAAIgBAAIgCAAQAAABAAAAQAAAAgBAAQAAABAAAAQAAAAgBAAIgDAAIgBABIgBAAgAgSAIIAAADIAAAEIAAALIgBAMIABACIABgCIAAgCIABAAIAAAAIABgBIAAgDQAAAAAAAAQgBAAAAgBQAAAAAAAAQAAAAAAgBIAAgCQgBgDAAgFIABgIQABgEgCgEIgBAEg");
	this.shape_9.setTransform(89.15,15.975);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#FFFFFF").s().p("AgWBEIgCgCIgBAAIgDgBIgDgBIgBgBIgDgBIgCgBIgEgDQAAAAgBAAQAAgBAAAAQgBAAgBAAQAAAAgBAAQAAgBAAAAQAAAAAAAAQAAgBAAAAQgBAAAAAAIgCgBIgBgDIABgCIAAgCIAEgFQACgCAEAAIADABIADACIABABIABACIAEACIAEACIAFACIACABIACAAIACABIAAACIAAACIgBABIAAABIAAABIAAAAIgBADIgDACQAAAAAAABQAAAAgBAAQAAABAAAAQgBAAAAAAIgEAAgAAMBCIgCgBIgBgCIAAAAIAAgBIgBgBIAAgCIABgDIAAgDIAAgBIABgBIAAgCIADgDIAEgEQAEgDABgDIABgJIAAgDIAAgDIgDgCIgCgEQgBAAAAgBQAAAAAAAAQgBAAAAAAQAAAAgBAAIgCgBIgBgCIAAgDIgDABIgCgBIgCAAIgBAAIgGgBIgGgBIgBAAIgBgBIgCgBIgDAAIgCgBIgHgCQgEgBgCgCIgFgCIgFgDIgBAAIgCgBIgCgBIgCgCIgCgCIgBgCIgBgCIgBgGIgCgFIABgDIAAgDIAAgDIABgEQADgCAAgCIACgFQABAAAAAAQABAAAAgBQAAAAAAAAQABgBAAAAQAAgBAAAAQAAAAABAAQAAgBAAAAQABAAAAAAQAAAAAAAAQABgBAAAAQAAgBABAAQAAAAABgBIAGgDIAEgCIAEAAIADAAIAFAAIAGAAIABAAIACAAIACAFIABAEIAAADIAAAEIgCADIgCACIgDACIgDAAIgCADIAAACIAAABIAAACIgBABIACADIABACQACADADABIAHABIAGAAIAGAAIAGABIAFABIAGADIAGACIACACIADAAQAAAAAAAAQABAAAAABQAAAAAAAAQABABAAAAIACACIACACQAAAAAAAAQAAABABAAQAAAAAAAAQAAABABAAIACABIACACIADAJIADALIgBAEIAAAFIgCAIIAAAGIgCAFIgHAGIgCADIgDADIgMAEQgFADgHAAgAAqgpIgEgCQgBgCgCgCIgGgBIgFgBIgBgBIgCgBIgDgEQAAAAAAgBQgBAAAAgBQAAAAAAgBQAAgBAAAAIAAgCIADgDQABgBAAAAQAAgBABAAQAAAAABAAQABgBAAAAIACABIABAAQACAAAEABQAEABADADIAGADQABAAAAABQAAAAABABQAAAAAAABQABAAAAAAIADADIABADIAAADQAAACgDACIgFACIgDgBg");
	this.shape_10.setTransform(77.525,15.975);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#FFFFFF").s().p("AgQBEIgBAAIgBgBIgDAAQgCAAgCgDIgBgFIAAgCIAAgDIABgEIAAgDIAAgEIABgFIAAgBIAAgBIAAgDIAAgDIAAgCIAAgCIABgEIAAgEIgBgFIgDgGIgDgDIgBgCIAAgCIgBgBIgCgBIAAgDIABAAIgDgBIAAgDIgBgBIgBAAIgDgDIgBgDIgBgDIAAAAIgBgDIgCgDIgDgDIgBgDQgDgDAAgDQgCgEgDgCIgBgDIgBgDIgCgCIgBgCIgCgCIgCgCIgBgCIgBgCIACgDIACgCIACAAIABAAIADAAIADAAIADABIADAAIABgBIAFAAIADAAIABAAIABAAIADAAIACABIABAAIAAAAIABAAIAAACQAEABADAEIADAHQAEADABADIACAFIADAFIAAAAIACAEIAEAFIACAEIAAACIABABIAEAJIAFAIIABACIACADIACADQAAAAAAAAQAAABAAAAQAAABAAAAQAAABAAAAIABAIIAAALIAAAHIAAABIgBABIABACIgBABIAAAPIABABIAAADIAAAEIAAABIAAABIgBABIgBAAIgCgBIgDAAIgBAAIgBAAIgBAAIgCABIAAgBIgCgBIgBAAIgBAAIgBACIAAAAIgDAAIgCgBIgBABIgBABIgCgBIgBACIgBAAgAAbgRIgBgCIgCgCIgBgCQAAgBAAAAQAAAAAAgBQgBAAAAAAQAAAAgBAAIAAgDIgBgCIgBgCQAAAAgBgBQAAAAAAgBQAAAAAAgBQgBAAAAAAIgCgDIABgCIAAgCIADgEIADgDIAEgDIACgDIACgBIABgCIAFgDQABgCADgBIAFAAIAEAAIAIACIAGABQADAAAEAEIgDAEIgEAGIgEAFQAAAAAAABQAAAAgBAAQAAABgBAAQAAAAgBABIgDADIgCABIgBACIgDACIgBACQgDAAgCADIgEAFQgDACgDABIgBABIgBABIgCgBgAA9g3IABACQgBAAAAAAQAAABAAAAQAAAAAAABQgBAAAAABIAAADIAAAAIACgCIACgCIABgCIABgBIAAgBIgCgBIgCAAIAAAAIgBABg");
	this.shape_11.setTransform(64.1,15.9917);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#FFFFFF").s().p("AgrBAIgBAAIgBgDIgDgBIgBgDIAAgCIgBgCIAAgEIAAgDIgBgDIAAgEIgBgCIAAgCIAAgMIAAgMQgBgCAAgDQABgDgBgDIABgFIAAgFIAAgEIAAgFIAAgHIAAgDQgBgFAAgGIAAgKIAAgBIABgBIgBgCIAAgDIAAgBIAAgBIACgDIACgBIAEABIABAAIABAAIAEAAIABAAIADAAIABAAIABAAIABAAIACAAIACAAIADAAIADAAIAEABIACAAIACgBIAAABIABAAIAAAKIABAKIAAAJIgBAJIAAAHIAAAJIAAAHIAAAAIAAABIAAAHIAAAFIAAAOIAAAMIAAADIgBADIAAADIAAAFIAAACIgBADIgBAEIgGAAIgFABIgCgBIgCAAQgBAAAAAAQAAAAAAAAQgBAAAAAAQAAAAAAABIgCAAIgCABIgCAAIgCAAIgCAAgAgbA6IgBAAIAAACIAGAAIAFgCIAAgDIgDACQAAAAgBABQAAAAAAAAQgBAAAAAAQgBAAAAAAIgBAAIgBgBIgCABgAgSg4IAAADIABAEIABAHIAAAGIAAABIgBACIAAABIABAIIAAAIIABAAIAAgBIAAgBIAAgDIAAgDIAAgCIAAgCIAAAAIAAgBIAAgJIAAgKIAAgDIAAgEIgBgDIgBAAIgBACgAAuA+IgCgBIgCAAIgFABIgHAAIgGABQgBgBAAAAQgBAAAAAAQgBAAgBAAQAAAAgBAAIgEgBIgBgDQAAAAAAAAQAAAAgBABQAAAAAAAAQAAAAAAABIgBACIgEgBIAAgEIAAgCIAAgBIgBgGIAAgEIAAgBIgBgBIACgEIADgBIAHgBIAHAAIAEgBIABAAIAEABIAEAAIABAAIABAAIAJAAIABAAIACABIAAAIIACAHIAAAFIgCAGIgCAAIgCAAgAAvAqIABABIAAAEIgBAFQAAAAABABQAAAAAAAAQAAAAAAABQAAAAAAABIAAACIgCADIACACIADgBIAAgEIAAgDIAAgEIgBgGIAAgEIgCAAIgBACg");
	this.shape_12.setTransform(50.725,16.15);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#FFFFFF").s().p("AgJBCQgGAAgDgDQgEgDgBgIIAAgBIgBgCIABgCIAAgDIgBgHIABgKIABgLIAAgGIAAgCIABgDIgBgCIAAgDQAAAAAAAAQAAAAAAgBQAAAAAAgBQAAAAAAgBIABgDIAAgIIABgIIAAgEIABgGIABgEIgBgDIAAgEIAAgCIABgCIgBgCIAAgCIABgGIAAgGIACgBIACgBIACAAIACABIACgBQAAABABAAQAAAAAAAAQAAAAABAAQAAAAABAAIADgBIACABIADABIAEgBIAEgBIACAAIACABIABAAIACAAQABAAABAAQAAAAABABQAAAAABAAQAAABAAAAIACAFIAAADIAAADIAAAEIABACIgBAEIAAAEIAAADIgBAEIgBALQgBAGABAFIgBAEIgBAEIABADIgBAFIAAAFIgBADIABACIgBADIAAAFIgBADIAAAEIgBADIAAADIAAAAIgBAIIAAAIIAAAAIgBADIAAADQAAAAAAABQAAAAgBAAQAAABAAAAQAAAAgBAAIgCACIgEABIgFAAIgFAAIgGAAgAgUATIAAAFIgBAGIABAJIAAAJIABABIAAgCIAAgBIABgCIABgDIAAAAIAAgBIAAgDIgBgBIgBgCIABgGIAAgGIAAgCIgBgCg");
	this.shape_13.setTransform(41.325,15.8625);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#FFFFFF").s().p("AhKBCIgCgBQgBAAAAAAQAAAAAAAAQAAgBAAAAQgBAAAAgBIABgEIAAgFIABgEIgBgEIABgIIAAgIIAAgBIABgBIABgBIAAAAIABAAIABAAIAEAFQABADADABIADAGQACACABADIABADIAAADIAAACIAAACIAAAEIAAACIgDACIgBAAIgDAAIgEABIgEABIgCgBgAAzA/IgEgGQgCgDAAgDIAAgEIAAgFIgBgEIAAgBIAAgEIABgEIAAgDIgBgEIAAgEIAAgDIAAgGIAAgBIABAAIABAAIAAAAIgBgBIgBgBIAAgBIAAgEIABgCIgBgEIAAgCIABgDIgBgFIAAgIIAAgEIAAgJIAAgJIAAgBIAAgDIAAgEIACgEQABgBAAAAQABAAAAAAQABgBAAAAQAAAAABAAIADABIADABIAGgBIAHgBIAEABIAGABIAAABIAAAAIAAADIgBAEIAAADIABACIgBADQAAABAAAAQAAABAAAAQAAAAAAAAQAAABAAAAIgBACIAAACIABACIABACIgBACIgBACIABABIAAACIgBACIgBAAIAAAAIAAABIAAABIAAABIACACIAAABIgBACIAAADIAAADIgBADIABADIAAABIAAACIgBADIAAAEIABAFIgBABIAAABIAAABQAAAAAAAAQAAAAAAAAQAAAAAAAAQAAAAABAAIAAABIAAABIAAAAIgBACIABAEIgDABIAAABIABABIABACIAAABIAAABIAAADIgBADIAAADIAAACIAAACIABABIAAABIgBABIABADIABACIgBAFQAAABAAAAQgBABAAAAQAAABgBAAQAAABgBAAIgBgBIgBAAIgCAAIgEABIgCABIgFAAIgGABgABHA2IAAACIAAABIABACIAAAAIABgCIAAgCIAAgBgABAA6IACgBIACgCIgBgBIABgBIgDAAIgBAAIgBACIgCgBIgDAAIAAABIAAABIABACIADgBIACABgAgIBAIgBgBIgCgBIgEgFIgDgEIgEgFIgDgEIgDgEIgDgFIgDgDIgDgGIgEgGIgCgDIgCgDQgBgBAAAAQAAAAAAgBQAAAAgBgBQAAAAAAgBIgCgDIgDgEIgCgDQgBAAAAAAQgBAAAAAAQAAAAAAgBQAAAAAAAAIgBgEIgDgCIgCgCIgBgDIgDgEIgDgEIgBgDIgCgEIgBgGIAAgCIAAgBIABgGIAAgFIABgGIAAgGQABgDABgCQAAgBABAAQAAAAABgBQAAAAABAAQABAAABAAIAFABQACABAEAAIADABIAEADQAAABAAAAQAAABABAAQAAABAAAAQAAAAAAABIADAGIAFAGQAAABAAAAQAAAAAAABQAAAAAAAAQABABAAAAIABAEIAEAFIADAGQAAABABAAQAAAAABABQAAAAAAABQAAAAAAABIAEAEIAAACIACACIABAEIACADQABABAAAAQAAAAABABQAAAAAAABQAAAAAAABIACADIACACIACADIABACIAAAAIACABIADABIACgBIABgBIAAgBIABgDQABAAAAAAQAAAAABAAQAAAAAAAAQAAgBAAAAIACgCIAAAAIADgEQABAAAAgBQABAAAAgBQAAAAAAgBQAAAAAAgBIACgBIABgBIAEgCIAGgEQAAABAAAAQABAAAAABQAAAAAAABQAAABABABIAAAEIAAACIgBACIAAABIAAAFIAAAHIABADIAAADIAAACIAAABIAAABIAAAFIgBAHIgCAEIgCACIgBACQAAAAgBAAQAAAAAAAAQgBABAAAAQgBAAAAABIgBAEIgDABIgCACIgCACIgBACIgDABIAAAAQAAABAAAAQAAAAAAABQgBAAAAAAQAAAAgBAAIgBADIgBABIgBABIgDACIgDABgAhFgsIAAAEIAAADIgBACIAAABIABABIACgDIABgDIAAgEIAAgCIgBgBIgBAAIgBACgAg3g7IABACIACACIABABIADABIABACIABADIABAAIAAgBIAAgBIAAgCIgBgCIgDgBIgBgDIgEgCg");
	this.shape_14.setTransform(29.4,15.8);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#FFFFFF").s().p("AAqBCIgCgCIgBACIABAAIAAABIgBABIgBAAIgEgBIgGgBIgBAAIgDAAIgEAAIgEABIgDgBIgDgCIAAgBIAAgBIgBgBQABAAAAgBQAAAAAAgBQAAAAAAgBQAAAAAAgBQAAAAAAgBQAAAAAAgBQgBAAAAAAQAAgBAAAAIAAgDIABgGQABgDACgDIAEgBIADAAIABAAIACAAIANABIALABIACAAIADABIAAAEIAAAEIAAAFIAAAFIAAACIAAACIgBABIgCACIgCACIAAgBIgBAAIgBABIgBAAQAAAAgBAAQAAAAAAAAQgBgBAAAAQAAAAAAgBgAgpBEIgCAAIgHgBIgCgEIgBgGQABgFgBgGIAAgLIABgBIABAFIAAAFIAAADIgBAFIAAADIABACIAAACIABgBIAAgCIAAgCIAAgCIACgDIAAgBIABgEIACgDIgBgBIAAgBIgCgCIgBgCIgBgFIAAgIIAAgFIAAgDIAAgDIAAgCQAAgBAAAAQAAAAAAgBQAAAAAAAAQgBAAAAAAIAAABIgCABIAAgBIAAgBIAAgBIAAgBIAAgCIABgCIABACIABgBIgBgCIgCgDIAAgCIAAgCIAAgBIAAgBIAAgCIACgCIgBgEIAAgHIgBgHIAAgFIAAgCIAAgCIAAgBIABgBIAAgCIABgBIABgCIAAgCIgBgBIAAACIgBgBIABgDIgCgDIAAgEIAAgDIACgCIADgCIACgBIACABIACAAIAGgBIAHAAIAEAAIADABIAFAAIACAAIAEADIABAGIABAFIgBABIAAADIgBACIAAAHIAAAIIAAADIAAAFIABADIAAACIAAADIABAEIAEACQAEgCADABIAIAAIAMAAIAFgBIAFAAIAFAAIADAAIAEABQADADAAADIAAAFIABAGIgCAHQAAABAAAAQAAABAAAAQgBAAAAAAQgBABAAAAIgIAAIgDAAIgDAAIgBAAIgCAAIgBAAIgBABIgCAAIgDgBIgCABQgDgBgEAAIgHABIgCgBIgBAAIgEAAIgFgBIgCABQgBAAAAAAQAAAAgBABQAAAAAAAAQAAAAgBABQAAAAAAAAQgBAAAAABQgBAAAAABQAAAAgBABIAAAEIAAADIAAADIAAAHIAAAIIAAAGIAAAEIABAFIgBACIAAABIgJACIgIAAIgBAAIgBAAIgCAAIgBAAIgBABIgCAAgAgeA/IgBACIACAAIABAAIADgBIAGgBQAAAAAAAAQABgBAAAAQAAAAAAgBQABAAAAAAIgBgDIAAgCIgBgCQAAAAgBAAQAAAAAAAAQAAAAAAABQAAAAAAAAIAAADIgBAAQAAAAgBAAQAAAAAAABQAAAAAAAAQgBAAAAABIgBACQAAABAAAAQAAAAgBAAQAAAAgBgBQAAAAgBAAgAgoA3IAAACIACACIABgBIAAgCIAAgDIgBgBIgCADgAAHAPIACABIAAAAIABgBIADAAIgBgBIgCAAIgBgBIgDgCIgEgBIgBAAIgBAAIAAABIAAABQAAAAAAABQAAAAAAABQABAAAAAAQAAABAAAAIADAAIACAAIABAAgAArAKQAAAAAAABQAAAAgBAAQAAABAAAAQgBAAAAAAIgDADIACAAIACAAIACAAIABgCIAAgBIAAgBIgCgCgAgFgEIACAAIACAAIABAAIAAgBIgBgBIgBAAIgBAAIgCAAgAAsglIgBAAIAAAAIgEgBIgCABIgBgBIgBAAIgCAAIgBABIgGAAIgGgCIgBAAIgCgBIgCgBIgCgEIgBgEIABgBIgBgBIABgGIACgGIADgCIAFgBQABAAAAAAQABAAAAAAQABAAAAAAQABAAAAAAIABABIABAAIAEgBIAEAAIACgBIADAAIAFAAIAFABIABAEIAAAEIAAACIgBADIABABIABABIAAACIAAACIAAAEIgBAEIgDABIgEABIgCAAgAAwgrIgBACIABAAIABABIACgBIAAgBIAAgBIAAgBIgDgBIAAACgAAQgwIACAEIADACIAAgEQAAAAAAAAQAAAAAAgBQgBAAAAAAQAAAAgBAAIgCgCg");
	this.shape_15.setTransform(14.8,15.525);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_15},{t:this.shape_14},{t:this.shape_13},{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	// Layer_2
	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("rgba(255,255,255,0.008)").s().p("AxuCUIAAknMAjdAAAIAAEng");
	this.shape_16.setTransform(113.5,14.75);

	this.timeline.addTween(cjs.Tween.get(this.shape_16).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmilyLink, new cjs.Rectangle(0,0,227,29.5), null);


(lib.Tween3_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FF0000").s().p("AgQAAQAAgRAQAAQARAAAAARQAAASgRAAQgQAAAAgSg");
	this.shape_2.setTransform(6.5375,-0.375);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FF0000").s().p("AgaAAQAAgYAaAAQAbAAAAAYQAAAZgbAAQgaAAAAgZg");
	this.shape_3.setTransform(-6.2859,0.376,0.7124,0.7124);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_3},{t:this.shape_2}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.2,-2.1,16.4,4.300000000000001);


(lib.Squarecopy = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("Ag7A8IAAh3IB3AAIAAB3g");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6,-6,12,12);


(lib.Square_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#000000").s().p("AgxAyIAAhjIBjAAIAABjg");

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5,-5,10,10);


(lib.HighScoresText = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AAABvIAAhJIhMAAIAAhNIBKAAIAAhHIBMAAIAABOIhJAAIAABBIBLAAIAABOg");
	this.shape.setTransform(-68.45,-0.975);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#404040").s().p("AO4B5IgCABQgDgBgGgDQgBgFgKgBQgGgCgIgFQAAAAAAgBQAAAAgBgBQAAAAgBAAQAAgBgBAAQgEgBAAgFIABgHQAOgLAFAAQADAAAHADIADAGIAYAKQACACAEAAQAEABAAAFIAAACQAAAAgBAAQAAABAAAAQAAABAAAAQAAABAAABIgBACQAAAGgGABQgBAEgKAAgAgoB5IgDABQgDgBgGgDQAAgFgLgBQgFgCgIgFQAAAAgBgBQAAAAAAgBQgBAAgBAAQAAgBgBAAQgDgBAAgFIAAgHQAOgLAFAAQADAAAHADQADAEAAACIAYAKQACACAFAAQADACAAAEIAAACQAAAAgBAAQAAABAAAAQAAABAAAAQAAABAAABIgBACQgBAGgFABQgBAEgKAAgAP6B6QgEgDgCgDIABgBQAAgCgDgDIAAgBQACgDAAgGIAAgDQADgBAAgEQAGgIAFgEQAMgGAAgTIgBgJQgCAAgEgIQgEgFgDABQgDAAgDgGIAAgDIgFABIgEgDQgCABgDABQgIAAgPgFIgEgBQgCgEgKAAQgWgHgCgCIgRgHIgBAAQgDAAgFgEIgGgGQgDgCgBgGQgDgQgCgCIABgKQACgEAAgIQAHgDADgLQADgIAFAAQABgEAWgKIANABIASgBQAEAAACACQAFALAAADIAAALQgEAHgEABQgDAEgGABIgEAEIAAAGIgBAEQAFAFgBADQAIAJAaAAIAVACQADAAAbAJQALACABAFQABAEAHACQAAACAFADQAFABABACQAJAZAAALIAAAPQgCAEgDASQgBALgPAIIgIAKIgqANgAkXB6QgCgCgRgBQABgCgCgEIAAgCQADAEADAAIABgBIABgCIgHgEIgCgDIADgFIABADIACgFIgBgCIAAgJQACgFADgCIAAgFIABgCIACgUIABgFIgBgBIgCgMQgBgEgGgBIAAgBQAAgHgHAFIgIgCQgCgFgBgMQABgDgBgFQAAgCAGgHIAMAAQAEAAAFgFIAAgCQAAgBAEgDIgBgEIABgCQgCgFADgBQgGgKAAgTIAAgfQACgCABgFQABgEAFAAQAEgCAMAAQAIADADAAIAFgCIAIAAQAIAAADAEIAGAAQABAFAFAIIAAAGQAAALgCAHQABAEgBACIABAMQAAALgCAFIABAEIgDAEQgBAHABAEIgBACIACAEIgBACQgBABAAAGIAAADIgCAGIACACIABAFQgGAFAAAEIACAIQgDAJABAFIgBAQIgBALIgBAIQAAAAAAABQAAAAAAAAQABABAAAAQAAAAABAAQgDAWABAFQgDAEgFAAIACgDQAAgDgCgDIgCAAIgDABIgCAEIgCAAQgEgBgDAEIgDgBIgKACQgCACgFAAIgFAAgAj9AgIABABQgCADAAACQAAAFAEABQABgBAAgKIABABIACgFIgEAAgAj+ASIACACQAAgCADgDIgDAAgAMqB6QAAgCgFAAQgDAAAAgGQABgBAAAAQABgBAAAAQAAAAAAgBQAAAAAAgBQAAgDgDgEIgGgEQgBAAAAABQgBAAAAAAQAAABgBAAQAAABAAAAQAAABgBAAQAAgBAAAAQAAAAAAgBQAAAAAAgBQAAAAAAgBQAAAAgBgBQAAAAAAAAQgBAAAAAAQgJgIAAgCIABAAIAAgBQACADACAAIACAAIAAgBIgBgIIgOgGQAAgFgKgJIgBAAQgCAAAAgFQAAgDgDgEIgBgDIgCADIgBgFIACgBQgBgBAAgFQAAgJATgDQAMgCAGgUQADgEAAgCQAAgDADgGIABgEIgCgEQgCgLgDgCQAAgEgGgHIgHgCQAAgBAAgBQgBAAAAgBQAAAAgBAAQAAgBgBAAIgBAAQAAABAAAAQAAABgBAAQAAAAAAAAQgBABAAAAQgGgBgJgGQgFgCgCgEIgBgDIACgHQAAgJgCgGIAGgHIAJAAIAHABQAPgDAHAAQAAAAABAAQABAAAAAAQABABAAAAQABAAAAABIANgBQADAAAEgBQAJADAFAAQARAAAIAFQgBAFgDAAIgBABIABABIAGAEIAAABQAEAEgBACIAAACIAGABQACAHADADQAJASAAAKQgDAOAAAHIgOALQgGABAAAFQgEAEgFAAQgHAEgBAEIgCAAQgDgBgEAGQAAAEgGAAQgHABAAAEIAAABIABAAQABAGADAAIABAAIACgGIAFAIIgDAFIAFABIABAAIAFABIAAAAQAAABgBAAQAAABAAAAQgBAAAAABQAAAAAAAAIAEAGQAEAKAGABIAHALIgBACIgEgCIgBAAIgCAEIABACQAFAFAAADIADACIAAABQAAABAAAAQAAABAAAAQABABAAAAQAAABABABQADABAAADQAAACgHADIgFgBIgDABIgIgCIgCABQgBACgIAAIgBAEIgBAAQgCABgEgGIgEACIgBADIgFACgANCBlIABAFIAFABQABAAABgBQAAAAABAAQAAAAABgBQAAAAAAgBQAAgBgFgCgAKYB3QgCgDgHgDIABADIgBABQgEAAAAgEIACgPIgDgTQAAgFACgCQgCgFAEgCIAAAAIgDgCIgCgKIABgCQgBgIACgJIABgBQABAAAAAGIABADQACgFABgRIABgGIgCgEIgEgBIAAgBIACgKIgBgRIAAgNIAAgqQgBgBAAAAQAAgBgBAAQAAAAAAgBQAAAAAAgBQAAgKATAAIAcABQAEAAALAIIABAGQgDAKAAAEIABADQgDADAAACIADADIAAACQAAAYgGAHIABAJQAAAHgDAGQAEACAAACIgBABQABAHgDABIABAEQgDAIAAAFIABAFQACAKgCAEIACAGIAAABQAAAIgBAEQgDALACAEIgDANIAAACQAAAAAAABQAAAAAAABQAAAAgBABQAAABgBAAIgBAAQgBAAgDAFQAAAAAAAAQAAAAABABQAAAAAAAAQAAABAAAAQAAABAAAAQAAAAgBABQAAAAAAAAQgBAAAAAAIgHgCIAAAAQgCAEgHgBgAm1B1IgGgEIAAgFIABgOIgBAAIAAgQQACgFgBgKIAAgIQADgDAAgHIgBgOQABgDgCgJIABgSQAEgDgDgaIAAgJIAAgDIAAgNIABgMQAAgJABgQQABgCgCgFQAAAAABgBQAAAAAAgBQAAAAABAAQAAgBAAAAIADgFQAEgBACABIARgBQAEACADgBQARAHADgCIAEABIAJgCQADAAABADIgBAZQgCAoACAJQgBAAAAABQAAAAAAABQAAAAgBABQAAAAAAABIABADIAEABIAIAGQAGACABAFQAEABAAACQgCAQACAIIgDAGIgDgCIABgEIgEABQAAAFgCABIABACIADgCIgBACQgCAAgCADIgIgDIAAAAIABACIgGAKIAAACIgBAQIAAABQgCAkABAEQABAHgCADQgFABAAACIgHAAQAAAAgBAAQAAAAAAAAQgBAAAAAAQgBgBAAAAIgCgDIgDADQgCgDgCAAIAAACQAAABAAAAQAAABAAAAQAAAAgBAAQAAAAAAAAQgDAAgDgDIgCABIgDgBIgFACIgTACgAJgByQgCADgCAAIgGAAIgIAAQgBgBgGAAIgDgDQgHABgBADIgCAAQgEAAgFgFIAAgBQAAgDgCgEQAAgEgEgGQgKgIABgHIgDgIQgFgCgDgMIABgEQAAAAAAAAQAAgBAAAAQAAAAAAAAQAAAAgBAAIgDAAQgDgFADgCIAAgDIgBAAQgHAAgDgKQAAgCgCgFQgDgCgBgFQgBgFgEgHIgDgGIABgCIgDgFQgEgDgBgIQAAgCgEgDIAAgGQAAgBAAAAQAAAAAAgBQgBAAAAAAQgBAAgBAAQgBgCAAgFQAAgBAAAAQAAgBgBAAQAAgBAAAAQgBAAAAgBQgFgHAAgGQgFgBgBgIQgEgGAAgMQgEgBgBgHQACgOAXAAIAKABQAKABAFgCIARACIAFADQACADAAACQAEAJAEADQACAKAFAGIAAABQAGAJAAAFQANAUACALQACABARAkQATAeAAAVQAAAAAAAAQAAABAAAAQABAAAAAAQAAABABAAQADAFAAADQgFAEgBAEQAHAHAAANIgBAIQgEAAgGAEIgFgEgAGFB0QgFgCgNAAIgDAAIgGABIgMABQgFgBgCgCIAAgDQAAgEAEgGQAFgHADgHQADgKAIABQABgKAFgDIABgDQAAgJAJgFQABgGAGgHIADgJQAGgIAIgRIAEgGIAFgJQAEgDANgWQAFgQAEAAQACAAAEADQAAAHAGAHQAFAGgBAFIALAUQACAGACACIAAAAIAEAIIAHAPQAGAPABAHQACAKAEAEQAAAEAEACQAEAIAAAFQAAACgDACIgGACQgaAAgKgDQAAAAgBAAQAAgBAAAAQAAgBgBgBQAAAAAAgBIgBABIAAAAQgBABgBAAQAAABgBAAQAAABAAAAQAAABABAAIgGAAQgGAAgHAEQgCABgCADIgCAFQgEADAAAGQAAABgEADQgCABgCAFIgCgBQgDAAgCAEQgDgBgFAAIgDAAQAAABAAAAQAAAAgBABQAAAAAAAAQgBAAAAAAgAFmBdQgGAGABAFQgDABAAADIAAADIAHAAIAAgBQAAAAAAgBQAAgBAAAAQgBgBAAAAQgBAAgBAAQABgKAOgSIgBAAIgKAOgAF2BfIABADIABAAQABAAABAAQABAAABgBQAAAAABAAQAAgBAAAAIgBgBIABgHIgHAHgAG+BPIACABIAAAAIgBgBgAHpBNIAFACIACgCIgEgGgAugB1QgCgCgRAAQABgDgCgEIAAgBQADADACAAIABgBIACgBIgHgEIgCgEIACgEIACADIACgGIgBgCIAAgJQABgFADgCIABgEIABgCIABgVIACgEIgBgBIgDgNQAAgEgHAAIAAgBQAAgHgGAFIgJgCQgCgFgBgMQABgEAAgEQAAgCAFgHIAMAAQAFAAAEgFIAAgCQAAgBAEgEIgBgDIACgCQgCgFADgBQgHgKAAgTIAAggIADgHQABgEAFAAQAEgBAMAAQAIACADAAIAFgBIAIgBQAIAAADAEIAGAAQABAFAFAIIAAAGQAAAMgCAGQABAEgBACIABANQABAKgDAFIABAFIgCADQgBAHABAEIgBACIACAEIgBACQgBABAAAGIgBADIgBAGIABACIABAFQgFAFAAAEIACAIQgDAJAAAFIAAAQIgCALIAAAIQAAABAAAAQAAAAAAABQAAAAABAAQAAAAAAABQgCAVABAFQgDAFgGAAIADgEQgBgDgBgCIgCgBIgEABIgCAEIgBAAQgFAAgCAEIgDgBIgKACQgDABgFAAIgEAAgAuGAbIABABQgDAEAAACQAAAFAEAAQABgBAAgKIACABIABgEIgEAAgAuHANIACACQAAgCADgDIgDAAgAAgB0QgFgCgCgEIABgBQAAgCgDgCIAAgBQACgDAAgGIABgEQACgBAAgDQAGgJAFgDQAIgEADgJQABgFAAgHIgBgJIgGgIQgEgGgDABQgDABgDgGIABgEIgGABIgEgCIgFABQgIAAgOgEIgEgBQgCgEgKgBQgWgGgBgDIgSgHIgBAAQgDAAgFgDIgGgHQgDgCgBgGQgDgRgBgBIAAgKQACgEAAgHQAHgEADgLQAEgHAFgBQAAgDAWgKIANABIASgBIAGABIAFAPIAAALQgDAGgEACQgEAEgFAAIgFAFIAAAFIgBAFQAGAFgCADQAIAJAZAAIAVACQAEgBAbAKQAKACACAFQAAACAHAEQAKAEABAEQAJAZAAAKIAAAPQgCAEgDATQgBAKgPAJQgEAHgDADIgRAEIgaAIgAERB0QgDgDgHgCQgDgFAAgLQAAgEAEgHQAHgHASgGIAKgHQABgDAEgEQAEgDAFgJQACgJAGAAIALACIABAAIAGADQACADAAAHQgCAFAAAEIgCADIABABQgGAOAAACIgJAMQgDAAgCAEIAAABQgGACAAADQgJADgCADQgIAFAAACQgDABgGAAgAw+BxIgGgEIAAgFIABgOIgBAAIAAgQQACgFgBgKIAAgHQADgDgBgIIgBgOQACgEgCgHIAAgSQAEgEgDgaIAAgJIABgDIgBgNIABgNQAAgIABgPQABgDgCgFQAAgBAAAAQABAAAAgBQAAAAAAAAQABgBAAAAIADgFQAEgBACABIARgBQAEACADAAQARAGADgCIAEABIAJgCQADAAABADIgBAYQgCApACAJQAAAAgBABQAAAAAAAAQAAABAAAAQAAABAAAAIAAAEIAFABIAHAFQAGADACAEQAEABAAAEQgCAPABAHIgCAHIgDgCIAAgEIgDABQAAAFgDABIACABIADgBIgBACQgCAAgDADIgHgDIgBAAIACADIgGAJIAAACIgCAPIABACQgCAkABAEQABAHgCADQgFABAAACIgHABQAAAAgBgBQAAAAgBAAQAAAAgBAAQAAgBgBAAIgBgEIgDADQgCgDgCAAIAAADQAAABAAAAQAAABgBAAQAAAAAAAAQAAAAAAABQgDAAgDgEIgCAAIgDAAIgFACIgTADgANnBrQgCgIgDgBIABgCIABAAQADAAACAIIACADIABAFQAAAAAAABQAAAAAAAAQAAABgBAAQAAAAgBAAQgBAAgCgHgADFBsIgDAAIgIgBQgEgCgagTIgCAAQAAAAAAABQAAAAAAAAQgBABAAAAQAAAAgBAAIgBAAQgDgCgDgGIABAAQAAgCgEgDQgFgBgCgKIAAgEQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAAAgBgBQAAgGgFgEIAAgDQgDgGABgDIgBgcIgBgGQAAgEACgHIACgIIgCgCIgEADIAAgBQAAgCAHgGIAAgCIgDAAIACgEIAEAAIAKgTQAAgCgEgBIAFgIIAHgJQAEgEADAAQAEgFAFgDQAAgCACgDQAHgBADgDIACgCQgCAJgIAFQgFADgGAIQAAADgDACIAAADQAAAGgCADIAAABQACADAAACIAAABQABAEAFABIAEACIAagIIgLAPQgFAFAAAEQgDAUAAAKQAAASAEAJIAGAQQAEAIADADQAHACABAEQAIAJAGACQABABADAUQgDABACAGQgGAGgDAAQgEAAgFgEgADKBkIAAAIIAEAAQAFAAAAgGIgDgDIgBgBIgFACgAsoBvIgBgEIgFgCIgEgNIgCgKQACgEgEgIIgCgJQgBgNABgbQgDgDACgQQABgGAAgNQgBgfABgBQgEgMABgYIACgEIgCgIIABgEQACgGAEgBIAJABIADgBIAHACIADgBIAEABQAAAAABAAQABgBAAAAQABAAAAAAQABgBAAAAQADADADgBIAJgBQALAAACACIAHgBIADACIACAjIAAAeQACAdgDAKIABADIAAAVQgCAeACAPQABAGgDADQABAJgBAFIACADQgFAMgBAAQgGACgNABIgEgCQgGgBgDACQgCgBgEADIgEAAIgDABIgBAAIgGgBgAsKBmIABADQAMgBAJgDIAAgGIgMAHIgEgCQgDABgDABgAr5hdQAFALAAATQgDAEAAADIABACIABAbIACABIABgFQgBgHAAgEQgBgBACgFIgBgCIAAggQAAgOgCgEIgDAAgAqABpQgEgEgMgCQgBgDgFgCQgMgEgFgGQgHgBgIgLQgEgFgIgKQAAgEgDgHQgCgDgFgFQABgDgEgCIAAgBIgCgJIgCgFIAAgBQAAgIgDgOIABgDQAAgQAHgbQABAAAAAAQAAgBAAAAQAAgBAAAAQAAgBAAgBIAIgPQAHgFAJgMQABgDAHgGIAQgLQAGgDAFAAQABgFAJgBIADAAIAQgBQAHAAAEgDQADAAAAAFQADADAAAJIAAAEIgCAOQgBABgJAAQgRAAgNANQgDAFgGADQgDAIgEADIgHAVQgBABAAAJIgCAEQACADgDAFIAAAKQACADAAAKQAAAAAAABQAAAAAAABQABAAAAABQAAAAABABQgBADAEAGQABAFAJAOQAFAHAFABQAgALAFARIAAAJIgDAIIAAACQAAACgGAFgAnoBiQgGgEgEADIgEgBIgGABIgDgIQgBAAgBAAQAAAAAAgBQAAAAAAgBQAAAAAAgBIAAgDQgDgBgEgBQgFABgHADIgPAGQgEgDgCAAQgDAAgHADIgBACIAIAAIACABIgCADQgEgCgIAAIgFgNQAAgKgCgDQACgCAAgEIAAgFIAEgFQAbgLAFgZQgCAAgDgIIgFgBIgEgDIgOACQgDABgMAAIgEACQgFgDgDgXQAGgLAGAAIAHABQADgBADAAIAFABQAJABADgCQAQAAACADQALgBAEACQADgCAFAAQAQADAKgDIAJAAQADAEAAAPIACAEIgBAKIAAACQgCAEACALIgDALIABALQABAIgBAFIABAKQgBANABAHQgCAEgKAEgAE/gqQgGAAgEADQgDgBgKgHQgBgEgFgEQgHgDgIgKIgEgNIACgMQABgIAFgDIABAAIAIgBIAWAIIALAJQACAHAEABQAAAEAFACQAGACAAACQADADAAAFQAAAIACACIgDALQAAABgPABQgCgDgEAAgAEqgyQAHAIADgBIABgBIgEgCQAAgDgHgDgAFPgzIgBAIIABAAQAEgCAAgFIgBgEgAQpg+QgDgHgWgDQgBgDgGAAIgHgPIAAgCQAIgKAGAAIAEACQAEgBAeANQAJAGACAFIABAJQAAAMgNAAQgCgBgKgFgABHg+QgCgHgXgDQgBgDgGAAIgHgPIAAgCQAIgKAGAAIAEACQAEgBAfANQAIAGACAFIACAJQAAAMgOAAQgCgBgKgFgAophTQgQgLAAgEQADgNAGgGQABgGAMAAQAGAEAHABQAaANAAAHQAAAHgHAHIgDABIAAgBQAAAAAAgBQAAAAAAAAQABgBAAAAQAAgBABAAIAAgBQgFABAAAHQAAAHgLABQgFAAgQgLg");
	this.shape_1.setTransform(63.0125,-1.75);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-76.1,-14.1,248.5,24.7);


(lib.Path_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("Eg9ZAibMAAAhE1MB6zAAAMAAABE1g");
	this.shape.setTransform(393.025,220.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_2, new cjs.Rectangle(0,0,786.1,440.7), null);


(lib.BackButton = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FF0000").s().p("AgaBSIgCgBIgDgCIgGgCQgDgBgCgCQgHgCgEgEIgHgJIgGgIIAAAAIgBgCQAAAAAAAAQAAAAAAAAQAAgBAAAAQAAAAAAgBIgBAAQgFAAgBgCIAAgGQAAgDgCgCQgBgEgCgEQgCgFAAgFIAAgWIABgXIAAgCIABgEIAAgEIAAgDIAAgCQAAgBAAAAQAAgBAAgBQAAAAAAgBQAAAAABgBQAAAAAAgBQAAgBAAAAQAAgBAAAAQAAgBAAAAIAAgDIAAgEIABgCIgBgCIABgEIgBgEIABgCIAAgDIAAgCIABgCIADAAIAEAAIADAAIAIACIALAAIAIAAIADAAIADACIADACIABAFQAAAKgBAKIgBAUIgBAGIAAAGIAAAFIgBAGIAAAFIAAAJIgBAKIgBACIAAACIAAADIABAEQADACABAEIADAHQADABABACIADAEQACACACABIACADQAAABAAAAQAAAAAAABQAAAAAAABQAAAAAAABIABABIAAACIgBACIAAACIgBAFIgCAEIAAABIAAACIgBACIgDACIgEABgAg8A5IAEAEIAEAEIACACIADACIABgCIgCgCIgEgDIgBgCIgBgDQAAgBgBAAQAAAAAAAAQAAgBgBAAQAAAAgBAAgAALBMIgCgGIAAgFIABgGIABgGIAEgEIAEgCIADgCQABAAAAgBQAAAAAAAAQABAAAAgBQAAAAAAgBIAEgHIAEgKQACgEgBgDIABgIIACgIIAAgCIAAgDIAAgGIABgEIgBgEQAAAAAAgBQAAAAAAgBQAAAAAAgBQAAgBAAAAIgBgDIABgBIAAgBIAAgBIAAAAQAAAAgBAAQAAAAAAgBQgBAAAAAAQAAAAAAgBIAAgDIABgBIAAgBIgBgFQAAgBAAAAQAAgBAAgBQAAAAAAgBQAAAAAAgBIAAgLIgBgMIAAgBIAAgCIAAgCIABgDIAEgCIAHgCIAFAAIAEAAIADACIABAAIACAAIABACIAEgBQABAAAAAAQABAAAAAAQABAAAAgBQABAAAAAAIADgBIADAAIACAAIACABIACACIABADIAAAEQAAABAAAAQgBABAAAAQAAABAAAAQgBAAAAABIABABIABABIgBACIgBABQACADgBADIABAFIgBAFIABAGIgCACIABADIgBADIAAADIgCAEIAAgCIgCACIAAAEIABAEQgBAAAAABQgBAAAAABQAAAAAAAAQAAABAAAAIABAEIgBACIABABIAAABIABgBIABAAIABAAIABABIgBACIAAABIAAACIABADIgBADIABADIgBAFIgBAFIAAAEIgBAFIgCAFIAAABIAAACIgCABIgBADIgCACQAAADgCACIgDAEIgCAAIgCgBIgFAEIgFADIgCADIgCADIgDABIAAACIgDgBIgCgDIgEADIgDADIgCAAIgCACIgCABIgCABIgBAAQAAAAgBAAQAAAAAAAAQAAAAAAABQAAAAAAAAIgCADIgDABIgDAAQAAAAgBAAQAAAAgBgBQAAAAAAgBQgBAAAAgBgAAfBMIAEgBQAAAAABgBQAAAAABAAQAAAAABgBQAAAAAAAAIAFgCIAEgBIAAABIgFACIgEADQgCABgEAAg");
	this.shape.setTransform(186.325,18.625);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FF0000").s().p("AhKBQIgFgCIAAgEQAAAAAAAAQAAgBAAAAQAAgBAAAAQAAgBAAAAIAAgIIgBgIQABAAAAgBQAAgBAAAAQAAgBAAAAQAAgBAAAAIAAgGIAAgDIAAgEIAAgDQAAgBAAAAQAAAAAAgBQAAAAAAAAQAAgBAAAAQgBgEABgDIABgHIAAgBQAAgBAAAAQAAgBABAAQAAAAAAAAQAAgBABAAIADgCIACACIACACIACACIAFAFIADAEIAEACIAEAEIACADIADADIAAACIABAKIABAKIABACIgBAGIABAGIgBAEIgCAAIAAgCIAAgCIAAgEIgBgDIgDABIABACIABACIAAAAIgCACIgCACIACACIABAAIgBABIgEAAIgHAAQgBgBAAAAQgBAAAAgBQgBAAAAAAQgBgBAAAAIgCABIgBACIgGAAgAhNBCIABAEIAAAEQAAABAAAAQAAABABAAQAAAAAAABQABAAAAAAIADAAIgCAAIAAgCIABgCIABgDIAAAAIgCgCIgBgCIgBgBIgBgBgABHBLIgBgCIABgCIABgCIgBgBIgDABIAAACIgBACIgCACIgDAAIgEAAIgDAAIgDAAIgDACIgBgBIABgBIgEgCIgEgBIgCgCIAAgCIgEgDIgFgCIgBgBIgBABIgBAAQgBgEgDgCIgEgEIgDgBIAAgBIAAgBIgBgCIgBAAIgCgBQgBAAAAAAQAAAAAAgBQgBAAAAAAQAAAAAAAAIgBgBIAAgBIgCgDIgCgDQgBAAAAABIgDgDQAAAAAAAAQAAgBgBAAQAAAAAAgBQAAAAgBAAQAAAAAAgBQAAAAAAAAQAAgBgBAAQAAAAAAAAIgDgDIABgCIgCgCIgDgCIgCgDQgBAAAAAAQAAAAAAAAQgBgBAAAAQAAAAAAgBIAAAAIgBgCIgBgBIgCgDIgDgBIgBAAIgCACIgEgEQgCgBgBgCIABgDIABgCIgCAAIgCAAIgEgBQgBAAAAAAQAAAAAAAAQgBAAAAgBQAAAAAAAAIgBgDQAAAAgBgBQAAAAAAAAQAAAAgBAAQAAAAgBAAIgBgCQAAAAAAgBQgBAAAAAAQAAAAAAAAQgBAAAAAAIgDgDIgCgEIgEgBQAAAAAAAAQAAgBgBAAQAAgBAAAAQAAgBgBAAIgBgDIgCgCIABgBIABACIABgCIgBAAIgBAAIgBgBQAAAAAAAAQgBAAAAAAQAAAAgBAAQAAAAAAAAIgEgBIgCgCIgDgEIgFgEIgEgEQgBgEABgDQABgFgBgDIAAgHIABgFQAAgDADgCIADAAIAHAAQAEABAEAAIABAAIADAAIABAAIACgBIAEAAIAEAAQAEgBACADIAGADIAFAGIAFAGIADACQABAAAAABQAAAAAAABQABAAAAABQAAAAAAAAIAEAEQACABACADIAGAFIAFAFQABADADACIAGADIABAEQAAAAAAABQAAAAABABQAAAAAAAAQABAAAAABIADADIAEAEQAKALALAKIAVAXQADABABACIADAFIABAEIABAGIgBACIAAAAIgCgDIAAgFQAAAAAAAAQAAgBAAAAQgBgBAAAAQgBgBAAAAIgEgEIAAAAQAAAAAAgBQAAAAAAAAQAAAAgBgBQAAAAAAAAIgDgCIAAACIABAGQABACAEABIAAADIABADIAAACIgBADIABABIABABIACAAIgBgCIABgBIABgBIAAAIIABAGIAAADIAAACIAAADIgDABIAAgCgABJgKIAAgBIABgBQAAgBAAAAQgBAAAAAAQAAgBAAAAQgBAAAAAAIgEgBQgBAAAAAAQAAAAAAAAQAAAAAAgBQAAAAAAgBIgBgBIgEABIgCgBIgCgBIgBgEIgBgCIgFgEIgFgEIgBgCIgBgBQAAgBAAAAQAAAAABgBQAAAAAAAAQAAAAABAAIACgBIABAAIgDgDIgBgBIAAgBIAAgBIAAAAIAAgFIACgBIABgCIgBgBIgCAAIACgGIAAgFIgBgDIAAgCIAAgCIABgCIAEgCQABAAAAAAQABAAAAgBQABAAAAAAQAAgBAAgBIADAAIADgBIACACIAEgBIAEAAIADAAIAEABQABAAAAAAQABAAAAAAQABABAAAAQAAAAABAAIgCAFIgBAFIABADIAAACIgBACIAAACIABACIABABIgBACIgBACIABACIAAACIgBABIgCABIAAABIABADIAAADIABACIABABIgBABIAAAAIgBgBIgBABIgBABQABABAAAAQAAAAAAAAQABAAAAABQAAAAAAABIAAADIAAACIABAEIAAAGQgBAEgCACgAg6gZIABAAIABAAIgBACg");
	this.shape_1.setTransform(168.425,18.5);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FF0000").s().p("AA0BTQAAgBAAAAQAAgBgBAAQAAAAAAgBQgBAAAAAAIgBACIABAAIAAABIgBACIgCABIgGgDIgFgBQgBAAAAAAQAAABgBAAQAAAAgBAAQAAAAgBgBIgCAAIgGAAIgEABIgEgBIgEgCIAAgCIAAgBIgBAAQACgDgBgDQAAgCgCgCIAAgEIACgIQABgDACgEIAFgBIAGAAIABAAIACAAQAHAAAIACQAIABAGAAIAEABIACABQAAAAAAABQAAAAABABQAAAAAAABQAAAAAAABIAAAGIgBAGIAAAGIABADIAAABIgCABIgBADQgBABAAAAQAAAAAAABQgBAAAAAAQAAAAgBABIgBgBIgBgBIgBACIgBABQgBgBAAAAQgBAAAAAAQAAgBgBAAQAAAAAAgBgAg2BVQgHAAgCgCQgCgBgBgDIgBgIQACgGgBgHIgBgPIABgBIABAHIACAGIgCAEIAAAGIAAAEIAAACIABACIABgBIABgCQAAAAAAgBQAAAAAAAAQAAgBgBAAQAAAAAAAAIABgEIACgCIgBgCIACgFIABgEIAAgBIgBgBQAAgBAAAAQgBAAAAAAQAAgBAAAAQAAAAAAgBQAAAAgBAAQAAgBAAAAQAAAAAAAAQgBgBAAAAIAAgHIgBgKIABgFIAAgEIAAgEIgBgEQAAAAAAAAQAAgBAAAAQAAAAAAAAQgBgBAAAAIgBABIgBACIgBgBIAAgCIAAgBIAAgBIAAgDIABgCIACACIABgBIAAgDIgEgCIAAgEIAAgDIAAAAIAAgCIAAgDIACgCIgBgEIAAgJIAAgJIgBgGIABgDIgBgDIAAgBIABgBIAAgCIACgCIABgCIABgCIAAgBIgCgBIgBADIgBgCIABgDIgCgEIAAgEIAAgFIACgCIAEgCIADgCIACABIAEAAIAFAAIAJgBIAHAAIAEABIAFAAIADAAQACABACADIACAHIAAAGIAAACIgBAEIAAACIAAAKIgBAJIAAAEIABAGIAAADIABAEIAAADQAAADABACQACACADABQAFgDAEABIAKAAIAQAAIAGgBIAGAAQADABADgCIAEABIAFACQAEADAAADIAAAGIAAAIIgCAKQAAABAAAAQAAABgBAAQAAAAAAAAQgBAAAAAAIgLACIgDgBIgDABIgCgBIgDABIgCAAIgBAAIgBAAIgDAAIgFAAQgDgBgFAAIgJABIgBAAIgCgBIgGAAIgGgBQAAAAAAABQAAAAgBAAQAAAAgBAAQAAABgBAAQAAgBAAAAQgBAAAAABQAAAAgBAAQAAAAAAABQgDABgBADIgCAGIABADIABAEIgBAJIAAAJIABAJIAAAEIAAAGIAAACIgCACIgKACQgEABgGgBIgBAAIgCAAIgCABIgBgBIgCABIgCABIgCAAgAgmBPIgBABIABAAIACABIAFgBIAGgBQAAgBABAAQAAAAABgBQAAAAAAAAQAAgBAAAAIAAgDIgBgDIAAgDQgBAAAAAAQAAAAgBAAQAAABAAAAQAAAAAAABIAAADIgBAAQAAAAgBABQAAAAAAAAQAAAAgBABQAAAAAAAAIgCAEQAAAAAAAAQAAAAgBAAQAAAAgBAAQgBgBAAAAgAgyBEIgBADIACACQAAAAABAAQAAAAAAAAQAAAAAAAAQAAgBAAAAIABgCIAAgDIgCgCQAAABAAAAQAAAAgBAAQAAABAAAAQAAAAAAABgAAIATIADAAIAAAAIABAAIAEgBQAAAAAAAAQAAAAAAgBQAAAAgBAAQAAAAAAAAIgCAAIgCgBIgEgCIgEgBIgBAAIgBAAIgBABIAAABQAAAAAAABQAAAAAAABQAAAAABABQAAAAABAAIADABIACAAIABAAgAA1AMQAAABAAAAQAAABgBAAQAAABAAAAQAAAAgBABQgBAAAAAAQgBAAAAAAQgBABAAAAQAAABgBAAIADAAIABABIAEgBIABgBIAAgCIAAgCIgDgCgAgGgGIACAAIACAAIABAAIAAgBIgBgBIgBAAIgCAAIgBAAgAA2guIgBgBIgEAAIgDAAIgCAAIgCgBIgBABIgCABIgHgBIgIgCIgBAAIgDgBIgCgCIgBgEIgCgGIAAgBIAAgBIACgIIACgHIADgDIAHgBQAAAAABAAQABAAAAAAQABAAAAAAQABAAAAABIACAAIACAAIAEAAIAFgBIACAAIADgBIAHAAIAGABQAAAAABABQAAAAAAABQABAAAAABQAAABAAAAIAAAGIgBADIAAAEIAAABIABABIABACIABADIgBAFIgCAGIgDABIgFABIgCAAIgBAAgAA7g2IAAACIAAABIADAAIABgBIAAgBIAAgBIAAgCIgDAAIgBACgAATg8QAAADACACIAFACIAAgEIgDgDIgDgBg");
	this.shape_2.setTransform(151.85,17.7);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FF0000").s().p("AheBTIgCgBIgBgDIAAgGIABgFIAAgFIgBgGIABgJIABgKIAAgCIABgBIAAgBIABgBIACABIABAAQADADABADIAFAGIAEAGQADADAAADQABABAAAAQAAAAAAABQABAAAAABQAAAAAAABIAAAEIgBAAIABADIAAADIAAAEIgBADIgBACIgCAAIgEABIgFAAIgFACIgEgBgAgJBQIgBAAIgCAAIgDgCIgDgHIgFgEIgFgHIgEgFIgDgFIgEgHIgDgDQgCgEgDgEQgDgDgCgEQAAgBgBAAQAAAAAAgBQgBAAAAgBQAAAAAAgBIgDgEQAAAAgBgBQAAgBAAAAQAAgBgBAAQAAAAgBgBQgCgCAAgCIgDgFIgEgEQAAAAgBAAQAAAAAAAAQgBgBAAAAQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAgBAAAAQAAAAgBgBIgBgDQgBAAAAgBQgBAAAAAAQgBgBAAAAQAAgBgBAAIgBgEIgEgEIgDgGIgCgCIgCgHIgCgHIABgCIAAgBIACgHIAAgHIAAgHIAAgIQAAgEACgCQACgDAEAAIAHABQADACAEgBIAEADIAFADQAAABAAAAQABABAAAAQAAABAAABQAAAAAAABIAFAHIAFAIQAAAAAAABQAAABAAAAQAAAAABABQAAAAAAABQABAAAAABQAAAAABABQAAAAAAABQAAAAAAABIAFAHIADAIQADABABADQABADACACIABADIACADIADAEIACAFQAAAAABAAQAAABAAAAQABABAAAAQAAABAAAAIADAEIABAEIAEADIABADIAAAAIADABIACABIADgBIACgBIAAgCIACgCQAAAAABgBQAAAAAAAAQAAAAABgBQAAAAAAgBIABgCIABgBIAFgEQACgCAAgDIACgBIABgCIAFgDIAHgEQACACAAAEIABAGIgBACIAAABIgBACIABAIIAAAIIABADIAAAEIgBADIABABIAAABIAAAHIgBAHIgDAFIgCADIgBADQgBAAAAAAQgBABgBAAQAAAAAAABQgBAAAAABQgBAAAAABQAAAAgBABQAAAAAAABQAAABAAAAQAAAAgBAAQAAAAgBABQAAAAgBAAQAAAAAAABIgCACQgBAAAAABQgBAAAAAAQAAAAAAABQgBAAAAAAIgBADQAAAAgBAAQAAABgBAAQAAAAgBAAQgBAAgBAAIABABQAAABAAAAQAAAAgBABQAAAAAAAAQAAABgBAAIgCACIgBABIgCACIgDADIgDABIgBAAgAhWg3IAAAFIgBADIgBADIABACIABABIACgEIABgEIAAgFIAAgCIgBgDIgBAAIgBAEgAhFhKIACACIACACIACADIACABQAAAAAAAAQABAAAAABQAAAAAAAAQABABAAAAIABADIABAAIAAAAIABgBIgCgDIgBgDIgDgCIgBgDIgEgBgAA/BPIgEgHQgCgEgBgEIAAgFIAAgHIgBgFIAAgBQAAAAAAgBQAAgBAAAAQAAgBAAAAQAAgBABAAIAAgFIAAgFIgBgFIAAgEIAAgEIgBgIIABgBIABAAIABAAIAAgBIgBgBIgBgCIABgEIAAgEIAAgEIAAgDIAAgEIgBgGIAAgJIABgHIgBgKIAAgLIAAgCIgBgDIABgFIADgGQAAAAABgBQAAAAABAAQAAgBABAAQABAAAAAAIAEABIAEABIAIgBIAIgBQADABADAAIAGABIAAABIAAABIAAAEIgBAFIABADIAAADIAAAEIgBADIgBADIAAADIABACIABACIgBADIgBABIABACIAAADIgBACIgBAAIgBABIAAAAIAAACIAAACIADACIAAABIgBADQAAAAgBAAQAAABAAAAQAAAAABABQAAAAAAAAIgBAFIAAAEIABADIAAACIAAADIgCADIABAFQAAADABADIgBABIgBACIABABQAAAAAAAAQAAAAAAABQAAAAAAAAQAAAAAAAAIABABIAAABIAAAAIgBADIAAAEIgCABIAAABIABADIABACIAAABIgBABIAAADQAAABAAAAQAAABAAABQAAAAAAAAQAAABAAAAIAAAEIgBADIABACIABACIgBABIgBABIABAEIABADIAAAGQgBACgCACIgCAAIgBgBIgDABIgEAAIgDACIgHAAIgGABgABYBEIAAACIABACIABACIABgDIAAgDIAAAAgABNBIIAEAAIACgBIABgCIgBgBQAAAAAAgBQAAAAABAAQAAAAAAAAQAAAAABAAIgDgBIgBABIgBACIgEgBIgEAAIAAABIAAABIACACIACAAIABAAg");
	this.shape_3.setTransform(133.225,18.025);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FF0000").s().p("AgPBQIgCAAIgCAAIgBAAIgFgBIgFgBIgEgBIgEAAIgCgCIgDgBIgGgDIgHgEIgDgCIgEgDIAAgDIgEgCQgBAAAAAAQgBAAAAAAQgBgBAAAAQAAgBgBAAQAAAAAAAAQgBAAAAgBQAAAAAAAAQAAgBgBAAIgBgFQgBAAAAgBQAAAAgBAAQAAgBgBAAQAAAAAAAAIgCgEIAEgBIgBgCIgBAAIgCABIgBABIgCgCIgBgCIgBgCIAAgDIAAgCIAAAAIgBgBIgCgCIgBgDIAAgEQgBgCgBgFIgBgHIAAgGIABAAIAAgIIACgKQACgGACgCQAAgFADgFIAHgJIAIgIIADgDIACgDIAFgCIAEgDIAFgDIAEgBIAFgBIAHgBIABgCIAJgDIAIgBQAFABACABQACACABADIABAHIAAADIAAAFIAAACIgBACIgHADIgLAFIgLAGIgGACIgDADIgCAEIgDAEIgCADIAAABIAAACIgBABIgCAFIgBAFIAAACIABACIAAADIAAAEIABAFIAAADIABAGQAAADACACIADAFIAEAEIABADIABACIADADIAFAEIACABIADAAIAEgCIABACIAAADIAFAEIAFACIAAACIAAADIAAABIAAADIAAADIABAFIABADIgCAEIgCACIgDgBgAhLgpIgFAIIAAACIADgDIACgEIABgCIACgCIAAAAIACgBIABgCIgBAAIAAgBQgDACgCADgAAiBKIgBgCIgDACIgCAAIgDAAIgDgBIgCgBIgCgEIAAgCIAAgGIADgDQgBAAgBAAQgBAAAAAAQgBABAAAAQAAABgBAAIgBAGIAAAAIgBgBIAAgCIAAgDIABgCQACgCAEgCIAJgEIAGgEIAFgFIAEgGIADgFIADgEIACgEIAEgLIABgLIgBgHIgBgGIgCgDIAAgEIABAAIAAgBIAAgCIAAgBIgDgBIAAABIgBABIAAAAIgCgFIgBgCIgCgCIgBgDIgBAAQAAAAAAAAQgBAAAAgBQgBAAAAAAQAAgBAAgBIgCgEIgCABIgCAAQAAAAgBAAQAAAAgBAAQAAAAgBAAQgBgBAAAAIgFgCQAAgBgBAAQAAgBAAAAQgBAAAAAAQgBAAAAgBQgBAAgBAAQAAAAgBAAQAAgBAAAAQgBAAAAgBIgDgBIgCAAQAAgBgBAAQAAAAAAgBQgBAAAAgBQAAAAAAgBIAAgFIABgGIABgGIAEgEIAFgDIACAAIADAAIABAAIABABQAHAAAEADIALAHQAEAEAGADQACACACABQAAAAABAAQAAABABAAQAAAAABABQAAAAAAAAIACADIACACIACADIADADIABADIABADIADAEIABACIgBABIAAABIABAAQAAABAAAAQABAAAAAAQAAABAAAAQABABAAABIABAEIAAAEIAAACIABABIAAAHIABACIABABIAAABIgCACIAAADIABAAIABAAIAAAEIAAAEIAAADIgBADIAAAEIAAADQAAABAAAAQAAAAAAABQAAAAAAAAQgBABAAAAIgBgDIgCABIAAAEIABABQgBAAAAAAQAAABgBAAQAAABAAAAQAAABAAAAQgBABAAABQAAABAAAAQAAABgBAAQAAABgBAAIAAADQAAAAAAAAQAAAAAAABQgBAAAAAAQAAAAgBAAIAAACIAAADQAAAAAAAAQAAAAABABQAAAAAAAAQABAAAAAAIgBACIgBACQAAABgBAAQAAABgBAAQAAABAAAAQAAABAAABQgBAAAAABQAAAAgBABQAAAAgBAAQAAABgBAAIgCAEIgCgDIgCgBQgBAAAAABQgBAAAAAAQAAAAgBABQAAAAAAAAQAAABAAAAQgBABAAAAQAAAAgBAAQAAABgBAAIgCAEIgBACQgCABgEAAIgDADIgGADIgBgBIgBAAIgFABIgDABg");
	this.shape_4.setTransform(105.55,18.2);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FF0000").s().p("AgOBQIgBgBIAAgBIAEgBQABgBAAAAQABAAAAgBQABAAAAgBQAAAAAAgBIAAgBIgCgBIgCAEIgDABIgDACIgDABIgDAAIgBAAIgBAAIgBgEIAAgGIAAgCIABgDIAAgDQAAAAAAgBQAAAAAAgBQAAAAAAAAQAAgBAAAAIAAgIIgBgIIAAgFIABgDIAAgGQABgDgBgBQABgFgBgFQAAgFABgEIgBgGIABgEIAAgFIAAgEIACgEIgBgKQAAgEgCgFIgBgBIAAgDIgDABIgCgBQgDABgDABIgGAAQgDgBgCABIgCAAIgDAAIgDAAIgCgBIgDgBIAAgDIAAgDIAAgFIgBgEQAAgKACgFQABgEAFAAIANAAIAEgBIAEAAIADgBIAEgBIAGABIAFgCIAIACIAIAAIAKAAIALgCIAEAAIAIAAIAEAAIADABIADgBIAGACIAFgBQABAAAAAAQABAAAAABQABAAAAAAQABABAAABIAEAEIACAFIAAAQIgBAFQAAABAAAAQAAABgBAAQAAABAAAAQgBAAAAABIgBACIgBAAQAAAAAAAAQgBAAAAAAQAAAAAAgBQAAAAAAAAIAAgCIgBgBIgCgBIABAFIAAAEIgBADIgCABIgEABIgGgDQgDgBgBgDIgDgBIgCgDIAAAAIgBAAIgBAAIgBABIgDAAIgDAAQgCACgBAGIgBAMIgBAKIAAAHIgBAHIgEAKIgCAKIAAAKQgBABAAABQAAAAAAABQAAAAAAABQAAAAAAABIABAEIgBADIABADQABAAAAgBQABAAAAAAQABAAAAgBQAAAAAAgBIABgEIABACIABACIgBAFIgBAFIABAEIAAAIIgBAHIgDABIAAgBIAAgDIAAAAIAAgBIgCABIgCABQAAABAAAAQAAAAgBABQAAAAAAAAQgBAAgBABIgEAAIgDAAIgCAAIgCABQAAAAgBAAQAAABAAAAQAAAAgBAAQAAABgBAAIgDAAIgBAAIgCABgAgWAKIgBAEIABAEIgBAPIgBAPIACACIAAgDIAAgDIACAAIAAAAIABgBIAAgDIgBgCIAAgDQgCgEABgGIABgKQABgGgCgDIgBAEg");
	this.shape_5.setTransform(88.625,18.25);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FF0000").s().p("AA2BPIAAgBIgCgBQAAgBAAAAQgBAAAAAAQAAAAAAAAQgBAAAAAAIgBgCIgCAAIgCAAIgCAAIgBABIgBACIgDABIgCgBIgEgEIgEgFIACgBIAAACIACgBIABgCIgDgCQAAAAAAgBQAAAAgBAAQAAAAAAgBQAAAAAAgBIgEgCIgFgBIgBgDIgHgHIgHgHIgDgDIgCgFIgBgCIgBgCIAAAAIgBAAIgCAAIgCgBIACgDIABgDIgBgBIAAgBIgBABIgBAAIgBAAIAAgDIAAgEIAAgDQAAAAAAgBQAAAAAAgBQAAAAABAAQAAgBAAAAIAAgHIABgFIADgCIACgDQAAAAAAAAQAAgBAAAAQAAAAAAAAQAAAAABAAIAAAAQABAAAAAAQAAAAABAAQAAgBAAAAQAAgBAAAAIABgEIACACIABgDIAAgCIADgEIAHgIIADgFIAEgEIADgDQgBgCADgDIAFgHQACgDABgEQADgCABgCIADgEQABgCAHAAIAEAAIAGABIADAAIAEAAIAAgBIABgBIACABIADgBIAEABQAAAAAAABQABAAAAAAQAAAAABABQAAAAAAAAIAAADIAAACIACACIAAAEIAAADIABADIABACIgBADIgCAAIgBACIgBgBIAAgCIAAgCIgBgBIgBgDIgBgCIgDABIAAABIABACIABABIgCADIgBACIAAABIgCADIgEAEIgCADIgBACIgBABIAAAAQAAABAAAAQAAABAAAAQgBAAAAABQAAAAAAAAIgCADIgCABIgBABIAAAAIgBACIgBACIgCAFQAAAAAAABQgBAAAAABQAAAAgBABQAAAAgBAAIgDAFIgDAEIgCAEIgDAAIgBAEIgBAEIADADIADAEQADAAABADIACAEIAEAFIAEAHIAEAGIABACIABACQADACABACIAEAFIAAABIABACIACACQABAAAAAAQABABAAAAQAAAAABABQAAAAAAABIACADIAAABQAAAAAAAAQAAABAAAAQABAAAAABQAAAAABAAIABADIgBACQAAAAAAAAQAAAAgBABQAAAAAAAAQAAAAAAABQAAAAAAABQAAAAAAAAQgBAAAAABQAAAAAAAAIgEAAIgDAAIAAAAIgBgBIgCABIgCABIgCAAIgBgCIABgBIAAABIABABIABAAIAAgBIABgCIgCgBQAAAAAAABQgBAAAAAAQAAAAAAAAQgBgBAAAAIgCAAIgEAAIgBAAIAAABIAAABIACACIADAAIgDABIgBABIgCABIgBAAgABEg/IgBACIgBABIAAABIAAABIADABIADgCQAAgBABAAQAAAAAAAAQAAgBAAAAQAAgBAAAAIAAgBIgCAAIgCAAgAg8BNIgCAAIgBgBIACgCIgBgCIgBAAIgDAAIgCABIAAACQAAAAAAAAQAAABAAAAQAAAAAAAAQAAAAgBAAIgCABIgCgBIgCgCIgDABIgCgCIgCgCIAAgEIgBgFIAAgEIABgDIABgCIgBgCIAAgDIAAgDIABgDIAAgDIAAgEIAAgEIAAgBIAAgCIAAAAIAAgHIAAgJIABgGIAAgDQgCgDABgDIACgIIgBgBIAAgBIAAgGIgBgGIAAgDIABgDQAAgBAAAAQAAgBAAAAQAAgBAAgBQAAAAAAgBQABAAAAgBQAAgBAAAAQAAgBAAAAQAAgBgBgBIAAgEIAAgEIAAgBIAAgCIAAgDIABgEIAAgEIABgEIgBgBIAAgBIABgDIAAgDIADgBIADgBIACAAIADgBIADABIACAAIADAAIADABIACAAIADABQABAAAAAAQAAABAAAAQABAAAAAAQABAAABAAIAFgBIAEAAQAAAAABAAQAAAAABABQAAAAAAAAQAAABAAAAIABAEIgBAHIABAHQgCAFABAFIAAAKIgBAKIAAACIgBAEIAAAFIAAADIgBAEIABADIgBAEIAAAEIABAIIgBAFIABAEIAAACIgBADIABACIABACIAAAJIgBAOIgCANIgCAIQgCACgDAAIgHAAIgBABIgBAAIgEAAgAgvBCIAAAFIgFABIAAACIACAAQAFAAABgCQACgCgBgDIABgHIgDAAQgCADAAADgAhPAdIAAAHIAAALIAAAIIgBAFIABAEIACgFIACgFIAAgDIAAgDIAAgDIAAgDIACgCQAAgBABAAQAAAAAAAAQAAgBAAAAQAAAAAAgBIAAgDIAAgEIgCgBIAAABIgDABIAAgBIgBgCg");
	this.shape_6.setTransform(65.3,18.725);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FF0000").s().p("AAlBTIgEAAIgFAAIgCgCIgEgCIgBgDIgBgFIAAgEIABgEIACgEQADgDAGgCQAFgCADgDIAEgCIADgDIADgCQAAgBAAAAQAAAAABAAQAAgBAAAAQAAAAAAgBIADgFIAEgEIABgFQAAgBAAAAQABAAAAAAQABgBAAAAQABAAABAAIAEABIAEABIAAAAIACABIADABIABAEIAAADIgBAEIAAADIgCACIABABIAAAAQAAAEgCADIgCAFIgEAEIgDAFIgCABIgBACIAAAAQAAABAAAAQAAABgBAAQAAAAAAAAQgBABAAAAQgBAAAAAAQAAAAgBABQAAAAAAAAQAAAAgBABQAAAAAAABQgBAAAAAAQgBABAAAAQgBAAgBAAQAAAAAAAAQgBABAAAAQgBAAAAAAQgBABAAAAIgEACIgCADIgDABIgDAAgAApBQIgCABIADgBIABgBIgBABIgBAAgAgUBPIgEgCIgBAAIgBAAIgCAAIgDgBIgHgEIgJgIIgGgEIgBAAIgBABIgBABIAAAAIgCgDIgDgCIABgBIgCgBQAAAAAAgBQAAAAgBAAQAAAAAAgBQAAAAAAAAQgBAAAAgBQgBAAAAgBQAAAAAAgBQAAgBAAAAIgCgFIgBgBIABgCIgBgCIgBAAIgBgFIgDgDIAAgCIgBgEIAAgDIgBgLQgBgFABgFIAAgBIAAgCIAAgFIABgFIABgDIAAgCIgBgCIgDACIACgEIADgDIAAgBIgCAAIABgDIADAAIACgEIAEgGIABgEIgBgBIgBgBIABgDIACgDIACgEIADgDIACgBIADgCIADgDIAEgDIAAgCIABgCIAEgBIADgCIAIgEQAEgCAEgBIAEgBIAFAAIACgBIABAAIAFAAIABADIABACIAAACIAAACIAAABIAAAAIACAAIgBAFIgEAGIgCAEIgDADIgGACIgCACIgCACIgCACIgCACIgCACIgDAEIgEAGIgCAFIgCADIgBAEIgBALQgCAFAAAFIABALQAAAFACAFIABAGIADAGQABAAAAAAQABABAAAAQAAABABAAQAAABAAAAIACAEQAAABABAAQAAABAAAAQABAAAAAAQABABAAAAQABAAAAAAQABAAAAABQAAAAABAAQAAABAAAAIAFAFIAFAEQACADAAAEIABAIQAAAAgBABQAAAAAAAAQAAAAAAABQAAAAAAABIAAACIgCAEQgBAAAAAAQgBABAAAAQgBAAAAAAQgBAAgBAAIgCgBgAgSBGIgCABIAAAGIACAAQABAAAAAAQABAAAAgBQAAAAAAAAQABAAAAgBIABgCIgCgDIgBAAIAAAAIgBAAIAAAAgAhOgOIABAAIAAABgABCghIgCgBIgDAAIgDAAIgEABIgEgCIgFgDIgBgEIgDgDQgEgBgCgDQgBgDgDgCIgDgFIAAgEIABgHIAAgGQACgDADgBIAAgBIACAAIADAAQAEAAAEACIAIADIAEAEIAEADIABADQABABAAAAQAAABAAAAQABAAAAABQAAAAABAAIACADIADACQABAAAAAAQABABAAAAQAAABABAAQAAABAAAAIACADIAAADIABAEIABADIgCAFIAAADIgDABIgIAAgAAugoIAEADQAAABAAAAQABAAAAAAQABABABAAQAAAAABAAIAAAAIAAgBIgBgBIgBgBIgCgCIgEgCgABJgpIAAADIgBADIABAAIACgCIABgDIAAgCIgBgCgAhFgmQABAAAAgBQAAAAABAAQAAAAAAgBQAAAAAAAAQAAgBAAAAQAAAAAAAAQAAgBAAAAQABAAAAAAIAAABIgBACIAAABIgBABg");
	this.shape_7.setTransform(47.4,17.825);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FF0000").s().p("ABaBSIgCgCIgCACIgBABIgCgBIgCAAIgDAAIgCABIgDgBIgDAAIgCgCIgDABQgBAAAAAAQAAAAgBAAQAAAAAAABQAAAAgBAAIgBABIgDgCIgEgCIABgBIgBgCIgBgCIAAgCQAAAAAAAAQAAgBAAAAQAAAAAAAAQgBgBAAAAIgCgCQAAAAAAgBQAAAAAAAAQAAAAAAgBQAAAAAAgBIgCgCIgDgGIgBgDIgCgDIAAgEQgDgBAAgDIgDgFIABgBIABgCIgCgBIgCAAIgBgDQAAAAAAgBQAAAAAAAAQAAgBABAAQAAAAAAgBIAAgBIgBAAQAAAAgBgBQAAAAAAAAQgBAAAAAAQAAgBAAAAIgCgEQAAAAAAAAQgBgBAAAAQAAAAgBgBQAAAAgBAAIgBgCQAAgBAAAAQAAAAAAgBQAAAAAAAAQAAgBAAAAQAAAAgBgBQAAAAAAAAQAAgBAAAAQAAAAAAgBIgBgDIgDgEIgCgEIgBgBIgBgDIABgDIgCgDQAAAAgBgBQAAAAgBgBQAAAAAAgBQAAAAAAgBQAAgBAAAAQAAgBAAAAQgBgBAAAAQAAgBAAAAIgBgCIgCgCIgBgCIABgCIgBgBIgBgBIgBgCIAAgDIgBgCIAAAAIgDgFIgBgFIgBgCIgBgEQAAAAAAgBQAAAAAAAAQAAgBAAAAQgBAAAAAAIgCgDIAAgFIgBgEQgBgBAAAAQAAAAgBgBQAAAAAAgBQAAAAAAgBQAAAAAAAAQAAgBAAAAQAAgBgBAAQAAAAgBAAQABgDADgDQADgCADgBIAHgCIAEAAIADABQADgBACABIAGAAIAGAAIAGABIADABIABACIABACIACAFQABACACADIACAFIADAGIAAABIADAEIACAHIADAGIAFAKIACAHIACAEIAGAKIADAIIACAFIAGALIAGAPQACAIAAAEIAAAAIABABIABAEIACADQAAAAAAABQAAAAgBAAQAAABAAAAQgBAAAAAAIgCADIABAEIACAHIABAEIAAAEIgBACIgDACQAAAAgBAAQAAAAgBABQAAAAgBAAQAAAAAAAAIgCgBgAgDhJIAAABIAAACIABACIABAAIABgCIgBgCQAAAAAAgBQAAAAgBAAQAAAAAAAAQgBAAAAAAIAAAAgAg2BSQAAABgBAAQAAAAAAAAQgBAAAAgBQAAAAgBAAIgBAAIgBABIgBAAIgDgBIgCAAIgHgBIgGgBIgDAAIgCABIgCAAIgFAAIgDABIgDgBIgDgBIAAgCIABgFIACgDIADgFIACgFIADgDIACgDIAEgBQAAgBAAgBQAAgBAAAAQAAgBABAAQAAgBAAAAIACgCIABgCIABgCIAAgCIABgDIADgEIACgDIACgFIADgFIABgDIABgEQAEgEACgFIAEgJQAAAAABAAQAAAAAAAAQAAgBAAAAQAAAAAAgBIACgBIACgFIABgDQAEgDADgGIAFgKIADgEIACgFQAAgBAAAAQAAgBAAAAQABAAAAAAQAAAAAAAAIADABIACACQAAACACADIACAEIACAFQAAAAABAAQAAABAAAAQAAABAAAAQAAABAAABIAEAHIADAIQABAAAAAAQABAAAAABQAAAAAAABQAAAAAAABIACADIAAABIABACIACACIACAGIACAFQAAAFACAEIADAIIABAFQABADABACIABADIADACIABAEIABAFIAAACIgBACIgCAAIgDAAIgIAAIgJAAIgHgCQAAAAAAAAQgBAAAAAAQAAAAAAAAQAAgBAAAAIgBgCIgBABIAAAAIAAABIgBABQAAAAAAAAQgBAAAAABQAAAAABAAQAAAAAAAAIgEAAIgFABIgEADIgCABIgBACIgCADIgCADIAAADIgBACIgDABIgBADQAAAAAAABQAAAAAAAAQAAAAAAABQgBAAAAAAIgCAAIgBACIgCABIgDgBgAhUA7IgEAFIgCAFQAAAAgBAAQAAABAAAAQAAABAAAAQgBABAAAAIgBACIgBACIABADIAEAAIAAgBIgBgCIgBgCQABgDACgEIAEgGQADgEAAgDIAAAAIgDAFgAhLA/IgBACIAAADIABAAIACAAIABgCIAAgBIAAgCIAAgCIgDACgAgYA3IAAgBIgBAAIgBAAIABAAIABABIAAAAIAAAAgAgFAyIgDACQAAAAAAABQABAAAAAAQAAAAAAAAQABABAAAAIADAAIADgBIAAgBIAAAAIgDgDIgCABgAAEA0IADACIABgBIgBgDIgCgCg");
	this.shape_8.setTransform(28.25,17.95);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#FF0000").s().p("AARBRIAAgCQAAAAgBgBQAAAAAAAAQAAAAAAAAQgBgBAAAAIgCgBIgDAAIgCADIgDgDIAAgDQAAAAgBgBQAAAAAAAAQAAgBAAAAQgBAAAAAAIAAABIgBABIAAADIAAAAIgBgHIAAgIIgBgCIAAgCIAAgBQABAAAAgBQABAAAAAAQABAAAAgBQAAAAAAAAIAEgDIAFgFQADgCACgEQACAAABgDIADgGIABgEIgFgDQAAAAAAAAQAAgBAAAAQAAgBAAgBQAAgBAAgBIgBgBIgBgBIgBgEIAAgEIgEgBIgEAAIgBgDIgCAAIgCABIgBAAIgCgBIAAgCIABgCIgBgBIAAAAIAAAAIgBACIgBgDIACgCIACAAIAEgBIACgCIACgCIACgEIABAAIABgDIAAgCIAAgBIgCgDIAAAAIABgCIACgBIAAgCIAAgBIAAgEIAAgDIgCgCIABgFIAAgFIgCgDIgBgCQAAgBAAAAQAAAAAAgBQgBAAAAAAQAAAAgBAAIgBAAIAAADIABADIAAACIgCgEIgBgDIgDgCIgBgDIgBgBIgBgCIgCgEQgCgDAAgDQAAgFAEgDIAHgBIACAAIACABIABAAIADABIACAAIAIAAIAIABIACgBIADgBIAGAAIAGABIAEABQABAAAAAAQAAAAABgBQAAAAAAAAQABAAAAAAIADAAIABAAIABAAQADAAACAFIAFAJQACAFAFABIABAFIABAGIABAEIgBAGIgBAFIAAAFIgBADIgCAEIABABIABACIgDACIgDACIAAACIAAACIAAABIgBAAIgBADQAAABAAAAQAAABAAAAQgBABAAAAQAAAAAAABIAAAAQAAAAAAABQAAAAAAABQAAAAAAABQABABAAAAIADAFQABAAAAABQAAAAABAAQAAABAAAAQAAABAAAAIACADIACADIACAEQACAEAAAEIAAACIgBADIACACIABACIAAAEIgBACIgCgBIAAAEIgBAFIgBAAIACABIABgBIgBADQAAABAAABQgBAAAAAAQAAABgBAAQAAAAgBAAIAAABIABABIAAABIAAABIAAAAIgDACIAAACIgCACIAAgDIgCgCIgCABIgCAAIgBABIAAACQAAAAAAABQAAAAAAAAQgBAAAAABQAAAAAAAAIgEABQAAAAgBAAQAAAAgBAAQAAABAAAAQAAAAAAABQgBAAgBAAQAAAAgBABQAAAAgBAAQAAAAgBAAIgFAAIgDACIgCAAIgBAAIgCAAQgBAAgBAAQAAABgBAAQAAAAgBAAQAAAAgBgBQAAAAgBAAQAAAAgBAAQAAABgBAAQgBAAAAAAIgDABQgBAAAAAAQgBAAAAAAQgBAAAAAAQgBgBAAAAIgBACIgDAAIgDABIgCgBIgBACgAhBBOIgBgBIgFAAIgDgBIgEAAQgBAAAAAAQgBAAgBAAQAAAAAAgBQgBAAAAgBIgCgFIABgIIgBgIIAAgGIABgEIAAgJIAAgJIAAgDIgBgCQABgFAAgGIgBgKIgBgJIABgJIgBgSIAAgTIAAgIIAAgJIADgCIABAAIADgBQAAAAABAAQAAgBABAAQAAAAABAAQAAAAABAAIACAAIABABIAEgBQAAAAABAAQAAAAABAAQAAAAABABQAAAAABAAIADgBIAHAAIAEAAIACABIACABIABgBIACgBQABAAAAABQABAAAAAAQABAAAAAAQAAAAABgBIADABIADgBQABAAAAAAQABAAAAAAQABABAAAAQABAAAAAAIACACIABADQABADgCAHIABAEIAAAFIAAALQABAHgBAEIAAAIIAAAOIABAJIgBAEIABAGIgBARIgBARIAAABIAAACIAAAFIAAAEIAAAFIAAAFIAAADQgBAAAAAAQAAAAAAAAQAAABABAAQAAAAAAAAIgBAEIgHABIgFgBIgDABIgCgBIgBABIgCAAIgFAAIgDAAQgBAAgBAAQgBAAAAAAQgBAAAAABQgBAAAAAAIgEACIgBgBgAhRAkIAAAQIAAAPIABAEQAAAAAAABQAAAAAAABQABAAAAABQAAAAAAAAIACAAQAAAAABAAQAAAAAAAAQAAAAABgBQAAAAAAAAIABgEIABgDIAAgCIABgCIgBgBIAAAAQgDgCABgDIAAgGIAAgBIAAgCIAAgCIgDgCIgBgDIgBgCIAAgCIgBgBgAgdBIIABAAIAAgBg");
	this.shape_9.setTransform(8.15,18.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(2));

	// BG
	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#000000").s().p("Ar8B4IAAjvIX5AAIAADvg");
	this.shape_10.setTransform(77.175,21.4);

	this.timeline.addTween(cjs.Tween.get(this.shape_10).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3.6,-1.2,201.1,35.900000000000006);


(lib.Arrow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#404040").s().p("AhpBNQgIAAgFgCIgCgCQgCgEADgGIAIgLIAFgGIACgEQAHgNACgIQACgCABgHQAAAAAAAAQABgBAAAAQAAAAABAAQAAAAABAAIABgDQAFgFAAgDQAGAAACgDIAAgCQADgEAGAEQAEgEACABQAHAEAGgDIAGACQAFAAACgCQAJgFADgHIADgGQABADAFgCIABAAIACgBQABgCgFgDQADgMAPgcIAGgGQADgBADACQAGADAFAJQAAAFAEADQACAGAKAJQAHAFALAQQAMAOABAEIAFAGIABABQAAAEAGAGIAPAYQAGACADAKQAFAKAGAEQACAGgCADQgQgCgHACQgfgBgGACIgNAAQgGgBgCACQgZgDgMACQgCgCgIgBQgNACgFgCQgOAFgHgEQgBgBgBAAQAAAAgBgBQAAAAgBAAQAAAAgBAAQgGADgLgEQgCAFgGAAQgHAAgCABQgGgBgOABg");
	this.shape.setTransform(-2.3434,-0.3028);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-14.5,-8,24.4,15.5);


(lib.DimMC = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("EhQaAumMAAAhdLMCg1AAAMAAABdLg");
	this.shape.setTransform(1749.125,153.625);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DimMC, new cjs.Rectangle(1234.5,-144.6,1029.3000000000002,596.5), null);


(lib.YesButton = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Text
	this.instance = new lib.YesText("single",0);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgXAYIAAgvIAvAAIAAAvg");
	this.shape.setTransform(-20.85,-0.15);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#333333").s().p("AgXAYIAAgvIAvAAIAAAvg");
	this.shape_1.setTransform(-20.1,0.3);

	this.instance_1 = new lib.Square("single",0);
	this.instance_1.setTransform(0,0,6.9997,5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance}]}).to({state:[{t:this.instance},{t:this.shape_1}]},1).to({state:[{t:this.instance_1}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-35,-25,70,50);


(lib.Symbol53 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Tween3("synched",0);
	this.instance.setTransform(0.45,0.15);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({x:1.25},14).to({x:1.2,alpha:0.3984},8).to({x:1.15,alpha:1},11).to({x:0.45},9).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-7.7,-2,17.2,4.3);


(lib.Symbol52 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AghAfIBDgBIABBFIhDABgAgihhIBDgBIABBEIhEAAg");
	this.shape.setTransform(-34.225,0.55);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#404040").s().p("AjXBdIgHgEIgBgJIABgPQABgJAFgBIALACQACgCAIAAIACAAQABAAAAAAQABAAAAAAQAAAAAAABQAAAAAAAAIAKABQACAJACANIAAAJQgEAHgIgCIgFACQgFgBgKADQgDAAgDgEgAgVBaQgFgBgBgDIgCgIIACgPQAAgJAFgBIALACQADgCAHAAIACAAIACABIAGAAIADABQADAKAAAMQgBAEACAFQgDAHgJgCIgEABQgFAAgJADQgEAAgDgFgACtBYIgIgEIAAgIIABgPQABgKAFAAQAIgBACACQAHAAADgBIADgBIADABIAFABIAEABQADAMAAAJIAAAKQgDAHgJgCIgEABQgGAAgIADQgEAAgDgFgAjGAbIgCAAQgFgBgDgCIgBAAQgEAAAAgIIABgLQACgFADAAIABgEQAAAAAAgBQAAAAAAAAQAAgBAAAAQABAAAAAAQAJgGAKgOIAGgBQASgRABgCQgBgFgFgKIgCgDIAAAAQgFAAAAAEIgIAAIgGgGIgBgMQABgCgBgGQgBgDAJgDIAaABQADgBAFABQAaACAKAKQAJAEAAAUQAAAHgFANQgHAKgFAEQgHAFgCADQgVAJgCADQgEAAgEAEIgFAGQgFACgBAJIgEAGQAAAAgBABQAAAAAAABQAAAAgBAAQAAAAgBAAgAgEAZIgBgBQgFAAgEgDIgBAAQgDAAAAgHIABgLQABgEADgBQABgBAAAAQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAgBABAAQAAAAAAAAQAAgBABAAQAAAAAAAAQAKgHAJgNIAFgCQATgQAAgCQAAgGgFgJIgDgDQgEAAAAAEQgDgBgFABIgHgHIgBgMIAAgIQgBgCAJgDIAbABQACgCAGACQAZACALAKQAJAEAAATQAAAIgHANQgGAKgFAEQgHAEgBAEQgXAIgBADQgEAAgDAEIgGAHQgFACgCAIIgDAHQAAAAAAABQAAAAgBABQAAAAAAAAQgBAAAAAAgAC9AXIgBgBIgIgDIgBAAQgEAAAAgIIABgKQABgFAEAAIAAgEQAAgBAAAAQAAAAAAgBQABAAAAAAQAAAAAAgBQAKgGAKgNIAGgCQATgQAAgDQAAgFgGgJIgDgDQgEAAAAAEIgHgBIgHgGIgBgMIAAgIQgBgCAJgDIAaABQADgCAFABQAaADAJAKQAKAEAAATQAAAJgGAMQgGAKgFADQgHAFgBAEQgXAIgCADQgDAAgEAFIgFAGQgFACgCAIIgEAGQAAABAAAAQAAABAAAAQAAAAgBABQAAAAgBAAgAkBgqQgCgBgGgEQgBgFgJgEQgFAAgDgIQAAAAgBgBQAAAAgBgBQAAAAAAgBQAAgBAAAAIACgFIABAAIAPgIIAEABQAAgBABAAQAAgBAAAAQABAAAAgBQABAAABAAIACAAQAEgCACAAIADgDIALgCQAOAAACAZIgBAFQgDgBgMAKQAAABgBAAQAAABgBAAQAAAAgBABQAAAAAAAAIgCgBQgCAAgEADQgCAAgCAGQgBAAgBAAQAAgBgBAAQAAAAgBAAQAAgBgBAAgAg+gtQgEAAgEgFIgKgIQgFgBgDgHQgBgBAAAAQgBAAAAgBQAAAAAAgBQAAgBAAgBIABgEIACAAIANgJIAFACQACgDACgBIACABQAEgDACAAIAEgCIALgCQAFAAAGAKQAFAJAAAGIgBAEQgEAAgLAJQgBABAAABQgBAAAAAAQgBABAAAAQgBAAAAAAIgCgBQgCABgDACQgCABgDAGQAAAAgBAAQAAgBgBAAQAAAAgBgBQAAAAgBgBgACDgvQgCAAgHgFQAAgEgJgEQgFgBgDgHIgDgFIACgFIACABIAOgJIAFABIADgDIACABQAFgDACAAIADgDIAMgBQAFAAAGAKQAEAJAAAGIgBAEQgEAAgKAJQgDADgCAAIgBgBQgDAAgDADQgCAAgCAGQgBAAAAAAQgBAAgBAAQAAgBgBAAQAAAAgBgBg");
	this.shape_1.setTransform(9.2,-0.725);

	this.instance = new lib.Symbol53();
	this.instance.setTransform(-60.95,-423.75,1.4413,1.4413);

	this.instance_1 = new lib.Symbol53();
	this.instance_1.setTransform(-61.3,89.05,1.5323,1.5323);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f().s("#FF0000").ss(1,1,1).p("AH+CTIv7AAIAAklIP7AAg");
	this.shape_2.setTransform(6.525,-2.4);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#333333").s().p("An9CTIAAklIP7AAIAAElg");
	this.shape_3.setTransform(6.525,-2.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).to({state:[{t:this.shape_1},{t:this.shape},{t:this.instance_1},{t:this.instance}]},1).to({state:[{t:this.shape_3},{t:this.shape_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-73.1,-426.6,131.7,519.2);


(lib.QuitButton = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Text
	this.instance = new lib.QuitText("single",0);

	this.instance_1 = new lib.Square("single",0);
	this.instance_1.setTransform(7,0,8,3.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},1).to({state:[{t:this.instance_1}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-33,-17.5,80,35);


(lib.PlayButton = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Text
	this.instance = new lib.PlayText("single",0);

	this.instance_1 = new lib.Symbol53();
	this.instance_1.setTransform(77.25,-421.55,1.4604,1.4604);

	this.instance_2 = new lib.Symbol53();
	this.instance_2.setTransform(76.7,93,1.4604,1.4604);

	this.instance_3 = new lib.Square("single",0);
	this.instance_3.setTransform(23.75,0,11.9999,3.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance},{t:this.instance_2},{t:this.instance_1}]},1).to({state:[{t:this.instance_3}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-41.9,-424.4,131.8,520.8);


(lib.PauseButton = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Text
	this.instance = new lib.PauseText("single",0);

	this.instance_1 = new lib.Square("single",0);
	this.instance_1.setTransform(-5,0,8,3.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},1).to({state:[{t:this.instance_1}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-45,-17.5,90.8,35);


(lib.PageNumber = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// number_idn
	this.numberTxt = new cjs.Text("10", "40px 'flyerfont'", "#FFFFFF");
	this.numberTxt.name = "numberTxt";
	this.numberTxt.textAlign = "center";
	this.numberTxt.lineHeight = 47;
	this.numberTxt.lineWidth = 44;
	this.numberTxt.parent = this;
	this.numberTxt.setTransform(0,-26.85);

	this.timeline.addTween(cjs.Tween.get(this.numberTxt).wait(1));

	// back
	this.back = new lib.PageNumberBack();
	this.back.setTransform(0.05,0.05,1,1,0,0,0,31.8,31.8);

	this.timeline.addTween(cjs.Tween.get(this.back).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PageNumber, new cjs.Rectangle(-31.7,-31.7,63.5,98.3), null);


(lib.OK2Button = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Text
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FF0000").s().p("AgQBEIgBAAIgBgBIgDAAQgCAAgCgDIgBgFIAAgCIAAgDIABgEIAAgDIAAgEIAAgFIAAgBIAAgBIABgDIAAgDIAAgCIAAgCIABgEIAAgEIgCgFIgCgGIgDgDIgBgCIAAgCIgCgBIgBgBIAAgDIAAAAIgCgBIAAgDIgBgBIAAAAIgEgDIgBgDIgBgDIAAAAIgBgDIgCgDIgDgDIgBgDQgDgDAAgDQgBgEgEgCIgBgDIgBgDIgCgCIgBgCIgCgCIgCgCIgBgCIgBgCIACgDIADgCIABAAIABAAIADAAIAEAAIACABIACAAIACgBIAFAAIADAAIABAAIABAAIADAAIACABIAAAAIABAAIABAAIAAACQAEABADAEIADAHQAEADABADIACAFIADAFIAAAAIACAEIADAFIADAEIAAACIABABIAEAJIAFAIIABACIACADIABADQABAAAAAAQAAABAAAAQAAABAAAAQAAABAAAAIAAAIIABALIgBAHIAAABIAAABIAAACIAAABIAAAPIABABIgBADIABAEIAAABIgBABIAAABIgBAAIgCgBIgDAAIgBAAIgBAAIgCAAIgBABIAAgBIgCgBIgBAAIgBAAIgBACIgBAAIgCAAIgCgBIgBABIgBABIgCgBIgBACIgBAAgAAbgRIgBgCIgBgCIgCgCQAAgBAAAAQAAAAAAgBQgBAAAAAAQAAAAgBAAIgBgDIAAgCIgBgCQAAAAgBgBQAAAAAAgBQAAAAAAgBQgBAAAAAAIgBgDIAAgCIAAgCIADgEIADgDIAEgDIACgDIACgBIABgCIAFgDQACgCACgBIAFAAIAEAAIAIACIAGABQADAAAEAEIgDAEIgEAGIgEAFQAAAAAAABQAAAAgBAAQAAABgBAAQAAAAgBABIgDADIgBABIgCACIgDACIgBACQgCAAgDADIgEAFQgCACgEABIgBABIgBABIgCgBgAA9g3IABACIgBADIgBADIABAAIABgCIACgCIAAgCIABgBIAAgBIgBgBIgCAAIAAAAIgBABg");
	this.shape.setTransform(38.1,3.9417);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FF0000").s().p("ABIBBIgBgBIgCACIgBAAIgBAAIgCAAIgCAAIgDAAIgCAAIgCAAIgBgCIgDABQAAAAgBAAQAAAAAAAAQAAAAAAAAQgBABAAAAIgBAAIgCgBIgDgCIAAAAIAAgCIgCgBIABgCIgBgCIgCgBIAAgCIgBgDIgDgEIgBgDIgBgCIgBgDQAAAAAAgBQgBAAAAAAQAAgBgBAAQAAgBAAAAIgCgFIABgBIAAgBIgBgBIgBAAIgBgCIABgCIAAgCIgBAAIgDgBIgBgDQAAAAAAgBQAAAAAAAAQgBAAAAAAQAAAAgBAAIgBgDIAAgCIgBgCIgBgCIgBgEQgBAAAAgBQAAAAgBgBQAAAAAAgBQAAAAAAAAIgBgBIgBgCIABgCIgCgDQAAAAgBAAQAAgBAAAAQAAgBAAAAQAAAAAAgBIgBgDIgBgCIgBgBIgBgBIABgDIgBgBIgCAAIAAgCIAAgCIgBgBIgBgBIgBgEIgBgEQAAAAgBgBQAAAAAAAAQAAAAAAAAQAAgBAAAAIAAgCQAAgBAAAAQAAAAAAgBQgBAAAAAAQAAAAgBAAIgBgDIAAgEIgBgDIgBgCQAAgBAAAAQAAgBAAAAQgBAAAAgBQAAAAAAAAQAAgCACgCIAFgDIAFgBIAEAAIACAAQABAAAAAAQABAAAAgBQABAAAAAAQABAAABABQAAAAABAAQAAAAABAAQAAAAABAAQAAAAABAAIAFABIAEAAIADABQAAAAAAABQAAAAAAAAQAAAAABAAQAAAAAAABIABACIACADIACAEIABAFIADAEIAAABIACADIACAGIACAFIAEAHIACAGIABADIAEAIIAEAHIABADIAFAJIAEAMIACAKIAAAAIABABIABADIACACIgCACIgCADIABADIACAFIABAEIAAACIgBACIgDACIgCABIgCgCgAgDg6IAAABIABACIACABIAAAAIAAgCIAAgBIgCgBIgBAAgAgyBCIgCAAIgFgBIgFgBIgDAAIgBABIgCAAIgDAAIgEAAIgCAAIgBgBIAAgCIAAgDIABgDIADgEIACgEIACgCIACgDIACgBIABgEIACgBIABgCIABgBIAAgBIABgDIACgDIABgDIACgEIADgEIABgCIAAgDQADgDABgFIAEgHQAAAAABAAQAAAAAAAAQAAAAAAAAQAAgBAAAAIABgCIACgCIABgDIAFgHIAEgIIADgEIABgEIACgCIACABIABACIACAEIACAEIABADQAAAAABAAQAAAAAAABQAAAAAAABQAAAAAAABIADAGIADAGQAAAAABAAQAAABAAAAQAAAAAAABQABAAAAABIABACIAAABIAAACIABABIADAEIABAFIACAHIACAGIABAFIACAEIABACIABABIACAEIAAAEIAAABIgBACIgBAAIgDAAIgFAAIgIAAIgGgBQAAgBAAAAQAAAAAAAAQAAAAAAAAQAAgBAAAAIgBgBIgBAAIAAAAIAAABIAAABQgBAAAAAAQAAAAAAABQAAAAAAAAQAAAAABAAIgEAAIgEABIgDACIgBABIgCABIgBADIgCACIAAADIgBACIgBABIgBACIgBABIgCAAIgBABIgCABIgCAAIgCAAIgCAAIAAAAIgBABIgCgBgAhEAwIgCAEIgBADQgBAAAAAAQAAABgBAAQAAABAAAAQAAABAAAAIgBABIgBACIAAACIAFAAIAAgBIgBgBIgBgBQAAgDACgDIADgFIADgGIgBAAIgDAFgAg7AyIgCADIABACIAAAAIACgBIABgBIgBAAIAAgCIABgCIgCABgAgTAsIgBAAIABAAgAgEAoIgCACQAAAAAAAAQAAABAAAAQABAAAAAAQAAAAAAAAIADABIACgCIAAAAIAAgBIgCgBIgCAAgAgUAsIAAAAIAAgBgAADAqIADABIABgBIgBgCQAAAAAAgBQAAAAAAAAQgBAAAAAAQAAAAgBAAg");
	this.shape_1.setTransform(22.25,3.6917);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FF0000").s().p("AgrBAIgBgBIgBgCIgDgBIgBgDIAAgCIgBgCIAAgDIAAgEIgBgDIAAgEIgBgCIAAgCIAAgMIAAgMQgBgCAAgDQABgDgBgDIABgFIAAgFIAAgEIAAgFIAAgHIAAgDQgBgFAAgFIAAgLIAAgBIABgCIgBgBIAAgDIAAgBIAAgBIACgDIACgBIAEABIABgBIABAAIAEABIABgBIADABIABgBIABAAIABABIACAAIACAAIADAAIADAAIAEABIACAAIACgBIAAABIABAAIAAAKIABAKIAAAJIgBAJIAAAHIAAAJIAAAHIAAAAIAAABIAAAHIAAAGIAAANIAAAMIAAADIgBADIAAADIAAAFIAAACIgBAEIgBADIgGAAIgFABIgCgBIgCAAQgBAAAAAAQAAAAgBAAQAAAAAAAAQAAAAAAAAIgCAAIgCABIgCAAIgCABIgCAAgAgbA6IgBABIAAABIAGAAIAFgBIAAgEIgDACQAAAAgBABQAAAAAAAAQgBAAAAAAQgBABAAAAIgBgBIgBgBIgCABgAgSg4IAAACIABAGIABAGIAAAGIAAABIgBACIAAABIABAIIAAAIIABAAIAAgBIAAgBIAAgDIAAgDIAAgCIAAgCIAAAAIAAgBIAAgJIAAgKIAAgDIAAgEIgBgCIgBgBIgBACgAAuA+IgCgBIgCAAIgFABIgHAAIgGAAQgBAAAAAAQgBAAAAAAQgBAAgBAAQAAAAgBAAIgEgBIgBgDQAAAAAAAAQAAAAgBAAQAAABAAAAQAAAAAAABIgBACIgEgBIAAgEIAAgCIAAgCIgBgFIAAgEIAAgBIgBgBIACgEIADgBIAHgBIAHAAIAEgBIABAAIAEABIAEAAIABAAIABAAIAJAAIABAAIACABIAAAIIACAHIAAAFIgCAFIgCAAIgCABgAAvAqIABABIAAAEIgBAFQABAAAAABQAAAAAAAAQAAAAAAABQAAAAAAAAIAAADIgCADIACACIADgBIAAgEIAAgEIAAgDIgBgGIAAgDIgCAAIgBABg");
	this.shape_2.setTransform(7.775,4.1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FF0000").s().p("AgeA/IgDABIgBgBIAAAAIgBAAIgBgBIgBgBIgBABIgBAAQAAABAAAAQAAAAAAAAQAAABAAAAQgBAAAAAAIgCAAIgCAAIgCAAIgGgBQgBAAAAAAQAAgBgBAAQAAAAAAAAQAAgBAAAAIAAgHIAAgBIAAAAIABgCIACgBIABgEIAAAAIgBgBIgBABIgBABIAAAAIgBgBIAAgEQAAAAAAgBQAAgBAAAAQAAgBAAAAQAAgBABAAQgBgBAAAAQAAAAAAAAQAAgBAAAAQAAAAAAgBQABAAAAAAQAAgBAAAAQAAAAAAgBQAAAAgBAAIAAgDIAAgCIAAgCIABgBIAAgDIAAgCIABgCIABgBIgBgBIAAAAIAAgCIgBgCIAAgDIAAgCIAAgBIgBgBIABgBQAAAAAAgBQAAAAAAAAQAAAAAAAAQAAgBgBAAIABgBIABgBIAAgBIgBgBQABAAAAAAQAAgBAAAAQAAAAAAgBQAAAAgBAAIAAgDIAAgCQAAgBAAAAQAAAAAAAAQAAAAAAAAQAAgBAAAAIAAgCIABgBIAAgBIgBAAIAAgCIAAgBIABgCIABgCIAAgGIAAgCIAAgCIgBgCIgBgBIgBgCIABgCIgBgBIABgFIAAgEIAAgCIAAgCIABgDIAAgCQAAgBABAAQAAAAAAAAQABgBAAAAQABAAAAAAIAFAAIABgBIABgBIAGAAIAGAAIADAAIADAAQABAAAAAAQAAAAAAAAQABAAAAABQAAAAAAABIABAGIAAAHIAAAHIAAAJQgBAGABAEIAAACIAAADIAAADIAAAbIgBAdIAAAEIAAAFIAAAEIAAADQAAABAAAAQAAAAgBABQAAAAAAAAQgBAAAAAAIAAgFIAAgGIgBgDIgCgCIgBACIABACIABADIgBACIABACIgBADIgBACIACACIgCABQgBAAAAAAQAAgBAAAAQAAAAgBAAQAAAAAAAAgAAFAeIgDgBIgBgBIgBgCIAAgDIABgDIgBgCIABgDIADgCIACgBIACgBIAEgEQACgCABgDQACgBABgCIADgGIACgGIgCgHIgDgJIgDgIIgBgBIgBgBIgEgEIgFgCQgEAAgBgDQgBgDAAgEIAAgCIABgBIABgCIAAgCIADgBIACAAIACABQABAAAAABQAAAAABAAQAAABABAAQAAAAABAAIAEAAIADACIAEABIABABIABAAIAFACIAEADIACABIACADIADAAIADAEQABABAAAAQABAAAAABQAAAAAAABQABABAAAAIACAEIADAEQAAAAAAAAQABABAAAAQAAABABAAQAAABAAABIABAHIABAFIAAAFIAAAFIgBAEIgCADQAAAAgBABQAAAAgBABQAAAAAAAAQAAABAAAAIgBADIgCADIgGAFIgBABIgBAAIgCABIgCABIgBAAIgBAAIgCABIgDACIgCABIABABIABAAIAAABIgEAAIgEAAIgCgCIgCACIgBADIgCABIgCAAIgBAAIAAgBIgBABIgCABIgCAAg");
	this.shape_3.setTransform(-4.625,4.275);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgbAcIAAg3IA3AAIAAA3g");
	this.shape_4.setTransform(-23.2375,6.9125);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AgbAcIAAg3IA3AAIAAA3g");
	this.shape_5.setTransform(-23.1625,0.7125);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("AgbAcIAAg3IA3AAIAAA3g");
	this.shape_6.setTransform(-16.6875,0.8625);

	this.instance = new lib.Symbol53();
	this.instance.setTransform(5.75,-271.65);

	this.instance_1 = new lib.Symbol53();
	this.instance_1.setTransform(5.75,62.9);

	this.instance_2 = new lib.Square("single",0);
	this.instance_2.setTransform(0,0,10,3.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).to({state:[{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.instance_1},{t:this.instance},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-50,-273.6,100,338.8);


(lib.NoButton = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Text
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgaAbIAAg1IA1AAIAAA1g");
	this.shape.setTransform(-22.7625,6.7125);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AgaAbIAAg1IA1AAIAAA1g");
	this.shape_1.setTransform(-11.7,-4.7625);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgaAbIAAg1IA1AAIAAA1g");
	this.shape_2.setTransform(-17.2625,0.775);

	this.instance = new lib.NoText("single",0);

	this.instance_1 = new lib.Symbol66("synched",0);
	this.instance_1.setTransform(-17.2,1);
	this.instance_1.filters = [new cjs.ColorFilter(0, 0, 0, 1, 51, 51, 51, 0)];
	this.instance_1.cache(-10,-10,20,21);

	this.instance_2 = new lib.Square("single",0);
	this.instance_2.setTransform(0,0,6,5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).to({state:[{t:this.instance},{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-30,-25,60,50);


(lib.NextShapeSymbol = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(8));

	// Layer_1
	this.instance = new lib.square_3();
	this.instance.setTransform(22,-10.4,1,1,0,0,0,10,10.1);

	this.instance_1 = new lib.square_3();
	this.instance_1.setTransform(0,-10.4,1,1,0,0,0,10,10.1);

	this.instance_2 = new lib.square_3();
	this.instance_2.setTransform(-22,-10.4,1,1,0,0,0,10,10.1);

	this.instance_3 = new lib.square_3();
	this.instance_3.setTransform(22,11.6,1,1,0,0,0,10,10.1);

	this.instance_4 = new lib.square_5();
	this.instance_4.setTransform(22,-10.4,1,1,0,0,0,10,10.1);

	this.instance_5 = new lib.square_5();
	this.instance_5.setTransform(0,-10.4,1,1,0,0,0,10,10.1);

	this.instance_6 = new lib.square_5();
	this.instance_6.setTransform(-22,-10.4,1,1,0,0,0,10,10.1);

	this.instance_7 = new lib.square_5();
	this.instance_7.setTransform(-22,11.6,1,1,0,0,0,10,10.1);

	this.instance_8 = new lib.square_6();
	this.instance_8.setTransform(-22,-10.4,1,1,0,0,0,10,10.1);

	this.instance_9 = new lib.square_6();
	this.instance_9.setTransform(0,-10.4,1,1,0,0,0,10,10.1);

	this.instance_10 = new lib.square_6();
	this.instance_10.setTransform(22,11.6,1,1,0,0,0,10,10.1);

	this.instance_11 = new lib.square_6();
	this.instance_11.setTransform(0,11.6,1,1,0,0,0,10,10.1);

	this.instance_12 = new lib.square_4();
	this.instance_12.setTransform(22,-11.4,1,1,0,0,0,10,10.1);

	this.instance_13 = new lib.square_4();
	this.instance_13.setTransform(0,-11.4,1,1,0,0,0,10,10.1);

	this.instance_14 = new lib.square_4();
	this.instance_14.setTransform(-22,10.6,1,1,0,0,0,10,10.1);

	this.instance_15 = new lib.square_4();
	this.instance_15.setTransform(0,10.6,1,1,0,0,0,10,10.1);

	this.instance_16 = new lib.square_7();
	this.instance_16.setTransform(33,0.6,1,1,0,0,0,10,10.1);

	this.instance_17 = new lib.square_7();
	this.instance_17.setTransform(11,0.6,1,1,0,0,0,10,10.1);

	this.instance_18 = new lib.square_7();
	this.instance_18.setTransform(-33,0.6,1,1,0,0,0,10,10.1);

	this.instance_19 = new lib.square_7();
	this.instance_19.setTransform(-11,0.6,1,1,0,0,0,10,10.1);

	this.instance_20 = new lib.square_2();
	this.instance_20.setTransform(11,-10.4,1,1,0,0,0,10,10.1);

	this.instance_21 = new lib.square_2();
	this.instance_21.setTransform(-11,-10.4,1,1,0,0,0,10,10.1);

	this.instance_22 = new lib.square_2();
	this.instance_22.setTransform(-11,11.6,1,1,0,0,0,10,10.1);

	this.instance_23 = new lib.square_2();
	this.instance_23.setTransform(11,11.6,1,1,0,0,0,10,10.1);

	this.instance_24 = new lib.square_1();
	this.instance_24.setTransform(22,-0.4,1,1,0,0,0,10,10.1);

	this.instance_25 = new lib.square_1();
	this.instance_25.setTransform(-22,-0.4,1,1,0,0,0,10,10.1);

	this.instance_26 = new lib.square_1();
	this.instance_26.setTransform(0,-22.4,1,1,0,0,0,10,10.1);

	this.instance_27 = new lib.square_1();
	this.instance_27.setTransform(0,21.6,1,1,0,0,0,10,10.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4}]},1).to({state:[{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8}]},1).to({state:[{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12}]},1).to({state:[{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16}]},1).to({state:[{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20}]},1).to({state:[{t:this.instance_27},{t:this.instance_26},{t:this.instance_25},{t:this.instance_24}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-43,-32.5,88,66);


(lib.NextShapeArea = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.EmilyLink();
	this.instance.setTransform(78.7,86.15,0.7709,0.7693,0,0,0,113.5,14.8);
	this.instance.filters = [new cjs.ColorFilter(0, 0, 0, 1, 51, 51, 51, 0)];
	this.instance.cache(-2,-2,231,34);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("ACDF8IuKAbIgohDIASAGIgRr0IFqApITigQIASFbIgfD7IARC5Il1g1ICBBCg");
	this.shape.setTransform(79.025,40.95);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.8,-0.2,175,97.7);


(lib.Next5Button = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.NextText("single",0);

	this.instance_1 = new lib.Squarecopy("single",0);
	this.instance_1.setTransform(0,0,8.3334,3.3333);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},1).to({state:[{t:this.instance_1}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-50,-20,100,40);


(lib.Last5Button = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.LastText("single",0);

	this.instance_1 = new lib.Squarecopy("single",0);
	this.instance_1.setTransform(0,0,8.3334,3.3333);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},1).to({state:[{t:this.instance_1}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-50,-20,100,40);


(lib.GameOverMenu = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FF0000").s().p("ABBChQgCgCgDAAQAAAAgBAAQgBAAAAAAQgBAAAAAAQgBAAAAgBQgDgBAAgGIACgDIABgDQAAgDgDgDQgBgBAAgEIgEgDQgBgBgBAAQAAgBgBAAQAAAAgBAAQAAAAgBAAQAAAAgBAAQAAAAgBAAQAAAAAAABQgBAAAAAAIgBADQgBAAAAAAQAAAAgBAAQAAAAAAgBQAAAAAAAAIAAgDIAAgCQgBAAAAAAQAAAAAAAAQgBAAAAAAQAAAAgBAAIgHgHQgEgDgBgFIABgBIAAgCQABAAABABQAAAAAAAAQABABAAAAQAAABAAAAQABABAAAAQAAABAAAAQABABAAAAQABAAABAAIABAAIABgCIgBgGIAAgFIgLgEQgGgCgDgDQgBgFgFgGQgFgHgDgEIAAAAQgBAAgBAAQAAAAAAAAQgBgBAAAAQAAgBAAAAIgBgFQgBgDgCgCQgCgCABgDIgBgEIgDAEIgBgIIACgCIgCgEIAAgEQABgHAEgDIALgEQAGgCAFgDQAFgBAFgGQAGgGAEgGQADgHABgFIAEgDQAAAAABAAQAAAAAAAAQAAgBAAAAQAAAAABAAIAAgHQABgEACgDQADgCgCgFIABgCIABgCQAAgBgBAAQAAgBAAAAQAAgBAAAAQgBAAAAgBIgDgDIgBgKQgBgGgDgDQgBgFgEgDQgEgDAAgFIgLgEIgBgDQAAgBgBAAQAAgBAAAAQgBAAAAAAQgBAAAAAAIgBAAIgBACIgDABQgDAAgDgDIgFgFQgDgCgFAAQgDgBgDgCIgEgGQAAAAgBgBQAAAAAAgBQAAAAAAgBQAAgBAAAAIABgFIABgFIgBgHIgBgJIgBgHIAEgGIAFgFQAEABADgBIAGAAIAEABIAEAAQAIAAAIgCIAQgCIADABIADADQAEgCAGABQAEAAAFgBIAEAAIAFgBIAKACQAFACAFAAIASABQAIABAJAGIgBAGQAAAAAAABQgBAAAAAAQgBAAAAABQgBAAgBAAIgBAAIgBABIABABIAFACIAEADIAAABQAAADACADQADACgBADIABACIAHABIADAIQABAEADAEQABAGADAHIAGAOQADAHAAAHIgCAQQgBAIgBAIIgUARQgEABAAADIgBAEQAAABAAAAQAAABgBAAQAAAAgBAAQgBAAAAAAQgDACgDABQgDACgDAAQgCADgFADQgDACgCAEIgCgBIgBAAQgDAAgDADQgBAEgDABQAAADgDABIgGABQgBAEgEAAQgEABAAAEIAAABIAAAAQADABAAAEQAAADAEABIACgBIACgHIAEAGIADAFIgDAHIAFABIABAAIACAAIADAAIADACIAAABQAAABAAAAQAAAAAAAAQAAABAAAAQgBAAAAAAQAAAAgBABQAAAAAAAAQAAAAAAABQAAAAAAAAIACAFIAEADQAEACACADIADAIQABADAEACIAEAIQABAFAEADIgBACIgCgCIgEgBIgBAAIgBABIgBACIgBADIAAACIABABQAAAFADACQAEACABAEIAEACIgBACIABAEIACADQAAAAABAAQAAAAABABQAAAAABAAQAAABAAAAQABABAAAAQAAAAABABQAAAAAAABQAAABAAAAQgBADgDACIgGACIgHAAIgEABIgGgBQgDgCgCAAIgDABQgBADgEABIgIAAIgBAFIgDABQgCgBgCgCIgDgFIgGADIgBAFIgEABIgEABgABiCEIACAGIADABIADAAIAEgBQABAAAAAAQABgBAAAAQAAAAAAgBQAAAAAAAAQAAgBAAAAQAAAAgBAAQAAgBgBAAQAAAAgBAAIgEgDgAiECeIgKAAQgBgEgEgCIgIgEIACACIAAADIAAACIgCABQAAAAAAgBQgBAAAAAAQgBgBAAAAQgBgBAAAAIgBgFIABgLIABgLQAAgGgCgIIgCgOIABgFIABgFIAAgFQAAgEADgBIAAgBIgBgCIgCgBIgBgHIgCgHIAAgCIABgCIAAgMIACgNIABgBQAAAAABAAQAAAAABABQAAAAAAABQAAABAAABIgBAFIABACIAAACQACgEAAgHIAAgMQABgHADgDIAAgFIABgEIgDgEIgGgBIAAgCIABgGIAAgFIABgEIAAgDIgBgIIgBgHQgBgDACgGQgBgFABgFIAAgKIgBgfQgBgQACgQIgCgCIgBgDQABgGAEgDQAFgDAGgCIALgCIAUABIAUABQAIAAADAEIAJAIIACAEIABAEQgBAGgCAFIgCAMIABACQAAABAAAAQAAABAAABQgBAAAAABQAAAAAAABQgBAAAAABQAAAAgBABQAAAAAAABQAAABAAAAQAAABAAAAQAAAAAAABQABAAAAAAQAAAAABAAIABABIABAEIgCAOIgDAUQgCAJgCADIABAHIAAAIIgBAKQAAAFgCAEQAAABAAAAQABABAAAAQAAAAABABQAAAAAAAAQABABAAAAQABABAAAAQAAABAAAAQABABAAAAIgBACQgCABABAEQABADgDADIABAEQAAAGgCAFQgCAFAAAFIABADIAAAEQgBAFACAGQABAFgBAFIABAEIABAEIAAADIAAAJIgCAIQABADgCAHQgCAHADAGIgDAJIgDAKIACACIgCAEIgCADIgBAAQAAAAgBAAQAAABAAAAQgBAAAAABQgBAAAAABIgDAEQAAAAABABQAAAAAAABQAAAAAAABQABAAAAABIgCACIgCAAQAAAAgBAAQAAAAgBAAQAAAAgBgBQgBAAAAAAIgFgCIgBAAQgBADgDABIgHABIgKAAgACYCQIgDgKQgCgGgEgBIADgEIABAAQAEABABAEIABAHIAEAEIAAAEIABAEIgBACIgBACQgCgBgCgGg");
	this.shape.setTransform(155.7,144.725);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FF0000").s().p("ABoCmQgBgEgDgCIgBAEIABABIABABQAAABAAAAQAAAAAAABQgBAAAAABQgBAAAAAAIgEACIgMgEIgMgDQgCABgDAAIgGgBIgKABIgKABIgIgCIgHgEIAAgEIAAgBIgBgCQACgFgBgFQgBgFgDgEIAAgGIgBAAIAEgRQACgHAGgIIAJgBQAFgBAFABIADgBIADAAQAPABAQACQAPAEAOgBIAGABQADgBACADQACAEgBAFQgBAGABAFQgCAGABAGIABANIABAFIgBADIgDACIgCAHIgFAEIgCgBIgCgBIgDACQAAAAAAABQgBAAAAAAQAAAAgBAAQAAABgBAAQgEgBgBgEgAh+CmQgFgDgCgGIgCgPQADgNgBgPIgBgcIACgCIACANIACAOIgCAIIgBALIAAAIIABAEQAAABAAAAQABABAAAAQAAABAAAAQAAABAAABIACgBIACgGQAAgCgCgCIABgHQABgEADgCIAAgDQAAgFADgEQACgEABgFIgBgCIgBgDQgDgBgBgDQAAgEgCgBIgBgOIgBgTQgBgKABgCIAAgHIAAgIQgBgDABgEQAAgDgDgCIgBADIgDACIgBgBIgBgDIABgDIABgDIgBgFIACgEIADAEIACgCIgBgHIgFgFIgBgGQgBgDACgDIgCgDIAAgCIABgGIAEgEIgBgIIgBgSIgBgTIAAgMQABgDgBgCIgBgGIABgBIABgCQAAgBAAAAQAAgBAAAAQAAgBAAAAQAAgBAAgBIADgEQAAgBABAAQAAAAABAAQAAgBAAAAQAAgBAAgBIABgEIAAgBIgDgDIgBAGIgCgDIACgIQgDgCAAgFIgBgJIAAgJIAFgDIAHgGIAFgCIAFAAIAGABIAMgBIASAAIANAAQABABAGAAIALAAIAHgBQAEADADAHQADAGABAHIABAMIgBAEIgBAIIgCAFQABAIgBAKIgBASIAAAJIABALQABAGACACIAAAGIAAAGQAAAGADAFQADAEAHABQAJgEAKAAIAVABIAdAAQAHgCAGgBIAMABQAGAAAGgCIAJACQAEAAAFADQAHAHABAHQABAHgBAHQAAAGACAIIgFAUQgBAEgEABIgWACQgDgBgDAAIgGABQgBAAAAgBQgBAAAAAAQgBgBAAAAQgBAAAAAAIgFACQgBAAAAAAQgBAAAAAAQgBAAAAAAQgBAAAAgBIgDABIgCAAIgHAAIgHAAQgJgCgIABIgSABIgDAAIgEgCQgEACgHgBIgNgCQgCADgEgBQgEAAgBAEQgFACgDAHQgCAGAAAFIAAAHQAAADACADIgBARIAAAUQAAAJABAIQgBAFABAFIABALIgBAEQAAADgCACIgUADQgKACgLgCIgDABIgEgBIgDACQAAAAgBgBQAAAAAAAAQgBgBAAAAQAAAAgBAAIgDACIgFABIgFAAQgMAAgEgDgAhNCdIgCAEIADABIADAAIAKgCIAMgDQAFgCABgDIgCgGIAAgHIgCgGQgEABAAAEIAAAHIgCAAQgDAAgBAEQAAAEgCADQgCACgHgEgAhlCIIAAAGIADAFQAAAAABAAQAAAAAAgBQABAAAAgBQAAAAABgBIAAgFIABgGIgEgDQgDACAAAEgAAQAmQADABADAAIABAAIACgBIAIgBQAAgBgBgBQAAAAAAAAQgBgBAAAAQAAAAgBAAIgEAAQgCAAgDgCIgGgEQgEgDgFgBIgCABIgDAAIgBADIAAACQAAAEADACQADABAEABIADgBIADABgABrAYQgBAFgEACQgFABgBAFIAEABIAEAAIAFgBQADgCAAgDIAAgDIAAgDIgFgDgAgKgQIgDAAIAAADIAEABIAEAAIACgBIAAgCIgCgBIgCgBIgDABgABrheIgBgBQgDgCgEABIgHABIgEgBIgCgBQgBAAAAAAQgBAAAAAAQgBAAAAABQAAAAAAABQgBAAAAAAQAAAAgBABQAAAAgBAAQAAAAgBAAIgPgBIgPgEIgCAAQgDAAgDgCIgFgDIgDgJQgCgEAAgHIABgDIgBgDQAAgHACgIIAEgNQADgDAFgDIAMgDQAGgCAEADIADABIADAAIAKgBIAJgCIAGAAIAGgBIAMAAIANACIADAJIABAKIgCAHIgCAHQAAAAAAABQAAAAABABQAAAAAAABQAAAAABABIACABIACAFIABAEIgCALIgDALIgHACIgJABIgGABIgCAAgAB4huIgBAFIAAACIAFAAIABgBIABgCIgBgEIABgDIgFgBIgBAEgAAmh6QACAGADAEQAEAEAFACIAAgKQAAgCgEgCQgFgBgCgCg");
	this.shape_1.setTransform(122.075,143.2);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FF0000").s().p("AgTCoQgCgCgDgCQgEgCgHADQgCgDgEABQgEgBgBgCIgEgPIgEgQQgDgBAAgDIAAgGQAAgEgCgCQAAgDgDgFIgEgIIAAgDIgBgHQgCgCAAgFQAAgCgDgEIgFgIQgDgFAAgCIgGgNQgDgIAAgGQgCgCgBgEQgBgEgDgDIgCgIQAAgFgDgDIgFgKIgGgPIgEgIQAAgFgDgGIgIgOQgDgHgBgGQgBAAAAAAQgBAAAAAAQAAgBAAAAQgBgBAAAAIAAgFQgEgDgCgEQAAgEgCgEIgGgHIgDgGIABgCQAAgEgDgEIgCgIQgEgBAAgDQAAgFgCgCIgDgJQgCgFgDgEIAAgFQAEgDAFAAQAGgBAFgCIABAAQADAAADAAIAHgCIAFgDIACAAQAJAAAJgBIARgCIAFACIADADIgBACIACAEQAAAAAAAAQABABAAAAQAAABAAAAQAAABAAAAIAFANIAHARQADAHACADIAGARQADAHACAKIAIAQIALAdIALAeIAJAYIAFALQAFAQAGAQIAOAgQAHAOAEAQIAAACQAAAEACAGIAFAKQADAGAAAFQgBAGgGACQgGACgHgBIgMAAIgGgCIgFACQgDABgBADIgCABIgCABIgDgDgAA5A6IABgEIgBgFIgCgDIAAgBQAAgEgDgCQgCgCACgEIgEgEIAAgBIABgCIgCgEQgBgDAAgCIgDgFQgCgCACgEQgDgDAAgDQgBgDgCgDIgBgFIgBgEIAAgCIABgDIACgGIAFgMIADgGIADgHIAHgKIAFgHQABgGADgGQAEgFABgHIAIgQQAAgEADgEQACgEABgDQAGgGACgIIAGgNQADgIAIgEQAIgEAQgBIAFABQABADAFAAQAFABAFgBQAGAAACgCIAEACIAEADIAAACIgCAGQgCADABADIgFAJQgDAFAAAHIgCACIAAACIAAACIgCACIgEAEQgCACAAADQgDABgEAJIgGASIgEANIgFAKQgCAHgFACIgCAIQgBAEgDADQgBAFgCAEQgDAEAAAFQgEAFgEAHIgGANQAAAFgCADIgDAIIgEAKQgCAGgEADQgBAGgDAEIgHAJgABVAFIgBAEIABACIABAAQABAAAAAAQABAAAAgBQABAAAAAAQAAgBABAAIACgEQADgDACgFIABgKIgEAFQAAAAgBAAQAAABAAAAQgBABAAAAQAAABABAAIgBAFQgBAAAAABQAAAAgBAAQAAABgBAAQAAAAgBAAIgDADgACChdIgBAEIgDAFIgCAGQgFAFgBAHIgCANQgFACgBAHIgCALIADgHQADgBABgDQABgEADgBIAAgEIADgGIACgFQABgGADgHQADgFABgGIADgHIgDgBIgCADgACSiZQgEAAgCAEIABAHQAAAEAEgBIACAEIABADIAAABIgEAJIgFAJIABAFQADgDAEgJIAHgRQAEgJAEgEQAAgBgBAAQAAgBgBAAQAAAAgBgBQAAAAgBAAIgEAAIgIAAg");
	this.shape_2.setTransform(88.125,143.75);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FF0000").s().p("AgfCgIgEgBIgDAAIgDABIgKgDQgEgCgGACIgHgDIgIAAQgCgDgDgBIgGgBIgNgIQgFgFgIgBIgIgGIgGgGIgBgFIgIgDQgEgCgCgDQgDAAgCgFIgDgJQgCgEgFgCIgBgFIAGgDIgCgEIgBAAIgDACIgDACIgDgDIgDgGIgDgEIAAgEIABgEIgBgBIgBgCQgDgBgBgEIgBgGIgBgIQgDgFgBgHIgBgPIAAgMIAAAAIACgRQABgLADgKQACgKAEgFQABgKAGgKQAGgLAIgJQAIgJAIgGQACgDADgCQAEgDACgDIAJgFQAFgCADgEIAJgEIAJgEQAFAAAGgCQAGgCAFgBIAEgDIARgFQAIgCAIAAQALAAADAEQAEAEACAGIAEAMQgCAEABAFIAAAIIgBAFIgCAFIgMAFIgWALIgYAKIgMAEQgDADgCADIgEAHQgCAFgDAEIgGAHIABACIgBACIgDADIgCALIgCALIABADIAAAEQgBAEACADQABAFgCADIACAIQACAEgCAEIACALQADAGADAEIAGAKQADAEACAGIAEAEIACAFIAIAFIAHAHQADADADABQAEAAADgCIAGgDIADAFIAAAHIAJAGIAJAFIACAFQABADgCADIAAABIABAGQABADgBAEIABAIIACAIQgBADgDADQgCAEgDAAIgFgBgAiXhSIgJAOIAAAGIAEgHIAFgHIACgFQABAAAAgBQAAgBABAAQAAAAABgBQAAAAABAAIACgCIACgCQAAgBABAAQAAAAAAgBQAAAAAAgBQAAAAABgBIAAgBIgBAAQgGADgFAIgABECVIgDgFQgBAAgBAAQAAABgBAAQAAAAgBABQAAAAgBABQAAAAAAABQgBAAAAAAQgBABAAAAQgBAAAAAAIgGgBQgDgCgFAAQAAAAAAAAQgBAAAAgBQgBAAAAgBQgBgBAAAAIgDgHIgBgGQAAgFABgEIAEgIQgHABgBAEIgCALIgBAAQAAAAgBAAQAAAAAAgBQgBAAAAAAQAAAAAAgBIgBgDIABgFIACgFQADgEAIgEIASgIQAJgEAFgEQACgCAGgHIAKgOIAFgKQAEgDACgEIAEgIQAEgLADgMQACgLAAgLIgCgOQgCgHABgFIgCgGIgCgHIACgBIABgDIgBgDIAAgDIgHgCIAAACIAAABIgBABIgFgIIgBgFIgDgEIgDgGIgCAAQgDAAgCgGIgEgIIgDACIgCABQgGAAgEgDIgKgFQgCgDgFgBQgFgBgCgEIgGgCQgCgCgCABQgDgCgBgGIgBgIQABgGACgHIADgNQADgEAFgDIAIgGQADABACgBIAGgBIACAAIABABQANABALAGQALAHAJAIQALAIALAFQACAEAEACQAGACACAEQADACABADQAAACADACIADAGQADADADACIAEAFQAAAFACAEQABAEAEADIABADIgBAEIAAABIABABQAEABABAEQACAFgBAFIABAIIABADIACACIABAOQAAAAAAABQAAAAAAABQAAAAAAAAQABABAAAAIACAEIgBADIgEADIAAAFIADgBIABACIABAKQgBADABAEIAAAGIgCAHQgBAEACACIgBAHQAAAEgDABIgDgFIgDADIAAAGIACACQgEADgBAFQgBAFgDAEIgBAFQAAAAAAABQgBAAAAABQAAAAgBABQAAAAAAAAIgBAEIgBAEQAAABABABQAAAAAAABQABAAAAAAQABAAABAAIAAABIgCAEQgBAAAAABQAAAAAAABQgBAAAAABQAAABAAAAQgEAEgBAEQgCAFgFADIgEAHIgEgEQgBgCgDAAQgEAAgCAEQgBAEgEAAIgEAKQgBADgDABIgKABIgHAFQgGAFgGACIgDgBIgCAAIgIABIgIADg");
	this.shape_3.setTransform(50.05,144.225);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FF0000").s().p("ABoClQgBgDgDgCIgBAEIABABIABABQAAABAAAAQAAAAAAABQgBAAAAABQgBAAAAAAIgEACIgMgEIgMgDQgCABgDAAIgGgBIgKABIgKABIgIgCIgHgEIAAgDIAAgCIgBgCQACgFgBgFQgBgFgDgEIAAgGIgBAAIAEgRQACgHAGgIIAJgBQAFgBAFABIADgBIADAAQAPABAQACQAPAEAOgBIAGABQADgBACADQACAEgBAFQgBAGABAFQgCAGABAGIABANIABAFIgBADIgDACIgCAHIgFAEIgCgBIgCgBIgDACQAAAAAAABQgBAAAAAAQAAAAgBAAQAAABgBAAQgEgBgBgFgAh+CmQgFgDgCgGIgCgPQADgNgBgPIgBgcIACgCIACANIACAOIgCAIIgBALIAAAIIABAEQAAABAAAAQABABAAAAQAAABAAAAQAAABAAABIACgBIACgGQAAgCgCgCIABgHQABgEADgCIAAgDQAAgFADgEQACgEABgFIgBgCIgBgDQgDgBgBgDQAAgEgCgBIgBgOIgBgTQgBgKABgCIAAgHIAAgIQgBgDABgDQAAgEgDgCIgBADIgDADIgBgCIgBgDIABgDIABgDIgBgFIACgEIADAEIACgCIgBgHIgFgFIgBgGQgBgDACgDIgCgCIAAgDIABgGIAEgEIgBgIIgBgSIgBgTIAAgMQABgDgBgCIgBgGIABgBIABgCQAAgBAAAAQAAgBAAAAQAAgBAAAAQAAgBAAgBIADgEQAAgBABAAQAAAAABAAQAAgBAAAAQAAgBAAgBIABgEIAAgBIgDgDIgBAGIgCgDIACgIQgDgCAAgFIgBgKIAAgIIAFgDIAHgGIAFgCIAFAAIAGABIAMgBIASAAIANAAQABABAGAAIALAAIAHgBQAEADADAHQADAGABAHIABAMIgBAEIgBAIIgCAFQABAIgBAKIgBASIAAAJIABALQABAGACACIAAAGIAAAGQAAAGADAFQADAEAHABQAJgEAKAAIAVABIAdAAQAHgCAGgBIAMABQAGAAAGgCIAJACQAEAAAFADQAHAHABAHQABAHgBAHQAAAGACAIIgFAUQgBAEgEABIgWACQgDgBgDAAIgGABQgBAAAAgBQgBAAAAAAQgBgBAAAAQgBAAAAAAIgFACQgBAAAAAAQgBAAAAAAQgBAAAAAAQgBAAAAgBIgDABIgCAAIgHAAQgEgBgDABQgJgCgIABIgSABIgDAAIgEgCQgEACgHgBIgNgCQgCADgEgBQgEAAgBAEQgFACgDAHQgCAGAAAFIAAAHQAAADACADIgBARIAAAUQAAAJABAIQgBAFABAFIABALIgBAEQAAADgCACIgUADQgKACgLgCIgDABIgEgBIgDACQAAAAgBgBQAAAAAAAAQgBgBAAAAQAAAAgBAAIgDACIgFABIgFAAQgMAAgEgDgAhNCdIgCAEIADABIADAAIAKgCIAMgDQAFgCABgDIgCgGIAAgHIgCgGQgEABAAAEIAAAHIgCAAQgDAAgBAEQAAAEgCADQgCACgHgEgAhlCIIAAAGIADAGQAAgBABAAQAAAAAAgBQABAAAAgBQAAAAABgBIAAgFIABgGIgEgDQgDACAAAEgAAQAmQADABADAAIABAAIACgBIAIgBQAAgBgBgBQAAAAAAAAQgBgBAAAAQAAAAgBAAIgEAAQgCAAgDgCIgGgEQgEgDgFgBIgCABIgDAAIgBADIAAACQAAAEADACQADABAEABIADgBIADABgABrAYQgBAFgEABQgFACgBAFIAEABIAEAAIAFgBQADgCAAgDIAAgDIAAgDIgFgDgAgKgQIgDAAIAAADIAEABIAEAAIACgBIAAgCIgCgBIgCgBIgDABgABrheIgBgBQgDgCgEABIgHABIgEgBIgCgBQgBAAAAAAQgBAAAAAAQgBAAAAABQAAAAAAABQgBAAAAAAQAAAAgBABQAAAAgBAAQAAAAgBAAIgPgBIgPgEIgCAAQgDAAgDgCIgFgDIgDgJQgCgEAAgHIABgDIgBgDQAAgHACgIIAEgNQADgDAFgDIAMgDQAGgCAEADIADABIADAAIAKgBIAJgCIAGAAIAGgBIAMAAIANACIADAJIABAKIgCAHIgCAHQAAAAAAABQAAAAABABQAAAAAAABQAAAAABAAIACACIACAFIABAEIgCALIgDALIgHACIgJABIgGABIgCAAgAB4huIgBAFIAAABIAFABIABgBIABgCIgBgEIABgDIgFgBIgBAEgAAmh6QACAGADAEQAEAEAFACIAAgKQAAgCgEgCQgFgBgCgCg");
	this.shape_4.setTransform(164.375,95.5);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FF0000").s().p("Ai9CmIgEgCQgCgBgBgFIACgLIAAgMQACgEAAgFIgCgLIABgTIABgUIABgDIABgDIABgCIACgBIADABIADAAQAFAGAEAGQADAHAGAFQAEAHAEAFQAFAGACAHQACADAAAEIAAAHIAAABIAAAGIABAGIAAAIIgBAHIgEAEIgDAAIgJABQgFACgFgBIgJACIgIgBgAB9CfQgBgHgGgIQgFgJAAgHIAAgKIgBgOQgBgHgBgCIAAgCIABgKIACgJIgBgKIgCgJQABgEgBgFQgBgDABgFIgCgQQAAAAABAAQAAgBAAAAQAAAAABAAQAAgBABAAIACAAIABAAIABgBIgBgCIgCgCQgBAAAAAAQAAgBgBAAQAAAAAAgBQAAAAAAgBIABgIIABgJQAAgFgBgDQABgDAAgDQgBgEACgDIgCgNQgBgJABgJIABgNQgCgKAAgLIABgVIgCgGIgBgFQAAgFADgFQABgHAEgEQADgEAGgBIAHACQAEACAEAAQAIAAAJgCIAPgCQAGADAGAAIALABIABACIAAACIgBAJIgBAJQABADAAADIAAAHIAAAHQAAAEgBADIgBAFIAAAGIACAEIABAEQAAADgBACIgDAEQAAAAAAABQAAAAAAABQAAAAABABQAAAAABABIAAAGQAAABAAAAQAAABAAAAQgBABAAAAQAAAAAAAAQgBAAAAABQAAAAgBAAQAAAAgBAAQAAgBgBAAIgBACIAAABIABADIgBADIAFAFIABACIgDAGQgCACADADIgBAJIgCAIIADAGIAAAGIgBAGQAAAEgDACQADAEgBAGQAAAGACAFIgDACIgBAEIABACQAAAAAAABQAAAAAAAAQABABAAAAQAAAAAAAAQABAAAAABQABAAAAAAQAAAAAAABQABAAAAAAIAAABIgBABIgDAGIABAIIgEADIAAACQAAABAAAAQAAABAAABQAAAAABABQAAAAAAABQABAAABABQAAAAAAABQABAAAAABQAAAAAAABIgBABIgBACIAAAIQACAFgDADIAAAGIAAAHIAAAEIADAEIgCACIgBADIABAGIACAHIgBALQgBAGgEAEIgEgCIgDAAIgGAAIgIACQgEABAAACIgOAAQgIAAgFACgACxCJIAAADIAAAEIADAEIAAgBIACgFIABgFIAAgCgAChCRQABAAAAAAQABAAAAgBQABAAAAAAQABgBAAAAIADgEIgBgDQAAgBAAAAQAAgBAAAAQABAAAAAAQABgBAAAAIgFgBIgDADIgCADIgHgBIgHgBIgBACIAAADIADAEIAHgBIAHABgAgVCgIgEgBQgCABgDgDQgDgDgFgLIgIgJIgMgOQgFgHgBgDIgGgKIgKgNIgFgHQgEgIgGgHQgGgHgDgIQgEgDgCgFQgBgEgEgDQgBgFgEgDQgEgEgBgFIgGgJIgHgJQgFgBAAgEQAAgFgDgDIgEgGQgEgCgCgEIgEgIQgEgDgDgGIgGgKIgDgFIgFgNQgDgHAAgHIABgEQAAgBAAAAQABAAAAgBQAAAAAAgBQAAAAAAgBQACgGAAgHIAAgOIABgPIABgPQAAgHAEgFQADgFAIAAQAIAAAGACQAHACAHgBIAIAGIAJAHQAEAEgBAFQAGAGADAJQAFAJAGAGQAAAEADAEQADADAAAFIAKAOQAFAHACAJQAFADACAGQACAFAFAEIACAGQABACABAEQAFADACAFIADAKQAEACACAFQABAEADADIAEAIQACAFAFADIACAFIABAAQACABACACIAFACIAHgCIAEgEIAAgDQABgDADgBQADgBAAgEIADgEQADgBAAgDIAIgIQAEgEABgGIAEgCIACgDIAKgHIANgHQAFADAAAHIABANIgBADIAAAEQgBAAAAABQAAAAgBABQAAAAAAABQAAABAAAAIACAPQAAAIAAAJQACADgBADIABAHIgBAHIABADIAAACIgBAMIgBAQQgCAHgEADQAAADgDADQgCACgBAEQgFAAgEAFQgDAEAAAFQgFAAgBACIgFAGQgDABgBADIgEAFQgCACgGABIAAABQAAAEgDACQgDACgCADIgCABIgDAEIgHAFQgEADgFAAgAithuIAAAIIgCAHIgBAHIABADIABADQADgEABgEIADgJIAAgKIgBgFIgBgEIgDAAIgBAIgAiLiVIAEAFIAFAEIACAEQAAABABAAQAAAAABABQAAAAABAAQABAAAAAAIAFAGIACAGIABAAIACgCIABgCQgBgDgCgCQgCgCgBgDIgGgEQgCgDAAgEIgIgDg");
	this.shape_5.setTransform(127.15,96.125);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FF0000").s().p("AC0CjIgEgDIgCADQAAABgBAAQAAABgBAAQAAAAgBAAQAAABAAAAIgEgBIgEAAIgGAAIgFABIgGgCIgGAAIgDgFIgHACQgDABgBADIgEABQgDgBgDgDQgDgDgEgBIABgCQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAAAAAgBIgDgDQAAgBAAAAQAAAAAAgBQAAAAABgBQAAAAABgBQgBgDgCgCIgEgEQgCgCACgDIgFgHIgFgJQgDgFAAgCIgDgGIgBgHQgFgCgBgHQgBgHgEgEIABgDIABgCQAAgBAAAAQAAgBAAAAQgBgBAAAAQAAAAgBAAIgDAAIgDgFQAAgDABgCIAAgEIgBAAQgFAAgBgDIgDgHQgBgEgDgBQAAgDgCgCQgCgCAAgDQgCgDgBgEQABgEgDgBIgFgJQgCgEAAgEIgCgEIgCgEIABgFIgFgHQgEgDABgFQAAgFgEgDQABgBAAAAQAAgBgBAAQAAgBAAAAQAAgBgBAAIgDgDIgBgEIABgFQAAgBgBAAQAAgBAAAAQAAAAAAgBQgBAAAAAAIgDgBIgCgEIAAgGIgBgDIgCgCIgFgKQgCgEAAgGQgCgBAAgDIgBgHQgBgDgDgBQgDgDAAgFIgBgJQAAgEgDgEQgCgCAAgEQAAgFgDgBQAAgHAHgEQAGgFAGgDQAJgCAFAAIAHAAIAHABQAFgCAGABQAGACAGgCIALACIAMABIAHADQAAABAAAAQAAABAAABQABAAAAAAQAAABAAAAQABABAAAAQAAABABAAQAAABAAAAQAAABAAAAQADAEACAFQACAGAEAEIAEAMIAHALIgBACIAEAIQAEAHABAHIAGAMIAJAUIAFAMIAGAKIAJATIAJASIADAJQAFAIAGAPQAHAPAEAPQAGAPgBAIIABACIACACIADAGQABACABAEQAAAFgEABQgDACgBADIADAJIAEAMIACAJIAAAGIgCAGQgEABgDACIgHADIgDgDgAgHiTIgBACIACAFQAAABAAABQAAAAABABQAAAAABAAQAAAAABAAIABAAIACgEIgDgFQAAAAAAgBQgBAAAAgBQgBAAAAAAQgBAAAAAAIgBABgAh/ClQgCgBgDAAQgGgCgGAAQgHAAgHgCIgFAAIgEABIgEABQgEgBgEABIgIABIgGgBIgEgDIgBgEQAAgEACgEIADgHIAHgLIAFgKQADgCABgEIAFgGQABgCAGAAQABgHACgDIADgEIACgEIABgDIAAgDIAEgGIAFgJIAFgGQABgFACgFIAGgJIADgHQABgDAAgEQAHgJAFgKQADgJAGgKQAAAAABAAQAAgBABAAQAAgBAAAAQABgBAAAAIACgFIAEgHIADgHQAIgHAGgKIAKgUQACgDACgGIAEgKQACgFACAAQAEAAACACIADAEQABAFACAFIAFAKQABAEADADQAEAEgBAFIAIAPIAGAPQAFACAAAEQAAAEACADIAAABIACAFIADAEQADAEACAHIAFANQAAAJAEAIQAEAHACAJQACAEABAGQAAAGAFAEIABAGIAEAEIAEAIQABAFAAAFIAAAEIgCAEIgFABIgEAAIgQAAIgTgCIgPgCQAAAAgBAAQAAgBAAAAQAAgBAAAAQAAgBAAgBQAAAAgBgBQAAAAAAgBQAAAAAAAAQgBgBAAAAIgBABIgCABIAAABIgCADQAAAAAAAAQgBABAAAAQAAABAAAAQABABAAAAIgIAAQgFgBgFACIgIAFQAAAAgBAAQAAABgBAAQAAABAAAAQAAABgBAAQAAABAAAAQAAABgBAAQAAAAgBABQAAAAgBAAIgDAHQgDADgBADIgBAHQAAABgBAAQAAABAAAAQAAAAgBABQAAAAgBAAIgEADQgBACAAADQAAABAAABQgBAAAAABQgBAAAAAAQgBAAgBAAIgDAAQAAAAgBAAQAAAAgBABQAAAAAAABQgBABAAAAQgBADgDABQgCgCgDABQgEABgCgCIgEAAIgCABIgCABIgFgBgAiqB2QgDAGgEAEQAAAFgDAEQgEADAAAFQAAAAgBABQAAAAgBAAQAAAAAAABQgBAAAAABIgBAEIABAFIAJAAIAAgCIgBgEIgDgCQABgHAEgHIAJgOQAFgHACgHIgBAAIgIALgAiVB+IgEAFIAAAFIACAAIAEAAQABAAAAgBQABAAAAAAQAAgBAAAAQABAAAAgBIgBgCIAAgFIABgFQgEABgBAEgAgxBuIgBgCIgBgBIAAABIAAABIABABIABAAIAAAAgAgHBsIAHgDIAAgBIAAgBIgGgFQgDAAgDACIgEAEQAAABAAABQAAAAABAAQAAABABAAQABAAAAAAQAEAAACABgAAIBoIAHADIADgCIgCgGQgBgCgEgBg");
	this.shape_6.setTransform(84.9,96.0219);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FF0000").s().p("AgwCqIgKgBQgFgFgHgBIgMgDQAAgDgDgCQgEgBgCgCQgHgCgFgEQgHgDgEgGQgHgCgEgGQgFgFgGgEIgIgMQgFgFgEgGQAAgDgBgCIgDgFQgCgCADgEQgFgGgGgGQAAAAAAgBQAAAAAAgBQAAgBAAAAQgBgBAAAAIgDgEIAAgCQAAgDgBgDIgCgHIgDgHIAAgDQABgIgCgIIgDgRIABgCIABgCQAAgLACgLIAFgVQADgKAAgKIABgDIAAgEIABgBIALgVQAHgGAEgHQAEgIAGgEQACgEAFgDIAFgHIAMgIIALgIQAEAAAEgDQADgCAEAAQACgFAEAAQAGgBADgDIAEABIALgBIALgBIAIgBIAJgEQAAAAABABQAAAAABAAQAAABAAAAQABABAAAAIABAFQAEAFAAADIAAAKIAAAGIgBAKIgCAKQgEADgDAAIgIgBQgLAAgHAEIgLAJQgGAFgIACQgBAEgDACIgIAEIgEAKQgBAEgEAEIgHAPQgDAIAAAIQgCADgBAEIAAAHIAAAEIgBADIAAAHIgCAGQACADgBAEIgBAIIADAHIAAAEIgBAHIABADIACADQAAAEACADIADAHQABAGAFAJIAIAOQAEACACAEQADAEAEABQAKAIAKAFQALAFAKAHQAIAGAEAMIAAAHIAAAGQABAEgCACIgCAGIAAADQAAADgEACIgEAEIgKgCgACbCdQgDACgCgBIgEgDQgCAAgDABIgCgBIgDAAIgJABIgDgFQgCgCABgEIgDgCQAAgBAAAAQAAAAAAgBQAAAAAAAAQAAgBABAAIAAgEIgGgCIgGgBQgCABgCACIgFADQgCACgEgCIgLAFQgGADgFABIgDgDQgDgCgDAAIgHACQgDACgEABIgBADQADACACgBIAGgBIACAAIABABIgDAEQgEgBgEABQgFAAgDgDIgGgJQgCgFAAgFIAAgKQAAgGgCgEQAAAAAAgBQAAAAAAgBQAAAAAAgBQAAgBAAAAQAAgBAAAAQAAgBAAgBQAAAAABgBQAAAAABgBIAAgHIAGgHQAOgGAIgGQAJgHAGgJQAEgKAEgQQgFAAgBgEIgBgHIgHgCIgGgFIgKABIgKACQgFADgFAAIgLgBIgFADQgEgCgCgIIgDgQIgDgNIAGgMQACgFAJAAIAGABIAEABIAEgBIAEgBIAEABIAEABIAJAAQAEAAADgCIAIAAIALACQAFAAACADIALgBQAGAAAFACQACgBAEABQADABACgDIASACQAKAAAJgDIANABQAEAHAAAHIAAANIABAFQgBAEAAAFIABAJIAAACQgCAFAAAGIACAKQgCAFgBAEIgBAIQABAEAAAFQgBAFABAEQgBAEABAFQABAEgBAEIAAAIIABAIIgBAPQAAAIABAHQgCAGgCACQAAABgBAAQAAABgBAAQAAAAgBAAQgBAAgBAAIgHACgABRhlIgSgLIgQgNQgGgGgBgDIAEgQQADgHAGgGQADgHAEgBQAFgBAGABQAFACAEABIAKACIAOAJIAPALQAIAGAAAGQAAAGgDAFIgHAJIgEABIAAgBQAAgBAAAAQAAAAAAAAQAAgBAAAAQABAAAAAAIABgCIAAgCIgHADQAAAAAAABQAAAAgBAAQAAABAAAAQAAABAAAAIABAGQAAAEgGAEQgFADgFAAQgDAAgIgEg");
	this.shape_7.setTransform(43.8,93.8667);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	// GameOver
	this.mainMenuButton = new lib.MainMenuButton();
	this.mainMenuButton.setTransform(100.55,237.05,1,1,0,0,0,74.5,12.6);

	this.submitScoreButton = new lib.SubmitScoreButton();
	this.submitScoreButton.setTransform(100.55,210.05,1,1,0,0,0,74.5,12.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.submitScoreButton},{t:this.mainMenuButton}]}).wait(1));

	// back
	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("rgba(0,0,0,0.878)").s().p("AwcSSMAAAgkjMAg5AAAMAAAAkjg");
	this.shape_8.setTransform(105.325,159.075);

	this.timeline.addTween(cjs.Tween.get(this.shape_8).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GameOverMenu, new cjs.Rectangle(0,42.1,210.7,234.00000000000003), null);


(lib.Symbol53_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance_1 = new lib.Tween3_1("synched",0);
	this.instance_1.setTransform(0.45,0.15);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({x:1.25},14).to({x:1.2,alpha:0.3984},8).to({x:1.15,alpha:1},11).to({x:0.45},9).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-7.7,-2,17.2,4.3);


(lib.HighScoresButton = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Text
	this.instance = new lib.HighScoresText("single",0);

	this.instance_1 = new lib.Symbol53_1();
	this.instance_1.setTransform(44.15,-460.2,1.442,1.442);

	this.instance_2 = new lib.Symbol53_1();
	this.instance_2.setTransform(44.4,54.45,1.5584,1.5584);

	this.instance_3 = new lib.Square_1("single",0);
	this.instance_3.setTransform(60.35,0,25.6,3.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance},{t:this.instance_2},{t:this.instance_1}]},1).to({state:[{t:this.instance_3}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-76.1,-463,264.5,521);


(lib.BigPlayButton = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_4
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FF0000").s().p("AgVBVIgCgCIgDAAQgDAAgCgDQgCgDAAgEIAAgCIABgDIAAgGIAAgDIABgGIABgGIAAgBIgBgBIABgEIAAgEIAAgCIAAgDIABgFIAAgFIgBgGIgEgIQgCgDgCgBQAAAAAAAAQgBgBAAAAQAAAAAAgBQAAAAAAAAIAAgCQAAAAAAAAQAAAAgBgBQAAAAAAAAQgBAAAAAAQAAAAgBgBQAAAAAAAAQAAAAAAgBQAAAAAAAAIgBgDIABgBIgEgCIAAgCIgBgCIgBgBQAAAAgBAAQAAAAAAgBQgBAAAAAAQAAgBAAAAIgCgEIgDgEIAAgBIgBgDIgCgEIgCgEIgDgEQgDgDgBgEQgBgEgEgDIgCgEIgCgDIgBgDIgDgDIgCgDIgCgCQAAAAAAAAQAAgBAAAAQAAAAAAgBQgBAAAAAAIgBgDQAAgBAAAAQAAgBAAAAQABgBAAAAQAAgBABAAIADgCIABgBIACAAIAEABIAEAAQAAABABAAQAAAAAAAAQABAAAAAAQABAAAAAAQAAAAABAAQAAAAABAAQAAAAABAAQAAAAAAAAIADgBIAFAAIAFAAIABAAIACgBIACABIAEABIAAAAIABAAIABABIABABQAEACADAEIAEAJQAFAFACADIACAGQABADADADIAAABIACAFIAEAHIAEAEIABACIABACIADAKIAHALIACADIACADIACAEQAAAAABABQAAAAAAABQAAAAAAABQAAABAAAAIAAAKIABANIgBAKIAAABIAAABIAAACIAAACIAAASIABACIgBAEIABAEIAAACIgBABIAAABIgCAAIgDgBIgDAAIgBAAIgBAAIgCAAIgCABIgBgBIgCgBIAAAAIgBAAIgCACIgBAAIgDAAIgDgBIgBABIgBABIgDAAIgBABIgCABgAAhgWIAAgDIgCgCIgBgDQgBAAAAAAQAAgBAAAAQgBAAAAAAQAAgBgBAAIgBgDIgCgDIABAAIgCgDIgBgEIgCgDIAAgDIAAgCIAEgFIAEgEIAEgEIADgEIADgBIABgCIAFgEQADgDADAAIAGAAIAFAAIAKABIAHACQAEABAFAEIgCAFIgHAIIgEAGQgBACgDABQgDABgBADIgCACIgCACIgCACIgDADQgDABgDADIgFAGQgDADgDABIgCACIgCAAQAAAAgBAAQAAAAgBAAQAAAAAAgBQAAAAgBAAgABNhHIAAACIAAACQAAABgBAAQAAAAAAABQAAAAAAABQAAAAAAABIgBADIABABIACgDIABgCIACgCIAAgDIgBgBIgCgBg");
	this.shape.setTransform(26,1.525);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FF0000").s().p("ABaBSIgCgCIgCACIgBABIgCgBIgCAAIgDAAIgCABIgDgBIgDAAIgBgCIgEABQgBAAAAAAQAAAAgBAAQAAABAAAAQAAAAgBAAIgBABIgDgCIgEgCIABgBIgBgCIgBgCIAAgBQAAgBAAAAQAAgBAAAAQAAAAAAAAQgBgBAAAAIgBgCQgBAAAAgBQAAAAAAAAQAAAAAAgBQAAAAAAgBIgCgCIgDgGIgBgDIgCgDIAAgEQgDgBAAgDIgDgFIABgBIABgCIgCgBIgCAAIgBgDQAAAAAAgBQAAAAAAAAQAAgBABAAQAAAAAAgBIAAgBIgBAAQAAAAgBgBQAAAAAAAAQgBAAAAAAQAAgBAAAAIgCgEQAAAAAAAAQgBgBAAAAQAAAAgBgBQAAAAgBAAIgBgCQAAgBAAAAQAAAAAAgBQAAAAAAAAQAAgBAAAAQAAAAgBgBQAAAAAAAAQAAgBAAAAQAAAAAAgBIgBgDIgDgEIgCgEIgBgBIgBgDIABgDIgCgDQAAAAgBgBQAAAAgBgBQAAAAAAgBQAAAAAAgBQAAgBAAAAQAAgBAAAAQgBgBAAAAQAAgBAAAAIgBgCIgCgCIgBgCIABgCIgBgBIgBgBIgBgCIAAgDIAAgBIgBgBIgDgFIgBgFIgBgDIgBgDQAAAAAAgBQAAAAAAAAQAAgBAAAAQgBAAAAAAIgCgEIAAgEIgBgFQgBAAAAAAQAAAAgBgBQAAAAAAgBQAAAAAAgBQAAAAAAAAQAAgBAAAAQAAgBgBAAQAAAAgBAAQABgDADgDQADgDADAAIAHgCIAEAAIADABQADgBACABIAGAAIAGAAIAGABIADABIABACIABACIACAFQABADACABIADAGIACAGIAAABIADAEIACAHIADAGIAFAKIACAHIACAEIAGAKIADAIIACAFIAGALIAGAPQACAIAAAEIABAAIAAABIABADIACAEQAAAAAAABQAAAAgBAAQAAABAAAAQgBAAAAAAIgCADIABAFIACAGIABAEIAAADIgBADIgDACQAAAAgBAAQAAAAgBABQAAAAgBAAQAAAAAAAAIgCgBgAgDhJIAAABIAAACIABACIABAAIABgCIgBgCQAAAAAAgBQAAAAgBAAQAAAAAAAAQgBAAAAAAIAAAAgAg2BSQAAABgBAAQAAAAAAAAQgBAAAAgBQAAAAgBAAIgBAAIgBABIgBAAIgDgBIgDAAIgGgBIgGgBIgDAAIgCABIgCAAIgFAAIgDABIgDgBIgDgBIAAgDIABgDIACgEIADgFIACgGIADgCIACgDIAEgBQAAgBAAgBQAAgBAAAAQAAgBABAAQAAgBAAAAIACgCIABgCIABgCIAAgCIABgDIADgEIACgDIACgFIADgFIABgDIABgEQAEgEACgFIAEgJQAAAAABAAQAAAAAAAAQAAgBAAAAQAAAAAAgBIACgBIACgFIACgDQADgDADgGIAFgJIADgFIACgFQAAgBAAAAQAAgBAAAAQABAAAAAAQAAAAAAAAIADABIACACQAAACACACIACAFIACAEQAAABABAAQAAABAAAAQAAABAAAAQAAABAAABIAEAHIADAIQABAAAAAAQABAAAAABQAAAAAAABQAAAAAAABIACADIAAABIABACIACACIACAGIACAFQAAAFACAEIADAIIABAFQABADABACIABADIADACIABAEIABAFIAAACIgBACIgCAAIgDAAIgIAAIgJAAIgHgBQAAgBAAAAQgBAAAAAAQAAAAAAAAQAAgBAAAAIgBgCIgBABIAAAAIAAABIgBABQAAAAAAAAQgBAAAAABQAAAAABAAQAAAAAAAAIgEAAIgFABIgEACIgCACIgBACIgCADIgCADIAAAEIgBABIgDABIgBADQAAAAAAABQAAAAAAAAQAAAAAAABQgBAAAAAAIgBAAIgCACIgCABIgDgBgAhUA7IgEAGIgCADQAAABgBAAQAAABAAAAQAAABAAAAQgBABAAABIgBABIgBACIABADIAEAAIAAgCIgBgBIgBgCQABgDACgEIAEgGQADgEAAgDIAAAAIgDAFgAhLA/IgBACIAAADIABAAIACAAIABgCIAAgBIAAgCIAAgCIgDACgAgYA3IAAgBIgBAAIgBAAIABABIABAAIAAAAIAAAAgAgFAyIgDACQAAAAAAABQABAAAAAAQAAAAAAAAQABABAAAAIADAAIADgBIAAgBIAAAAIgDgDIgCABgAAEA0IADACIABgBIgBgDIgBgCg");
	this.shape_1.setTransform(6.2,1.2);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FF0000").s().p("Ag2BQIgCgBIAAgDIgEgBIgBgDIgBgDIAAgDIgBgEIAAgDQAAgBAAgBQAAAAAAgBQAAAAAAgBQAAAAAAgBIgCgEIAAgDIgBgEIAAgOIAAgPQgBgCABgFIAAgHIAAgGIABgHIgBgEIAAgHIAAgIIABgFIgBgMQABgHgBgHIAAgBIAAgCIAAgCIAAgEIAAgBIAAgBIACgDQAAAAAAgBQAAAAAAAAQABgBAAAAQABAAAAAAIAGABIABAAIABAAIAEABIADgBIACABIACgBIABAAIACABIACABIADgBIADgBIAFABQAAAAABAAQAAAAABAAQAAAAABAAQAAABABAAIACAAIADAAIABAAIABABIAAAMIABANIgBAKIAAALIAAAJIAAAMIgBAIIAAAAIABACIgBAHIABAIIgBAQQgBAIABAIIAAADQAAABAAAAQAAABAAAAQAAABAAAAQgBAAAAABIABAFIgBAFIABADIgCAFIgCADIgGABQgEAAgDABIgCgCIgDAAIgDABIgCAAIgCABIgDAAIgCABIgDAAgAgiBIIgCACIABABIAHAAIAHgBIAAgFIgEACIgEADIgBgCIgCAAIgCAAgAgWhGIAAADIABAHIABAHIAAAHIgBADIAAADIAAABIAAAJIABAKIABAAIAAgBIAAgCIAAgEIAAgDIAAgCIAAgDIAAgBIAAgBIABgLIgBgMIAAgEIAAgFIgBgDIgCgBIAAADgAA5BNIgCgBIgCAAQgCABgFAAIgJABIgHAAQgDgBgDAAQgDABgCgBIgBgEQgBAAAAAAQAAAAAAAAQgBABAAAAQAAAAABABIgBACQgFAAAAAAIgBgGIAAgCIAAgCIgBgGIAAgGIgBgCIAAgBIACgEQAAAAAAAAQAAgBABAAQAAAAABAAQABAAABAAIAIgCIAJgBIAGAAIABAAIAFABIAFAAIABAAIABAAIALAAIACAAIACACIABAJQAAAFACAEIgBAGQAAAFgCACIgDAAIgCABgAA7A0IABACIAAAGIgBAFQAAAAAAABQABAAAAABQAAAAAAABQAAAAAAABIAAADIgCADIACACIAEgBIAAgFIAAgDIAAgGIgBgHIgBgEIgCAAIgBABg");
	this.shape_2.setTransform(-11.9083,1.7);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FF0000").s().p("AgmBPIgEAAIgBAAIAAgBIgBAAIgBgBIgCAAIgBAAIgBABIgBABIgCABIgDAAIgDgBIgIAAQAAgBgBAAQAAAAAAAAQgBgBAAAAQAAgBAAAAIAAgJIAAAAIAAgCQAAAAAAAAQAAAAAAAAQAAgBABAAQAAAAAAAAIADgCQABAAAAgBQAAAAAAgBQAAAAAAgBQAAgBAAAAIAAgCIgBAAIgBACIgCAAIAAAAIgBAAIAAgGIABgFIgBgDQAAAAABgBQAAAAAAgBQAAAAAAAAQgBgBAAAAIAAgDIAAgDIAAgDIABgBIAAgEIAAgCIABgCIABgCIAAgBIgBgBIAAgCIgBgCIAAgEIAAgDIAAAAIgBgBIABgCQAAgBAAAAQAAAAAAAAQAAgBAAAAQgBAAAAAAIACgDIABgBIgBAAIAAgBQAAgBAAAAQAAgBAAAAQAAAAAAgBQAAAAAAgBIgBgEIAAAAIABgCQAAAAAAgBQAAAAAAAAQAAgBgBAAQAAAAAAAAIABgCIABgCIgBgBIgBgBIAAgBIAAgCIABgDIACgCIgBgHIABgCIAAgDIgBgEQAAABAAAAQgBAAAAgBQAAAAAAAAQgBAAAAgBIgBgBQABgBAAAAQAAAAAAAAQAAgBAAAAQAAAAAAAAIgBgDIABgFIAAgGQAAAAAAgBQABAAAAAAQAAAAAAgBQAAAAAAAAIgBgDIABgDIAAgDQACgCADAAIAFAAIACgBIACgCIAHAAIAHgBQABABAAAAQAAAAABAAQAAAAABAAQAAAAABAAIAEAAQAAAAABAAQAAAAAAABQABAAAAAAQAAAAAAABIABAHIABALIAAAHIgBAMQgBAHABAFIAAACIAAAFIAAADIAAAiQAAASgBASIAAAGIAAAGIAAAFIAAADQAAABAAAAQgBABAAAAQAAABgBAAQAAAAgBABIAAgHIAAgIIAAgDIgDgEIgBADIABADIABAEIgBADIABADIgBACIgBADIACACIgDACQAAAAgBgBQAAAAAAAAQAAgBgBAAQAAAAAAABgAAHAlIgEgBIgCgBIgBgDIAAgEIABgDIgCgDIACgEQAAAAAAAAQABgBAAAAQABAAAAAAQABAAAAgBIADgBIADgCQACgDADgCQADgCAAgEQADgBACgCIAEgIIABgHIgCgKIgDgLIgEgJIgCgBIgBgCIgFgGQgCgCgEAAQgFAAgBgEQgDgDABgFIAAgCQABAAAAgBQAAAAAAAAQAAAAAAgBQAAAAAAAAIACgCIAAgDIAEgBIADAAIACABQACACADABIAFAAIAEACIAEABIACABIABAAQACADADABQAEABACACQAAAAABAAQAAAAABAAQAAABABAAQAAAAAAAAIACADIAEACIAEAEQACACABAEQAAAAABAAQAAABABAAQAAABAAAAQABABAAAAQABADACACQACABABAEIACAJIABAHIAAAGIgBAGQAAABAAABQgBAAAAABQAAAAAAABQAAAAAAABQAAABAAAAQAAABgBAAQAAAAAAAAQAAABgBAAIgDAFIgBADIgCAFIgIAFIgBACIgCAAIgCACIgCABIgCAAIgBgBIgCACIgFACIgCACIABABIACgBIAAACIgFAAIgFAAIgCgCIgDADQgBAAAAAAQAAAAAAABQgBAAAAABQAAAAAAABIgCAAIgCABIgBgBIgBAAIgCABIgBABIgCAAg");
	this.shape_3.setTransform(-27.375,1.95);

	this.instance = new lib.Symbol53();
	this.instance.setTransform(-149,-361.1,1.2209,1.2164);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).to({state:[{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape},{t:this.instance}]},1).wait(1));

	// Layer_3
	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("rgba(255,255,255,0.008)").s().p("Al1CzIAAllILrAAIAAFlg");

	this.timeline.addTween(cjs.Tween.get(this.shape_4).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-158.4,-363.5,195.8,381.4);


(lib.BangClip = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_6 = function() {
		/* x = Number(_parent._name) - y;
		
		with (_root) {
			// Move this block and every block above down
			for (var j=y; j>0; j-=10) {	
				drawBlock(flag_array[x+j] = flag_array[x+j - 10], x+j);
			}
			if (!x) simult--;
		
			// Resume game if no more lines
			if (!simult) {
				drawNextShape();
				drawThisShape();
				startFall();
			}
		}*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(6).call(this.frame_6).wait(1));

	// Flash
	this.instance = new lib.Square("single",0);
	this.instance.setTransform(0,0,2,2);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({_off:true},1).wait(1).to({_off:false},0).to({_off:true},1).wait(1).to({_off:false},0).to({_off:true},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10,-10,20,20);


(lib.ArrowButton = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Arrow
	this.instance = new lib.Arrow("single",0);

	this.instance_1 = new lib.Square("single",0);
	this.instance_1.setTransform(0,0,5,5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},1).to({state:[{t:this.instance_1}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-25,-25,50,50);


(lib.Symbol59 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Symbol52();
	this.instance.setTransform(0,0,0.6501,0.6524);
	new cjs.ButtonHelper(this.instance, 0, 1, 2, false, new lib.Symbol52(), 3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Symbol59, new cjs.Rectangle(-47.5,-278.3,72.1,338.6), null);


(lib.QuitMenu = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.noBtn = new lib.NoButton();
	this.noBtn.setTransform(37.2,41.15);
	new cjs.ButtonHelper(this.noBtn, 0, 1, 2, false, new lib.NoButton(), 3);

	this.yesBtn = new lib.YesButton();
	this.yesBtn.setTransform(-27.75,41.15);
	new cjs.ButtonHelper(this.yesBtn, 0, 1, 2, false, new lib.YesButton(), 3);

	this.instance = new lib.Square("single",0);
	this.instance.setTransform(0,0.5,17.9779,18.6284);
	this.instance.alpha = 0.7813;

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FF0000").s().p("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");
	this.shape.setTransform(6.925,-24.825);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance},{t:this.yesBtn},{t:this.noBtn}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.QuitMenu, new cjs.Rectangle(-89.9,-92.6,179.8,186.3), null);


(lib.Next5Clip = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Next5Button();
	new cjs.ButtonHelper(this.instance, 0, 1, 2, false, new lib.Next5Button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Next5Clip, new cjs.Rectangle(-43.1,-12,85.4,26.4), null);


(lib.Last5Clip = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.Last5Button();
	new cjs.ButtonHelper(this.instance, 0, 1, 2, false, new lib.Last5Button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Last5Clip, new cjs.Rectangle(-42.1,-12,87.6,26.4), null);


(lib.InstructionsMenu = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_2
	this.backButton = new lib.BigPlayButton();
	this.backButton.setTransform(90.3,46.4,0.8721,0.8721);
	new cjs.ButtonHelper(this.backButton, 0, 1, 1);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgCAIIgLgIQAFgIAJgBIAOABQACASgLAAQgDAAgFgCg");
	this.shape.setTransform(5.1141,-248.4342,0.2493,0.2493);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#000000").s().p("AAbCtQgCgxgxADQhMgRhNA3QAMgnAFgVQAJgmgRgZQgbgbgugDQgogCgoAOQgSAFgtAiQgmAdgfAAQAKgcAVgcIApg1QgRgLATgaQARgYgfgLQhtAUhGAJQhlAOhNAAQDYh6B3gpQDNhIC0AoQgWBBAYA4QAZA6A7ADQACATgDAbQABATAUASIBzg+IARBHQAsAGAqgaQAZgOAuglIAmiDIBpAdQBFATAmAQQB4AzAQBgQgCANgDAvQgHAsgUAIQgJghgbgwQgmhCgmgPQg4AAgwAXQgzAZgcAsIAAArQgOgCgTgPIgjgeQgtgjgnAeQgnAphZA3IiMBWQAYgvgBglg");
	this.shape_1.setTransform(14.065,-245.1516,0.2493,0.2493);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AAMDqQALgpgBgGQABgkgKgIQgIgGgTAAQhFgOhIAyIgaAFIANg7QAJgZABgMQACgTgKgOQgWgXgpgCQglgCgmANQgLADgOAJIgXARQgXATgPAIQgYANgZAAIgXAAIAIgUQAJgYANgVQAIgMATgYIATgZIgGgJIAAgFQgBgNANgQIAGgIIgIgEQhrAThIAKQhjANhNAAIg6AAIBbg0QDGhvBtglQC8g/CsAmIA2gLIgQA7IAWBeQAOAmAhACIAOgCIABAwIgCALQABAMAKAKIB5hCIASBPQAeACAegQQASgJAigaIAUgQIAvieIBhAiQCMAlAoAVQBcAuAOBWIgIAtQAAALACAFQgBAGgKAhIgFAGIgvBWQAAgagOgvQgNgwgLgPQgWgcgKgLQgUgUgTgJQgzABgrAWQgtAWgZAlIAAA2IgRgCQgOgBgRgKQgJgHgSgPQgbgZgPgFQgTgHgVAPQgdAfgsAeQgcATg2AfIiBBSQgIgIAIghg");
	this.shape_2.setTransform(13.7284,-245.0611,0.2493,0.2493);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("AhkA0QglgBgMgCIAQgGQgEABADgIQACgIgFACQAagfAigKQAQgFAlgIQAfgYAzgKQAugJAuAEQg6AVgcAEIACAPQgWgLgfAHQgaAGgpAWQgHgBgaAMQgbAMgGAAQAUAFAVALQAbANAHANQgTgKgkgEg");
	this.shape_3.setTransform(90.4515,-274.9374,0.2493,0.2493);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#000000").s().p("AlcA5QATgUARgKQAHgHAMgHQAQgJAFADQA+AhA8AHQBLALA0ggQgGgxAmgwQAUgXA8gyQBOgGBRAPQBDALBPAcIAAAXQgUANgpgGQgxgKgXgDQgqgFgUAPQgbATgDA5QgRgUgcgCQggAAgDAfQAAACAGAJQAIAJgBAGQgBAFgCAHIgGALQgDANAEAVQAFAUAJALQgIADgQgFQgVgFgEABIgOgBQgIAAgGgCQgFgBgDgDIgIgJQgRgQgUAEQgLACgXAJQgWAJgLABIgqACQgZAAgQAFIgSANQgNAJgFgBQgGAAgJgLQgKgOgFgBQgQgKgdABQg2gBgbAOQgHADgJAIIgOAMQAJgtAlgsg");
	this.shape_4.setTransform(73.2592,-234.5664,0.2493,0.2493);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AmzCdIAAgUQAFgwAngrQAmgoAwgRIAHgCIAGADQArAXAyALQBNARA2gcIAAgEQAAguAkgtQAWgbAzgqIANgVIANgCQBlgJBvAkQAkALAxATQAVAIATAQQAMALAVAYQgSgMgTABQgUABgQALQgRALgegCIgxgJQgigHgPgBQgagCgNALQgTAPgDAvIgDAsIgbgjQgGgIgNgEQgNgFgIACQgEABgEAKQAMAPgEAVQgHAhABAGQABATAKASQALAUAQAIIg5gKQgigFgYgIIgMgBQgIAAgEgCQgDgBgDgFQgEgFgDgCQgIgEgOAEIgUAJQgjAOgOACQgIABgPgCIgWAAQg4AFgQAjQgGgfgkgKQgdgIgkAGQggAGgRAHQgZALgPAUQACgHgBgNg");
	this.shape_5.setTransform(73.9449,-234.518,0.2493,0.2493);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("AgGAHIAAgNIANAAIAAANg");
	this.shape_6.setTransform(101.7031,-250.7799,0.2493,0.2493);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFFF").s().p("AgGAKIAAgSIANAAIAAASg");
	this.shape_7.setTransform(93.2566,-253.0801,0.2493,0.2493);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#000000").s().p("AmpA+QA6hDB+iGQAlgGAqAUQANAFA/AmQAuAcAhAHQAtAKAsgXQAwghAWgxQAYg1gNg5QDNgyDLAyIAAAXQhGgQhBAbQg6AZguA2QADAHgDASQAAAQAPAGQgPAUgUACQgMACgZgGQgxgMgQAkQgRAtADA2IAJBhQgQgTgbgSIg6ghQgagDgHADQgIADgNAUQhAgighgOQg6gYgvAaQgdAVgNA9QgNBAgZAXQgOgug0gJQgKgChUAAQgxAqglAYQgvAfguAQQAuhjBkh1g");
	this.shape_8.setTransform(97.7074,-250.7394,0.2493,0.2493);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#FFFFFF").s().p("ApvEUQAmhVBLheQAtg4BkhrIBOhVIAogkQASASApARQA1AXARAKQAbARAvAhQAnAUAogUQAvggATguQATgvgMgyIgDgRIAvgbQBmgYBgABQBaABBrAaIBeBHIhaAKIgUgFQg7gOg5AWQg5AVgvAzIABALIgBAIQAAAEAEABIATAJIgLARQgSAagcADQgQACgagHQgXgFgHACQgLADgGAPQgMAiALA2QAHAggBAXIgGBIQgTgJgUgMQgmgWgDgJQgCgLgKABQgQACgHgEIgegGQgKgCgGAKIgHAMIhFghQgsgZgVgFQgjgJgdARQgQAMgJAVQgGANgFAdQgIAigFAOQgLAcgTARIgTARIgIgYQgLgfgegKQgWgHg2ACIgWABQgyAqgmAYQguAegsAQIgmANg");
	this.shape_9.setTransform(98.6424,-250.8495,0.2493,0.2493);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#FFFFFF").s().p("AgGAHIAAgNIANAAIAAANg");
	this.shape_10.setTransform(75.1854,-259.8248,0.2493,0.2493);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#FFFFFF").s().p("AgIAJIAAgRIARAAIAAARg");
	this.shape_11.setTransform(71.4826,-262.1126,0.2493,0.2493);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#FFFFFF").s().p("AAAAQQgKgBgFgJIAggWIAAAgIgMABIgFgBg");
	this.shape_12.setTransform(88.3196,-263.4353,0.2493,0.2493);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#FFFFFF").s().p("AgIAKIAAgTIARAAIAAATg");
	this.shape_13.setTransform(70.6598,-265.5099,0.2493,0.2493);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#FFFFFF").s().p("AgBgLIAMAAIgWAXg");
	this.shape_14.setTransform(89.9652,-265.566,0.2493,0.2493);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#FFFFFF").s().p("AgIAJIAAgSIARAAIAAASg");
	this.shape_15.setTransform(92.1408,-266.3327,0.2493,0.2493);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("#FFFFFF").s().p("AgLAHIALgHQAGgGAGAAIAAANg");
	this.shape_16.setTransform(71.545,-266.2704,0.2493,0.2493);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("#FFFFFF").s().p("AAgAOIgPgKQgggUgSANQAOgRAUALQAdAOACAAQAEAJgDAAIgBAAg");
	this.shape_17.setTransform(97.5656,-271.386,0.2493,0.2493);

	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f("#FFFFFF").s().p("AgqgHIBGALIgRACIgUACQghAAAAgPgAAcAEIAMgBQAIgBgMAEgAAcAEg");
	this.shape_18.setTransform(101.2017,-276.1168,0.2493,0.2493);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f("#FFFFFF").s().p("AhDAAQAWgLAsABQA9ACAIgBQgnALgYAFQgPAEgOAAQgZAAgSgLg");
	this.shape_19.setTransform(97.2461,-276.2933,0.2493,0.2493);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f("#000000").s().p("AwGHdQAcg1AFgaQAqiiCuihICXiBQBahOAzg5QAhgFALAUQAIAMABAmQACAqAHASQALAgAfAMQAUAUAqARQAXAJAuAOQASgDgCglQgCgnAFgCQAUgIA/AlQBAAkAfgMIBChwQANAJAOAYIAXAnQAeApAqghQA5gigMhJQgYhTACgkQgKgbgsg6QgngygFgnQCuiDEXgBQDxgBDpBbIA4BCQgmgCg8gNIhkgWQh4gVhEAwQgFAsAYBBQAaBKACAiQgiANgigfQgqglgRgCIhFgXQgqgOgjAAQgkAbAAA8QAAATAMBNQAKAXAcAbQAXAXAeAUQgSgDhWgaQhJgWgjAAQgiAQgFA+QgFA1APAlQgJAPgmgQQgmgPglgjQgWgDgXAYQgQARgOAcQAAAyAVBIIAjB2QgpgJgrgvQgsg5gWgXQhLgzglgQQhDgdg4APQgZAcABAgQAAAKAKA1QgQgMgegFIg0gHQhBgKgQguQgngHgfAQQggAPgLAgQgJAhAQA6QAPA3gMAdQgZg6hAgfQhBggg+ARQhEArhCBCQhDBCgjA8QgdgcAUgwg");
	this.shape_20.setTransform(84.0568,-263.5838,0.2493,0.2493);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f("#FFFFFF").s().p("AwiIxQgRgwABgaQABgTAPgfIAahOQAfh5BghlQAagcCmiNQBAg2AhgeQA0gwAlgpIAEgFIAGgBQAFgBAggKQAXgHAHAGQAMAJgCAiIgEA0QACAnAGAQQAIAXAYAJIADACIACACQANANATAGQAMAEAbAFIAgAIQADgFAKgjQAIgbAJgDQARgHAeAVIAwAhQAaAMAOADQAWAGARgEIBHh6IAPAKQALAIAKAPQAGAIAMAVIARAbQAJANAIABQAJACAVgPQAngXAAgrQAAgbgMgpQgLgyAAgVIAAgDQgHgRgMgTIgZghQgYgfgKgRQgRgdgEgeIgCgJIgfgUQDth0EUgHQELgGDLBiIAEACIBsBdIg/AEQgugChUgUQhVgTgpgCQhCgCguAdIgBAJQAAAWAHAaQAEAQALAeQAMAgAtBNIARAFQggANg3gLQgzgLgRgRQgNgMgGgEQgLgIgMgBIgogOQg2gVgogCQgaAZAAAtQAAAZAJAwIADARIAUAcQAIAJAUARQAPAPAAANIAgANQAeALgJAFIhNAAQg4gIgagPQgegSg8gDQgQAJgJAYQgGANgIAgQgEAVAWAlQAMAUAQAWQAIAPhLgbQhMgcgagXQgNABgPAQQgNAOgLAWQABAjAJApQAHAbAPAxIAwCBIgtgcQglgIgjghQgUgUglgtIgagiIgIgFQhCgrgjgPQg8gagvALQgRAWAAAWQAAAQAGAaIANA9IgkgaQgLgIgTgFQgMgCgZgDQgogFgWgJQgigPgQgfQgegDgYAMQgZANgHAXQgGASADAWQABAOAIAbQAIAeABAQQADAagJAXIADBEIgQgkQgkhKg+gjQg6ghg2APQhCAphBBAQhBBBgiA7IgLATg");
	this.shape_21.setTransform(84.6909,-263.464,0.2493,0.2493);

	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f("#FFFFFF").s().p("AhNBMIAAiXICbAAIAACXg");
	this.shape_22.setTransform(-169.982,-24.1543,0.2493,0.2493);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f("#FFFFFF").s().p("AhNBMIAAiXICbAAIAACXg");
	this.shape_23.setTransform(-162.5017,-20.4017,0.2493,0.2493);

	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f("#FFFFFF").s().p("AhNBNIAAiZICbAAIAACZg");
	this.shape_24.setTransform(-166.2418,-24.1419,0.2493,0.2493);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f("#FFFFFF").s().p("AhMBOIAAibICYAAIAACbg");
	this.shape_25.setTransform(-111.0807,-125.1729,0.2493,0.2493);

	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f("#FFFFFF").s().p("AhLBOIAAibICXAAIAACbg");
	this.shape_26.setTransform(-103.4882,-132.6532,0.2493,0.2493);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f("#FFFFFF").s().p("AhMBOIAAibICYAAIAACbg");
	this.shape_27.setTransform(-107.2284,-128.9131,0.2493,0.2493);

	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f("#FFFFFF").s().p("AhNBMIAAiXICbAAIAACXg");
	this.shape_28.setTransform(-101.0758,-219.7241,0.2493,0.2493);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f("#FFFFFF").s().p("AhNBMIAAiXICbAAIAACXg");
	this.shape_29.setTransform(-93.6017,-219.7241,0.2493,0.2493);

	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.f("#FFFFFF").s().p("AhMBMIAAiXICZAAIAACXg");
	this.shape_30.setTransform(-97.3419,-223.4643,0.2493,0.2493);

	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.f("#999999").s().p("AgJAYIAAgSIATAAIAAASgAgJgEIAAgTIATAAIAAATg");
	this.shape_31.setTransform(-34.725,-30.8);

	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.f("#999999").s().p("AAAAZQgJAAgFgCQgGgDgDgGQgEgGAAgIQABgKAHgHQAHgHAMAAQAKAAAGAEQAGADADAGQADAGAAAIIAAACIgkAAQAAAEACACQADADADAAIAFAAIAEgDIASABQgEAIgGADQgFACgJAAIgDAAgAgGgKQgCADAAAEIARAAQAAgFgCgCQgDgDgDAAQgEAAgDADg");
	this.shape_32.setTransform(-39.375,-30.8714);

	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.f("#999999").s().p("AAWAZIAAgbIgBgFQgBgCgDAAQgDAAgDACQgCADAAAEIAAAZIgRAAIAAgaIgBgEIgCgDQAAgBAAAAQAAAAgBAAQAAgBgBAAQAAAAgBAAQgDAAgCADQgDACAAAFIAAAYIgSAAIAAgvIASAAIAAAHQADgEAEgCQAEgCAFAAQAGAAADACIAFAHQAEgFAEgCQAEgCAFAAQAIAAAEAFQAEAFAAAJIAAAeg");
	this.shape_33.setTransform(-47.1475,-30.925);

	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.f("#999999").s().p("AgWAVQgFgEAAgGQAAgFADgEQAEgCAIgCIANgDIAGgBQABgEgCgBQgBgCgEAAQgDAAgCABIgEAFIgRgCIADgHQACgDADgCQADgCAEAAIAKgBIAMABQAFABAEADQACACABAEQACAEgBADIAAAUIABAGIACAFIgSAAIgBgDIgBgDQgDADgEABQgEACgGAAQgJAAgEgEgAAAAEQgFABgCACQAAAAAAABQgBAAAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABABAAQAAAAAAABQABAAAAAAQABABAAAAQABAAAAAAQABAAABAAQACAAACgBQADgBABgDIABgFIAAgDIgHACg");
	this.shape_34.setTransform(-54.875,-30.975);

	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.f("#999999").s().p("AAAAiQgOAAgFgEQgGgEAAgIIAAgCIASACIACADQADACACAAQAEAAACgCQACgCAAgFIAAgIQgDAEgDABQgDACgFAAQgKAAgGgJQgEgFAAgJQABgMAFgGQAFgGAJAAQAGAAADACQADADADAEIAAgHIASAAIgBAtIAAACQAAAEgCAEIgFAHQgDADgFABIgHABIgEgBgAgFgSQgCADAAAGQAAAFACADQACABADAAQADAAACgBQADgDAAgFQAAgFgDgDQgCgDgDAAQgDAAgCACg");
	this.shape_35.setTransform(-61.175,-30.0917);

	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.f("#999999").s().p("AgEAgQgDgCgCgDQgBgEAAgIIAAgQIgHAAIAAgNIAHAAIAAgJIASgKIAAATIAKAAIAAAOIgKgBIgBAQIABAEQAAABAAAAQABAAAAAAQAAABABAAQAAAAABAAIAGgBIABANIgNABQgGAAgDgCg");
	this.shape_36.setTransform(-69.375,-31.925);

	this.shape_37 = new cjs.Shape();
	this.shape_37.graphics.f("#999999").s().p("AgIAhIAAgvIARAAIAAAvgAgIgUIAAgMIARAAIAAAMg");
	this.shape_37.setTransform(-72.975,-32.025);

	this.shape_38 = new cjs.Shape();
	this.shape_38.graphics.f("#999999").s().p("AgUAUQgFgFAAgJIABgeIASAAIAAAaQAAAEABACQACACADAAQACAAADgCQACgCAAgGIAAgXIATAAIgBAvIgRAAIAAgIQgEAFgEABQgDADgGAAQgHAAgEgFg");
	this.shape_38.setTransform(-77.625,-31.1);

	this.shape_39 = new cjs.Shape();
	this.shape_39.graphics.f("#999999").s().p("AAWAhIgGgFQgHADgJAAQgPAAgJgIQgLgJAAgQQABgRAJgJQAJgJAQABQAQAAAJAIQAJAJgBARQAAAOgHAJIAFADIAFACIgGAMIgIgFgAADAQQgDgDgEgCIADgIIADACIAGADIACACQADgEAAgIQAAgKgDgFQgEgEgGAAQgGAAgEAEQgDAEAAAKQgBAKAEAEQADAEAHABIADAAIAAAAg");
	this.shape_39.setTransform(-84.525,-31.7513);

	this.shape_40 = new cjs.Shape();
	this.shape_40.graphics.f("#999999").s().p("AgJAYIAAgSIATAAIAAASgAgJgEIAAgTIATAAIAAATg");
	this.shape_40.setTransform(-34.575,-46.2);

	this.shape_41 = new cjs.Shape();
	this.shape_41.graphics.f("#999999").s().p("AAAAZQgJAAgFgCQgGgDgDgGQgEgGAAgIQABgKAHgHQAHgHAMAAQAKAAAGAEQAGADADAGQADAGAAAIIAAACIgkAAQAAAEACACQADADADAAIAFAAIAEgDIASABQgEAIgGADQgFACgJAAIgDAAgAgGgKQgCADAAAEIARAAQAAgFgCgCQgDgDgDAAQgEAAgDADg");
	this.shape_41.setTransform(-39.225,-46.2714);

	this.shape_42 = new cjs.Shape();
	this.shape_42.graphics.f("#999999").s().p("AAWAZIAAgbIgBgFQgBgCgDAAQgDAAgDACQgCADAAAEIAAAZIgRAAIAAgaIgBgEIgCgDQAAgBAAAAQAAAAgBAAQAAgBgBAAQAAAAgBAAQgDAAgCADQgDACAAAFIAAAYIgSAAIAAgvIASAAIAAAHQADgEAEgCQAEgCAFAAQAGAAADACIAFAHQAEgFAEgCQAEgCAFAAQAIAAAEAFQAEAFAAAJIAAAeg");
	this.shape_42.setTransform(-46.9975,-46.325);

	this.shape_43 = new cjs.Shape();
	this.shape_43.graphics.f("#999999").s().p("AgWAVQgFgEAAgGQAAgFADgEQAEgCAIgCIANgDIAGgBQABgEgCgBQgBgCgEAAQgDAAgCABIgEAFIgRgCIADgHQACgDADgCQADgCAEAAIAKgBIAMABQAFABAEADQACACABAEQACAEgBADIAAAUIABAGIACAFIgSAAIgBgDIgBgDQgDADgEABQgEACgGAAQgJAAgEgEgAAAAEQgFABgCACQAAAAAAABQgBAAAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABABAAQAAAAAAABQABAAAAAAQABABAAAAQABAAAAAAQABAAABAAQACAAACgBQADgBABgDIABgFIAAgDIgHACg");
	this.shape_43.setTransform(-54.725,-46.375);

	this.shape_44 = new cjs.Shape();
	this.shape_44.graphics.f("#999999").s().p("AAAAiQgOAAgFgEQgGgEAAgIIAAgCIASACIACADQADACACAAQAEAAACgCQACgCAAgFIAAgIQgDAEgDABQgDACgFAAQgKAAgGgJQgEgFAAgJQABgMAFgGQAFgGAJAAQAGAAADACQADADADAEIAAgHIASAAIgBAtIAAACQAAAEgCAEIgFAHQgDADgFABIgHABIgEgBgAgFgSQgCADAAAGQAAAFACADQACABADAAQADAAACgBQADgDAAgFQAAgFgDgDQgCgDgDAAQgDAAgCACg");
	this.shape_44.setTransform(-61.025,-45.4917);

	this.shape_45 = new cjs.Shape();
	this.shape_45.graphics.f("#999999").s().p("AAAAZQgJAAgFgCQgGgDgDgGQgEgGAAgIQABgKAHgHQAHgHAMAAQAKAAAGAEQAGADADAGQADAGAAAIIAAACIgkAAQAAAEACACQADADADAAIAFAAIAEgDIASABQgEAIgGADQgFACgJAAIgDAAgAgGgKQgCADAAAEIARAAQAAgFgCgCQgDgDgDAAQgEAAgDADg");
	this.shape_45.setTransform(-70.275,-46.5214);

	this.shape_46 = new cjs.Shape();
	this.shape_46.graphics.f("#999999").s().p("AAAAZQgMAAgGgDQgFgEgCgHIASgCIAEAFQACABACAAIAGgBIABgDQAAAAAAgBQAAAAAAgBQAAAAgBAAQAAgBgBAAQgBgBgGgBIgMgDQgEgCgDgCQgDgEABgEQAAgFACgDQAEgEAFgBQAEgCAHAAQAJAAAEACIAHAEIAEAHIgRACIgCgEQgDgBgCAAQAAAAgBAAQgBAAAAAAQgBAAAAAAQgBAAAAABQAAAAgBAAQAAABAAAAQAAAAAAABQAAAAAAABIABACIAHACQAJABAEACQAFACACADQADADgBAEQABAEgDAEQgCAEgGADQgEABgHAAIgEAAg");
	this.shape_46.setTransform(-76.25,-46.52);

	this.shape_47 = new cjs.Shape();
	this.shape_47.graphics.f("#999999").s().p("AgUAUQgFgFAAgJIABgeIASAAIAAAaQAAAEABACQACACADAAQACAAADgCQACgCAAgGIAAgXIATAAIgBAvIgRAAIAAgIQgEAFgEABQgDACgGABQgHAAgEgFg");
	this.shape_47.setTransform(-82.125,-46.5);

	this.shape_48 = new cjs.Shape();
	this.shape_48.graphics.f("#999999").s().p("AgWAVQgFgEAAgGQAAgFADgEQAEgCAIgCIANgDIAGgBQABgEgCgBQgBgCgEAAQgDAAgCABIgEAFIgRgCIADgHQACgDADgCQADgCAEAAIAKgBIAMABQAFABAEADQACACABAEQACAEgBADIAAAUIABAGIACAFIgSAAIgBgDIgBgDQgDADgEABQgEACgGAAQgJAAgEgEgAAAAEQgFABgCACQAAAAAAABQgBAAAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABABAAQAAAAAAABQABAAAAAAQABABAAAAQABAAAAAAQABAAABAAQACAAACgBQADgBABgDIABgFIAAgDIgHACg");
	this.shape_48.setTransform(-88.375,-46.625);

	this.shape_49 = new cjs.Shape();
	this.shape_49.graphics.f("#999999").s().p("AgbAhIAAhBIAiAAQAKAAAGAFQAFAGAAAKQAAAKgGAEQgGAGgNAAIgKAAIAAAYgAgGgEIAFAAQAFABADgCQACgDAAgDQAAgDgCgCQgCgCgFgBIgGAAg");
	this.shape_49.setTransform(-94.55,-47.575);

	this.shape_50 = new cjs.Shape();
	this.shape_50.graphics.f("#999999").s().p("AgJAYIAAgSIATAAIAAASgAgJgFIAAgSIATAAIAAASg");
	this.shape_50.setTransform(-34.475,-61.625);

	this.shape_51 = new cjs.Shape();
	this.shape_51.graphics.f("#999999").s().p("AgEAgQgEgCgBgDQgCgEAAgIIABgQIgHAAIAAgNIAHAAIAAgJIARgKIAAATIALAAIAAANIgLAAIAAAQIAAAFQABAAAAAAQAAAAABABQAAAAABAAQAAAAABAAIAFgBIACANIgNABQgGAAgDgCg");
	this.shape_51.setTransform(-38.15,-62.55);

	this.shape_52 = new cjs.Shape();
	this.shape_52.graphics.f("#999999").s().p("AAHAZIAAgaQAAgFgCgBQAAgBAAAAQgBgBAAAAQgBAAAAAAQgBgBgBAAQgCAAgDADQgCACAAAGIAAAXIgTAAIABgvIARAAIAAAIQAEgFADgCQAEgCAGAAQAIAAAEAFQAEAEAAAKIAAAeg");
	this.shape_52.setTransform(-43.3725,-61.725);

	this.shape_53 = new cjs.Shape();
	this.shape_53.graphics.f("#999999").s().p("AAAAZQgJAAgFgCQgGgDgDgGQgEgGAAgIQABgKAGgHQAIgHAMAAQAKAAAGADQAGADADAGQADAGAAAJIAAACIglAAIADAGQADADADAAQADABACgBIADgEIATACQgEAHgGAEQgFACgJAAIgDAAgAgFgKQgCACgBAFIARAAQAAgFgCgDQgDgCgEAAQgDAAgCADg");
	this.shape_53.setTransform(-49.6,-61.7714);

	this.shape_54 = new cjs.Shape();
	this.shape_54.graphics.f("#999999").s().p("AABAZQgGAAgFgBQgGgCgDgDQgEgDgCgEQgCgFAAgHQAAgGADgFIAFgHIAHgEQAFgCAHAAQAMAAAHAEQAGAFACAIIgSACQAAgDgCgCIgGgCQgEAAgDAEQgCADAAAGQAAAGACADQADADADAAQAEAAADgCQACgBABgEIASACQgCAFgCAEQgEAEgFADQgEABgGAAIgEAAg");
	this.shape_54.setTransform(-55.85,-61.82);

	this.shape_55 = new cjs.Shape();
	this.shape_55.graphics.f("#999999").s().p("AAAAZQgMAAgGgDQgFgEgCgHIATgCQABADACACQACABACAAIAGgBIACgDQAAAAAAgBQgBAAAAgBQAAAAAAgBQgBAAAAAAIgHgCIgOgEQgEgBgCgCQgDgEABgEQAAgFACgEQADgDAFgCQAFgBAHAAIANABIAHAEIAFAIIgSACQAAgBgBgBQAAAAAAgBQAAAAgBgBQAAAAAAAAQgDgCgCAAIgEABIgCADQAAABAAAAQAAABABAAQAAAAAAAAQAAABABAAIAHACQAJABAEACQAFACACACQADAEAAAEQAAAEgDAEQgCAEgGADQgEABgHAAIgEAAg");
	this.shape_55.setTransform(-61.875,-61.82);

	this.shape_56 = new cjs.Shape();
	this.shape_56.graphics.f("#999999").s().p("AAAAZQgJAAgFgCQgGgDgDgGQgEgGAAgIQABgKAGgHQAIgHAMAAQAKAAAGADQAGADADAGQADAGAAAJIAAACIgkAAIACAGQADADADAAQADABACgBIAEgEIASACQgEAHgGAEQgFACgJAAIgDAAgAgFgKQgCACgBAFIARAAQgBgFgBgDQgCgCgEAAQgEAAgCADg");
	this.shape_56.setTransform(-67.85,-61.8714);

	this.shape_57 = new cjs.Shape();
	this.shape_57.graphics.f("#999999").s().p("AgVAaQgFgHAAgLQABgLAFgHQAGgGAJAAQAEAAACACQAEABADADIAAgXIATAAIgBBCIgRAAIAAgHQgEAFgDABQgDACgFAAQgJAAgGgIgAgGAAQgCACAAAHQAAAGACACQADADADAAQADAAADgCQACgDAAgGQgBgGgCgDQgCgCgDAAQgCAAgEACg");
	this.shape_57.setTransform(-74.2,-62.775);

	this.shape_58 = new cjs.Shape();
	this.shape_58.graphics.f("#999999").s().p("AAAAZQgJAAgGgCQgFgDgEgGQgDgGAAgIQABgKAGgHQAIgHAMAAQAKAAAGADQAGADAEAGQACAGAAAJIAAACIgkAAIACAGQADADADAAQADABACgBIAEgEIASACQgEAHgGAEQgFACgJAAIgDAAgAgGgKQgCACAAAFIARAAQgBgFgBgDQgCgCgEAAQgEAAgDADg");
	this.shape_58.setTransform(-83.5,-62.0214);

	this.shape_59 = new cjs.Shape();
	this.shape_59.graphics.f("#999999").s().p("AgaAiIABhCIARAAIAAAHQAEgFADgBQADgCAFAAQAKAAAFAHQAFAIAAALQAAALgGAGQgGAHgJAAQgEAAgCgCIgHgEIAAAXgAgEgRQgDADAAAGQAAAGADACQACACADAAQADABACgDQACgBAAgHQAAgGgCgCQgCgDgDgBQgDAAgCADg");
	this.shape_59.setTransform(-89.6727,-61.18);

	this.shape_60 = new cjs.Shape();
	this.shape_60.graphics.f("#999999").s().p("AgXAVQgEgEAAgGQAAgFADgEQAEgCAIgCIANgDIAHgCQAAgDgCgCIgEgBQgEAAgDABQgCABgBADIgRgBIACgIQACgDAEgBIAHgDIAKAAIAMABQAFABAEADIADAGQACAEAAADIAAAUIAAAGIACAFIgRAAIgCgDIAAgDQgEADgEABQgEACgGAAQgJAAgFgEgAAAAEQgGABgBACQAAAAgBABQAAAAAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQABAAAAABQAAAAABAAQAAABABAAQAAAAABAAQABAAAAAAQADAAACgCQABAAABAAQAAgBABAAQAAAAAAgBQABAAAAgBQACgCAAgDIAAgDIgIACg");
	this.shape_60.setTransform(-96.1,-62.075);

	this.shape_61 = new cjs.Shape();
	this.shape_61.graphics.f("#999999").s().p("AAHAiIAAgbQAAgFgCgBQAAgBAAAAQgBAAAAAAQgBAAAAAAQgBgBgBAAQgCAAgDACQgCACAAAHIAAAXIgTAAIABhCIATAAIAAAZQADgEADgCIAJgBQAIAAAEAFQAEAEAAAJIAAAfg");
	this.shape_61.setTransform(-102.3725,-63.025);

	this.shape_62 = new cjs.Shape();
	this.shape_62.graphics.f("#999999").s().p("AAAAZQgMAAgGgDQgFgEgCgHIATgCQABADACACQACABACAAIAGgBIACgDQAAAAAAgBQAAAAgBgBQAAAAAAgBQgBAAAAAAIgHgCIgOgEQgEgBgCgCQgDgEABgEQAAgFACgEQADgDAFgCQAFgBAHAAIANABIAHAEIAFAIIgSACQAAgBgBgBQAAAAAAgBQAAAAgBgBQAAAAAAAAQgDgCgCAAIgEABIgCADQAAABAAAAQAAABABAAQAAAAAAAAQAAABABAAIAHACQAJABAEACQAFACACACQADAEAAAEQAAAEgDAEQgCAEgGADQgEABgHAAIgEAAg");
	this.shape_62.setTransform(-108.375,-62.17);

	this.shape_63 = new cjs.Shape();
	this.shape_63.graphics.f("#999999").s().p("AAAAZQgJAAgFgCQgGgDgDgGQgEgGAAgIQABgKAGgHQAIgHAMAAQAKAAAGADQAGADADAGQADAGAAAJIAAACIglAAIADAGQADADADAAQADABACgBIADgEIATACQgEAHgGAEQgFACgJAAIgDAAgAgFgKQgCACgBAFIARAAQAAgFgCgDQgCgCgEAAQgEAAgCADg");
	this.shape_63.setTransform(-117.45,-62.2714);

	this.shape_64 = new cjs.Shape();
	this.shape_64.graphics.f("#999999").s().p("AgEAgQgEgBgBgEQgCgEAAgIIABgQIgHAAIAAgOIAHAAIAAgJIASgJIAAASIAKABIAAAOIgKgBIgBAQIABAEQAAABAAAAQAAAAABABQAAAAABAAQAAAAABAAIAGgBIABANIgNABQgGAAgDgCg");
	this.shape_64.setTransform(-122.65,-63.15);

	this.shape_65 = new cjs.Shape();
	this.shape_65.graphics.f("#999999").s().p("AgXAVQgEgEAAgGQAAgFADgEQAEgCAIgCIANgDIAGgCQABgDgCgCIgEgBQgEAAgDABQgCABgBADIgRgBIACgIQADgDADgBIAHgDIAKAAIAMABQAFABAEADIADAGQACAEgBADIAAAUIABAGIACAFIgRAAIgCgDIAAgDQgFADgDABQgEACgHAAQgIAAgFgEgAAAAEQgGABgBACQAAAAgBABQAAAAAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQABAAAAABQAAAAABAAQAAABABAAQAAAAABAAQABAAAAAAQADAAADgCQAAAAABAAQAAgBABAAQAAAAAAgBQABAAAAgBQABgCAAgDIAAgDIgHACg");
	this.shape_65.setTransform(-127.7,-62.325);

	this.shape_66 = new cjs.Shape();
	this.shape_66.graphics.f("#999999").s().p("AgSAZIAAgwIASAAIAAAIQABgFADgCQACgCAEABQAEAAAFACIgGANIgFgBQgDAAgDADQgCAEAAAKIAAARg");
	this.shape_66.setTransform(-132.675,-62.405);

	this.shape_67 = new cjs.Shape();
	this.shape_67.graphics.f("#999999").s().p("AAAAZQgJAAgGgCQgFgDgEgGQgDgGAAgIQAAgKAIgHQAHgHAMAAQAKAAAGADQAGADAEAGQACAGAAAJIAAACIgkAAIACAGQADADADAAQADABACgBIAEgEIASACQgEAHgGAEQgFACgJAAIgDAAgAgGgKQgCACAAAFIARAAQgBgFgBgDQgDgCgDAAQgEAAgDADg");
	this.shape_67.setTransform(-138.3,-62.4214);

	this.shape_68 = new cjs.Shape();
	this.shape_68.graphics.f("#999999").s().p("AgJAhIABhBIARAAIAABBg");
	this.shape_68.setTransform(-142.95,-63.35);

	this.shape_69 = new cjs.Shape();
	this.shape_69.graphics.f("#999999").s().p("AAAAZQgJAAgGgCQgFgDgEgGQgDgGAAgIQAAgKAIgHQAHgHAMAAQAKAAAGADQAHADADAGQACAGAAAJIAAACIgkAAIACAGQADADADAAQADABADgBIADgEIASACQgEAHgGAEQgFACgJAAIgDAAgAgGgKQgCACAAAFIARAAQgBgFgBgDQgDgCgEAAQgDAAgDADg");
	this.shape_69.setTransform(-147.65,-62.4714);

	this.shape_70 = new cjs.Shape();
	this.shape_70.graphics.f("#999999").s().p("AACAZQgHAAgGgBQgEgCgEgDQgEgDgCgEQgCgFAAgHQAAgGADgFIAFgHIAHgEQAFgCAIAAQALAAAHAEQAGAFACAIIgRACQgBgDgCgCIgFgCQgFAAgCAEQgDADgBAGQABAGADADQACADAEAAQADAAACgCQADgBACgEIARACQgCAFgDAEQgDAEgFADQgEABgGAAIgDAAg");
	this.shape_70.setTransform(-153.9,-62.52);

	this.shape_71 = new cjs.Shape();
	this.shape_71.graphics.f("#999999").s().p("AACAZQgHAAgGgBQgEgCgEgDQgEgDgCgEQgCgFAAgHQAAgGADgFIAFgHIAHgEQAFgCAIAAQALAAAHAEQAGAFACAIIgRACQgBgDgCgCIgFgCQgFAAgCAEQgDADgBAGQABAGADADQACADAEAAQADAAACgCQADgBACgEIARACQgCAFgDAEQgDAEgFADQgEABgGAAIgDAAg");
	this.shape_71.setTransform(-160.2,-62.57);

	this.shape_72 = new cjs.Shape();
	this.shape_72.graphics.f("#999999").s().p("AAPAiIgDgLIgXgBIgDALIgWAAIAahCIAWABIAZBCgAgGAIIANAAIgGgXg");
	this.shape_72.setTransform(-166.95,-63.525);

	this.shape_73 = new cjs.Shape();
	this.shape_73.graphics.f("#999999").s().p("AgJAYIAAgSIATAAIAAASgAgJgEIAAgTIATAAIAAATg");
	this.shape_73.setTransform(-34.375,-77.15);

	this.shape_74 = new cjs.Shape();
	this.shape_74.graphics.f("#999999").s().p("AAAAZQgJAAgFgCQgGgDgDgGQgEgGAAgIQABgKAHgHQAHgHAMAAQAKAAAGAEQAGADADAGQADAGAAAIIAAACIgkAAQAAAEACACQADADADAAIAFAAIAEgDIASABQgEAIgGADQgFACgJAAIgDAAgAgGgKQgCADAAAEIARAAQAAgFgCgCQgDgDgDAAQgEAAgDADg");
	this.shape_74.setTransform(-39.025,-77.2214);

	this.shape_75 = new cjs.Shape();
	this.shape_75.graphics.f("#999999").s().p("AAAAZQgMAAgFgDQgGgEgCgHIASgCIAEAFQACABACAAIAGgBIACgDQAAAAgBgBQAAAAAAgBQAAAAgBAAQAAgBAAAAQgCgBgFgBIgOgDQgEgCgCgCQgCgEAAgEQAAgFADgDQACgEAGgBQAEgCAHAAQAJAAAEACIAHAEIAFAHIgSACQAAgBgBAAQAAgBAAAAQAAgBgBAAQAAgBgBAAQgCgBgCAAQAAAAgBAAQgBAAAAAAQgBAAAAAAQgBAAAAABQAAAAgBAAQAAABAAAAQAAAAAAABQgBAAAAABIABACIAHACQAKABAFACQAEACACADQACADABAEQgBAEgCAEQgCAEgGADQgEABgHAAIgEAAg");
	this.shape_75.setTransform(-45.05,-77.27);

	this.shape_76 = new cjs.Shape();
	this.shape_76.graphics.f("#999999").s().p("AgIAhIAAgvIARAAIAAAvgAgIgUIAAgMIARAAIAAAMg");
	this.shape_76.setTransform(-49.325,-78.175);

	this.shape_77 = new cjs.Shape();
	this.shape_77.graphics.f("#999999").s().p("AAKAYIgKgcIgJAcIgQAAIgSgvIASAAIAIAdIAKgdIAQAAIAJAdIAIgdIASAAIgTAvg");
	this.shape_77.setTransform(-55.25,-77.325);

	this.shape_78 = new cjs.Shape();
	this.shape_78.graphics.f("#999999").s().p("AAHAhIgIgUIgHAIIAAAMIgTAAIAAhBIATAAIAAAhIANgOIAXAAIgSAPIASAfg");
	this.shape_78.setTransform(-62.525,-78.3);

	this.shape_79 = new cjs.Shape();
	this.shape_79.graphics.f("#999999").s().p("AACAZQgHAAgFgBQgFgCgEgDQgEgDgCgEQgCgFAAgHQAAgGADgFIAFgHIAHgEQAFgCAIAAQAMAAAGAFQAGAEACAIIgRACIgDgEIgGgCQgDAAgEADQgCADAAAGQAAAGACADQADADADAAQAEAAADgBQACgCABgEIASACQgCAFgDAEQgDAEgFADQgFABgFAAIgDAAg");
	this.shape_79.setTransform(-68.825,-77.42);

	this.shape_80 = new cjs.Shape();
	this.shape_80.graphics.f("#999999").s().p("AAAAZQgLAAgHgGQgJgHAAgMQABgKAHgHQAHgHAMAAQAPAAAHAJQAGAHgBAJQAAALgHAHQgHAGgLAAIgCAAgAgGgIQgCADAAAFQAAAHACADQADADADAAQAEAAACgDQADgDAAgGQAAgGgDgDQgCgDgEAAQgDAAgDADg");
	this.shape_80.setTransform(-75.0479,-77.4733);

	this.shape_81 = new cjs.Shape();
	this.shape_81.graphics.f("#999999").s().p("AgIAhIAAhBIARAAIAABBg");
	this.shape_81.setTransform(-79.7,-78.425);

	this.shape_82 = new cjs.Shape();
	this.shape_82.graphics.f("#999999").s().p("AACAZQgHAAgFgBQgFgCgEgDQgEgDgCgEQgCgFAAgHQAAgGADgFIAFgHIAHgEQAFgCAIAAQAMAAAGAFQAGAEACAIIgRACIgDgEIgGgCQgDAAgEADQgCADAAAGQAAAGACADQADADADAAQAEAAADgBQACgCABgEIASACQgCAFgDAEQgDAEgFADQgFABgFAAIgDAAg");
	this.shape_82.setTransform(-84.075,-77.57);

	this.shape_83 = new cjs.Shape();
	this.shape_83.graphics.f("#999999").s().p("AAAAZQgJAAgFgCQgGgDgDgGQgEgGAAgIQABgKAHgHQAHgHAMAAQAKAAAGAEQAGADADAGQADAGAAAIIAAACIgkAAQAAAEACACQADADADAAIAFAAIAEgDIASABQgEAIgGADQgFACgJAAIgDAAgAgGgKQgCADAAAEIARAAQAAgFgCgCQgDgDgDAAQgEAAgDADg");
	this.shape_83.setTransform(-93.425,-77.6214);

	this.shape_84 = new cjs.Shape();
	this.shape_84.graphics.f("#999999").s().p("AgaAiIABhCIARAAIAAAHQAEgEADgCQADgCAFAAQAJAAAGAIQAFAHAAALQAAALgGAHQgGAGgJAAQgEAAgDgCIgGgEIAAAXgAgFgRQgCADAAAGQAAAGACACQADADACAAQAEAAACgDQACgBAAgHQAAgFgCgDQgCgDgDAAQgDAAgDACg");
	this.shape_84.setTransform(-99.5229,-76.7792);

	this.shape_85 = new cjs.Shape();
	this.shape_85.graphics.f("#999999").s().p("AgWAVQgFgEAAgGQAAgFADgEQAEgCAIgCIANgDIAGgBQABgEgCgBQgBgCgEAAQgDAAgCABIgEAFIgRgCIADgHQACgDADgCQADgCAEAAIAKgBIAMABQAFABAEADQACACABAEQACAEgBADIAAAUIABAGIACAFIgSAAIgBgDIgBgDQgDADgEABQgEACgGAAQgJAAgEgEgAAAAEQgFABgCACQAAAAAAABQgBAAAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABABAAQAAAAAAABQABAAAAAAQABABAAAAQABAAAAAAQABAAABAAQACAAACgBQADgBABgDIABgFIAAgDIgHACg");
	this.shape_85.setTransform(-105.925,-77.725);

	this.shape_86 = new cjs.Shape();
	this.shape_86.graphics.f("#999999").s().p("AAHAhIAAgaQAAgEgCgCQgBgBgDgBQgDAAgCACQgCADAAAGIAAAXIgTAAIABhBIASAAIAAAYQAEgEADgCQAEgBAFAAQAHAAAFAFQAEAFgBAIIAAAeg");
	this.shape_86.setTransform(-112.1472,-78.65);

	this.shape_87 = new cjs.Shape();
	this.shape_87.graphics.f("#999999").s().p("AABAZQgNAAgFgDQgGgEgBgHIASgCIADAFQACABADAAIAFgBIACgDQAAAAgBgBQAAAAAAgBQAAAAgBAAQAAgBgBAAQgBgBgFgBIgOgDQgDgCgDgCQgCgEAAgEQAAgFACgDQAEgEAEgBQAFgCAIAAQAIAAAEACIAHAEIAEAHIgRACIgDgEQgCgBgCAAQAAAAgBAAQgBAAAAAAQgBAAAAAAQgBAAAAABQAAAAgBAAQAAABAAAAQAAAAAAABQAAAAgBABIABACIAHACQAKABAFACQAEACACADQADADAAAEQAAAEgDAEQgDAEgFADQgEABgHAAIgDAAg");
	this.shape_87.setTransform(-118.15,-77.82);

	this.shape_88 = new cjs.Shape();
	this.shape_88.graphics.f("#999999").s().p("AAAAZQgJAAgFgCQgGgDgDgGQgEgGAAgIQABgKAHgHQAHgHAMAAQAKAAAGAEQAGADADAGQADAGAAAIIAAACIgkAAQAAAEACACQADADADAAIAFAAIAEgDIASABQgEAIgGADQgFACgJAAIgDAAgAgGgKQgCADAAAEIARAAQAAgFgCgCQgDgDgDAAQgEAAgDADg");
	this.shape_88.setTransform(-127.125,-77.8714);

	this.shape_89 = new cjs.Shape();
	this.shape_89.graphics.f("#999999").s().p("AgEAgQgDgCgCgDQgBgEAAgIIAAgQIgHAAIAAgNIAHAAIAAgJIASgKIAAATIAKAAIAAAOIgKgBIgBAQIABAEQAAABAAAAQABAAAAAAQAAABABAAQAAAAABAAIAGgBIABANIgNABQgGAAgDgCg");
	this.shape_89.setTransform(-132.275,-78.775);

	this.shape_90 = new cjs.Shape();
	this.shape_90.graphics.f("#999999").s().p("AgWAVQgFgEAAgGQAAgFADgEQAEgCAIgCIANgDIAGgBQABgEgCgBQgBgCgEAAQgDAAgCABIgEAFIgRgCIADgHQACgDADgCQADgCAEAAIAKgBIAMABQAFABAEADQACACABAEQACAEgBADIAAAUIABAGIACAFIgSAAIgBgDIgBgDQgDADgEABQgEACgGAAQgJAAgEgEgAAAAEQgFABgCACQAAAAAAABQgBAAAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABABAAQAAAAAAABQABAAAAAAQABABAAAAQABAAAAAAQABAAABAAQACAAACgBQADgBABgDIABgFIAAgDIgHACg");
	this.shape_90.setTransform(-137.275,-77.975);

	this.shape_91 = new cjs.Shape();
	this.shape_91.graphics.f("#999999").s().p("AgEAgQgDgCgCgDQgBgEAAgIIAAgQIgHAAIAAgNIAHAAIAAgJIASgKIAAATIAKAAIAAAOIgKgBIgBAQIABAEQAAABAAAAQABAAAAAAQAAABABAAQAAAAABAAIAGgBIABANIgNABQgGAAgDgCg");
	this.shape_91.setTransform(-142.475,-78.825);

	this.shape_92 = new cjs.Shape();
	this.shape_92.graphics.f("#999999").s().p("AAAAZQgLAAgHgGQgJgHAAgMQABgKAHgHQAHgHAMAAQAPAAAHAJQAGAHgBAJQAAALgHAHQgHAGgLAAIgCAAgAgGgIQgCADAAAFQAAAHACADQADADADAAQAEAAACgDQADgDAAgGQAAgGgDgDQgCgDgEAAQgDAAgDADg");
	this.shape_92.setTransform(-147.6479,-78.0233);

	this.shape_93 = new cjs.Shape();
	this.shape_93.graphics.f("#999999").s().p("AAKAhIgKgUIgEgFQgCgCgDAAIgCAAIAAAbIgVAAIABhBIAhAAQAKAAAFACQAFABADAEQADAFAAAHQAAAFgCAEQgDAEgEABIgIADIAGACIADAEIADAEIAKATgAgLgFIAJAAIAFgBIADgCIABgEQAAgDgCgCQgCgBgEgBIgKAAg");
	this.shape_93.setTransform(-153.775,-78.95);

	this.shape_94 = new cjs.Shape();
	this.shape_94.graphics.f("#999999").s().p("AgJAYIAAgSIATAAIAAASgAgJgEIAAgTIATAAIAAATg");
	this.shape_94.setTransform(-34.275,-92.55);

	this.shape_95 = new cjs.Shape();
	this.shape_95.graphics.f("#999999").s().p("AgYAhIgBgNQAEABAFAAQADAAACgBQACgCABgEIgTgvIATAAIAIAgIAKgfIASAAIgTAyQgDAJgEACQgEAFgKAAIgMgBg");
	this.shape_95.setTransform(-38.575,-91.625);

	this.shape_96 = new cjs.Shape();
	this.shape_96.graphics.f("#999999").s().p("AgIAhIAAhBIARAAIAABBg");
	this.shape_96.setTransform(-43.25,-93.525);

	this.shape_97 = new cjs.Shape();
	this.shape_97.graphics.f("#999999").s().p("AgJAhIABhBIARAAIAABBg");
	this.shape_97.setTransform(-46.3,-93.575);

	this.shape_98 = new cjs.Shape();
	this.shape_98.graphics.f("#999999").s().p("AgWAVQgFgEAAgGQAAgFADgEQAEgCAIgCIANgDIAGgBQABgEgCgBQgBgCgEAAQgDAAgCABIgEAFIgRgCIADgHQACgDADgCQADgCAEAAIAKgBIAMABQAFABAEADQACACABAEQACAEgBADIAAAUIABAGIACAFIgSAAIgBgDIgBgDQgDADgEABQgEACgGAAQgJAAgEgEgAAAAEQgFABgCACQAAAAAAABQgBAAAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABABAAQAAAAAAABQABAAAAAAQABABAAAAQABAAAAAAQABAAABAAQACAAACgBQADgBABgDIABgFIAAgDIgHACg");
	this.shape_98.setTransform(-50.975,-92.725);

	this.shape_99 = new cjs.Shape();
	this.shape_99.graphics.f("#999999").s().p("AgEAgQgDgCgCgDQgBgEAAgIIAAgQIgHAAIAAgNIAHAAIAAgJIASgKIAAATIAKAAIAAAOIgKgBIgBAQIABAEQAAABAAAAQABAAAAAAQAAABABAAQAAAAABAAIAGgBIABANIgNABQgGAAgDgCg");
	this.shape_99.setTransform(-56.125,-93.575);

	this.shape_100 = new cjs.Shape();
	this.shape_100.graphics.f("#999999").s().p("AAHAZIAAgaQAAgEgCgCQgBgCgDgBQgDAAgCADQgCADAAAFIAAAXIgTAAIABgvIARAAIAAAIQAEgFADgCQAEgCAFAAQAIAAAFAFQAEAFgBAJIAAAeg");
	this.shape_100.setTransform(-61.2972,-92.775);

	this.shape_101 = new cjs.Shape();
	this.shape_101.graphics.f("#999999").s().p("AAAAZQgLAAgHgGQgJgHAAgMQABgKAHgHQAHgHAMAAQAPAAAHAJQAGAHgBAJQAAALgHAHQgHAGgLAAIgCAAgAgGgIQgCADAAAFQAAAHACADQADADADAAQAEAAACgDQADgDAAgGQAAgGgDgDQgCgDgEAAQgDAAgDADg");
	this.shape_101.setTransform(-67.4979,-92.8233);

	this.shape_102 = new cjs.Shape();
	this.shape_102.graphics.f("#999999").s().p("AgXAYIAAgMIAXgXIgVAAIAAgMIAsAAIAAALIgXAXIAYABIAAAMg");
	this.shape_102.setTransform(-73.15,-92.825);

	this.shape_103 = new cjs.Shape();
	this.shape_103.graphics.f("#999999").s().p("AgIAhIAAgvIARAAIAAAvgAgIgUIAAgMIARAAIAAAMg");
	this.shape_103.setTransform(-77.225,-93.825);

	this.shape_104 = new cjs.Shape();
	this.shape_104.graphics.f("#999999").s().p("AgSAZIAAgvIARAAIAAAHQACgFADgCQADgCADABQAEAAAFACIgGAOIgFgCQgDAAgDADQgCAEAAALIAAAQg");
	this.shape_104.setTransform(-80.4,-92.955);

	this.shape_105 = new cjs.Shape();
	this.shape_105.graphics.f("#999999").s().p("AAAAZQgLAAgHgGQgJgHAAgMQABgKAHgHQAHgHAMAAQAPAAAHAJQAGAHgBAJQAAALgHAHQgHAGgLAAIgCAAgAgGgIQgCADAAAFQAAAHACADQADADADAAQAEAAACgDQADgDAAgGQAAgGgDgDQgCgDgEAAQgDAAgDADg");
	this.shape_105.setTransform(-86.0479,-92.9733);

	this.shape_106 = new cjs.Shape();
	this.shape_106.graphics.f("#999999").s().p("AAHAiIAAgbQAAgFgCgCQgBgBgDAAQgDAAgCABQgCADAAAHIAAAXIgTAAIABhCIASAAIAAAZQAEgEADgBQAEgCAFAAQAHAAAFAFQAEAFgBAIIAAAfg");
	this.shape_106.setTransform(-92.2472,-93.9);

	this.shape_107 = new cjs.Shape();
	this.shape_107.graphics.f("#999999").s().p("AAAAZQgMAAgGgDQgFgEgBgHIASgCIADAFQACABADAAIAFgBIABgDQAAAAAAgBQAAAAAAgBQAAAAgBAAQAAgBgBAAQgBgBgGgBIgMgDQgFgCgCgCQgDgEABgEQAAgFACgDQAEgEAEgBQAFgCAHAAQAJAAAEACIAHAEIAEAHIgRACIgCgEQgCgBgDAAQAAAAgBAAQgBAAAAAAQgBAAAAAAQgBAAAAABQAAAAgBAAQAAABAAAAQAAAAAAABQAAAAAAABIABACIAHACQAJABAEACQAFACACADQADADgBAEQABAEgDAEQgDAEgFADQgEABgHAAIgEAAg");
	this.shape_107.setTransform(-101.35,-93.07);

	this.shape_108 = new cjs.Shape();
	this.shape_108.graphics.f("#999999").s().p("AAAAZQgJAAgFgCQgGgDgDgGQgEgGAAgIQABgKAHgHQAHgHAMAAQAKAAAGAEQAGADADAGQADAGAAAIIAAACIgkAAQAAAEACACQADADADAAIAFAAIAEgDIASABQgEAIgGADQgFACgJAAIgDAAgAgGgKQgCADAAAEIARAAQAAgFgCgCQgDgDgDAAQgEAAgDADg");
	this.shape_108.setTransform(-107.225,-93.1214);

	this.shape_109 = new cjs.Shape();
	this.shape_109.graphics.f("#999999").s().p("AgaAiIABhCIARAAIAAAHQAEgEADgCQADgCAFAAQAJAAAGAIQAFAHAAALQAAALgGAHQgGAGgJAAQgEAAgDgCIgGgEIAAAXgAgFgRQgCADAAAGQAAAGACACQADADACAAQAEAAACgDQACgBAAgHQAAgFgCgDQgCgDgDAAQgDAAgDACg");
	this.shape_109.setTransform(-113.3229,-92.2792);

	this.shape_110 = new cjs.Shape();
	this.shape_110.graphics.f("#999999").s().p("AgWAVQgFgEAAgGQAAgFADgEQAEgCAIgCIANgDIAGgBQABgEgCgBQgBgCgEAAQgDAAgCABIgEAFIgRgCIADgHQACgDADgCQADgCAEAAIAKgBIAMABQAFABAEADQACACABAEQACAEgBADIAAAUIABAGIACAFIgSAAIgBgDIgBgDQgDADgEABQgEACgGAAQgJAAgEgEgAAAAEQgFABgCACQAAAAAAABQgBAAAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABABAAQAAAAAAABQABAAAAAAQABABAAAAQABAAAAAAQABAAABAAQACAAACgBQADgBABgDIABgFIAAgDIgHACg");
	this.shape_110.setTransform(-119.725,-93.225);

	this.shape_111 = new cjs.Shape();
	this.shape_111.graphics.f("#999999").s().p("AAHAhIAAgaQAAgEgCgDQgBAAgDgBQgDAAgCABQgCAEAAAGIAAAXIgTAAIABhBIASAAIAAAYQAEgEADgBQAEgCAFAAQAHAAAFAFQAEAFgBAIIAAAeg");
	this.shape_111.setTransform(-125.9472,-94.15);

	this.shape_112 = new cjs.Shape();
	this.shape_112.graphics.f("#999999").s().p("AAAAZQgMAAgGgDQgFgEgBgHIASgCIADAFQACABADAAIAFgBIABgDQAAAAAAgBQAAAAAAgBQAAAAgBAAQAAgBgBAAQgBgBgGgBIgMgDQgFgCgCgCQgDgEABgEQAAgFACgDQAEgEAEgBQAFgCAHAAQAJAAAEACIAHAEIAEAHIgRACIgCgEQgCgBgDAAQAAAAgBAAQgBAAAAAAQgBAAAAAAQgBAAAAABQAAAAgBAAQAAABAAAAQAAAAAAABQAAAAAAABIABACIAHACQAJABAEACQAFACACADQADADgBAEQABAEgDAEQgDAEgFADQgEABgHAAIgEAAg");
	this.shape_112.setTransform(-131.95,-93.32);

	this.shape_113 = new cjs.Shape();
	this.shape_113.graphics.f("#999999").s().p("AAAAZQgJAAgFgCQgGgDgDgGQgEgGAAgIQABgKAHgHQAHgHAMAAQAKAAAGAEQAGADADAGQADAGAAAIIAAACIgkAAQAAAEACACQADADADAAIAFAAIAEgDIASABQgEAIgGADQgFACgJAAIgDAAgAgGgKQgCADAAAEIARAAQAAgFgCgCQgDgDgDAAQgEAAgDADg");
	this.shape_113.setTransform(-140.925,-93.3714);

	this.shape_114 = new cjs.Shape();
	this.shape_114.graphics.f("#999999").s().p("AgIAYIgUgvIAUAAIAIAdIAKgdIATAAIgWAvg");
	this.shape_114.setTransform(-146.6,-93.375);

	this.shape_115 = new cjs.Shape();
	this.shape_115.graphics.f("#999999").s().p("AAAAZQgLAAgHgGQgJgHAAgMQABgKAHgHQAHgHAMAAQAPAAAHAJQAGAHgBAJQAAALgHAHQgHAGgLAAIgCAAgAgGgIQgCADAAAFQAAAHACADQADADADAAQAEAAACgDQADgDAAgGQAAgGgDgDQgCgDgEAAQgDAAgDADg");
	this.shape_115.setTransform(-152.2979,-93.4733);

	this.shape_116 = new cjs.Shape();
	this.shape_116.graphics.f("#999999").s().p("AAUAhIABgxIgOAxIgOAAIgMgyIgBAyIgRAAIABhBIAbAAIAJAnIALgnIAbAAIgBBBg");
	this.shape_116.setTransform(-159.725,-94.4);

	this.shape_117 = new cjs.Shape();
	this.shape_117.graphics.f("#FFFFFF").s().p("AgJAJIAAgRIATAAIAAARg");
	this.shape_117.setTransform(21.05,-28.175);

	this.shape_118 = new cjs.Shape();
	this.shape_118.graphics.f("#FFFFFF").s().p("AAHAhIAAgaQAAgFgCgBQgBgCgDAAQgDAAgCACQgCADAAAGIAAAXIgTAAIABhBIASAAIAAAYQAEgEADgBQAEgCAFAAQAHAAAFAFQAEAFgBAIIAAAeg");
	this.shape_118.setTransform(16.3528,-30.6);

	this.shape_119 = new cjs.Shape();
	this.shape_119.graphics.f("#FFFFFF").s().p("AgUAUQgFgFAAgJIABgdIASAAIAAAZQAAAFABABQACACADAAQACAAADgCQACgDAAgFIAAgXIATAAIgBAvIgRAAIAAgIQgEAFgEABQgDACgGAAQgHABgEgFg");
	this.shape_119.setTransform(10.175,-29.7);

	this.shape_120 = new cjs.Shape();
	this.shape_120.graphics.f("#FFFFFF").s().p("AgVAaQgFgIAAgKQABgLAFgHQAGgGAJAAQAEAAADACIAGAEIAAgWIATAAIgBBBIgRAAIAAgHQgEAEgDABQgDACgFAAQgKAAgFgHgAgFAAQgCADAAAFQAAAHACACQACADADAAQADAAACgCQADgDAAgGQAAgGgDgCQgCgDgDAAQgDAAgCACg");
	this.shape_120.setTransform(3.875,-30.6);

	this.shape_121 = new cjs.Shape();
	this.shape_121.graphics.f("#FFFFFF").s().p("AgJAKIAIgEQABgCAAgEIgJAAIAAgSIATAAIAAAQQAAAHgDAFQgEAFgIADg");
	this.shape_121.setTransform(-3.75,-27.4);

	this.shape_122 = new cjs.Shape();
	this.shape_122.graphics.f("#FFFFFF").s().p("AgKAhIABgxIgVAAIAAgRIA9ABIAAAQIgVAAIAAAyg");
	this.shape_122.setTransform(-7.275,-30.75);

	this.shape_123 = new cjs.Shape();
	this.shape_123.graphics.f("#FFFFFF").s().p("AgKAhIABhBIATAAIAABBg");
	this.shape_123.setTransform(-12.45,-30.825);

	this.shape_124 = new cjs.Shape();
	this.shape_124.graphics.f("#FFFFFF").s().p("AgIAhQgGgBgEgBIgHgHQgDgDgBgEQgCgHAAgEIABgnIAUAAIgBAnQAAAGADADQADADAFAAQAFAAADgDQADgCAAgGIABgnIAUAAIAAAmQgBAGgBAFQgCAFgEAEQgEAFgEABQgGACgIAAIgKgBg");
	this.shape_124.setTransform(-18.1,-30.8);

	this.shape_125 = new cjs.Shape();
	this.shape_125.graphics.f("#FFFFFF").s().p("AAWAhIgGgFQgHADgJAAQgPAAgJgIQgLgJAAgQQABgRAJgJQAJgJAQABQAQAAAJAIQAJAJgBARQAAAOgHAJIAFADIAFACIgGAMIgIgFgAADAQQgDgDgEgCIADgIIADACIAGADIACACQADgEAAgIQAAgKgDgFQgEgEgGAAQgGAAgEAEQgDAEAAAKQgBAKAEAEQADAEAHABIADAAIAAAAg");
	this.shape_125.setTransform(-25.775,-30.5513);

	this.shape_126 = new cjs.Shape();
	this.shape_126.graphics.f("#FFFFFF").s().p("AgbAhIABhBIA2AAIAAAOIgigBIAAALIAfAAIAAAOIgggBIAAANIAjAAIAAAPg");
	this.shape_126.setTransform(1.2,-46.1);

	this.shape_127 = new cjs.Shape();
	this.shape_127.graphics.f("#FFFFFF").s().p("AgWAbQgGgGgBgKIAUgBQAAAEACADQADAEAFAAQAFAAACgCQACgCAAgDQAAAAAAgBQAAgBAAAAQgBgBAAAAQAAgBgBAAQgCgCgHgDQgOgDgFgEQgGgFAAgHQAAgGADgEQADgFAGgCQAGgDAJABQANAAAHAEQAGAFACAKIgUACQAAgFgDgCQgCgCgEgBQgDAAgCACQgBAAAAABQAAAAgBABQAAAAAAABQAAAAAAABIABADIAGACQAOADAGADQAGADACAEQACAEAAAGQAAAGgDAFQgEAGgGADQgGACgKAAQgQAAgHgHg");
	this.shape_127.setTransform(-5.675,-46.1292);

	this.shape_128 = new cjs.Shape();
	this.shape_128.graphics.f("#FFFFFF").s().p("AgIAhQgGgBgEgCIgHgGQgDgDgBgEQgCgGAAgGIAAgmIAVAAIgBAnQABAGADADQADADAEABQAFAAADgEQADgDAAgFIAAgoIAVAAIgBAnQABAGgCAFQgCAGgEAEQgEAEgEABQgGACgIAAIgKgBg");
	this.shape_128.setTransform(-12.85,-46.15);

	this.shape_129 = new cjs.Shape();
	this.shape_129.graphics.f("#FFFFFF").s().p("AAPAhIgEgLIgWAAIgDALIgVAAIAZhBIAWAAIAYBBgAgGAHIANABIgHgXg");
	this.shape_129.setTransform(-20.025,-46.25);

	this.shape_130 = new cjs.Shape();
	this.shape_130.graphics.f("#FFFFFF").s().p("AgcAhIABhBIAhAAQALAAAGAFQAGAGAAAKQAAAKgHAEQgGAGgMAAIgKAAIAAAYgAgGgEIAFAAQAFABACgCQACgDAAgDQAAgDgCgCQgBgCgGgBIgFAAg");
	this.shape_130.setTransform(-26.1,-46.325);

	this.shape_131 = new cjs.Shape();
	this.shape_131.graphics.f("#FFFFFF").s().p("AAMAiIgXgkIgBAjIgTAAIABhCIASAAIAYAlIABgkIATAAIgBBCg");
	this.shape_131.setTransform(34.65,-61.25);

	this.shape_132 = new cjs.Shape();
	this.shape_132.graphics.f("#FFFFFF").s().p("AALAhIgLgpIgLApIgUAAIgOhBIATAAIAHAkIAKgkIATAAIAJAkIAIgkIATAAIgOBBg");
	this.shape_132.setTransform(26.15,-61.3);

	this.shape_133 = new cjs.Shape();
	this.shape_133.graphics.f("#FFFFFF").s().p("AgRAeQgHgDgFgIQgFgIAAgLQABgQAJgJQAJgJAPABQARAAAJAIQAJAJgBAQQAAALgDAIQgEAHgIAEQgHAEgLAAQgLAAgHgEgAgJgOQgDAEgBAKQAAAKAEAEQAEAEAFABQAHAAADgEQAEgFAAgKQAAgJgDgFQgEgEgHAAIAAAAQgFAAgEAEg");
	this.shape_133.setTransform(17.7013,-61.3763);

	this.shape_134 = new cjs.Shape();
	this.shape_134.graphics.f("#FFFFFF").s().p("AgeAhIABhCIAdABQAJAAAGACQAGADADAEQAEAFABAGQACAGAAAGQAAAKgDAHQgCAFgFAFQgEADgFABQgHACgFAAgAgJASIAFAAQAFAAADgBQADgBABgEQACgEAAgHQAAgKgDgEQgDgEgHAAIgGAAg");
	this.shape_134.setTransform(10.43,-61.45);

	this.shape_135 = new cjs.Shape();
	this.shape_135.graphics.f("#FFFFFF").s().p("AgbAhIAAhCIA2ABIAAAOIghgBIAAALIAfAAIgBAOIgegBIAAANIAiAAIAAAQg");
	this.shape_135.setTransform(0.35,-61.5);

	this.shape_136 = new cjs.Shape();
	this.shape_136.graphics.f("#FFFFFF").s().p("AgbAhIAAhBIAiAAQAKAAAGAFQAFAGAAAKQAAAKgGAEQgGAGgNAAIgKAAIAAAYgAgGgEIAFAAQAFABADgCQACgDAAgDQAAgDgCgCQgCgCgFgBIgGAAg");
	this.shape_136.setTransform(-6.35,-61.575);

	this.shape_137 = new cjs.Shape();
	this.shape_137.graphics.f("#FFFFFF").s().p("AgKAhIABhBIAUAAIgBBBg");
	this.shape_137.setTransform(-11.7,-61.625);

	this.shape_138 = new cjs.Shape();
	this.shape_138.graphics.f("#FFFFFF").s().p("AAMAhIgMgoIgLAoIgUAAIgPhBIAUAAIAGAkIALgkIATAAIAKAkIAHgkIAUAAIgPBBg");
	this.shape_138.setTransform(-18.1,-61.65);

	this.shape_139 = new cjs.Shape();
	this.shape_139.graphics.f("#FFFFFF").s().p("AgWAbQgGgGgBgKIAUgBQAAAEACADQADAEAFAAQAFAAACgCQACgCAAgDQAAAAAAgBQAAgBAAAAQgBgBAAAAQAAgBgBAAQgCgCgHgDQgOgDgFgEQgGgFAAgHQAAgGADgEQADgFAGgCQAGgDAJABQANAAAHAEQAGAFACAKIgUACQAAgFgDgCQgCgCgEgBQgDAAgCACQgBAAAAABQgBAAAAABQAAAAAAABQAAAAAAABIABADIAGACQAOADAGADQAGADACAEQACAEAAAGQAAAGgDAFQgEAGgGADQgGACgKAAQgQAAgHgHg");
	this.shape_139.setTransform(-26.175,-61.6792);

	this.shape_140 = new cjs.Shape();
	this.shape_140.graphics.f("#FFFFFF").s().p("AgbAhIABhBIA2AAIAAAOIgigBIAAALIAfAAIAAAOIgggBIAAANIAjAAIAAAPg");
	this.shape_140.setTransform(25.6,-76.7);

	this.shape_141 = new cjs.Shape();
	this.shape_141.graphics.f("#FFFFFF").s().p("AgcAhIABhBIAhAAQALAAAGAFQAGAGAAAKQAAAKgHAEQgGAGgMAAIgKAAIAAAYgAgGgEIAFAAQAFABACgCQACgDAAgDQAAgDgCgCQgBgCgGgBIgFAAg");
	this.shape_141.setTransform(18.9,-76.775);

	this.shape_142 = new cjs.Shape();
	this.shape_142.graphics.f("#FFFFFF").s().p("AAPAiIgEgLIgWgBIgDALIgVAAIAZhCIAWABIAYBCgAgGAHIANABIgHgXg");
	this.shape_142.setTransform(11.775,-76.8);

	this.shape_143 = new cjs.Shape();
	this.shape_143.graphics.f("#FFFFFF").s().p("AALAiIAAgbIgWgBIAAAbIgUAAIABhCIAUAAIAAAYIAWAAIAAgXIAUAAIAABCg");
	this.shape_143.setTransform(4.3,-76.9);

	this.shape_144 = new cjs.Shape();
	this.shape_144.graphics.f("#FFFFFF").s().p("AgWAbQgGgGgBgKIAUgBQAAAEACADQADAEAFAAQAFAAACgCQACgCAAgDQAAAAAAgBQAAgBAAAAQAAgBgBAAQAAgBgBAAQgCgCgHgDQgOgDgFgEQgGgFAAgHQAAgGADgEQADgFAGgCQAGgDAJABQANAAAHAEQAGAFACAKIgUACQAAgFgDgCQgCgCgEgBQgDAAgCACQgBAAAAABQgBAAAAABQAAAAAAABQAAAAAAABIABADIAGACQAOADAGADQAGADACAEQACAEAAAGQAAAGgDAFQgEAGgGADQgGACgKAAQgQAAgHgHg");
	this.shape_144.setTransform(-2.925,-76.9292);

	this.shape_145 = new cjs.Shape();
	this.shape_145.graphics.f("#FFFFFF").s().p("AgcAhIABhBIAhAAQALAAAGAFQAGAGAAAKQAAAKgHAEQgGAGgMAAIgKAAIAAAYgAgGgEIAFAAQAFABACgCQACgDAAgDQAAgDgCgCQgBgCgGgBIgFAAg");
	this.shape_145.setTransform(-12.6,-77.025);

	this.shape_146 = new cjs.Shape();
	this.shape_146.graphics.f("#FFFFFF").s().p("AAPAhIgEgKIgWgBIgDALIgVAAIAZhBIAWAAIAYBBgAgGAHIANABIgHgXg");
	this.shape_146.setTransform(-19.675,-77.05);

	this.shape_147 = new cjs.Shape();
	this.shape_147.graphics.f("#FFFFFF").s().p("AgKAhIABgxIgVAAIAAgRIA9ABIAAAQIgVAAIAAAyg");
	this.shape_147.setTransform(-26.025,-77.1);

	this.shape_148 = new cjs.Shape();
	this.shape_148.graphics.f("#FFFFFF").s().p("AgJAhIAAgxIgWAAIAAgRIA+ABIAAAQIgVAAIAAAyg");
	this.shape_148.setTransform(99.85,-91.625);

	this.shape_149 = new cjs.Shape();
	this.shape_149.graphics.f("#FFFFFF").s().p("AALAiIAAgbIgWgBIAAAbIgUAAIAAhCIAVAAIAAAYIAWAAIAAgXIAUAAIAABCg");
	this.shape_149.setTransform(92.575,-91.725);

	this.shape_150 = new cjs.Shape();
	this.shape_150.graphics.f("#FFFFFF").s().p("AgSAeQgHgEgEgIQgEgIAAgKQAAgKAFgIQAEgJAJgEQAHgDAKAAQALAAAGADQAFACAEAEQAEAEABAGIgUAEQgBgEgDgCQgDgCgEAAQgGAAgEAEQgEAFgBAKQAAAKAEAFQAFAFAGAAIAGgBIAIgDIAAgHIgOAAIAAgNIAgAAIAAAcQgJAGgHADQgHACgKAAQgLgBgIgEg");
	this.shape_150.setTransform(84.725,-91.7781);

	this.shape_151 = new cjs.Shape();
	this.shape_151.graphics.f("#FFFFFF").s().p("AgKAhIABhBIAUAAIgBBBg");
	this.shape_151.setTransform(79.025,-91.8);

	this.shape_152 = new cjs.Shape();
	this.shape_152.graphics.f("#FFFFFF").s().p("AAKAiIgLgVIgDgFQgDgCgCAAIgCAAIAAAbIgVAAIABhCIAhABQAKAAAFABQAFACADAEQADAFAAAGQAAAGgCAEQgCAEgFABIgHADIAFADIADADIADAEIAKAUgAgLgGIAJABIAFgBQAAAAABAAQAAAAABgBQAAAAAAAAQABgBAAAAQAAgBABAAQAAgBAAAAQAAgBAAAAQAAgBAAAAQAAgDgCgCQgBgCgGAAIgJAAg");
	this.shape_152.setTransform(73.9,-91.825);

	this.shape_153 = new cjs.Shape();
	this.shape_153.graphics.f("#FFFFFF").s().p("AgMAjIAQhFIAKAAIgRBFg");
	this.shape_153.setTransform(68.65,-91.925);

	this.shape_154 = new cjs.Shape();
	this.shape_154.graphics.f("#FFFFFF").s().p("AgJAhIAAgxIgVAAIAAgRIA+ABIAAAQIgWAAIAAAyg");
	this.shape_154.setTransform(63.95,-91.925);

	this.shape_155 = new cjs.Shape();
	this.shape_155.graphics.f("#FFFFFF").s().p("AgZAhIABhBIAyAAIAAAOIgdAAIAAALIAZABIgBAMIgZAAIAAAbg");
	this.shape_155.setTransform(57.575,-92);

	this.shape_156 = new cjs.Shape();
	this.shape_156.graphics.f("#FFFFFF").s().p("AgbAhIAAhCIA3ABIAAAOIgigBIAAALIAfABIAAAMIggAAIAAANIAjABIAAAPg");
	this.shape_156.setTransform(51.025,-92.025);

	this.shape_157 = new cjs.Shape();
	this.shape_157.graphics.f("#FFFFFF").s().p("AgaAhIABhCIAUAAIAAAyIAfAAIAAARg");
	this.shape_157.setTransform(44.6,-92.075);

	this.shape_158 = new cjs.Shape();
	this.shape_158.graphics.f("#FFFFFF").s().p("AgbAhIABhBIA2AAIAAAOIgigBIAAALIAfABIAAAMIgfAAIAAANIAiABIAAAOg");
	this.shape_158.setTransform(34.95,-92.15);

	this.shape_159 = new cjs.Shape();
	this.shape_159.graphics.f("#FFFFFF").s().p("AgbAhIAAhBIAiAAQAKAAAGAFQAFAGAAAKQAAAKgGAEQgGAGgNAAIgKAAIAAAYgAgGgEIAFAAQAFABADgCQACgDAAgDQAAgDgCgCQgDgCgEgBIgGAAg");
	this.shape_159.setTransform(28.2,-92.225);

	this.shape_160 = new cjs.Shape();
	this.shape_160.graphics.f("#FFFFFF").s().p("AAPAhIgEgLIgWAAIgDALIgVAAIAZhBIAWAAIAYBBgAgGAHIANABIgHgXg");
	this.shape_160.setTransform(21.125,-92.25);

	this.shape_161 = new cjs.Shape();
	this.shape_161.graphics.f("#FFFFFF").s().p("AALAiIAAgbIgVgBIAAAbIgVAAIABhCIAUAAIAAAYIAVAAIAAgXIAVAAIAABCg");
	this.shape_161.setTransform(13.65,-92.3);

	this.shape_162 = new cjs.Shape();
	this.shape_162.graphics.f("#FFFFFF").s().p("AgWAbQgGgGgBgKIAUgBQAAAEACADQADAEAFAAQAFAAACgCQACgCAAgDQAAAAAAgBQAAgBAAAAQgBgBAAAAQAAgBgBAAQgCgCgHgDQgOgDgFgEQgGgFAAgHQAAgGADgEQADgFAGgCQAGgDAJABQANAAAHAEQAGAFACAKIgUACQAAgFgDgCQgCgCgEgBQgDAAgCACQgBAAAAABQAAAAgBABQAAAAAAABQAAAAAAABIABADIAGACQAOADAGADQAGADACAEQACAEAAAGQAAAGgDAFQgEAGgGADQgGACgKAAQgQAAgHgHg");
	this.shape_162.setTransform(6.375,-92.3292);

	this.shape_163 = new cjs.Shape();
	this.shape_163.graphics.f("#FFFFFF").s().p("AgSAeQgHgEgEgIQgEgIAAgKQABgKAEgIQAFgJAIgEQAGgDALABQALAAAFACQAGACAEAEQADAEACAGIgTAEQgCgEgDgCQgDgCgFAAQgFAAgEAEQgEAFAAAKQAAAKADAFQAEAEAHABIAGgBIAIgEIAAgGIgOAAIAAgNIAgAAIAAAcQgJAGgIACQgHACgJAAQgLAAgIgEg");
	this.shape_163.setTransform(-3.9,-92.4286);

	this.shape_164 = new cjs.Shape();
	this.shape_164.graphics.f("#FFFFFF").s().p("AAPAhIgEgLIgWAAIgDALIgVAAIAZhCIAWABIAYBBgAgGAIIANAAIgHgXg");
	this.shape_164.setTransform(-11.225,-92.5);

	this.shape_165 = new cjs.Shape();
	this.shape_165.graphics.f("#FFFFFF").s().p("AAKAiIgKgVIgEgFQgCgCgDAAIgCAAIAAAbIgVAAIABhCIAhABQAKAAAFACQAFABADAEQADAFAAAHQAAAFgCAEQgDAEgEABIgIADIAGADIADADIADAEIAKAUgAgLgGIAJABIAFgBIADgCIABgEQAAgDgCgCQgCgBgEgBIgKAAg");
	this.shape_165.setTransform(-18.075,-92.55);

	this.shape_166 = new cjs.Shape();
	this.shape_166.graphics.f("#FFFFFF").s().p("AgeAhIABhBIAdAAQAJAAAGACQAGADADAEQAEAFABAGQACAGAAAGQAAALgDAFQgCAGgFAFQgEADgFABQgHACgFAAgAgJASIAFAAQAFAAADgBQADgBABgEQACgEAAgHQAAgKgDgEQgDgEgHAAIgGAAg");
	this.shape_166.setTransform(-25.52,-92.6);

	this.shape_167 = new cjs.Shape();
	this.shape_167.graphics.f("#999999").s().p("AgJAYIAAgSIATAAIAAASgAgJgFIAAgSIATAAIAAASg");
	this.shape_167.setTransform(-17.55,-128.525);

	this.shape_168 = new cjs.Shape();
	this.shape_168.graphics.f("#999999").s().p("AgPAXQgFgDgEgGQgDgGAAgIQAAgKAHgHQAIgHAMAAQAKAAAGADQAGADADAGQADAGAAAIIAAADIgkAAQAAAEACACQADADADAAIAFgBIAEgDIASACQgEAHgGADQgGADgLAAQgJAAgGgCgAgGgKQgCACAAAFIARAAQgBgGgBgCQgDgCgEAAQgDAAgDADg");
	this.shape_168.setTransform(-22.2,-128.525);

	this.shape_169 = new cjs.Shape();
	this.shape_169.graphics.f("#999999").s().p("AAWAZIAAgbIgBgFQgCgCgDAAQgDAAgCACQgCACAAAFIAAAZIgSAAIAAgaIAAgEIgCgDIgDgBQgEAAgCACQgCACAAAFIAAAZIgSAAIAAgwIARAAIAAAHQAEgEAEgCQADgCAGAAQAGAAACACQADACADAEQAEgFAEgBQADgCAFAAQAIAAAFAFQAEAEAAAKIAAAeg");
	this.shape_169.setTransform(-30.025,-128.575);

	this.shape_170 = new cjs.Shape();
	this.shape_170.graphics.f("#999999").s().p("AgXAVQgEgEAAgGQAAgFADgEQADgCAJgCIAMgDIAIgCQgBgEgBgBIgFgBQgEAAgCABQgCABgBADIgSgCIADgHQACgDAEgCIAHgCIAKAAIAMAAQAFABADADQADACABAEIACAHIAAAVIAAAFIACAFIgSAAIgBgDIAAgDIgIAFQgEACgGAAQgJAAgFgEgAAAAEQgGABgBACQAAAAgBABQAAAAAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQABAAAAABQAAAAABAAQAAABABAAQAAAAABAAQABAAABAAQACAAACgCIAEgDQABgCABgEIAAgDIgIADg");
	this.shape_170.setTransform(-37.85,-128.525);

	this.shape_171 = new cjs.Shape();
	this.shape_171.graphics.f("#999999").s().p("AgTAeQgGgEAAgHIABgDIASACQAAABAAAAQAAABABAAQAAABAAAAQAAAAABAAQACACACAAQAEAAACgCQACgCAAgGIAAgHQgDADgDACQgDACgFAAQgKAAgGgJQgEgEAAgLQAAgLAGgGQAFgFAJAAQAGgBACACQAEACADAFIAAgIIASAAIAAAtIAAACQAAAFgCAEQgCAEgDADQgEACgFABIgLACQgOgBgFgEgAgFgRQgCACAAAGQAAAFACADQACABADABQADAAADgDQACgCAAgFQAAgGgCgCQgDgDgDAAQgDAAgCADg");
	this.shape_171.setTransform(-44.225,-127.6);

	this.shape_172 = new cjs.Shape();
	this.shape_172.graphics.f("#999999").s().p("AgEAgQgDgCgCgDQgBgEAAgIIAAgQIgHAAIAAgOIAHAAIAAgJIARgJIAAASIALAAIAAAOIgLAAIAAAQIABAFQAAAAAAAAQABAAAAABQABAAAAAAQABAAAAAAIAGgBIABAMIgNACQgGAAgDgCg");
	this.shape_172.setTransform(-52.475,-129.4);

	this.shape_173 = new cjs.Shape();
	this.shape_173.graphics.f("#999999").s().p("AgIAiIAAgwIARAAIAAAwgAgIgUIAAgNIARAAIAAANg");
	this.shape_173.setTransform(-56.075,-129.45);

	this.shape_174 = new cjs.Shape();
	this.shape_174.graphics.f("#999999").s().p("AgUAUQgFgEAAgKIAAgeIATAAIAAAaQAAAEACACQAAABABAAQAAABABAAQAAAAABAAQAAAAABAAQADAAACgCQACgDAAgFIAAgYIATAAIAAAwIgSAAIAAgIQgEAFgEACQgDACgFAAQgIAAgEgFg");
	this.shape_174.setTransform(-60.825,-128.475);

	this.shape_175 = new cjs.Shape();
	this.shape_175.graphics.f("#999999").s().p("AAWAhIgHgEQgHACgJAAQgPABgJgJQgKgJAAgQQAAgRAJgJQAJgJAQAAQAQAAAJAJQAJAJAAARQAAAOgHAJIAFADIAFACIgGAMIgIgFgAgLgQQgDAEAAAJQAAAKADAFQAEAEAGAAIAEgBQgDgCgEgCIACgHIAEAAIAGAEIACACQADgFAAgHQAAgLgEgDQgEgFgGAAQgGAAgEAFg");
	this.shape_175.setTransform(-67.7,-129.15);

	this.shape_176 = new cjs.Shape();
	this.shape_176.graphics.f("#999999").s().p("AgJAYIAAgSIATAAIAAASgAgJgFIAAgSIATAAIAAASg");
	this.shape_176.setTransform(-17.55,-144.075);

	this.shape_177 = new cjs.Shape();
	this.shape_177.graphics.f("#999999").s().p("AgPAXQgFgDgEgGQgDgGAAgIQAAgKAHgHQAIgHAMAAQAKAAAGADQAGADADAGQADAGAAAIIAAADIgkAAQAAAEACACQADADADAAIAFgBIAEgDIASACQgEAHgGADQgGADgLAAQgJAAgGgCgAgGgKQgCACAAAFIARAAQgBgGgBgCQgDgCgEAAQgDAAgDADg");
	this.shape_177.setTransform(-22.2,-144.075);

	this.shape_178 = new cjs.Shape();
	this.shape_178.graphics.f("#999999").s().p("AAWAZIAAgbIgBgFQgCgCgDAAQgDAAgCACQgCACAAAFIAAAZIgSAAIAAgaIAAgEIgCgDIgDgBQgEAAgCACQgCACAAAFIAAAZIgSAAIAAgwIARAAIAAAHQAEgEAEgCQADgCAGAAQAGAAACACQADACADAEQAEgFAEgBQADgCAFAAQAIAAAFAFQAEAEAAAKIAAAeg");
	this.shape_178.setTransform(-30.025,-144.125);

	this.shape_179 = new cjs.Shape();
	this.shape_179.graphics.f("#999999").s().p("AgXAVQgEgEAAgGQAAgFADgEQADgCAJgCIAMgDIAIgCQgBgEgBgBIgFgBQgEAAgCABQgCABgBADIgSgCIADgHQACgDAEgCIAHgCIAKAAIAMAAQAFABADADQADACABAEIACAHIAAAVIAAAFIACAFIgSAAIgBgDIAAgDIgIAFQgEACgGAAQgJAAgFgEgAAAAEQgGABgBACQAAAAgBABQAAAAAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQABAAAAABQAAAAABAAQAAABABAAQAAAAABAAQABAAABAAQACAAACgCIAEgDQABgCABgEIAAgDIgIADg");
	this.shape_179.setTransform(-37.85,-144.075);

	this.shape_180 = new cjs.Shape();
	this.shape_180.graphics.f("#999999").s().p("AgTAeQgGgEAAgIIABgCIASACQAAABAAAAQAAABABAAQAAABAAAAQAAAAABAAQACACACAAQAEAAACgCQACgCAAgGIAAgHQgDADgDABQgDADgFAAQgKAAgGgJQgEgFAAgJQAAgMAGgGQAFgFAJgBQAGABACABQAEACADAEIAAgHIASAAIAAAtIAAADQAAAEgCAEQgCAEgDADQgEADgFABIgLABQgOAAgFgFgAgFgRQgCACAAAGQAAAFACADQACABADAAQADAAADgBQACgDAAgFQAAgGgCgCQgDgDgDAAQgDAAgCADg");
	this.shape_180.setTransform(-44.225,-143.15);

	this.shape_181 = new cjs.Shape();
	this.shape_181.graphics.f("#999999").s().p("AgPAXQgFgDgEgGQgDgGAAgIQAAgKAHgHQAIgHAMAAQAKAAAGADQAGADADAGQADAGAAAIIAAADIgkAAQABAEABACQADADADAAIAGgBIACgDIATACQgEAHgGADQgGADgLAAQgJAAgGgCgAgGgKQgBACgBAFIARAAQAAgGgCgCQgDgCgEAAQgEAAgCADg");
	this.shape_181.setTransform(-53.5,-144.075);

	this.shape_182 = new cjs.Shape();
	this.shape_182.graphics.f("#999999").s().p("AgSAWQgFgEgCgHIATgCQABADACACQACABACAAQAEAAACgBIACgDQAAgBAAAAQAAgBgBAAQAAgBAAAAQgBAAAAgBIgHgBIgOgEQgEgBgCgCQgDgEAAgEQAAgFADgEQADgDAFgCQAFgBAHAAIANABIAHAEIAEAIIgSABQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAAAgBAAQgCgCgCAAIgFABIgBADQAAABAAAAQAAAAAAABQAAAAABAAQAAABABAAIAHACIANACQAFACACADQADADAAAEQAAAFgDAEQgCAEgGACQgFACgKAAQgMAAgGgDg");
	this.shape_182.setTransform(-59.575,-144.075);

	this.shape_183 = new cjs.Shape();
	this.shape_183.graphics.f("#999999").s().p("AgUAUQgFgEAAgKIAAgeIATAAIAAAaQAAAEACACQAAABABAAQAAAAABABQAAAAABAAQAAAAABAAQADAAACgCQACgDAAgFIAAgYIATAAIAAAwIgSAAIAAgIQgEAFgEACQgDACgFAAQgIAAgEgFg");
	this.shape_183.setTransform(-65.525,-144.025);

	this.shape_184 = new cjs.Shape();
	this.shape_184.graphics.f("#999999").s().p("AgWAVQgFgEAAgGQAAgFADgEQAEgCAIgCIAMgDIAHgCQABgEgCgBIgFgBQgDAAgDABQgBAAAAABQAAAAgBABQAAAAAAABQgBAAAAABIgSgCIADgHQACgDADgCIAHgCIAKAAIANAAQAFABAEADQACACABAEIABAHIAAAVIABAFIACAFIgSAAIgBgDIgBgDIgHAFQgEACgHAAQgIAAgEgEgAAAAEQgFABgCACQAAAAgBABQAAAAAAAAQAAABAAAAQgBABAAAAQAAABABAAQAAABAAAAQAAABAAAAQABAAAAABQAAAAABAAQAAABABAAQAAAAABAAQABAAABAAQACAAADgCIADgDQACgCgBgEIAAgDIgHADg");
	this.shape_184.setTransform(-71.75,-144.075);

	this.shape_185 = new cjs.Shape();
	this.shape_185.graphics.f("#999999").s().p("AgbAhIAAhBIAhAAQALAAAGAEQAFAGAAAKQAAAKgGAFQgGAGgMgBIgLAAIAAAZgAgHgEIAFAAQAFAAADgCQACgCAAgEQAAgCgCgDQgCgCgFAAIgGAAg");
	this.shape_185.setTransform(-77.975,-145);

	this.shape_186 = new cjs.Shape();
	this.shape_186.graphics.f("#999999").s().p("AgJAYIAAgSIATAAIAAASgAgJgFIAAgSIATAAIAAASg");
	this.shape_186.setTransform(-17.55,-159.625);

	this.shape_187 = new cjs.Shape();
	this.shape_187.graphics.f("#999999").s().p("AgEAhQgDgCgCgEQgBgEAAgIIAAgQIgHAAIAAgOIAHAAIAAgJIARgJIAAASIALAAIAAAOIgLAAIAAAQIABAEQAAABAAAAQABAAAAABQABAAAAAAQABAAAAAAIAGgCIABAOIgNABQgGAAgDgBg");
	this.shape_187.setTransform(-21.175,-160.5);

	this.shape_188 = new cjs.Shape();
	this.shape_188.graphics.f("#999999").s().p("AAHAZIAAgaQAAgFgCgBQAAgBgBAAQAAAAgBgBQAAAAgBAAQgBAAAAAAQgDAAgCACQgCADAAAFIAAAYIgTAAIAAgwIASAAIAAAIQAEgFADgCQAEgCAFAAQAIAAAEAFQAFAEAAAKIAAAeg");
	this.shape_188.setTransform(-26.425,-159.675);

	this.shape_189 = new cjs.Shape();
	this.shape_189.graphics.f("#999999").s().p("AgPAXQgFgDgEgGQgDgGAAgIQAAgKAHgHQAHgHANAAQAJAAAHADQAGADADAGQADAGAAAIIAAADIgkAAQAAAEACACQADADADAAIAFgBIAEgDIASACQgEAHgGADQgGADgLAAQgJAAgGgCgAgGgKQgCACAAAFIARAAQAAgGgDgCQgCgCgEAAQgDAAgDADg");
	this.shape_189.setTransform(-32.65,-159.625);

	this.shape_190 = new cjs.Shape();
	this.shape_190.graphics.f("#999999").s().p("AgLAYQgEgCgEgDQgEgDgCgEQgCgFAAgHQAAgGACgFQADgEACgDIAIgEQAEgCAIAAQAMAAAGAEQAHAEACAIIgSADQAAgEgDgBQgCgCgDAAQgEAAgCAEQgEADAAAGQAAAGAEADQACADADAAQAEAAACgCQADgCABgEIASACQgBAGgDAEQgEAEgFACQgFACgJAAQgGAAgGgBg");
	this.shape_190.setTransform(-38.9,-159.625);

	this.shape_191 = new cjs.Shape();
	this.shape_191.graphics.f("#999999").s().p("AgSAWQgFgEgCgHIATgCQABADACACQACABACAAQAEAAACgBIACgDQAAgBAAAAQAAgBgBAAQAAgBAAAAQgBAAAAgBIgHgBIgOgEQgEgBgCgCQgDgEAAgEQAAgFADgEQADgDAFgCQAFgBAHAAIANABIAHAEIAEAIIgSABQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAAAgBAAQgCgCgCAAIgFABIgBADQAAABAAAAQAAAAAAABQABAAAAAAQAAAAABABIAHACIANACQAFACACADQADADAAAEQAAAFgDAEQgCAEgGACQgFACgKAAQgMAAgGgDg");
	this.shape_191.setTransform(-44.925,-159.625);

	this.shape_192 = new cjs.Shape();
	this.shape_192.graphics.f("#999999").s().p("AgPAXQgFgDgEgGQgDgGAAgIQAAgKAHgHQAIgHAMAAQAKAAAGADQAGADADAGQADAGAAAIIAAADIgkAAQAAAEACACQADADADAAIAGgBIADgDIASACQgEAHgGADQgGADgLAAQgJAAgGgCgAgGgKQgCACAAAFIARAAQgBgGgBgCQgDgCgEAAQgDAAgDADg");
	this.shape_192.setTransform(-50.9,-159.625);

	this.shape_193 = new cjs.Shape();
	this.shape_193.graphics.f("#999999").s().p("AgVAaQgFgHAAgLQAAgLAGgHQAGgFAJgBIAGABQAEACADADIAAgXIATAAIAABCIgSAAIAAgHQgEAEgDACQgDACgFAAQgJAAgGgIgAgFAAQgCACAAAHQAAAGACACQACADADAAQADAAADgDQACgCAAgHQAAgFgDgDQgCgCgDAAQgDAAgCACg");
	this.shape_193.setTransform(-57.275,-160.5);

	this.shape_194 = new cjs.Shape();
	this.shape_194.graphics.f("#999999").s().p("AgPAXQgFgDgEgGQgDgGAAgIQAAgKAHgHQAIgHAMAAQAKAAAGADQAGADADAGQADAGAAAIIAAADIgkAAQABAEABACQADADADAAIAGgBIACgDIATACQgEAHgGADQgGADgLAAQgJAAgGgCgAgGgKQgBACgBAFIARAAQAAgGgCgCQgDgCgEAAQgEAAgCADg");
	this.shape_194.setTransform(-66.55,-159.625);

	this.shape_195 = new cjs.Shape();
	this.shape_195.graphics.f("#999999").s().p("AgaAiIAAhCIASAAIAAAHQADgEADgCQAEgCAEAAQAKAAAFAHQAGAIAAALQAAALgGAGQgGAHgJgBQgEAAgCgBIgHgEIAAAXgAgFgQQgCACAAAHQAAAFACACQADACADABQADgBACgCQACgBAAgHQAAgGgCgCQgDgEgDAAQgDAAgCAEg");
	this.shape_195.setTransform(-72.7,-158.75);

	this.shape_196 = new cjs.Shape();
	this.shape_196.graphics.f("#999999").s().p("AgXAVQgEgEAAgGQAAgFADgEQADgCAJgCIAMgDIAIgCQgBgEgBgBIgFgBQgEAAgCABQgCABgBADIgSgCIADgHQACgDADgCIAIgCIAKAAIAMAAQAFABADADQADACABAEIACAHIAAAVIAAAFIACAFIgSAAIgBgDIgBgDIgHAFQgEACgGAAQgJAAgFgEgAAAAEQgFABgCACQAAAAgBABQAAAAAAAAQAAABAAAAQgBABAAAAQAAABABAAQAAABAAAAQAAABAAAAQABAAAAABQAAAAABAAQAAABABAAQAAAAABAAQABAAABAAQACAAACgCIAEgDQABgCABgEIAAgDIgIADg");
	this.shape_196.setTransform(-79.15,-159.625);

	this.shape_197 = new cjs.Shape();
	this.shape_197.graphics.f("#999999").s().p("AAHAhIAAgaQAAgFgCgBQAAgBgBAAQAAAAgBAAQAAAAgBAAQAAgBgBAAQgDAAgCACQgCACAAAHIAAAXIgTAAIAAhBIATAAIAAAYQAEgEADgCQADgBAFAAQAIAAAEAEQAFAFAAAJIAAAeg");
	this.shape_197.setTransform(-85.425,-160.55);

	this.shape_198 = new cjs.Shape();
	this.shape_198.graphics.f("#999999").s().p("AgSAWQgFgEgCgHIATgCQABADACACQACABACAAQAEAAACgBIACgDQAAgBAAAAQgBgBAAAAQAAgBAAAAQgBAAAAgBIgHgBIgOgEQgEgBgCgCQgDgEAAgEQAAgFADgEQADgDAFgCQAFgBAHAAIANABIAHAEIAEAIIgSABQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAAAgBAAQgCgCgCAAIgFABIgBADQAAABAAAAQAAAAAAABQABAAAAAAQAAAAABABIAHACIANACQAFACACADQADADAAAEQAAAFgDAEQgCAEgGACQgFACgKAAQgMAAgGgDg");
	this.shape_198.setTransform(-91.475,-159.625);

	this.shape_199 = new cjs.Shape();
	this.shape_199.graphics.f("#999999").s().p("AgPAXQgFgDgEgGQgDgGAAgIQAAgKAHgHQAIgHAMAAQAKAAAGADQAGADADAGQADAGAAAIIAAADIgkAAQAAAEACACQADADADAAIAFgBIAEgDIASACQgEAHgGADQgGADgLAAQgJAAgGgCgAgGgKQgCACAAAFIARAAQgBgGgBgCQgDgCgEAAQgDAAgDADg");
	this.shape_199.setTransform(-100.5,-159.625);

	this.shape_200 = new cjs.Shape();
	this.shape_200.graphics.f("#999999").s().p("AgEAhQgDgCgCgEQgBgEAAgIIAAgQIgHAAIAAgOIAHAAIAAgJIARgJIAAASIALAAIAAAOIgLAAIAAAQIABAEQAAABAAAAQABAAAAABQABAAAAAAQABAAAAAAIAGgCIABAOIgNABQgGAAgDgBg");
	this.shape_200.setTransform(-105.775,-160.5);

	this.shape_201 = new cjs.Shape();
	this.shape_201.graphics.f("#999999").s().p("AgXAVQgEgEAAgGQAAgFADgEQADgCAJgCIAMgDIAIgCQgBgEgBgBIgFgBQgEAAgCABQgCABgBADIgSgCIADgHQACgDAEgCIAHgCIAKAAIAMAAQAFABADADQADACABAEIACAHIAAAVIAAAFIACAFIgSAAIgBgDIAAgDIgIAFQgEACgGAAQgJAAgFgEgAAAAEQgGABgBACQAAAAgBABQAAAAAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQABAAAAABQAAAAABAAQAAABABAAQAAAAABAAQABAAABAAQACAAACgCIAEgDQABgCABgEIAAgDIgIADg");
	this.shape_201.setTransform(-110.75,-159.625);

	this.shape_202 = new cjs.Shape();
	this.shape_202.graphics.f("#999999").s().p("AgSAZIAAgwIARAAIAAAIQACgFADgCQACgCAEAAQAEAAAFADIgFANIgGgCQgDAAgCAEQgDAEAAAKIAAARg");
	this.shape_202.setTransform(-115.75,-159.675);

	this.shape_203 = new cjs.Shape();
	this.shape_203.graphics.f("#999999").s().p("AgPAXQgFgDgEgGQgDgGAAgIQAAgKAHgHQAIgHAMAAQAKAAAGADQAGADADAGQADAGAAAIIAAADIgkAAQABAEABACQADADADAAIAGgBIACgDIATACQgEAHgGADQgGADgLAAQgJAAgGgCgAgGgKQgBACgBAFIARAAQAAgGgCgCQgDgCgEAAQgEAAgCADg");
	this.shape_203.setTransform(-121.35,-159.625);

	this.shape_204 = new cjs.Shape();
	this.shape_204.graphics.f("#999999").s().p("AgIAhIAAhBIARAAIAABBg");
	this.shape_204.setTransform(-126.025,-160.55);

	this.shape_205 = new cjs.Shape();
	this.shape_205.graphics.f("#999999").s().p("AgPAXQgFgDgEgGQgDgGAAgIQAAgKAHgHQAHgHANAAQAJAAAHADQAGADADAGQADAGAAAIIAAADIgkAAQAAAEACACQADADADAAIAFgBIAEgDIASACQgEAHgGADQgGADgLAAQgJAAgGgCgAgGgKQgCACAAAFIARAAQAAgGgDgCQgCgCgEAAQgDAAgDADg");
	this.shape_205.setTransform(-130.75,-159.625);

	this.shape_206 = new cjs.Shape();
	this.shape_206.graphics.f("#999999").s().p("AgLAYQgEgCgEgDQgEgDgCgEQgCgFAAgHQAAgGACgFQADgEACgDIAIgEQAEgCAIAAQAMAAAGAEQAHAEACAIIgSADQAAgEgDgBQgCgCgDAAQgEAAgCAEQgEADAAAGQAAAGAEADQACADADAAQAEAAACgCQADgCABgEIASACQgBAGgDAEQgEAEgFACQgFACgJAAQgGAAgGgBg");
	this.shape_206.setTransform(-137,-159.625);

	this.shape_207 = new cjs.Shape();
	this.shape_207.graphics.f("#999999").s().p("AgKAYQgGgCgDgDQgEgDgCgEQgCgFAAgHQAAgGACgFQACgEAEgDIAGgEQAGgCAHAAQAMAAAHAEQAFAEADAIIgRADQgBgEgCgBQgDgCgDAAQgEAAgDAEQgCADAAAGQAAAGACADQADADAEAAQADAAADgCQACgCABgEIASACQgBAGgEAEQgDAEgFACQgFACgJAAQgGAAgFgBg");
	this.shape_207.setTransform(-143.25,-159.625);

	this.shape_208 = new cjs.Shape();
	this.shape_208.graphics.f("#999999").s().p("AAPAhIgDgLIgXAAIgDALIgWAAIAahBIAWAAIAYBBgAgHAIIAOAAIgHgXg");
	this.shape_208.setTransform(-150.05,-160.55);

	this.shape_209 = new cjs.Shape();
	this.shape_209.graphics.f("#999999").s().p("AgJAYIAAgSIATAAIAAASgAgJgFIAAgSIATAAIAAASg");
	this.shape_209.setTransform(-17.55,-175.175);

	this.shape_210 = new cjs.Shape();
	this.shape_210.graphics.f("#999999").s().p("AgPAXQgFgDgEgGQgDgGAAgIQAAgKAHgHQAIgHAMAAQAKAAAGADQAGADADAGQADAGAAAIIAAADIgkAAQAAAEACACQADADADAAIAFgBIAEgDIASACQgEAHgGADQgGADgLAAQgJAAgGgCgAgGgKQgCACAAAFIARAAQgBgGgBgCQgDgCgEAAQgDAAgDADg");
	this.shape_210.setTransform(-22.2,-175.175);

	this.shape_211 = new cjs.Shape();
	this.shape_211.graphics.f("#999999").s().p("AgSAWQgFgEgCgHIATgCQABADACACQACABACAAQAEAAACgBIACgDQAAgBAAAAQAAgBgBAAQAAgBAAAAQgBAAAAgBIgHgBIgOgEQgEgBgCgCQgDgEAAgEQAAgFADgEQADgDAFgCQAFgBAHAAIANABIAHAEIAEAIIgSABQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAAAgBAAQgCgCgCAAIgFABIgBADQAAABAAAAQAAAAAAABQABAAAAAAQAAAAABABIAHACIANACQAFACACADQADADAAAEQAAAFgDAEQgCAEgGACQgFACgKAAQgMAAgGgDg");
	this.shape_211.setTransform(-28.275,-175.175);

	this.shape_212 = new cjs.Shape();
	this.shape_212.graphics.f("#999999").s().p("AgIAiIAAgwIARAAIAAAwgAgIgUIAAgNIARAAIAAANg");
	this.shape_212.setTransform(-32.625,-176.1);

	this.shape_213 = new cjs.Shape();
	this.shape_213.graphics.f("#999999").s().p("AAKAYIgKgcIgIAcIgRAAIgSgvIASAAIAIAdIAKgdIAPAAIALAdIAIgdIARAAIgRAvg");
	this.shape_213.setTransform(-38.625,-175.175);

	this.shape_214 = new cjs.Shape();
	this.shape_214.graphics.f("#999999").s().p("AAHAiIgJgUIgHAHIAAANIgTAAIAAhDIATAAIAAAiIANgPIAYAAIgSAQIATAgg");
	this.shape_214.setTransform(-45.9,-176.1);

	this.shape_215 = new cjs.Shape();
	this.shape_215.graphics.f("#999999").s().p("AgKAYQgGgCgDgDQgEgDgCgEQgCgFAAgHQAAgGACgFQACgEAEgDIAGgEQAGgCAHAAQAMAAAGAEQAGAEADAIIgSADQAAgEgCgBQgCgCgEAAQgEAAgDAEQgCADAAAGQAAAGACADQADADADAAQAEAAADgCQACgCABgEIASACQgCAGgCAEQgEAEgFACQgFACgJAAQgGAAgFgBg");
	this.shape_215.setTransform(-52.25,-175.175);

	this.shape_216 = new cjs.Shape();
	this.shape_216.graphics.f("#999999").s().p("AgSATQgJgHAAgMQAAgKAIgHQAHgHAMAAQAOAAAIAIQAGAHAAAJQAAALgHAHQgIAHgNAAQgLAAgHgGgAgGgIQgCADAAAFQAAAHACADQADADADAAQAEAAADgDQACgDAAgHQAAgFgCgEQgDgDgEAAQgDAAgDAEg");
	this.shape_216.setTransform(-58.525,-175.175);

	this.shape_217 = new cjs.Shape();
	this.shape_217.graphics.f("#999999").s().p("AgIAiIAAhDIARAAIAABDg");
	this.shape_217.setTransform(-63.225,-176.1);

	this.shape_218 = new cjs.Shape();
	this.shape_218.graphics.f("#999999").s().p("AgKAYQgGgCgDgDQgEgDgCgEQgCgFAAgHQAAgGACgFQACgEAEgDIAGgEQAGgCAHAAQAMAAAHAEQAFAEADAIIgRADQgBgEgCgBQgDgCgDAAQgEAAgDAEQgCADAAAGQAAAGACADQADADAEAAQADAAADgCQACgCABgEIASACQgBAGgEAEQgDAEgFACQgFACgJAAQgGAAgFgBg");
	this.shape_218.setTransform(-67.65,-175.175);

	this.shape_219 = new cjs.Shape();
	this.shape_219.graphics.f("#999999").s().p("AgSAZIAAgwIARAAIAAAIQACgFADgCQACgCAEAAQAEAAAFADIgFANIgGgCQgEAAgBAEQgDAEAAAKIAAARg");
	this.shape_219.setTransform(-72.65,-175.225);

	this.shape_220 = new cjs.Shape();
	this.shape_220.graphics.f("#999999").s().p("AgPAXQgFgDgEgGQgDgGAAgIQAAgKAHgHQAIgHAMAAQAKAAAGADQAGADADAGQADAGAAAIIAAADIgkAAQABAEABACQADADADAAIAGgBIACgDIATACQgEAHgGADQgGADgLAAQgJAAgGgCgAgGgKQgBACgBAFIARAAQAAgGgCgCQgDgCgEAAQgEAAgCADg");
	this.shape_220.setTransform(-78.25,-175.175);

	this.shape_221 = new cjs.Shape();
	this.shape_221.graphics.f("#999999").s().p("AgEAgQgDgCgCgDQgBgEAAgIIAAgQIgHAAIAAgNIAHAAIAAgJIARgKIAAATIALAAIAAANIgLAAIAAAQIABAFQAAAAAAAAQABAAAAABQABAAAAAAQABAAAAAAIAGgBIABAMIgNACQgGAAgDgCg");
	this.shape_221.setTransform(-83.475,-176.05);

	this.shape_222 = new cjs.Shape();
	this.shape_222.graphics.f("#999999").s().p("AAHAZIAAgaQAAgFgCgBQAAgBgBAAQAAAAgBgBQAAAAgBAAQAAAAgBAAQgDAAgCACQgCADAAAFIAAAYIgTAAIAAgwIASAAIAAAIQAEgFADgCQAEgCAFAAQAIAAAEAFQAFAEAAAKIAAAeg");
	this.shape_222.setTransform(-88.675,-175.225);

	this.shape_223 = new cjs.Shape();
	this.shape_223.graphics.f("#999999").s().p("AgUAUQgFgEAAgKIAAgeIATAAIAAAaQAAAEACACQAAABABAAQAAAAABABQAAAAABAAQABAAAAAAQADAAACgCQACgDAAgFIAAgYIATAAIAAAwIgSAAIAAgIQgEAFgEACQgDACgFAAQgIAAgEgFg");
	this.shape_223.setTransform(-94.975,-175.125);

	this.shape_224 = new cjs.Shape();
	this.shape_224.graphics.f("#999999").s().p("AgSATQgJgHAAgMQAAgKAIgHQAHgHAMAAQAOAAAIAIQAGAHAAAJQAAALgHAHQgIAHgNAAQgLAAgHgGgAgGgIQgCADAAAFQAAAHACADQADADADAAQAEAAADgDQACgDAAgHQAAgFgCgEQgDgDgEAAQgDAAgDAEg");
	this.shape_224.setTransform(-101.225,-175.175);

	this.shape_225 = new cjs.Shape();
	this.shape_225.graphics.f("#999999").s().p("AgLAYQgFgCgDgDQgEgDgCgEQgCgFAAgHQAAgGADgFQABgEADgDIAHgEQAFgCAIAAQAMAAAHAEQAFAEADAIIgRADQgBgEgDgBQgCgCgDAAQgEAAgCAEQgDADAAAGQAAAGADADQACADAEAAQADAAACgCQADgCACgEIARACQgCAGgDAEQgDAEgFACQgGACgHAAQgHAAgGgBg");
	this.shape_225.setTransform(-107.45,-175.175);

	this.shape_226 = new cjs.Shape();
	this.shape_226.graphics.f("#999999").s().p("AgPAXQgFgDgEgGQgDgGAAgIQAAgKAHgHQAIgHAMAAQAKAAAGADQAGADADAGQADAGAAAIIAAADIgkAAQABAEABACQADADADAAIAGgBIACgDIATACQgEAHgGADQgGADgLAAQgJAAgGgCgAgGgKQgBACgBAFIARAAQAAgGgCgCQgDgCgEAAQgEAAgCADg");
	this.shape_226.setTransform(-116.85,-175.175);

	this.shape_227 = new cjs.Shape();
	this.shape_227.graphics.f("#999999").s().p("AgaAiIAAhCIASAAIAAAHQADgEAEgCQACgCAGAAQAJAAAFAHQAGAIAAALQAAALgGAGQgGAHgJAAQgEAAgCgCIgHgEIAAAXgAgFgQQgCACAAAHQAAAFACACQADADADgBQADABACgDQACgBAAgHQAAgGgCgCQgCgDgEAAQgDAAgCADg");
	this.shape_227.setTransform(-123,-174.3);

	this.shape_228 = new cjs.Shape();
	this.shape_228.graphics.f("#999999").s().p("AgWAVQgFgEAAgGQAAgFADgEQAEgCAIgCIAMgDIAHgCQAAgEgBgBIgFgBQgEAAgCABQgCABgBADIgSgCIADgHQACgDADgCIAIgCIAJAAIANAAQAFABADADQADACABAEIABAHIAAAVIABAFIACAFIgSAAIgBgDIgBgDIgHAFQgEACgHAAQgIAAgEgEgAAAAEQgFABgCACQAAAAgBABQAAAAAAAAQAAABAAAAQgBABAAAAQAAABABAAQAAABAAAAQAAABAAAAQABAAAAABQAAAAABAAQAAABABAAQAAAAABAAQABAAABAAQACAAACgCIAEgDQABgCAAgEIAAgDIgHADg");
	this.shape_228.setTransform(-129.45,-175.175);

	this.shape_229 = new cjs.Shape();
	this.shape_229.graphics.f("#999999").s().p("AAHAiIAAgbQAAgFgCgBQAAgBgBAAQAAAAgBAAQAAAAgBAAQAAAAgBAAQgDAAgCABQgCADAAAGIAAAYIgTAAIAAhDIATAAIAAAZQAEgEADgCQADgBAFAAQAIAAAEAFQAFAEAAAIIAAAgg");
	this.shape_229.setTransform(-135.725,-176.1);

	this.shape_230 = new cjs.Shape();
	this.shape_230.graphics.f("#999999").s().p("AgSAWQgFgEgCgHIATgCQABADACACQACABACAAQAEAAACgBIACgDQAAgBAAAAQgBgBAAAAQAAgBAAAAQgBAAAAgBIgHgBIgOgEQgEgBgCgCQgDgEAAgEQAAgFADgEQADgDAFgCQAFgBAHAAIANABIAHAEIAEAIIgSABQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAAAgBAAQgCgCgCAAIgFABIgBADQAAABAAAAQAAAAAAABQABAAAAAAQAAAAABABIAHACIANACQAFACACADQADADAAAEQAAAFgDAEQgCAEgGACQgFACgKAAQgMAAgGgDg");
	this.shape_230.setTransform(-141.775,-175.175);

	this.shape_231 = new cjs.Shape();
	this.shape_231.graphics.f("#999999").s().p("AgOAXQgGgDgDgGQgEgGAAgIQAAgKAHgHQAHgHANAAQAJAAAHADQAGADADAGQADAGAAAIIAAADIgkAAQABAEABACQADADADAAIAFgBIADgDIATACQgEAHgGADQgGADgLAAQgJAAgFgCgAgGgKQgBACgBAFIARAAQgBgGgCgCQgCgCgEAAQgDAAgDADg");
	this.shape_231.setTransform(-150.85,-175.175);

	this.shape_232 = new cjs.Shape();
	this.shape_232.graphics.f("#999999").s().p("AgEAgQgDgCgCgDQgBgEAAgIIAAgQIgHAAIAAgNIAHAAIAAgJIARgKIAAATIALAAIAAANIgLAAIAAAQIABAFQAAAAAAAAQABAAAAABQABAAAAAAQABAAAAAAIAGgBIABAMIgNACQgGAAgDgCg");
	this.shape_232.setTransform(-156.075,-176.05);

	this.shape_233 = new cjs.Shape();
	this.shape_233.graphics.f("#999999").s().p("AgWAVQgFgEAAgGQAAgFADgEQADgCAJgCIANgDIAGgCQAAgEgBgBIgFgBQgDAAgDABQgCABgBADIgRgCIACgHQACgDADgCIAHgCIAKAAIANAAQAFABAEADQACACABAEIABAHIAAAVIABAFIACAFIgRAAIgCgDIgBgDIgHAFQgEACgHAAQgIAAgEgEgAAAAEQgGABgBACQAAAAgBABQAAAAAAAAQAAABAAAAQgBABAAAAQAAABABAAQAAABAAAAQAAABAAAAQABAAAAABQAAAAABAAQAAABABAAQAAAAABAAQABAAAAAAQADAAADgCIADgDQABgCAAgEIAAgDIgHADg");
	this.shape_233.setTransform(-161.1,-175.175);

	this.shape_234 = new cjs.Shape();
	this.shape_234.graphics.f("#999999").s().p("AgEAgQgDgCgCgDQgBgEAAgIIAAgQIgHAAIAAgNIAHAAIAAgJIARgKIAAATIALAAIAAANIgLAAIAAAQIABAFQAAAAAAAAQABAAAAABQABAAAAAAQABAAAAAAIAGgBIABAMIgNACQgGAAgDgCg");
	this.shape_234.setTransform(-166.325,-176.05);

	this.shape_235 = new cjs.Shape();
	this.shape_235.graphics.f("#999999").s().p("AgSATQgJgHAAgMQAAgKAIgHQAHgHAMAAQAOAAAIAIQAGAHAAAJQAAALgHAHQgIAHgNAAQgLAAgHgGgAgGgIQgCADAAAFQAAAHACADQADADADAAQAEAAADgDQACgDAAgHQAAgFgCgEQgDgDgEAAQgDAAgDAEg");
	this.shape_235.setTransform(-171.525,-175.175);

	this.shape_236 = new cjs.Shape();
	this.shape_236.graphics.f("#999999").s().p("AAJAiIgJgVIgEgFIgFgBIgCAAIAAAbIgVAAIAAhDIAhAAQALABAFABQAFACADAEQACAFAAAGQAAAFgBAEQgDAFgEABIgIADIAGADIADADIADAEIAKAUgAgLgGIAJAAIAEgBQABAAAAAAQABAAAAAAQABAAAAgBQAAAAABAAQAAgBAAAAQAAgBABAAQAAgBAAAAQAAgBAAgBQAAgDgCgBQgCgCgFAAIgJAAg");
	this.shape_236.setTransform(-177.7,-176.1);

	this.shape_237 = new cjs.Shape();
	this.shape_237.graphics.f("#999999").s().p("AgJAYIAAgSIATAAIAAASgAgJgFIAAgSIATAAIAAASg");
	this.shape_237.setTransform(-17.55,-190.725);

	this.shape_238 = new cjs.Shape();
	this.shape_238.graphics.f("#999999").s().p("AgPAXQgFgDgEgGQgDgGAAgIQAAgKAHgHQAIgHAMAAQAKAAAGADQAGADADAGQADAGAAAIIAAADIgkAAQAAAEACACQADADADAAIAFgBIAEgDIASACQgEAHgGADQgGADgLAAQgJAAgGgCgAgGgKQgCACAAAFIARAAQgBgGgBgCQgDgCgEAAQgDAAgDADg");
	this.shape_238.setTransform(-22.2,-190.725);

	this.shape_239 = new cjs.Shape();
	this.shape_239.graphics.f("#999999").s().p("AgSAWQgFgEgCgHIATgCQABADACACQACABACAAQAEAAACgBIACgDQAAgBAAAAQAAgBgBAAQAAgBAAAAQgBAAAAgBIgHgBIgOgEQgEgBgCgCQgDgEAAgEQAAgFADgEQADgDAFgCQAFgBAHAAIANABIAHAEIAEAIIgSABQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAAAgBAAQgCgCgCAAIgFABIgBADQAAABAAAAQAAAAAAABQABAAAAAAQAAABABAAIAHACIANACQAFACACADQADADAAAEQAAAFgDAEQgCAEgGACQgFACgKAAQgMAAgGgDg");
	this.shape_239.setTransform(-28.275,-190.725);

	this.shape_240 = new cjs.Shape();
	this.shape_240.graphics.f("#999999").s().p("AgIAiIAAgwIARAAIAAAwgAgIgUIAAgNIARAAIAAANg");
	this.shape_240.setTransform(-32.625,-191.65);

	this.shape_241 = new cjs.Shape();
	this.shape_241.graphics.f("#999999").s().p("AAKAYIgKgcIgIAcIgRAAIgSgvIASAAIAIAdIAKgdIAPAAIALAdIAIgdIARAAIgRAvg");
	this.shape_241.setTransform(-38.625,-190.725);

	this.shape_242 = new cjs.Shape();
	this.shape_242.graphics.f("#999999").s().p("AAHAiIgJgUIgHAHIAAANIgTAAIAAhDIATAAIAAAiIANgPIAYAAIgSAQIATAgg");
	this.shape_242.setTransform(-45.9,-191.65);

	this.shape_243 = new cjs.Shape();
	this.shape_243.graphics.f("#999999").s().p("AgKAYQgGgCgDgDQgEgDgCgEQgCgFAAgHQAAgGACgFQACgEAEgDIAGgEQAGgCAHAAQAMAAAGAEQAGAEADAIIgSADQAAgEgCgBQgCgCgEAAQgEAAgDAEQgCADAAAGQAAAGACADQADADADAAQAEAAADgCQACgCABgEIASACQgCAGgCAEQgEAEgFACQgFACgJAAQgGAAgFgBg");
	this.shape_243.setTransform(-52.25,-190.725);

	this.shape_244 = new cjs.Shape();
	this.shape_244.graphics.f("#999999").s().p("AgSATQgJgHAAgMQAAgKAIgHQAHgHAMAAQAOAAAIAIQAGAHAAAJQAAALgHAHQgIAHgNAAQgLAAgHgGgAgGgIQgCADAAAFQAAAHACADQADADADAAQAEAAADgDQACgDAAgHQAAgFgCgEQgDgDgEAAQgDAAgDAEg");
	this.shape_244.setTransform(-58.525,-190.725);

	this.shape_245 = new cjs.Shape();
	this.shape_245.graphics.f("#999999").s().p("AgIAiIAAhDIARAAIAABDg");
	this.shape_245.setTransform(-63.225,-191.65);

	this.shape_246 = new cjs.Shape();
	this.shape_246.graphics.f("#999999").s().p("AgKAYQgGgCgDgDQgEgDgCgEQgCgFAAgHQAAgGACgFQACgEAEgDIAGgEQAGgCAHAAQAMAAAHAEQAFAEADAIIgRADQgBgEgCgBQgDgCgDAAQgEAAgDAEQgCADAAAGQAAAGACADQADADAEAAQADAAADgCQACgCABgEIASACQgBAGgEAEQgDAEgFACQgFACgJAAQgGAAgFgBg");
	this.shape_246.setTransform(-67.65,-190.725);

	this.shape_247 = new cjs.Shape();
	this.shape_247.graphics.f("#999999").s().p("AgOAXQgGgDgDgGQgEgGAAgIQAAgKAHgHQAHgHANAAQAJAAAHADQAGADADAGQADAGAAAIIAAADIgkAAQABAEABACQADADADAAIAFgBIADgDIATACQgEAHgGADQgGADgLAAQgJAAgFgCgAgGgKQgBACgBAFIARAAQgBgGgCgCQgCgCgEAAQgDAAgDADg");
	this.shape_247.setTransform(-77.05,-190.725);

	this.shape_248 = new cjs.Shape();
	this.shape_248.graphics.f("#999999").s().p("AgaAiIAAhCIARAAIAAAHQAFgFADgBQACgCAGAAQAJAAAFAHQAGAHAAALQAAAMgGAGQgGAGgJABQgEgBgCgBIgHgEIAAAXgAgFgRQgCADAAAGQAAAGACACQADACACAAQADAAADgCQACgCAAgGQAAgGgCgDQgCgCgEAAQgCAAgDACg");
	this.shape_248.setTransform(-83.2,-189.85);

	this.shape_249 = new cjs.Shape();
	this.shape_249.graphics.f("#999999").s().p("AgWAVQgFgEAAgGQAAgFADgEQADgCAJgCIAMgDIAHgCQABgEgCgBIgFgBQgEAAgCABQgBABAAAAQAAAAgBABQAAAAAAABQgBAAAAABIgSgCIADgHQACgDADgCIAHgCIAKAAIANAAQAFABAEADQACACABAEIABAHIAAAVIABAFIACAFIgRAAIgCgDIgBgDIgHAFQgEACgHAAQgIAAgEgEgAAAAEQgFABgCACQAAAAgBABQAAAAAAAAQAAABAAAAQgBABAAAAQAAABABAAQAAABAAAAQAAABAAAAQABAAAAABQAAAAABAAQAAABABAAQAAAAABAAQABAAAAAAQADAAADgCIADgDQACgCgBgEIAAgDIgHADg");
	this.shape_249.setTransform(-89.65,-190.725);

	this.shape_250 = new cjs.Shape();
	this.shape_250.graphics.f("#999999").s().p("AAHAiIAAgbQAAgFgCgCQAAAAgBAAQAAAAgBAAQAAAAgBAAQgBAAAAAAQgDgBgCACQgCACAAAHIAAAYIgTAAIAAhDIATAAIAAAZQAEgEADgCQADgBAFAAQAIAAAEAFQAFAEAAAIIAAAgg");
	this.shape_250.setTransform(-95.925,-191.65);

	this.shape_251 = new cjs.Shape();
	this.shape_251.graphics.f("#999999").s().p("AgSAWQgFgEgCgHIATgCQABADACACQACABACAAQAEAAACgBIACgDQAAgBAAAAQAAgBgBAAQAAgBAAAAQgBAAAAgBIgHgBIgOgEQgEgBgCgCQgDgEAAgEQAAgFADgEQADgDAFgCQAFgBAHAAIANABIAHAEIAEAIIgSABQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAAAgBAAQgCgCgCAAIgFABIgBADQAAABAAAAQAAAAAAABQABAAAAAAQAAABABAAIAHACIANACQAFACACADQADADAAAEQAAAFgDAEQgCAEgGACQgFACgKAAQgMAAgGgDg");
	this.shape_251.setTransform(-101.975,-190.725);

	this.shape_252 = new cjs.Shape();
	this.shape_252.graphics.f("#999999").s().p("AgOAXQgGgDgDgGQgEgGAAgIQAAgKAHgHQAHgHANAAQAJAAAHADQAGADADAGQADAGAAAIIAAADIgkAAQAAAEACACQADADADAAIAFgBIAEgDIASACQgEAHgGADQgGADgLAAQgJAAgFgCgAgGgKQgCACAAAFIARAAQgBgGgCgCQgCgCgEAAQgDAAgDADg");
	this.shape_252.setTransform(-111.05,-190.725);

	this.shape_253 = new cjs.Shape();
	this.shape_253.graphics.f("#999999").s().p("AgEAgQgDgCgCgDQgBgEAAgIIAAgQIgHAAIAAgNIAHAAIAAgJIARgKIAAATIALAAIAAANIgLAAIAAAQIABAFQAAAAAAAAQABAAAAABQABAAAAAAQABAAAAAAIAGgBIABAMIgNACQgGAAgDgCg");
	this.shape_253.setTransform(-116.275,-191.6);

	this.shape_254 = new cjs.Shape();
	this.shape_254.graphics.f("#999999").s().p("AgXAVQgEgEAAgGQAAgFADgEQAEgCAIgCIANgDIAHgCQAAgEgCgBIgFgBQgDAAgDABQgCABgBADIgRgCIACgHQACgDAEgCIAGgCIALAAIAMAAQAFABADADQADACABAEIACAHIAAAVIAAAFIACAFIgRAAIgCgDIAAgDIgIAFQgEACgGAAQgJAAgFgEgAAAAEQgGABgBACQAAAAgBABQAAAAAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQABAAAAABQAAAAABAAQAAABABAAQAAAAABAAQABAAAAAAQADAAACgCIAEgDQACgCAAgEIAAgDIgIADg");
	this.shape_254.setTransform(-121.3,-190.725);

	this.shape_255 = new cjs.Shape();
	this.shape_255.graphics.f("#999999").s().p("AgEAgQgDgCgCgDQgBgEAAgIIAAgQIgHAAIAAgNIAHAAIAAgJIARgKIAAATIALAAIAAANIgLAAIAAAQIABAFQAAAAAAAAQABAAAAABQABAAAAAAQABAAAAAAIAGgBIABAMIgNACQgGAAgDgCg");
	this.shape_255.setTransform(-126.525,-191.6);

	this.shape_256 = new cjs.Shape();
	this.shape_256.graphics.f("#999999").s().p("AgSATQgJgHAAgMQAAgKAIgHQAHgHAMAAQAOAAAIAIQAGAHAAAJQAAALgHAHQgIAHgNAAQgLAAgHgGgAgGgIQgCADAAAFQAAAHACADQADADADAAQAEAAADgDQACgDAAgHQAAgFgCgEQgDgDgEAAQgDAAgDAEg");
	this.shape_256.setTransform(-131.725,-190.725);

	this.shape_257 = new cjs.Shape();
	this.shape_257.graphics.f("#999999").s().p("AAJAiIgKgVIgDgFIgFgBIgCAAIAAAbIgVAAIAAhDIAhAAQALAAAEACQAFABADAFQADAEAAAHQAAAFgCAEQgCAEgEACIgHADIAFADIADADIADAEIAKAUgAgLgGIAJAAIAEgBQABAAAAAAQABAAAAAAQABgBAAAAQAAAAABgBQAAAAAAAAQAAgBABAAQAAgBAAAAQAAgBAAAAQAAgEgCgCQgCgBgFAAIgJAAg");
	this.shape_257.setTransform(-137.9,-191.65);

	this.shape_258 = new cjs.Shape();
	this.shape_258.graphics.f("#999999").s().p("AgJAYIAAgSIATAAIAAASgAgJgFIAAgSIATAAIAAASg");
	this.shape_258.setTransform(-17.55,-206.275);

	this.shape_259 = new cjs.Shape();
	this.shape_259.graphics.f("#999999").s().p("AgXAhIgCgNQAEABAFABQADgBACgBQADgCABgEIgVgvIAUAAIAJAgIAKggIASAAIgTAzQgEAJgDADQgEAEgKAAIgMgBg");
	this.shape_259.setTransform(-21.95,-205.3);

	this.shape_260 = new cjs.Shape();
	this.shape_260.graphics.f("#999999").s().p("AgIAhIAAhBIARAAIAABBg");
	this.shape_260.setTransform(-26.525,-207.2);

	this.shape_261 = new cjs.Shape();
	this.shape_261.graphics.f("#999999").s().p("AgIAhIAAhBIARAAIAABBg");
	this.shape_261.setTransform(-29.625,-207.2);

	this.shape_262 = new cjs.Shape();
	this.shape_262.graphics.f("#999999").s().p("AgXAVQgEgEAAgGQAAgFADgEQADgCAJgCIANgDIAHgCQAAgEgCgBIgFgBQgDAAgDABQgCABgBADIgRgCIACgHQACgDAEgCIAHgCIAKAAIAMAAQAFABADADQADACABAEIACAHIAAAVIAAAFIACAFIgSAAIgBgDIAAgDIgIAFQgEACgGAAQgJAAgFgEgAAAAEQgFABgCACQAAAAgBABQAAAAAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQABAAAAABQAAAAABAAQAAABABAAQAAAAABAAQABAAAAAAQADAAACgCIAEgDQACgCAAgEIAAgDIgIADg");
	this.shape_262.setTransform(-34.35,-206.275);

	this.shape_263 = new cjs.Shape();
	this.shape_263.graphics.f("#999999").s().p("AgEAgQgDgBgCgEQgBgEAAgIIAAgQIgHAAIAAgOIAHAAIAAgJIARgJIAAASIALAAIAAAOIgLAAIAAAQIABAEQAAABAAAAQABAAAAABQABAAAAAAQABAAAAAAIAGgCIABANIgNACQgGAAgDgCg");
	this.shape_263.setTransform(-39.575,-207.15);

	this.shape_264 = new cjs.Shape();
	this.shape_264.graphics.f("#999999").s().p("AAHAZIAAgaQAAgFgCgBQAAgBgBAAQAAgBgBAAQAAAAgBAAQgBAAAAAAQgDAAgCACQgCADAAAFIAAAYIgTAAIAAgwIASAAIAAAIQAEgFADgCQAEgCAFAAQAIAAAEAFQAFAEAAAKIAAAeg");
	this.shape_264.setTransform(-44.775,-206.325);

	this.shape_265 = new cjs.Shape();
	this.shape_265.graphics.f("#999999").s().p("AgSATQgJgHAAgMQAAgKAIgHQAHgHAMAAQAOAAAIAIQAGAHAAAJQAAALgHAHQgIAHgNAAQgLAAgHgGgAgGgIQgCADAAAFQAAAHACADQADADADAAQAEAAADgDQACgDAAgHQAAgFgCgEQgDgDgEAAQgDAAgDAEg");
	this.shape_265.setTransform(-51.025,-206.275);

	this.shape_266 = new cjs.Shape();
	this.shape_266.graphics.f("#999999").s().p("AgXAYIAAgMIAXgXIgVAAIAAgMIAsAAIAAALIgYAYIAZAAIAAAMg");
	this.shape_266.setTransform(-56.725,-206.275);

	this.shape_267 = new cjs.Shape();
	this.shape_267.graphics.f("#999999").s().p("AgIAhIAAgvIARAAIAAAvgAgIgUIAAgMIARAAIAAAMg");
	this.shape_267.setTransform(-60.825,-207.2);

	this.shape_268 = new cjs.Shape();
	this.shape_268.graphics.f("#999999").s().p("AgSAZIAAgwIASAAIAAAIQABgFACgCQADgCAEAAQAEAAAFADIgGANIgFgCQgEAAgCAEQgCAEAAAKIAAARg");
	this.shape_268.setTransform(-64.05,-206.325);

	this.shape_269 = new cjs.Shape();
	this.shape_269.graphics.f("#999999").s().p("AgSATQgJgHAAgMQAAgKAIgHQAHgHAMAAQAOAAAIAIQAGAHAAAJQAAALgHAHQgIAHgNAAQgLAAgHgGgAgGgIQgCADAAAFQAAAHACADQADADADAAQAEAAADgDQACgDAAgHQAAgFgCgEQgDgDgEAAQgDAAgDAEg");
	this.shape_269.setTransform(-69.725,-206.275);

	this.shape_270 = new cjs.Shape();
	this.shape_270.graphics.f("#999999").s().p("AAHAhIAAgaQAAgFgCgCQAAAAgBAAQAAAAgBAAQAAAAgBAAQAAgBgBAAQgDABgCABQgCACAAAHIAAAXIgTAAIAAhBIATAAIAAAYQAEgEADgBQADgCAFAAQAIAAAEAEQAFAFAAAJIAAAeg");
	this.shape_270.setTransform(-75.975,-207.2);

	this.shape_271 = new cjs.Shape();
	this.shape_271.graphics.f("#999999").s().p("AgSAWQgFgEgCgHIATgCQABADACACQACABACAAQAEAAACgBIACgDQAAgBAAAAQAAgBgBAAQAAgBAAAAQgBAAAAgBIgHgBIgOgEQgEgBgCgCQgDgEAAgEQAAgFADgEQADgDAFgCQAFgBAHAAIANABIAHAEIAEAIIgSABQAAAAAAgBQAAAAgBgBQAAAAAAgBQAAAAgBAAQgCgCgCAAIgFABIgBADQAAABAAAAQAAAAAAABQAAAAABAAQAAABABAAIAHACIANACQAFACACADQADADAAAEQAAAFgDAEQgCAEgGACQgFACgKAAQgMAAgGgDg");
	this.shape_271.setTransform(-85.125,-206.275);

	this.shape_272 = new cjs.Shape();
	this.shape_272.graphics.f("#999999").s().p("AgPAXQgFgDgEgGQgDgGAAgIQAAgKAHgHQAIgHAMAAQAKAAAGADQAGADADAGQADAGAAAIIAAADIgkAAQAAAEACACQADADADAAIAFgBIAEgDIASACQgEAHgGADQgGADgLAAQgJAAgGgCgAgGgKQgCACAAAFIARAAQgBgGgBgCQgDgCgEAAQgDAAgDADg");
	this.shape_272.setTransform(-91.05,-206.275);

	this.shape_273 = new cjs.Shape();
	this.shape_273.graphics.f("#999999").s().p("AgaAiIAAhCIARAAIAAAHQAFgEACgCQAEgCAEAAQAKAAAGAHQAFAIAAAKQAAAMgGAGQgGAGgJAAQgEABgDgCIgGgEIAAAXgAgEgRQgDADAAAGQAAAGADACQACADADAAQACAAADgDQACgCAAgGQAAgGgCgDQgDgDgDAAQgCAAgCADg");
	this.shape_273.setTransform(-97.2,-205.4);

	this.shape_274 = new cjs.Shape();
	this.shape_274.graphics.f("#999999").s().p("AgXAVQgEgEAAgGQAAgFADgEQADgCAJgCIANgDIAHgCQAAgEgCgBIgFgBQgDAAgDABQgCABgBADIgRgCIACgHQACgDAEgCIAHgCIAKAAIAMAAQAFABADADQADACABAEIACAHIAAAVIAAAFIACAFIgSAAIgBgDIAAgDIgIAFQgEACgGAAQgJAAgFgEgAAAAEQgFABgCACQAAAAgBABQAAAAAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQAAABAAAAQABAAAAABQAAAAABAAQAAABABAAQAAAAABAAQABAAAAAAQADAAACgCIAEgDQACgCAAgEIAAgDIgIADg");
	this.shape_274.setTransform(-103.65,-206.275);

	this.shape_275 = new cjs.Shape();
	this.shape_275.graphics.f("#999999").s().p("AAHAhIAAgaQAAgFgCgCQAAAAgBAAQAAAAgBAAQAAAAgBAAQgBgBAAAAQgDABgCABQgCACAAAHIAAAXIgTAAIAAhBIATAAIAAAYQAEgEADgBQADgCAFAAQAIAAAEAEQAFAFAAAJIAAAeg");
	this.shape_275.setTransform(-109.925,-207.2);

	this.shape_276 = new cjs.Shape();
	this.shape_276.graphics.f("#999999").s().p("AgSAWQgFgEgCgHIATgCQABADACACQACABACAAQAEAAACgBIACgDQAAgBAAAAQgBgBAAAAQAAgBAAAAQgBAAAAgBIgHgBIgOgEQgEgBgCgCQgDgEAAgEQAAgFADgEQADgDAFgCQAFgBAHAAIANABIAHAEIAEAIIgSABQAAAAAAgBQAAAAgBgBQAAAAAAgBQAAAAgBAAQgCgCgCAAIgFABIgBADQAAABAAAAQAAAAAAABQAAAAABAAQAAABABAAIAHACIANACQAFACACADQADADAAAEQAAAFgDAEQgCAEgGACQgFACgKAAQgMAAgGgDg");
	this.shape_276.setTransform(-115.975,-206.275);

	this.shape_277 = new cjs.Shape();
	this.shape_277.graphics.f("#999999").s().p("AgPAXQgFgDgEgGQgDgGAAgIQAAgKAHgHQAIgHAMAAQAKAAAGADQAGADADAGQADAGAAAIIAAADIgkAAQABAEABACQADADADAAIAGgBIACgDIATACQgEAHgGADQgGADgLAAQgJAAgGgCgAgGgKQgBACgBAFIARAAQAAgGgCgCQgDgCgEAAQgEAAgCADg");
	this.shape_277.setTransform(-125.05,-206.275);

	this.shape_278 = new cjs.Shape();
	this.shape_278.graphics.f("#999999").s().p("AgHAYIgVgvIAUAAIAIAdIAKgdIATAAIgVAvg");
	this.shape_278.setTransform(-130.775,-206.275);

	this.shape_279 = new cjs.Shape();
	this.shape_279.graphics.f("#999999").s().p("AgSATQgJgHAAgMQAAgKAIgHQAHgHAMAAQAOAAAIAIQAGAHAAAJQAAALgHAHQgIAHgNAAQgLAAgHgGgAgGgIQgCADAAAFQAAAHACADQADADADAAQAEAAADgDQACgDAAgHQAAgFgCgEQgDgDgEAAQgDAAgDAEg");
	this.shape_279.setTransform(-136.475,-206.275);

	this.shape_280 = new cjs.Shape();
	this.shape_280.graphics.f("#999999").s().p("AAVAhIAAgyIgNAyIgPAAIgNgyIAAAyIgRAAIAAhBIAcAAIAJAnIALgnIAbAAIAABBg");
	this.shape_280.setTransform(-144.025,-207.2);

	this.shape_281 = new cjs.Shape();
	this.shape_281.graphics.f("#FFFFFF").s().p("AAVAhIgGgFQgGADgKAAQgPAAgJgHQgKgKAAgQQAAgRAJgIQAJgKAQAAQAQAAAJAJQAJAJAAARQABAOgIAIIAFAEIAFADIgGALIgJgFgAgLgRQgDAFAAAJQAAAKADAEQAEAFAGAAIAEAAQgDgDgFgCIADgIIAEABIAGAFIACABQACgFAAgHQAAgLgDgEQgEgEgGAAQgGAAgEAEg");
	this.shape_281.setTransform(-9.35,-128.75);

	this.shape_282 = new cjs.Shape();
	this.shape_282.graphics.f("#FFFFFF").s().p("AgbAiIAAhDIAhAAQALAAAGAGQAFAFAAAKQAAAKgGAFQgGAFgMABIgLAAIAAAZgAgHgEIAFAAQAFAAADgCQACgCAAgEQAAgCgCgDQgCgCgFAAIgGAAg");
	this.shape_282.setTransform(-9.875,-144.6);

	this.shape_283 = new cjs.Shape();
	this.shape_283.graphics.f("#FFFFFF").s().p("AgYAhIgBgNQAEACAFAAQADAAACgCQACgBACgEIgUgwIATAAIAJAgIAJggIASAAIgSAzQgEAIgEAEQgDAEgKAAIgNgBg");
	this.shape_283.setTransform(72.75,-158.25);

	this.shape_284 = new cjs.Shape();
	this.shape_284.graphics.f("#FFFFFF").s().p("AgPAXQgFgDgEgGQgDgGAAgIQAAgKAHgHQAIgHAMAAQAKAAAGADQAGADADAGQADAGAAAIIAAADIgkAAQABAEABACQADADADAAIAGgBIACgDIATACQgEAHgGADQgGADgLAAQgJAAgGgCgAgGgKQgBACgBAFIARAAQAAgGgCgCQgDgCgEAAQgEAAgCADg");
	this.shape_284.setTransform(66.75,-159.225);

	this.shape_285 = new cjs.Shape();
	this.shape_285.graphics.f("#FFFFFF").s().p("AAKAiIgNgcIgLALIAAARIgVAAIAAhDIAVAAIAAAZIAVgZIAcAAIgZAZIAaAqg");
	this.shape_285.setTransform(60.35,-160.15);

	this.shape_286 = new cjs.Shape();
	this.shape_286.graphics.f("#FFFFFF").s().p("AAKAYIgKgcIgIAcIgRAAIgSgvIASAAIAIAdIAKgdIAPAAIALAdIAIgdIARAAIgRAvg");
	this.shape_286.setTransform(48.525,-159.225);

	this.shape_287 = new cjs.Shape();
	this.shape_287.graphics.f("#FFFFFF").s().p("AgSATQgJgHAAgMQAAgKAIgHQAHgHAMAAQAOAAAIAIQAGAHAAAJQAAALgHAHQgIAHgNAAQgLAAgHgGgAgGgIQgCADAAAFQAAAHACADQADADADAAQAEAAADgDQACgDAAgHQAAgFgCgEQgDgDgEAAQgDAAgDAEg");
	this.shape_287.setTransform(41.175,-159.225);

	this.shape_288 = new cjs.Shape();
	this.shape_288.graphics.f("#FFFFFF").s().p("AgSAZIAAgwIASAAIAAAIQABgFACgCQADgCAEAAQAEAAAFADIgGANIgFgCQgDAAgCAEQgDAEAAAKIAAARg");
	this.shape_288.setTransform(36.2,-159.275);

	this.shape_289 = new cjs.Shape();
	this.shape_289.graphics.f("#FFFFFF").s().p("AgSAZIAAgwIASAAIAAAIQABgFADgCQACgCAEAAQAEAAAFADIgFANIgGgCQgDAAgDAEQgCAEAAAKIAAARg");
	this.shape_289.setTransform(31.65,-159.275);

	this.shape_290 = new cjs.Shape();
	this.shape_290.graphics.f("#FFFFFF").s().p("AAPAiIgEgLIgWAAIgDALIgVAAIAZhDIAVAAIAaBDgAgHAIIAPAAIgIgXg");
	this.shape_290.setTransform(25.5,-160.15);

	this.shape_291 = new cjs.Shape();
	this.shape_291.graphics.f("#FFFFFF").s().p("AAMAiIgXgkIAAAkIgUAAIAAhDIAUAAIAXAkIAAgkIAUAAIAABDg");
	this.shape_291.setTransform(14.8,-160.15);

	this.shape_292 = new cjs.Shape();
	this.shape_292.graphics.f("#FFFFFF").s().p("AAMAiIgMgqIgLAqIgUAAIgPhDIAUAAIAHAlIAKglIATAAIAKAlIAIglIATAAIgPBDg");
	this.shape_292.setTransform(6.25,-160.15);

	this.shape_293 = new cjs.Shape();
	this.shape_293.graphics.f("#FFFFFF").s().p("AgRAfQgIgDgEgIQgFgIAAgMQAAgPAJgJQAJgKAQAAQAQAAAJAJQAKAJAAAQQAAALgEAIQgEAIgIAEQgHAEgMAAQgKAAgHgEgAgJgNQgEAEAAAJQAAAKAEAFQADAEAGAAQAGAAAEgEQAEgEAAgLQAAgJgEgEQgEgFgGAAQgGAAgDAFg");
	this.shape_293.setTransform(-2.175,-160.175);

	this.shape_294 = new cjs.Shape();
	this.shape_294.graphics.f("#FFFFFF").s().p("AgeAiIAAhDIAeAAQAJAAAFADQAHADADAEQADAEACAHIACAMQAAAKgDAHQgCAFgFAEQgDAEgGACQgGACgGAAgAgJASIAFAAQAFABADgCQADgCACgDQABgEAAgIQAAgJgDgFQgEgEgHAAIgFAAg");
	this.shape_294.setTransform(-9.6,-160.15);

	this.shape_295 = new cjs.Shape();
	this.shape_295.graphics.f("#FFFFFF").s().p("AgfAhIAAgOIAkgmIggAAIAAgNIA5AAIAAANIglAmIAnAAIAAAOg");
	this.shape_295.setTransform(-10.05,-175.7);

	this.shape_296 = new cjs.Shape();
	this.shape_296.graphics.f("#FFFFFF").s().p("AAOAhIgOgVIgMAVIgYAAIAYgiIgVgfIAWAAIALAUIAMgUIAWAAIgUAgIAWAhg");
	this.shape_296.setTransform(64.25,-191.25);

	this.shape_297 = new cjs.Shape();
	this.shape_297.graphics.f("#FFFFFF").s().p("AgMAjIAQhFIAJAAIgQBFg");
	this.shape_297.setTransform(59.325,-191.275);

	this.shape_298 = new cjs.Shape();
	this.shape_298.graphics.f("#FFFFFF").s().p("AgYAhIgBgNQAEABAFAAQADAAACgBQACgBACgFIgUgvIATAAIAJAgIAJggIASAAIgSAzQgEAJgEADQgDAEgKAAIgNgBg");
	this.shape_298.setTransform(55.2,-189.35);

	this.shape_299 = new cjs.Shape();
	this.shape_299.graphics.f("#FFFFFF").s().p("AgPAXQgFgDgEgGQgDgGAAgIQAAgKAHgHQAIgHAMAAQAKAAAGADQAGADADAGQADAGAAAIIAAADIgkAAQABAEABACQADADADAAIAGgBIACgDIATACQgEAHgGADQgGADgLAAQgJAAgGgCgAgGgKQgBACgBAFIARAAQAAgGgCgCQgDgCgEAAQgEAAgCADg");
	this.shape_299.setTransform(49.2,-190.325);

	this.shape_300 = new cjs.Shape();
	this.shape_300.graphics.f("#FFFFFF").s().p("AAKAhIgNgbIgLALIAAAQIgVAAIAAhBIAVAAIAAAZIAVgZIAcAAIgZAZIAZAog");
	this.shape_300.setTransform(42.8,-191.25);

	this.shape_301 = new cjs.Shape();
	this.shape_301.graphics.f("#FFFFFF").s().p("AAKAYIgKgcIgIAcIgRAAIgSgvIASAAIAIAdIAKgdIAPAAIALAdIAIgdIARAAIgRAvg");
	this.shape_301.setTransform(30.975,-190.325);

	this.shape_302 = new cjs.Shape();
	this.shape_302.graphics.f("#FFFFFF").s().p("AgSATQgJgHAAgMQAAgKAIgHQAHgHAMAAQAOAAAIAIQAGAHAAAJQAAALgHAHQgIAHgNAAQgLAAgHgGgAgGgIQgCADAAAFQAAAHACADQADADADAAQAEAAADgDQACgDAAgHQAAgFgCgEQgDgDgEAAQgDAAgDAEg");
	this.shape_302.setTransform(23.625,-190.325);

	this.shape_303 = new cjs.Shape();
	this.shape_303.graphics.f("#FFFFFF").s().p("AgSAZIAAgwIASAAIAAAIQABgFACgCQADgCAEAAQAEAAAFADIgGANIgFgCQgDAAgDAEQgCAEAAAKIAAARg");
	this.shape_303.setTransform(18.65,-190.375);

	this.shape_304 = new cjs.Shape();
	this.shape_304.graphics.f("#FFFFFF").s().p("AgSAZIAAgwIARAAIAAAIQACgFADgCQACgCAEAAQAEAAAFADIgFANIgGgCQgDAAgDAEQgCAEAAAKIAAARg");
	this.shape_304.setTransform(14.1,-190.375);

	this.shape_305 = new cjs.Shape();
	this.shape_305.graphics.f("#FFFFFF").s().p("AAPAhIgEgLIgWAAIgDALIgVAAIAZhBIAVAAIAaBBgAgHAIIAPAAIgIgXg");
	this.shape_305.setTransform(7.95,-191.25);

	this.shape_306 = new cjs.Shape();
	this.shape_306.graphics.f("#FFFFFF").s().p("AgbAhIAAhBIAhAAQALAAAGAEQAFAGAAAKQAAAKgGAFQgGAGgMgBIgLAAIAAAZgAgHgEIAFAAQAFAAADgCQACgCAAgEQAAgDgCgCQgCgCgFAAIgGAAg");
	this.shape_306.setTransform(-2.075,-191.25);

	this.shape_307 = new cjs.Shape();
	this.shape_307.graphics.f("#FFFFFF").s().p("AgIAiQgGgBgEgCIgHgGQgDgEgBgEQgCgGAAgFIAAgnIAUAAIAAAoQAAAGADADQADACAFAAQAFAAADgCQADgDAAgGIAAgoIAVAAIAAAnQAAAGgCAFQgCAGgEADQgEAEgEACQgGACgIAAIgKAAg");
	this.shape_307.setTransform(-9.475,-191.2);

	this.shape_308 = new cjs.Shape();
	this.shape_308.graphics.f("#FFFFFF").s().p("AgSAWQgFgEgCgHIATgCQABADACACQACABACAAQAEAAACgBIACgDQAAgBAAAAQAAgBgBAAQAAgBAAAAQgBAAAAgBIgHgBIgOgEQgEgBgCgCQgDgEAAgEQAAgFADgEQADgDAFgCQAFgBAHAAIANABIAHAEIAEAIIgSABQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAAAgBAAQgCgCgCAAIgFABIgBADQAAABAAAAQAAAAAAABQAAAAABAAQAAAAABABIAHACIANACQAFACACADQADADAAAEQAAAFgDAEQgCAEgGACQgFACgKAAQgMAAgGgDg");
	this.shape_308.setTransform(108.275,-205.875);

	this.shape_309 = new cjs.Shape();
	this.shape_309.graphics.f("#FFFFFF").s().p("AgXAhIgCgNQAEACAFgBQADABACgCQACgCACgEIgVgvIAUAAIAJAgIAKggIASAAIgTAzQgEAIgDAEQgEAEgKAAIgMgBg");
	this.shape_309.setTransform(102.6,-204.9);

	this.shape_310 = new cjs.Shape();
	this.shape_310.graphics.f("#FFFFFF").s().p("AgPAXQgFgDgEgGQgDgGAAgIQAAgKAHgHQAIgHAMAAQAKAAAGADQAGADADAGQADAGAAAIIAAADIgkAAQAAAEACACQADADADAAIAFgBIAEgDIASACQgEAHgGADQgGADgLAAQgJAAgGgCgAgGgKQgCACAAAFIARAAQgBgGgBgCQgDgCgEAAQgDAAgDADg");
	this.shape_310.setTransform(96.6,-205.875);

	this.shape_311 = new cjs.Shape();
	this.shape_311.graphics.f("#FFFFFF").s().p("AAKAhIgNgbIgLALIAAAQIgUAAIAAhCIAUAAIAAAaIAVgaIAcAAIgZAaIAaAog");
	this.shape_311.setTransform(90.2,-206.8);

	this.shape_312 = new cjs.Shape();
	this.shape_312.graphics.f("#FFFFFF").s().p("AAKAYIgKgcIgIAcIgRAAIgSgvIASAAIAIAdIAKgdIAPAAIALAdIAIgdIARAAIgRAvg");
	this.shape_312.setTransform(78.425,-205.875);

	this.shape_313 = new cjs.Shape();
	this.shape_313.graphics.f("#FFFFFF").s().p("AgSATQgJgHAAgMQAAgKAIgHQAHgHAMAAQAOAAAIAIQAGAHAAAJQAAALgHAHQgIAHgNAAQgLAAgHgGgAgGgIQgCADAAAFQAAAHACADQADADADAAQAEAAADgDQACgDAAgHQAAgFgCgEQgDgDgEAAQgDAAgDAEg");
	this.shape_313.setTransform(71.025,-205.875);

	this.shape_314 = new cjs.Shape();
	this.shape_314.graphics.f("#FFFFFF").s().p("AgSAZIAAgwIASAAIAAAIQABgFACgCQADgCAEAAQAEAAAFADIgGANIgFgCQgEAAgCAEQgCAEAAAKIAAARg");
	this.shape_314.setTransform(66.1,-205.925);

	this.shape_315 = new cjs.Shape();
	this.shape_315.graphics.f("#FFFFFF").s().p("AgSAZIAAgwIASAAIAAAIQABgFACgCQADgCAEAAQAEAAAFADIgGANIgFgCQgEAAgCAEQgCAEAAAKIAAARg");
	this.shape_315.setTransform(61.5,-205.925);

	this.shape_316 = new cjs.Shape();
	this.shape_316.graphics.f("#FFFFFF").s().p("AAPAhIgDgLIgXAAIgDALIgWAAIAahCIAWAAIAZBCgAgGAIIANAAIgHgXg");
	this.shape_316.setTransform(55.35,-206.8);

	this.shape_317 = new cjs.Shape();
	this.shape_317.graphics.f("#FFFFFF").s().p("AgJAhIAAgxIgVAAIAAgRIA+AAIAAARIgWAAIAAAxg");
	this.shape_317.setTransform(45.15,-206.8);

	this.shape_318 = new cjs.Shape();
	this.shape_318.graphics.f("#FFFFFF").s().p("AAMAhIAAgbIgXAAIAAAbIgUAAIAAhCIAUAAIAAAYIAXAAIAAgYIAUAAIAABCg");
	this.shape_318.setTransform(37.9,-206.8);

	this.shape_319 = new cjs.Shape();
	this.shape_319.graphics.f("#FFFFFF").s().p("AgSAfQgHgEgEgIQgEgIAAgLQAAgKAEgIQAFgIAJgEQAGgEALAAQALAAAFACQAGADAEAEQADAEACAGIgUAEQgBgEgDgCQgDgCgEAAQgGAAgFAFQgDAFAAAJQAAALADAFQAFAEAGAAIAHgBIAHgDIAAgHIgOAAIAAgNIAgAAIAAAcQgJAGgHADQgHACgKAAQgLAAgIgEg");
	this.shape_319.setTransform(30.05,-206.825);

	this.shape_320 = new cjs.Shape();
	this.shape_320.graphics.f("#FFFFFF").s().p("AgJAhIAAhCIATAAIAABCg");
	this.shape_320.setTransform(24.35,-206.8);

	this.shape_321 = new cjs.Shape();
	this.shape_321.graphics.f("#FFFFFF").s().p("AAJAhIgKgUIgDgFIgFgCIgCAAIAAAbIgVAAIAAhCIAiAAQAJABAFABQAGACACAEQADAFAAAGQAAAGgCADQgCAEgEACIgHADIAFACIADAEIADAEIAKATgAgLgGIAIAAIAFAAQABgBAAAAQABAAAAAAQABAAAAgBQAAAAAAAAQABgBAAAAQAAgBABAAQAAgBAAAAQAAgBAAgBQAAgCgCgCQgCgCgFAAIgJAAg");
	this.shape_321.setTransform(19.25,-206.8);

	this.shape_322 = new cjs.Shape();
	this.shape_322.graphics.f("#FFFFFF").s().p("AgMAjIAQhFIAJAAIgQBFg");
	this.shape_322.setTransform(13.975,-206.825);

	this.shape_323 = new cjs.Shape();
	this.shape_323.graphics.f("#FFFFFF").s().p("AgJAhIAAgxIgVAAIAAgRIA+AAIAAARIgWAAIAAAxg");
	this.shape_323.setTransform(9.25,-206.8);

	this.shape_324 = new cjs.Shape();
	this.shape_324.graphics.f("#FFFFFF").s().p("AgYAhIAAhCIAyAAIAAAPIgeAAIAAAMIAZAAIAAAMIgZAAIAAAbg");
	this.shape_324.setTransform(2.9,-206.8);

	this.shape_325 = new cjs.Shape();
	this.shape_325.graphics.f("#FFFFFF").s().p("AgbAhIAAhCIA2AAIAAAPIgiAAIAAALIAgAAIAAAMIggAAIAAAOIAjAAIAAAOg");
	this.shape_325.setTransform(-3.625,-206.8);

	this.shape_326 = new cjs.Shape();
	this.shape_326.graphics.f("#FFFFFF").s().p("AgZAhIAAhCIAUAAIAAAyIAgAAIAAAQg");
	this.shape_326.setTransform(-10.05,-206.8);

	this.shape_327 = new cjs.Shape();
	this.shape_327.graphics.f("#FFFFFF").s().p("AhPBOIAAibICfAAIAACbg");
	this.shape_327.setTransform(-120.56,-250.7303,0.2493,0.2493);

	this.shape_328 = new cjs.Shape();
	this.shape_328.graphics.f("#FFFFFF").s().p("AhPBOIAAibICfAAIAACbg");
	this.shape_328.setTransform(-116.1106,-241.9436,0.2493,0.2493);

	this.shape_329 = new cjs.Shape();
	this.shape_329.graphics.f("#FFFFFF").s().p("AhPBOIAAibICfAAIAACbg");
	this.shape_329.setTransform(-116.1106,-246.2809,0.2493,0.2493);

	this.shape_330 = new cjs.Shape();
	this.shape_330.graphics.f("#FFFFFF").s().p("AhPBOIAAibICfAAIAACbg");
	this.shape_330.setTransform(-111.6612,-250.6244,0.2493,0.2493);

	this.shape_331 = new cjs.Shape();
	this.shape_331.graphics.f("#FFFFFF").s().p("AhPBOIAAibICfAAIAACbg");
	this.shape_331.setTransform(-116.1106,-250.6244,0.2493,0.2493);

	this.shape_332 = new cjs.Shape();
	this.shape_332.graphics.f("#FFFFFF").s().p("AhPBOIAAibICfAAIAACbg");
	this.shape_332.setTransform(-116.1106,-254.9616,0.2493,0.2493);

	this.shape_333 = new cjs.Shape();
	this.shape_333.graphics.f("#FFFFFF").s().p("AhzCtQg4gugJhUIBkAlQgSAZAZAlQAbAmAuAAQAuAAAbgWQAcgYAAgpQAAgkgRgRQgOgPgUADIiNAXQgPgNgQgWQgegsAAgtQAAg/AtgoQAsgmBAAAQAjAAAlAQQA6AZAgA6IhWASQAAgZgSgZQgXgggkAAQggAAgZAUQgZAVAAAeQAAAbATAWQAUAVAVgEICVgYIAbAjQAbAsAAA1QAABGg1ApQgxAmhHAAQhJAAgygqg");
	this.shape_333.setTransform(-73.3924,-247.3015,0.2493,0.2493);

	this.shape_334 = new cjs.Shape();
	this.shape_334.graphics.f("#FFFFFF").s().p("AjOEAQAMgVAKggQAQgyAAg1IAAkeQAAgagUgLIgUgGIAAgOIBkgUIDoEOIAEAAIAAjWQABgRgLgGQgHgDgXgCIAAgSIB5AAIAAASQgWACgGADQgLAFAAAQIAAFxIgqAAIAAgcIj8kqIAAEJQAAAggMAlQgTA0gmAsg");
	this.shape_334.setTransform(-83.7402,-246.167,0.2493,0.2493);

	this.shape_335 = new cjs.Shape();
	this.shape_335.graphics.f("#FFFFFF").s().p("AhyCjQhahDAAhjQAAheBlhEQAzgiAzgPQAygBBEA8QBXBLAABwQAABAhiBCQgfAUglATIgfAPQgzAAhGg1gAhzhvQgfAXgBA4QAAAzA2A2QA7A9BPAAQAuAAAcgZQAZgXAAggQAAg/g2g6Qg6g+hGAAQg0AAgZASg");
	this.shape_335.setTransform(-94.6988,-247.3701,0.2493,0.2493);

	this.shape_336 = new cjs.Shape();
	this.shape_336.graphics.f("#FFFFFF").s().p("ABfDXIgJgMIjSAAIAAgUQAxgDAOgJQATgNAAgpIAAkHQAAghgjgGQgwgIgFgEQgLgKAFgJQAEgKASABQARAAAKAPIDGAAIAAAUQgUgBgRAFQgiAJAAAdIAAERQAAAoAcAIQAIADATADQATADAMAIQAOAIgBAOQgBAPgRAAQgOAAgMgMg");
	this.shape_336.setTransform(-103.9156,-247.2457,0.2493,0.2493);

	this.shape_337 = new cjs.Shape();
	this.shape_337.graphics.f("#FFFFFF").s().p("AiBCmQhMg7gBhhQAAhDA0hFQBEhZBxAAQAyABAnAQQAmAPAfAiIhHA5IgPgSQgBgUgUgSQgagWgtAAQgvAAgkAyQglAyAABHQAABDAlArQAnAuBDAAQBfAAA8hKIAWAXQgtA1gsAaQgzAeg8AAQhJAAg/gxg");
	this.shape_337.setTransform(-128.2998,-247.8076,0.2493,0.2493);

	this.shape_338 = new cjs.Shape();
	this.shape_338.graphics.f("#FFFFFF").s().p("AiDCfQhPhAAAhbQAAhOBBhGQBChHBQAAQAyAAAtARQAZAIAjAUIAbgOIAQARIhdBFQgHgUgQgTQghgngvAAQg6AAgfA9QgWArAAAsIE1gPIhXBcIjcgVQAAA3AlAsQAmAuAxAAQA8AAAegsQAOgVAIgmIBRAAIAAALQgYBAgtAhQgzAlhPABQhKAAhFg5g");
	this.shape_338.setTransform(-139.3423,-247.8201,0.2493,0.2493);

	this.shape_339 = new cjs.Shape();
	this.shape_339.graphics.f("#FFFFFF").s().p("AAhCEQgcgrgOgPQgZgagcAAIgpASIAABKQAAAfASANQAJAHAIAAIAAARIidAAIAAgRIATgIQASgNAAgeIAAjjQAAgagRgOIgSgIIAAgTQAqgDBIgdQBFgcAsAAQBCAAAoAcQAmAbAAAqQAAAkgmAhQgXAUg3AcQAjAdAwBCQAfAtAbAAIAMgDQAOgFAJgOIASAGQgMAzgaAWQgVASghAAQgvAAg2hTgAhSiWQgVAYAAAiIAAB2QBPglAZgRQA7gpAAgqQAAgfgWgTQgVgSgbAAQgvAAgZAdg");
	this.shape_339.setTransform(-150.8772,-247.8139,0.2493,0.2493);

	this.shape_340 = new cjs.Shape();
	this.shape_340.graphics.f("#FFFFFF").s().p("ABfDXIgJgLIjSAAIAAgVQAxgCAOgKQATgNAAgpIAAkHQAAghgjgGQgwgIgFgEQgLgJAFgKQAEgKASABQARAAALAPIDFAAIAAAUQgUgBgRAFQgiAJAAAdIAAERQAAAoAcAIQAIADATACQATAEAMAIQAOAIgBAOQgBAPgRAAQgOAAgMgMg");
	this.shape_340.setTransform(-160.6271,-247.6958,0.2493,0.2493);

	this.shape_341 = new cjs.Shape();
	this.shape_341.graphics.f("#FFFFFF").s().p("AjKDDIAVgZQAUgfABgeIAAi7QAAgjgXgTIgXgMIAJgSQAeAAA9gaQA+gbAsAAQA9AABJBQQBIBQAABBQAAAuhHBMQhOBThJAAQgrgKgegFQg5gJgnAZgAg6ilQgTAUgBAhIAADVQgBAoAWATQASAPAfAAQArAAAmg4QAlg3ABg/QgBhCgog8Qgng8gnAAQgeAAgUAUg");
	this.shape_341.setTransform(-169.8589,-247.8014,0.2493,0.2493);

	this.shape_342 = new cjs.Shape();
	this.shape_342.graphics.f("#404040").s().p("AgRA2IgCgBIgBAAIgCgBIgDgBIgBgBIgCgBIgBAAIgDgCIgEgBIgBgCIgBgBIgBgCIAAgCIABgBIADgEQACgCADAAIADAAIACACIAAABIABACIAEACIACABIAFABIABABIACAAIABABIAAACIAAABIAAABIAAABIAAABIgBAAIAAACIgCABQAAABgBAAQAAAAAAABQAAAAgBAAQAAAAgBAAIgCAAgAAKA1IgCgBIgBgCIAAAAIAAAAIgBgBIAAgBIAAgBIABgCIAAgCIAAgCIABgBIAAgBIADgCIACgEQADgCACgCIABgHIgBgCIAAgDIgCgCIgCgDIgCgBIgBgBIgCgCIABgBIgDAAIgCgBIgBAAIgBABIgEgBIgGgBIAAgBIgBAAIgCAAIgCgBIgCgBIgFgBQgEgBgBgBIgEgCIgEgCIgBAAIgBgBIgCAAIgBgDIgCgBIgBgCIgBgBIAAgFIgCgEIAAgCIABgDIAAgDIAAgCQABgBAAAAQABgBAAAAQABgBAAAAQAAAAAAgBIACgEIACgBIACgCQAAAAAAgBQAAAAAAAAQABAAAAAAQABgBAAAAIAFgDIADgBIADAAIADAAIAEAAIAEAAIABAAIACAAIABADIABAEIAAACIAAADIgBADIgCABIgCACIgDAAIgCACIABACIgBABIAAACIAAABIABABQABABAAAAQAAAAAAAAQAAAAAAABQAAAAAAAAIAEAEIAGAAIAEAAIAFABIAFAAIAEABIAFACIAEABIACACIACAAIACACIABACIACABIACACIACAAIABACIADAHIACAJIgBAEIAAADIgBAHIgBAEIgBAEQgCACgEADIgCADIgCACIgJADIgKACgAAhggIgCgCIgDgDIgFgCIgEAAIgBgBIgCAAIgCgDIgBgEIAAgCIADgCQABgBAAAAQAAAAAAgBQABAAAAAAQABAAAAAAIABABIABAAQACgBADACIAGACIAFACIACAEIADACIAAACIAAACQAAABAAAAQAAABAAAAQgBABAAAAQgBABAAAAIgEACIgDgBg");
	this.shape_342.setTransform(9.075,-113.85);

	this.shape_343 = new cjs.Shape();
	this.shape_343.graphics.f("#404040").s().p("AgPA1IgBAAQgBAAAAAAQgBAAAAAAQgBgBAAAAQAAAAgBgBIgBgEIAAgCIAAgCIABgDIAAgCIAAgEIABgEIAAgBIAAAAIAAgDIAAgCIAAgCIAAgBIABgDIAAgEIgBgEIgDgFIgCgCIAAgCIgBgBQAAAAAAAAQAAAAAAAAQAAAAgBAAQAAAAAAAAIgBgCIAAgCIAAAAIgCgBIAAgCIAAgBIgBAAQAAAAgBgBQAAAAAAAAQgBAAAAgBQAAAAAAAAIgBgDIgCgCIgBgCIgBgDIgCgCIgBgDIgDgFIgDgEIgBgDIgBgCIgBgCIgBgCIgCgBIgBgCIgBgBIgBgCQAAgBAAAAQAAAAABgBQAAAAAAAAQAAAAABAAIACgCIAAAAIABAAIADAAIADABIACAAIACAAIABAAIADgBIAEAAIAAAAIABAAIACAAIACABIAAAAIABAAIABAAIAAABQADABACADIACAGIAFAFIABAEIADAEIAAAAIABADIADAFIACADIAAABIABABIACAHIAFAGIABACIABACIABACIABADIAAAGIAAAJIAAAGIAAABIAAAAIAAACIAAABIAAALIABACIgBACIAAADIAAABIAAABIAAAAIgBABIgCgBIgCAAIgBAAIAAAAIgCAAIgBAAIAAAAIgBgBIgBAAIgBAAIgBACIAAAAIgCgBIgCAAIgBAAIAAABIgCAAIgBABIgBAAIgCgBgAAVgOIAAgBIgCgCIAAgCIgCgBIgBgCIAAgCIgBgCIgBgCIgCgDIABgBIAAgCIACgDIADgCIACgDIACgCIACgBIABgBIADgDQABgBAAAAQABAAAAAAQAAgBABAAQABAAAAAAIAEAAIADAAIAGABIAFABIAGADIgCADIgEAGIgDADQAAABAAAAQAAAAgBABQAAAAAAAAQgBAAAAAAIgDADIgBABIgBABIgCACIgCACIgDACIgEAEIgEADIgBABIgBAAIgCgBgAAxgtIAAABIAAACIgBACIAAACIACgBIABgCIABgBIAAgBIAAgBIgBgBIgCAAg");
	this.shape_343.setTransform(-1.675,-113.825);

	this.shape_344 = new cjs.Shape();
	this.shape_344.graphics.f("#404040").s().p("AAhA1IgBgCIgBABIABAAIAAABIgBABIgBABIgDgBIgEgCIgCABIgCgBIgDABIgDAAIgCgBIgDgBIAAgBIAAgBIgBAAIABgDIgBgDIAAgCIgBAAIACgFIADgGIACAAIADAAIACAAIABAAIAJABIAKABIABAAQABAAAAAAQAAAAAAAAQABAAAAABQAAAAAAAAIAAADIAAADIAAAEIAAAFIAAABIAAABIgBAAIgBACIgBACIAAAAIgBAAIgBAAIgBABIgCgCgAggA2IgCAAIgGAAIgBgEIgBgEIABgJIgBgJIABgBIAAAEIABAFIgBACIAAADIAAADIAAACIAAABIABAAIAAgCQABAAAAAAQAAgBAAAAQAAAAgBAAQAAAAAAgBIAAgCIACgCIgBAAIABgDIABgEIAAAAIAAgBIgBgBIgBgCIAAgEIgBgGIAAgEIAAgCIAAgDIAAgCIgBgCIAAABIAAABIgBgBIAAgBIAAgBIAAgBIAAgBIABgBIAAABIABAAIAAgCIgCgCIAAgCIAAgBIAAgBIAAgBIAAgCIABgCIAAgCIAAgGIAAgGIgBgEIABgCIgBgBIAAAAIABgBIAAgBIAAgCIABgBIAAgCIAAAAIgBgBIAAACIAAgBIAAgCIgBgCIAAgEIAAgCIABgBIACgCIACgBIACAAIACABIAEgBIAGAAIADAAIADABIADAAIACgBIADADIABAEIABAFIAAAAIgBADIAAABIAAAGIgBAGIAAADIAAADIABADIABACIgBACIABAEQAAAAABAAQAAAAAAABQABAAAAAAQABAAAAAAQAEgCACABIAHAAIAJAAIAEAAIADAAIAFgBIACABIADABQACABABADIAAAEIABAEIgCAHQAAAAAAAAQgBAAAAABQAAAAAAAAQgBAAAAAAIgGABIgCgBIgDABIgBgBIgCABIgBgBIAAABIgBAAIgDAAIgCAAQgDgBgCAAIgGABIgBAAIgBgBIgDAAIgEAAIgCAAQAAAAgBABQAAAAAAAAQAAAAAAAAQgBABAAAAQAAAAAAAAQgBABAAAAQAAAAgBABQAAAAAAABIgBADIAAACIABACIgBAGIAAAGIABAFIgBAEIABADIAAACIgBABIgHABIgGABIgBAAIgBAAIgCAAIAAAAIgBAAIgBAAgAgYAyIAAABIABAAIAAAAIADAAIAFgBIABgCIAAgBIAAgCIgBgDIgBACIAAADIgBAAIgBABIgBACIgDgBgAggArIAAADIABABIABgBIAAgBIAAgDIgBAAIgBABgAAFAMIACAAIAAAAIABAAIADAAIgBgBIgBAAIgCAAIgCgCIgDgBIAAAAIgBAAIgBABIAAABIABACIACAAIABAAIABAAgAAiAIQAAAAAAABQAAAAAAAAQgBAAAAABQAAAAgBAAIgCACIACAAIABAAIACAAIABgBIAAgBIAAgBIgCgCgAgEgEIACABIABAAIABgBIAAAAIgBgBIgBAAIgBAAIgBAAgAAigdIAAgBQAAAAgBAAQAAAAAAAAQAAAAgBAAQAAAAgBAAIgBAAIgBAAIgBgBIgBABIgCABIgEgBIgFgBIgBAAIgCgBIgBAAIgBgDIgBgEIABgBIgBgBIABgFIABgEIACgBIAFgBIACAAIABAAIABAAIAEAAIADgBIABAAIACAAIAFAAIADABIABACIAAADIAAADIgBACIABABIAAAAIABACIAAABIAAAEIgBADIgCABIgDAAIgCABgAAngiIgBABIAAABIABAAIABAAIAAgBIAAgBIAAgBIgBAAIAAABgAAMgmIACADIACACIABgEIgCgBIgCgBg");
	this.shape_344.setTransform(-12.5,-114.2);

	this.shape_345 = new cjs.Shape();
	this.shape_345.graphics.f("#404040").s().p("AAjAyIgBAAIgBgBIgBgBIgBgBIgBAAIgCAAIAAAAIgBABIgBABIgBABIgBgBIgDgDIgDgDIABAAIAAABIACgBIAAgBIgBgBIgBgCIgDgBIgDgBIgBgCIgEgFIgFgEIgCgCIgBgDIAAgBIgBgCIAAAAIgBABIgBgBIgBAAIABgCIABgCIAAgBIgBgBIAAABIgBAAIAAgCIgBgCQAAAAABAAQAAgBAAAAQAAAAAAgBQAAAAAAAAIAAgCIAAgEIABgDIABgCIABgBIABgBIAAAAIABgCIABgCIABABIABgBIgBgCIADgDIAEgEIACgEIACgCIACgCIACgEIADgEIACgEIACgDIACgDIAFgBIAEAAIADABIACAAIACAAIABgBIAAAAIACAAIABAAIADAAIABACIAAACIABABIAAABIAAAAIABADIAAACIABABIAAACIAAABIgCABIgBABIgBgBIAAgBIAAgBIAAgBIgBgCIAAgCIgCACIAAAAIAAABIABABIgBACIgBABIAAABIgBACIgCACIgCACIAAABIgBABIgBACIgBACIgBAAIgBABIAAABIgBABIAAABQgBAAAAABQAAAAAAAAQgBABAAAAQAAAAAAABIgCACIgBADIgDADIgBACIgBAAIgBACIgBADIACACIACACIACACIACADIACADIADAFIACADIABABIABACIACADIADADIAAAAIAAACIACABQAAAAAAAAQABAAAAABQAAAAAAAAQABAAAAABIABACIAAAAIABACIABACIAAABIgBABQAAAAAAABQAAAAgBAAQAAAAAAAAQAAAAgBAAIgBAAIgCAAIgBAAIAAAAIgCAAIgBABIgBAAIAAgBIAAgBIAAABIABAAIAAAAIABAAIAAgCIgBAAIgCAAIgBAAIgCAAIgBAAIAAAAIAAABIABABIACAAIgCABIgBABIgBAAgAArgnIgBABIAAABIABAAIABABIACgCIABgCIAAAAIgCAAIgBAAIAAAAIgBABgAgkAxIgCAAIgBAAIgBAAIACgCIgBgBIgBAAIgCAAIgBABIAAABIAAABIgCAAIgBgBIgCgBIgBABIgBgBIgCgCIgBgCIAAgDIAAgDIABgCIAAgBIAAgCIAAgBIAAgCIABgCIgBgCIAAgDIABgCIAAgBIAAgBIAAgFIAAgGIAAgDIAAgCIAAgEIABgEIAAgBIgBgBIAAgEIAAgEIAAgCIABgCIAAgDIAAgDIAAgDIgBgCIAAgBIAAgBIAAgCIABgCIAAgDIABgDIgBAAIAAgBIABgCIAAgCIABAAIACgBIACAAIABAAIACAAIACAAIACAAIABABIACAAIACAAIACABIADAAIADgBIACACIAAACIAAAFIAAAEIgBAGIAAAHIgBAGIAAACIAAACIAAADIAAAAIAAADIgBACIABABIAAADIgBACIABAGIAAACIAAADIAAACIgBABIABACIAAABIAAAGIAAAIIgBAJIgBAFIgEACIgEgBIgBABgAgeAqIAAADIgDABIAAABIACAAQAAAAABAAQABAAAAAAQABAAAAgBQAAAAABAAIAAgEIABgEIgDAAIgBAEgAgyATIAAAEIAAAHIAAAFIAAADIAAADIACgDIAAgDIAAgCIAAgDIAAgCIAAgBIACgCIABgBIgBgDIAAgCIgBgBIAAABIgBABIAAgBIgCgBg");
	this.shape_345.setTransform(-23.325,-113.525);

	this.shape_346 = new cjs.Shape();
	this.shape_346.graphics.f("#404040").s().p("AAhA1IgBgCIAAABIAAAAIAAABIAAABIgBABIgFgBIgDgCIgCABIgCgBIgDABIgDAAIgCgBIgDgBIAAgBIAAgBIgBAAIABgDIgBgDIAAgCIgBAAIACgFIADgGIADAAIACAAIABAAIABAAIAKABIAKABIACAAQAAAAAAAAQAAAAAAAAQABAAAAABQAAAAAAAAQAAAAAAABQABAAAAAAQAAABAAAAQAAAAgBABIAAADIAAAEIAAAFIAAABIAAABIAAAAIgBACIgCACIAAAAIgBAAIgBAAIgBABIgCgCgAggA2IgDAAIgEAAIgCgEIgBgEIABgJIgBgJIABgBIABAEIAAAFIAAACIgBADIAAADIAAACIABABIAAAAIABgCQAAAAAAAAQAAgBAAAAQAAAAgBAAQAAAAAAgBIABgCIABgCIgBAAIABgDIABgEIAAAAIAAgBIgBgBIgBgCIAAgEIAAgGIAAgEIAAgCIAAgDIAAgCIgBgCIgBABIAAABIgBgBIAAgBIAAgBIAAgBIAAgBIABgBIABABIAAAAIAAgCIgCgCIAAgCIAAgBIAAgBIAAgBIAAgCIABgCIAAgCIAAgGIAAgGIgBgEIABgCIgBgBIAAAAIABgBIAAgBIABgCIABgBIAAgCIAAAAIgBgBIgBACIAAgBIAAgCIgBgCIAAgEIAAgCIACgBIABgCIACgBIACAAIACABIAEgBIAGAAIADAAIADABIAEAAIABgBIADADIABAEIAAAFIAAAAIgBADIAAABIAAAGIAAAGIAAADIAAADIABADIAAACIAAACIABAEQAAAAABAAQAAAAAAABQABAAAAAAQAAAAABAAQAEgCACABIAGAAIAKAAIAEAAIADAAIAFgBIACABIADABQACABABADIAAAEIABAEIgCAHQAAAAAAAAQAAAAgBABQAAAAAAAAQgBAAAAAAIgGABIgDgBIgCABIgBgBIgBABIgCgBIAAABIgCAAIgCAAIgCAAQgCgBgEAAIgFABIgBAAIgBgBIgDAAIgEAAIgCAAQAAAAgBABQAAAAAAAAQAAAAAAAAQgBABAAAAQAAAAAAAAQgBABAAAAQAAAAgBABQAAAAAAABIgBADIAAACIABACIAAAGIgBAGIABAFIAAAEIAAADIAAACIgBABIgHABIgGABIgBAAIgBAAIgCAAIAAAAIgBAAIgBAAgAgYAyIAAABIABAAIABAAIACAAIAFgBIACgCIgBgBIAAgCIgBgDIgBACIgBADIAAAAIgBABIgBACIgCgBgAgfArIAAADIABABIAAgBIAAgBIAAgDIAAAAIgBABgAAFAMIACAAIAAAAIABAAIADAAIgCgBIgBAAIgBAAIgCgCIgDgBIAAAAIgCAAIAAABIAAABIABACIADAAIABAAIAAAAgAAiAIQAAAAAAABQAAAAAAAAQgBAAAAABQAAAAgBAAIgBACIABAAIABAAIACAAIABgBIAAgBIAAgBIgCgCgAgDgEIABABIABAAIABgBIAAAAIgBgBIgBAAIgBAAIAAAAgAAigdIAAgBQAAAAgBAAQAAAAAAAAQAAAAgBAAQAAAAAAAAIgCAAIgBAAIgCgBIgBABIgBABIgEgBIgFgBIgBAAIgBgBIgCAAIgBgDIgBgEIABgBIgBgBIABgFIABgEIACgBIAEgBIAEAAIABAAIAAAAIADAAIAEgBIACAAIABAAIAFAAIADABIABACIAAADIAAADIgBACIABABIAAAAIABACIAAABIAAAEIgBADIgCABIgDAAIgCABgAAngiIgBABIAAABIACAAIAAAAIABgBIgBgBIABgBIgCAAIAAABgAANgmIABADIACACIABgEIgCgBIgBgBg");
	this.shape_346.setTransform(-38.8,-114.2);

	this.shape_347 = new cjs.Shape();
	this.shape_347.graphics.f("#404040").s().p("AgfAzIgBAAIgCAAIgBAAIgBgCIgCgBIgBgCIAAgBIgBgDIAAgCIAAgCIAAgDIgBgDIAAgCIgBgCIAAgKIAAgJIAAgEIAAgFIAAgDIABgFIgBgCIAAgFIAAgFIABgDQgBgEAAgEQABgEgBgEIAAgBIAAgBIAAgCIAAgCIAAgBIAAgBIABgCIACgBIADABIABgBIABAAIADABIABgBIACABIABAAIABgBIABABIABAAIACAAIACAAIADAAIADABIABAAIACgBIAAABIABAAIAAAIIAAAIIAAAHIAAAHIAAAGIAAAHIAAAFIAAABIAAAAIAAAFIAAAFIgBAKIABALIAAACIgBACIAAADIAAADIAAACIgBADIgBADIgEAAIgEABIgCgBIgCAAIgCAAIgBAAIgBABgAgVAvIgCAAIABABIAEAAIAFgBIAAgDIgDACIgCABIgBAAIgBgBIgBABgAgOgsIAAABIABAFIAAAFIABAEIgBACIAAACIAAAAIAAAHIAAAGIABAAIAAgBIAAgBIAAgCIAAgDIAAgBIAAgCIAAAAIAAgBIABgHIgBgIIAAgCIAAgEIAAgCIgCAAIAAACgAAoAyIgCAAIgCgBIgBAAIgBAAIgFABIgFAAIgFAAIgDAAIgEgBIgBgCIAAABIgBACQgBAAAAAAQgBAAAAAAQgBgBAAAAQAAAAAAAAIAAgDIgBgCIAAgBIAAgEIAAgEIgBgBIAAAAIABgDIADgBIAFgBIAGgBIADAAIABAAIADABIAEAAIAAAAIABAAIAHAAIABAAIABABIABAGIABAFIAAAFQAAAAAAABQAAABgBAAQAAABAAAAQAAABgBAAIgBAAgAAmAiIABABIgBADIAAAEIAAACIAAACIgBACIACABIACgBIAAgCIAAgDIAAgDIgBgFIAAgCIgCgBIAAACg");
	this.shape_347.setTransform(-48.575,-113.725);

	this.shape_348 = new cjs.Shape();
	this.shape_348.graphics.f("#404040").s().p("AgHA1QgFAAgCgDQgDgCgBgGIAAgBIgBgBIABgCIAAgDIgBgFIABgIIAAgIIAAgGIABgCIAAgBIAAgCIgBgDQAAAAABAAQAAAAAAAAQAAgBAAAAQAAAAAAgBIAAgCIABgHIAAgGIAAgDIABgFIABgDIgBgDIAAgDIAAgCIABgBIgBgCIAAgBIABgFIAAgFIABgBIACgBIABABIACAAIACAAIACAAIACAAIACAAIACABIAEAAIADgBIABAAIACAAQAAAAAAAAQAAABAAAAQABAAAAAAQAAAAAAAAIABgBQABAAAAAAQABAAAAABQABAAAAAAQABABAAAAIABAEIAAADIAAACIAAACIABACIgBAEIAAADIAAACIgBADIgBAJIAAAJIAAADIgBADIAAADIAAADIAAAFIAAACIAAABIgBADIAAAEIgBACIAAADIgBAEIAAABIABABIgBAGIgBAGIABAAIgBADIAAACIgBABIgCACIgEAAIgEABIgIAAgAgQAUIAAAEIAAAIIAAAHIABAAIAAgBIAAgBIABgCIABgCIAAgBIgBAAIAAgCIAAgBIgBgCIAAgEIABgGIAAgBIgBgBIgBAAIAAAFg");
	this.shape_348.setTransform(-56.075,-113.95);

	this.shape_349 = new cjs.Shape();
	this.shape_349.graphics.f("#404040").s().p("AAKAzIAAgBIgCgBIgCAAIgBABIgCgBIAAgCIgBgCIAAABIAAABIAAACIgBAAIAAgFIgBgFIAAgBIAAgBIAAgBIACgCIACgBIAEgDIADgEQAAAAAAAAQABAAAAgBQAAAAABAAQAAgBAAAAIACgEIAAgDIgDgBIAAgDIAAgCIgBAAIgBgDIAAgCIgCgBIgDAAIgBgCIgBABIgBAAIAAAAIgBAAIgBAAIAAgCIAAgCIAAAAIAAAAIAAAAIAAABIgBgBIABgBIABgBIABAAIABAAIACgBIABgCIACgCIAAAAIABgCIAAgBIAAgBIgBgBIAAgBIAAgBIABgBIABgBIAAgBIAAgCIgBgCIgBgCIABgDIAAgDIgBgBIgBgDIgBAAIgBAAIAAACIABACIAAABIgCgCIAAgDIgCgBIAAgCIgBgBIgBgBIgBgCIgBgEQAAgEACgBQABgBADAAIACAAIABABIABAAIABAAIACAAIAFAAIAFABIACgBIACAAIADAAIAEAAIADABQAAAAAAAAQAAAAAAAAQABAAAAAAQAAAAAAAAIACAAIABgBIAAAAQABAAAAAAQABABAAAAQABAAAAABQAAAAABABIADAGQABADADABIABADIABAEIAAADIAAADIgBAEIABADIgCACIgBACIABABIAAABIgBACIgCABIAAABIAAABIAAABIgBAAIgBACIgBACIAAAAIABADIACADIACACIABACIABABIACADIABAGIAAABIgBABIABACIABACIAAABIgBACIgBgBIAAADIAAADIgBAAIABAAIABAAIgBACIgCACIABABIAAABIAAAAIAAAAIgCACIAAABIgBABIAAgCIgCgBIgBAAIgCAAIAAABIAAACIgBABIgCAAIgCACIgDABIgDAAIgCABIgBAAIAAAAIgCAAIgDAAQgBAAAAAAQAAAAgBAAQAAAAAAAAQAAABgBAAIgCAAIgCAAIgBAAIgCABIgBAAIgCAAIgBAAIgBAAgAgqAyIAAAAIgDAAIgCgBIgDAAQAAAAgBAAQAAAAAAAAQgBAAAAgBQAAAAAAgBIgBgDIAAgFIAAgFIAAgDIAAgEIAAgFIAAgGIAAgBIAAgCIAAgHIAAgGQgBgDAAgDIAAgGIAAgMIAAgLIAAgGIAAgFIACgCIABABIACgBIACAAIABgBIABABIACAAIADAAIACAAIAEgBIADAAIABABIABAAIACAAIABgBIACABIACAAIACgBIACABIABABQAAAAABAAQAAAAAAABQAAAAAAAAQAAABAAAAIAAAHIAAADIAAACIABAHIgBAHIABAGIAAAIIAAAGIAAADIAAADIgBALIAAALIAAABIgBABIABADIgBADIABADIAAADIgBACIABABIgBACIgEABIgEgBIgBABIgBgBIgBAAIgBABIgBAAIgCAAIgDAAIgDAAIgDABIgBAAgAg0AXIAAAKIABAKIAAADIABACIABAAIABgBIABgDIABgCIAAgBIAAgBIAAgBIAAAAQgBgBAAAAQgBAAAAAAQAAgBAAAAQAAAAAAgBIAAgEIAAAAIAAgBIAAgCIgBgBIgBgCIgBgBIAAgCIgBgBgAgSAuIAAAAg");
	this.shape_349.setTransform(-64.725,-113.825);

	this.shape_350 = new cjs.Shape();
	this.shape_350.graphics.f("#404040").s().p("AgJAzIgCgBIgBABIgBAAIgCgBIgEAAIgDgBIgCAAIgBgBIgCAAIgFgDIgDgCIgDgCIgCgCIgBgBIgCgBIgCgCIgCgCIgBgCIgCgCIAAgCIACgBIgBgBIAAgBIgBABIgBABIgBgBIgBgCIgBgBIAAgBIABgBIgBgBIAAAAIgCgCIAAgCIAAgDIgCgEIAAgEIAAgEIABgFIABgHIACgEIADgHIAEgGIAFgFIABgCIACgCIAEgBIACgCIACgBIAEgBIADgCIAEAAIABgCIAFgBIAGgBQAAABABAAQABAAAAAAQABAAAAAAQABABAAAAIACADIABAEIgBACIABAEIgBABIAAACIgEABIgHADIgIAEIgDABIgCACIgBACIgCADIgCACIAAABIAAABIgBAAIgBAEIAAADIAAABIAAACIAAACIAAACIABACIAAADIAAAEIACADIADADIABADIABABIABACIACACIACACIADABIACAAIABgBIACABIAAACIADACIADACIAAACIAAACIAAAAIAAACIAAACIAAADIABACIgBACIgCABIgBAAgAgwgZIgDAEIAAABIABgCIACgCIABgBIABgCIABAAIABgBIAAgBIAAgBIgEAFgAAVAwIgBgCIgBABIgBABIgCgBIgDAAIgBgBIgBgDIAAgCIAAgCIACgDQgBAAAAAAQgBAAAAABQAAAAAAAAQAAAAAAABIgBADIgBgBIAAAAIAAgCIABgCIADgDIAGgCIAEgCIADgDIADgEIABgEIACgDIABgCIADgHIABgHIgBgEIAAgEIgBgCIAAgCIAAAAIAAgBIAAgBIAAgBIgCgBIAAABIAAABIgBAAIgBgDIgBgCIgBgBIAAgCIgBAAIgBgBIgCgEIgBABIgBAAIgDgBIgDgBIgCgBIgDgBIgBgBIgBgBIgCgCIAAgDIABgEIABgFIACgCIACgBIADAAIACAAIAAAAIABAAQADAAAEACIAGAFQADACAEACIACACIADACIABABIABACIABABIACACIABACIABADIACACIAAABIAAABIAAAAIAAABIACABIAAAEIAAACIAAABIABAAIAAAFIAAABIABABIAAABIgCABIABACIAAgBIABABIAAADIAAACIAAACIgBACIABACIgBACIgBACIAAgCIgBABIAAACIABAAIgCAEIgBACIAAABIgCACIAAABIAAACIABABIABAAIgCABIAAABIgCADIgCACIgBADIgBgBIgBgBQgBAAAAAAQgBAAAAAAQAAAAAAAAQAAABgBAAIgBABIgCADIgBABIgDABIgCACIgEACIgBAAIAAAAIgEAAIgCABg");
	this.shape_350.setTransform(-77.2,-113.85);

	this.shape_351 = new cjs.Shape();
	this.shape_351.graphics.f("#404040").s().p("Ag8A1IgBAAIgBgDIAAgDIABgDIAAgEIgBgDIABgHIAAgFIAAgCIABgBIAAAAIABgBIABAAIABABIADAEIADADIACAFIACADIABACIAAADIAAAAIAAACIAAACIAAACIAAADIgBABIgBAAIgDABIgDAAIgDABIgDgBgAAoAzIgCgFIgCgFIAAgEIAAgDIgBgEIAAgBIAAgCIABgDIAAgEIgBgCIAAgDIAAgDIAAgFIAAAAIABAAIAAAAIABgBIgBgBIgBAAIAAgBIAAgDIABgCIgBgDIABgCIAAgBIgBgFIAAgFIABgFIgBgGIAAgHIAAgCIAAgCIAAgDIACgDIADgCIACABIADABIAFgBIAFgBIAEABIADABIABAAIAAABIgBACIAAADIAAADIAAACIAAACIAAACIgBACIAAACIABABIABABIgBACIgBABIABABIAAADIgBABIgBAAIAAAAIAAABIAAABIACABIAAABIgBACIAAACIAAACIgBADIABACIAAACIAAABIgBACIABAEIAAADIAAAAIgBACIAAAAIABABIAAABIAAABIgBACIABACIgCABIAAAAIABACIABACIgBAAIAAABIAAACQAAAAAAABQAAAAAAAAQAAABAAAAQAAAAAAAAIAAACIAAADIAAABIABABIgBABIAAAAIAAADIABACIgBADQAAABAAAAQAAABAAAAQAAABgBAAQAAAAAAAAIgBAAIgBAAIgCAAIgDAAIgBABIgFAAIgEACgAA4AsIAAABIABABIAAABIABAAIAAgBIAAgCIAAAAgAAzAuIACAAIABgBIgBgBIABgBIgCAAIgBAAIAAACIgCgBIgDAAIAAABIAAAAIABABIACAAIACAAgAgGA0IgBgBIgCgBIgCgEIgDgDIgEgFIgCgDIgCgDIgDgEIgCgCIgDgFIgDgFIgCgDQAAAAAAAAQAAgBAAAAQAAAAgBAAQAAAAAAgBIgCgCQAAgBAAAAQgBAAAAgBQAAAAAAAAQAAgBAAAAIgDgDIgCgDQAAAAAAAAQgBAAAAAAQAAAAAAAAQAAgBAAAAIgBgDIgBgCIgCgBIgBgCIgDgEIgCgDIgBgBIgCgFIAAgEIAAgBIAAgBIABgFIAAgEIAAgFIABgFIABgEQAAAAAAgBQABAAAAAAQABAAAAAAQABAAAAAAIAFAAIAFAAIACACIADACQAAABAAAAQABABAAAAQAAAAAAABQAAAAAAABIADAEIADAFIABACIABADIADAFIADAFIACADIACACIABACIAAADIACACIABADIACACIACADIABACIACACIABACIACABIABABIACgBIABgCIAAgBIABgBQABAAAAAAQAAAAAAAAQAAgBAAAAQAAAAAAgBIABgBIABAAIADgDQAAAAAAAAQABgBAAAAQAAgBAAAAQAAAAAAgBIABgBIABAAIAEgDIAEgCIABADIABAEIgBABIAAABIgBACIABAEIAAAGIABABIAAACIgBADIABABIAAABIAAADIgBAFIgCADIgBACIgBACIgDACIgBADIgCAAIgBACIgCABIgBACIgCABIAAABIgBACIgCABIAAAAIgBABIgCACIgDACgAg3giIAAACIAAACIgBADIABABIAAABIABgDIABgDIAAgDIAAgBIAAgCIgBAAIgBADgAgrgtIACABIABABIABABIABABIABADIABAAIAAgBIAAgBIgBgBIAAgCIgCgBIgBgCIgDgBIgBAAIABACg");
	this.shape_351.setTransform(-90.425,-114);

	this.shape_352 = new cjs.Shape();
	this.shape_352.graphics.f("#404040").s().p("AgRA0IgCgBIAAAAIgCgBIgCAAIgCgCIgCgBIgCgBIgCgCIgDgBIgBAAIgCgBIgBgDIABgCIAAgBIADgDQABgBAAAAQABAAAAgBQABAAABAAQAAAAABAAIACAAIACACIACABIAAABIAEACIACABIAFACIABABIABAAIABABIABABIgBABIAAABIAAABIAAAAIAAABIgBACIgCACQAAAAAAAAQgBAAAAABQAAAAAAAAQgBAAAAAAIgDAAgAAJAzIgCgBIgBgBIAAgBIABAAIgBgCIAAgBIAAgCIAAgCIAAgBIABgCIAAgBIADgCIADgDQADgCABgDIABgHIgBgCIAAgCIgCgCIgBgDQgBAAAAAAQAAAAAAgBQgBAAAAAAQAAAAAAAAIgCgBIgBgBIAAgBIgCAAIgCgBIgBAAIgBABIgEgBIgFgBIgBAAIgBgBIgCgBIgBgBIgCAAIgGgBIgEgCIgEgCIgEgCIAAAAIgCgBIgCgBIgBgCIgCgBIAAgBIgBgCIgBgFIgBgDIAAgDIAAgCIABgCIAAgDQAAgBABAAQAAAAABgBQAAAAAAgBQAAAAAAgBIACgDIACgCIACgCIACgCIAEgCIAEgCIADABIACAAIAFgBIADAAIABAAIACABIABADIABAEIAAACIAAACIgBACIgCACIgCACIgCABIgCABIAAABIAAACIAAABIAAABIABACIABACQACACACAAIAFABIAEAAIAEABIAGAAIADACIAGABIAEACIABABIACAAIACACIABACIACABIABACIACABIABABIADAHIACAIIAAADIAAAEIgCAGIAAAFIgCADIgFAGIgCACIgBACIgJADQgFACgFABgAAggfIgCgCIgDgDIgEgBIgFgBIgBAAIgCgBIgBgDIgBgEIAAAAIACgDQABgBAAAAQAAAAABgBQAAAAABAAQAAAAAAAAIABAAIACAAIAEABIAGADIAEACIACADQABAAAAAAQABABAAAAQAAAAABABQAAAAAAABIABACIAAABQAAABgBAAQAAABAAAAQAAABgBAAQAAABAAAAIgFACIgCgBg");
	this.shape_352.setTransform(28.15,-220.8);

	this.shape_353 = new cjs.Shape();
	this.shape_353.graphics.f("#404040").s().p("AgMA0IgBAAQAAAAAAAAQAAAAAAgBQAAAAgBAAQAAAAAAABIgCAAQAAAAAAgBQgBAAAAAAQgBAAAAgBQgBAAAAAAIgBgEIAAgCIAAgCIAAgDIABgDIAAgDIAAgEIAAAAIAAgBIABgCIgBgDIABgBIAAgCIAAgDIAAgDIgBgEIgBgFIgDgCIAAgCIAAgBIgCAAIgBgBIAAgCIAAgBIgCgBIAAgBIAAgBIgBgBIgCgBIgBgDIgBgCIgBgCIgBgDIgCgCIgBgDIgDgEIgDgFIgBgCIgBgCIgBgCIgBgCIgCgBIgBgCIgBgBIgBgCIABgCIADgCIABAAIAAAAIACABIADAAIACAAIACAAIABAAIAEgBIADABIABgBIABAAIABABIACAAIAAAAIABAAIAAABIABABQADAAABADIADAGQAEACAAACIACAEIACAEIABADIADAFIACADIABABIAAABQABADABADIAFAHIABABIAAACIACACIAAADIABAGIAAAIIAAAGIgBABIAAAAIAAACIAAABIAAALIABABIAAADIAAACIAAABIAAABIgBABIgBAAIgBgBIgCAAIgBAAIAAAAIgCAAIgBABIAAgBIgCgBIAAAAIAAABIgBABIgBAAIgCAAIgCgBIgBABIAAABIgCgBIAAABIgBAAgAAVgNIgBgCIgCgBIAAgCQAAAAAAAAQAAgBAAAAQgBAAAAAAQAAAAgBAAIAAgCIgBgCIABAAIgBgBIgCgDIgBgCIABgCIAAgBIACgDIACgDIACgCIADgCIABgBIABgBIADgDIAEgCIADAAIAEAAIAFABIAFABIAGADIgCADIgDAFIgEAEQAAAAAAAAQAAABAAAAQgBAAAAAAQAAAAgBABIgCACIgBABIgBACIgDABIgBACIgDACIgEAEIgEACIAAABIgBABIgCgBgAAwgrIgBABIABACIgCACIAAACIAAAAIACgBIABgCIABgBIABgCIgCgBIgBAAg");
	this.shape_353.setTransform(17.8,-220.8083);

	this.shape_354 = new cjs.Shape();
	this.shape_354.graphics.f("#404040").s().p("AAgAzIgBgCIgBACIABAAIAAAAIgBABIgBAAIgDgBIgEAAIgCAAIgCAAIgDAAIgDAAIgCAAIgCgCIAAgBIAAAAIgBgBIABgDIgCgCIAAgDIABgFIADgEIADgBIADAAIABAAIABAAIAJABIAJABIACAAIABABIABACIAAAEIAAAEIAAADIAAACIAAABIgBABIgBACIgBABIgBAAIAAgBIgBABIgBAAIgCgBgAggA0IgBAAIgFgBIgCgCIgBgFQABgEAAgFIgBgJIABAAIABAEIAAAEIAAACIgBAEIAAACIABACIAAABIABAAIAAgCIAAgBIAAgCIABgCIAAgBIABgDIABgCIAAgBIgBgBIgBgCIgBgBIAAgEIAAgGIAAgDIAAgDIAAgDIAAgCIgBgBIAAABIgBAAIgBAAIAAgBIAAAAIABgBIgBgCIABgCIABACIABgBIgBgBIgBgCIgBgBIABgCIgBgCIAAAAIABgCIABgBIgBgDIAAgGIAAgFIAAgEIAAgBIAAgCIAAAAIAAgBIAAgCIABgBIABgBIAAgCIgBAAIAAABIgBgBIABgCIgBgCIgBgDIAAgCIACgCIACgBIACgCIABABIACABIAEgBIAFgBIAEAAIACABIAEAAIACAAIACADIABAEIABAEIAAABIgBACIAAABIAAAHIgBAFIAAADIAAADIABACIABADIgBACIABACIADACQADgBADAAIAGAAIAJAAIAEgBIAEABIADgBIADAAIADABQACACAAADIABADIAAAFIgBAGQAAAAgBABQAAAAAAAAQAAAAgBAAQAAABAAAAIgHABIgCgBIgCABIgBgBIgBABIgCgBIAAABIgBAAIgCAAIgDAAIgFgBIgFABIgBgBIgBAAIgDAAIgEAAIgCAAQAAAAAAAAQgBAAAAAAQAAAAAAABQAAAAAAAAIgDADIgBADIAAADIABABIAAAGIAAAGIAAAFIAAADIAAAEIAAABIgBABIgGABIgGAAIgBAAIgBAAIgBAAIgBAAIgBABIgCAAgAgXAxIgBABIABAAIABAAIADAAIAEgBIACgCIgBgCIAAgCIAAgCIgCABIAAACIAAAAQAAAAgBABQAAAAAAAAQAAAAAAAAQAAABAAAAIgBACIgDAAgAgeAqIAAACIAAABIABgBIABgBIAAgCIgBgBIgBACgAAFAMIACAAIAAAAIABAAIACgBIgBgBIgBAAIgCAAIgBgCIgDgBIgBAAIgBABIAAAAIAAABIABACIACABIABgBIABABgAAhAHQAAABAAAAQAAAAgBABQAAAAAAAAQAAAAgBAAIgBACIABABIABAAIACgBIABgBIgBgBIAAgBIgBgBgAgDgEIAAABIABAAIABAAIABAAIAAgBIgBAAIAAAAIgBAAIgBAAgAAhgcIAAgBIgDAAIgCAAIgBAAIgBAAIgBAAIgBABIgEgBIgFgBIAAAAIgCAAIgCgBIgBgEIAAgDIAAAAIAAgBIAAgFIABgEIADgCIAEgBIADABIABAAIABAAIACAAIADgBIACAAIACgBIAEAAIAEABIABADIAAADIgBACIAAADIAAABIABAAIAAABIABACIgBADIgBAEIgCAAIgCAAIgCABIgBAAgAAlghIAAACIAAAAIABAAIABAAIAAgBIAAgBIAAgBIgCgBIAAACgAAMglIABADIADACIAAgDIgBgBIgCgCg");
	this.shape_354.setTransform(7.375,-221.15);

	this.shape_355 = new cjs.Shape();
	this.shape_355.graphics.f("#404040").s().p("AAhAxIAAgBIgBgBQAAAAAAAAQAAgBAAAAQgBAAAAAAQAAAAAAABIgBgBIgBAAIgCAAIgBAAIAAAAIgBABIgBABIgCAAIgCgEIgDgDIABAAIABABIABgBIAAgBIgBgBIgBgBIgDgCIgDgBIAAgCIgFgDIgFgFIgBgCIgBgCIAAgCIgBgCIgBABIgBgBIgBAAIABgCIABgCIgBAAIAAgBIAAABIgBAAIAAgCIgBgDQAAAAABAAQAAAAAAAAQAAgBAAAAQAAAAAAgBIAAgCIAAgDIABgDIABgCIABgBIABgBIAAABIABgCIABgDIAAABIABgBIAAgCIACgCIAFgFIACgDIACgCIABgDIACgDIADgDIACgFIACgCIACgDQABAAAAgBQAAAAABAAQAAAAABAAQABgBABAAIADABIADABIACgBIACABIABgCIAAAAIACAAIABAAIADABIABACIAAABIABABIAAABIABADIAAACIAAABIABACIgBABIgBABIgBABIgBgBIAAgBIAAgBIAAgBIgBgBIAAgCIgCABIAAABIAAAAIABABIgBACIgBABIAAABIgBABIgCAEIgCABIAAABIgBABIgBACIgBACIgBAAIgBABIAAACIgBAAIgBADQAAAAAAABQAAAAgBAAQAAABAAAAQAAAAgBABIgCACIgCADIgBACIgBAAIgBACIgBACIACADIACACIACACIABACIADADIACAFIACADIABABIABABIADAEIACACIAAABIABABIABABIACACIABADIABABIABACIgBABIAAACQAAAAAAAAQAAAAgBAAQAAAAAAAAQAAABgBAAIgBAAIgCAAIgBAAIAAgBIgBABIgCABIgBgBIAAgBIAAAAIABAAIAAABIABAAIAAgBIAAgCIgBAAIgBAAIgCAAIgCAAIAAAAIgBAAIABACIABABIABAAIgBABIgBAAIgBABgAAqgnIgBABIAAABIAAABIABABIACgCIABgBIAAgBIgBAAIgCAAgAgkAvIgCAAIgBAAIACgCIgBgBIgBAAIgCAAIAAABIAAABIgBABIgBAAIgCAAIgBgBIgBAAIgCgBIgBgCIgBgCIAAgDIAAgDIAAgBIABgCIAAgBIAAgBIAAgCIAAgDIAAgBIAAgDIAAgCIAAgBIAAgBIABgEIAAgGIAAgDIAAgCIAAgEIAAgEIAAgBIAAAAIAAgFIAAgDIAAgCIAAgCIAAgDIAAgDIAAgDIAAgCIAAgBIAAAAIAAgDIAAgCIABgDIAAgCIAAgBIAAAAIAAgCIABgCIABgBIABgBIACAAIACAAIACABIABAAIACgBIABABIACAAIACABIACAAIADAAIADAAIABABIABADIgBAEIABAFIgBAFIAAAGIgBAHIAAABIAAACIAAADIgBADIAAACIABABIgBADIAAADIABAEIgBADIAAADIAAABIAAACIABABIAAABIAAAGIgBAIIAAAIIgBAFIgEACIgEAAIgBAAIgBABIgBgBgAgdAoIAAADIgDABIAAACIACAAQABAAAAgBQABAAAAAAQABAAAAAAQAAgBAAAAIABgDIABgEIgDAAIgBADgAgwASIAAAEIAAAHIgBAFIAAADIABACIABgCIABgEIAAgCIAAgCIAAgBIAAgDIABgBIABgCIAAgBIgBgCIgBgCIAAACIgBAAIAAgBIgBgBg");
	this.shape_355.setTransform(-3.025,-220.5);

	this.shape_356 = new cjs.Shape();
	this.shape_356.graphics.f("#404040").s().p("AgXAwIgCABIgBAAIAAgBIgCgBIgBAAIAAAAIgBABIAAABIgCAAIgCAAIgCAAIgEgBQAAAAAAAAQgBAAAAAAQAAAAAAAAQAAgBAAAAIgBgFIAAgBIABgBIAAgBIACgBIABgCIAAgBIgBAAIgBABIgBAAIAAAAIAAgDIAAgEQAAAAAAAAQAAAAAAgBQAAAAAAAAQAAAAAAgBIAAgBIAAgCIAAgDIAAgBIAAgBIAAgCIAAgBIABgCIABgBIgBgBIAAAAIAAgCIgBgBIAAgBIAAgDIAAgBIAAgBIAAgBIABgCIAAAAIAAAAIAAgBIAAgCIgBgCIAAgBIABgBIgBgBIABgBIAAgCIAAAAIgBAAIAAgCIAAgBIABgBIABgCIAAgEIAAgCIAAgBIgBgCIgBgBIAAgBQAAAAAAAAQAAAAAAgBQAAAAAAAAQAAAAAAAAIAAgCIAAgEIAAgCIABgCIgBgCIABgCIAAgBIADgCIADAAIABAAIABgBIAFAAIAEgBIACABIADAAIABABIABAEIAAAHIAAAEIAAAHIAAAIIAAABIAAADIAAACIAAAVIgBAWIAAADIAAAEIAAADIAAACIgBACIAAgEIAAgEIgBgDIgBgBIgBABIAAACIABACIAAACIAAACIgBABIAAACIABABIgCABIgBgBgAAEAXIgCgBIgCAAIAAgCIAAgCIAAgCIAAgCIAAgDIADgBIABgBIACAAIADgEIACgDIADgCIACgFIABgEIgBgHIgCgHIgCgFIgCAAIAAgCIgDgDQgBAAAAgBQAAAAgBAAQAAAAgBAAQAAgBgBAAQgDAAAAgCQgCgCAAgDIABgCIAAAAIABgCIAAgBIADgCIABABIABABIADABIAEABIACABIADAAIABABIABAAIADACIADACIACABIACACIACABIACACIACAEIACACQAAAAAAABQAAAAABABQAAAAAAAAQABABAAAAIACAEIABAEIABAFIgBADIAAAEIgBAEIgBABIgCADIAAACIgCADIgEADIgBABIgBAAIgCABIgBABIgBAAIgBAAIgBAAIgDACIgBABIABAAIABAAIAAABIgEAAIgDAAIgBgBIgCABIgBACIgBABIgCAAIAAAAIgBAAIAAAAIgBABIgCAAg");
	this.shape_356.setTransform(-17.975,-220.55);

	this.shape_357 = new cjs.Shape();
	this.shape_357.graphics.f("#404040").s().p("AgJAxIgBAAIgBAAIgBAAIgDgBIgDAAIgDgBIgCAAIgBgBIgCAAIgEgDIgEgCIgCgBIgDgCIAAgCIgCgBIgCgBIgBgCIgBgCIgDgCIAAgCIACgBIgBgBIAAAAIgBAAIgBABIgBgBIgBgCIgBgBIAAgBIAAgBIAAgBIAAAAIgBgCIAAgCIgBgCIgBgEIAAgEIAAgEIAAAAIAAgFIACgGQAAgBAAgBQAAAAAAgBQABAAAAgBQAAAAAAgBQAAgDACgDIAFgGIAEgFIACgBIACgCIADgBIACgCIADgCIADgBIADgBIAEAAIABgBIAFgCIAFAAQABAAABAAQAAAAABAAQAAAAABAAQAAABAAAAQABAAAAAAQAAABABAAQAAAAAAABQAAAAAAABIACAEIgBACIAAADIAAABIgBACIgEABIgHAEIgGADIgFABIgBACIgBACIgBADIgDACIAAAAIAAABIAAABIgBADIgBAEIAAABIABABIAAACIAAACIAAADIAAACIABADIACADIACADIABADIABACIABABIACACIADACIACABIABAAIACgBIABABIAAACIADACIADACIAAABIAAACIAAACIAAACIABADIAAACIgBACIgBACIgCgBgAgugZIgDAFIAAABIABgCIACgCIABgBIABgBIABgBIAAgBIAAgBIAAAAIgDADgAAVAuIgBgCIgBABIgBABIgCgBIgDAAIgBgBIgBgCIAAgCIAAgDIABgCIgCABIAAAEIgBAAIAAgBIgBgBIABgBIAAgCIAEgDIAGgCIADgCIADgDIADgEIABgEIACgCIABgCIADgHIABgGIgBgFIAAgDIgBgCIAAgCIAAgBIAAAAIAAgBIAAgBIgCgBIAAAAIgBABIgBgCIgBgCIgBgBIAAgCQgBAAAAAAQAAAAgBAAQAAgBAAAAQAAAAAAgBIgBgCIgCAAIgBABIgDgBIgCgCIgDgBIgCgBIgCgBIgBgBIgBgCIAAgCIABgEIABgEIACgDIACgBIACAAIACgBIABAAIAAABQAEAAADACIAGAEIAHAEIACACIADACIABACIABABIAAACIACABIABACIABADIACACIAAABIAAABIAAAAIAAABIACABIAAADIAAACIABABIAAABIAAAEIABABIAAACIAAAAIgBABIAAACIAAAAIABAAIAAADIAAACIAAACIAAACIAAACIAAACQAAAAAAAAQAAABAAAAQAAAAgBAAQAAAAAAAAIgBgBIgBABIAAACIABAAIgCADQAAAAAAAAQAAABAAAAQgBAAAAABQAAAAgBAAIAAACIgBABIAAABIAAABIABABIAAABIAAABQAAAAAAAAQgBAAAAAAQAAABAAAAQAAAAAAAAIgCADIgBACIgCACIgBgBIgBgBQAAAAgBAAQAAAAAAABQAAAAgBAAQAAAAAAABIgCABIgBADIgBABIgDAAIgCACIgEACIAAAAIgBAAIgDAAIgDABg");
	this.shape_357.setTransform(-28.95,-220.825);

	this.shape_358 = new cjs.Shape();
	this.shape_358.graphics.f("#404040").s().p("AgIAxIAAAAIgBAAIAAgBIADgBIACgCIgBAAIgBgBIgBACIgCABIgCABIgCABIgCAAIAAAAIgBAAIAAgDIAAgDIAAgCIABgBIgBgCIABgCIgBgFIAAgFIAAgDIAAgCIABgDIgBgDIABgGQgBgDABgDIAAgDIAAgDIAAgCIAAgDIABgCIAAgGIgBgGIgBgBIAAgCIgCABIgBgBIgEABIgEAAQAAAAgBAAQAAAAgBAAQAAAAAAAAQgBAAAAABIgBgBIgCAAIgCAAIgBAAIgCgBIAAgCIAAgBIAAgDIAAgDIABgJQAAAAAAgBQABAAAAgBQABAAAAAAQABgBAAAAIAJAAIACAAIACAAIADgBIACgBIADABIADgBIAGABIAEAAIAGAAIAHgBIADAAIAEAAIADAAIACAAIACAAIADABIADgBIADACIACADIABADIAAAKIAAADQAAAAAAAAQAAABgBAAQAAAAAAABQAAAAgBAAIAAABIgBAAIAAAAIAAgBIgBgBIgBAAIAAACIABADIgBABIgCACIgCAAIgDgCIgDgCIgCgBIgBgCIgBAAIAAAAIgBABIgCAAIgCAAIgCAFIAAAHIAAAGIgBAFIAAADIgDAHIgBAGIAAAGIgBADIABADIgBABIABACIACgBIABgDIAAABIABABIgBADIAAAEIAAACIAAAFIAAAEIgCABIAAgBIAAgBIAAgBIgBABIgCAAIgBACIgDAAIgCAAIgBAAIgBAAQAAABAAAAQAAAAgBAAQAAAAAAAAQAAAAgBAAIgCABIgBAAIgBAAgAgNAGIgBACIABADIgBAJIAAAJIABACIAAgCIAAgBIABAAIAAAAIAAgBIAAgCIAAgCIAAgBQgBgDABgDIAAgHQABgDgCgDIAAADg");
	this.shape_358.setTransform(-39.375,-220.825);

	this.shape_359 = new cjs.Shape();
	this.shape_359.graphics.f("#404040").s().p("AAhAxIAAgBIgBgBQAAAAAAAAQAAgBAAAAQgBAAAAAAQAAAAAAABIgBgBIgBAAIgCAAIgBAAIAAAAIgBABIgBABIgCAAIgCgEIgDgDIABAAIABABIABgBIAAgBIgBgBIgBgBIgDgCIgDgBIAAgCIgFgDIgFgFIgBgCIgBgCIAAgCIgBgCIgBABIgBgBIgBAAIABgCIABgCIgBAAIAAgBIAAABIgBAAIAAgCIgBgDQAAAAABAAQAAAAAAAAQAAgBAAAAQAAAAAAgBIAAgCIAAgDIABgDIABgCIABgBIABgBIAAABIABgCIABgDIAAABIABgBIAAgCIACgCIAFgFIACgDIACgCIABgDIACgDIADgDIACgFIACgCIACgDQABAAAAgBQAAAAABAAQAAAAABAAQABgBABAAIADABIADABIACgBIACABIABgCIAAAAIACAAIABAAIADABIABACIAAABIABABIAAABIABADIAAACIAAABIABACIgBABIgBABIgBABIgBgBIAAgBIAAgBIAAgBIgBgBIAAgCIgCABIAAABIAAAAIABABIgBACIgBABIAAABIgBABIgCAEIgCABIAAABIgBABIgBACIgBACIgBAAIgBABIAAACIgBAAIgBADQAAAAAAABQAAAAgBAAQAAABAAAAQAAAAgBABIgCACIgCADIgBACIgBAAIgBACIgBACIACADIACACIACACIABACIADADIACAFIACADIABABIABABIADAEIACACIAAABIABABIABABIACACIABADIABABIABACIgBABIAAACQAAAAAAAAQAAAAgBAAQAAAAAAAAQAAABgBAAIgBAAIgCAAIgBAAIAAgBIgBABIgCABIgBgBIAAgBIAAAAIABAAIAAABIABAAIAAgBIAAgCIgBAAIgBAAIgCAAIgCAAIAAAAIgBAAIABACIABABIABAAIgBABIgBAAIgBABgAAqgnIgBABIAAABIAAABIABABIACgCIABgBIAAgBIgBAAIgCAAgAgkAvIgCAAIgBAAIACgCIgBgBIgBAAIgCAAIAAABIAAABIgBABIgBAAIgCAAIgBgBIgBAAIgCgBIgBgCIgBgCIAAgDIAAgDIAAgBIABgCIAAgBIAAgBIAAgCIAAgDIAAgBIAAgDIAAgCIAAgBIAAgBIABgEIAAgGIAAgDIAAgCIAAgEIAAgEIAAgBIAAAAIAAgFIAAgDIAAgCIAAgCIAAgDIAAgDIAAgDIAAgCIAAgBIAAAAIAAgDIAAgCIABgDIAAgCIAAgBIAAAAIAAgCIABgCIABgBIABgBIACAAIACAAIACABIABAAIACgBIABABIACAAIACABIACAAIADAAIADAAIABABIABADIgBAEIABAFIgBAFIAAAGIgBAHIAAABIAAACIAAADIgBADIAAACIABABIgBADIAAADIABAEIgBADIAAADIAAABIAAACIABABIAAABIAAAGIgBAIIAAAIIgBAFIgEACIgEAAIgBAAIgBABIgBgBgAgdAoIAAADIgDABIAAACIACAAQABAAAAgBQABAAAAAAQABAAAAAAQAAgBAAAAIABgDIABgEIgDAAIgBADgAgwASIAAAEIAAAHIgBAFIAAADIABACIABgCIABgEIAAgCIAAgCIAAgBIAAgDIABgBIABgCIAAgBIgBgCIgBgCIAAACIgBAAIAAgBIgBgBg");
	this.shape_359.setTransform(-49.275,-220.5);

	this.shape_360 = new cjs.Shape();
	this.shape_360.graphics.f("#404040").s().p("AgRA0IgCgBIAAAAIgCgBIgDAAIgBgCIgCgBIgBgBIgDgCIgDgBIgBAAIgCgBIAAgDIAAgCIAAgBIADgDQABgBAAAAQABAAAAgBQABAAABAAQAAAAABAAIACAAIACACIABABIABABIAEACIACABIAFACIABABIABAAIABABIABABIgBABIAAABIAAABIAAAAIAAABIgBACIgCACQAAAAAAAAQgBAAAAABQAAAAAAAAQgBAAAAAAIgDAAgAAJAzIgCgBIAAgBIAAgBIAAAAIgBgCIAAgBIABgCIAAgCIAAgBIAAgCIAAgBIADgCIADgDQADgCABgDIABgHIgBgCIAAgCIgBgCIgCgDQgBAAAAAAQAAAAAAgBQgBAAAAAAQAAAAgBAAIgBgBIgBgBIAAgBIgCAAIgCgBIgBAAIgBABIgEgBIgFgBIgBAAIgBgBIgCgBIgBgBIgCAAIgGgBIgFgCIgDgCIgEgCIAAAAIgCgBIgCgBIgBgCIgBgBIgBgBIgBgCIgBgFIgBgDIAAgDIAAgCIABgCIAAgDQAAgBABAAQAAAAABgBQAAAAAAgBQAAAAABgBIABgDIACgCIACgCIACgCIAEgCIAEgCIADABIACAAIAFgBIADAAIABAAIACABIABADIABAEIAAACIAAACIgCACIgBACIgCACIgCABIgCABIAAABIAAACIAAABIAAABIABACIABACQACACACAAIAFABIAEAAIAFABIAEAAIAEACIAFABIAFACIABABIACAAIACACIABACIACABIABACIACABIABABIADAHIACAIIAAADIAAAEIgCAGIAAAFIgCADIgFAGIgCACIgCACIgJADQgEACgFABgAAggfIgDgCIgCgDIgEgBIgFgBIgBAAIgBgBIgCgDIgBgEIAAAAIADgDQAAgBAAAAQAAAAABgBQAAAAABAAQAAAAAAAAIABAAIABAAIAFABIAGADIAEACIACADQABAAAAAAQABABAAAAQAAAAABABQAAAAAAABIABACIAAABQAAABgBAAQAAABAAAAQAAABgBAAQAAABgBAAIgEACIgCgBg");
	this.shape_360.setTransform(-59.7,-220.8);

	this.shape_361 = new cjs.Shape();
	this.shape_361.graphics.f("#404040").s().p("AAgAzIgBgCIgBACIABAAIAAAAIgBABIgBAAIgDgBIgEAAIgCAAIgCAAIgDAAIgDAAIgCAAIgCgCIAAgBIAAAAIgBgBIABgDIgCgCIAAgDIABgFIADgEIADgBIADAAIABAAIABAAIAJABIAJABIACAAIABABIABACIAAAEIAAAEIAAADIAAACIAAABIgBABIgBACIgBABIgBAAIAAgBIgBABIgBAAIgCgBgAggA0IgBAAIgFgBIgCgCIgBgFQABgEAAgFIgBgJIABAAIABAEIAAAEIAAACIgBAEIAAACIABACIAAABIABAAIAAgCIAAgBIAAgCIABgCIAAgBIABgDIABgCIAAgBIgBgBIgBgCIgBgBIAAgEIAAgGIAAgDIAAgDIAAgDIAAgCIgBgBIAAABIgBAAIgBAAIAAgBIAAAAIABgBIgBgCIABgCIABACIABgBIgBgBIgBgCIgBgBIABgCIgBgCIAAAAIABgCIABgBIgBgDIAAgGIAAgFIAAgEIAAgBIAAgCIAAAAIAAgBIAAgCIABgBIABgBIAAgCIgBAAIAAABIgBgBIABgCIgBgCIgBgDIAAgCIACgCIACgBIACgCIABABIACABIAEgBIAFgBIAEAAIACABIAEAAIACAAIACADIABAEIABAEIAAABIgBACIAAABIAAAHIgBAFIAAADIAAADIABACIABADIgBACIABACIADACQADgBADAAIAGAAIAJAAIAEgBIAEABIADgBIADAAIADABQACACAAADIABADIAAAFIgBAGQAAAAgBABQAAAAAAAAQAAAAgBAAQAAABAAAAIgHABIgCgBIgCABIgBgBIgBABIgCgBIAAABIgBAAIgCAAIgDAAIgFgBIgFABIgBgBIgBAAIgDAAIgEAAIgCAAQAAAAAAAAQgBAAAAAAQAAAAAAABQAAAAAAAAIgDADIgBADIAAADIABABIAAAGIAAAGIAAAFIAAADIAAAEIAAABIgBABIgGABIgGAAIgBAAIgBAAIgBAAIgBAAIgBABIgCAAgAgXAxIgBABIABAAIABAAIADAAIAEgBIACgCIgBgCIAAgCIAAgCIgCABIAAACIAAAAQgBAAAAABQAAAAAAAAQAAAAAAAAQAAABAAAAIgBACIgDAAgAgeAqIAAACIAAABIABgBIABgBIAAgCIgBgBIgBACgAAFAMIACAAIAAAAIABAAIACgBIgBgBIgBAAIgCAAIgBgCIgDgBIgBAAIgBABIAAAAIAAABIABACIACABIABgBIABABgAAhAHQAAABAAAAQAAAAgBABQAAAAAAAAQAAAAgBAAIgBACIABABIABAAIACgBIABgBIgBgBIAAgBIgBgBgAgDgEIAAABIABAAIABAAIABAAIAAgBIgBAAIAAAAIgBAAIgBAAgAAhgcIAAgBIgDAAIgCAAIgBAAIgBAAIgBAAIgBABIgEgBIgFgBIAAAAIgCAAIgCgBIgBgEIAAgDIAAAAIAAgBIAAgFIABgEIADgCIAEgBIADABIABAAIABAAIACAAIADgBIACAAIACgBIAEAAIAEABIABADIAAADIgBACIAAADIAAABIABAAIAAABIABACIgBADIgBAEIgCAAIgCAAIgCABIgBAAgAAlghIAAACIAAAAIABAAIABAAIAAgBIAAgBIAAgBIgCgBIAAACgAAMglIABADIADACIAAgDIgBgBIgCgCg");
	this.shape_361.setTransform(-69.075,-221.15);

	this.shape_362 = new cjs.Shape();
	this.shape_362.graphics.f("#404040").s().p("AgEAxQAAgBAAAAQgBAAAAgBQAAAAAAgBQAAAAAAgBIAAgCIAAgBIAAgBIgBgBIABgCIABgBIAEgCIADgBQABAAAAgBQABAAAAAAQABAAAAgBQAAAAABAAIAFgGQAEgCACgDIABgDIABgDIAAAAIABgCIAAgDIABgCIAAgDIAAgBIAAgCIAAgHIgCgIIgBgBIgBgCIAAgBIgBgBIgBgBIAAgCIAAgBIgCgBIAAgBIgBgCIgCgBIgBgCIgBgDIgDgBIgBABIgBABIgBAAIgBgBIgBAAIgBgBQAAAAgBAAQAAAAAAAAQAAAAgBAAQAAAAAAAAIgBgBIgCgBIAAgDIAAgCIAAgBIAAgBIAAAAIABgDIABgBIACgBIABABIADgBIACAAIABAAIACAAIABABIAAAAIABgBIABABIABgBIADAAIADABIADAAIAEACIADABIADAAIABACIABAAIADABIADACIACABIABACIABACIABADIACADIABABIAAABIACAEIABAFQAAAAAAAAQABABAAAAQAAAAAAABQAAAAAAAAIABADIgBACIACAEIABAFIgBABIAAADIAAACIABACIgBABIAAABIAAACIgBACIgBADIAAAEIgBABIgBADIgBABIgBADIgCACIgCABIgBACIAAABIgCACIgCACIgCADIgDABQAAAAAAAAQgBABAAAAQAAAAAAABQAAAAgBAAIgEABIgDABIgCAAIgCAAIgCABIgCABIgBgBIgCABIgDAAIgCgBIgBABIgEAAIgDAAIgEAAgAgEAuIADABIABAAIABAAIABAAIgDgBIgBgBIgBAAIAAAAgAARAvIABAAIAAgBIgBAAgAAbAqIgBABIgDABIgCABIAFAAIADgBIAEgCIgCgBIgCABIgBgBIgBABgAgsAxIgBAAIgDgBIgDgBIgBAAIAAgCIAAgBIAAgBIAAgBIAAgBIAAgCIAAgBIAAgBIAAgDIABgDIgBgCIAAgCIABgEIAAgFIAAgDIAAgHIAAgHIAAgBIAAgCIAAgDIAAgEIAAgEIAAgCIABgBIAAgDIgBgDIABgJIAAgJIAAgDIAAgCIABgBIADgBIADgBIACAAIACAAIABAAIABAAIACAAIAEAAIACAAQAAABABAAQAAAAAAAAQABAAAAAAQAAAAABAAIACgBIACACIAAADIAAACIgBAEIABAEIAAABIgBACIAAAFIAAAFIAAAAIAAABIAAAFIgBAFIAAALIAAANIAAACIgBABIAAAEIAAADIAAAFIAAAFIAAABIAAACIAAAEIAAAEQgBABAAAAQgBABAAAAQgBAAAAAAQgBAAAAAAIgGABIgBgBIgBAAIAAAAIgBAAIgCABIgCAAIgCAAgAgeAsIABABQAAAAgBABQAAAAABAAQAAAAAAAAQAAAAAAAAIABAAIABgCIgBAAIgBgBgAgxAlIgBABIAAADIAAACIAAACIABABIABAAIgBgDIAAgDIAAgBIAAgCIABgEIgBgCIAAgBIAAAHgAgxgMIAAALIAAADIAAAFIABgBIAAgGIAAgFIABgCIAAgEIAAgCIAAgBIABAAIgBgBIAAgCIgBgDIAAgCIAAgBIgBALg");
	this.shape_362.setTransform(-79.7125,-221.125);

	this.shape_363 = new cjs.Shape();
	this.shape_363.graphics.f("#999999").s().p("AgIAIIAAgPIARAAIAAAPg");
	this.shape_363.setTransform(-31.575,43.775);

	this.shape_364 = new cjs.Shape();
	this.shape_364.graphics.f("#999999").s().p("AgQAWIAAgpIAQAAIAAAHQABgFACgCIAGgCQAEAAAEACIgGALIgEgBQgDABgCACQgCAFAAAJIAAAOg");
	this.shape_364.setTransform(-33.8,42.45);

	this.shape_365 = new cjs.Shape();
	this.shape_365.graphics.f("#999999").s().p("AgUATQgDgEAAgFQAAgFACgDQADgCAIgCIALgDIAFgCIgBgEIgEgBQgEAAgBACIgDADIgQgBQABgEACgDQABgCAEgCIAGgCIAIAAIALAAQAEABADACIAEAFIABAHIAAASIABAEIABAFIgOAAIgCgDIgBgCQgDADgDABQgDACgGAAQgHAAgFgDgAAAADQgFABgBACIgBADIABADQAAAAABABQAAAAABAAQAAAAABAAQAAAAABAAQACAAADgCIACgDIABgFIAAgDIgGADg");
	this.shape_365.setTransform(-38.7,42.5625);

	this.shape_366 = new cjs.Shape();
	this.shape_366.graphics.f("#999999").s().p("AgJAVQgFgBgDgDQgDgDgCgEQgCgEAAgGQAAgGACgEIAEgGIAGgDQAFgCAHAAQAKgBAGAEQAFAEACAHIgPACIgDgEQgCgCgDAAQgDABgCADQgCADAAAEQAAAGACACQADADACAAQAEAAACgCIADgFIAQACQgCAFgDADQgDAEgEACQgFACgHAAIgCAAIgIgBg");
	this.shape_366.setTransform(-44.175,42.6031);

	this.shape_367 = new cjs.Shape();
	this.shape_367.graphics.f("#999999").s().p("AgPATQgFgDgCgHIARgBQAAABAAAAQABABAAAAQAAABABAAQAAABAAAAQACABACAAQAEAAABgCQABAAAAAAQAAAAAAgBQABAAAAAAQAAgBAAAAQAAgBAAAAQgBgBAAAAQAAAAAAgBQgBAAAAAAIgGgBIgMgDQgDgBgDgCQgCgDAAgEQAAgEACgDQADgDAEgCQAEgBAHAAQAHgBAEABQADABADADQACACACAEIgQACQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAAAgBAAIgDgBIgEABQgBABAAAAQAAAAAAAAQgBABAAAAQAAAAAAABQAAAAAAABQAAAAABAAQAAAAAAABQAAAAABAAIAGABQAJABAEABQAEACACACQACADAAAEQAAAEgCADQgDAEgFACQgEACgJAAQgKAAgFgDg");
	this.shape_367.setTransform(-49.525,42.6167);

	this.shape_368 = new cjs.Shape();
	this.shape_368.graphics.f("#999999").s().p("AgDAdQgDgCgCgEIgBgKIAAgOIgGAAIAAgMIAGAAIAAgIIAPgIIAAAQIAJAAIAAAMIgJAAIAAAOIABAEQAAAAAAABQABAAAAAAQAAAAABAAQAAABABAAIAFgCIABALIgLACQgFAAgDgBg");
	this.shape_368.setTransform(-56.575,41.95);

	this.shape_369 = new cjs.Shape();
	this.shape_369.graphics.f("#999999").s().p("AgPATQgFgDgCgHIARgBIACAEQACABACAAQAEAAABgCQABAAAAAAQAAAAAAgBQABAAAAAAQAAgBAAAAQAAgBAAAAQgBgBAAAAQAAAAAAgBQgBAAAAAAIgGgBIgMgDQgDgBgDgCQgCgDAAgEQAAgEACgDQADgDAEgCQAEgBAHAAQAHgBAEABQADABADADQACACACAEIgQACQAAAAAAgBQAAAAgBgBQAAAAAAgBQAAAAgBAAIgDgBIgEABQgBABAAAAQAAAAAAAAQgBABAAAAQAAAAAAABQAAAAAAABQAAAAABAAQAAAAAAABQAAAAABAAIAGABQAJABAEABQAEACACACQACADAAAEQAAAEgCADQgDAEgFACQgEACgJAAQgKAAgFgDg");
	this.shape_369.setTransform(-60.975,42.7667);

	this.shape_370 = new cjs.Shape();
	this.shape_370.graphics.f("#999999").s().p("AgNAUQgEgDgEgFQgDgFAAgHQAAgJAGgGQAGgGAMAAQAIgBAFADQAGADACAFQAEAFAAAIIAAABIggABQAAAEACACQACADADAAIAFgCIADgDIAQACQgEAGgFADQgFADgKAAQgIAAgFgCgAAAgMQgDAAgDADQgBACAAAEIAPAAQgBgFgCgCQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAAAAAIgBAAg");
	this.shape_370.setTransform(-66.1768,42.8208);

	this.shape_371 = new cjs.Shape();
	this.shape_371.graphics.f("#999999").s().p("AgVAeIgBg7IARAAIAAAWQADgDACgCQAEgCAEAAQAHAAAEAFQADAEABAHIAAAbIgRAAIAAgYQAAgEgCgBQAAAAgBAAQAAAAAAAAQgBgBgBAAQAAAAgBABQgCAAgCABIgBAIIAAAVg");
	this.shape_371.setTransform(-71.725,42.05);

	this.shape_372 = new cjs.Shape();
	this.shape_372.graphics.f("#999999").s().p("AgQAbQgFgFAAgGIAAgCIAQACIACADIADABQAEgBACgBQABgCAAgFIAAgHIgFAFQgCACgFABQgIgBgGgHQgDgFAAgJQgBgJAFgFQAFgGAIAAIAHABQADACADAEIAAgGIAPAAIABAnIAAACQAAAEgCAEQgCADgCACQgDADgFABIgKABQgMAAgEgDgAAAgSQgDAAgCADIgBAHQAAAEACADQACABACAAQADAAACgCQACgCAAgEQAAgGgCgCQgBgBAAAAQgBAAAAgBQgBAAgBAAQAAAAgBAAIAAAAg");
	this.shape_372.setTransform(-77.3023,43.75);

	this.shape_373 = new cjs.Shape();
	this.shape_373.graphics.f("#999999").s().p("AgHAeIAAgqIAPAAIABAqgAgHgSIAAgLIAPAAIAAALg");
	this.shape_373.setTransform(-81.35,42.1);

	this.shape_374 = new cjs.Shape();
	this.shape_374.graphics.f("#999999").s().p("AgVAdIgBg5IARAAIAAAVQADgDACgCQAEgCAEAAQAHAAAEAFQADADABAIIAAAbIgRAAIAAgYQAAgEgCgBQAAAAgBAAQAAAAAAAAQgBgBgBAAQAAAAgBABQgCAAgCABIgBAIIAAAUg");
	this.shape_374.setTransform(-85.475,42.15);

	this.shape_375 = new cjs.Shape();
	this.shape_375.graphics.f("#999999").s().p("AgSAYQgEgHAAgKQgBgJAFgGQAFgFAIAAIAGABQADABADACIAAgUIAQAAIABA6IgQAAIAAgHQgDAEgDACQgCACgEAAQgJAAgFgGgAAAgBQgDAAgCABIgBAIQAAAFACADQACACACAAQADAAACgDQACgCAAgGQAAgFgCgCQgBAAAAAAQgBgBAAAAQgBAAgBAAQAAAAgBAAIAAAAg");
	this.shape_375.setTransform(-93.7523,42.225);

	this.shape_376 = new cjs.Shape();
	this.shape_376.graphics.f("#999999").s().p("AgVAWIgBgpIAPAAIAAAGQAEgEADgCQADgCAFAAQAHAAAEAEQADAEABAJIAAAaIgRAAIAAgXQAAgEgCgCQAAAAgBAAQAAgBAAAAQgBAAgBAAQAAAAgBAAQgCAAgCADIgBAGIAAAVg");
	this.shape_376.setTransform(-99.175,43);

	this.shape_377 = new cjs.Shape();
	this.shape_377.graphics.f("#999999").s().p("AgUATQgEgEAAgFQAAgFADgDQADgCAIgCIALgDIAFgCIgBgEIgEgBQgEAAgCACIgCADIgQgBQABgEACgDQACgCADgCIAGgCIAJAAIAKAAQAEABAEACIADAFIABAHIAAASIABAEIABAFIgOAAIgCgDIAAgCQgDADgEABQgDACgGAAQgHAAgFgDgAAAADQgEABgCACIgBADIABADQAAAAABABQAAAAABAAQAAAAABAAQAAAAABAAQACAAACgCIADgDIABgFIAAgDIgGADg");
	this.shape_377.setTransform(-104.65,43.1125);

	this.shape_378 = new cjs.Shape();
	this.shape_378.graphics.f("#999999").s().p("AgPATQgFgDgCgHIARgBIACAEQACABACAAQAEAAABgCQABAAAAAAQAAAAAAgBQABAAAAAAQAAgBAAAAQAAgBAAAAQgBgBAAAAQAAAAAAgBQgBAAAAAAIgGgBIgMgDQgDgBgDgCQgCgDAAgEQAAgEACgDQADgDAEgCQAEgBAHAAQAHgBAEABQADABADADQACACACAEIgQACQAAAAAAgBQAAAAgBgBQAAAAAAgBQAAAAgBAAIgDgBIgEABQgBABAAAAQAAAAAAAAQgBABAAAAQAAAAAAABQAAAAAAABQAAAAABAAQAAAAAAABQAAAAABAAIAGABQAJABAEABQAEACACACQACADAAAEQAAAEgCADQgDAEgFACQgEACgJAAQgKAAgFgDg");
	this.shape_378.setTransform(-112.725,43.2167);

	this.shape_379 = new cjs.Shape();
	this.shape_379.graphics.f("#999999").s().p("AgNAUQgEgDgEgFQgDgFAAgHQAAgJAGgGQAGgGAMAAQAIgBAFADQAGADACAFQAEAFAAAIIAAABIggABQAAAEACACQACADADAAIAFgCIADgDIAQACQgEAGgFADQgFADgKAAQgIAAgFgCgAAAgMQgDAAgDADQgBACAAAEIAPAAQgBgFgCgCQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAAAAAIgBAAg");
	this.shape_379.setTransform(-117.9268,43.2708);

	this.shape_380 = new cjs.Shape();
	this.shape_380.graphics.f("#999999").s().p("AgYgUIARAAIAIAaIAIgbIAQAAIgRAqIgOABg");
	this.shape_380.setTransform(-123.025,43.3);

	this.shape_381 = new cjs.Shape();
	this.shape_381.graphics.f("#999999").s().p("AgUATQgDgEAAgFQAAgFACgDQADgCAIgCIALgDIAFgCIgBgEIgEgBQgEAAgCACIgCADIgQgBQABgEACgDQACgCADgCIAGgCIAIAAIALAAQAFABADACIADAFIABAHIAAASIABAEIABAFIgOAAIgCgDIgBgCQgDADgDABQgDACgGAAQgHAAgFgDgAAAADQgFABgBACIgBADIABADQAAAAABABQAAAAABAAQAAAAABAAQAAAAABAAQACAAADgCIACgDIABgFIAAgDIgGADg");
	this.shape_381.setTransform(-128.15,43.3625);

	this.shape_382 = new cjs.Shape();
	this.shape_382.graphics.f("#999999").s().p("AgPAWIgBgqIAQAAIAAAHQAAgEADgCIAGgCQADAAAFACIgGAMIgEgBQgDAAgCADQgCAEAAAIIAAAPg");
	this.shape_382.setTransform(-132.55,43.3);

	this.shape_383 = new cjs.Shape();
	this.shape_383.graphics.f("#999999").s().p("AgQAaQgFgDAAgHIAAgCIAQACIACADIADABQAEgBACgCQABgBAAgFIAAgGIgFAEQgCACgFAAQgIABgGgIQgDgEAAgJQgBgKAFgGQAFgEAIAAIAHABQADABADAEIAAgGIAPAAIABAnIAAACQAAAEgCADQgCAFgCABQgDADgFABIgKACQgMgBgEgEgAAAgSQgDAAgCACIgBAIQAAAEACADQACABACAAQADAAACgBQACgDAAgFQAAgEgCgDQgBgBAAAAQgBAAAAgBQgBAAgBAAQAAAAgBAAIAAAAg");
	this.shape_383.setTransform(-137.6523,44.25);

	this.shape_384 = new cjs.Shape();
	this.shape_384.graphics.f("#999999").s().p("AgDAdQgDgCgCgEIgBgKIAAgOIgGAAIAAgMIAGAAIAAgIIAPgIIAAAQIAJAAIAAAMIgJAAIAAAOIABAEQAAAAAAABQABAAAAAAQAAAAABAAQAAABABAAIAFgCIABALIgLACQgFAAgDgBg");
	this.shape_384.setTransform(-144.875,42.75);

	this.shape_385 = new cjs.Shape();
	this.shape_385.graphics.f("#999999").s().p("AgPATQgFgDgCgHIARgBIACAEQACABACAAQAEAAABgCQABAAAAAAQAAAAAAgBQABAAAAAAQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAAAAAgBQgBAAAAAAIgGgBIgMgDQgDgBgDgCQgCgDAAgEQAAgEACgDQADgDAEgCQAEgBAHAAQAHgBAEABQADABADADQACACACAEIgQACQAAAAAAgBQAAAAgBgBQAAAAAAgBQAAAAgBAAIgDgBIgEABQgBABAAAAQAAAAAAAAQgBABAAAAQAAAAAAABQAAAAAAABQAAAAABAAQAAAAAAABQAAAAABAAIAGABQAJABAEABQAEACACACQACADAAAEQAAAEgCADQgDAEgFACQgEACgJAAQgKAAgFgDg");
	this.shape_385.setTransform(-149.275,43.5667);

	this.shape_386 = new cjs.Shape();
	this.shape_386.graphics.f("#999999").s().p("AgQARQgHgGAAgLQgBgJAHgGQAGgGALAAQAMgBAHAHQAFAGABAJQAAAJgHAGQgGAHgMAAQgJAAgHgFgAAAgKQgDAAgCADQgCACAAAFQAAAGACACQADADACAAQAEAAACgDQACgDAAgFQAAgFgCgDQgDgCgDAAIAAAAg");
	this.shape_386.setTransform(-154.5018,43.6233);

	this.shape_387 = new cjs.Shape();
	this.shape_387.graphics.f("#999999").s().p("AgjAWIgBgpIAQAAIAAAFQADgEAEgBQADgCAEAAQAGAAACACIAFAFIAHgFQADgCAFAAQAGAAAEAEQAEAEAAAIIAAAaIgQAAIAAgXQAAgBAAAAQAAgBAAAAQgBgBAAAAQAAgBgBAAQAAgBAAAAQgBgBAAAAQgBAAAAAAQgBAAAAAAQgBAAgBAAQgBAAAAAAQgBAAAAABQgBAAAAAAQgBADgBAEIAAAVIgPAAIAAgWIAAgEIgDgCIgCgBQgBAAgBAAQgBAAAAAAQgBABAAAAQgBABAAAAQgBADgBADIAAAWg");
	this.shape_387.setTransform(-161.4,43.6);

	this.shape_388 = new cjs.Shape();
	this.shape_388.graphics.f("#999999").s().p("AgNAUQgEgDgEgFQgDgFAAgHQAAgJAGgGQAGgGAMAAQAIgBAFADQAGADACAFQAEAFAAAIIAAABIggABQAAAEACACQACADADAAIAFgCIADgDIAQACQgEAGgFADQgFADgKAAQgIAAgFgCgAAAgMQgDAAgDADQgBACAAAEIAPAAQgBgFgCgCQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAAAAAIgBAAg");
	this.shape_388.setTransform(95.0732,26.7708);

	this.shape_389 = new cjs.Shape();
	this.shape_389.graphics.f("#999999").s().p("AgVAeIgBg7IARAAIAAAWQADgDACgCQAEgBAEAAQAHAAAEADQADAFABAHIAAAbIgRAAIAAgYQAAgDgCgCQAAAAgBAAQAAAAgBAAQAAgBgBAAQAAAAgBAAQgCABgCABIgBAIIAAAVg");
	this.shape_389.setTransform(89.525,26);

	this.shape_390 = new cjs.Shape();
	this.shape_390.graphics.f("#999999").s().p("AgDAdQgDgCgCgEIgBgKIAAgOIgGAAIAAgMIAGAAIAAgIIAPgIIAAAQIAJAAIAAAMIgJAAIAAAOIABAEQAAAAAAABQABAAAAAAQAAAAABAAQAAABABAAIAFgCIABALIgLACQgFAAgDgBg");
	this.shape_390.setTransform(84.975,26.1);

	this.shape_391 = new cjs.Shape();
	this.shape_391.graphics.f("#999999").s().p("AgQAWIAAgpIAPAAIAAAGQACgFACgBIAGgCQADAAAFACIgGAMIgEgBQgDAAgCACQgCAEAAAKIAAAOg");
	this.shape_391.setTransform(78.9,26.85);

	this.shape_392 = new cjs.Shape();
	this.shape_392.graphics.f("#999999").s().p("AgQARQgHgGAAgLQgBgJAHgGQAGgGALAAQAMgBAHAHQAFAGABAJQAAAJgHAGQgGAHgMAAQgJAAgHgFgAAAgKQgDAAgCADQgCACAAAFQAAAGACACQADADACAAQAEAAACgDQACgDAAgFQAAgFgCgDQgDgCgDAAIAAAAg");
	this.shape_392.setTransform(73.9982,26.9733);

	this.shape_393 = new cjs.Shape();
	this.shape_393.graphics.f("#999999").s().p("AgJAeIgBgeIgGAAIAAgLIAGAAIAAgDIABgFIACgGIAFgDIAHgBIAMABIgCAKIgFAAIgCAAIgCACIAAAFIAIgBIAAAMIgIAAIAAAeg");
	this.shape_393.setTransform(69.9,26.15);

	this.shape_394 = new cjs.Shape();
	this.shape_394.graphics.f("#999999").s().p("AgSAYQgEgHAAgKQgBgJAFgGQAFgFAIAAIAGABQADABADACIAAgUIAQAAIABA6IgQAAIAAgHQgDAEgDACQgCACgEAAQgJAAgFgGgAAAgBQgDAAgCABIgBAIQAAAFACADQACACACAAQADAAACgDQACgCAAgGQAAgFgCgCQgBAAAAAAQgBgBAAAAQgBAAgBAAQAAAAgBAAIAAAAg");
	this.shape_394.setTransform(62.5977,26.275);

	this.shape_395 = new cjs.Shape();
	this.shape_395.graphics.f("#999999").s().p("AgPAWIgBgpIAQAAIAAAHQAAgGADgBIAGgCQADAAAFACIgGALIgEAAQgDAAgCACQgCAFAAAJIAAAOg");
	this.shape_395.setTransform(58.25,27.05);

	this.shape_396 = new cjs.Shape();
	this.shape_396.graphics.f("#999999").s().p("AgQARQgHgGAAgLQgBgJAHgGQAGgGALAAQAMgBAHAHQAFAGABAJQAAAJgHAGQgGAHgMAAQgJAAgHgFgAAAgKQgDAAgCADQgCACAAAFQAAAGACACQADADACAAQAEAAACgDQACgDAAgFQAAgFgCgDQgDgCgDAAIAAAAg");
	this.shape_396.setTransform(53.3482,27.1733);

	this.shape_397 = new cjs.Shape();
	this.shape_397.graphics.f("#999999").s().p("AgJAVQgFgBgDgDQgDgDgCgEQgCgEAAgGQAAgGACgEIAEgGIAGgDQAFgCAHAAQAKgBAGAEQAFAEACAHIgPACIgDgEQgCgCgDAAQgDABgCADQgCADAAAEQAAAGACACQADADACAAQAEAAACgCIADgFIAQACQgCAFgDADQgDAEgEACQgFACgHAAIgCAAIgIgBg");
	this.shape_397.setTransform(47.875,27.2031);

	this.shape_398 = new cjs.Shape();
	this.shape_398.graphics.f("#999999").s().p("AgNAUQgEgDgEgFQgDgFAAgHQAAgJAGgGQAGgGAMAAQAIgBAFADQAGADACAFQAEAFAAAIIAAABIggABQAAAEACACQACADADAAIAFgCIADgDIAQACQgEAGgFADQgFADgKAAQgIAAgFgCgAAAgMQgDAAgDADQgBACAAAEIAPAAQgBgFgCgCQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAAAAAIgBAAg");
	this.shape_398.setTransform(42.3732,27.2708);

	this.shape_399 = new cjs.Shape();
	this.shape_399.graphics.f("#999999").s().p("AgQAWIAAgqIAPAAIAAAIQACgGACgBIAGgCQADAAAFACIgGALIgEgBQgDABgCADQgCADAAAJIAAAPg");
	this.shape_399.setTransform(37.95,27.25);

	this.shape_400 = new cjs.Shape();
	this.shape_400.graphics.f("#999999").s().p("AgHAdIgBg5IAQAAIAAA5g");
	this.shape_400.setTransform(31.65,26.5);

	this.shape_401 = new cjs.Shape();
	this.shape_401.graphics.f("#999999").s().p("AgUATQgDgEAAgFQAAgFACgDQADgCAIgCIALgDIAFgCIgBgEIgEgBQgEAAgCACIgCADIgQgBQABgEACgDQACgCADgCIAGgCIAIAAIALAAQAFABADACIADAFIABAHIAAASIABAEIABAFIgOAAIgCgDIgBgCQgDADgDABQgDACgGAAQgHAAgFgDgAAAADQgFABgBACIgBADIABADQAAAAABABQAAAAABAAQAAAAABAAQAAAAABAAQACAAADgCIACgDIABgFIAAgDIgGADg");
	this.shape_401.setTransform(27.55,27.3625);

	this.shape_402 = new cjs.Shape();
	this.shape_402.graphics.f("#999999").s().p("AgVAWIgBgqIAPAAIAAAHQAEgEADgCQADgCAFAAQAHAAAEAEQADAEABAJIAAAaIgRAAIAAgXQAAgEgCgBQAAgBgBAAQAAgBgBAAQAAAAgBAAQAAAAgBAAQgCAAgCADIgBAHIAAAUg");
	this.shape_402.setTransform(22.025,27.35);

	this.shape_403 = new cjs.Shape();
	this.shape_403.graphics.f("#999999").s().p("AgQARQgHgGAAgLQgBgJAHgGQAGgGALAAQAMgBAHAHQAFAGABAJQAAAJgHAGQgGAHgMAAQgJAAgHgFgAAAgKQgDAAgCADQgCACAAAFQAAAGACACQADADACAAQAEAAACgDQACgDAAgFQAAgFgCgDQgDgCgDAAIAAAAg");
	this.shape_403.setTransform(16.5482,27.4733);

	this.shape_404 = new cjs.Shape();
	this.shape_404.graphics.f("#999999").s().p("AgPATQgFgDgCgHIARgBIACAEQACABACAAQAEAAABgCQABAAAAAAQAAAAAAgBQABAAAAAAQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAAAAAgBQgBAAAAAAIgGgBIgMgDQgDgBgDgCQgCgDAAgEQAAgEACgDQADgDAEgCQAEgBAHAAQAHgBAEABQADABADADQACACACAEIgQACQAAAAAAgBQAAAAgBgBQAAAAAAgBQAAAAgBAAIgDgBIgEABQgBABAAAAQAAAAAAAAQgBABAAAAQAAAAAAABQAAAAAAABQAAAAABAAQAAAAAAABQAAAAABAAIAGABQAJABAEABQAEACACACQACADAAAEQAAAEgCADQgDAEgFACQgEACgJAAQgKAAgFgDg");
	this.shape_404.setTransform(11.275,27.5167);

	this.shape_405 = new cjs.Shape();
	this.shape_405.graphics.f("#999999").s().p("AgPAWIgBgpIAPAAIAAAHQABgGADgBIAGgCQADAAAFACIgFALIgFgBQgDABgCACQgCAFAAAJIAAAOg");
	this.shape_405.setTransform(7.1,27.5);

	this.shape_406 = new cjs.Shape();
	this.shape_406.graphics.f("#999999").s().p("AgNAUQgEgDgEgFQgDgFAAgHQAAgJAGgGQAGgGAMAAQAIgBAFADQAGADACAFQAEAFAAAIIAAABIggABQAAAEACACQACADADAAIAFgCIADgDIAQACQgEAGgFADQgFADgKAAQgIAAgFgCgAAAgMQgDAAgDADQgBACAAAEIAPAAQgBgFgCgCQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAAAAAIgBAAg");
	this.shape_406.setTransform(2.2732,27.6208);

	this.shape_407 = new cjs.Shape();
	this.shape_407.graphics.f("#999999").s().p("AgWAeIgBg6IAQAAIAAAGIAFgFQADgCAEAAQAJAAAFAGQAEAHABAJQAAAKgFAGQgFAFgIAAIgGgBQgDgBgDgCIAAAUgAgEgOQgCACAAAGQAAAFACABQACACADAAQADAAACgCQABgCAAgFQAAgGgCgCQgCgCgDAAQgCAAgCADg");
	this.shape_407.setTransform(-3.175,28.425);

	this.shape_408 = new cjs.Shape();
	this.shape_408.graphics.f("#999999").s().p("AgPAWIgBgqIAPAAIAAAHQACgEACgCIAGgCQADAAAFACIgFAMIgFgBQgDAAgCADQgCADAAAKIAAAOg");
	this.shape_408.setTransform(-10.25,27.65);

	this.shape_409 = new cjs.Shape();
	this.shape_409.graphics.f("#999999").s().p("AgSASQgDgEAAgIIgBgbIAQAAIABAXQAAAEABABQABABAAAAQABAAAAABQABAAAAAAQABAAAAAAQADgBACgCQABgCAAgFIAAgUIAQAAIABAqIgQAAIAAgHQgDAEgDACQgDACgFAAQgHAAgEgEg");
	this.shape_409.setTransform(-15.175,27.8);

	this.shape_410 = new cjs.Shape();
	this.shape_410.graphics.f("#999999").s().p("AgQARQgHgGAAgLQgBgJAHgGQAGgGALAAQAMgBAHAHQAFAGABAJQAAAJgHAGQgGAHgMAAQgJAAgHgFgAAAgKQgDAAgCADQgCACAAAFQAAAGACACQADADACAAQAEAAACgDQACgDAAgFQAAgFgCgDQgDgCgDAAIAAAAg");
	this.shape_410.setTransform(-20.6518,27.8233);

	this.shape_411 = new cjs.Shape();
	this.shape_411.graphics.f("#999999").s().p("AgUAdIgBgLIAIABQAAAAABAAQABAAAAgBQABAAAAAAQABAAAAgBQACgBABgDIgSgqIARAAIAJAcIAHgcIAQAAIgQAsQgDAIgDADQgDAEgJAAIgLgBg");
	this.shape_411.setTransform(-25.825,28.725);

	this.shape_412 = new cjs.Shape();
	this.shape_412.graphics.f("#999999").s().p("AgPATQgFgDgCgHIARgBIACAEQACABACAAQAEAAABgCQABAAAAAAQAAAAAAgBQABAAAAAAQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAAAAAgBQgBAAAAAAIgGgBIgMgDQgDgBgDgCQgCgDAAgEQAAgEACgDQADgDAEgCQAEgBAHAAQAHgBAEABQADABADADQACACACAEIgQACQAAAAAAgBQAAAAgBgBQAAAAAAgBQAAAAgBAAIgDgBIgEABQgBABAAAAQAAAAAAAAQgBABAAAAQAAAAAAABQAAAAAAABQAAAAABAAQAAAAAAABQAAAAABAAIAGABQAJABAEABQAEACACACQACADAAAEQAAAEgCADQgDAEgFACQgEACgJAAQgKAAgFgDg");
	this.shape_412.setTransform(-33.625,27.9667);

	this.shape_413 = new cjs.Shape();
	this.shape_413.graphics.f("#999999").s().p("AgPATQgFgDgCgHIARgBIACAEQACABACAAQAEAAABgCQABAAAAAAQAAAAAAgBQABAAAAAAQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAAAAAgBQgBAAAAAAIgGgBIgMgDQgDgBgDgCQgCgDAAgEQAAgEACgDQADgDAEgCQAEgBAHAAQAHgBAEABQADABADADQACACACAEIgQACQAAAAAAgBQAAAAgBgBQAAAAAAgBQAAAAgBAAIgDgBIgEABQgBABAAAAQAAAAAAAAQgBABAAAAQAAAAAAABQAAAAAAABQAAAAABAAQAAAAAAABQAAAAABAAIAGABQAJABAEABQAEACACACQACADAAAEQAAAEgCADQgDAEgFACQgEACgJAAQgKAAgFgDg");
	this.shape_413.setTransform(-38.675,27.9667);

	this.shape_414 = new cjs.Shape();
	this.shape_414.graphics.f("#999999").s().p("AgUATQgEgEAAgFQAAgFADgDQADgCAIgCIALgDIAFgCIgBgEIgEgBQgEAAgCACIgCADIgQgBQABgEACgDQACgCADgCIAGgCIAJAAIAKAAQAEABAEACIADAFIABAHIAAASIABAEIABAFIgOAAIgCgDIAAgCQgDADgEABQgDACgGAAQgHAAgFgDgAAAADQgEABgCACIgBADIABADQAAAAABABQAAAAABAAQAAAAABAAQAAAAABAAQACAAACgCIADgDIABgFIAAgDIgGADg");
	this.shape_414.setTransform(-43.9,28.0125);

	this.shape_415 = new cjs.Shape();
	this.shape_415.graphics.f("#999999").s().p("AgWAeIgBg6IAQAAIAAAGIAFgFQADgCAEAAQAJAAAFAGQAEAHABAJQAAAKgFAGQgFAFgIAAIgGgBQgDgBgDgCIAAAUgAgEgOQgCACAAAGQAAAFACABQACACADAAQADAAACgCQABgCAAgFQAAgGgCgCQgCgCgDAAQgCAAgCADg");
	this.shape_415.setTransform(-49.325,28.825);

	this.shape_416 = new cjs.Shape();
	this.shape_416.graphics.f("#999999").s().p("AgPAWIgBgpIAPAAIAAAHQABgFADgCIAGgCQAEAAAEACIgFALIgFgBQgDABgCACQgCAFAAAIIAAAPg");
	this.shape_416.setTransform(-54,28.05);

	this.shape_417 = new cjs.Shape();
	this.shape_417.graphics.f("#999999").s().p("AgSASQgDgEAAgJIgBgaIAQAAIABAXQAAAEABACQABAAAAAAQABAAAAABQABAAAAAAQABAAAAAAQADgBACgBQABgDAAgEIAAgVIAQAAIABApIgQAAIAAgHQgDAFgDACQgDACgFAAQgHAAgEgEg");
	this.shape_417.setTransform(-58.925,28.2);

	this.shape_418 = new cjs.Shape();
	this.shape_418.graphics.f("#999999").s().p("AgPATQgFgDgCgHIARgBIACAEQACABACAAQAEAAABgCQABAAAAAAQAAAAAAgBQABAAAAAAQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAAAAAgBQgBAAAAAAIgGgBIgMgDQgDgBgDgCQgCgDAAgEQAAgEACgDQADgDAEgCQAEgBAHAAQAHgBAEABQADABADADQACACACAEIgQACQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAAAgBAAIgDgBIgEABQgBABAAAAQAAAAAAAAQgBABAAAAQAAAAAAABQAAAAAAABQAAAAABAAQAAAAAAABQAAAAABAAIAGABQAJABAEABQAEACACACQACADAAAEQAAAEgCADQgDAEgFACQgEACgJAAQgKAAgFgDg");
	this.shape_418.setTransform(-64.175,28.2167);

	this.shape_419 = new cjs.Shape();
	this.shape_419.graphics.f("#999999").s().p("AgQARQgHgGAAgLQgBgJAHgGQAGgGALAAQAMgBAHAHQAFAGABAJQAAAJgHAGQgGAHgMAAQgJAAgHgFgAAAgKQgDAAgCADQgCACAAAFQAAAGACACQADADACAAQAEAAACgDQACgDAAgFQAAgFgCgDQgDgCgDAAIAAAAg");
	this.shape_419.setTransform(-72.1518,28.3233);

	this.shape_420 = new cjs.Shape();
	this.shape_420.graphics.f("#999999").s().p("AgDAdQgDgCgCgEIgBgKIAAgOIgGAAIAAgMIAGAAIAAgIIAPgIIAAAQIAJAAIAAAMIgJAAIAAAOIABAEQAAAAAAABQABAAAAAAQAAAAABAAQAAABABAAIAFgCIABALIgLACQgFAAgDgBg");
	this.shape_420.setTransform(-76.725,27.55);

	this.shape_421 = new cjs.Shape();
	this.shape_421.graphics.f("#999999").s().p("AgJAeIAAgeIgHAAIAAgLIAHAAIAAgDIAAgFIACgGIAFgDIAGgBIANABIgCAKIgFAAIgCAAIgCACIAAAFIAHgBIAAAMIgHAAIAAAeg");
	this.shape_421.setTransform(-83.3,27.5);

	this.shape_422 = new cjs.Shape();
	this.shape_422.graphics.f("#999999").s().p("AgHAdIAAg5IAPAAIAAA5g");
	this.shape_422.setTransform(-86.4,27.6);

	this.shape_423 = new cjs.Shape();
	this.shape_423.graphics.f("#999999").s().p("AgNAUQgEgDgEgFQgDgFAAgHQAAgJAGgGQAGgGAMAAQAIgBAFADQAGADACAFQAEAFAAAIIAAABIggABQAAAEACACQACADADAAIAFgCIADgDIAQACQgEAGgFADQgFADgKAAQgIAAgFgCgAAAgMQgDAAgDADQgBACAAAEIAPAAQgBgFgCgCQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAAAAAIgBAAg");
	this.shape_423.setTransform(-90.4768,28.4708);

	this.shape_424 = new cjs.Shape();
	this.shape_424.graphics.f("#999999").s().p("AgPATQgFgDgCgHIARgBIACAEQACABACAAQAEAAABgCQABAAAAAAQAAAAAAgBQABAAAAAAQAAgBAAAAQAAgBAAAAQgBgBAAAAQAAAAAAgBQgBAAAAAAIgGgBIgMgDQgDgBgDgCQgCgDAAgEQAAgEACgDQADgDAEgCQAEgBAHAAQAHgBAEABQADABADADQACACACAEIgQACQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAAAgBAAIgDgBIgEABQgBABAAAAQAAAAAAAAQgBABAAAAQAAAAAAABQAAAAAAABQAAAAABAAQAAAAAAABQAAAAABAAIAGABQAJABAEABQAEACACACQACADAAAEQAAAEgCADQgDAEgFACQgEACgJAAQgKAAgFgDg");
	this.shape_424.setTransform(-95.775,28.5167);

	this.shape_425 = new cjs.Shape();
	this.shape_425.graphics.f("#999999").s().p("AgQAWIAAgqIAQAAIAAAHQABgEACgCIAGgCQAEAAAEACIgGAMIgEgBQgDAAgCADQgCAEAAAIIAAAPg");
	this.shape_425.setTransform(-99.95,28.45);

	this.shape_426 = new cjs.Shape();
	this.shape_426.graphics.f("#999999").s().p("AgSASQgDgEAAgIIgBgaIAQAAIABAWQAAAEABABQABABAAAAQABAAAAABQABAAAAAAQABAAAAAAQADAAACgDQABgCAAgFIAAgUIAQAAIABAqIgQAAIAAgHQgDAEgDACQgDACgFAAQgHAAgEgEg");
	this.shape_426.setTransform(-104.875,28.6);

	this.shape_427 = new cjs.Shape();
	this.shape_427.graphics.f("#999999").s().p("AgQARQgHgGAAgLQgBgJAHgGQAGgGALAAQAMgBAHAHQAFAGABAJQAAAJgHAGQgGAHgMAAQgJAAgHgFgAAAgKQgDAAgCADQgCACAAAFQAAAGACACQADADACAAQAEAAACgDQACgDAAgFQAAgFgCgDQgDgCgDAAIAAAAg");
	this.shape_427.setTransform(-110.3518,28.6233);

	this.shape_428 = new cjs.Shape();
	this.shape_428.graphics.f("#999999").s().p("AgUAdIgBgLIAIABQABAAAAAAQABAAAAgBQABAAAAAAQABAAAAgBQACgBABgDIgSgqIARAAIAJAcIAHgcIAQAAIgQAsQgDAIgDADQgDAEgJAAIgLgBg");
	this.shape_428.setTransform(-115.525,29.525);

	this.shape_429 = new cjs.Shape();
	this.shape_429.graphics.f("#999999").s().p("AgNAUQgEgDgEgFQgDgFAAgHQAAgJAGgGQAGgGAMAAQAIgBAFADQAGADACAFQAEAFAAAIIAAABIggABQAAAEACACQACADADAAIAFgCIADgDIAQACQgEAGgFADQgFADgKAAQgIAAgFgCgAAAgMQgDAAgDADQgBACAAAEIAPAAQgBgFgCgCQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAAAAAIgBAAg");
	this.shape_429.setTransform(-123.4768,28.7708);

	this.shape_430 = new cjs.Shape();
	this.shape_430.graphics.f("#999999").s().p("AgQAbQgFgEAAgHIAAgCIAQACIACADIADABQAEAAACgCQABgCAAgFIAAgHIgFAFQgCADgFgBQgIAAgGgHQgDgFAAgIQgBgKAFgGQAFgEAIAAIAHABQADABADAEIAAgGIAPAAIABAnIAAACQAAAEgCADQgCAEgCADQgDACgFABIgKABQgMAAgEgDgAAAgSQgDAAgCACIgBAIQAAAFACACQACABACAAQADAAACgBQACgDAAgEQAAgFgCgDQgBgBAAAAQgBAAAAgBQgBAAgBAAQAAAAgBAAIAAAAg");
	this.shape_430.setTransform(-129.1023,29.65);

	this.shape_431 = new cjs.Shape();
	this.shape_431.graphics.f("#999999").s().p("AgVAWIgBgqIAPAAIAAAHQAEgEADgCQADgCAFAAQAHAAAEAEQADAEABAJIAAAaIgRAAIAAgXQAAgEgCgBQAAgBgBAAQAAgBAAAAQgBAAgBAAQAAAAgBAAQgCAAgCADIgBAHIAAAUg");
	this.shape_431.setTransform(-134.525,28.8);

	this.shape_432 = new cjs.Shape();
	this.shape_432.graphics.f("#999999").s().p("AgNAUQgEgDgEgFQgDgFAAgHQAAgJAGgGQAGgGAMAAQAIgBAFADQAGADACAFQAEAFAAAIIAAABIggABQAAAEACACQACADADAAIAFgCIADgDIAQACQgEAGgFADQgFADgKAAQgIAAgFgCgAAAgMQgDAAgDADQgBACAAAEIAPAAQgBgFgCgCQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAAAAAIgBAAg");
	this.shape_432.setTransform(-139.9768,28.9208);

	this.shape_433 = new cjs.Shape();
	this.shape_433.graphics.f("#999999").s().p("AgHAdIAAg6IAPAAIABA6g");
	this.shape_433.setTransform(-144.15,28.1);

	this.shape_434 = new cjs.Shape();
	this.shape_434.graphics.f("#999999").s().p("AgHAeIgBg7IAQAAIAAA7g");
	this.shape_434.setTransform(-146.9,28.15);

	this.shape_435 = new cjs.Shape();
	this.shape_435.graphics.f("#999999").s().p("AgUATQgEgEAAgFQAAgFADgDQADgCAIgCIALgDIAFgCIgBgEIgEgBQgEAAgCACIgCADIgQgBQABgEACgDQACgCADgCIAGgCIAJAAIAKAAQAEABAEACIADAFIABAHIAAASIABAEIABAFIgOAAIgCgDIAAgCQgDADgEABQgDACgGAAQgHAAgFgDgAAAADQgEABgCACIgBADIABADQAAAAABABQAAAAABAAQAAAAABAAQAAAAABAAQACAAACgCIADgDIABgFIAAgDIgGADg");
	this.shape_435.setTransform(-151,29.0125);

	this.shape_436 = new cjs.Shape();
	this.shape_436.graphics.f("#999999").s().p("AgVAeIgBg7IARAAIAAAWQADgDACgCQAEgBAEAAQAHAAAEADQADAFABAHIAAAbIgRAAIAAgYQAAgDgCgCQAAAAgBAAQAAAAgBAAQAAgBgBAAQAAAAgBAAQgCABgCABQgBACAAAGIAAAVg");
	this.shape_436.setTransform(-156.525,28.25);

	this.shape_437 = new cjs.Shape();
	this.shape_437.graphics.f("#999999").s().p("AgMAcQgHgDgEgHQgEgHgBgLQAAgOAIgHQAHgIANgBQAMAAAGAFQAHAEACAKIgQADIgBgEIgEgDQgCgBgDAAQgFAAgEAFQgCAEAAAHQAAAKADADQADAEAFAAQAFAAADgDQADgDABgGIAQAFQgCAHgDAEQgEAFgFACQgFACgIAAIgCABQgHAAgFgDg");
	this.shape_437.setTransform(-162.4,28.2536);

	this.shape_438 = new cjs.Shape();
	this.shape_438.graphics.f("#999999").s().p("AgIAIIAAgPIARAAIAAAPg");
	this.shape_438.setTransform(44.775,13.975);

	this.shape_439 = new cjs.Shape();
	this.shape_439.graphics.f("#999999").s().p("AgSAYQgEgHAAgKQgBgJAFgGQAFgFAIAAIAGABQADABADACIAAgUIAQAAIABA6IgQAAIAAgHQgDAEgDACQgCACgEAAQgJAAgFgGgAAAgBQgDAAgCABIgBAIQAAAFACADQACACACAAQADAAACgDQACgCAAgGQAAgFgCgCQgBAAAAAAQgBgBAAAAQgBAAgBAAQAAAAgBAAIAAAAg");
	this.shape_439.setTransform(40.5477,11.925);

	this.shape_440 = new cjs.Shape();
	this.shape_440.graphics.f("#999999").s().p("AgPAWIgBgqIAQAAIAAAHQAAgEADgCIAGgCQADAAAFACIgGAMIgEgBQgDAAgCADQgCAEAAAIIAAAPg");
	this.shape_440.setTransform(36.2,12.7);

	this.shape_441 = new cjs.Shape();
	this.shape_441.graphics.f("#999999").s().p("AgUATQgDgEAAgFQAAgFADgDQACgCAIgCIALgDIAFgCIgBgEIgFgBQgCAAgCACIgDADIgQgBQABgEACgDQACgCACgCIAHgCIAIAAIALAAQAEABADACIAEAFIACAHIAAASIAAAEIABAFIgPAAIgBgDIgBgCQgDADgDABQgDACgGAAQgIAAgEgDgAAAADQgEABgCACIgBADIABADQAAAAABABQAAAAABAAQAAAAABAAQAAAAABAAQACAAADgCIADgDIABgFIAAgDIgHADg");
	this.shape_441.setTransform(31.3,12.8125);

	this.shape_442 = new cjs.Shape();
	this.shape_442.graphics.f("#999999").s().p("AgUAdIgBgLIAIABQAAAAABAAQABAAAAgBQABAAAAAAQABAAAAgBQACgBABgDIgSgqIARAAIAJAcIAHgcIAQAAIgQAsQgDAIgDADQgDAEgJAAIgLgBg");
	this.shape_442.setTransform(26.125,13.725);

	this.shape_443 = new cjs.Shape();
	this.shape_443.graphics.f("#999999").s().p("AgNAUQgEgDgEgFQgDgFAAgHQAAgJAGgGQAGgGAMAAQAIgBAFADQAGADACAFQAEAFAAAIIAAABIggABQAAAEACACQACADADAAIAFgCIADgDIAQACQgEAGgFADQgFADgKAAQgIAAgFgCgAAAgMQgDAAgDADQgBACAAAEIAPAAQgBgFgCgCQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAAAAAIgBAAg");
	this.shape_443.setTransform(20.9232,12.9208);

	this.shape_444 = new cjs.Shape();
	this.shape_444.graphics.f("#999999").s().p("AgYgUIARAAIAIAaIAIgaIAQAAIgRApIgOABg");
	this.shape_444.setTransform(15.825,12.95);

	this.shape_445 = new cjs.Shape();
	this.shape_445.graphics.f("#999999").s().p("AgUATQgDgEAAgFQAAgFADgDQACgCAIgCIALgDIAFgCIgBgEIgFgBQgDAAgBACIgDADIgQgBQABgEACgDQABgCAEgCIAGgCIAIAAIALAAQAEABADACIAEAFIACAHIAAASIAAAEIABAFIgPAAIgBgDIgBgCQgDADgDABQgDACgGAAQgIAAgEgDgAAAADQgFABgBACIgBADIABADQAAAAABABQAAAAABAAQAAAAABAAQAAAAABAAQACAAADgCIADgDIAAgFIAAgDIgGADg");
	this.shape_445.setTransform(10.7,13.0125);

	this.shape_446 = new cjs.Shape();
	this.shape_446.graphics.f("#999999").s().p("AgQAWIAAgqIAQAAIAAAIQABgFACgCIAGgCQAEAAAEACIgGALIgEgBQgDABgCADQgCADAAAJIAAAPg");
	this.shape_446.setTransform(6.35,12.95);

	this.shape_447 = new cjs.Shape();
	this.shape_447.graphics.f("#999999").s().p("AgQAbQgFgEAAgHIAAgCIAQACIACADIADABQAEAAACgCQABgCAAgFIAAgHIgFAFQgCADgFgBQgIAAgGgHQgDgFAAgIQgBgKAFgGQAFgEAIAAIAHABQADABADAEIAAgGIAPAAIABAnIAAACQAAAEgCADQgCAEgCADQgDACgFABIgKABQgMAAgEgDgAAAgSQgDAAgCACIgBAIQAAAFACACQACABACAAQADAAACgBQACgDAAgEQAAgFgCgDQgBgBAAAAQgBAAAAgBQgBAAgBAAQAAAAgBAAIAAAAg");
	this.shape_447.setTransform(1.2477,13.9);

	this.shape_448 = new cjs.Shape();
	this.shape_448.graphics.f("#999999").s().p("AgNAUQgEgDgEgFQgDgFAAgHQAAgJAGgGQAGgGAMAAQAIgBAFADQAGADACAFQAEAFAAAIIAAABIggABQAAAEACACQACADADAAIAFgCIADgDIAQACQgEAGgFADQgFADgKAAQgIAAgFgCgAAAgMQgDAAgDADQgBACAAAEIAPAAQgBgFgCgCQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAAAAAIgBAAg");
	this.shape_448.setTransform(-6.8768,13.1708);

	this.shape_449 = new cjs.Shape();
	this.shape_449.graphics.f("#999999").s().p("AgVAeIgBg7IARAAIAAAWQADgDACgBQAEgCAEAAQAHAAAEADQADAEABAIIAAAbIgRAAIAAgXQAAgEgCgCQAAAAgBAAQAAAAAAAAQgBgBgBAAQAAAAgBAAQgCABgCABIgBAIIAAAVg");
	this.shape_449.setTransform(-12.425,12.4);

	this.shape_450 = new cjs.Shape();
	this.shape_450.graphics.f("#999999").s().p("AgDAdQgDgCgCgEIgBgKIAAgNIgGAAIAAgNIAGAAIAAgIIAPgIIAAAQIAJAAIAAAMIgJABIAAANIABAEQAAAAAAABQABAAAAAAQAAAAABAAQAAABABAAIAFgCIABALIgLACQgFAAgDgBg");
	this.shape_450.setTransform(-16.975,12.45);

	this.shape_451 = new cjs.Shape();
	this.shape_451.graphics.f("#999999").s().p("AgPATQgFgDgCgHIARgBIACAEQACABACAAQAEAAABgCQABAAAAAAQAAAAAAgBQABAAAAAAQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAAAAAgBQgBAAAAAAIgGgBIgMgDQgDgBgDgCQgCgDAAgEQAAgEACgDQADgDAEgCQAEgBAHAAQAHgBAEABQADABADADQACACACAEIgQACQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAAAgBAAIgDgBIgEABQgBABAAAAQAAAAAAAAQgBABAAAAQAAAAAAABQAAAAAAABQAAAAABAAQAAAAAAABQAAAAABAAIAGABQAJABAEABQAEACACACQACADAAAEQAAAEgCADQgDAEgFACQgEACgJAAQgKAAgFgDg");
	this.shape_451.setTransform(-24.125,13.3167);

	this.shape_452 = new cjs.Shape();
	this.shape_452.graphics.f("#999999").s().p("AgPATQgFgDgCgHIARgBIACAEQACABACAAQAEAAABgCQABAAAAAAQAAAAAAgBQABAAAAAAQAAgBAAAAQAAgBAAAAQgBgBAAAAQAAAAAAgBQgBAAAAAAIgGgBIgMgDQgDgBgDgCQgCgDAAgEQAAgEACgDQADgDAEgCQAEgBAHAAQAHgBAEABQADABADADQACACACAEIgQACQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAAAgBAAIgDgBIgEABQgBABAAAAQAAAAAAAAQgBABAAAAQAAAAAAABQAAAAAAABQAAAAABAAQAAAAAAABQAAAAABAAIAGABQAJABAEABQAEACACACQACADAAAEQAAAEgCADQgDAEgFACQgEACgJAAQgKAAgFgDg");
	this.shape_452.setTransform(-29.175,13.3667);

	this.shape_453 = new cjs.Shape();
	this.shape_453.graphics.f("#999999").s().p("AgQARQgHgGAAgLQgBgJAHgGQAGgGALAAQAMgBAHAHQAFAGABAJQAAAJgHAGQgGAHgMAAQgJAAgHgFgAAAgKQgDAAgCADQgCACAAAFQAAAGACACQADADACAAQAEAAACgDQACgDAAgFQAAgFgCgDQgDgCgDAAIAAAAg");
	this.shape_453.setTransform(-34.4018,13.4233);

	this.shape_454 = new cjs.Shape();
	this.shape_454.graphics.f("#999999").s().p("AgQAWIAAgpIAQAAIAAAGQABgFACgBIAGgCQAEAAAEACIgGAMIgEgBQgDAAgCACQgCAEAAAKIAAAOg");
	this.shape_454.setTransform(-38.75,13.35);

	this.shape_455 = new cjs.Shape();
	this.shape_455.graphics.f("#999999").s().p("AgJAVQgFgBgDgDQgDgDgCgEQgCgEAAgGQAAgGACgEIAEgGIAGgDQAFgCAHAAQAKgBAGAEQAFAEACAHIgPACIgDgEQgCgCgDAAQgDABgCADQgCADAAAEQAAAGACACQADADACAAQAEAAACgCIADgFIAQACQgCAFgDADQgDAEgEACQgFACgHAAIgCAAIgIgBg");
	this.shape_455.setTransform(-43.625,13.4531);

	this.shape_456 = new cjs.Shape();
	this.shape_456.graphics.f("#999999").s().p("AgUATQgDgEAAgFQAAgFACgDQADgCAIgCIALgDIAFgCIgBgEIgFgBQgDAAgBACIgDADIgQgBQABgEACgDQABgCAEgCIAGgCIAIAAIALAAQAEABADACIAEAFIACAHIAAASIAAAEIABAFIgPAAIgBgDIgBgCQgDADgDABQgDACgGAAQgIAAgEgDgAAAADQgFABgBACIgBADIABADQAAAAABABQAAAAABAAQAAAAABAAQAAAAABAAQACAAADgCIACgDIABgFIAAgDIgGADg");
	this.shape_456.setTransform(-49.15,13.5125);

	this.shape_457 = new cjs.Shape();
	this.shape_457.graphics.f("#999999").s().p("AgPATQgFgDgCgHIARgBIACAEQACABACAAQAEAAABgCQABAAAAAAQAAAAAAgBQABAAAAAAQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAAAAAgBQgBAAAAAAIgGgBIgMgDQgDgBgDgCQgCgDAAgEQAAgEACgDQADgDAEgCQAEgBAHAAQAHgBAEABQADABADADQACACACAEIgQACQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAAAgBAAIgDgBIgEABQgBABAAAAQAAAAAAAAQgBABAAAAQAAAAAAABQAAAAAAABQAAAAABAAQAAAAAAABQAAAAABAAIAGABQAJABAEABQAEACACACQACADAAAEQAAAEgCADQgDAEgFACQgEACgJAAQgKAAgFgDg");
	this.shape_457.setTransform(-57.225,13.6167);

	this.shape_458 = new cjs.Shape();
	this.shape_458.graphics.f("#999999").s().p("AgYAeIAAg7IAQAAIAAAeIAMgNIAUAAIgPANIAQAcIgSAAIgIgQIgGAFIAAAMg");
	this.shape_458.setTransform(-62.225,12.85);

	this.shape_459 = new cjs.Shape();
	this.shape_459.graphics.f("#999999").s().p("AgJAVQgFgBgDgDQgDgDgCgEQgCgEAAgGQAAgGACgEIAEgGIAGgDQAFgCAHAAQAKgBAGAEQAFAEACAHIgPACIgDgEQgCgCgDAAQgDABgCADQgCADAAAEQAAAGACACQADADACAAQAEAAACgCIADgFIAQACQgCAFgDADQgDAEgEACQgFACgHAAIgCAAIgIgBg");
	this.shape_459.setTransform(-67.775,13.7031);

	this.shape_460 = new cjs.Shape();
	this.shape_460.graphics.f("#999999").s().p("AgQARQgHgGAAgLQgBgJAHgGQAGgGALAAQAMgBAHAHQAFAGABAJQAAAJgHAGQgGAHgMAAQgJAAgHgFgAAAgKQgDAAgCADQgCACAAAFQAAAGACACQADADACAAQAEAAACgDQACgDAAgFQAAgFgCgDQgDgCgDAAIAAAAg");
	this.shape_460.setTransform(-73.3018,13.7733);

	this.shape_461 = new cjs.Shape();
	this.shape_461.graphics.f("#999999").s().p("AgHAeIgBg7IAQAAIABA7g");
	this.shape_461.setTransform(-77.45,12.95);

	this.shape_462 = new cjs.Shape();
	this.shape_462.graphics.f("#999999").s().p("AgBAcIgGgFIAAAGIgPAAIgBg6IARAAIAAAVIAFgEIAGgCQAIAAAFAGQAFAFABAKQAAAHgDAFQgCAFgEADQgEADgFAAIgHgCgAgEAAQgCADAAAFQAAAFACADQACACADAAQACAAACgDQACgCAAgGQAAgFgCgCQgCgCgDAAQgCABgCABg");
	this.shape_462.setTransform(-81.475,13.025);

	this.shape_463 = new cjs.Shape();
	this.shape_463.graphics.f("#999999").s().p("AgJAeIgBgeIgGAAIAAgLIAGAAIAAgDIABgFIACgGIAEgDIAHgBIANABIgCAKIgEAAIgEAAIgBACIgBAFIAIgBIAAAMIgIAAIABAeg");
	this.shape_463.setTransform(-89,13);

	this.shape_464 = new cjs.Shape();
	this.shape_464.graphics.f("#999999").s().p("AgQARQgHgGAAgLQgBgJAHgGQAGgGALAAQAMgBAHAHQAFAGABAJQAAAJgHAGQgGAHgMAAQgJAAgHgFgAAAgKQgDAAgCADQgCACAAAFQAAAGACACQADADACAAQAEAAACgDQACgDAAgFQAAgFgCgDQgDgCgDAAIAAAAg");
	this.shape_464.setTransform(-93.4518,13.9233);

	this.shape_465 = new cjs.Shape();
	this.shape_465.graphics.f("#999999").s().p("AgPATQgFgDgCgHIARgBIACAEQACABACAAQAEAAABgCQABAAAAAAQAAAAAAgBQABAAAAAAQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAAAAAgBQgBAAAAAAIgGgBIgMgDQgDgBgDgCQgCgDAAgEQAAgEACgDQADgDAEgCQAEgBAHAAQAHgBAEABQADABADADQACACACAEIgQACQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAAAgBAAIgDgBIgEABQgBABAAAAQAAAAAAAAQgBABAAAAQAAAAAAABQAAAAAAABQAAAAABAAQAAAAAAABQAAAAABAAIAGABQAJABAEABQAEACACACQACADAAAEQAAAEgCADQgDAEgFACQgEACgJAAQgKAAgFgDg");
	this.shape_465.setTransform(-101.525,14.0167);

	this.shape_466 = new cjs.Shape();
	this.shape_466.graphics.f("#999999").s().p("AgmgUIAQAAIAHAZIAIgaIAPAAIAJAaIAHgaIAPAAIgPAqIgPAAIgJgZIgHAZIgOAAg");
	this.shape_466.setTransform(-107.95,14.05);

	this.shape_467 = new cjs.Shape();
	this.shape_467.graphics.f("#999999").s().p("AgQARQgHgGAAgLQgBgJAHgGQAGgGALAAQAMgBAHAHQAFAGABAJQAAAJgHAGQgGAHgMAAQgJAAgHgFgAAAgKQgDAAgCADQgCACAAAFQAAAGACACQADADACAAQAEAAACgDQACgDAAgFQAAgFgCgDQgDgCgDAAIAAAAg");
	this.shape_467.setTransform(-114.4018,14.1233);

	this.shape_468 = new cjs.Shape();
	this.shape_468.graphics.f("#999999").s().p("AgQAWIAAgpIAQAAIAAAHQABgFACgCIAGgCQAEAAAEACIgGALIgEgBQgDABgCACQgCAFAAAIIAAAPg");
	this.shape_468.setTransform(-118.75,14.1);

	this.shape_469 = new cjs.Shape();
	this.shape_469.graphics.f("#999999").s().p("AgNAUQgEgDgEgFQgDgFAAgHQAAgJAGgGQAGgGAMAAQAIgBAFADQAGADACAFQAEAFAAAIIAAABIggABQAAAEACACQACADADAAIAFgCIADgDIAQACQgEAGgFADQgFADgKAAQgIAAgFgCgAAAgMQgDAAgDADQgBACAAAEIAPAAQgBgFgCgCQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAAAAAIgBAAg");
	this.shape_469.setTransform(-126.3768,14.2208);

	this.shape_470 = new cjs.Shape();
	this.shape_470.graphics.f("#999999").s().p("AgDAdQgDgCgCgEIgBgKIAAgOIgGAAIAAgMIAGAAIAAgIIAPgIIAAAQIAJAAIAAAMIgJAAIAAAOIABAEQAAAAAAABQABAAAAAAQAAAAABAAQAAABABAAIAFgCIABALIgLACQgFAAgDgBg");
	this.shape_470.setTransform(-130.975,13.5);

	this.shape_471 = new cjs.Shape();
	this.shape_471.graphics.f("#999999").s().p("AgNAUQgEgDgEgFQgDgFAAgHQAAgJAGgGQAGgGAMAAQAIgBAFADQAGADACAFQAEAFAAAIIAAABIggABQAAAEACACQACADADAAIAFgCIADgDIAQACQgEAGgFADQgFADgKAAQgIAAgFgCgAAAgMQgDAAgDADQgBACAAAEIAPAAQgBgFgCgCQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAAAAAIgBAAg");
	this.shape_471.setTransform(-135.5268,14.3208);

	this.shape_472 = new cjs.Shape();
	this.shape_472.graphics.f("#999999").s().p("AgHAdIgBg5IAQAAIAAA5g");
	this.shape_472.setTransform(-139.7,13.55);

	this.shape_473 = new cjs.Shape();
	this.shape_473.graphics.f("#999999").s().p("AgWAeIgBg6IAQAAIAAAGIAFgFQADgCAEAAQAJAAAFAGQAEAHABAJQAAAKgFAGQgFAFgIAAIgGgBQgDgBgDgCIAAAUgAgEgOQgCACAAAGQAAAFACABQACACADAAQADAAACgCQABgCAAgFQAAgGgCgCQgCgCgDAAQgCAAgCADg");
	this.shape_473.setTransform(-143.725,15.175);

	this.shape_474 = new cjs.Shape();
	this.shape_474.graphics.f("#999999").s().p("AgjAWIgBgqIAQAAIAAAHQADgEADgCQAEgCAEAAQAGAAACABIAFAGIAHgGQADgBAEAAQAIAAADAEQAEAEAAAJIAAAaIgQAAIAAgYQAAgBAAAAQAAgBAAAAQgBgBAAAAQAAgBgBAAQAAgBAAAAQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAgBABQgBAAAAAAQgBAAAAABQgBAAAAABQgBACgBAEIAAAWIgPAAIAAgXIAAgEIgCgCIgDgBQgBAAgBAAQgBAAAAAAQgBABAAAAQgBAAAAABQgCACABAEIAAAWg");
	this.shape_474.setTransform(-150.7,14.4);

	this.shape_475 = new cjs.Shape();
	this.shape_475.graphics.f("#999999").s().p("AgQARQgHgGAAgLQgBgJAHgGQAGgGALAAQAMgBAHAHQAFAGABAJQAAAJgHAGQgGAHgMAAQgJAAgHgFgAAAgKQgDAAgCADQgCACAAAFQAAAGACACQADADACAAQAEAAACgDQACgDAAgFQAAgFgCgDQgDgCgCAAIgBAAg");
	this.shape_475.setTransform(-157.5518,14.5233);

	this.shape_476 = new cjs.Shape();
	this.shape_476.graphics.f("#999999").s().p("AgJAVQgFgBgDgDQgDgDgCgEQgCgEAAgGQAAgGACgEIAEgGIAGgDQAFgCAHAAQAKgBAGAEQAFAEACAHIgPACIgDgEQgCgCgDAAQgDABgCADQgCADAAAEQAAAGACACQADADACAAQAEAAACgCIADgFIAQACQgCAFgDADQgDAEgEACQgFACgHAAIgCAAIgIgBg");
	this.shape_476.setTransform(-163.025,14.5531);

	this.shape_477 = new cjs.Shape();
	this.shape_477.graphics.f("#999999").s().p("AgQAbQgFgEAAgHIAAgCIAQACIACADIADABQAEAAACgDQABgBAAgFIAAgGIgFAEQgCACgFAAQgIABgGgIQgDgEAAgJQgBgKAFgGQAFgEAIAAIAHABQADABADAEIAAgGIAPAAIABAnIAAACQAAAEgCADQgCAFgCACQgDACgFABIgKABQgMAAgEgDgAAAgSQgDAAgCACIgBAIQAAAEACADQACABACAAQADAAACgBQACgDAAgFQAAgEgCgDQgBgBAAAAQgBAAAAgBQgBAAgBAAQAAAAgBAAIAAAAg");
	this.shape_477.setTransform(79.3477,-1.3);

	this.shape_478 = new cjs.Shape();
	this.shape_478.graphics.f("#999999").s().p("AgVAWIgBgpIAPAAIAAAGQAEgEADgCQADgCAFAAQAHAAAEAEQADAEABAIIAAAaIgRAAIAAgWQAAgEgCgCQAAAAgBAAQAAgBAAAAQgBAAgBAAQAAAAgBAAQgCAAgCACIgBAHIAAAVg");
	this.shape_478.setTransform(73.925,-2.2);

	this.shape_479 = new cjs.Shape();
	this.shape_479.graphics.f("#999999").s().p("AgHAeIgBgqIAQAAIABAqgAgIgSIAAgLIAQAAIAAALg");
	this.shape_479.setTransform(69.8,-2.9);

	this.shape_480 = new cjs.Shape();
	this.shape_480.graphics.f("#999999").s().p("AgDAcQgDgBgCgEIgBgKIAAgNIgGAAIAAgNIAGAAIAAgIIAPgIIAAAQIAJAAIAAAMIgJABIAAANIABAEQAAAAAAABQABAAAAAAQAAAAABAAQAAABABAAIAFgCIABALIgLACQgFAAgDgCg");
	this.shape_480.setTransform(66.625,-2.85);

	this.shape_481 = new cjs.Shape();
	this.shape_481.graphics.f("#999999").s().p("AgUATQgDgEAAgFQAAgFACgDQADgCAIgCIALgDIAFgCIgBgEIgEgBQgEAAgCACIgCADIgQgBQABgEACgDQACgCADgCIAGgCIAIAAIALAAQAFABADACIADAFIABAHIAAASIABAEIABAFIgOAAIgCgDIgBgCQgDADgDABQgDACgGAAQgHAAgFgDgAAAADQgFABgBACIgBADIABADQAAAAABABQAAAAABAAQAAAAABAAQAAAAABAAQACAAADgCIACgDIABgFIAAgDIgGADg");
	this.shape_481.setTransform(62.2,-2.0375);

	this.shape_482 = new cjs.Shape();
	this.shape_482.graphics.f("#999999").s().p("AgNAUQgEgDgEgFQgDgFAAgHQAAgJAGgGQAGgGAMAAQAIgBAFADQAGADACAFQAEAFAAAIIAAABIggABQAAAEACACQACADADAAIAFgCIADgDIAQACQgEAGgFADQgFADgKAAQgIAAgFgCgAAAgMQgDAAgDADQgBACAAAEIAPAAQgBgFgCgCQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAAAAAIgBAAg");
	this.shape_482.setTransform(56.7232,-1.9792);

	this.shape_483 = new cjs.Shape();
	this.shape_483.graphics.f("#999999").s().p("AgPAWIgBgqIAPAAIAAAIQACgGACgBIAGgCQADAAAFACIgFALIgFgBQgDABgCADQgCADAAAJIAAAPg");
	this.shape_483.setTransform(52.3,-2);

	this.shape_484 = new cjs.Shape();
	this.shape_484.graphics.f("#999999").s().p("AgJAVQgFgBgDgDQgDgDgCgEQgCgEAAgGQAAgGACgEIAEgGIAGgDQAFgCAHAAQAKgBAGAEQAFAEACAHIgPACIgDgEQgCgCgDAAQgDABgCADQgCADAAAEQAAAGACACQADADACAAQAEAAACgCIADgFIAQACQgCAFgDADQgDAEgEACQgFACgHAAIgCAAIgIgBg");
	this.shape_484.setTransform(47.425,-1.8969);

	this.shape_485 = new cjs.Shape();
	this.shape_485.graphics.f("#999999").s().p("AgUAdIgBgLIAIABQAAAAABAAQABAAAAgBQABAAAAAAQABAAAAgBQACgBABgDIgSgqIARAAIAJAcIAHgcIAQAAIgQAsQgDAIgDADQgDAEgJAAIgLgBg");
	this.shape_485.setTransform(39.325,-0.975);

	this.shape_486 = new cjs.Shape();
	this.shape_486.graphics.f("#999999").s().p("AgBAcIgGgFIAAAGIgPAAIgBg6IARAAIAAAVIAFgEIAGgCQAIAAAFAGQAFAFABAKQAAAHgDAFQgCAFgEADQgEADgFAAIgHgCgAgEAAQgCADAAAFQAAAFACADQACACADAAQACAAACgDQACgCAAgGQAAgFgCgCQgCgCgDAAQgCABgCABg");
	this.shape_486.setTransform(34.175,-2.575);

	this.shape_487 = new cjs.Shape();
	this.shape_487.graphics.f("#999999").s().p("AgPATQgFgDgCgHIARgBQAAABAAAAQABABAAAAQAAABABAAQAAABAAAAQACABACAAQAEAAABgCQABAAAAAAQAAAAAAgBQABAAAAAAQAAgBAAAAQAAgBAAAAQgBgBAAAAQAAAAAAgBQgBAAAAAAIgGgBIgMgDQgDgBgDgCQgCgDAAgEQAAgEACgDQADgDAEgCQAEgBAHAAQAHgBAEABQADABADADQACACACAEIgQACQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAAAgBAAIgDgBIgEABQgBABAAAAQAAAAAAAAQgBABAAAAQAAAAAAABQAAAAAAABQAAAAABAAQAAAAAAABQAAAAABAAIAGABQAJABAEABQAEACACACQACADAAAEQAAAEgCADQgDAEgFACQgEACgJAAQgKAAgFgDg");
	this.shape_487.setTransform(26.075,-1.6833);

	this.shape_488 = new cjs.Shape();
	this.shape_488.graphics.f("#999999").s().p("AgDAcQgDgBgCgDIgBgKIAAgPIgGAAIAAgLIAGAAIAAgIIAPgJIAAARIAJgBIAAAMIgJAAIAAAPIABADQAAAAAAABQABAAAAAAQAAAAABAAQAAAAABAAIAFgBIABALIgLACQgFAAgDgCg");
	this.shape_488.setTransform(21.775,-2.45);

	this.shape_489 = new cjs.Shape();
	this.shape_489.graphics.f("#999999").s().p("AgVAWIgBgqIAPAAIAAAHQAEgEADgCQADgCAFAAQAHAAAEAEQADAEABAIIAAAaIgRAAIAAgWQAAgEgCgBQAAgBgBAAQAAgBgBAAQAAAAgBAAQAAAAgBAAQgCAAgCADQgBABAAAGIAAAUg");
	this.shape_489.setTransform(17.175,-1.7);

	this.shape_490 = new cjs.Shape();
	this.shape_490.graphics.f("#999999").s().p("AgHAdIAAgpIAPAAIAAApgAgHgRIAAgLIAPAAIAAALg");
	this.shape_490.setTransform(13.05,-2.4);

	this.shape_491 = new cjs.Shape();
	this.shape_491.graphics.f("#999999").s().p("AgQARQgHgGAAgLQgBgJAHgGQAGgGALAAQAMgBAHAHQAFAGABAJQAAAJgHAGQgGAHgMAAQgJAAgHgFgAAAgKQgDAAgCADQgCACAAAFQAAAGACACQADADACAAQAEAAACgDQACgDAAgFQAAgFgCgDQgDgCgCAAIgBAAg");
	this.shape_491.setTransform(8.9482,-1.5267);

	this.shape_492 = new cjs.Shape();
	this.shape_492.graphics.f("#999999").s().p("AgWAeIgBg6IAQAAIAAAGIAFgFQADgCAEAAQAJAAAFAGQAEAHABAJQAAAKgFAGQgFAFgIAAIgGgBQgDgBgDgCIAAAUgAgEgOQgCACAAAGQAAAFACABQACACADAAQADAAACgCQABgCAAgFQAAgGgCgCQgCgCgDAAQgCAAgCADg");
	this.shape_492.setTransform(3.525,-0.725);

	this.shape_493 = new cjs.Shape();
	this.shape_493.graphics.f("#999999").s().p("AgVAWIgBgpIAPAAIAAAGQAEgEADgCQADgCAFAAQAHAAAEAEQADAEABAIIAAAaIgRAAIAAgWQAAgEgCgCQAAAAgBAAQAAgBAAAAQgBAAgBAAQAAAAgBAAQgCAAgCACIgBAHIAAAVg");
	this.shape_493.setTransform(-4.775,-1.5);

	this.shape_494 = new cjs.Shape();
	this.shape_494.graphics.f("#999999").s().p("AgQAWIAAgqIAQAAIAAAIQABgFACgCIAGgCQAEAAAEACIgGALIgEgBQgDABgCADQgCADAAAJIAAAPg");
	this.shape_494.setTransform(-9.4,-1.45);

	this.shape_495 = new cjs.Shape();
	this.shape_495.graphics.f("#999999").s().p("AgUATQgDgEAAgFQAAgFACgDQADgCAIgCIALgDIAFgCIgBgEIgEgBQgEAAgCACIgCADIgQgBQABgEACgDQACgCADgCIAGgCIAIAAIALAAQAFABADACIADAFIABAHIAAASIABAEIABAFIgOAAIgCgDIgBgCQgDADgDABQgDACgGAAQgHAAgFgDgAAAADQgFABgBACIgBADIABADQAAAAABABQAAAAABAAQAAAAABAAQAAAAABAAQACAAADgCIACgDIABgFIAAgDIgGADg");
	this.shape_495.setTransform(-14.3,-1.3375);

	this.shape_496 = new cjs.Shape();
	this.shape_496.graphics.f("#999999").s().p("AgNAUQgEgDgEgFQgDgFAAgHQAAgJAGgGQAGgGAMAAQAIgBAFADQAGADACAFQAEAFAAAIIAAABIggABQAAAEACACQACADADAAIAFgCIADgDIAQACQgEAGgFADQgFADgKAAQgIAAgFgCgAAAgMQgDAAgDADQgBACAAAEIAPAAQgBgFgCgCQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAAAAAIgBAAg");
	this.shape_496.setTransform(-19.7768,-1.2792);

	this.shape_497 = new cjs.Shape();
	this.shape_497.graphics.f("#999999").s().p("AgQARQgHgGAAgLQgBgJAHgGQAGgGALAAQAMgBAHAHQAFAGABAJQAAAJgHAGQgGAHgMAAQgJAAgHgFgAAAgKQgDAAgCADQgCACAAAFQAAAGACACQADADACAAQAEAAACgDQACgDAAgFQAAgFgCgDQgDgCgDAAIAAAAg");
	this.shape_497.setTransform(-28.0518,-1.1767);

	this.shape_498 = new cjs.Shape();
	this.shape_498.graphics.f("#999999").s().p("AgDAcQgDgBgCgEIgBgKIAAgNIgGAAIAAgNIAGAAIAAgIIAPgIIAAAQIAJAAIAAAMIgJABIAAANIABAEQAAAAAAABQABAAAAAAQAAAAABAAQAAABABAAIAFgCIABALIgLACQgFAAgDgCg");
	this.shape_498.setTransform(-32.625,-1.95);

	this.shape_499 = new cjs.Shape();
	this.shape_499.graphics.f("#999999").s().p("AgPATQgFgDgCgHIARgBIACAEQACABACAAQAEAAABgCQABAAAAAAQAAAAAAgBQABAAAAAAQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAAAAAgBQgBAAAAAAIgGgBIgMgDQgDgBgDgCQgCgDAAgEQAAgEACgDQADgDAEgCQAEgBAHAAQAHgBAEABQADABADADQACACACAEIgQACQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAAAgBAAIgDgBIgEABQgBABAAAAQAAAAAAAAQgBABAAAAQAAAAAAABQAAAAAAABQAAAAABAAQAAAAAAABQAAAAABAAIAGABQAJABAEABQAEACACACQACADAAAEQAAAEgCADQgDAEgFACQgEACgJAAQgKAAgFgDg");
	this.shape_499.setTransform(-39.775,-1.0833);

	this.shape_500 = new cjs.Shape();
	this.shape_500.graphics.f("#999999").s().p("AgHAeIAAgqIAPAAIAAAqgAgHgSIAAgLIAPAAIAAALg");
	this.shape_500.setTransform(-43.65,-1.9);

	this.shape_501 = new cjs.Shape();
	this.shape_501.graphics.f("#999999").s().p("AgNAUQgEgDgEgFQgDgFAAgHQAAgJAGgGQAGgGAMAAQAIgBAFADQAGADACAFQAEAFAAAIIAAABIggABQAAAEACACQACADADAAIAFgCIADgDIAQACQgEAGgFADQgFADgKAAQgIAAgFgCgAAAgMQgDAAgDADQgBACAAAEIAPAAQgBgFgCgCQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAAAAAIgBAAg");
	this.shape_501.setTransform(-50.4768,-0.9792);

	this.shape_502 = new cjs.Shape();
	this.shape_502.graphics.f("#999999").s().p("AgjAWIgBgqIAQAAIAAAHQADgFAEgBQADgCAFAAQAFAAACABIAEAGIAIgGQADgBAFAAQAGAAAEAEQAEAEAAAJIAAAaIgQAAIAAgYQAAgBAAAAQAAgBAAAAQgBgBAAAAQAAgBgBAAQAAgBAAAAQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAgBABQgBAAAAAAQgBAAAAABQgBAAAAABQgBACgBAEIAAAWIgPAAIAAgXIAAgEIgDgDIgCAAQgBAAgBAAQgBAAAAABQgBAAAAAAQgBAAAAABQgBADgBADIAAAWg");
	this.shape_502.setTransform(-57.35,-1);

	this.shape_503 = new cjs.Shape();
	this.shape_503.graphics.f("#999999").s().p("AgTATQgEgEgBgFQABgFADgDQACgCAIgCIALgDIAFgCIgBgEIgFgBQgCAAgCACIgDADIgQgBQABgEACgDQABgCADgCIAHgCIAIAAIALAAQAEABADACIAEAFIACAHIAAASIAAAEIACAFIgQAAIgBgDIgBgCQgCADgEABQgDACgGAAQgIAAgDgDgAAAADQgEABgCACIgBADIABADQAAAAABABQAAAAABAAQAAAAABAAQAAAAABAAQACAAACgCIAEgDIABgFIAAgDIgHADg");
	this.shape_503.setTransform(-64.2,-0.8875);

	this.shape_504 = new cjs.Shape();
	this.shape_504.graphics.f("#999999").s().p("AgQAaQgFgEAAgGIAAgCIAQACIACADIADABQAEAAACgDQABgBAAgFIAAgHIgFAFQgCACgFABQgIAAgGgIQgDgEAAgKQgBgJAFgFQAFgGAIAAIAHABQADACADAEIAAgGIAPAAIABAnIAAACQAAAEgCAEQgCADgCACQgDADgFABIgKACQgMAAgEgFgAAAgSQgDAAgCADIgBAHQAAAEACADQACABACAAQADAAACgCQACgCAAgFQAAgFgCgCQgBgBAAAAQgBAAAAgBQgBAAgBAAQAAAAgBAAIAAAAg");
	this.shape_504.setTransform(-69.8023,0);

	this.shape_505 = new cjs.Shape();
	this.shape_505.graphics.f("#999999").s().p("AgNAUQgEgDgEgFQgDgFAAgHQAAgJAGgGQAGgGAMAAQAIgBAFADQAGADACAFQAEAFAAAIIAAABIggABQAAAEACACQACADADAAIAFgCIADgDIAQACQgEAGgFADQgFADgKAAQgIAAgFgCgAAAgMQgDAAgDADQgBACAAAEIAPAAQgBgFgCgCQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAAAAAIgBAAg");
	this.shape_505.setTransform(-77.9268,-0.7292);

	this.shape_506 = new cjs.Shape();
	this.shape_506.graphics.f("#999999").s().p("AgVAdIgBg5IARAAIAAAVQADgDACgCQAEgCAEAAQAHAAAEAFQADADABAIIAAAbIgRAAIAAgYQAAgEgCgBQAAAAgBAAQAAAAgBAAQAAgBgBAAQAAAAgBABQgCAAgCABIgBAIIAAAUg");
	this.shape_506.setTransform(-83.475,-1.5);

	this.shape_507 = new cjs.Shape();
	this.shape_507.graphics.f("#999999").s().p("AgDAdQgDgCgCgEIgBgJIAAgPIgGAAIAAgLIAGAAIAAgJIAPgIIAAARIAJgBIAAAMIgJAAIAAAPIABADQAAAAAAABQABAAAAAAQAAAAABAAQAAAAABAAIAFgBIABALIgLACQgFAAgDgBg");
	this.shape_507.setTransform(-88.025,-1.45);

	this.shape_508 = new cjs.Shape();
	this.shape_508.graphics.f("#999999").s().p("AgJAeIgBgeIgGAAIAAgMIAGAAIAAgCIABgFIACgGIAEgDIAIgBIAMABIgCAKIgEAAIgEAAIgBACIgBAEIAJAAIAAAMIgJAAIABAeg");
	this.shape_508.setTransform(-94.6,-1.5);

	this.shape_509 = new cjs.Shape();
	this.shape_509.graphics.f("#999999").s().p("AgQARQgHgGAAgLQgBgJAHgGQAGgGALAAQAMgBAHAHQAFAGABAJQAAAJgHAGQgGAHgMAAQgJAAgHgFgAAAgKQgDAAgCADQgCACAAAFQAAAGACACQADADACAAQAEAAACgDQACgDAAgFQAAgFgCgDQgDgCgDAAIAAAAg");
	this.shape_509.setTransform(-99.0518,-0.5767);

	this.shape_510 = new cjs.Shape();
	this.shape_510.graphics.f("#999999").s().p("AgNAUQgEgDgEgFQgDgFAAgHQAAgJAGgGQAGgGAMAAQAIgBAFADQAGADACAFQAEAFAAAIIAAABIggABQAAAEACACQACADADAAIAFgCIADgDIAQACQgEAGgFADQgFADgKAAQgIAAgFgCgAAAgMQgDAAgDADQgBACAAAEIAPAAQgBgFgCgCQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAAAAAIgBAAg");
	this.shape_510.setTransform(-107.2268,-0.4792);

	this.shape_511 = new cjs.Shape();
	this.shape_511.graphics.f("#999999").s().p("AgYgUIARAAIAIAaIAIgbIAQAAIgRAqIgOABg");
	this.shape_511.setTransform(-112.375,-0.45);

	this.shape_512 = new cjs.Shape();
	this.shape_512.graphics.f("#999999").s().p("AgHAeIAAgqIAPAAIABAqgAgHgRIAAgMIAPAAIAAAMg");
	this.shape_512.setTransform(-116.25,-1.25);

	this.shape_513 = new cjs.Shape();
	this.shape_513.graphics.f("#999999").s().p("AgDAdQgDgCgCgEIgBgKIAAgNIgGAAIAAgNIAGAAIAAgIIAPgIIAAAQIAJAAIAAAMIgJABIAAANIABAEQAAAAAAABQABAAAAAAQAAAAABAAQAAABABAAIAFgCIABALIgLACQgFAAgDgBg");
	this.shape_513.setTransform(-119.425,-1.15);

	this.shape_514 = new cjs.Shape();
	this.shape_514.graphics.f("#999999").s().p("AgJAVQgFgBgDgDQgDgDgCgEQgCgEAAgGQAAgGACgEIAEgGIAGgDQAFgCAHAAQAKgBAGAEQAFAEACAHIgPACIgDgEQgCgCgDAAQgDABgCADQgCADAAAEQAAAGACACQADADACAAQAEAAACgCIADgFIAQACQgCAFgDADQgDAEgEACQgFACgHAAIgCAAIgIgBg");
	this.shape_514.setTransform(-123.975,-0.3469);

	this.shape_515 = new cjs.Shape();
	this.shape_515.graphics.f("#999999").s().p("AgNAUQgEgDgEgFQgDgFAAgHQAAgJAGgGQAGgGAMAAQAIgBAFADQAGADACAFQAEAFAAAIIAAABIggABQAAAEACACQACADADAAIAFgCIADgDIAQACQgEAGgFADQgFADgKAAQgIAAgFgCgAAAgMQgDAAgDADQgBACAAAEIAPAAQgBgFgCgCQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAAAAAIgBAAg");
	this.shape_515.setTransform(-129.4768,-0.2792);

	this.shape_516 = new cjs.Shape();
	this.shape_516.graphics.f("#999999").s().p("AgMAlIACgMIAEAAQAAAAAAAAQABAAAAAAQABAAAAgBQAAAAAAAAIABgGIAAgnIAQAAIAAAoIgBAMIgFAFQgDACgEAAIgMgBgAgDgaIAAgLIAQAAIAAALg");
	this.shape_516.setTransform(-134.1,-0.225);

	this.shape_517 = new cjs.Shape();
	this.shape_517.graphics.f("#999999").s().p("AgBAcIgGgFIAAAGIgPAAIgBg6IARAAIAAAVIAFgEIAGgCQAIAAAFAGQAFAFABAKQAAAHgDAFQgCAFgEADQgEADgFAAIgHgCgAgEAAQgCADAAAFQAAAFACADQACACADAAQACAAACgDQACgCAAgGQAAgFgCgCQgCgCgDAAQgCABgCABg");
	this.shape_517.setTransform(-137.675,-1.025);

	this.shape_518 = new cjs.Shape();
	this.shape_518.graphics.f("#999999").s().p("AgQARQgHgGAAgLQgBgJAHgGQAGgGALAAQAMgBAHAHQAFAGABAJQAAAJgHAGQgGAHgMAAQgJAAgHgFgAAAgKQgDAAgCADQgCACAAAFQAAAGACACQADADACAAQAEAAACgDQACgDAAgFQAAgFgCgDQgDgCgCAAIgBAAg");
	this.shape_518.setTransform(-143.2518,-0.1767);

	this.shape_519 = new cjs.Shape();
	this.shape_519.graphics.f("#999999").s().p("AgNAUQgEgDgEgFQgDgFAAgHQAAgJAGgGQAGgGAMAAQAIgBAFADQAGADACAFQAEAFAAAIIAAABIggABQAAAEACACQACADADAAIAFgCIADgDIAQACQgEAGgFADQgFADgKAAQgIAAgFgCgAAAgMQgDAAgDADQgBACAAAEIAPAAQgBgFgCgCQgBgBAAAAQgBAAAAAAQgBgBAAAAQgBAAAAAAIgBAAg");
	this.shape_519.setTransform(-151.4768,-0.0792);

	this.shape_520 = new cjs.Shape();
	this.shape_520.graphics.f("#999999").s().p("AgVAdIgBg5IARAAIAAAVQADgDACgBQAEgCAEgBQAHABAEAEQADADABAIIAAAbIgRAAIAAgXQAAgFgCgBQAAAAgBAAQAAAAAAAAQgBgBgBAAQAAAAgBABQgCgBgCACIgBAIIAAAUg");
	this.shape_520.setTransform(-157.025,-0.85);

	this.shape_521 = new cjs.Shape();
	this.shape_521.graphics.f("#999999").s().p("AgIgOIgTAAIAAgOIA3gBIAAAPIgTAAIAAArIgRABg");
	this.shape_521.setTransform(-162.975,-0.825);

	this.shape_522 = new cjs.Shape();
	this.shape_522.graphics.f("#404040").s().p("AgrBAIgBgBIgBgCIgDgBIgBgDIAAgCIgBgCIAAgDIAAgEIgBgDIAAgEIgBgCIAAgCIAAgMIAAgMQgBgCAAgDQABgDgBgDIABgFIAAgFIAAgDIAAgGIAAgHIAAgDQgBgFAAgFQABgGgBgFIAAgBIABgBIgBgCIAAgDIAAgBIAAgBIACgDIACgBIAEABIABgBIABAAIAEABIABgBIADABIAAAAIACgBIABABIACABIACgBIADAAIADAAIAEABIACAAIABAAIABAAIABABIAAAKIABAKIAAAIIgBAJIAAAHIAAAJIAAAHIAAAAIAAABIAAAHIAAAGIgBAMQAAAHABAGIAAADIgBACIAAAEIgBAFIABACIgBAEIgBADIgGAAIgFABIgCgBIgCAAQgBAAAAAAQAAAAgBAAQAAAAAAAAQAAAAAAAAIgCAAIgCABIgCAAIgCABIgCAAgAgbA6IgBABIAAABIAGAAIAFgBIAAgEIgDACQAAAAgBABQAAAAAAAAQgBAAAAAAQgBABAAAAIgBgBIgBgBIgCABgAgSg3IAAABIABAGIABAGIAAAGIAAABIgBADIAAABIABAHIAAAIIABAAIAAgBIAAgBIAAgDIAAgDIAAgCIAAgCIAAAAIAAgBIAAgJIAAgKIAAgDIAAgEIgBgCIgBAAIgBACgAAtA+IgBgBIgCAAIgFABIgHAAIgGAAQgBAAAAAAQgBAAAAAAQgBAAgBAAQAAAAgBAAIgEgBIgBgDQAAAAAAAAQAAAAAAAAQgBABAAAAQAAAAAAABIgBACIgEgBIAAgEIAAgCIgBgCIAAgFIAAgEIAAgBIgBgBIABgEIAEgBIAHgBIAHgBIAEAAIABAAIAEABIAEAAIABAAIABAAIAIAAIACAAIABABIABAHIACAIIgBAFQAAADgCACIgBAAIgCABgAAvAqIABABIAAAEIgBAFIABACIgBADIgBADIACACIADgBIAAgEIAAgEIAAgDIgBgGIAAgDIgDAAIAAABg");
	this.shape_522.setTransform(-101.325,-21.55);

	this.shape_523 = new cjs.Shape();
	this.shape_523.graphics.f("#404040").s().p("ABIBBIgCgBIAAACIgCAAIgBAAIgCAAIgDAAIgBAAIgCAAIgDAAIgCgCIgCABQAAAAgBAAQAAAAAAAAQgBAAAAAAQAAABAAAAIgBAAIgDgBIgDgCIABAAIgBgCIAAgCIAAgBIgBgCIgBgBQgBgBAAAAQAAAAAAAAQAAgBAAAAQAAAAABgBIgDgDIgCgDIgBgDIgBgDIAAgCQgBAAAAgBQgBAAAAAAQAAgBgBAAQAAgBAAgBIgCgEIAAgBIABgBIgBgBIgCAAIAAgCQAAAAAAgBQAAAAAAAAQAAgBAAAAQAAAAAAgBIAAgBIAAAAIgCgBIgBgDQgBAAAAgBQAAAAAAAAQAAAAgBAAQAAgBAAAAIgCgCIAAgCIgBgCIgBgDIgCgDIgBgDIgBgBIAAgCIAAgCIgCgCQAAgBgBAAQAAgBAAAAQAAgBAAAAQgBAAAAgBIgBgDIgBgCIgBgBIAAgCIAAgCIAAgBIgBAAIgBgCIAAgCIAAgCIgBAAIgDgEIAAgEQAAAAgBAAQAAAAAAgBQAAAAAAAAQAAgBAAAAIAAgDIgBgBIgCgDIAAgEIgBgDQAAAAgBgBQAAAAAAAAQAAAAAAgBQAAAAAAgBQAAAAAAAAQAAgBAAAAQgBAAAAgBQAAAAgBAAQABgDADgBIAEgEIAGgBIACABIADAAIAEAAIAFAAIAEAAIAGABIACACIABABIAAACIACADIACAEIADAEIACAFIAAABIABADIACAGIADAEIADAIIACAGIACADIAFAIIADAHIABADIAFAJIAEAMIACAKIABABIAAAAIABACIABACQAAABAAAAQAAABAAAAQgBABAAAAQAAAAAAABIgCACIABACIACAGIAAADIAAACIAAADIgDACIgDAAIgBgBgAgCg6IAAAAIAAADIABABIABgCIgBgCIgBgBIAAABgAgyBCIgCAAIgFgBIgGgBIgBAAIgCABIgCAAIgDAAIgDAAIgCAAIgDgBIAAgCIABgDIACgDIACgEIACgEIACgCIABgDIAEgBIABgEIABgBIABgDIAAgBIAAgBIABgCIADgDIACgDIABgEIACgEIABgDIABgCQADgEACgEIADgHIABgBIACgCIABgDIACgDQACgCACgFIAFgIQAAAAAAAAQAAAAABgBQAAAAAAgBQAAAAAAgBIACgEQAAgBAAAAQABAAAAAAQAAgBAAAAQABAAAAAAIACABIABACIABADIACAFIACADIABADIADAGIADAGQAAAAABAAQAAABAAAAQAAAAAAABQAAAAAAABIABACIAAAAIACACIABACIACAEIABAFIABAGIADAHIABAFIACADIAAACIACACIABAEIABADIAAACIgBACIgCAAIgBAAIgHAAIgHAAIgFgBIgBgCQAAAAAAAAQAAgBAAAAQAAAAgBAAQAAAAAAgBIgBABIAAAAIAAAAIgBACQAAAAAAAAQAAAAAAABQAAAAAAAAQAAAAAAABIgDgBIgEABIgEACIgBABIAAABIgBADIgCACIgBADIgBABIgCABIAAADIgCABIAAAAIgCABIgBABIgDAAIgCAAIgBAAIgBAAIgBAAIgCAAgAhDAwIgDADIgCAEQAAAAAAAAQAAABgBAAQAAABAAAAQAAABAAAAIgBABIAAACIAAACIADAAIAAgBIAAgCIgBgBQAAgCACgDIAEgGIACgFIAAAAIgDAFgAg7AyIgCACIAAADIABAAIACgBIABAAIAAgCIAAgCIAAgCIgCACgAgTAsIAAgBIAAABgAgEAoIgCABQAAABAAAAQAAAAAAABQABAAAAAAQAAAAABAAIACAAIACgBIAAgBIgBgCIgDABgAgUArIABAAIgBAAgAADApIADACIABgBIgBgCQAAAAAAgBQAAAAAAAAQgBAAAAAAQAAAAAAAAg");
	this.shape_523.setTransform(-115.95,-21.95);

	this.shape_524 = new cjs.Shape();
	this.shape_524.graphics.f("#404040").s().p("AgMBAIgBAAIgBAAIgBAAIgFgBIgDAAIgEgBIgDAAIgBgCIgDgBIgFgDIgGgCIgDgCIgCgDIAAgCIgEgBIgCgCIgCgCIgBgEQAAAAgBAAQAAgBAAAAQgBAAAAgBQAAAAgBAAIgBgCIADgBIgBgCIAAAAIgCABIgBAAIgBgBIgBgCIgBgBIAAgCIAAgBIAAgBIAAgBQgBAAAAAAQAAAAgBAAQAAgBAAAAQAAAAAAgBIgBgCIAAgDQAAgBgBAAQAAgBAAAAQAAgBAAgBQgBAAAAgBIAAgGIAAgFIAAgGIACgJIADgGQAAgEACgDIAGgIIAGgHQABAAAAAAQAAAAAAgBQABAAAAAAQAAAAABAAIACgDIADgCIAEgCIADgCIAEgBIAEgBIAFgCIACgBIAGgCIAGgBQAFABACABIABAEIACAFIgBAEIABADIgBABIgBACIgEADIgKAEIgJAEIgEACIgCACIgCADIgCAEIgDACIABABIgBABIAAABIgBAFIgBAEIAAABIABACIAAACIAAADIAAAEIAAACIABAFIACAEIACAEIADAEIABABIABACIADACIADAEIADABIACgBIACgBIACACIAAACIADADIAEACIABACIgBACIABAEIAAACIAAADIABAEIgCACQAAAAAAABQAAAAgBAAQAAAAAAAAQgBAAAAAAIgCAAgAg8ggIgEAGIAAACIACgDIADgDIABgCIABgBIAAgBIABAAIABgCIAAAAIgBAAIgEAEgAAbA7IgBgCIgCABIgBABIgCAAIgEgBIgBgBIgBgCIgBgDIABgEIABgDQAAAAgBAAQAAABgBAAQAAAAAAABQAAAAAAAAIgBAFIgBAAIgBgBIAAgCIAAgCIABgBIAEgDIAIgEIAFgDIADgEIAEgFIADgEIACgDIABgDIADgJIACgIIgCgGIgBgFIAAgDIgBgCIABAAIAAgBIAAgCIAAgBIgDgBIAAABIAAABIAAAAIgCgEIAAgCIgCgBIgBgCIgBAAQAAAAAAgBQgBAAAAAAQAAAAAAgBQAAAAgBgBIgBgDIgBABIgBAAIgFgBIgDgCQgBAAAAgBQAAAAAAAAQgBgBAAAAQgBAAAAAAQAAAAgBAAQAAAAgBAAQAAgBAAAAQgBAAAAgBIgCgBIgCAAQAAAAgBgBQAAAAAAAAQAAgBAAAAQAAgBAAAAIAAgEIAAgEIACgGIACgDIADgCIADAAIACAAIABAAIAAAAQAGAAAEADIAIAGIAIAFQABABAAAAQAAAAABABQAAAAABAAQAAAAAAABIAEACIABACIABABIABADIADACIACACIAAADIADADIAAACIAAABIAAAAIAAABQAAAAAAAAQABAAAAABQAAAAAAAAQAAABAAAAIABAEIAAADIAAABIABABIABAGIAAABIABABIAAABIgCABIAAADIABAAIABAAIAAAEIAAADIAAACIgBACIAAADIAAADQAAAAAAABQAAAAAAAAQAAAAAAABQgBAAAAAAIgBgCIgBABIAAACIAAABIgBAEQAAAAgBAAQAAABAAAAQAAABAAAAQgBABAAAAIAAACIgBABIAAACIgBACQAAAAAAAAQAAAAAAAAQABAAAAAAQAAABABAAIAAAAIgBABIgBACIgCAEIgDADIgBACIgCgBIgCgBQAAAAAAAAQgBAAAAAAQAAABgBAAQAAAAAAAAIgCACIgBAEIgCACIgEAAIgDACIgFADIgBgBIgBAAIgDABIgEABg");
	this.shape_524.setTransform(-132.4,-21.75);

	this.shape_525 = new cjs.Shape();
	this.shape_525.graphics.f("#404040").s().p("AgTBEIgDAAQgCgCgDgBIgEgBIgDgCIgCgBIgEgCIgFgEQgDgBgBgCIgFgEIgDgFIgDgFIgBgCIgBgCIAAgBIgEgGIAAgBIgBgBIAAgBIgBgDIAAgDIgCgCIAAgBIgBgHIgBgHIABgBIAAAAQAAgFABgEIACgIIACgIIAAgCIAAgBIAAAAIAEgJIAFgFIAEgEIADgDIACgDIAEgDIAFgDIADgCIADgBQAAAAAAAAQABgBAAAAQAAAAABAAQAAgBABAAIADgBIABAAIAFAAIAEAAIAEgBIADgBIABABIAAABIACAEIAAAEIAAACIgBAFIAAADIgDABIgDAAQgEAAgDABIgFAEQgCACgDABIgCACIgDACIgCAEIgBADIgDAGIgCAHIgBADIAAACIAAACIAAABIAAADIgBACIAAACIAAAEIABACIAAACIAAADIAAABIABABIAAADIACACIADAGIACAHIADACIADACIAIAFIAIAEQADADACAFIAAACIAAADIgBACIAAADIAAABIgBACIgCACIgFgBgAA8A/IgBgBIgCAAIgCAAIgBAAIgDAAIgBgBIgBgDIgBgBIABgBIAAgCIgDgBIgCAAIgCABIgCABQAAABgBAAQAAAAAAAAQAAAAgBAAQAAAAgBgBIgEADIgEABIgCgBIgCAAIgCAAIgEABIAAABIADABIACgBIAAABIABAAIgBABIgDAAQgBAAAAAAQgBAAAAAAQgBAAAAAAQgBAAAAgBIgCgDIAAgFIgBgDIgBgFQAAAAAAAAQABAAAAAAQAAAAAAgBQAAAAAAAAQgBAAAAgBQAAAAABAAQAAAAAAgBQAAAAABAAIAAgDIABgDIAJgEQAEgDACgEIADgKQAAAAAAAAQgBAAAAgBQAAAAAAAAQAAAAAAAAIgBgEIgDgBIgDgCIgDABIgFABIgDABIgFgBIgCABQAAAAgBAAQAAAAAAgBQgBAAAAgBQAAAAAAgBIgBgHIgBgEIACgFQAAgCAEAAIADAAIACABIABAAIABgBIACABIACAAIADAAIADgBIADAAIAEABIADABIAFAAIAEAAIADAAIACgBIAHABIAIgBIAEAAQACADAAADIAAAFIAAABIAAAFIAAADIAAAAQAAABAAABQAAAAAAABQAAAAAAABQAAAAAAABIAAAEIgBAEIAAADIAAADIAAAEIAAADIAAAEIAAADIABADIgBAGIAAAGIgBADIgBABIgDABIgEAAIgBAAIgBAAgAAhgoIgIgFIgGgEIgDgEIACgHQABgDADgBQAAgBAAgBQAAAAABgBQAAAAAAAAQABAAAAAAIAEgBIAFACIADABIAGADIAGAFQADABAAADIgBAFIgDADIgCAAIAAAAIAAgBIABAAIAAgBIgDABIAAABIAAACQAAABAAAAQAAABAAAAQAAAAgBABQAAAAgBABIgEABIgEgCg");
	this.shape_525.setTransform(-148.25,-22.8);

	this.shape_526 = new cjs.Shape();
	this.shape_526.graphics.f("#FFFFFF").s().p("AhChBICEgBIABCEIiEACg");
	this.shape_526.setTransform(48.8576,43.9734,0.2493,0.2493);

	this.shape_527 = new cjs.Shape();
	this.shape_527.graphics.f("#FFFFFF").s().p("AhChBICEgBIABCEIiEABg");
	this.shape_527.setTransform(45.7034,47.1089,0.2493,0.2493);

	this.shape_528 = new cjs.Shape();
	this.shape_528.graphics.f("#FFFFFF").s().p("AhChBICEgCIABCFIiEABg");
	this.shape_528.setTransform(51.9868,47.0403,0.2493,0.2493);

	this.shape_529 = new cjs.Shape();
	this.shape_529.graphics.f("#FFFFFF").s().p("AhDhBICFgBIABCEIiDABg");
	this.shape_529.setTransform(48.9261,50.288,0.2493,0.2493);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_529},{t:this.shape_528},{t:this.shape_527},{t:this.shape_526},{t:this.shape_525},{t:this.shape_524},{t:this.shape_523},{t:this.shape_522},{t:this.shape_521},{t:this.shape_520},{t:this.shape_519},{t:this.shape_518},{t:this.shape_517},{t:this.shape_516},{t:this.shape_515},{t:this.shape_514},{t:this.shape_513},{t:this.shape_512},{t:this.shape_511},{t:this.shape_510},{t:this.shape_509},{t:this.shape_508},{t:this.shape_507},{t:this.shape_506},{t:this.shape_505},{t:this.shape_504},{t:this.shape_503},{t:this.shape_502},{t:this.shape_501},{t:this.shape_500},{t:this.shape_499},{t:this.shape_498},{t:this.shape_497},{t:this.shape_496},{t:this.shape_495},{t:this.shape_494},{t:this.shape_493},{t:this.shape_492},{t:this.shape_491},{t:this.shape_490},{t:this.shape_489},{t:this.shape_488},{t:this.shape_487},{t:this.shape_486},{t:this.shape_485},{t:this.shape_484},{t:this.shape_483},{t:this.shape_482},{t:this.shape_481},{t:this.shape_480},{t:this.shape_479},{t:this.shape_478},{t:this.shape_477},{t:this.shape_476},{t:this.shape_475},{t:this.shape_474},{t:this.shape_473},{t:this.shape_472},{t:this.shape_471},{t:this.shape_470},{t:this.shape_469},{t:this.shape_468},{t:this.shape_467},{t:this.shape_466},{t:this.shape_465},{t:this.shape_464},{t:this.shape_463},{t:this.shape_462},{t:this.shape_461},{t:this.shape_460},{t:this.shape_459},{t:this.shape_458},{t:this.shape_457},{t:this.shape_456},{t:this.shape_455},{t:this.shape_454},{t:this.shape_453},{t:this.shape_452},{t:this.shape_451},{t:this.shape_450},{t:this.shape_449},{t:this.shape_448},{t:this.shape_447},{t:this.shape_446},{t:this.shape_445},{t:this.shape_444},{t:this.shape_443},{t:this.shape_442},{t:this.shape_441},{t:this.shape_440},{t:this.shape_439},{t:this.shape_438},{t:this.shape_437},{t:this.shape_436},{t:this.shape_435},{t:this.shape_434},{t:this.shape_433},{t:this.shape_432},{t:this.shape_431},{t:this.shape_430},{t:this.shape_429},{t:this.shape_428},{t:this.shape_427},{t:this.shape_426},{t:this.shape_425},{t:this.shape_424},{t:this.shape_423},{t:this.shape_422},{t:this.shape_421},{t:this.shape_420},{t:this.shape_419},{t:this.shape_418},{t:this.shape_417},{t:this.shape_416},{t:this.shape_415},{t:this.shape_414},{t:this.shape_413},{t:this.shape_412},{t:this.shape_411},{t:this.shape_410},{t:this.shape_409},{t:this.shape_408},{t:this.shape_407},{t:this.shape_406},{t:this.shape_405},{t:this.shape_404},{t:this.shape_403},{t:this.shape_402},{t:this.shape_401},{t:this.shape_400},{t:this.shape_399},{t:this.shape_398},{t:this.shape_397},{t:this.shape_396},{t:this.shape_395},{t:this.shape_394},{t:this.shape_393},{t:this.shape_392},{t:this.shape_391},{t:this.shape_390},{t:this.shape_389},{t:this.shape_388},{t:this.shape_387},{t:this.shape_386},{t:this.shape_385},{t:this.shape_384},{t:this.shape_383},{t:this.shape_382},{t:this.shape_381},{t:this.shape_380},{t:this.shape_379},{t:this.shape_378},{t:this.shape_377},{t:this.shape_376},{t:this.shape_375},{t:this.shape_374},{t:this.shape_373},{t:this.shape_372},{t:this.shape_371},{t:this.shape_370},{t:this.shape_369},{t:this.shape_368},{t:this.shape_367},{t:this.shape_366},{t:this.shape_365},{t:this.shape_364},{t:this.shape_363},{t:this.shape_362},{t:this.shape_361},{t:this.shape_360},{t:this.shape_359},{t:this.shape_358},{t:this.shape_357},{t:this.shape_356},{t:this.shape_355},{t:this.shape_354},{t:this.shape_353},{t:this.shape_352},{t:this.shape_351},{t:this.shape_350},{t:this.shape_349},{t:this.shape_348},{t:this.shape_347},{t:this.shape_346},{t:this.shape_345},{t:this.shape_344},{t:this.shape_343},{t:this.shape_342},{t:this.shape_341},{t:this.shape_340},{t:this.shape_339},{t:this.shape_338},{t:this.shape_337},{t:this.shape_336},{t:this.shape_335},{t:this.shape_334},{t:this.shape_333},{t:this.shape_332},{t:this.shape_331},{t:this.shape_330},{t:this.shape_329},{t:this.shape_328},{t:this.shape_327},{t:this.shape_326},{t:this.shape_325},{t:this.shape_324},{t:this.shape_323},{t:this.shape_322},{t:this.shape_321},{t:this.shape_320},{t:this.shape_319},{t:this.shape_318},{t:this.shape_317},{t:this.shape_316},{t:this.shape_315},{t:this.shape_314},{t:this.shape_313},{t:this.shape_312},{t:this.shape_311},{t:this.shape_310},{t:this.shape_309},{t:this.shape_308},{t:this.shape_307},{t:this.shape_306},{t:this.shape_305},{t:this.shape_304},{t:this.shape_303},{t:this.shape_302},{t:this.shape_301},{t:this.shape_300},{t:this.shape_299},{t:this.shape_298},{t:this.shape_297},{t:this.shape_296},{t:this.shape_295},{t:this.shape_294},{t:this.shape_293},{t:this.shape_292},{t:this.shape_291},{t:this.shape_290},{t:this.shape_289},{t:this.shape_288},{t:this.shape_287},{t:this.shape_286},{t:this.shape_285},{t:this.shape_284},{t:this.shape_283},{t:this.shape_282},{t:this.shape_281},{t:this.shape_280},{t:this.shape_279},{t:this.shape_278},{t:this.shape_277},{t:this.shape_276},{t:this.shape_275},{t:this.shape_274},{t:this.shape_273},{t:this.shape_272},{t:this.shape_271},{t:this.shape_270},{t:this.shape_269},{t:this.shape_268},{t:this.shape_267},{t:this.shape_266},{t:this.shape_265},{t:this.shape_264},{t:this.shape_263},{t:this.shape_262},{t:this.shape_261},{t:this.shape_260},{t:this.shape_259},{t:this.shape_258},{t:this.shape_257},{t:this.shape_256},{t:this.shape_255},{t:this.shape_254},{t:this.shape_253},{t:this.shape_252},{t:this.shape_251},{t:this.shape_250},{t:this.shape_249},{t:this.shape_248},{t:this.shape_247},{t:this.shape_246},{t:this.shape_245},{t:this.shape_244},{t:this.shape_243},{t:this.shape_242},{t:this.shape_241},{t:this.shape_240},{t:this.shape_239},{t:this.shape_238},{t:this.shape_237},{t:this.shape_236},{t:this.shape_235},{t:this.shape_234},{t:this.shape_233},{t:this.shape_232},{t:this.shape_231},{t:this.shape_230},{t:this.shape_229},{t:this.shape_228},{t:this.shape_227},{t:this.shape_226},{t:this.shape_225},{t:this.shape_224},{t:this.shape_223},{t:this.shape_222},{t:this.shape_221},{t:this.shape_220},{t:this.shape_219},{t:this.shape_218},{t:this.shape_217},{t:this.shape_216},{t:this.shape_215},{t:this.shape_214},{t:this.shape_213},{t:this.shape_212},{t:this.shape_211},{t:this.shape_210},{t:this.shape_209},{t:this.shape_208},{t:this.shape_207},{t:this.shape_206},{t:this.shape_205},{t:this.shape_204},{t:this.shape_203},{t:this.shape_202},{t:this.shape_201},{t:this.shape_200},{t:this.shape_199},{t:this.shape_198},{t:this.shape_197},{t:this.shape_196},{t:this.shape_195},{t:this.shape_194},{t:this.shape_193},{t:this.shape_192},{t:this.shape_191},{t:this.shape_190},{t:this.shape_189},{t:this.shape_188},{t:this.shape_187},{t:this.shape_186},{t:this.shape_185},{t:this.shape_184},{t:this.shape_183},{t:this.shape_182},{t:this.shape_181},{t:this.shape_180},{t:this.shape_179},{t:this.shape_178},{t:this.shape_177},{t:this.shape_176},{t:this.shape_175},{t:this.shape_174},{t:this.shape_173},{t:this.shape_172},{t:this.shape_171},{t:this.shape_170},{t:this.shape_169},{t:this.shape_168},{t:this.shape_167},{t:this.shape_166},{t:this.shape_165},{t:this.shape_164},{t:this.shape_163},{t:this.shape_162},{t:this.shape_161},{t:this.shape_160},{t:this.shape_159},{t:this.shape_158},{t:this.shape_157},{t:this.shape_156},{t:this.shape_155},{t:this.shape_154},{t:this.shape_153},{t:this.shape_152},{t:this.shape_151},{t:this.shape_150},{t:this.shape_149},{t:this.shape_148},{t:this.shape_147},{t:this.shape_146},{t:this.shape_145},{t:this.shape_144},{t:this.shape_143},{t:this.shape_142},{t:this.shape_141},{t:this.shape_140},{t:this.shape_139},{t:this.shape_138},{t:this.shape_137},{t:this.shape_136},{t:this.shape_135},{t:this.shape_134},{t:this.shape_133},{t:this.shape_132},{t:this.shape_131},{t:this.shape_130},{t:this.shape_129},{t:this.shape_128},{t:this.shape_127},{t:this.shape_126},{t:this.shape_125},{t:this.shape_124},{t:this.shape_123},{t:this.shape_122},{t:this.shape_121},{t:this.shape_120},{t:this.shape_119},{t:this.shape_118},{t:this.shape_117},{t:this.shape_116},{t:this.shape_115},{t:this.shape_114},{t:this.shape_113},{t:this.shape_112},{t:this.shape_111},{t:this.shape_110},{t:this.shape_109},{t:this.shape_108},{t:this.shape_107},{t:this.shape_106},{t:this.shape_105},{t:this.shape_104},{t:this.shape_103},{t:this.shape_102},{t:this.shape_101},{t:this.shape_100},{t:this.shape_99},{t:this.shape_98},{t:this.shape_97},{t:this.shape_96},{t:this.shape_95},{t:this.shape_94},{t:this.shape_93},{t:this.shape_92},{t:this.shape_91},{t:this.shape_90},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84},{t:this.shape_83},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80},{t:this.shape_79},{t:this.shape_78},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75},{t:this.shape_74},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71},{t:this.shape_70},{t:this.shape_69},{t:this.shape_68},{t:this.shape_67},{t:this.shape_66},{t:this.shape_65},{t:this.shape_64},{t:this.shape_63},{t:this.shape_62},{t:this.shape_61},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55},{t:this.shape_54},{t:this.shape_53},{t:this.shape_52},{t:this.shape_51},{t:this.shape_50},{t:this.shape_49},{t:this.shape_48},{t:this.shape_47},{t:this.shape_46},{t:this.shape_45},{t:this.shape_44},{t:this.shape_43},{t:this.shape_42},{t:this.shape_41},{t:this.shape_40},{t:this.shape_39},{t:this.shape_38},{t:this.shape_37},{t:this.shape_36},{t:this.shape_35},{t:this.shape_34},{t:this.shape_33},{t:this.shape_32},{t:this.shape_31},{t:this.shape_30},{t:this.shape_29},{t:this.shape_28},{t:this.shape_27},{t:this.shape_26},{t:this.shape_25},{t:this.shape_24},{t:this.shape_23},{t:this.shape_22},{t:this.shape_21},{t:this.shape_20},{t:this.shape_19},{t:this.shape_18},{t:this.shape_17},{t:this.shape_16},{t:this.shape_15},{t:this.shape_14},{t:this.shape_13},{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape},{t:this.backButton}]}).wait(1));

	// Layer_5
	this.instance = new lib.Symbol75();
	this.instance.setTransform(-64.2,-7.65,2.3849,2.3849);
	new cjs.ButtonHelper(this.instance, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// back
	this.instance_1 = new lib.Tween8("synched",0);
	this.instance_1.setTransform(-37.85,-106.25,17.4253,18.5534,0,0,0,0,-0.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-243.4,-277.7,411.20000000000005,341.2);


(lib.HiscoresTextClip = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(2));

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgJAKIAAgTIATAAIAAATg");
	this.shape.setTransform(59.75,49.85);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AgJAKIAAgTIATAAIAAATg");
	this.shape_1.setTransform(54.2,49.85);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgJAKIAAgTIATAAIAAATg");
	this.shape_2.setTransform(48.65,49.85);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("AgeBBQgSgJgIgRQgJgRAAgWQAAgTAJgSQAIgTARgIQAQgJAVAAQAPAAANAFQAMAFAHAJQAHAJAEAPIgRAEQgDgLgFgGQgFgHgJgDQgIgEgLAAQgMAAgKAEQgJAEgGAGQgGAHgDAIQgGANAAAPQAAASAHAOQAHAMAMAHQANAGANAAQAMAAAMgFQAMgEAGgGIAAgaIgqAAIAAgQIA8AAIAAA0QgOAKgOAHQgPAFgQAAQgUAAgRgJg");
	this.shape_3.setTransform(37.975,43.7);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AAlBHIhKhvIAABvIgSAAIAAiOIATAAIBKBwIAAhwIASAAIAACOg");
	this.shape_4.setTransform(23,43.7);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AgJBHIAAiOIASAAIAACOg");
	this.shape_5.setTransform(13.1,43.7);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("Ag6BHIAAiOIAxAAQAQAAAIACQANADAIAHQAMAKAFAPQAGAPAAATQAAAQgEAMQgEAMgGAJQgFAIgIAFQgHAFgKACQgKACgMAAgAgnA2IAeAAQANABAIgDQAIgDAFgFQAHgGAEgMQAEgLAAgPQAAgWgIgNQgHgMgLgEQgHgDgQAAIgeAAg");
	this.shape_6.setTransform(3.325,43.7);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFFF").s().p("AAtBHIgQgrIg7AAIgPArIgVAAIA3iOIAUAAIA6COgAgJgcIgQAoIAwAAIgPgmIgJgdQgDANgFAOg");
	this.shape_7.setTransform(-10.85,43.7);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FFFFFF").s().p("AgjBAQgQgKgIgRQgJgRAAgSQABgjATgUQATgUAdAAQAUAAAQAKQAQAJAJARQAHAQABAVQAAAWgJARQgJARgQAJQgQAJgTAAQgTAAgQgKgAghgrQgPANAAAgQAAAaAOAPQAOAOAUAAQAWAAAOgOQANgPAAgcQAAgRgGgMQgGgNgLgIQgMgHgOAAQgTAAgOAOg");
	this.shape_8.setTransform(-25.25,43.7);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#FFFFFF").s().p("AgsBHIAAiOIATAAIAAB9IBGAAIAAARg");
	this.shape_9.setTransform(-38.225,43.7);

	this.Next = new lib.Next5Clip();
	this.Next.setTransform(180,430.5);

	this.Last = new lib.Last5Clip();
	this.Last.setTransform(-190,430.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).to({state:[{t:this.Last},{t:this.Next}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-232.1,30.8,454.29999999999995,414.09999999999997);


(lib.highscoreMenu = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// pageNum
	this.page_10 = new lib.PageNumber();
	this.page_10.setTransform(153.3,-156.6,0.424,0.424,0,0,0,0.1,0.1);

	this.page_9 = new lib.PageNumber();
	this.page_9.setTransform(121,-156.6,0.424,0.424,0,0,0,0.1,0.1);

	this.page_8 = new lib.PageNumber();
	this.page_8.setTransform(88.7,-156.6,0.424,0.424,0,0,0,0.1,0.1);

	this.page_7 = new lib.PageNumber();
	this.page_7.setTransform(56.4,-156.6,0.424,0.424,0,0,0,0.1,0.1);

	this.page_6 = new lib.PageNumber();
	this.page_6.setTransform(24.1,-156.6,0.424,0.424,0,0,0,0.2,0.1);

	this.page_5 = new lib.PageNumber();
	this.page_5.setTransform(-7.15,-156.6,0.424,0.424,0,0,0,0.1,0.1);

	this.page_4 = new lib.PageNumber();
	this.page_4.setTransform(-39.45,-156.6,0.424,0.424,0,0,0,0.1,0.1);

	this.page_3 = new lib.PageNumber();
	this.page_3.setTransform(-71.75,-156.6,0.424,0.424,0,0,0,0.1,0.1);

	this.page_2 = new lib.PageNumber();
	this.page_2.setTransform(-104.05,-156.6,0.424,0.424,0,0,0,0.2,0.1);

	this.page_1 = new lib.PageNumber();
	this.page_1.setTransform(-136.35,-156.6,0.424,0.424,0,0,0,0.2,0.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.page_1},{t:this.page_2},{t:this.page_3},{t:this.page_4},{t:this.page_5},{t:this.page_6},{t:this.page_7},{t:this.page_8},{t:this.page_9},{t:this.page_10}]}).wait(1));

	// scrollBtns
	this.scroll_right = new lib.ScrollBtn();
	this.scroll_right.setTransform(195.95,-164.9,1.6129,1.6113,0,0,180,4.8,8.2);

	this.scroll_left = new lib.ScrollBtn();
	this.scroll_left.setTransform(-177.05,-156.85,1.6129,1.6113,0,0,0,7.8,13.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.scroll_left},{t:this.scroll_right}]}).wait(1));

	// numbers
	this.number_10 = new cjs.Text("100.", "24px 'flyerfont'", "#FF0000");
	this.number_10.name = "number_10";
	this.number_10.lineHeight = 27;
	this.number_10.lineWidth = 43;
	this.number_10.parent = this;
	this.number_10.setTransform(-201.35,126.5);

	this.number_9 = new cjs.Text("100.", "24px 'flyerfont'", "#FF0000");
	this.number_9.name = "number_9";
	this.number_9.lineHeight = 27;
	this.number_9.lineWidth = 43;
	this.number_9.parent = this;
	this.number_9.setTransform(-201.35,97.8);

	this.number_8 = new cjs.Text("100.", "24px 'flyerfont'", "#FF0000");
	this.number_8.name = "number_8";
	this.number_8.lineHeight = 27;
	this.number_8.lineWidth = 43;
	this.number_8.parent = this;
	this.number_8.setTransform(-201.35,69.3);

	this.number_7 = new cjs.Text("100.", "24px 'flyerfont'", "#FF0000");
	this.number_7.name = "number_7";
	this.number_7.lineHeight = 27;
	this.number_7.lineWidth = 43;
	this.number_7.parent = this;
	this.number_7.setTransform(-201.35,41.3);

	this.number_6 = new cjs.Text("100.", "24px 'flyerfont'", "#FF0000");
	this.number_6.name = "number_6";
	this.number_6.lineHeight = 27;
	this.number_6.lineWidth = 43;
	this.number_6.parent = this;
	this.number_6.setTransform(-201.35,11.25);

	this.number_5 = new cjs.Text("100.", "24px 'flyerfont'", "#FF0000");
	this.number_5.name = "number_5";
	this.number_5.lineHeight = 23;
	this.number_5.lineWidth = 43;
	this.number_5.parent = this;
	this.number_5.setTransform(-201.35,-18.05);

	this.number_4 = new cjs.Text("100.", "24px 'flyerfont'", "#FF0000");
	this.number_4.name = "number_4";
	this.number_4.lineHeight = 23;
	this.number_4.lineWidth = 43;
	this.number_4.parent = this;
	this.number_4.setTransform(-201.35,-46.55);

	this.number_3 = new cjs.Text("100.", "24px 'flyerfont'", "#FF0000");
	this.number_3.name = "number_3";
	this.number_3.lineHeight = 23;
	this.number_3.lineWidth = 43;
	this.number_3.parent = this;
	this.number_3.setTransform(-201.35,-75.95);

	this.number_2 = new cjs.Text("100.", "24px 'flyerfont'", "#FF0000");
	this.number_2.name = "number_2";
	this.number_2.lineHeight = 23;
	this.number_2.lineWidth = 43;
	this.number_2.parent = this;
	this.number_2.setTransform(-201.35,-105.4);

	this.number_1 = new cjs.Text("100.", "24px 'flyerfont'", "#FF0000");
	this.number_1.name = "number_1";
	this.number_1.lineHeight = 27;
	this.number_1.lineWidth = 43;
	this.number_1.parent = this;
	this.number_1.setTransform(-201.35,-133.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.number_1},{t:this.number_2},{t:this.number_3},{t:this.number_4},{t:this.number_5},{t:this.number_6},{t:this.number_7},{t:this.number_8},{t:this.number_9},{t:this.number_10}]}).wait(1));

	// Layer_2
	this.username_10 = new cjs.Text("...", "20px 'flyerfont'", "#FFFFFF");
	this.username_10.name = "username_10";
	this.username_10.lineHeight = 28;
	this.username_10.lineWidth = 195;
	this.username_10.parent = this;
	this.username_10.setTransform(-161.65,131.15);

	this.username_9 = new cjs.Text("...", "20px 'flyerfont'", "#FFFFFF");
	this.username_9.name = "username_9";
	this.username_9.lineHeight = 28;
	this.username_9.lineWidth = 195;
	this.username_9.parent = this;
	this.username_9.setTransform(-161.65,102.4);

	this.username_8 = new cjs.Text("...", "20px 'flyerfont'", "#FFFFFF");
	this.username_8.name = "username_8";
	this.username_8.lineHeight = 28;
	this.username_8.lineWidth = 195;
	this.username_8.parent = this;
	this.username_8.setTransform(-161.65,73.65);

	this.username_7 = new cjs.Text("...", "20px 'flyerfont'", "#FFFFFF");
	this.username_7.name = "username_7";
	this.username_7.lineHeight = 28;
	this.username_7.lineWidth = 195;
	this.username_7.parent = this;
	this.username_7.setTransform(-161.65,45.85);

	this.username_6 = new cjs.Text("...", "20px 'flyerfont'", "#FFFFFF");
	this.username_6.name = "username_6";
	this.username_6.lineHeight = 28;
	this.username_6.lineWidth = 195;
	this.username_6.parent = this;
	this.username_6.setTransform(-161.65,15.9);

	this.username_5 = new cjs.Text("...", "20px 'flyerfont'", "#FFFFFF");
	this.username_5.name = "username_5";
	this.username_5.lineHeight = 28;
	this.username_5.lineWidth = 195;
	this.username_5.parent = this;
	this.username_5.setTransform(-161.65,-13.2);

	this.username_4 = new cjs.Text("...", "20px 'flyerfont'", "#FFFFFF");
	this.username_4.name = "username_4";
	this.username_4.lineHeight = 28;
	this.username_4.lineWidth = 195;
	this.username_4.parent = this;
	this.username_4.setTransform(-161.65,-41.95);

	this.username_3 = new cjs.Text("...", "20px 'flyerfont'", "#FFFFFF");
	this.username_3.name = "username_3";
	this.username_3.lineHeight = 28;
	this.username_3.lineWidth = 195;
	this.username_3.parent = this;
	this.username_3.setTransform(-161.65,-71.3);

	this.username_2 = new cjs.Text("...", "20px 'flyerfont'", "#FFFFFF");
	this.username_2.name = "username_2";
	this.username_2.lineHeight = 28;
	this.username_2.lineWidth = 195;
	this.username_2.parent = this;
	this.username_2.setTransform(-161.65,-100.75);

	this.username_1 = new cjs.Text("...", "20px 'flyerfont'", "#FFFFFF");
	this.username_1.name = "username_1";
	this.username_1.lineHeight = 28;
	this.username_1.lineWidth = 195;
	this.username_1.parent = this;
	this.username_1.setTransform(-161.65,-129.5);

	this.score_10 = new cjs.Text("0", "20px 'flyerfont'", "#FFFFFF");
	this.score_10.name = "score_10";
	this.score_10.textAlign = "right";
	this.score_10.lineHeight = 28;
	this.score_10.lineWidth = 148;
	this.score_10.parent = this;
	this.score_10.setTransform(186.35,131.15);

	this.score_9 = new cjs.Text("0", "20px 'flyerfont'", "#FFFFFF");
	this.score_9.name = "score_9";
	this.score_9.textAlign = "right";
	this.score_9.lineHeight = 28;
	this.score_9.lineWidth = 148;
	this.score_9.parent = this;
	this.score_9.setTransform(186.35,102.4);

	this.score_8 = new cjs.Text("0", "20px 'flyerfont'", "#FFFFFF");
	this.score_8.name = "score_8";
	this.score_8.textAlign = "right";
	this.score_8.lineHeight = 28;
	this.score_8.lineWidth = 148;
	this.score_8.parent = this;
	this.score_8.setTransform(186.35,73.4);

	this.score_7 = new cjs.Text("0", "20px 'flyerfont'", "#FFFFFF");
	this.score_7.name = "score_7";
	this.score_7.textAlign = "right";
	this.score_7.lineHeight = 28;
	this.score_7.lineWidth = 148;
	this.score_7.parent = this;
	this.score_7.setTransform(186.35,46.45);

	this.score_6 = new cjs.Text("0", "20px 'flyerfont'", "#FFFFFF");
	this.score_6.name = "score_6";
	this.score_6.textAlign = "right";
	this.score_6.lineHeight = 28;
	this.score_6.lineWidth = 148;
	this.score_6.parent = this;
	this.score_6.setTransform(186.35,15.9);

	this.score_5 = new cjs.Text("0", "20px 'flyerfont'", "#FFFFFF");
	this.score_5.name = "score_5";
	this.score_5.textAlign = "right";
	this.score_5.lineHeight = 28;
	this.score_5.lineWidth = 148;
	this.score_5.parent = this;
	this.score_5.setTransform(187.3,-12.6);

	this.score_4 = new cjs.Text("0", "20px 'flyerfont'", "#FFFFFF");
	this.score_4.name = "score_4";
	this.score_4.textAlign = "right";
	this.score_4.lineHeight = 28;
	this.score_4.lineWidth = 148;
	this.score_4.parent = this;
	this.score_4.setTransform(186.35,-40.95);

	this.score_3 = new cjs.Text("0", "20px 'flyerfont'", "#FFFFFF");
	this.score_3.name = "score_3";
	this.score_3.textAlign = "right";
	this.score_3.lineHeight = 28;
	this.score_3.lineWidth = 148;
	this.score_3.parent = this;
	this.score_3.setTransform(186.35,-70.3);

	this.score_2 = new cjs.Text("0", "20px 'flyerfont'", "#FFFFFF");
	this.score_2.name = "score_2";
	this.score_2.textAlign = "right";
	this.score_2.lineHeight = 28;
	this.score_2.lineWidth = 148;
	this.score_2.parent = this;
	this.score_2.setTransform(186.35,-100.75);

	this.score_1 = new cjs.Text("0", "20px 'flyerfont'", "#FFFFFF");
	this.score_1.name = "score_1";
	this.score_1.textAlign = "right";
	this.score_1.lineHeight = 24;
	this.score_1.lineWidth = 148;
	this.score_1.parent = this;
	this.score_1.setTransform(186.35,-128.55);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.score_1},{t:this.score_2},{t:this.score_3},{t:this.score_4},{t:this.score_5},{t:this.score_6},{t:this.score_7},{t:this.score_8},{t:this.score_9},{t:this.score_10},{t:this.username_1},{t:this.username_2},{t:this.username_3},{t:this.username_4},{t:this.username_5},{t:this.username_6},{t:this.username_7},{t:this.username_8},{t:this.username_9},{t:this.username_10}]}).wait(1));

	// Layer_1
	this.backBtn = new lib.BackButton();
	this.backBtn.setTransform(0.05,184.5,1,1,0,0,0,97,16.7);
	new cjs.ButtonHelper(this.backBtn, 0, 1, 1);

	this.loadingTxt = new lib.HiscoresTextClip();
	this.loadingTxt.setTransform(24.9,-242.1);

	this.Poster = new lib.Empty();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.Poster},{t:this.loadingTxt},{t:this.backBtn}]}).wait(1));

	// Layer_3
	this.instance = new lib.Symbol4();
	this.instance.setTransform(-3.2,27.2,1,1,0,0,0,173.5,146.5);
	this.instance.alpha = 0.3984;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// dim
	this.instance_1 = new lib.Path_2();
	this.instance_1.setTransform(1.05,-0.1,0.4765,0.6675,0,0,0,392.9,220.2);
	this.instance_1.alpha = 0.6016;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Layer_4
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("AEMBlQgbgBgpgRQg2gWgNgEQghgJhDgBQi2gBiwAMQgdACgOgEQgLgEgIgHQgJgIgBgLQgBgHAEgSQAKgjAIgTQANgdASgSQANAqAnAaQAnAbAsgFQAYgDAdgMIAzgYQBkgsBtAMIBGAIQAoADAcgKICcArQAHA1gpAsQgmApgzAAIgGAAg");
	this.shape.setTransform(28.7303,-25.3126,0.3671,0.3671);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#777777").s().p("AARgiIgDAGQgHAXgGAHIgPAeIgCADg");
	this.shape_1.setTransform(17.9283,-27.8687,0.3671,0.3671);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#777777").s().p("AAeg+QgQBUgsApg");
	this.shape_2.setTransform(17.9467,-27.8687,0.3671,0.3671);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#777777").s().p("AgMAdQAGg/AYgoQgMAagHAwQgJA3gHAUQAFgaAAgUg");
	this.shape_3.setTransform(28.8022,-58.5724,0.3671,0.3671);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#777777").s().p("AgBACIAAgJQACACABAFIgBAIg");
	this.shape_4.setTransform(41.9885,-25.7214,0.3671,0.3671);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#777777").s().p("AgFAFQAFgHACgOIAGgFQAFgEABABIgFAYQgEALgSAOQABgMAHgIg");
	this.shape_5.setTransform(21.2685,-27.0281,0.3671,0.3671);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#777777").s().p("AgBABQAGgPAAgIIAAATQgBASgFAIQgGgHAGgPg");
	this.shape_6.setTransform(23.0028,-25.437,0.3671,0.3671);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#777777").s().p("AgBACIAAgEIAEAAIAAAEg");
	this.shape_7.setTransform(42.6308,-27.5475,0.3671,0.3671);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#777777").s().p("AgBAAIAIgUIgLApQgFgBAIgUg");
	this.shape_8.setTransform(22.0863,-29.1258,0.3671,0.3671);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#777777").s().p("AgBgDIADACIAAAFg");
	this.shape_9.setTransform(43.1355,-29.6305,0.3671,0.3671);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#777777").s().p("AAJgRIgLAdIgGAGg");
	this.shape_10.setTransform(24.4251,-30.438,0.3671,0.3671);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#777777").s().p("AATgjIglBHQAJgmAcghg");
	this.shape_11.setTransform(23.4249,-32.3192,0.3671,0.3671);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#777777").s().p("AgBgEIADAEIAAAFg");
	this.shape_12.setTransform(43.576,-32.053,0.3671,0.3671);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#777777").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_13.setTransform(44.0164,-32.6036,0.3671,0.3671);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#777777").s().p("AADgFIAAAGQAAAEgDABQgHgEAKgHg");
	this.shape_14.setTransform(44.0479,-33.1542,0.3671,0.3671);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#777777").s().p("AAKgXIgIAYQgEAOgHAJQgBgBAUgug");
	this.shape_15.setTransform(21.4053,-34.2737,0.3671,0.3671);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("#777777").s().p("AgDAAQACgEALgMQAAAIgIAJQgIALgBAFQgEgHAIgKg");
	this.shape_16.setTransform(22.3859,-37.3019,0.3671,0.3671);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("#777777").s().p("AgBAAQAEgJAHgDIgIAPQgEAJgHABIAIgNg");
	this.shape_17.setTransform(21.5162,-40.8255,0.3671,0.3671);

	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f("#777777").s().p("AHtCIQgSgJhGgJQg5gHgYgeQg9gGh4AMQh8ANg7gEQgzALhlgJQhkgKgyALQgyADh2gGQh1gGg5ADIAIguQAGgbAIgQQA9gFCtALQCOAJBVgWQBdgODFAZQC7AYBkgWQAigRAsgtQA0g2AWgQIBBgJQAogFAbAAQAAAAAAAAQAAAAAAABQABAAAAAAQABAAABAAQAAABABAAQAAAAAAABQAAAAAAABQAAABAAABQgHAPgSAGQgXAHgHAHQAMACAVgCQAXgCAKABQAOAFgEAIQgEAGgHADQgNAFhFgEQg0gDgPAkQAOAFAdAAQAgAAALADQAFAIgIAIQgHAHgKAAIg/gBQgqAAgHAcQgBAEACADIAFAFIA3ACQgJAIgUADIggAEQACgEgHgHQgFgCgEADQgEADgBAEQgGANAEAPQADAOAJAKQAIANAQADQAPAEAOgIIAOgKQAJgEAIACQANAFgPAPQgTAVgcAAIgMgBg");
	this.shape_18.setTransform(70.2493,-37.8532,0.3671,0.3671);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f("#777777").s().p("AAFgSIAAAFIADAAIgPAgg");
	this.shape_19.setTransform(23.636,-42.6608,0.3671,0.3671);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f("#777777").s().p("AABgHIAFAAIAAAFIgLAKg");
	this.shape_20.setTransform(24.159,-43.8996,0.3671,0.3671);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f("#777777").s().p("AgBAMQgBgFACgLIAAgPIACATQACAMgCAIg");
	this.shape_21.setTransform(37.2512,-46.0147,0.3671,0.3671);

	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f("#777777").s().p("AAEgFQAMgcAGgWIgLAwQgKAhgWAeIAZg9g");
	this.shape_22.setTransform(27.4808,-43.9592,0.3671,0.3671);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f("#777777").s().p("AAAANIAAgFQgDgBABgJIABgRIADATQADAOgFAGg");
	this.shape_23.setTransform(38.9895,-47.5793,0.3671,0.3671);

	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f("#777777").s().p("AgCgPIAFAAIAAAfg");
	this.shape_24.setTransform(33.9776,-46.5423,0.3671,0.3671);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f("#777777").s().p("AgKAfQgBgVAHgSQAEgPALgVQgJASgEAYIgIAvg");
	this.shape_25.setTransform(34.4908,-49.6806,0.3671,0.3671);

	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f("#777777").s().p("AAAADIAAgFIABAAIAAAFg");
	this.shape_26.setTransform(26.4714,-49.7449,0.3671,0.3671);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f("#777777").s().p("AAeg+QgQBCgrA7g");
	this.shape_27.setTransform(24.3609,-48.8823,0.3671,0.3671);

	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f("#777777").s().p("AAHgeIgFAmIgIAXg");
	this.shape_28.setTransform(27.077,-51.7269,0.3671,0.3671);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f("#777777").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_29.setTransform(50.66,-53.0942,0.3671,0.3671);

	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.f("#777777").s().p("AgXA2QAFgrAIgVIApheQgWA7gLAmQgQA2gEArIgIAPQADgIAEgrg");
	this.shape_30.setTransform(31.7202,-49.3686,0.3671,0.3671);

	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.f("#777777").s().p("AgGADQACgQAGgHIAAABIABgCQADgJAAgEQADAFgDAIIgBACIgFARQgHAZADAMQgEgMACgUg");
	this.shape_31.setTransform(40.5968,-53.6448,0.3671,0.3671);

	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.f("#777777").s().p("AtKEKQgRgOgLgRQgNgVAAgUQgDgRANgPQAIgJARgOQBbgfChgNQDQgRA3gKQAwADBXgbQBYgcAyADQA9gGCQAAQCIABBIgKQBBgBAigDQA4gHAjgTQAmgbAhhRQAhhTAfgXQAMgKAZgKQAYgJAGABQAJADgBAHQgBAHgHAGIgbASQgYAOgJALQgXAbAIAhQgEADAAAHQAGAIAIgGIAkgtQAUgaAXgFIAcAAQAPAAAKgCQAegFAGAAQAUgBAQAHQAAASgYAHQgeAFgLAEQgDACgRgBQgKAAABAOIAOABIAfACIAJAAQAJACAAAFQAAAGgLAGQgLAGgKAAIgZgCIgJACQACAEANAFQALAEAAAKQgHADg5ADQgoACgDAhQgEAIgBAMQgCAMADACQATANAlAFQACABAEgCIAGAAQAJgHATgUQAGgEAGgDQAHgDABADQADAGgDAJIgHANQgFAJgMALIgSAPQgNAKgbgDQgdgEgNAFQgZAZgjAFQgfAEgfgLIAPgNQALgKACgIQgMAEgPAKQgQALgJADQhTADikAgQigAehUABQgVADiEAYQhdAQg/gCQgoAHh/ARQhmANg+AQQhGAIgjAIQg4AOglAdQgIgHgNAHQgNAGgHgKIgJAKQgBAAAAABQgBAAAAAAQgBABAAAAQgBAAAAAAQgDAAgEgDg");
	this.shape_32.setTransform(67.7055,-47.165,0.3671,0.3671);

	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.f("#777777").s().p("AiPhiQANglACgPIABAQQACAKAFAGIASgKQAKgHAEgJIAZgrQAHAOAAAfQgBAiAEANQAsgwAlgPIAFAJQADAFACAIIgEAEQADAIAIASQAGAPgGAMQgZgDgNAAQgVABgIAMQAIAEASAbQAOAUAUgIQACgJgKgHQgLgHgBgFIAwAAQgDAIAEALQADAKAHAHQANAFAKgSQAJgRAPAEIAHgLQADgHgCgHQgQgEgVgCIgogDQAHgHAdgPQAXgMAKgQQAJAIAHAdQAGAaAJgCQgNAlABAcQACAUALAbIACATQgBAOgNAFQgGADgLAFQgMAFgFADQgCAEgCAJQgCANADALQgGAFgUAFQgUAFgHAGQACAGAIAAQAIgBAAAGIisAUQhWhOArjQg");
	this.shape_33.setTransform(47.2128,-51.0571,0.3671,0.3671);

	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.f("#777777").s().p("AgCAEQAGgWAJgRIgLAkQgEAWgKANQABgJAJgXg");
	this.shape_34.setTransform(37.437,-57.6915,0.3671,0.3671);

	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.f("#777777").s().p("ACNBtQgBghgEgGQgKgPgGAYIgJAjQgJAdgGAAQgGgpgUgQIgGAFQgBABgBAGQgGATgIALIgCggQgDgYgIgEQgJgFgIAZIgIAYIgIgYQgFgUgMAGIgLAfQgIAWgEgDQgCgCgFgeQgFgagEAEQgEAAgIALQgJALgDABQACgCgBgfQgCgegCgBQgKAHg6AxQAGgLAIgWQAJgZABgKQgEgFgHAFIgwAgQgEgCALgZQANgZgCgFQgFgLgMAJQgNAJgFgIQgIAIgOADQgPADgIAIQACgEASgYQAPgUAAgKQgGgDgNACQgMABgJADQACgCAEgMIAJgXIgPgFQgJgCgRANQAPgfAZgUQAWgRAUgEQAAAGgNATQgKAQAFABIA1gYIgPAVQgKAOgCAIQACAAAVgMQAUgLALACIgTAZQgKAMACAPQAGADAIgDIAPgGIAlgOIgaAdQgNAPALAMQAfgHAFgPQABgFAHACQAHACAEgEIgKAhQgFATABACQAIABAOgKQAOgJADgIQgBAJACAPQACAWAFABQAGACATgtIAOAoQAGAOAFgBQAGgBAIgYQAKgdADgEQAMAOAJAXIALAhQAJgNAEgVQADgTAFgFIAHATQAHAUAJAFQANgGAEgKQACgFgBgPIAKAPQAMATAHANQAMgFgBgZQgBgSABABIAOAVQAKAQAGAEIAIgjQAEgGACABIADAIQACACABAOQABALAFACQAEgEAFgIQAFgJABgFIAGAAQAGABABACQAIANAFAZQAHAbgEAMQgEgCgGgUIgJgXQgFADgBAaQgBAbgDAEQgCgDgGgXQgFgSgFAFQgCACgEAcQgDAaAAAEQgIgygMgEQgBASgCALQgEAPgLAKIgFgYQgDgQgJABQgJABgEAXIgFAeQgGgGgBgfg");
	this.shape_35.setTransform(46.366,-68.0423,0.3671,0.3671);

	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.f("#000000").s().p("AgoBzIgBgtQgCg7ALgFQAEhMA3g0QAAAIgFASQgGASAAAFQAYg2AegsIADAEQgiCFhPCVIAAAgIggAYIAgg4g");
	this.shape_36.setTransform(17.0933,-29.1075,0.3671,0.3671);

	this.shape_37 = new cjs.Shape();
	this.shape_37.graphics.f("#000000").s().p("AABADQAVgpASgMQgEAmgaAqIgxAVQAXgLARglg");
	this.shape_37.setTransform(17.9008,-25.5884,0.3671,0.3671);

	this.shape_38 = new cjs.Shape();
	this.shape_38.graphics.f("#000000").s().p("AgUAOQADgCAOgRQAMgRgBgBQANAIAAAOQAAAHgFASg");
	this.shape_38.setTransform(20.2044,-24.8956,0.3671,0.3671);

	this.shape_39 = new cjs.Shape();
	this.shape_39.graphics.f("#000000").s().p("AyOIcIARhFQAKgpAUgUQAMgvAzhCQA8hOAOgeIgCgCQh4B5gaBgQgBgIACgcQADgagBgGQgIAGgHASQgGAQgIAFQgCglAbgpQAQgYAngyQCqi+AzjcQAIgJACgZQADgXAKgJQAciMA7hmQBJh7Bxg3QAhgHBBgQQA6gMAtAKQCUAQBdBAQBLAtAaBYQAUBEgFBrQgRBDgLAeQgSAxgYApQgOASgLAHQgCgHACgSQADgPgGgGQgaAngHAdQgHAiAQAlQAHASgBAJQgBASgXAJQgVAHgJAHQgFADAGAZQgBARgPAEQgMADACAHQBvgGAlgEQBUgKA2gXQBmgMC5gFQDFgFBagJIBhgMQA3gOAWgtQAKgTAYg4QAVgwAQgbQAvgrA0gIQANACAEACQAGADAEAJQAHAPgVATQgDADgQAJIgNAIQgRAKgHAKQgJALACARQAKgPANgOQAOgPAJgFQAGgDAdgBIAtgDIAWgDQANgDAJAAQAmAAADAJQACAKgFALIgKASQgCAGgNAFQgOAFgBAFQAJAEgBAJQgCAOgPAHIgXAMQAEAEAAAGQgCAHgFAEQgKAGgzgBQgngBgKAeIgCAKQgCAGABAEIARAGQASAGAIAAIAmgYQAegTAKAQQAHANgYAfQgXAdgXALQgIAFgagDQgagCgNAHQgaAdgpABIhKgIQgVgCgOABQgRAAgZAGQgUAAgWAEIgsALQkpA4lxAbQgaAKg2AGQg4AHgZAIQgdADgtAIIhJAMIgFAHQgFAEADAFICjAMQBmAIBGgBQBLgUBSgFQBXgEBKAOICrASQBgAHBLgHQAqgRAjgZQAUgTAjgkQAfggAYgRQASABA7gHQAvgGAdAJQAMAHgHAPQgDAIgGAGQAYADAEAVQADAPgUAKQgZAKgqgGQgogFgaAKQAFAEAtACQAfABgEAeQgPAWguAAQgygBgNAMQAGADAcgBQATgBACATQgGAPg3AIQgTADgCAGQgDAJAWATQAJABAZgOQAUgLAPAPQALAJgJAYQgXAaggALQgsgPgtgGIgTgDQgMgBgJABQgYgCgZgQQgGgDgWgSQg0gDhwALQh6AMgvAAQgWgChaAEQhIADgsgLQhTAGiFAAIjZAAIgLAUQgEAjgVBGQgTBDgBAlIrrAiQgUguAJhvg");
	this.shape_39.setTransform(57.937,-49.6035,0.3671,0.3671);

	this.shape_40 = new cjs.Shape();
	this.shape_40.graphics.f("#777777").s().p("AANgNQgNALgMAQQAEgPAVgMg");
	this.shape_40.setTransform(93.7792,-54.3513,0.3671,0.3671);

	this.shape_41 = new cjs.Shape();
	this.shape_41.graphics.f("#777777").s().p("AgnBlIAFgUIgFgVQADgJAAgPQAAgMACgEQABgHAGgCIACgBIAAgDQAFhCAsgwIgEALQgFASAAAGIAIACQATgoAXgmQgOAYgQAzQgTA9gLATIgsBeIgDAMIgWAkIAZgwg");
	this.shape_41.setTransform(16.5886,-29.0524,0.3671,0.3671);

	this.shape_42 = new cjs.Shape();
	this.shape_42.graphics.f("#777777").s().p("AyQKKQgEgbAAgRQAAggACgTQAIgXAGgdQAEghAEgPQAGgbAOgPIAFgQQgGAFgEgDQgDgBgGAJQgGAKgCACIgJgcIAAgFQAAgZAKgVQAHgOAUgZIBShqQAxhBAZgtQAPgaAdguQAZgqAPgwIAYhQQAFgKAdgqQAYglAFgPIAVhuQANg/ASgrQAvh0Byg4IAMgLIBBgTQAlgJAiABQAiAAAqAIQCVARBdBAQBOAuAaBcQATBDgGBsIgBAEQgQBBgMAfQgRAwgZApIgDAEQgCADgCAHQgCAIgFADIgQANIgCgPIgBgLIABgOIABgLIAAgCQgeAuAAAjQAAAXALAYIABADQAGANAAALQAAAWgbALIgMAFQgNAFgEADIgBAEQAAAHADANIAAABQgBAOgHAGQgEADgJABIgHADIAUgCQBZgDAvgGQBMgLAzgVQBEgIBWgFICWgFQCtgEBigJIAdgDQA5gFAYgJQApgPASglQAMgVASgsQAXg2AUghQAwgrA0gJIABAAIACAAQANADAFACQAHAFAFAJQABAFAAAEQAAAPgQAPQgDADgMAHQAKgCAfgBIAigCIAQgDQAVgEAGABQAqAAADAMQADAJgDAJQgBAEgGAJIgFAJQgDAIgRAHIgIAEQAGAFAAAHIAAADQgCAMgIAHQgFAEgMAFIgMAGIACAHIAAACQAAAJgIAGQgKAEgOABIgagBQgZgBgKACQgRAFgGAUIAAAAIgDAPIAAABQAdALAKAAQAEAAAQgMQAhgZAPADQAJABAEAJQAEAHgDAKQgFARgWAYQgVAWgRAKQgGADgKAAIgSgBIgUgBQgLABgIAEQgXAaghADQgUADgqgGIgagDQgVgCgNABQgRAAgZAFQgXAAgnALIgYAFQknA3lrAbQgcAKg+AIQgzAGgcAIQgjADg7ALIgzAJIgHAHIBrAJIBvAIQA/ADAyAAQBOgVBVgFQBVgDBIAOIBJAHQBcAKApACQBJAEA9gFQAogRAkgZIAhgiQAygyAcgUIABgBIABAAQATACAqgGQAegFAQABQAagBAWAHQAIAFABAHIAAAEQAAALgIALQAVAGAEATIAAAEQAAAQgUAKQgRAHgTABQgLAAgVgDQgggFgVAGIAWABQAfgCAKAKQAIAJgDATIAAABIgBABQgLAQgWAFQgMACgbAAQghgCgMAGIAPABQAPgBAGACQALAEACAQIAAACQgFAMgRAHQgKADgWACQgbAFgBAEIgBABQAAAGARAOQAIABAQgJQAOgIAIgBQANgCALAMQAOAJgKAcIgBABQgXAcgiALIgBAAIgBAAQgvgPgqgGIgJgCQgUgCgKABQgjgDgqghIgCgDQgigBgyACIhaAIQhrALgzAAQgbgDg7AEQgvACgYAAQgngCgggIQg8AFhQACIiOAAIiTAAIgLASQgDAlgTA+IgPA3QgHAdgBAYIryAIQgEgMgEgbgAvzDsQgdAcgMANQgVAYgOAWQgGALgGAQIgGAOIAKgNIAug3QAlgvARgdg");
	this.shape_42.setTransform(57.611,-50.1761,0.3671,0.3671);

	this.shape_43 = new cjs.Shape();
	this.shape_43.graphics.f("#777777").s().p("AgMANQAPgdAKgKQgCACgDALIgDAOQgFAPgHALg");
	this.shape_43.setTransform(18.6349,-26.0334,0.3671,0.3671);

	this.shape_44 = new cjs.Shape();
	this.shape_44.graphics.f("#898989").s().p("AxSIzQAKgVAUg8QANgtANgYQgOAZgXAzIgMAJQgDgZgJAPQgKAQgQA7IAAADIgBAJQgEAJAAAGIAAAOQAAADACAHQACAGgBAEIgDALQgPAtgQhrQgEgZABgNQAMggACgMQAMg6AbgbQAIgfAZglQAIgMAngyQAlguAQgeIgQAQQgyAxgUAaQgjAsgMArIgJgBIAAgHQAAgJADgJIAAgDIgEAJQgIATgJAGIgGAEIgBgNQAAgaAJgXQAIgUASgXIBQhmQAvg9AZgtQAhg7APgfQAZgyAOgtIAQg0QAFgJAHgkQAHgbAQgQQAdiQAshXQBCiBB0g5IAMgMIA/gJQAsgLAcgDQAngDAmAIQCUAPBfBBQBNAvAbBcQASBCgGBsIgBAFQgRBDgKAcQgRAwgZApIgEAEQgMAPgKAHIgFADIgBgGQgCgFAAgGQAAgHACgHIABgKIgBgCQgcArAAAlQAAAXALAaIgBABQAHAUAAAIQAAAKgDAGQgFAHgOAFIgSAGQgOAFgDADIABAAQAAAAAAAAQAAAAAAAAQABAAAAAAQAAABAAAAIgBAJQAAAHABAHIABAAIAAABQgCAOgHAGQgEADgIABIgHADIATgBQBdgFArgGQBMgJA0gWQBFgIBUgFICWgFQCugEBhgJIAdgDQA4gEAZgJQApgPATgmQANgXARgpQAWg3AUggQAwgsA0gJIABAAIADABQANACAEADQAHADAFAKQACAEAAAFQAAAPgRAPQgEAFgLAFQAKgCAfgBIAigCIAQgDQAVgDAHAAQApABADALQADAJgCAJQgCAFgGAJIgFAJQgDAIgQAHQgHACgCACQAGAGAAAGIAAADQgBALgJAHQgFAEgMAFIgMAGIADAHIAAACQgCAJgHAFQgJAGgPABIgZAAQgagCgKADQgRAFgGATIAAgBIgDAQIAAABQAbAKAMAAQACAAASgMQAQgMAJgEQAOgHAJACQAJABAFAIQAEAHgEAKQgFASgVAXQgVAXgSAJQgGADgKABIgSgBQgagDgNAGQgXAaghAEQgUACgqgFIgZgEQgVgCgOABQgRABgZAFQgUAAgpAJIgZAGQkrA4ltAbQgdAKg3AHQgzAGgbAJQgnADg3ALIg0AIIgDAEIgDAEIBqAIIBvAIQA/AEAygBQBPgVBUgEQBWgEBIAOIBJAIQBbAJAqADQBJAEA9gGQAogRAjgZIAighQAzg0AagTIABgBIABAAQATACArgGQAfgEAPAAQAagBAVAHQAIAFABAIIABADQAAAKgJAMQAWAGADAUIAAADQAAAQgUAKQgRAHgTABQgLAAgVgDQgggFgVAGQAEABASAAQAggBAJAKQAIAJgDASIAAABIAAABQgLAQgWAFQgMACgcAAQghgBgMAGIAPAAQAPgBAHACQALAFABAQIAAABIAAAAQgFANgRAGQgKADgWADQgbAEgBAEIAAABQAAAGAQAPQAIAAARgJQAOgIAHgBQANgCALAMQAOALgKAaIgBABQgXAcghALIgCAAIgBAAQgsgPgsgGIgKgBQgTgDgLACQgmgEgmgiIgDgBQgigCgxADIhbAIQhmAKg4AAQgagCg8ADQgvACgYAAQgngBgggIQhbAHi/gBIiQAJIgLARQgDAkgTBBQgFASgLAfQgJAbgBAWIsIAsQAZgtAuhhg");
	this.shape_44.setTransform(57.8017,-49.5258,0.3671,0.3671);

	this.shape_45 = new cjs.Shape();
	this.shape_45.graphics.f("#000000").s().p("AAAAHIAAgNIABAAIAAANg");
	this.shape_45.setTransform(27.958,-52.6537,0.3671,0.3671);

	this.shape_46 = new cjs.Shape();
	this.shape_46.graphics.f("#FFCCFF").s().p("AiKCJIAAkRIEVAAIAAERg");
	this.shape_46.setTransform(114.9182,6.9946,0.3671,0.3671);

	this.shape_47 = new cjs.Shape();
	this.shape_47.graphics.f("#FFFFFF").s().p("AixiwIFjABIAAFgg");
	this.shape_47.setTransform(114.9273,7.0772,0.3671,0.3671);

	this.shape_48 = new cjs.Shape();
	this.shape_48.graphics.f("#BE6C97").s().p("AiuixIFfFhIliABg");
	this.shape_48.setTransform(114.8356,7.0313,0.3671,0.3671);

	this.shape_49 = new cjs.Shape();
	this.shape_49.graphics.f("#2E0402").s().p("AjdDZIAAmxIG7AAIAAGxg");
	this.shape_49.setTransform(114.9182,7.0588,0.3671,0.3671);

	this.shape_50 = new cjs.Shape();
	this.shape_50.graphics.f("#FFCCFF").s().p("AiKCIIAAkPIEVAAIAAEPg");
	this.shape_50.setTransform(131.014,6.9946,0.3671,0.3671);

	this.shape_51 = new cjs.Shape();
	this.shape_51.graphics.f("#FFFFFF").s().p("AixiwIFiABIABFgg");
	this.shape_51.setTransform(131.0232,7.0772,0.3671,0.3671);

	this.shape_52 = new cjs.Shape();
	this.shape_52.graphics.f("#BE6C97").s().p("AiuixIFfFhIliACg");
	this.shape_52.setTransform(130.9314,7.0313,0.3671,0.3671);

	this.shape_53 = new cjs.Shape();
	this.shape_53.graphics.f("#2E0402").s().p("AjdDZIAAmxIG7AAIAAGxg");
	this.shape_53.setTransform(131.014,7.0588,0.3671,0.3671);

	this.shape_54 = new cjs.Shape();
	this.shape_54.graphics.f("#FFCCFF").s().p("AiKCJIAAkQIEVAAIAAEQg");
	this.shape_54.setTransform(114.8815,-8.7892,0.3671,0.3671);

	this.shape_55 = new cjs.Shape();
	this.shape_55.graphics.f("#FFFFFF").s().p("AixiwIFjABIAAFgg");
	this.shape_55.setTransform(114.8906,-8.7066,0.3671,0.3671);

	this.shape_56 = new cjs.Shape();
	this.shape_56.graphics.f("#BE6C97").s().p("AiuixIFgFiIljAAg");
	this.shape_56.setTransform(114.7989,-8.7525,0.3671,0.3671);

	this.shape_57 = new cjs.Shape();
	this.shape_57.graphics.f("#2E0402").s().p("AjdDZIAAmxIG7AAIAAGxg");
	this.shape_57.setTransform(114.8815,-8.725,0.3671,0.3671);

	this.shape_58 = new cjs.Shape();
	this.shape_58.graphics.f("#FFCCFF").s().p("AiKCIIAAkPIEVAAIAAEPg");
	this.shape_58.setTransform(130.9773,-8.7892,0.3671,0.3671);

	this.shape_59 = new cjs.Shape();
	this.shape_59.graphics.f("#FFFFFF").s().p("AixiwIFjABIAAFgg");
	this.shape_59.setTransform(130.9865,-8.7066,0.3671,0.3671);

	this.shape_60 = new cjs.Shape();
	this.shape_60.graphics.f("#BE6C97").s().p("AiuixIFgFhIljABg");
	this.shape_60.setTransform(130.8947,-8.7525,0.3671,0.3671);

	this.shape_61 = new cjs.Shape();
	this.shape_61.graphics.f("#2E0402").s().p("AjdDZIAAmxIG7AAIAAGxg");
	this.shape_61.setTransform(130.9773,-8.725,0.3671,0.3671);

	this.shape_62 = new cjs.Shape();
	this.shape_62.graphics.f("#999999").s().p("AicCaIAAkzIE5AAIAAEzg");
	this.shape_62.setTransform(-129.6942,63.073,0.3671,0.3671);

	this.shape_63 = new cjs.Shape();
	this.shape_63.graphics.f("#E0E0E0").s().p("AjIjHIGRABIAAGOg");
	this.shape_63.setTransform(-129.6759,63.1648,0.3671,0.3671);

	this.shape_64 = new cjs.Shape();
	this.shape_64.graphics.f("#666666").s().p("AjFjIIGOGQImRABg");
	this.shape_64.setTransform(-129.786,63.1097,0.3671,0.3671);

	this.shape_65 = new cjs.Shape();
	this.shape_65.graphics.f("#2E0402").s().p("Aj6D1IAAnpIH1AAIAAHpg");
	this.shape_65.setTransform(-129.6942,63.1464,0.3671,0.3671);

	this.shape_66 = new cjs.Shape();
	this.shape_66.graphics.f("#999999").s().p("AicCaIAAkzIE5AAIAAEzg");
	this.shape_66.setTransform(-111.497,63.073,0.3671,0.3671);

	this.shape_67 = new cjs.Shape();
	this.shape_67.graphics.f("#E0E0E0").s().p("AjIjHIGRABIAAGOg");
	this.shape_67.setTransform(-111.4878,63.1648,0.3671,0.3671);

	this.shape_68 = new cjs.Shape();
	this.shape_68.graphics.f("#666666").s().p("AjEjIIGNGQImRABg");
	this.shape_68.setTransform(-111.5887,63.1097,0.3671,0.3671);

	this.shape_69 = new cjs.Shape();
	this.shape_69.graphics.f("#2E0402").s().p("Aj6D1IAAnpIH1AAIAAHpg");
	this.shape_69.setTransform(-111.4878,63.1464,0.3671,0.3671);

	this.shape_70 = new cjs.Shape();
	this.shape_70.graphics.f("#999999").s().p("AicCaIAAkzIE5AAIAAEzg");
	this.shape_70.setTransform(-111.5337,45.2336,0.3671,0.3671);

	this.shape_71 = new cjs.Shape();
	this.shape_71.graphics.f("#E0E0E0").s().p("AjIjHIGRABIAAGOg");
	this.shape_71.setTransform(-111.5245,45.3254,0.3671,0.3671);

	this.shape_72 = new cjs.Shape();
	this.shape_72.graphics.f("#666666").s().p("AjEjIIGNGQImRABg");
	this.shape_72.setTransform(-111.6346,45.2703,0.3671,0.3671);

	this.shape_73 = new cjs.Shape();
	this.shape_73.graphics.f("#2E0402").s().p("Aj6D1IAAnpIH1AAIAAHpg");
	this.shape_73.setTransform(-111.5337,45.307,0.3671,0.3671);

	this.shape_74 = new cjs.Shape();
	this.shape_74.graphics.f("#999999").s().p("AicCaIAAkzIE5AAIAAEzg");
	this.shape_74.setTransform(-93.3364,45.2336,0.3671,0.3671);

	this.shape_75 = new cjs.Shape();
	this.shape_75.graphics.f("#E0E0E0").s().p("AjIjHIGRABIAAGOg");
	this.shape_75.setTransform(-93.3272,45.3254,0.3671,0.3671);

	this.shape_76 = new cjs.Shape();
	this.shape_76.graphics.f("#666666").s().p("AjFjIIGOGQImRABg");
	this.shape_76.setTransform(-93.4282,45.2703,0.3671,0.3671);

	this.shape_77 = new cjs.Shape();
	this.shape_77.graphics.f("#2E0402").s().p("Aj6D1IAAnpIH1AAIAAHpg");
	this.shape_77.setTransform(-93.3364,45.307,0.3671,0.3671);

	this.shape_78 = new cjs.Shape();
	this.shape_78.graphics.f("#999999").s().p("AicCaIAAkzIE5AAIAAEzg");
	this.shape_78.setTransform(-34.4775,-73.8791,0.3671,0.3671);

	this.shape_79 = new cjs.Shape();
	this.shape_79.graphics.f("#E0E0E0").s().p("AjIjHIGRABIAAGOg");
	this.shape_79.setTransform(-34.4683,-73.7873,0.3671,0.3671);

	this.shape_80 = new cjs.Shape();
	this.shape_80.graphics.f("#666666").s().p("AjFjIIGOGQImRABg");
	this.shape_80.setTransform(-34.5692,-73.8424,0.3671,0.3671);

	this.shape_81 = new cjs.Shape();
	this.shape_81.graphics.f("#2E0402").s().p("Aj6D1IAAnpIH1AAIAAHpg");
	this.shape_81.setTransform(-34.4775,-73.8149,0.3671,0.3671);

	this.shape_82 = new cjs.Shape();
	this.shape_82.graphics.f("#999999").s().p("AicCaIAAkzIE5AAIAAEzg");
	this.shape_82.setTransform(-16.2802,-73.8791,0.3671,0.3671);

	this.shape_83 = new cjs.Shape();
	this.shape_83.graphics.f("#E0E0E0").s().p("AjIjHIGRABIAAGOg");
	this.shape_83.setTransform(-16.271,-73.7873,0.3671,0.3671);

	this.shape_84 = new cjs.Shape();
	this.shape_84.graphics.f("#666666").s().p("AjFjIIGOGQImRABg");
	this.shape_84.setTransform(-16.3811,-73.8424,0.3671,0.3671);

	this.shape_85 = new cjs.Shape();
	this.shape_85.graphics.f("#2E0402").s().p("Aj6D1IAAnpIH1AAIAAHpg");
	this.shape_85.setTransform(-16.2894,-73.8149,0.3671,0.3671);

	this.shape_86 = new cjs.Shape();
	this.shape_86.graphics.f("#999999").s().p("AicCaIAAk0IE5AAIAAE0g");
	this.shape_86.setTransform(-16.3261,-91.7277,0.3671,0.3671);

	this.shape_87 = new cjs.Shape();
	this.shape_87.graphics.f("#E0E0E0").s().p("AjIjHIGRABIAAGOg");
	this.shape_87.setTransform(-16.3077,-91.6267,0.3671,0.3671);

	this.shape_88 = new cjs.Shape();
	this.shape_88.graphics.f("#666666").s().p("AjFjIIGOGPImRACg");
	this.shape_88.setTransform(-16.4178,-91.6818,0.3671,0.3671);

	this.shape_89 = new cjs.Shape();
	this.shape_89.graphics.f("#2E0402").s().p("Aj6D1IAAnpIH1AAIAAHpg");
	this.shape_89.setTransform(-16.3261,-91.6543,0.3671,0.3671);

	this.shape_90 = new cjs.Shape();
	this.shape_90.graphics.f("#999999").s().p("AicCbIAAk1IE5AAIAAE1g");
	this.shape_90.setTransform(1.8712,-91.7277,0.3671,0.3671);

	this.shape_91 = new cjs.Shape();
	this.shape_91.graphics.f("#E0E0E0").s().p("AjIjHIGRABIAAGOg");
	this.shape_91.setTransform(1.8804,-91.6267,0.3671,0.3671);

	this.shape_92 = new cjs.Shape();
	this.shape_92.graphics.f("#666666").s().p("AjEjIIGNGPImRACg");
	this.shape_92.setTransform(1.7702,-91.6818,0.3671,0.3671);

	this.shape_93 = new cjs.Shape();
	this.shape_93.graphics.f("#2E0402").s().p("Aj6D1IAAnpIH1AAIAAHpg");
	this.shape_93.setTransform(1.8804,-91.6543,0.3671,0.3671);

	this.shape_94 = new cjs.Shape();
	this.shape_94.graphics.f("#999999").s().p("AjFDDIAAmFIGLAAIAAGFg");
	this.shape_94.setTransform(33.2278,61.7424,0.3671,0.3671);

	this.shape_95 = new cjs.Shape();
	this.shape_95.graphics.f("#E0E0E0").s().p("Aj9j8IH7ABIAAH4g");
	this.shape_95.setTransform(33.2461,61.8709,0.3671,0.3671);

	this.shape_96 = new cjs.Shape();
	this.shape_96.graphics.f("#666666").s().p("Aj5j9IH2H6In6ABg");
	this.shape_96.setTransform(33.1085,61.7883,0.3671,0.3671);

	this.shape_97 = new cjs.Shape();
	this.shape_97.graphics.f("#2E0402").s().p("Ak8E2IAAprIJ5AAIAAJrg");
	this.shape_97.setTransform(33.2369,61.8433,0.3671,0.3671);

	this.shape_98 = new cjs.Shape();
	this.shape_98.graphics.f("#999999").s().p("AjFDDIAAmFIGLAAIAAGFg");
	this.shape_98.setTransform(56.2244,61.7424,0.3671,0.3671);

	this.shape_99 = new cjs.Shape();
	this.shape_99.graphics.f("#E0E0E0").s().p("Aj9j7IH7AAIAAH4g");
	this.shape_99.setTransform(56.2428,61.8709,0.3671,0.3671);

	this.shape_100 = new cjs.Shape();
	this.shape_100.graphics.f("#666666").s().p("Aj5j9IH3H6In7ABg");
	this.shape_100.setTransform(56.1143,61.7883,0.3671,0.3671);

	this.shape_101 = new cjs.Shape();
	this.shape_101.graphics.f("#2E0402").s().p("Ak8E2IAAprIJ5AAIAAJrg");
	this.shape_101.setTransform(56.2336,61.8433,0.3671,0.3671);

	this.shape_102 = new cjs.Shape();
	this.shape_102.graphics.f("#999999").s().p("AjGDDIAAmFIGMAAIAAGFg");
	this.shape_102.setTransform(56.1785,39.1862,0.3671,0.3671);

	this.shape_103 = new cjs.Shape();
	this.shape_103.graphics.f("#E0E0E0").s().p("Aj9j8IH7ABIAAH3g");
	this.shape_103.setTransform(56.1877,39.3147,0.3671,0.3671);

	this.shape_104 = new cjs.Shape();
	this.shape_104.graphics.f("#666666").s().p("Aj5j9IH3H6In7ABg");
	this.shape_104.setTransform(56.0592,39.2321,0.3671,0.3671);

	this.shape_105 = new cjs.Shape();
	this.shape_105.graphics.f("#2E0402").s().p("Ak8E2IAAprIJ5AAIAAJrg");
	this.shape_105.setTransform(56.1785,39.2872,0.3671,0.3671);

	this.shape_106 = new cjs.Shape();
	this.shape_106.graphics.f("#999999").s().p("AjFDDIAAmFIGLAAIAAGFg");
	this.shape_106.setTransform(79.1843,39.1862,0.3671,0.3671);

	this.shape_107 = new cjs.Shape();
	this.shape_107.graphics.f("#E0E0E0").s().p("Aj+j8IH8ABIAAH3g");
	this.shape_107.setTransform(79.1935,39.3147,0.3671,0.3671);

	this.shape_108 = new cjs.Shape();
	this.shape_108.graphics.f("#666666").s().p("Aj5j9IH3H6In7ABg");
	this.shape_108.setTransform(79.0559,39.2321,0.3671,0.3671);

	this.shape_109 = new cjs.Shape();
	this.shape_109.graphics.f("#2E0402").s().p("Ak8E2IAAprIJ5AAIAAJrg");
	this.shape_109.setTransform(79.1752,39.2872,0.3671,0.3671);

	this.shape_110 = new cjs.Shape();
	this.shape_110.graphics.f("#FFFFFF").s().p("AhrBqIAAjTIDWAAIAADTg");
	this.shape_110.setTransform(-119.1503,124.8868,0.3671,0.3671);

	this.shape_111 = new cjs.Shape();
	this.shape_111.graphics.f("#E0E0E0").s().p("AiJiIIETAAIAAERg");
	this.shape_111.setTransform(-119.1411,124.9602,0.3671,0.3671);

	this.shape_112 = new cjs.Shape();
	this.shape_112.graphics.f("#999999").s().p("AiGiIIEPERIkRABg");
	this.shape_112.setTransform(-119.2145,124.9143,0.3671,0.3671);

	this.shape_113 = new cjs.Shape();
	this.shape_113.graphics.f("#2E0402").s().p("AirCoIAAlPIFXAAIAAFPg");
	this.shape_113.setTransform(-119.1411,124.9419,0.3671,0.3671);

	this.shape_114 = new cjs.Shape();
	this.shape_114.graphics.f("#FFFFFF").s().p("AhrBqIAAjTIDWAAIAADTg");
	this.shape_114.setTransform(-106.6884,124.8868,0.3671,0.3671);

	this.shape_115 = new cjs.Shape();
	this.shape_115.graphics.f("#E0E0E0").s().p("AiJiIIETAAIAAERg");
	this.shape_115.setTransform(-106.6792,124.9602,0.3671,0.3671);

	this.shape_116 = new cjs.Shape();
	this.shape_116.graphics.f("#999999").s().p("AiGiIIEPERIkRAAg");
	this.shape_116.setTransform(-106.7526,124.9143,0.3671,0.3671);

	this.shape_117 = new cjs.Shape();
	this.shape_117.graphics.f("#2E0402").s().p("AirCoIAAlPIFXAAIAAFPg");
	this.shape_117.setTransform(-106.6792,124.9419,0.3671,0.3671);

	this.shape_118 = new cjs.Shape();
	this.shape_118.graphics.f("#FFFFFF").s().p("AhqBpIAAjSIDVAAIAADSg");
	this.shape_118.setTransform(-106.7159,112.6727,0.3671,0.3671);

	this.shape_119 = new cjs.Shape();
	this.shape_119.graphics.f("#E0E0E0").s().p("AiJiIIESABIABEQg");
	this.shape_119.setTransform(-106.7068,112.737,0.3671,0.3671);

	this.shape_120 = new cjs.Shape();
	this.shape_120.graphics.f("#999999").s().p("AiHiIIERERIkTAAg");
	this.shape_120.setTransform(-106.7802,112.7002,0.3671,0.3671);

	this.shape_121 = new cjs.Shape();
	this.shape_121.graphics.f("#2E0402").s().p("AirCoIAAlPIFXAAIAAFPg");
	this.shape_121.setTransform(-106.7159,112.7278,0.3671,0.3671);

	this.shape_122 = new cjs.Shape();
	this.shape_122.graphics.f("#FFFFFF").s().p("AhqBqIAAjTIDVAAIAADTg");
	this.shape_122.setTransform(-94.2541,112.6727,0.3671,0.3671);

	this.shape_123 = new cjs.Shape();
	this.shape_123.graphics.f("#E0E0E0").s().p("AiJiIIETABIAAEQg");
	this.shape_123.setTransform(-94.2541,112.737,0.3671,0.3671);

	this.shape_124 = new cjs.Shape();
	this.shape_124.graphics.f("#999999").s().p("AiHiIIERERIkTAAg");
	this.shape_124.setTransform(-94.3183,112.7002,0.3671,0.3671);

	this.shape_125 = new cjs.Shape();
	this.shape_125.graphics.f("#2E0402").s().p("AirCoIAAlPIFXAAIAAFPg");
	this.shape_125.setTransform(-94.2541,112.7278,0.3671,0.3671);

	this.shape_126 = new cjs.Shape();
	this.shape_126.graphics.f("#8B1A11").s().p("AiJCIIAAkPIETAAIAAEPg");
	this.shape_126.setTransform(23.8401,14.0422,0.3671,0.3671);

	this.shape_127 = new cjs.Shape();
	this.shape_127.graphics.f("#E83323").s().p("AiwivIFhABIAAFeg");
	this.shape_127.setTransform(23.8492,14.134,0.3671,0.3671);

	this.shape_128 = new cjs.Shape();
	this.shape_128.graphics.f("#5C0E08").s().p("AitivIFdFeIlfABg");
	this.shape_128.setTransform(23.7575,14.0789,0.3671,0.3671);

	this.shape_129 = new cjs.Shape();
	this.shape_129.graphics.f("#2E0402").s().p("AjcDXIAAmuIG4AAIAAGug");
	this.shape_129.setTransform(23.8401,14.1156,0.3671,0.3671);

	this.shape_130 = new cjs.Shape();
	this.shape_130.graphics.f("#8B1A11").s().p("AiJCHIAAkNIETAAIAAENg");
	this.shape_130.setTransform(39.8349,14.0422,0.3671,0.3671);

	this.shape_131 = new cjs.Shape();
	this.shape_131.graphics.f("#E83323").s().p("AiwivIFgABIABFdg");
	this.shape_131.setTransform(39.8441,14.134,0.3671,0.3671);

	this.shape_132 = new cjs.Shape();
	this.shape_132.graphics.f("#5C0E08").s().p("AitivIFdFfIlgAAg");
	this.shape_132.setTransform(39.7523,14.0789,0.3671,0.3671);

	this.shape_133 = new cjs.Shape();
	this.shape_133.graphics.f("#2E0402").s().p("AjbDYIAAmvIG3AAIAAGvg");
	this.shape_133.setTransform(39.8349,14.1156,0.3671,0.3671);

	this.shape_134 = new cjs.Shape();
	this.shape_134.graphics.f("#8B1A11").s().p("AiJCIIAAkOIETAAIAAEOg");
	this.shape_134.setTransform(55.8298,14.0422,0.3671,0.3671);

	this.shape_135 = new cjs.Shape();
	this.shape_135.graphics.f("#E83323").s().p("AiwivIFhABIAAFeg");
	this.shape_135.setTransform(55.839,14.134,0.3671,0.3671);

	this.shape_136 = new cjs.Shape();
	this.shape_136.graphics.f("#5C0E08").s().p("AitivIFdFeIlfABg");
	this.shape_136.setTransform(55.7472,14.0789,0.3671,0.3671);

	this.shape_137 = new cjs.Shape();
	this.shape_137.graphics.f("#2E0402").s().p("AjbDXIAAmuIG4AAIAAGug");
	this.shape_137.setTransform(55.8298,14.1156,0.3671,0.3671);

	this.shape_138 = new cjs.Shape();
	this.shape_138.graphics.f("#8B1A11").s().p("AiJCHIAAkNIETAAIAAENg");
	this.shape_138.setTransform(71.8247,14.0422,0.3671,0.3671);

	this.shape_139 = new cjs.Shape();
	this.shape_139.graphics.f("#E83323").s().p("AiwiuIFhAAIAAFeg");
	this.shape_139.setTransform(71.8339,14.134,0.3671,0.3671);

	this.shape_140 = new cjs.Shape();
	this.shape_140.graphics.f("#5C0E08").s().p("AitivIFeFeIlgABg");
	this.shape_140.setTransform(71.7421,14.0789,0.3671,0.3671);

	this.shape_141 = new cjs.Shape();
	this.shape_141.graphics.f("#2E0402").s().p("AjcDXIAAmuIG5AAIAAGug");
	this.shape_141.setTransform(71.8155,14.1156,0.3671,0.3671);

	this.shape_142 = new cjs.Shape();
	this.shape_142.graphics.f("#8B1A11").s().p("AiJCIIAAkPIETAAIAAEPg");
	this.shape_142.setTransform(45.7906,-92.8747,0.3671,0.3671);

	this.shape_143 = new cjs.Shape();
	this.shape_143.graphics.f("#E83323").s().p("AiwivIFgABIABFeg");
	this.shape_143.setTransform(45.8089,-92.8013,0.3671,0.3671);

	this.shape_144 = new cjs.Shape();
	this.shape_144.graphics.f("#5C0E08").s().p("AitivIFdFeIlgACg");
	this.shape_144.setTransform(45.7172,-92.8472,0.3671,0.3671);

	this.shape_145 = new cjs.Shape();
	this.shape_145.graphics.f("#2E0402").s().p("AjcDYIAAmvIG5AAIAAGvg");
	this.shape_145.setTransform(45.7997,-92.8105,0.3671,0.3671);

	this.shape_146 = new cjs.Shape();
	this.shape_146.graphics.f("#8B1A11").s().p("AiJCIIAAkPIETAAIAAEPg");
	this.shape_146.setTransform(61.7946,-92.8747,0.3671,0.3671);

	this.shape_147 = new cjs.Shape();
	this.shape_147.graphics.f("#E83323").s().p("AiwivIFgABIABFeg");
	this.shape_147.setTransform(61.813,-92.8013,0.3671,0.3671);

	this.shape_148 = new cjs.Shape();
	this.shape_148.graphics.f("#5C0E08").s().p("AitiwIFeFfIlgABg");
	this.shape_148.setTransform(61.7212,-92.8472,0.3671,0.3671);

	this.shape_149 = new cjs.Shape();
	this.shape_149.graphics.f("#2E0402").s().p("AjcDYIAAmuIG5AAIAAGug");
	this.shape_149.setTransform(61.8038,-92.8105,0.3671,0.3671);

	this.shape_150 = new cjs.Shape();
	this.shape_150.graphics.f("#8B1A11").s().p("AiJCIIAAkPIETAAIAAEPg");
	this.shape_150.setTransform(77.7987,-92.8747,0.3671,0.3671);

	this.shape_151 = new cjs.Shape();
	this.shape_151.graphics.f("#E83323").s().p("AiwivIFgABIABFeg");
	this.shape_151.setTransform(77.817,-92.8013,0.3671,0.3671);

	this.shape_152 = new cjs.Shape();
	this.shape_152.graphics.f("#5C0E08").s().p("AitiwIFeFfIlhABg");
	this.shape_152.setTransform(77.7253,-92.8472,0.3671,0.3671);

	this.shape_153 = new cjs.Shape();
	this.shape_153.graphics.f("#2E0402").s().p("AjcDXIAAmtIG5AAIAAGtg");
	this.shape_153.setTransform(77.8079,-92.8105,0.3671,0.3671);

	this.shape_154 = new cjs.Shape();
	this.shape_154.graphics.f("#8B1A11").s().p("AiJCIIAAkPIETAAIAAEPg");
	this.shape_154.setTransform(93.8027,-92.8747,0.3671,0.3671);

	this.shape_155 = new cjs.Shape();
	this.shape_155.graphics.f("#E83323").s().p("AiwivIFhABIAAFeg");
	this.shape_155.setTransform(93.8211,-92.8013,0.3671,0.3671);

	this.shape_156 = new cjs.Shape();
	this.shape_156.graphics.f("#5C0E08").s().p("AitiwIFeFgIlhABg");
	this.shape_156.setTransform(93.7293,-92.8472,0.3671,0.3671);

	this.shape_157 = new cjs.Shape();
	this.shape_157.graphics.f("#2E0402").s().p("AjcDXIAAmuIG5AAIAAGug");
	this.shape_157.setTransform(93.8119,-92.8105,0.3671,0.3671);

	this.shape_158 = new cjs.Shape();
	this.shape_158.graphics.f("#8B1A11").s().p("AjFDDIAAmFIGLAAIAAGFg");
	this.shape_158.setTransform(-60.6309,135.596,0.3671,0.3671);

	this.shape_159 = new cjs.Shape();
	this.shape_159.graphics.f("#E83323").s().p("Aj9j7IH7AAIAAH3g");
	this.shape_159.setTransform(-60.6309,135.7152,0.3671,0.3671);

	this.shape_160 = new cjs.Shape();
	this.shape_160.graphics.f("#5C0E08").s().p("Aj5j9IH3H5In7ACg");
	this.shape_160.setTransform(-60.7593,135.6418,0.3671,0.3671);

	this.shape_161 = new cjs.Shape();
	this.shape_161.graphics.f("#2E0402").s().p("Ak8E2IAAprIJ5AAIAAJrg");
	this.shape_161.setTransform(-60.6401,135.6877,0.3671,0.3671);

	this.shape_162 = new cjs.Shape();
	this.shape_162.graphics.f("#8B1A11").s().p("AjFDDIAAmFIGLAAIAAGFg");
	this.shape_162.setTransform(-37.6342,135.596,0.3671,0.3671);

	this.shape_163 = new cjs.Shape();
	this.shape_163.graphics.f("#E83323").s().p("Aj+j7IH8AAIAAH3g");
	this.shape_163.setTransform(-37.625,135.7152,0.3671,0.3671);

	this.shape_164 = new cjs.Shape();
	this.shape_164.graphics.f("#5C0E08").s().p("Aj5j9IH3H5In7ACg");
	this.shape_164.setTransform(-37.7627,135.6418,0.3671,0.3671);

	this.shape_165 = new cjs.Shape();
	this.shape_165.graphics.f("#2E0402").s().p("Ak8E2IAAprIJ5AAIAAJrg");
	this.shape_165.setTransform(-37.6434,135.6877,0.3671,0.3671);

	this.shape_166 = new cjs.Shape();
	this.shape_166.graphics.f("#8B1A11").s().p("AjFDDIAAmFIGLAAIAAGFg");
	this.shape_166.setTransform(-14.6376,135.596,0.3671,0.3671);

	this.shape_167 = new cjs.Shape();
	this.shape_167.graphics.f("#E83323").s().p("Aj9j7IH7AAIAAH3g");
	this.shape_167.setTransform(-14.6192,135.7152,0.3671,0.3671);

	this.shape_168 = new cjs.Shape();
	this.shape_168.graphics.f("#5C0E08").s().p("Aj5j9IH3H5In7ACg");
	this.shape_168.setTransform(-14.766,135.6418,0.3671,0.3671);

	this.shape_169 = new cjs.Shape();
	this.shape_169.graphics.f("#2E0402").s().p("Ak8E2IAAprIJ5AAIAAJrg");
	this.shape_169.setTransform(-14.6468,135.6877,0.3671,0.3671);

	this.shape_170 = new cjs.Shape();
	this.shape_170.graphics.f("#8B1A11").s().p("AjFDDIAAmFIGLAAIAAGFg");
	this.shape_170.setTransform(8.3591,135.596,0.3671,0.3671);

	this.shape_171 = new cjs.Shape();
	this.shape_171.graphics.f("#E83323").s().p("Aj9j7IH7AAIAAH3g");
	this.shape_171.setTransform(8.3774,135.7152,0.3671,0.3671);

	this.shape_172 = new cjs.Shape();
	this.shape_172.graphics.f("#5C0E08").s().p("Aj5j9IH3H5In7ACg");
	this.shape_172.setTransform(8.2398,135.6418,0.3671,0.3671);

	this.shape_173 = new cjs.Shape();
	this.shape_173.graphics.f("#2E0402").s().p("Ak8E2IAAprIJ5AAIAAJrg");
	this.shape_173.setTransform(8.3682,135.6877,0.3671,0.3671);

	this.shape_174 = new cjs.Shape();
	this.shape_174.graphics.f("#E83323").s().p("AhBBBIAAiBICDAAIAACBg");
	this.shape_174.setTransform(-50.766,-58.5358,0.3671,0.3671);

	this.shape_175 = new cjs.Shape();
	this.shape_175.graphics.f("#EC706B").s().p("AhUhTICpAAIAACng");
	this.shape_175.setTransform(-50.7568,-58.4899,0.3671,0.3671);

	this.shape_176 = new cjs.Shape();
	this.shape_176.graphics.f("#BA271A").s().p("AhShTICmCnIioAAg");
	this.shape_176.setTransform(-50.8027,-58.5174,0.3671,0.3671);

	this.shape_177 = new cjs.Shape();
	this.shape_177.graphics.f("#2E0402").s().p("AhpBnIAAjNIDSAAIAADNg");
	this.shape_177.setTransform(-50.766,-58.4991,0.3671,0.3671);

	this.shape_178 = new cjs.Shape();
	this.shape_178.graphics.f("#E83323").s().p("AhBBBIAAiBICDAAIAACBg");
	this.shape_178.setTransform(-50.766,-72.4751,0.3671,0.3671);

	this.shape_179 = new cjs.Shape();
	this.shape_179.graphics.f("#EC706B").s().p("AhUhTICpAAIAACng");
	this.shape_179.setTransform(-50.7568,-72.4384,0.3671,0.3671);

	this.shape_180 = new cjs.Shape();
	this.shape_180.graphics.f("#BA271A").s().p("AhUBUIACinICmCng");
	this.shape_180.setTransform(-50.8027,-72.4659,0.3671,0.3671);

	this.shape_181 = new cjs.Shape();
	this.shape_181.graphics.f("#2E0402").s().p("AhpBnIAAjNIDSAAIAADNg");
	this.shape_181.setTransform(-50.766,-72.4476,0.3671,0.3671);

	this.shape_182 = new cjs.Shape();
	this.shape_182.graphics.f("#E83323").s().p("AhBBBIAAiBICDAAIAACBg");
	this.shape_182.setTransform(-57.9054,-65.5834,0.3671,0.3671);

	this.shape_183 = new cjs.Shape();
	this.shape_183.graphics.f("#EC706B").s().p("AhUhTICpAAIAACng");
	this.shape_183.setTransform(-57.8962,-65.5375,0.3671,0.3671);

	this.shape_184 = new cjs.Shape();
	this.shape_184.graphics.f("#BA271A").s().p("AhShTICnCnIipAAg");
	this.shape_184.setTransform(-57.9421,-65.5651,0.3671,0.3671);

	this.shape_185 = new cjs.Shape();
	this.shape_185.graphics.f("#2E0402").s().p("AhpBnIAAjNIDTAAIAADNg");
	this.shape_185.setTransform(-57.9054,-65.5559,0.3671,0.3671);

	this.shape_186 = new cjs.Shape();
	this.shape_186.graphics.f("#E83323").s().p("AhBBBIAAiBICDAAIAACBg");
	this.shape_186.setTransform(-43.7367,-65.5834,0.3671,0.3671);

	this.shape_187 = new cjs.Shape();
	this.shape_187.graphics.f("#EC706B").s().p("AhUhTICpAAIAACng");
	this.shape_187.setTransform(-43.7367,-65.5375,0.3671,0.3671);

	this.shape_188 = new cjs.Shape();
	this.shape_188.graphics.f("#BA271A").s().p("AhShTICmCnIinAAg");
	this.shape_188.setTransform(-43.7826,-65.5651,0.3671,0.3671);

	this.shape_189 = new cjs.Shape();
	this.shape_189.graphics.f("#2E0402").s().p("AhoBnIAAjNIDSAAIAADNg");
	this.shape_189.setTransform(-43.7367,-65.5559,0.3671,0.3671);

	this.shape_190 = new cjs.Shape();
	this.shape_190.graphics.f("#E83323").s().p("AjGDDIAAmFIGMAAIAAGFg");
	this.shape_190.setTransform(110.4859,72.5708,0.3671,0.3671);

	this.shape_191 = new cjs.Shape();
	this.shape_191.graphics.f("#EC706B").s().p("Aj9j7IH7AAIAAH3g");
	this.shape_191.setTransform(110.495,72.6901,0.3671,0.3671);

	this.shape_192 = new cjs.Shape();
	this.shape_192.graphics.f("#BA271A").s().p("Aj5j9IH3H5In7ACg");
	this.shape_192.setTransform(110.3666,72.6167,0.3671,0.3671);

	this.shape_193 = new cjs.Shape();
	this.shape_193.graphics.f("#2E0402").s().p("Ak8E2IAAprIJ5AAIAAJrg");
	this.shape_193.setTransform(110.4859,72.6626,0.3671,0.3671);

	this.shape_194 = new cjs.Shape();
	this.shape_194.graphics.f("#E83323").s().p("AjGDDIAAmFIGMAAIAAGFg");
	this.shape_194.setTransform(110.4859,30.6519,0.3671,0.3671);

	this.shape_195 = new cjs.Shape();
	this.shape_195.graphics.f("#EC706B").s().p("Aj9j7IH7AAIAAH4g");
	this.shape_195.setTransform(110.495,30.7804,0.3671,0.3671);

	this.shape_196 = new cjs.Shape();
	this.shape_196.graphics.f("#BA271A").s().p("Aj5j9IH3H6In7ABg");
	this.shape_196.setTransform(110.3666,30.6978,0.3671,0.3671);

	this.shape_197 = new cjs.Shape();
	this.shape_197.graphics.f("#2E0402").s().p("Ak8E2IAAprIJ5AAIAAJrg");
	this.shape_197.setTransform(110.4859,30.7529,0.3671,0.3671);

	this.shape_198 = new cjs.Shape();
	this.shape_198.graphics.f("#E83323").s().p("AjFDDIAAmFIGLAAIAAGFg");
	this.shape_198.setTransform(89.0217,51.3911,0.3671,0.3671);

	this.shape_199 = new cjs.Shape();
	this.shape_199.graphics.f("#EC706B").s().p("Aj9j8IH7ABIAAH3g");
	this.shape_199.setTransform(89.0401,51.5013,0.3671,0.3671);

	this.shape_200 = new cjs.Shape();
	this.shape_200.graphics.f("#BA271A").s().p("Aj5j9IH3H5In7ACg");
	this.shape_200.setTransform(88.9116,51.437,0.3671,0.3671);

	this.shape_201 = new cjs.Shape();
	this.shape_201.graphics.f("#2E0402").s().p("Ak8E2IAAprIJ5AAIAAJrg");
	this.shape_201.setTransform(89.0309,51.4737,0.3671,0.3671);

	this.shape_202 = new cjs.Shape();
	this.shape_202.graphics.f("#E83323").s().p("AjFDDIAAmFIGLAAIAAGFg");
	this.shape_202.setTransform(131.5829,51.3911,0.3671,0.3671);

	this.shape_203 = new cjs.Shape();
	this.shape_203.graphics.f("#EC706B").s().p("Aj9j8IH7ABIABH3g");
	this.shape_203.setTransform(131.5921,51.5013,0.3671,0.3671);

	this.shape_204 = new cjs.Shape();
	this.shape_204.graphics.f("#BA271A").s().p("Aj5j9IH3H5In7ACg");
	this.shape_204.setTransform(131.4545,51.437,0.3671,0.3671);

	this.shape_205 = new cjs.Shape();
	this.shape_205.graphics.f("#2E0402").s().p("Ak8E2IAAprIJ5AAIAAJrg");
	this.shape_205.setTransform(131.5738,51.4737,0.3671,0.3671);

	this.shape_206 = new cjs.Shape();
	this.shape_206.graphics.f("#FFCCFF").s().p("AhiBkIAAjHIDEAAIAADHg");
	this.shape_206.setTransform(78.0373,80.0681,0.3671,0.3671);

	this.shape_207 = new cjs.Shape();
	this.shape_207.graphics.f("#FFFFFF").s().p("AB/iAIAAEAIj+ABg");
	this.shape_207.setTransform(77.9822,80.0681,0.3671,0.3671);

	this.shape_208 = new cjs.Shape();
	this.shape_208.graphics.f("#BE6C97").s().p("Ah/h/ID/ACIj+D9g");
	this.shape_208.setTransform(78.0097,79.9947,0.3671,0.3671);

	this.shape_209 = new cjs.Shape();
	this.shape_209.graphics.f("#2E0402").s().p("AicCgIAAk/IE5AAIAAE/g");
	this.shape_209.setTransform(77.9914,80.0681,0.3671,0.3671);

	this.shape_210 = new cjs.Shape();
	this.shape_210.graphics.f("#FFCCFF").s().p("AhiBkIAAjHIDEAAIAADHg");
	this.shape_210.setTransform(78.0373,91.6858,0.3671,0.3671);

	this.shape_211 = new cjs.Shape();
	this.shape_211.graphics.f("#FFFFFF").s().p("Ah/CBID+kBIAAEBg");
	this.shape_211.setTransform(77.9822,91.6949,0.3671,0.3671);

	this.shape_212 = new cjs.Shape();
	this.shape_212.graphics.f("#BE6C97").s().p("Ah/h/ID/ACIj+D9g");
	this.shape_212.setTransform(78.0097,91.6307,0.3671,0.3671);

	this.shape_213 = new cjs.Shape();
	this.shape_213.graphics.f("#2E0402").s().p("AicCgIAAk/IE5AAIAAE/g");
	this.shape_213.setTransform(77.9914,91.6858,0.3671,0.3671);

	this.shape_214 = new cjs.Shape();
	this.shape_214.graphics.f("#FFCCFF").s().p("AhhBkIAAjHIDEAAIAADHg");
	this.shape_214.setTransform(89.4346,80.0314,0.3671,0.3671);

	this.shape_215 = new cjs.Shape();
	this.shape_215.graphics.f("#FFFFFF").s().p("Ah/CAID+j/IAAD/g");
	this.shape_215.setTransform(89.3796,80.0406,0.3671,0.3671);

	this.shape_216 = new cjs.Shape();
	this.shape_216.graphics.f("#BE6C97").s().p("Ah/h/ID/ACIj+D9g");
	this.shape_216.setTransform(89.4071,79.9764,0.3671,0.3671);

	this.shape_217 = new cjs.Shape();
	this.shape_217.graphics.f("#2E0402").s().p("AicCgIAAk/IE5AAIAAE/g");
	this.shape_217.setTransform(89.3888,80.0314,0.3671,0.3671);

	this.shape_218 = new cjs.Shape();
	this.shape_218.graphics.f("#FFCCFF").s().p("AhhBkIAAjHIDEAAIAADHg");
	this.shape_218.setTransform(89.4346,91.6674,0.3671,0.3671);

	this.shape_219 = new cjs.Shape();
	this.shape_219.graphics.f("#FFFFFF").s().p("AB/iAIAAEAIj+ABg");
	this.shape_219.setTransform(89.3796,91.6674,0.3671,0.3671);

	this.shape_220 = new cjs.Shape();
	this.shape_220.graphics.f("#BE6C97").s().p("Ah/h/ID/ACIj+D9g");
	this.shape_220.setTransform(89.4071,91.594,0.3671,0.3671);

	this.shape_221 = new cjs.Shape();
	this.shape_221.graphics.f("#2E0402").s().p("AicCgIAAk/IE5AAIAAE/g");
	this.shape_221.setTransform(89.3888,91.6674,0.3671,0.3671);

	this.shape_222 = new cjs.Shape();
	this.shape_222.graphics.f("#FFCCFF").s().p("AjCDGIAAmLIGFAAIAAGLg");
	this.shape_222.setTransform(-14.7293,73.6628,0.3671,0.3671);

	this.shape_223 = new cjs.Shape();
	this.shape_223.graphics.f("#FFFFFF").s().p("AD9j9IgBH7In3AAg");
	this.shape_223.setTransform(-14.8486,73.6812,0.3671,0.3671);

	this.shape_224 = new cjs.Shape();
	this.shape_224.graphics.f("#BE6C97").s().p("Aj9j9IH7AEIn5H2g");
	this.shape_224.setTransform(-14.7844,73.5435,0.3671,0.3671);

	this.shape_225 = new cjs.Shape();
	this.shape_225.graphics.f("#2E0402").s().p("Ak1E9IAAp5IJrAAIAAJ5g");
	this.shape_225.setTransform(-14.8211,73.6537,0.3671,0.3671);

	this.shape_226 = new cjs.Shape();
	this.shape_226.graphics.f("#FFCCFF").s().p("AjCDGIAAmLIGFAAIAAGLg");
	this.shape_226.setTransform(-14.7293,96.6595,0.3671,0.3671);

	this.shape_227 = new cjs.Shape();
	this.shape_227.graphics.f("#FFFFFF").s().p("AD9j9IgBH7In3AAg");
	this.shape_227.setTransform(-14.8486,96.6778,0.3671,0.3671);

	this.shape_228 = new cjs.Shape();
	this.shape_228.graphics.f("#BE6C97").s().p("Aj9j9IH7AEIn5H3g");
	this.shape_228.setTransform(-14.7844,96.5494,0.3671,0.3671);

	this.shape_229 = new cjs.Shape();
	this.shape_229.graphics.f("#2E0402").s().p("Ak1E9IAAp5IJrAAIAAJ5g");
	this.shape_229.setTransform(-14.8211,96.6687,0.3671,0.3671);

	this.shape_230 = new cjs.Shape();
	this.shape_230.graphics.f("#FFCCFF").s().p("AjCDGIAAmLIGFAAIAAGLg");
	this.shape_230.setTransform(7.8177,73.6078,0.3671,0.3671);

	this.shape_231 = new cjs.Shape();
	this.shape_231.graphics.f("#FFFFFF").s().p("Aj7D+IH4n7IgBH7g");
	this.shape_231.setTransform(7.7075,73.6261,0.3671,0.3671);

	this.shape_232 = new cjs.Shape();
	this.shape_232.graphics.f("#BE6C97").s().p("Aj9j9IH7AEIn5H3g");
	this.shape_232.setTransform(7.7718,73.4977,0.3671,0.3671);

	this.shape_233 = new cjs.Shape();
	this.shape_233.graphics.f("#2E0402").s().p("Ak1E9IAAp5IJrAAIAAJ5g");
	this.shape_233.setTransform(7.7259,73.617,0.3671,0.3671);

	this.shape_234 = new cjs.Shape();
	this.shape_234.graphics.f("#FFCCFF").s().p("AjCDGIAAmMIGFAAIAAGMg");
	this.shape_234.setTransform(7.8177,96.6136,0.3671,0.3671);

	this.shape_235 = new cjs.Shape();
	this.shape_235.graphics.f("#FFFFFF").s().p("Aj7D+IH4n7IgBH7g");
	this.shape_235.setTransform(7.7075,96.6228,0.3671,0.3671);

	this.shape_236 = new cjs.Shape();
	this.shape_236.graphics.f("#BE6C97").s().p("Aj9j9IH7AEIn5H3g");
	this.shape_236.setTransform(7.7718,96.4943,0.3671,0.3671);

	this.shape_237 = new cjs.Shape();
	this.shape_237.graphics.f("#2E0402").s().p("Ak1E9IAAp5IJrAAIAAJ5g");
	this.shape_237.setTransform(7.7259,96.6136,0.3671,0.3671);

	this.shape_238 = new cjs.Shape();
	this.shape_238.graphics.f("#999999").s().p("AiOCSIAAkjIEdAAIAAEjg");
	this.shape_238.setTransform(130.4909,83.436,0.3671,0.3671);

	this.shape_239 = new cjs.Shape();
	this.shape_239.graphics.f("#E0E0E0").s().p("Ai4C7IFxl1IAAF1g");
	this.shape_239.setTransform(130.4083,83.4451,0.3671,0.3671);

	this.shape_240 = new cjs.Shape();
	this.shape_240.graphics.f("#666666").s().p("Ai5i5IFzADIlyFwg");
	this.shape_240.setTransform(130.4634,83.3534,0.3671,0.3671);

	this.shape_241 = new cjs.Shape();
	this.shape_241.graphics.f("#2E0402").s().p("AjiDoIAAnPIHFAAIAAHPg");
	this.shape_241.setTransform(130.4267,83.436,0.3671,0.3671);

	this.shape_242 = new cjs.Shape();
	this.shape_242.graphics.f("#999999").s().p("AiOCRIAAkiIEdAAIAAEig");
	this.shape_242.setTransform(130.4909,100.321,0.3671,0.3671);

	this.shape_243 = new cjs.Shape();
	this.shape_243.graphics.f("#E0E0E0").s().p("AC5i6IAAF0IlxABg");
	this.shape_243.setTransform(130.4083,100.3301,0.3671,0.3671);

	this.shape_244 = new cjs.Shape();
	this.shape_244.graphics.f("#666666").s().p("Ai5i5IFzADIlyFwg");
	this.shape_244.setTransform(130.4634,100.2292,0.3671,0.3671);

	this.shape_245 = new cjs.Shape();
	this.shape_245.graphics.f("#2E0402").s().p("AjiDoIAAnPIHFAAIAAHPg");
	this.shape_245.setTransform(130.4267,100.321,0.3671,0.3671);

	this.shape_246 = new cjs.Shape();
	this.shape_246.graphics.f("#999999").s().p("AiOCSIAAkjIEdAAIAAEjg");
	this.shape_246.setTransform(147.0456,100.2843,0.3671,0.3671);

	this.shape_247 = new cjs.Shape();
	this.shape_247.graphics.f("#E0E0E0").s().p("AC5i6IAAF0IlxABg");
	this.shape_247.setTransform(146.963,100.2934,0.3671,0.3671);

	this.shape_248 = new cjs.Shape();
	this.shape_248.graphics.f("#666666").s().p("Ai5i5IFzACIlyFxg");
	this.shape_248.setTransform(147.0089,100.1925,0.3671,0.3671);

	this.shape_249 = new cjs.Shape();
	this.shape_249.graphics.f("#2E0402").s().p("AjjDoIAAnPIHGAAIAAHPg");
	this.shape_249.setTransform(146.9722,100.2843,0.3671,0.3671);

	this.shape_250 = new cjs.Shape();
	this.shape_250.graphics.f("#999999").s().p("AiOCSIAAkjIEdAAIAAEjg");
	this.shape_250.setTransform(147.0456,117.1601,0.3671,0.3671);

	this.shape_251 = new cjs.Shape();
	this.shape_251.graphics.f("#E0E0E0").s().p("Ai4C7IFxl0IAAF0g");
	this.shape_251.setTransform(146.963,117.1693,0.3671,0.3671);

	this.shape_252 = new cjs.Shape();
	this.shape_252.graphics.f("#666666").s().p("Ai5i5IFzADIlyFwg");
	this.shape_252.setTransform(147.0089,117.0683,0.3671,0.3671);

	this.shape_253 = new cjs.Shape();
	this.shape_253.graphics.f("#2E0402").s().p("AjjDpIAAnRIHGAAIAAHRg");
	this.shape_253.setTransform(146.9722,117.1601,0.3671,0.3671);

	this.shape_254 = new cjs.Shape();
	this.shape_254.graphics.f("#999999").s().p("AjCDGIAAmLIGFAAIAAGLg");
	this.shape_254.setTransform(-72.7899,-4.6873,0.3671,0.3671);

	this.shape_255 = new cjs.Shape();
	this.shape_255.graphics.f("#E0E0E0").s().p("Aj7D+IH3n7IAAH7g");
	this.shape_255.setTransform(-72.9092,-4.6689,0.3671,0.3671);

	this.shape_256 = new cjs.Shape();
	this.shape_256.graphics.f("#666666").s().p("Aj9j9IH7AEIn5H3g");
	this.shape_256.setTransform(-72.8358,-4.7974,0.3671,0.3671);

	this.shape_257 = new cjs.Shape();
	this.shape_257.graphics.f("#2E0402").s().p("Ak1E9IAAp5IJrAAIAAJ5g");
	this.shape_257.setTransform(-72.8817,-4.6781,0.3671,0.3671);

	this.shape_258 = new cjs.Shape();
	this.shape_258.graphics.f("#999999").s().p("AjCDGIAAmMIGFAAIAAGMg");
	this.shape_258.setTransform(-72.7899,18.3185,0.3671,0.3671);

	this.shape_259 = new cjs.Shape();
	this.shape_259.graphics.f("#E0E0E0").s().p("Aj7D+IH3n7IAAH7g");
	this.shape_259.setTransform(-72.9092,18.3277,0.3671,0.3671);

	this.shape_260 = new cjs.Shape();
	this.shape_260.graphics.f("#666666").s().p("Aj9j9IH7AEIn5H3g");
	this.shape_260.setTransform(-72.8358,18.1993,0.3671,0.3671);

	this.shape_261 = new cjs.Shape();
	this.shape_261.graphics.f("#2E0402").s().p("Ak1E9IAAp5IJrAAIAAJ5g");
	this.shape_261.setTransform(-72.8817,18.3185,0.3671,0.3671);

	this.shape_262 = new cjs.Shape();
	this.shape_262.graphics.f("#999999").s().p("AjCDGIAAmLIGFAAIAAGLg");
	this.shape_262.setTransform(-50.2337,18.2727,0.3671,0.3671);

	this.shape_263 = new cjs.Shape();
	this.shape_263.graphics.f("#E0E0E0").s().p("AD9j9IgBH7In4AAg");
	this.shape_263.setTransform(-50.3622,18.291,0.3671,0.3671);

	this.shape_264 = new cjs.Shape();
	this.shape_264.graphics.f("#666666").s().p("Aj9j9IH7AEIn6H3g");
	this.shape_264.setTransform(-50.2796,18.1442,0.3671,0.3671);

	this.shape_265 = new cjs.Shape();
	this.shape_265.graphics.f("#2E0402").s().p("Ak1E9IAAp5IJrAAIAAJ5g");
	this.shape_265.setTransform(-50.3347,18.2635,0.3671,0.3671);

	this.shape_266 = new cjs.Shape();
	this.shape_266.graphics.f("#999999").s().p("AjCDGIAAmLIGFAAIAAGLg");
	this.shape_266.setTransform(-50.2337,41.2693,0.3671,0.3671);

	this.shape_267 = new cjs.Shape();
	this.shape_267.graphics.f("#E0E0E0").s().p("AD9j9IgBH7In4AAg");
	this.shape_267.setTransform(-50.3622,41.2877,0.3671,0.3671);

	this.shape_268 = new cjs.Shape();
	this.shape_268.graphics.f("#666666").s().p("Aj9j9IH7AEIn6H3g");
	this.shape_268.setTransform(-50.2796,41.1592,0.3671,0.3671);

	this.shape_269 = new cjs.Shape();
	this.shape_269.graphics.f("#2E0402").s().p("Ak1E9IAAp5IJrAAIAAJ5g");
	this.shape_269.setTransform(-50.3347,41.2785,0.3671,0.3671);

	this.shape_270 = new cjs.Shape();
	this.shape_270.graphics.f("#FFFFFF").s().p("AjCDGIAAmLIGFAAIAAGLg");
	this.shape_270.setTransform(45.4419,34.3868,0.3671,0.3671);

	this.shape_271 = new cjs.Shape();
	this.shape_271.graphics.f("#E0E0E0").s().p("AD9j9IgCH7In3AAg");
	this.shape_271.setTransform(45.3317,34.4052,0.3671,0.3671);

	this.shape_272 = new cjs.Shape();
	this.shape_272.graphics.f("#999999").s().p("Aj9j9IH7AEIn5H3g");
	this.shape_272.setTransform(45.396,34.2584,0.3671,0.3671);

	this.shape_273 = new cjs.Shape();
	this.shape_273.graphics.f("#2E0402").s().p("Ak1E9IAAp5IJrAAIAAJ5g");
	this.shape_273.setTransform(45.3501,34.3777,0.3671,0.3671);

	this.shape_274 = new cjs.Shape();
	this.shape_274.graphics.f("#FFFFFF").s().p("AjCDGIAAmLIGFAAIAAGLg");
	this.shape_274.setTransform(45.4419,57.3835,0.3671,0.3671);

	this.shape_275 = new cjs.Shape();
	this.shape_275.graphics.f("#E0E0E0").s().p("AD9j9IgCH7In3AAg");
	this.shape_275.setTransform(45.3317,57.4018,0.3671,0.3671);

	this.shape_276 = new cjs.Shape();
	this.shape_276.graphics.f("#999999").s().p("Aj9j9IH7AEIn5H3g");
	this.shape_276.setTransform(45.396,57.2734,0.3671,0.3671);

	this.shape_277 = new cjs.Shape();
	this.shape_277.graphics.f("#2E0402").s().p("Ak1E9IAAp5IJrAAIAAJ5g");
	this.shape_277.setTransform(45.3501,57.3927,0.3671,0.3671);

	this.shape_278 = new cjs.Shape();
	this.shape_278.graphics.f("#FFFFFF").s().p("AjCDGIAAmMIGFAAIAAGMg");
	this.shape_278.setTransform(67.998,57.3376,0.3671,0.3671);

	this.shape_279 = new cjs.Shape();
	this.shape_279.graphics.f("#E0E0E0").s().p("Aj7D+IH3n7IAAH7g");
	this.shape_279.setTransform(67.8787,57.3468,0.3671,0.3671);

	this.shape_280 = new cjs.Shape();
	this.shape_280.graphics.f("#999999").s().p("Aj9j9IH7AEIn5H3g");
	this.shape_280.setTransform(67.9521,57.2183,0.3671,0.3671);

	this.shape_281 = new cjs.Shape();
	this.shape_281.graphics.f("#2E0402").s().p("Ak1E9IAAp5IJrAAIAAJ5g");
	this.shape_281.setTransform(67.9063,57.3376,0.3671,0.3671);

	this.shape_282 = new cjs.Shape();
	this.shape_282.graphics.f("#FFFFFF").s().p("AjCDGIAAmLIGFAAIAAGLg");
	this.shape_282.setTransform(67.998,80.3434,0.3671,0.3671);

	this.shape_283 = new cjs.Shape();
	this.shape_283.graphics.f("#E0E0E0").s().p("Aj7D+IH3n7IAAH7g");
	this.shape_283.setTransform(67.8787,80.3434,0.3671,0.3671);

	this.shape_284 = new cjs.Shape();
	this.shape_284.graphics.f("#999999").s().p("Aj9j9IH7AEIn5H3g");
	this.shape_284.setTransform(67.9521,80.215,0.3671,0.3671);

	this.shape_285 = new cjs.Shape();
	this.shape_285.graphics.f("#2E0402").s().p("Ak1E9IAAp5IJrAAIAAJ5g");
	this.shape_285.setTransform(67.9063,80.3343,0.3671,0.3671);

	this.shape_286 = new cjs.Shape();
	this.shape_286.graphics.f("#8B1A11").s().p("AheBgIAAi/IC8AAIAAC/g");
	this.shape_286.setTransform(141.925,-98.2155,0.3671,0.3671);

	this.shape_287 = new cjs.Shape();
	this.shape_287.graphics.f("#E83323").s().p("Ah6B7ID0j1IAAD1g");
	this.shape_287.setTransform(141.8699,-98.2155,0.3671,0.3671);

	this.shape_288 = new cjs.Shape();
	this.shape_288.graphics.f("#5C0E08").s().p("Ah6h6ID1ACIj1Dzg");
	this.shape_288.setTransform(141.9067,-98.2798,0.3671,0.3671);

	this.shape_289 = new cjs.Shape();
	this.shape_289.graphics.f("#2E0402").s().p("AiVCaIAAkzIErAAIAAEzg");
	this.shape_289.setTransform(141.8791,-98.2155,0.3671,0.3671);

	this.shape_290 = new cjs.Shape();
	this.shape_290.graphics.f("#8B1A11").s().p("AheBgIAAi/IC8AAIAAC/g");
	this.shape_290.setTransform(141.925,-87.0659,0.3671,0.3671);

	this.shape_291 = new cjs.Shape();
	this.shape_291.graphics.f("#E83323").s().p("Ah6B7ID0j1IAAD1g");
	this.shape_291.setTransform(141.8699,-87.0568,0.3671,0.3671);

	this.shape_292 = new cjs.Shape();
	this.shape_292.graphics.f("#5C0E08").s().p("Ah6h6ID1ACIj1Dzg");
	this.shape_292.setTransform(141.9067,-87.121,0.3671,0.3671);

	this.shape_293 = new cjs.Shape();
	this.shape_293.graphics.f("#2E0402").s().p("AiVCaIAAkzIErAAIAAEzg");
	this.shape_293.setTransform(141.8791,-87.0568,0.3671,0.3671);

	this.shape_294 = new cjs.Shape();
	this.shape_294.graphics.f("#8B1A11").s().p("AheBgIAAi/IC8AAIAAC/g");
	this.shape_294.setTransform(141.925,-75.9071,0.3671,0.3671);

	this.shape_295 = new cjs.Shape();
	this.shape_295.graphics.f("#E83323").s().p("Ah6B7ID0j1IAAD1g");
	this.shape_295.setTransform(141.8699,-75.898,0.3671,0.3671);

	this.shape_296 = new cjs.Shape();
	this.shape_296.graphics.f("#5C0E08").s().p("Ah6h6ID1ABIj1D0g");
	this.shape_296.setTransform(141.9067,-75.9622,0.3671,0.3671);

	this.shape_297 = new cjs.Shape();
	this.shape_297.graphics.f("#2E0402").s().p("AiVCaIAAkzIErAAIAAEzg");
	this.shape_297.setTransform(141.8791,-75.9071,0.3671,0.3671);

	this.shape_298 = new cjs.Shape();
	this.shape_298.graphics.f("#8B1A11").s().p("AheBgIAAi/IC8AAIAAC/g");
	this.shape_298.setTransform(141.925,-64.7484,0.3671,0.3671);

	this.shape_299 = new cjs.Shape();
	this.shape_299.graphics.f("#E83323").s().p("Ah6B7ID0j1IAAD1g");
	this.shape_299.setTransform(141.8699,-64.7392,0.3671,0.3671);

	this.shape_300 = new cjs.Shape();
	this.shape_300.graphics.f("#5C0E08").s().p("Ah6h6ID1ABIj1D0g");
	this.shape_300.setTransform(141.9067,-64.8034,0.3671,0.3671);

	this.shape_301 = new cjs.Shape();
	this.shape_301.graphics.f("#2E0402").s().p("AiVCaIAAkzIErAAIAAEzg");
	this.shape_301.setTransform(141.8791,-64.7484,0.3671,0.3671);

	this.shape_302 = new cjs.Shape();
	this.shape_302.graphics.f("#8B1A11").s().p("Ah3B6IAAjzIDvAAIAADzg");
	this.shape_302.setTransform(-25.8331,2.6724,0.3671,0.3671);

	this.shape_303 = new cjs.Shape();
	this.shape_303.graphics.f("#E83323").s().p("AiaCcIE1k3IAAE3g");
	this.shape_303.setTransform(-25.9065,2.6816,0.3671,0.3671);

	this.shape_304 = new cjs.Shape();
	this.shape_304.graphics.f("#5C0E08").s().p("AibibIE2ADIk1E0g");
	this.shape_304.setTransform(-25.8606,2.599,0.3671,0.3671);

	this.shape_305 = new cjs.Shape();
	this.shape_305.graphics.f("#2E0402").s().p("Ai9DDIAAmEIF7AAIAAGEg");
	this.shape_305.setTransform(-25.8881,2.6632,0.3671,0.3671);

	this.shape_306 = new cjs.Shape();
	this.shape_306.graphics.f("#8B1A11").s().p("Ah3B6IAAjzIDvAAIAADzg");
	this.shape_306.setTransform(-25.8331,16.7861,0.3671,0.3671);

	this.shape_307 = new cjs.Shape();
	this.shape_307.graphics.f("#E83323").s().p("AiaCcIE1k3IAAE3g");
	this.shape_307.setTransform(-25.9065,16.7952,0.3671,0.3671);

	this.shape_308 = new cjs.Shape();
	this.shape_308.graphics.f("#5C0E08").s().p("AibibIE2ADIk1E0g");
	this.shape_308.setTransform(-25.8606,16.7126,0.3671,0.3671);

	this.shape_309 = new cjs.Shape();
	this.shape_309.graphics.f("#2E0402").s().p("Ai9DDIAAmFIF7AAIAAGFg");
	this.shape_309.setTransform(-25.8881,16.7769,0.3671,0.3671);

	this.shape_310 = new cjs.Shape();
	this.shape_310.graphics.f("#8B1A11").s().p("Ah3B6IAAjzIDvAAIAADzg");
	this.shape_310.setTransform(-25.8331,30.8997,0.3671,0.3671);

	this.shape_311 = new cjs.Shape();
	this.shape_311.graphics.f("#E83323").s().p("ACbibIAAE2Ik1ABg");
	this.shape_311.setTransform(-25.9065,30.9089,0.3671,0.3671);

	this.shape_312 = new cjs.Shape();
	this.shape_312.graphics.f("#5C0E08").s().p("AibibIE2ADIk1E0g");
	this.shape_312.setTransform(-25.8606,30.8263,0.3671,0.3671);

	this.shape_313 = new cjs.Shape();
	this.shape_313.graphics.f("#2E0402").s().p("Ai9DCIAAmEIF7AAIAAGEg");
	this.shape_313.setTransform(-25.8881,30.8905,0.3671,0.3671);

	this.shape_314 = new cjs.Shape();
	this.shape_314.graphics.f("#8B1A11").s().p("Ah3B5IAAjxIDvAAIAADxg");
	this.shape_314.setTransform(-25.8331,45.0042,0.3671,0.3671);

	this.shape_315 = new cjs.Shape();
	this.shape_315.graphics.f("#E83323").s().p("ACbibIAAE2Ik1ABg");
	this.shape_315.setTransform(-25.9065,45.0226,0.3671,0.3671);

	this.shape_316 = new cjs.Shape();
	this.shape_316.graphics.f("#5C0E08").s().p("AibibIE2ADIk1Ezg");
	this.shape_316.setTransform(-25.8606,44.9308,0.3671,0.3671);

	this.shape_317 = new cjs.Shape();
	this.shape_317.graphics.f("#2E0402").s().p("Ai9DCIAAmEIF7AAIAAGEg");
	this.shape_317.setTransform(-25.8881,45.0042,0.3671,0.3671);

	this.shape_318 = new cjs.Shape();
	this.shape_318.graphics.f("#8B1A11").s().p("AjCDGIAAmLIGFAAIAAGLg");
	this.shape_318.setTransform(-140.0547,-94.1595,0.3671,0.3671);

	this.shape_319 = new cjs.Shape();
	this.shape_319.graphics.f("#E83323").s().p("Aj8D+IH4n7IgBH7g");
	this.shape_319.setTransform(-140.1648,-94.1411,0.3671,0.3671);

	this.shape_320 = new cjs.Shape();
	this.shape_320.graphics.f("#5C0E08").s().p("Aj9j9IH7AEIn5H3g");
	this.shape_320.setTransform(-140.1005,-94.2696,0.3671,0.3671);

	this.shape_321 = new cjs.Shape();
	this.shape_321.graphics.f("#2E0402").s().p("Ak1E9IAAp5IJrAAIAAJ5g");
	this.shape_321.setTransform(-140.1372,-94.1503,0.3671,0.3671);

	this.shape_322 = new cjs.Shape();
	this.shape_322.graphics.f("#8B1A11").s().p("AjCDGIAAmLIGFAAIAAGLg");
	this.shape_322.setTransform(-140.0547,-71.1536,0.3671,0.3671);

	this.shape_323 = new cjs.Shape();
	this.shape_323.graphics.f("#E83323").s().p("Aj8D+IH4n7IgBH7g");
	this.shape_323.setTransform(-140.1648,-71.1445,0.3671,0.3671);

	this.shape_324 = new cjs.Shape();
	this.shape_324.graphics.f("#5C0E08").s().p("Aj9j9IH7AEIn5H3g");
	this.shape_324.setTransform(-140.1005,-71.2729,0.3671,0.3671);

	this.shape_325 = new cjs.Shape();
	this.shape_325.graphics.f("#2E0402").s().p("Ak1E9IAAp5IJrAAIAAJ5g");
	this.shape_325.setTransform(-140.1372,-71.1536,0.3671,0.3671);

	this.shape_326 = new cjs.Shape();
	this.shape_326.graphics.f("#8B1A11").s().p("AjCDGIAAmLIGFAAIAAGLg");
	this.shape_326.setTransform(-140.0547,-48.1478,0.3671,0.3671);

	this.shape_327 = new cjs.Shape();
	this.shape_327.graphics.f("#E83323").s().p("AD8j+IgBH8In3AAg");
	this.shape_327.setTransform(-140.1648,-48.1386,0.3671,0.3671);

	this.shape_328 = new cjs.Shape();
	this.shape_328.graphics.f("#5C0E08").s().p("Aj9j9IH7AEIn5H3g");
	this.shape_328.setTransform(-140.1005,-48.2763,0.3671,0.3671);

	this.shape_329 = new cjs.Shape();
	this.shape_329.graphics.f("#2E0402").s().p("Ak1E9IAAp5IJrAAIAAJ5g");
	this.shape_329.setTransform(-140.1372,-48.157,0.3671,0.3671);

	this.shape_330 = new cjs.Shape();
	this.shape_330.graphics.f("#8B1A11").s().p("AjCDGIAAmLIGFAAIAAGLg");
	this.shape_330.setTransform(-140.0547,-25.1512,0.3671,0.3671);

	this.shape_331 = new cjs.Shape();
	this.shape_331.graphics.f("#E83323").s().p("AD8j9IgBH7In3AAg");
	this.shape_331.setTransform(-140.1648,-25.1328,0.3671,0.3671);

	this.shape_332 = new cjs.Shape();
	this.shape_332.graphics.f("#5C0E08").s().p("Aj9j9IH7AEIn5H3g");
	this.shape_332.setTransform(-140.1005,-25.2796,0.3671,0.3671);

	this.shape_333 = new cjs.Shape();
	this.shape_333.graphics.f("#2E0402").s().p("Ak1E9IAAp5IJrAAIAAJ5g");
	this.shape_333.setTransform(-140.1372,-25.1604,0.3671,0.3671);

	this.shape_334 = new cjs.Shape();
	this.shape_334.graphics.f("#E83323").s().p("AhQBSIAAijICgAAIAACjg");
	this.shape_334.setTransform(107.6962,-48.4415,0.3671,0.3671);

	this.shape_335 = new cjs.Shape();
	this.shape_335.graphics.f("#EC706B").s().p("AhnBpIDPjRIAADRg");
	this.shape_335.setTransform(107.6411,-48.4415,0.3671,0.3671);

	this.shape_336 = new cjs.Shape();
	this.shape_336.graphics.f("#BA271A").s().p("AhohnIDRABIjQDOg");
	this.shape_336.setTransform(107.6778,-48.4874,0.3671,0.3671);

	this.shape_337 = new cjs.Shape();
	this.shape_337.graphics.f("#2E0402").s().p("Ah/CDIAAkFID/AAIAAEFg");
	this.shape_337.setTransform(107.6503,-48.4415,0.3671,0.3671);

	this.shape_338 = new cjs.Shape();
	this.shape_338.graphics.f("#E83323").s().p("AhQBSIAAijIChAAIAACjg");
	this.shape_338.setTransform(124.9666,-48.4415,0.3671,0.3671);

	this.shape_339 = new cjs.Shape();
	this.shape_339.graphics.f("#EC706B").s().p("AhnBpIDPjRIAADRg");
	this.shape_339.setTransform(124.9115,-48.4415,0.3671,0.3671);

	this.shape_340 = new cjs.Shape();
	this.shape_340.graphics.f("#BA271A").s().p("AhohoIDRACIjQDOg");
	this.shape_340.setTransform(124.9482,-48.4874,0.3671,0.3671);

	this.shape_341 = new cjs.Shape();
	this.shape_341.graphics.f("#2E0402").s().p("Ah/CDIAAkFID/AAIAAEFg");
	this.shape_341.setTransform(124.9207,-48.4415,0.3671,0.3671);

	this.shape_342 = new cjs.Shape();
	this.shape_342.graphics.f("#E83323").s().p("AhPBSIAAijICfAAIAACjg");
	this.shape_342.setTransform(116.4231,-57.2878,0.3671,0.3671);

	this.shape_343 = new cjs.Shape();
	this.shape_343.graphics.f("#EC706B").s().p("AhnBpIDPjRIgBDRg");
	this.shape_343.setTransform(116.3773,-57.2878,0.3671,0.3671);

	this.shape_344 = new cjs.Shape();
	this.shape_344.graphics.f("#BA271A").s().p("AhohnIDRABIjQDOg");
	this.shape_344.setTransform(116.4048,-57.3336,0.3671,0.3671);

	this.shape_345 = new cjs.Shape();
	this.shape_345.graphics.f("#2E0402").s().p("Ah/CDIAAkFID/AAIAAEFg");
	this.shape_345.setTransform(116.3864,-57.2878,0.3671,0.3671);

	this.shape_346 = new cjs.Shape();
	this.shape_346.graphics.f("#E83323").s().p("AhPBSIAAijICfAAIAACjg");
	this.shape_346.setTransform(116.4231,-39.7604,0.3671,0.3671);

	this.shape_347 = new cjs.Shape();
	this.shape_347.graphics.f("#EC706B").s().p("AhnBpIDPjRIgBDRg");
	this.shape_347.setTransform(116.3773,-39.742,0.3671,0.3671);

	this.shape_348 = new cjs.Shape();
	this.shape_348.graphics.f("#BA271A").s().p("AhohoIDRACIjQDPg");
	this.shape_348.setTransform(116.4048,-39.8063,0.3671,0.3671);

	this.shape_349 = new cjs.Shape();
	this.shape_349.graphics.f("#2E0402").s().p("Ah/CCIAAkEID/AAIAAEEg");
	this.shape_349.setTransform(116.3864,-39.7512,0.3671,0.3671);

	this.shape_350 = new cjs.Shape();
	this.shape_350.graphics.f("#E83323").s().p("Ah6B9IAAj4ID1AAIAAD4g");
	this.shape_350.setTransform(-79.7091,85.8402,0.3671,0.3671);

	this.shape_351 = new cjs.Shape();
	this.shape_351.graphics.f("#EC706B").s().p("AieCgIE9k/IgBE/g");
	this.shape_351.setTransform(-79.7917,85.8494,0.3671,0.3671);

	this.shape_352 = new cjs.Shape();
	this.shape_352.graphics.f("#BA271A").s().p("AifieIE+ACIk9E7g");
	this.shape_352.setTransform(-79.7458,85.7668,0.3671,0.3671);

	this.shape_353 = new cjs.Shape();
	this.shape_353.graphics.f("#2E0402").s().p("AjCDHIAAmNIGFAAIAAGNg");
	this.shape_353.setTransform(-79.7733,85.8494,0.3671,0.3671);

	this.shape_354 = new cjs.Shape();
	this.shape_354.graphics.f("#E83323").s().p("Ah6B8IAAj3ID1AAIAAD3g");
	this.shape_354.setTransform(-53.363,85.8402,0.3671,0.3671);

	this.shape_355 = new cjs.Shape();
	this.shape_355.graphics.f("#EC706B").s().p("AieCgIE9k/IgBE/g");
	this.shape_355.setTransform(-53.4364,85.8494,0.3671,0.3671);

	this.shape_356 = new cjs.Shape();
	this.shape_356.graphics.f("#BA271A").s().p("AififIE/ADIk+E8g");
	this.shape_356.setTransform(-53.3905,85.7668,0.3671,0.3671);

	this.shape_357 = new cjs.Shape();
	this.shape_357.graphics.f("#2E0402").s().p("AjCDHIAAmNIGFAAIAAGNg");
	this.shape_357.setTransform(-53.418,85.8494,0.3671,0.3671);

	this.shape_358 = new cjs.Shape();
	this.shape_358.graphics.f("#E83323").s().p("Ah6B9IAAj5ID1AAIAAD5g");
	this.shape_358.setTransform(-66.3938,72.3506,0.3671,0.3671);

	this.shape_359 = new cjs.Shape();
	this.shape_359.graphics.f("#EC706B").s().p("AieCgIE9k/IgBE/g");
	this.shape_359.setTransform(-66.4672,72.3598,0.3671,0.3671);

	this.shape_360 = new cjs.Shape();
	this.shape_360.graphics.f("#BA271A").s().p("AifieIE+ACIk9E8g");
	this.shape_360.setTransform(-66.4213,72.2772,0.3671,0.3671);

	this.shape_361 = new cjs.Shape();
	this.shape_361.graphics.f("#2E0402").s().p("AjCDHIAAmNIGFAAIAAGNg");
	this.shape_361.setTransform(-66.4489,72.3598,0.3671,0.3671);

	this.shape_362 = new cjs.Shape();
	this.shape_362.graphics.f("#E83323").s().p("Ah6B9IAAj5ID1AAIAAD5g");
	this.shape_362.setTransform(-66.3938,99.1005,0.3671,0.3671);

	this.shape_363 = new cjs.Shape();
	this.shape_363.graphics.f("#EC706B").s().p("ACfifIgBE+Ik8ABg");
	this.shape_363.setTransform(-66.4672,99.1096,0.3671,0.3671);

	this.shape_364 = new cjs.Shape();
	this.shape_364.graphics.f("#BA271A").s().p("AififIE+ADIk9E8g");
	this.shape_364.setTransform(-66.4213,99.0179,0.3671,0.3671);

	this.shape_365 = new cjs.Shape();
	this.shape_365.graphics.f("#2E0402").s().p("AjCDHIAAmNIGFAAIAAGNg");
	this.shape_365.setTransform(-66.4489,99.1005,0.3671,0.3671);

	this.shape_366 = new cjs.Shape();
	this.shape_366.graphics.f("#E83323").s().p("AjCDGIAAmLIGFAAIAAGLg");
	this.shape_366.setTransform(3.4863,-32.8871,0.3671,0.3671);

	this.shape_367 = new cjs.Shape();
	this.shape_367.graphics.f("#EC706B").s().p("Aj7D+IH4n7IgBH7g");
	this.shape_367.setTransform(3.3578,-32.8779,0.3671,0.3671);

	this.shape_368 = new cjs.Shape();
	this.shape_368.graphics.f("#BA271A").s().p("Aj9j9IH7AEIn6H3g");
	this.shape_368.setTransform(3.4404,-33.0064,0.3671,0.3671);

	this.shape_369 = new cjs.Shape();
	this.shape_369.graphics.f("#2E0402").s().p("Ak1E9IAAp5IJrAAIAAJ5g");
	this.shape_369.setTransform(3.3853,-32.8871,0.3671,0.3671);

	this.shape_370 = new cjs.Shape();
	this.shape_370.graphics.f("#E83323").s().p("AjCDGIAAmMIGFAAIAAGMg");
	this.shape_370.setTransform(45.396,-32.8871,0.3671,0.3671);

	this.shape_371 = new cjs.Shape();
	this.shape_371.graphics.f("#EC706B").s().p("Aj8D+IH5n7IgCH7g");
	this.shape_371.setTransform(45.2767,-32.8779,0.3671,0.3671);

	this.shape_372 = new cjs.Shape();
	this.shape_372.graphics.f("#BA271A").s().p("Aj9j9IH7AEIn5H3g");
	this.shape_372.setTransform(45.3409,-33.0064,0.3671,0.3671);

	this.shape_373 = new cjs.Shape();
	this.shape_373.graphics.f("#2E0402").s().p("Ak1E9IAAp5IJrAAIAAJ5g");
	this.shape_373.setTransform(45.3042,-32.8871,0.3671,0.3671);

	this.shape_374 = new cjs.Shape();
	this.shape_374.graphics.f("#E83323").s().p("AjCDHIAAmNIGFAAIAAGNg");
	this.shape_374.setTransform(24.666,-54.3421,0.3671,0.3671);

	this.shape_375 = new cjs.Shape();
	this.shape_375.graphics.f("#EC706B").s().p("Aj8D+IH5n7IgBH7g");
	this.shape_375.setTransform(24.5375,-54.3329,0.3671,0.3671);

	this.shape_376 = new cjs.Shape();
	this.shape_376.graphics.f("#BA271A").s().p("Aj9j9IH7AEIn5H3g");
	this.shape_376.setTransform(24.6201,-54.4613,0.3671,0.3671);

	this.shape_377 = new cjs.Shape();
	this.shape_377.graphics.f("#2E0402").s().p("Ak1E9IAAp5IJrAAIAAJ5g");
	this.shape_377.setTransform(24.565,-54.3421,0.3671,0.3671);

	this.shape_378 = new cjs.Shape();
	this.shape_378.graphics.f("#E83323").s().p("AjCDGIAAmLIGFAAIAAGLg");
	this.shape_378.setTransform(24.666,-11.79,0.3671,0.3671);

	this.shape_379 = new cjs.Shape();
	this.shape_379.graphics.f("#EC706B").s().p("AD9j+IgBH8In4AAg");
	this.shape_379.setTransform(24.5375,-11.7808,0.3671,0.3671);

	this.shape_380 = new cjs.Shape();
	this.shape_380.graphics.f("#BA271A").s().p("Aj9j9IH7AEIn5H3g");
	this.shape_380.setTransform(24.6201,-11.9185,0.3671,0.3671);

	this.shape_381 = new cjs.Shape();
	this.shape_381.graphics.f("#2E0402").s().p("Ak1E9IAAp5IJrAAIAAJ5g");
	this.shape_381.setTransform(24.565,-11.7992,0.3671,0.3671);

	this.shape_382 = new cjs.Shape();
	this.shape_382.graphics.f("#000000").s().p("EhFNA6nMAAAh1NMCKbAAAMAAAB1Ng");
	this.shape_382.setTransform(3.4523,18.4349,0.3671,0.3671);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_382},{t:this.shape_381},{t:this.shape_380},{t:this.shape_379},{t:this.shape_378},{t:this.shape_377},{t:this.shape_376},{t:this.shape_375},{t:this.shape_374},{t:this.shape_373},{t:this.shape_372},{t:this.shape_371},{t:this.shape_370},{t:this.shape_369},{t:this.shape_368},{t:this.shape_367},{t:this.shape_366},{t:this.shape_365},{t:this.shape_364},{t:this.shape_363},{t:this.shape_362},{t:this.shape_361},{t:this.shape_360},{t:this.shape_359},{t:this.shape_358},{t:this.shape_357},{t:this.shape_356},{t:this.shape_355},{t:this.shape_354},{t:this.shape_353},{t:this.shape_352},{t:this.shape_351},{t:this.shape_350},{t:this.shape_349},{t:this.shape_348},{t:this.shape_347},{t:this.shape_346},{t:this.shape_345},{t:this.shape_344},{t:this.shape_343},{t:this.shape_342},{t:this.shape_341},{t:this.shape_340},{t:this.shape_339},{t:this.shape_338},{t:this.shape_337},{t:this.shape_336},{t:this.shape_335},{t:this.shape_334},{t:this.shape_333},{t:this.shape_332},{t:this.shape_331},{t:this.shape_330},{t:this.shape_329},{t:this.shape_328},{t:this.shape_327},{t:this.shape_326},{t:this.shape_325},{t:this.shape_324},{t:this.shape_323},{t:this.shape_322},{t:this.shape_321},{t:this.shape_320},{t:this.shape_319},{t:this.shape_318},{t:this.shape_317},{t:this.shape_316},{t:this.shape_315},{t:this.shape_314},{t:this.shape_313},{t:this.shape_312},{t:this.shape_311},{t:this.shape_310},{t:this.shape_309},{t:this.shape_308},{t:this.shape_307},{t:this.shape_306},{t:this.shape_305},{t:this.shape_304},{t:this.shape_303},{t:this.shape_302},{t:this.shape_301},{t:this.shape_300},{t:this.shape_299},{t:this.shape_298},{t:this.shape_297},{t:this.shape_296},{t:this.shape_295},{t:this.shape_294},{t:this.shape_293},{t:this.shape_292},{t:this.shape_291},{t:this.shape_290},{t:this.shape_289},{t:this.shape_288},{t:this.shape_287},{t:this.shape_286},{t:this.shape_285},{t:this.shape_284},{t:this.shape_283},{t:this.shape_282},{t:this.shape_281},{t:this.shape_280},{t:this.shape_279},{t:this.shape_278},{t:this.shape_277},{t:this.shape_276},{t:this.shape_275},{t:this.shape_274},{t:this.shape_273},{t:this.shape_272},{t:this.shape_271},{t:this.shape_270},{t:this.shape_269},{t:this.shape_268},{t:this.shape_267},{t:this.shape_266},{t:this.shape_265},{t:this.shape_264},{t:this.shape_263},{t:this.shape_262},{t:this.shape_261},{t:this.shape_260},{t:this.shape_259},{t:this.shape_258},{t:this.shape_257},{t:this.shape_256},{t:this.shape_255},{t:this.shape_254},{t:this.shape_253},{t:this.shape_252},{t:this.shape_251},{t:this.shape_250},{t:this.shape_249},{t:this.shape_248},{t:this.shape_247},{t:this.shape_246},{t:this.shape_245},{t:this.shape_244},{t:this.shape_243},{t:this.shape_242},{t:this.shape_241},{t:this.shape_240},{t:this.shape_239},{t:this.shape_238},{t:this.shape_237},{t:this.shape_236},{t:this.shape_235},{t:this.shape_234},{t:this.shape_233},{t:this.shape_232},{t:this.shape_231},{t:this.shape_230},{t:this.shape_229},{t:this.shape_228},{t:this.shape_227},{t:this.shape_226},{t:this.shape_225},{t:this.shape_224},{t:this.shape_223},{t:this.shape_222},{t:this.shape_221},{t:this.shape_220},{t:this.shape_219},{t:this.shape_218},{t:this.shape_217},{t:this.shape_216},{t:this.shape_215},{t:this.shape_214},{t:this.shape_213},{t:this.shape_212},{t:this.shape_211},{t:this.shape_210},{t:this.shape_209},{t:this.shape_208},{t:this.shape_207},{t:this.shape_206},{t:this.shape_205},{t:this.shape_204},{t:this.shape_203},{t:this.shape_202},{t:this.shape_201},{t:this.shape_200},{t:this.shape_199},{t:this.shape_198},{t:this.shape_197},{t:this.shape_196},{t:this.shape_195},{t:this.shape_194},{t:this.shape_193},{t:this.shape_192},{t:this.shape_191},{t:this.shape_190},{t:this.shape_189},{t:this.shape_188},{t:this.shape_187},{t:this.shape_186},{t:this.shape_185},{t:this.shape_184},{t:this.shape_183},{t:this.shape_182},{t:this.shape_181},{t:this.shape_180},{t:this.shape_179},{t:this.shape_178},{t:this.shape_177},{t:this.shape_176},{t:this.shape_175},{t:this.shape_174},{t:this.shape_173},{t:this.shape_172},{t:this.shape_171},{t:this.shape_170},{t:this.shape_169},{t:this.shape_168},{t:this.shape_167},{t:this.shape_166},{t:this.shape_165},{t:this.shape_164},{t:this.shape_163},{t:this.shape_162},{t:this.shape_161},{t:this.shape_160},{t:this.shape_159},{t:this.shape_158},{t:this.shape_157},{t:this.shape_156},{t:this.shape_155},{t:this.shape_154},{t:this.shape_153},{t:this.shape_152},{t:this.shape_151},{t:this.shape_150},{t:this.shape_149},{t:this.shape_148},{t:this.shape_147},{t:this.shape_146},{t:this.shape_145},{t:this.shape_144},{t:this.shape_143},{t:this.shape_142},{t:this.shape_141},{t:this.shape_140},{t:this.shape_139},{t:this.shape_138},{t:this.shape_137},{t:this.shape_136},{t:this.shape_135},{t:this.shape_134},{t:this.shape_133},{t:this.shape_132},{t:this.shape_131},{t:this.shape_130},{t:this.shape_129},{t:this.shape_128},{t:this.shape_127},{t:this.shape_126},{t:this.shape_125},{t:this.shape_124},{t:this.shape_123},{t:this.shape_122},{t:this.shape_121},{t:this.shape_120},{t:this.shape_119},{t:this.shape_118},{t:this.shape_117},{t:this.shape_116},{t:this.shape_115},{t:this.shape_114},{t:this.shape_113},{t:this.shape_112},{t:this.shape_111},{t:this.shape_110},{t:this.shape_109},{t:this.shape_108},{t:this.shape_107},{t:this.shape_106},{t:this.shape_105},{t:this.shape_104},{t:this.shape_103},{t:this.shape_102},{t:this.shape_101},{t:this.shape_100},{t:this.shape_99},{t:this.shape_98},{t:this.shape_97},{t:this.shape_96},{t:this.shape_95},{t:this.shape_94},{t:this.shape_93},{t:this.shape_92},{t:this.shape_91},{t:this.shape_90},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84},{t:this.shape_83},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80},{t:this.shape_79},{t:this.shape_78},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75},{t:this.shape_74},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71},{t:this.shape_70},{t:this.shape_69},{t:this.shape_68},{t:this.shape_67},{t:this.shape_66},{t:this.shape_65},{t:this.shape_64},{t:this.shape_63},{t:this.shape_62},{t:this.shape_61},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55},{t:this.shape_54},{t:this.shape_53},{t:this.shape_52},{t:this.shape_51},{t:this.shape_50},{t:this.shape_49},{t:this.shape_48},{t:this.shape_47},{t:this.shape_46},{t:this.shape_45},{t:this.shape_44},{t:this.shape_43},{t:this.shape_42},{t:this.shape_41},{t:this.shape_40},{t:this.shape_39},{t:this.shape_38},{t:this.shape_37},{t:this.shape_36},{t:this.shape_35},{t:this.shape_34},{t:this.shape_33},{t:this.shape_32},{t:this.shape_31},{t:this.shape_30},{t:this.shape_29},{t:this.shape_28},{t:this.shape_27},{t:this.shape_26},{t:this.shape_25},{t:this.shape_24},{t:this.shape_23},{t:this.shape_22},{t:this.shape_21},{t:this.shape_20},{t:this.shape_19},{t:this.shape_18},{t:this.shape_17},{t:this.shape_16},{t:this.shape_15},{t:this.shape_14},{t:this.shape_13},{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.highscoreMenu, new cjs.Rectangle(-203.3,-211.3,407,413.8), null);


(lib.square = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(8));

	// Bang
	this.bang_mc = new lib.BangClip();
	this.bang_mc.setTransform(10,10.05);

	this.timeline.addTween(cjs.Tween.get(this.bang_mc).wait(8));

	// Blocks
	this.instance = new lib.square_1();
	this.instance.setTransform(10,10,1,1,0,0,0,11,11);

	this.instance_1 = new lib.square_2();
	this.instance_1.setTransform(10,10,1,1,0,0,0,11,11);

	this.instance_2 = new lib.square_3();
	this.instance_2.setTransform(10,10,1,1,0,0,0,11,11);

	this.instance_3 = new lib.square_4();
	this.instance_3.setTransform(10,10,1,1,0,0,0,11,11);

	this.instance_4 = new lib.square_5();
	this.instance_4.setTransform(10,10,1,1,0,0,0,11,11);

	this.instance_5 = new lib.square_6();
	this.instance_5.setTransform(10,10,1,1,0,0,0,11,11);

	this.instance_6 = new lib.square_7();
	this.instance_6.setTransform(10,10,1,1,0,0,0,11,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1,-1,22,22);


// stage content:
(lib.DeathrisHTML5 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{mainMenu:0,difficultyMenu:1,game:2,submitScore:3,highscores:4});

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
		var _root = this;
		
		var bigPlayButton = this.bigPlayButton;
		var dim = this.dim;
		dim.alpha = 0.80;
		var instructionsButton = this.instructionsButton;
		var instructionsMenu = this.instructionsMenu;
		instructionsMenu.visible = false;
		var highscoresButton = this.highScoresButton;
		var backButton = this.instructionsMenu.backButton;
		var playButton = this.playButton;
		instructionsButton.gotoAndStop(0);
		
		if(_root.bigButtonClicked != true)
			bigPlayButton.addEventListener("click", onBigPlayButtonClicked);
		else {
			bigPlayButton.visible = false;
			dim.visible = false;
			addButtonListeners();
		}
		
		function onBigPlayButtonClicked(){
			_root.bigButtonClicked = true;
			bigPlayButton.removeEventListener("click", onBigPlayButtonClicked);
			bigPlayButton.parent.removeChild(bigPlayButton);
			dim.parent.removeChild(dim);
			playMusic("sfx_theme");
			playButton.visible = true;
			addButtonListeners();
		}
		
		function addButtonListeners(){
			instructionsButton.addEventListener("click", onInstructionsClicked);
			backButton.addEventListener("click", onBackClicked);
			playButton.addEventListener("click", onPlayClicked);
			highscoresButton.addEventListener("click", onHighscoresClicked);
		}
		
		function removeButtonListeners(){
			playButton.removeEventListener("click", onPlayClicked);
			instructionsButton.removeEventListener("click", onInstructionsClicked);
			backButton.removeEventListener("click", onBackClicked);
			highscoresButton.removeEventListener("click", onHighscoresClicked);
		}
		
		function onPlayClicked(e){
			removeButtonListeners();
			playSound("sfx_click");
			_root.gotoAndStop("difficultyMenu");
		}
		
		function onHighscoresClicked(){
			removeButtonListeners();
			playSound("sfx_click");
			//_root.gotoAndStop("highscores");
			_root.gotoAndStop("highscores");
		}
		
		function onInstructionsClicked(e){
			console.log("instructions clicked");
			playSound("sfx_click");
			instructionsMenu.visible = true;
			instructionsButton.removeEventListener("click", onInstructionsClicked);
		}
		
		function onBackClicked(e){
			console.log("back clicked");
			playSound("sfx_click");
			instructionsButton.addEventListener("click", onInstructionsClicked);
			instructionsMenu.visible = false;
		}
	}
	this.frame_1 = function() {
		this.stop();
		var _root = this;
		var level = 1;
		var upButton = this.upButton;
		var downButton = this.downButton;
		var okButton = this.okButton;
		
		updateTxt();
		aEL(upButton, "click", onUpClicked);
		aEL(downButton, "click", onDownClicked);
		aEL(okButton, "click", onOkClicked);
		
		//updateTxt();
		
		function onUpClicked(e){
			level++;
			if(level > 10) level = 10;
			else playSound("sfx_click");
			updateTxt();
		}
		
		function onDownClicked(e){
			level--;
			if(level < 1) level = 1;
			else playSound("sfx_click");
			updateTxt();
		}
		
		var buttonAlpha = 0.40;
		downButton.alpha = buttonAlpha;
		
		function updateTxt(){
			_root.diffTxt.text = level;
			if(level == 1) downButton.alpha = buttonAlpha;
			else downButton.alpha = 1;
			if(level == 10) upButton.alpha = buttonAlpha;
			else upButton.alpha = 1;
		}
		
		function onOkClicked(e){
			playSound("sfx_click");
			_root.level = level;
			okButton.removeEventListener("click", onOkClicked);
			upButton.removeEventListener("click", onUpClicked);
			downButton.removeEventListener("click", onDownClicked);
			_root.gotoAndStop("game");
		}
		
		function aEL(button, listener, handler){
			if(!button.hasEventListener(listener))
				button.addEventListener(listener, handler);
		}
	}
	this.frame_2 = function() {
		this.block_1_0 = [[0, 0, 0],
					      [3, 3, 3],
					      [0, 0, 3]];
		this.block_1_1 = [[0, 3, 0],
					      [0, 3, 0],
					      [3, 3, 0]];
		this.block_1_2 = [[3, 0, 0],
					      [3, 3, 3],
					      [0, 0, 0]];	
		this.block_1_3 = [[0, 3, 3],
					      [0, 3, 0],
					      [0, 3, 0]];	
						  
		this.block_2_0 = [[0, 0, 0],
					      [5, 5, 5],
					      [5, 0, 0]];
		this.block_2_1 = [[0, 5, 5],
					      [0, 0, 5],
					      [0, 0, 5]];
		this.block_2_2 = [[0, 0, 0],
					      [0, 0, 5],
					      [5, 5, 5]];	
		this.block_2_3 = [[5, 0, 0],
					      [5, 0, 0],
					      [5, 5, 0]];
						  
		
		this.block_3_0 = [[0,0,0],
						  [6,6,0],
						  [0,6,6]];
		this.block_3_1 = [[0,6,0],
						  [6,6,0],
						  [6,0,0]];
		this.block_3_2 = [[0,0,0],
						  [6,6,0],
						  [0,6,6]];
		this.block_3_3 = [[0,6,0],
						  [6,6,0],
						  [6,0,0]];
						  
		this.block_4_0 = [[0,0,0],
						  [0,4,4],
						  [4,4,0]];
		this.block_4_1 = [[4,0,0],
						  [4,4,0],
						  [0,4,0]];
		this.block_4_2 = [[0,0,0],
						  [0,4,4],
						  [4,4,0]];
		this.block_4_3 = [[4,0,0],
						  [4,4,0],
						  [0,4,0]];
		
		this.block_5_0 = [[0, 0, 0, 0],
						  [0, 0, 0, 0],
						  [0, 0, 0, 0],				  
						  [7, 7, 7, 7]];
		this.block_5_1 = [[0, 7, 0, 0],
						  [0, 7, 0, 0],
						  [0, 7, 0, 0],
						  [0, 7, 0, 0]];
		this.block_5_2 = [[0, 0, 0, 0],
						  [0, 0, 0, 0],
						  [0, 0, 0, 0],				  
						  [7, 7, 7, 7]];
		this.block_5_3 = [[0, 7, 0, 0],
						  [0, 7, 0, 0],
						  [0, 7, 0, 0],
						  [0, 7, 0, 0]];
		
		this.block_6_0 = [[2, 2],
						  [2, 2]];
		this.block_6_1 = [[2, 2],
						  [2, 2]];
		this.block_6_2 = [[2, 2],
						  [2, 2]];
		this.block_6_3 = [[2, 2],
						  [2, 2]];	
						  
		this.block_7_0 = [[0, 1, 0],
						  [1, 0, 1],
						  [0, 1, 0]];
		this.block_7_1 = [[0, 1, 0],
						  [1, 1, 1],
						  [0, 0, 0]];
		this.block_7_2 = [[0, 1, 0],
						  [1, 0, 1],
						  [0, 1, 0]];
		this.block_7_3 = [[0, 1, 0],
						  [1, 1, 1],
						  [0, 0, 0]];
						  
		var nextShape = randomInteger(1, 7);
		var nextShapeSymbol = this.nextShapeSymbol;
		
		function setNextShape(){
			nextShape = randomInteger(1, 7);
			nextShapeSymbol.gotoAndStop(nextShape);
		}
		
		var _root = this;
		var cols = 10;
		var rows = 16;
		var squareSize = 20.50;
		var gameArea = this.gameArea;
		var fallingBlocks = [];
		var fallTimeOriginal = 400;
		var fallTime = fallTimeOriginal;
		var isGameOver;
		var hasFullRows;
		var isPaused;
		var currentLevel = _root.level;
		var maxLevels = 10;
		
		var levelTxt = this.levelTxt;
		var linesTxt = this.linesTxt;
		var pointsTxt = this.pointsTxt;
		
		var points = 0;
		var currentShapePoints = 0;
		var lines = 0;
		
		var pauseBtn = this.pauseBtn;
		var quitBtn = this.quitBtn;
		var quitMenu = this.quitMenu;
		var pauseMenu = this.pauseMenu;
		quitMenu.visible = false;
		pauseMenu.visible = false;
		
		if(!pauseBtn.hasEventListener("click"))
			pauseBtn.addEventListener("click", onPauseBtnClicked);
		if(!quitBtn.hasEventListener("click"))
			quitBtn.addEventListener("click", onQuitBtnClicked);
		if(!quitMenu.yesBtn.hasEventListener("click"))
			quitMenu.yesBtn.addEventListener("click", onQuitYesClicked);
		if(!quitMenu.noBtn.hasEventListener("click"))
			quitMenu.noBtn.addEventListener("click", onQuitNoClicked);
		
		function onPauseBtnClicked(){
			if(!isGameOver && !quitMenu.visible){
				playSound("sfx_click");
				pauseMenu.visible = true;
				pauseGame();	
			}
		}
		
		function onQuitBtnClicked(){
			if(!pauseMenu.visible && !isGameOver){
				playSound("sfx_click");
				playSound("sfx_click");
				quitMenu.visible = true;
				changeAllSquaresVisibility(false);
			}
		}
		
		function onQuitYesClicked(){
			playSound("sfx_click");
			stage.removeEventListener("mousedown", onMouseDown);
			stage.removeEventListener("stagemouseup", onMouseUp);
			stage.removeEventListener("stagemousemove", onMouseMove);
			clearInterval(gameInterval);
			removeAllSquares();
			removeAllButtonListeners();
			_root.gotoAndStop("mainMenu");
		}
		
		function onQuitNoClicked(){
			playSound("sfx_click");
			changeAllSquaresVisibility(true);
			quitMenu.visible = false;
			//pauseGame();
		}
		
		function changeAllSquaresVisibility(visibility){
			if(gameBoard) {
				console.log("gameBoard.len "+gameBoard.length);
				if(gameBoard.length > 0){
					for(var i=0;i<gameBoard.length;i++){
						for(var j=0;j<gameBoard[i].length;j++){
							if(gameBoard[i][j] != null){
								var square = gameBoard[i][j];
								square.visible = visibility;
							}
						}
					}
					if(currentBlock){
						if(currentBlock.squares){
							for(var i=0;i<currentBlock.squares.length;i++) currentBlock.squares[i].visible = visibility;
						}
					}
				}
			}
		}
		
		function removeAllSquares(){
			for(var i=0;i<gameBoard.length;i++){
				for(var j=0;j<gameBoard[i].length;j++){
					if(gameBoard[i][j] != null){
						var square = gameBoard[i][j];
						square.parent.removeChild(square);
						square = null;
					}
				}
			}
			//gameBoard = null;
			if(currentBlock){
				if(currentBlock.squares){
					while(currentBlock.squares.length > 0){
						var square = currentBlock.squares.pop();
						square.parent.removeChild(square);
					}
				}
			}
			currentBlock = null;
			currentBlock = {};
		}
					
		startLevel();
		updateTxtFields();
		
		function startLevel(){
			isGameOver = false;
			isPaused = false;
			hasFullRows = false;
			createEmptyGameBoard();
			createNextBlock();
			clearInterval(moveBlockDown);
			gameInterval = setInterval(moveBlockDown, calculateFallTime());
		}
		
		function calculateFallTime(){
			var fallTimeArr = [1000, 1000, 900, 800, 600, 500, 450, 400, 350, 300, 250, 200];
			return fallTimeArr[currentLevel];	
			//return fallTimeOriginal - 20 * (currentLevel - 1);
		}
		
		function increaseLevel(){
			currentLevel = Math.floor(lines / 10) + 1;
			if(currentLevel > maxLevels) currentLevel = maxLevels;
			clearInterval(moveBlockDown);
			gameInterval = setInterval(moveBlockDown, calculateFallTime());
			updateTxtFields();
		}
		
		function pauseGame(){
			if(!isPaused){
				isPaused = true;
				//clearInterval(gameInterval);
				changeAllSquaresVisibility(false);
				pauseMenu.visible = true;
			}
			else{
				isPaused = false;
				//gameInterval = setInterval(moveBlockDown, calculateFallTime());
				changeAllSquaresVisibility(true);	
				pauseMenu.visible = false;
			}
		}
		
		function createNextBlock(){
			currentShapePoints = 0;
			drawBlockAt(5, rows + 1, nextShape, 0);
			setNextShape();
		}
		
		function drawBlockAt(col, row, shape, _rotation = 0, drawNewSquares = true){
			currentBlock.shape = shape;
			currentBlock._rotation = _rotation;
			currentBlock.col = col;
			currentBlock.row = row;
			if(drawNewSquares) currentBlock.squares = [];
			var currentBlockSquare = 0;
			var drawnRows = 0;
			var blockArray = _root["block_"+shape+"_"+_rotation];
			for(var i= blockArray.length - 1; i >=0; i--){
				for(var j=0;j<blockArray[i].length;j++){
					if(drawNewSquares){
						var square = drawSquare(col+j, row+drawnRows, blockArray[i][j]);
						currentBlock.squares.push(square);
					}
					else {
						square = drawSquare(col+j, row+drawnRows, blockArray[i][j], currentBlock.squares[currentBlockSquare]);
						currentBlockSquare++;
					}
				}
				drawnRows++;
			}
		}
		function drawSquare(col, row, type, _square = null){
			//console.log("drawSquare at "+col+" "+row+" type:"+type);
			if(_square != null) var square = _square
			else {
				square = new lib.square();
				square.bang_mc.gotoAndStop(0);
				stage.addChild(square);
			}
			square.type = type;
			square.gotoAndStop(type);
			square.col = col;
			square.row = row;
			moveSquare(square, col, row);
			return square;
		}
		
		function moveSquare(square, col, row){
			//console.log("corRow "+col+" "+row);
			square.x = gameArea.x + col * squareSize;
			square.y = gameArea.y - row * squareSize - squareSize;
			//console.log("square position "+square.x+" "+square.y);
		}
		
		function moveBlockDown(calledFromDownPressed = false){
			if(quitMenu.visible || pauseMenu.visible || isGameOver || !isGameOnFocus) return;
			if(!calledFromDownPressed && isDownPressed) return;
			var markedRows = markFullRows();
			//console.log("markedRows "+markedRows.length);
			//if there is full row delete it
			if(markedRows.length > 0){
				switch(markedRows.length){
					case 1: points += currentLevel * 40; break;
					case 2: points += currentLevel * 100; break;
					case 3: points += currentLevel * 300; break;
					case 4: points += currentLevel * 1200;
				}
				lines += markedRows.length;
				if(Math.floor(lines / 10) + 1 > currentLevel) increaseLevel();
				updateTxtFields();
				for(var i=0;i<markedRows.length;i++) deleteRow(markedRows[i]);
				reorderRows(markedRows);
				createNextBlock();
				hasFullRows = false;
			} 
			else if(!hasFullRows){
				//land the block
				if(!canBlockBePlaced(currentBlock, -1, 0)) {
					var hasGameOverSquare = landBlock(currentBlock);
					if(hasGameOverSquare){
						gameOver();
					}
					else if(markFullRows().length <= 0) {
						points += currentShapePoints;
						createNextBlock();
						updateTxtFields();
					}
					else hasFullRows = true;
				}
				else{
					//move block down
					currentShapePoints++;
					currentBlock.row--;
					drawBlockAt(currentBlock.col, currentBlock.row, currentBlock.shape, currentBlock._rotation, false);
				}	
			}
		}
		
		function updateTxtFields(){
			levelTxt.text = currentLevel;
			pointsTxt.text = points;
			linesTxt.text = lines;
		}
		
		function reorderRows(markedRows){
			var destroyedRows=0;
			var deletedRow = markedRows.shift();
			for(var i=0;i<gameBoard[0].length;i++){
				if(i == deletedRow){
					if(markedRows.length > 0) deletedRow = markedRows.shift();
					destroyedRows++;
				}
				else
				for(var j=0;j<gameBoard.length;j++){
					if(gameBoard[j][i] != null){
						var square = gameBoard[j][i];
						gameBoard[square.col][square.row] = null;
						square.row -= destroyedRows;
						gameBoard[square.col][square.row] = square;
						moveSquare(square, square.col, square.row);
					}
				}
			}
			if(destroyedRows > 0) playSound("sfx_glassbreak");
		}
		
		function printGameBoard(){
			console.log("GAME BOARD =================================");
			for(var i=gameBoard[0].length-1;i>=0;i--){
				var rowStr = "";
				for(var j=0;j<gameBoard.length;j++){
					var type = "0";
					if(gameBoard[j][i] != null) type = gameBoard[j][i].type.toString();
					rowStr += type+" ";
				}
				console.log(rowStr+"\n");
			}
			console.log("END GAME BOARD =============================");
		}
		
		function isRowEmpty(row){
			for(var i=0;i<gameBoard.length;i++){
				if(gameBoard[i][row] != null) return false;
			}
			return true;
		}
		
		function deleteRow(row){
			for(var i = row; i<gameBoard[0].length;i++){
				for(var j=0;j<gameBoard.length;j++){
					if(gameBoard[j][i] != null){
						var square = gameBoard[j][i];
						if(i == row){
							stage.removeChild(square);
							square = null;
							gameBoard[j][i] = null;
						}
					}
				}
			}
		}
		
		function landBlock(block){
			playSound("sfx_latch");
			var hasGameOverSquare = false;
			while(block.squares.length > 0){
				var square = block.squares.pop();
				if(square.type != 0) {
					if(gameBoard[square.col][square.row] != null){
						console.log("GameBoard "+square.col+"|"+square.row+" is not empty!");
						square.parent.removeChild(square);
					}
					else{
						gameBoard[square.col][square.row] = square;
						if(square.row > rows) hasGameOverSquare = true;
					}
				}
			}
			currentBlock = null;
			currentBlock = {};
			return hasGameOverSquare;
		}
		
		function markFullRows(){
			var markedRows = [];	
			for(var i=0;i<gameBoard[0].length;i++){
				var fullSquares = 0;	
				for(var j=0;j<gameBoard.length;j++){
					if(gameBoard[j][i] == null) continue;
					fullSquares++;
				}
				if(fullSquares == gameBoard.length) markedRows.push(i);
			}
			//make them blink
			for(var i=0;i<markedRows.length;i++){
				for(var j=0;j<gameBoard.length;j++){
					var square = gameBoard[j][markedRows[i]];
					square.bang_mc.gotoAndPlay(0);
				}
			}
			return markedRows;
		}
		
		function rotateBlock(rot){
			playSound("sfx_lever");
			var newRotation = currentBlock._rotation + rot;
			if(newRotation > 3) newRotation = 0;
			if(newRotation < 0) newRotation = 3;
			var clone = getBlockClone(currentBlock.shape, currentBlock._rotation, currentBlock.col, currentBlock.row);
			if(canBlockBePlaced(clone, 0, 0)){
				currentBlock._rotation = newRotation;
				drawBlockAt(currentBlock.col, currentBlock.row, currentBlock.shape, currentBlock._rotation, false);
			}	
		}
		
		function getBlockClone(shape, _rotation, col, row){
			var clone = {};
			clone.squares = [];
			var blockArray = _root["block_"+shape+"_"+_rotation];
			var drawnRows = 0;
		    for(var i=0;i<blockArray.length;i++){
				for(var j=0;j<blockArray[i].length;j++){
					var square = {};
					square.type = blockArray[i];
					square.col = col + j;
					square.row = row + drawnRows;
					clone.squares.push(square);
				}
				drawnRows++;
			}
			return clone;
		}
		
		function canBlockBePlaced(block, vMovement, hMovement){
			for(var i=0;i<block.squares.length;i++){
				var square = block.squares[i];
				if(square.type != 0){
					if(square.row + vMovement < 0) return false;
					if(square.col + hMovement < 0) return false;
					if(square.col + hMovement >= cols) return false;
					if(gameBoard[square.col + hMovement][square.row+vMovement] != null) {
						return false;
					}
				}
			}
			return true;
		}
		
		function moveBlockLeft(){
			console.log("moveLeft");
			if(canBlockBePlaced(currentBlock, 0, -1)) {
				currentBlock.col--;
				drawBlockAt(currentBlock.col, currentBlock.row, currentBlock.shape, currentBlock._rotation, false);
			}
		}
		
		function moveBlockRight(){
			if(canBlockBePlaced(currentBlock, 0, 1)){
				currentBlock.col++;
				drawBlockAt(currentBlock.col, currentBlock.row, currentBlock.shape, currentBlock._rotation, false);
			}
		}
		
		var gom = this.gameOverMenu;
		gom.parent.removeChild(gom);
		stage.addChild(gom);
		gom.visible = false;
		
		if(!gom.submitScoreButton.hasEventListener("click"))
			gom.submitScoreButton.addEventListener("click", onSubmitScoreClicked);
		if(!gom.mainMenuButton.hasEventListener("click"))
			gom.mainMenuButton.addEventListener("click", onMainMenuClicked);
		
		function onSubmitScoreClicked(){
			playSound("sfx_click");
			clearInterval(gameInterval);
			removeAllSquares();
			removeAllButtonListeners();
			gom.visible = false;
			_root.gotoAndStop("submitScore");
		}
		
		function onMainMenuClicked(){
			playSound("sfx_click");
			clearInterval(gameInterval);
			removeAllSquares();
			removeAllButtonListeners();
			gom.visible = false;
			_root.gotoAndStop("mainMenu");
		}
		
		function gameOver(){
			console.log("Game over!");
			stage.removeEventListener("mousedown", onMouseDown);
			stage.removeEventListener("stagemouseup", onMouseUp);
			stage.removeEventListener("stagemousemove", onMouseMove);
			playSound("sfx_gameover");
			_root.points = points;
			isGameOver = true;
			clearInterval(gameInterval);
			gom.visible = true;
			gom.parent.stop();
			gom.parent.setChildIndex(gom, gom.parent.numChildren - 1);
		}
		
		function createEmptyGameBoard(){
			gameBoard = [];
			for(var i=0;i<cols;i++){
				gameBoard[i] = [];
				for(var j=0;j<rows;j++){
					gameBoard[i][j] = null;
				}
			}
		}
		
		var gameOriginalWidth = 382;
		var gameOriginalHeight = 380;
		
		var stageScaleX = gameOriginalWidth / stage.canvas.width;
		var stageScaleY = gameOriginalHeight / stage.canvas.height;
		
		createjs.Touch.enable(stage);
		stage.mouseMoveOutside = true;
		
		stage.addEventListener("mousedown", onMouseDown);
		stage.on("stagemouseup", onMouseUp);
		stage.on("stagemousemove", onMouseMove);
		createjs.Ticker.addEventListener("tick", onTick);
		
		var mouseStartX;
		var mouseStartY;
		var minSwipeLength = 2;
		var minSwipeDownLength = 30;
		var gameAreaClick = false;
		
		function onMouseDown(e){
			console.log("mouse down");
			if(quitMenu.visible || pauseMenu.visible || isGameOver || !isGameOnFocus) return;
			if(e.stageX * stageScaleX > 0 && e.stageX * stageScaleX <= 220) {
				gameAreaClick = true;
				currentBlock.canBeSmashed = true;
				mouseStartX = e.stageX * stageScaleX;
				mouseStartY = e.stageY * stageScaleY;	
			}
		}
		
		function onMouseMove(e){
			console.log("mouse move");
			if(quitMenu.visible || pauseMenu.visible || isGameOver || !isGameOnFocus) return;
			if(!gameAreaClick) return;
			var mouse_x = e.stageX * stageScaleX;
			var mouse_y = e.stageY * stageScaleY;
		
			//square.x = gameArea.x + col * squareSize;
			//square.y = gameArea.y - row * squareSize - squareSize;
			
			console.log("startY "+mouseStartY+" mouse_y "+mouse_y);
			console.log("y diff is "+Math.abs(mouse_y - mouseStartY));	
			
			if(Math.abs(mouse_y - mouseStartY) > minSwipeDownLength){
				if(currentBlock.squares)
				if(canBlockBePlaced(currentBlock, -1, 0) && currentBlock.canBeSmashed == true){
					currentBlock.canBeSmashed = false;
					/*
					while(canBlockBePlaced(currentBlock, -1, 0)){
						currentBlock.row--;
						drawBlockAt(currentBlock.col, currentBlock.row, currentBlock.shape, currentBlock._rotation, false);
					}
					return;
					*/
					isDownPressed = true;
				}
				return;
			}
			mouseStartY = e.stageY * stageScaleY;
			
			if(Math.abs(mouse_x - mouseStartX) > minSwipeLength){
				var mouseCol = (mouse_x - gameArea.x - squareSize) / squareSize;
				mouseCol = Math.floor(mouseCol);
				
		
				if(currentBlock.col > mouseCol) moveBlockLeft();
				else if(currentBlock.col < mouseCol) moveBlockRight();	
			}
		}
		
		function onTick(){
			if(isDownPressed){
				if(downFrames <= 0){
					moveBlockDown(true);
					downFrames = downFramesO;
				}
				else downFrames--;	
			}
		}
		
		function onMouseUp(e){
			console.log("mouse up");
			if(!gameAreaClick || quitMenu.visible || pauseMenu.visible || isGameOver || !isGameOnFocus) return;
			isDownPressed = false;
			var mouse_x = e.stageX * stageScaleX;
			var mouse_y = e.stageY * stageScaleY;	
			if(Math.abs(mouse_x - mouseStartX) < minSwipeLength && Math.abs(mouse_y - mouseStartY) < minSwipeLength) rotateBlock(1);
		}
		
		function removeAllButtonListeners(){
			createjs.Ticker.addEventListener("tick", onTick);
			pauseBtn.removeEventListener("click", onPauseBtnClicked);
			quitBtn.removeEventListener("click", onQuitBtnClicked);
			quitMenu.yesBtn.removeEventListener("click", onQuitYesClicked);
			quitMenu.noBtn.removeEventListener("click", onQuitNoClicked);
			gom.submitScoreButton.removeEventListener("click", onSubmitScoreClicked);
			gom.mainMenuButton.removeEventListener("click", onMainMenuClicked);
		}
		
		//===========================================================
		document.onkeydown = handleKeyDown;
		document.onkeyup = handleKeyUp;
		
		var downFrames = 0;
		var downFramesO = 1;
		var isDownPressed = false;
		
		function handleKeyDown(e){
			if(!e){var e = window.event;};
			switch(e.keyCode){
				case 80:
					//pause
					pauseGame();
				break;
				case 32:
					printGameBoard();
				break;
				case 37:
					//LEFT
					moveBlockLeft();
				break;
				case 39:
					//RIGHT
					moveBlockRight();
				break;
				case 38:
					//UP
					rotateBlock(1);
				break;
				case 40:
					//down
					isDownPressed = true;
					if(downFrames <= 0){
						moveBlockDown(true);
						downFrames = downFramesO;
					}
					else downFrames--;		
				break;
				case 88:
					//X
					rotateBlock(1);
				break;
				case 90:
					//Z
					rotateBlock(-1);
				break;
			}
		}
		
		function handleKeyUp(e){
			if(!e){var e = window.event;};
			switch(e.keyCode){
				case 37:
					//LEFT
					
				break;
				case 39:
					//RIGHT
					
				break;
				case 38:
					//UP
					
				break;
				case 40:
					//DOWN
					isDownPressed = false;
				break;
			}
		}
		
		function randomInteger(min, max) {
		   return Math.floor(Math.random() * (max - min + 1)) + min;
		}
	}
	this.frame_3 = function() {
		var _root = this;
		
		showInputFields();
		
		createjs.Ticker.addEventListener('tick', onTickEvent);
		
		function onTickEvent(){
			var username = document.getElementById("username_input").value;
			var email = document.getElementById("email_input").value;
			if(username != "" || email != "")
				_root.onInputChange();
		}
		
		this.onOkClicked = function(){
			//var username = $('#username_input').val();
			//var email = $('#email_input').val();
			playSound("sfx_click");
			var username = document.getElementById("username_input").value;
			var email = document.getElementById("email_input").value;
			var warningText = "";
			if(username.length < 6){
				setWarningText("Name must be at least 6 characters!");
				return;
			}
			else if(username.length > 20){
				setWarningText("Name can be max 20 characters!");
				return;
			}
			else if(!onlyLettersAndNumbers(username)){
				setWarningText("Name can contain only letters and numbers!");
				return;
			}
			else if (!IsValidEmail(email)){
				setWarningText("E-mail is not valid!");
				return;
			}
			hideInputFields();
			//removeBtnListeners();
			postScore(username, email, _root.points);
		}
		
		function postScore(username, email, score){
			var formdata = 'username=' + username + '&email=' + email + '&score=' + score + '&gamename=deathris';
			
			$.ajax({
				 type: "POST",
				 url: "http://hosting.emilythestrange.com/php/postScore.php", 
				 data: formdata,
				 cache: false,
				 success: function(html) {
					//console.log("Score submitted!"+html);
					_root.gotoAndStop("highscores");
				 },
				 fail: function(){
					
				 },
				 error: function(){
					console.log('no internet ERROR!');
					 
				 }
			});
		}
		
		this.onInputChange = function(){
			var username = document.getElementById("username_input").value;
			var email = document.getElementById("email_input").value;
			var warningText = "";
			if(username.length < 6){
				setWarningText("Name must be at least 6 characters!");
				return;
			}
			else if(username.length > 20){
				setWarningText("Name can be max 20 characters!");
				return;
			}
			else if(!onlyLettersAndNumbers(username)){
				setWarningText("Name can contain only letters and numbers!");
				return;
			}
			else if (!IsValidEmail(email)){
				setWarningText("E-mail is not valid!");
				return;
			}
			else setWarningText("");
		}
		
		function setWarningText(txt){
			$("#warningMessage").text(txt);
		}
		
		this.onBackClicked = function(){
			playSound("sfx_click");
			hideInputFields();
			//removeBtnListeners();
			_root.gotoAndStop("mainMenu");
		}
		
		this.removeBtnListeners = function(){
			createjs.Ticker.removeEventListener('tick', onTickEvent);
			//okBtn.removeEventListener('click', onOkClicked);
			//backBtn.removeEventListener('click', onBackClicked);
		}
		
		function hideInputFields(){
			$('#input_div').hide();
			$('#warningMessage').hide();
			
		}
		
		function showInputFields(){
			$('#warningMessage').show();
			$('#input_div').show();
			var windowW = window.innerWidth/2;	
			var windowH = window.innerHeight/2;	
			var newW = windowW / 2;
			var newH = windowH / 10;
			var newY = window.innerHeight/2;
			$("#input_div").css({top: newY, position:'absolute'});
		}
		
		//VALIDATION==================================================
		function onlyLettersAndNumbers(str) {
		  return /^[A-Za-z0-9]*$/.test(str);
		}
		
		const validateEmail = (email) => {
		  return email.match(
		   // /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		   
		   /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9-]+(\.[a-z0-9-]+)*$/
		   
		  );
		}
		
		function IsValidEmail(email) {
			//Check minimum valid length of an Email.
			if (email.length <= 2) {
				return false;
			}
			//If whether email has @ character.
			if (email.indexOf("@") == -1) {
				return false;
			}
		
			var parts = email.split("@");
			var dot = parts[1].indexOf(".");
			var len = parts[1].length;
			var dotSplits = parts[1].split(".");
			var dotCount = dotSplits.length - 1;
		
		
			//Check whether Dot is present, and that too minimum 1 character after @.
			if (dot == -1 || dot < 2 || dotCount > 2) {
				return false;
			}
		
			//Check whether Dot is not the last character and dots are not repeated.
			for (var i = 0; i < dotSplits.length; i++) {
				if (dotSplits[i].length == 0) {
					return false;
				}
			}
		
			return true;
		}
		
		//END VALIDATION==============================================
	}
	this.frame_4 = function() {
		var _root = this;
		
		getTop100();
		
		function getTop100(){
			var formdata = 'gamename=deathris';
			$.ajax({
				 type: "POST",
				 url: "http://hosting.emilythestrange.com/php/getTopSto.php", 
				 data: formdata,
				 cache: false,
				 success: function(html) {
					//console.log(html);
					showHighscores(html);
				 },
				 fail: function(){
					 
				 },
				 error: function(){
				 console.log('no internet ERROR!');
					 
				 }
			});
		}
		
		var highscoreArr;
		var currentHighscorePage;
		var highscoreMenu = this.highscoresMC;
		
		function showHighscores(data){
			highscoreArr = data.split("*");
			//console.log("len "+d.length);
			highscoreMenu.gotoAndStop(0);
			highscoreMenu.loadingTxt.visible = false;
			highscoreMenu.backBtn.addEventListener("click", onHighscoreBackClicked);
			highscoreMenu.scroll_left.addEventListener("click", onScrollLeft);
			highscoreMenu.scroll_right.addEventListener("click", onScrollRight);
			for(var i=1;i<11;i++){
				var pageButton = highscoreMenu["page_"+i];
				pageButton.index = i-1;
				pageButton.numberTxt.text = i;
				pageButton.addEventListener("click", onPageButtonClicked);
			}
			stage.addChild(highscoreMenu);	
			currentHighscorePage = 0;	
			displayHighscorePage(currentHighscorePage);
		}
		
		function onPageButtonClicked(e){
			playSound("sfx_click");
			var button = e.currentTarget;
			displayHighscorePage(button.index);
		}
		
		function onScrollLeft(){
			playSound("sfx_click");
			displayHighscorePage(currentHighscorePage-1);
		}
		
		function onScrollRight(){
			playSound("sfx_click");
			displayHighscorePage(currentHighscorePage+1);
		}
		
		function displayHighscorePage(pageNumber){
			if(pageNumber < 0 || pageNumber > 9) return;
			currentHighscorePage = pageNumber;
			var disAlpha = 0.30;
			if(pageNumber <= 0) highscoreMenu.scroll_left.alpha = disAlpha;
			else highscoreMenu.scroll_left.alpha = 1;
			if(pageNumber >= 9) highscoreMenu.scroll_right.alpha = disAlpha;
			else highscoreMenu.scroll_right.alpha = 1;
			for(var i=1;i<11;i++){
				var pageButton = highscoreMenu["page_"+i];
				if(i != pageNumber+1) pageButton.back.gotoAndStop(0);
				else pageButton.back.gotoAndStop(1);
			}
			var currentUser = 1;
			var startIndex = pageNumber * 20;
			var currentDataIndex = startIndex;
			var username;
			var score;
			for(var i=startIndex;i<startIndex+10;i++){
				username = "...";
				if(currentDataIndex < highscoreArr.length) username = highscoreArr[currentDataIndex];
				currentDataIndex++;
				score = "...";
				//console.log('cdi '+currentDataIndex);	
				if(currentDataIndex < highscoreArr.length) score = highscoreArr[currentDataIndex];
				currentDataIndex++;
				highscoreMenu["number_"+currentUser.toString()].text = (pageNumber * 10) + currentUser;
				highscoreMenu["username_"+currentUser.toString()].text = username;
				highscoreMenu["score_"+currentUser.toString()].text = score;
				currentUser++;
			}
		}
		
		function onHighscoreBackClicked(){
			playSound("sfx_click");
			highscoreMenu.backBtn.removeEventListener("click", onHighscoreBackClicked);
			highscoreMenu.scroll_left.removeEventListener("click", onScrollLeft);
			highscoreMenu.scroll_right.removeEventListener("click", onScrollRight);
			for(var i=1;i<11;i++){
				var pageButton = highscoreMenu["page_"+i];
				pageButton.removeEventListener("click", onPageButtonClicked);
			}
			stage.removeChild(highscoreMenu);
			highscoreMenu = null;
			_root.gotoAndStop("mainMenu");
		}
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1).call(this.frame_2).wait(1).call(this.frame_3).wait(1).call(this.frame_4).wait(1));

	// actions
	this.highscoresMC = new lib.highscoreMenu();
	this.highscoresMC.setTransform(343.1,325.25,0.9065,0.9064,0,0,0,166.8,147.5);
	this.highscoresMC._off = true;

	this.timeline.addTween(cjs.Tween.get(this.highscoresMC).wait(4).to({_off:false},0).wait(1));

	// labels
	this.instance = new lib.Path_2();
	this.instance.setTransform(191.05,82.4,0.3533,0.3533,0,0,0,393,220.3);
	this.instance.alpha = 0.6016;

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#999999").s().p("AiKCJIAAkRIEVAAIAAERg");
	this.shape.setTransform(308.5831,83.6923,0.3533,0.3533);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#E0E0E0").s().p("AixCxIgBlhIFlFhg");
	this.shape_1.setTransform(308.5742,83.6129,0.3533,0.3533);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#666666").s().p("AixiwIFjgBIgDFjg");
	this.shape_2.setTransform(308.6714,83.6658,0.3533,0.3533);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#2E0402").s().p("AjdDaIAAmzIG7AAIAAGzg");
	this.shape_3.setTransform(308.5919,83.6394,0.3533,0.3533);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#999999").s().p("AiKCJIAAkRIEVAAIAAERg");
	this.shape_4.setTransform(293.0486,83.6923,0.3533,0.3533);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#E0E0E0").s().p("AiyCxIAAlhIFkFhg");
	this.shape_5.setTransform(293.0486,83.6129,0.3533,0.3533);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#666666").s().p("AixiwIFjgBIgDFjg");
	this.shape_6.setTransform(293.1281,83.6658,0.3533,0.3533);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#2E0402").s().p("AjeDZIAAmyIG8AAIAAGyg");
	this.shape_7.setTransform(293.0486,83.6394,0.3533,0.3533);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#999999").s().p("AiKCJIAAkRIEVAAIAAERg");
	this.shape_8.setTransform(293.084,98.9353,0.3533,0.3533);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#E0E0E0").s().p("AixCxIgBlhIFkFhg");
	this.shape_9.setTransform(293.0663,98.8559,0.3533,0.3533);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#666666").s().p("AixiwIFjgBIgDFjg");
	this.shape_10.setTransform(293.1634,98.9,0.3533,0.3533);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#2E0402").s().p("AjeDZIAAmxIG9AAIAAGxg");
	this.shape_11.setTransform(293.084,98.8647,0.3533,0.3533);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#999999").s().p("AiKCJIAAkRIEVAAIAAERg");
	this.shape_12.setTransform(277.5495,98.9353,0.3533,0.3533);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#E0E0E0").s().p("AiyCxIAAlhIFlFhg");
	this.shape_13.setTransform(277.5407,98.8559,0.3533,0.3533);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#666666").s().p("AixiwIFjgBIgDFjg");
	this.shape_14.setTransform(277.629,98.9,0.3533,0.3533);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#2E0402").s().p("AjeDaIAAmyIG9AAIAAGyg");
	this.shape_15.setTransform(277.5407,98.8647,0.3533,0.3533);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("#999999").s().p("AivCtIAAlZIFfAAIAAFZg");
	this.shape_16.setTransform(169.4708,84.8316,0.3533,0.3533);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("#E0E0E0").s().p("AjgDfIgBm+IHDG/g");
	this.shape_17.setTransform(169.4531,84.7256,0.3533,0.3533);

	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f("#666666").s().p("AjgjfIHBgBIgDHBg");
	this.shape_18.setTransform(169.5679,84.7874,0.3533,0.3533);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f("#2E0402").s().p("AkYETIAAolIIxAAIAAIlg");
	this.shape_19.setTransform(169.4708,84.7521,0.3533,0.3533);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f("#999999").s().p("AivCtIAAlZIFfAAIAAFZg");
	this.shape_20.setTransform(149.8297,84.8316,0.3533,0.3533);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f("#E0E0E0").s().p("AjhDfIAAm+IHDG/g");
	this.shape_21.setTransform(149.8209,84.7256,0.3533,0.3533);

	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f("#666666").s().p("AjgjfIHBgBIgDHBg");
	this.shape_22.setTransform(149.9357,84.7874,0.3533,0.3533);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f("#2E0402").s().p("AkYETIAAolIIxAAIAAIlg");
	this.shape_23.setTransform(149.8297,84.7521,0.3533,0.3533);

	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f("#999999").s().p("AivCtIAAlZIFfAAIAAFZg");
	this.shape_24.setTransform(149.8739,104.0929,0.3533,0.3533);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f("#E0E0E0").s().p("AjhDfIAAm+IHCG/g");
	this.shape_25.setTransform(149.8562,103.9869,0.3533,0.3533);

	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f("#666666").s().p("AjgjfIHBgBIgDHBg");
	this.shape_26.setTransform(149.971,104.0487,0.3533,0.3533);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f("#2E0402").s().p("AkYETIAAolIIxAAIAAIlg");
	this.shape_27.setTransform(149.8651,104.0046,0.3533,0.3533);

	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f("#999999").s().p("AivCtIAAlZIFfAAIAAFZg");
	this.shape_28.setTransform(130.2328,104.0929,0.3533,0.3533);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f("#E0E0E0").s().p("AjhDgIAAm/IHDG/g");
	this.shape_29.setTransform(130.224,103.9869,0.3533,0.3533);

	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.f("#666666").s().p("AjgjfIHBgBIgDHBg");
	this.shape_30.setTransform(130.33,104.0487,0.3533,0.3533);

	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.f("#2E0402").s().p("AkYETIAAolIIxAAIAAIlg");
	this.shape_31.setTransform(130.224,104.0046,0.3533,0.3533);

	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.f("#8B1A11").s().p("Ah5B4IAAjvIDzAAIAADvg");
	this.shape_32.setTransform(177.4897,125.562,0.3533,0.3533);

	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.f("#E83323").s().p("AicCbIAAk2IE5E3g");
	this.shape_33.setTransform(177.4809,125.4914,0.3533,0.3533);

	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.f("#5C0E08").s().p("AicibIE5AAIgDE4g");
	this.shape_34.setTransform(177.5515,125.5355,0.3533,0.3533);

	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.f("#2E0402").s().p("AjDC/IAAl9IGGAAIAAF9g");
	this.shape_35.setTransform(177.4809,125.5002,0.3533,0.3533);

	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.f("#8B1A11").s().p("Ah5B4IAAjvID0AAIAADvg");
	this.shape_36.setTransform(163.8275,125.562,0.3533,0.3533);

	this.shape_37 = new cjs.Shape();
	this.shape_37.graphics.f("#E83323").s().p("AicCbIAAk2IE5E3g");
	this.shape_37.setTransform(163.8187,125.4914,0.3533,0.3533);

	this.shape_38 = new cjs.Shape();
	this.shape_38.graphics.f("#5C0E08").s().p("AicibIE4AAIgCE3g");
	this.shape_38.setTransform(163.8982,125.5355,0.3533,0.3533);

	this.shape_39 = new cjs.Shape();
	this.shape_39.graphics.f("#2E0402").s().p("AjDC/IAAl9IGGAAIAAF9g");
	this.shape_39.setTransform(163.8275,125.5002,0.3533,0.3533);

	this.shape_40 = new cjs.Shape();
	this.shape_40.graphics.f("#8B1A11").s().p("Ah5B4IAAjvIDzAAIAADvg");
	this.shape_40.setTransform(150.1653,125.562,0.3533,0.3533);

	this.shape_41 = new cjs.Shape();
	this.shape_41.graphics.f("#E83323").s().p("AibCbIgBk2IE5E3g");
	this.shape_41.setTransform(150.1565,125.4914,0.3533,0.3533);

	this.shape_42 = new cjs.Shape();
	this.shape_42.graphics.f("#5C0E08").s().p("AicibIE4gBIgCE4g");
	this.shape_42.setTransform(150.2448,125.5355,0.3533,0.3533);

	this.shape_43 = new cjs.Shape();
	this.shape_43.graphics.f("#2E0402").s().p("AjDC/IAAl9IGHAAIAAF9g");
	this.shape_43.setTransform(150.1742,125.5002,0.3533,0.3533);

	this.shape_44 = new cjs.Shape();
	this.shape_44.graphics.f("#8B1A11").s().p("Ah5B4IAAjvIDzAAIAADvg");
	this.shape_44.setTransform(136.512,125.562,0.3533,0.3533);

	this.shape_45 = new cjs.Shape();
	this.shape_45.graphics.f("#E83323").s().p("AibCbIgBk2IE5E3g");
	this.shape_45.setTransform(136.5031,125.4914,0.3533,0.3533);

	this.shape_46 = new cjs.Shape();
	this.shape_46.graphics.f("#5C0E08").s().p("AicibIE5gBIgDE4g");
	this.shape_46.setTransform(136.5826,125.5355,0.3533,0.3533);

	this.shape_47 = new cjs.Shape();
	this.shape_47.graphics.f("#2E0402").s().p("AjDC/IAAl9IGHAAIAAF9g");
	this.shape_47.setTransform(136.512,125.5002,0.3533,0.3533);

	this.shape_48 = new cjs.Shape();
	this.shape_48.graphics.f("#8B1A11").s().p("AivCtIAAlZIFfAAIAAFZg");
	this.shape_48.setTransform(249.6246,21.7665,0.3533,0.3533);

	this.shape_49 = new cjs.Shape();
	this.shape_49.graphics.f("#E83323").s().p("AjhDgIAAm/IHDG/g");
	this.shape_49.setTransform(249.6158,21.6605,0.3533,0.3533);

	this.shape_50 = new cjs.Shape();
	this.shape_50.graphics.f("#5C0E08").s().p("AjgjfIHBgBIgDHBg");
	this.shape_50.setTransform(249.7306,21.7224,0.3533,0.3533);

	this.shape_51 = new cjs.Shape();
	this.shape_51.graphics.f("#2E0402").s().p("AkYETIAAolIIxAAIAAIlg");
	this.shape_51.setTransform(249.6246,21.687,0.3533,0.3533);

	this.shape_52 = new cjs.Shape();
	this.shape_52.graphics.f("#8B1A11").s().p("AivCtIAAlZIFfAAIAAFZg");
	this.shape_52.setTransform(229.9836,21.7665,0.3533,0.3533);

	this.shape_53 = new cjs.Shape();
	this.shape_53.graphics.f("#E83323").s().p("AjhDfIAAm+IHCG/g");
	this.shape_53.setTransform(229.9747,21.6605,0.3533,0.3533);

	this.shape_54 = new cjs.Shape();
	this.shape_54.graphics.f("#5C0E08").s().p("AjgjfIHBgBIgDHBg");
	this.shape_54.setTransform(230.0895,21.7224,0.3533,0.3533);

	this.shape_55 = new cjs.Shape();
	this.shape_55.graphics.f("#2E0402").s().p("AkYETIAAolIIxAAIAAIlg");
	this.shape_55.setTransform(229.9836,21.687,0.3533,0.3533);

	this.shape_56 = new cjs.Shape();
	this.shape_56.graphics.f("#8B1A11").s().p("AivCtIAAlZIFfAAIAAFZg");
	this.shape_56.setTransform(210.3425,21.7665,0.3533,0.3533);

	this.shape_57 = new cjs.Shape();
	this.shape_57.graphics.f("#E83323").s().p("AjhDgIAAm/IHCG/g");
	this.shape_57.setTransform(210.3337,21.6605,0.3533,0.3533);

	this.shape_58 = new cjs.Shape();
	this.shape_58.graphics.f("#5C0E08").s().p("AjgjfIHBgBIgDHBg");
	this.shape_58.setTransform(210.4485,21.7224,0.3533,0.3533);

	this.shape_59 = new cjs.Shape();
	this.shape_59.graphics.f("#2E0402").s().p("AkYETIAAolIIxAAIAAIlg");
	this.shape_59.setTransform(210.3425,21.687,0.3533,0.3533);

	this.shape_60 = new cjs.Shape();
	this.shape_60.graphics.f("#8B1A11").s().p("AivCtIAAlZIFfAAIAAFZg");
	this.shape_60.setTransform(190.7103,21.7665,0.3533,0.3533);

	this.shape_61 = new cjs.Shape();
	this.shape_61.graphics.f("#E83323").s().p("AjgDfIAAm+IHCG/g");
	this.shape_61.setTransform(190.6926,21.6605,0.3533,0.3533);

	this.shape_62 = new cjs.Shape();
	this.shape_62.graphics.f("#5C0E08").s().p("AjgjfIHBgBIgDHBg");
	this.shape_62.setTransform(190.8075,21.7224,0.3533,0.3533);

	this.shape_63 = new cjs.Shape();
	this.shape_63.graphics.f("#2E0402").s().p("AkYETIAAolIIxAAIAAIlg");
	this.shape_63.setTransform(190.7015,21.687,0.3533,0.3533);

	this.shape_64 = new cjs.Shape();
	this.shape_64.graphics.f("#E83323").s().p("AivCtIAAlZIFfAAIAAFZg");
	this.shape_64.setTransform(103.4913,75.5851,0.3533,0.3533);

	this.shape_65 = new cjs.Shape();
	this.shape_65.graphics.f("#EC706B").s().p("AjgDfIgBm+IHDG/g");
	this.shape_65.setTransform(103.4825,75.4791,0.3533,0.3533);

	this.shape_66 = new cjs.Shape();
	this.shape_66.graphics.f("#BA271A").s().p("AjgjfIHBgBIgEHBg");
	this.shape_66.setTransform(103.5973,75.5498,0.3533,0.3533);

	this.shape_67 = new cjs.Shape();
	this.shape_67.graphics.f("#2E0402").s().p("AkYETIAAolIIxAAIAAIlg");
	this.shape_67.setTransform(103.5002,75.5056,0.3533,0.3533);

	this.shape_68 = new cjs.Shape();
	this.shape_68.graphics.f("#E83323").s().p("AivCtIAAlZIFfAAIAAFZg");
	this.shape_68.setTransform(103.4913,111.37,0.3533,0.3533);

	this.shape_69 = new cjs.Shape();
	this.shape_69.graphics.f("#EC706B").s().p("AjgDfIgBm+IHDG/g");
	this.shape_69.setTransform(103.4825,111.2728,0.3533,0.3533);

	this.shape_70 = new cjs.Shape();
	this.shape_70.graphics.f("#BA271A").s().p("AjgjfIHBgBIgEHBg");
	this.shape_70.setTransform(103.5973,111.3346,0.3533,0.3533);

	this.shape_71 = new cjs.Shape();
	this.shape_71.graphics.f("#2E0402").s().p("AkYETIAAolIIxAAIAAIlg");
	this.shape_71.setTransform(103.5002,111.2993,0.3533,0.3533);

	this.shape_72 = new cjs.Shape();
	this.shape_72.graphics.f("#E83323").s().p("AivCtIAAlZIFfAAIAAFZg");
	this.shape_72.setTransform(121.8253,93.6718,0.3533,0.3533);

	this.shape_73 = new cjs.Shape();
	this.shape_73.graphics.f("#EC706B").s().p("AjgDgIAAm/IHCG/g");
	this.shape_73.setTransform(121.8077,93.5659,0.3533,0.3533);

	this.shape_74 = new cjs.Shape();
	this.shape_74.graphics.f("#BA271A").s().p("AjgjfIHBgBIgDHBg");
	this.shape_74.setTransform(121.9225,93.6365,0.3533,0.3533);

	this.shape_75 = new cjs.Shape();
	this.shape_75.graphics.f("#2E0402").s().p("AkYETIAAolIIxAAIAAIlg");
	this.shape_75.setTransform(121.8165,93.5923,0.3533,0.3533);

	this.shape_76 = new cjs.Shape();
	this.shape_76.graphics.f("#E83323").s().p("AivCtIAAlZIFfAAIAAFZg");
	this.shape_76.setTransform(85.4841,93.6718,0.3533,0.3533);

	this.shape_77 = new cjs.Shape();
	this.shape_77.graphics.f("#EC706B").s().p("AjhDgIAAm/IHCG/g");
	this.shape_77.setTransform(85.4753,93.5659,0.3533,0.3533);

	this.shape_78 = new cjs.Shape();
	this.shape_78.graphics.f("#BA271A").s().p("AjgjfIHBgBIgDHBg");
	this.shape_78.setTransform(85.5901,93.6365,0.3533,0.3533);

	this.shape_79 = new cjs.Shape();
	this.shape_79.graphics.f("#2E0402").s().p("AkYETIAAolIIxAAIAAIlg");
	this.shape_79.setTransform(85.4841,93.5923,0.3533,0.3533);

	this.shape_80 = new cjs.Shape();
	this.shape_80.graphics.f("#FFCCFF").s().p("AhWBZIAAixICuAAIAACxg");
	this.shape_80.setTransform(130.6567,126.9486,0.3533,0.3533);

	this.shape_81 = new cjs.Shape();
	this.shape_81.graphics.f("#FFFFFF").s().p("AhwhxIDhAAIjhDjg");
	this.shape_81.setTransform(130.7009,126.9486,0.3533,0.3533);

	this.shape_82 = new cjs.Shape();
	this.shape_82.graphics.f("#BE6C97").s().p("AhxBwIDijhIABDjg");
	this.shape_82.setTransform(130.6656,127.0104,0.3533,0.3533);

	this.shape_83 = new cjs.Shape();
	this.shape_83.graphics.f("#2E0402").s().p("AiKCOIAAkbIEVAAIAAEbg");
	this.shape_83.setTransform(130.6921,126.9486,0.3533,0.3533);

	this.shape_84 = new cjs.Shape();
	this.shape_84.graphics.f("#FFCCFF").s().p("AhWBZIAAixICuAAIAACxg");
	this.shape_84.setTransform(130.6567,117.0221,0.3533,0.3533);

	this.shape_85 = new cjs.Shape();
	this.shape_85.graphics.f("#FFFFFF").s().p("AhwhxIDhAAIjhDjg");
	this.shape_85.setTransform(130.7009,117.0221,0.3533,0.3533);

	this.shape_86 = new cjs.Shape();
	this.shape_86.graphics.f("#BE6C97").s().p("AhxBwIDijhIABDjg");
	this.shape_86.setTransform(130.6656,117.0839,0.3533,0.3533);

	this.shape_87 = new cjs.Shape();
	this.shape_87.graphics.f("#2E0402").s().p("AiKCOIAAkbIEVAAIAAEbg");
	this.shape_87.setTransform(130.6921,117.0309,0.3533,0.3533);

	this.shape_88 = new cjs.Shape();
	this.shape_88.graphics.f("#FFCCFF").s().p("AhXBZIAAixICvAAIAACxg");
	this.shape_88.setTransform(120.9245,126.9751,0.3533,0.3533);

	this.shape_89 = new cjs.Shape();
	this.shape_89.graphics.f("#FFFFFF").s().p("AhwhxIDhAAIjhDjg");
	this.shape_89.setTransform(120.9687,126.9662,0.3533,0.3533);

	this.shape_90 = new cjs.Shape();
	this.shape_90.graphics.f("#BE6C97").s().p("AhxBwIDijhIABDjg");
	this.shape_90.setTransform(120.9334,127.028,0.3533,0.3533);

	this.shape_91 = new cjs.Shape();
	this.shape_91.graphics.f("#2E0402").s().p("AiKCOIAAkbIEVAAIAAEbg");
	this.shape_91.setTransform(120.9599,126.9751,0.3533,0.3533);

	this.shape_92 = new cjs.Shape();
	this.shape_92.graphics.f("#FFCCFF").s().p("AhXBZIAAixICvAAIAACxg");
	this.shape_92.setTransform(120.9245,117.0486,0.3533,0.3533);

	this.shape_93 = new cjs.Shape();
	this.shape_93.graphics.f("#FFFFFF").s().p("AhwhxIDhAAIjhDjg");
	this.shape_93.setTransform(120.9687,117.0397,0.3533,0.3533);

	this.shape_94 = new cjs.Shape();
	this.shape_94.graphics.f("#BE6C97").s().p("AhxBwIDijhIABDjg");
	this.shape_94.setTransform(120.9334,117.1015,0.3533,0.3533);

	this.shape_95 = new cjs.Shape();
	this.shape_95.graphics.f("#2E0402").s().p("AiKCOIAAkbIEVAAIAAEbg");
	this.shape_95.setTransform(120.9599,117.0486,0.3533,0.3533);

	this.shape_96 = new cjs.Shape();
	this.shape_96.graphics.f("#FFCCFF").s().p("AisCwIAAlfIFZAAIAAFfg");
	this.shape_96.setTransform(210.422,74.649,0.3533,0.3533);

	this.shape_97 = new cjs.Shape();
	this.shape_97.graphics.f("#FFFFFF").s().p("AjejgIG+gBIm/HDg");
	this.shape_97.setTransform(210.528,74.6402,0.3533,0.3533);

	this.shape_98 = new cjs.Shape();
	this.shape_98.graphics.f("#BE6C97").s().p("AjgDdIHAm9IABHBg");
	this.shape_98.setTransform(210.4662,74.755,0.3533,0.3533);

	this.shape_99 = new cjs.Shape();
	this.shape_99.graphics.f("#2E0402").s().p("AkSEZIAAoxIIlAAIAAIxg");
	this.shape_99.setTransform(210.5015,74.6578,0.3533,0.3533);

	this.shape_100 = new cjs.Shape();
	this.shape_100.graphics.f("#FFCCFF").s().p("AisCwIAAlfIFZAAIAAFfg");
	this.shape_100.setTransform(210.422,55.0079,0.3533,0.3533);

	this.shape_101 = new cjs.Shape();
	this.shape_101.graphics.f("#FFFFFF").s().p("AjejgIG+gBIm/HDg");
	this.shape_101.setTransform(210.528,54.9991,0.3533,0.3533);

	this.shape_102 = new cjs.Shape();
	this.shape_102.graphics.f("#BE6C97").s().p("AjgDeIHAm+IABHBg");
	this.shape_102.setTransform(210.4662,55.1139,0.3533,0.3533);

	this.shape_103 = new cjs.Shape();
	this.shape_103.graphics.f("#2E0402").s().p("AkSEZIAAoxIIlAAIAAIxg");
	this.shape_103.setTransform(210.5015,55.0168,0.3533,0.3533);

	this.shape_104 = new cjs.Shape();
	this.shape_104.graphics.f("#FFCCFF").s().p("AisCwIAAlfIFZAAIAAFfg");
	this.shape_104.setTransform(191.1695,74.6931,0.3533,0.3533);

	this.shape_105 = new cjs.Shape();
	this.shape_105.graphics.f("#FFFFFF").s().p("AjfjgIG/AAIm/HBg");
	this.shape_105.setTransform(191.2755,74.6843,0.3533,0.3533);

	this.shape_106 = new cjs.Shape();
	this.shape_106.graphics.f("#BE6C97").s().p("AjgDeIHAm+IABHBg");
	this.shape_106.setTransform(191.2049,74.7991,0.3533,0.3533);

	this.shape_107 = new cjs.Shape();
	this.shape_107.graphics.f("#2E0402").s().p("AkSEZIAAoxIIlAAIAAIxg");
	this.shape_107.setTransform(191.2402,74.6931,0.3533,0.3533);

	this.shape_108 = new cjs.Shape();
	this.shape_108.graphics.f("#FFCCFF").s().p("AisCwIAAlfIFZAAIAAFfg");
	this.shape_108.setTransform(191.1695,55.0609,0.3533,0.3533);

	this.shape_109 = new cjs.Shape();
	this.shape_109.graphics.f("#FFFFFF").s().p("AjfjhIG/AAIm/HCg");
	this.shape_109.setTransform(191.2755,55.0433,0.3533,0.3533);

	this.shape_110 = new cjs.Shape();
	this.shape_110.graphics.f("#BE6C97").s().p("AjgDeIHAm+IABHBg");
	this.shape_110.setTransform(191.2049,55.1581,0.3533,0.3533);

	this.shape_111 = new cjs.Shape();
	this.shape_111.graphics.f("#2E0402").s().p("AkSEZIAAoxIIlAAIAAIxg");
	this.shape_111.setTransform(191.2402,55.0521,0.3533,0.3533);

	this.shape_112 = new cjs.Shape();
	this.shape_112.graphics.f("#999999").s().p("Ah+CBIAAkBID9AAIAAEBg");
	this.shape_112.setTransform(86.4114,66.3033,0.3533,0.3533);

	this.shape_113 = new cjs.Shape();
	this.shape_113.graphics.f("#E0E0E0").s().p("AijikIFIAAIlJFKg");
	this.shape_113.setTransform(86.4821,66.2945,0.3533,0.3533);

	this.shape_114 = new cjs.Shape();
	this.shape_114.graphics.f("#666666").s().p("AikCjIFIlHIABFJg");
	this.shape_114.setTransform(86.4379,66.374,0.3533,0.3533);

	this.shape_115 = new cjs.Shape();
	this.shape_115.graphics.f("#2E0402").s().p("AjJDOIAAmbIGTAAIAAGbg");
	this.shape_115.setTransform(86.4732,66.3033,0.3533,0.3533);

	this.shape_116 = new cjs.Shape();
	this.shape_116.graphics.f("#999999").s().p("Ah+CBIAAkBID9AAIAAEBg");
	this.shape_116.setTransform(86.4114,51.8905,0.3533,0.3533);

	this.shape_117 = new cjs.Shape();
	this.shape_117.graphics.f("#E0E0E0").s().p("AijikIFIAAIlJFKg");
	this.shape_117.setTransform(86.4821,51.8816,0.3533,0.3533);

	this.shape_118 = new cjs.Shape();
	this.shape_118.graphics.f("#666666").s().p("AikCjIFIlHIABFJg");
	this.shape_118.setTransform(86.4379,51.9611,0.3533,0.3533);

	this.shape_119 = new cjs.Shape();
	this.shape_119.graphics.f("#2E0402").s().p("AjJDOIAAmbIGTAAIAAGbg");
	this.shape_119.setTransform(86.4732,51.8905,0.3533,0.3533);

	this.shape_120 = new cjs.Shape();
	this.shape_120.graphics.f("#999999").s().p("Ah+CBIAAkBID9AAIAAEBg");
	this.shape_120.setTransform(72.2812,51.9169,0.3533,0.3533);

	this.shape_121 = new cjs.Shape();
	this.shape_121.graphics.f("#E0E0E0").s().p("AijilIFHAAIlIFKg");
	this.shape_121.setTransform(72.3518,51.9169,0.3533,0.3533);

	this.shape_122 = new cjs.Shape();
	this.shape_122.graphics.f("#666666").s().p("AikCjIFIlHIABFJg");
	this.shape_122.setTransform(72.3077,51.9964,0.3533,0.3533);

	this.shape_123 = new cjs.Shape();
	this.shape_123.graphics.f("#2E0402").s().p("AjJDOIAAmbIGTAAIAAGbg");
	this.shape_123.setTransform(72.343,51.9169,0.3533,0.3533);

	this.shape_124 = new cjs.Shape();
	this.shape_124.graphics.f("#999999").s().p("Ah+CBIAAkBID9AAIAAEBg");
	this.shape_124.setTransform(72.2812,37.5041,0.3533,0.3533);

	this.shape_125 = new cjs.Shape();
	this.shape_125.graphics.f("#E0E0E0").s().p("AijilIFHAAIlIFKg");
	this.shape_125.setTransform(72.3518,37.5041,0.3533,0.3533);

	this.shape_126 = new cjs.Shape();
	this.shape_126.graphics.f("#666666").s().p("AikCjIFIlHIABFJg");
	this.shape_126.setTransform(72.3077,37.5836,0.3533,0.3533);

	this.shape_127 = new cjs.Shape();
	this.shape_127.graphics.f("#2E0402").s().p("AjJDOIAAmcIGTAAIAAGcg");
	this.shape_127.setTransform(72.343,37.5041,0.3533,0.3533);

	this.shape_128 = new cjs.Shape();
	this.shape_128.graphics.f("#999999").s().p("AisCwIAAlfIFZAAIAAFfg");
	this.shape_128.setTransform(260.0015,141.5557,0.3533,0.3533);

	this.shape_129 = new cjs.Shape();
	this.shape_129.graphics.f("#E0E0E0").s().p("AjfjhIG/AAIm/HDg");
	this.shape_129.setTransform(260.1075,141.538,0.3533,0.3533);

	this.shape_130 = new cjs.Shape();
	this.shape_130.graphics.f("#666666").s().p("AjgDeIHAm+IABHBg");
	this.shape_130.setTransform(260.0368,141.6529,0.3533,0.3533);

	this.shape_131 = new cjs.Shape();
	this.shape_131.graphics.f("#2E0402").s().p("AkSEZIAAoxIIlAAIAAIxg");
	this.shape_131.setTransform(260.081,141.5469,0.3533,0.3533);

	this.shape_132 = new cjs.Shape();
	this.shape_132.graphics.f("#999999").s().p("AisCwIAAlfIFZAAIAAFfg");
	this.shape_132.setTransform(260.0015,121.9147,0.3533,0.3533);

	this.shape_133 = new cjs.Shape();
	this.shape_133.graphics.f("#E0E0E0").s().p("AjfjgIG/AAIm/HBg");
	this.shape_133.setTransform(260.1075,121.897,0.3533,0.3533);

	this.shape_134 = new cjs.Shape();
	this.shape_134.graphics.f("#666666").s().p("AjgDeIHAm+IABHBg");
	this.shape_134.setTransform(260.0368,122.0118,0.3533,0.3533);

	this.shape_135 = new cjs.Shape();
	this.shape_135.graphics.f("#2E0402").s().p("AkSEZIAAoxIIlAAIAAIxg");
	this.shape_135.setTransform(260.081,121.9058,0.3533,0.3533);

	this.shape_136 = new cjs.Shape();
	this.shape_136.graphics.f("#999999").s().p("AisCwIAAlfIFZAAIAAFfg");
	this.shape_136.setTransform(240.7402,121.95,0.3533,0.3533);

	this.shape_137 = new cjs.Shape();
	this.shape_137.graphics.f("#E0E0E0").s().p("AjejgIG+gBIm/HDg");
	this.shape_137.setTransform(240.8462,121.9412,0.3533,0.3533);

	this.shape_138 = new cjs.Shape();
	this.shape_138.graphics.f("#666666").s().p("AjgDeIHAm+IABHBg");
	this.shape_138.setTransform(240.7844,122.056,0.3533,0.3533);

	this.shape_139 = new cjs.Shape();
	this.shape_139.graphics.f("#2E0402").s().p("AkSEZIAAoxIIlAAIAAIxg");
	this.shape_139.setTransform(240.8197,121.9588,0.3533,0.3533);

	this.shape_140 = new cjs.Shape();
	this.shape_140.graphics.f("#999999").s().p("AisCwIAAlfIFZAAIAAFfg");
	this.shape_140.setTransform(240.7402,102.3089,0.3533,0.3533);

	this.shape_141 = new cjs.Shape();
	this.shape_141.graphics.f("#E0E0E0").s().p("AjejgIG+gBIm/HDg");
	this.shape_141.setTransform(240.8462,102.3001,0.3533,0.3533);

	this.shape_142 = new cjs.Shape();
	this.shape_142.graphics.f("#666666").s().p("AjgDdIHAm9IABHBg");
	this.shape_142.setTransform(240.7844,102.4149,0.3533,0.3533);

	this.shape_143 = new cjs.Shape();
	this.shape_143.graphics.f("#2E0402").s().p("AkSEZIAAoxIIlAAIAAIxg");
	this.shape_143.setTransform(240.8197,102.3178,0.3533,0.3533);

	this.shape_144 = new cjs.Shape();
	this.shape_144.graphics.f("#FFFFFF").s().p("AisCwIAAlfIFZAAIAAFfg");
	this.shape_144.setTransform(159.0409,108.1907,0.3533,0.3533);

	this.shape_145 = new cjs.Shape();
	this.shape_145.graphics.f("#E0E0E0").s().p("AjejgIG+gBIm/HDg");
	this.shape_145.setTransform(159.138,108.1818,0.3533,0.3533);

	this.shape_146 = new cjs.Shape();
	this.shape_146.graphics.f("#999999").s().p("AjgDdIHAm9IABHBg");
	this.shape_146.setTransform(159.0762,108.2966,0.3533,0.3533);

	this.shape_147 = new cjs.Shape();
	this.shape_147.graphics.f("#2E0402").s().p("AkSEaIAAoyIIlAAIAAIyg");
	this.shape_147.setTransform(159.1115,108.1907,0.3533,0.3533);

	this.shape_148 = new cjs.Shape();
	this.shape_148.graphics.f("#FFFFFF").s().p("AisCwIAAlfIFZAAIAAFfg");
	this.shape_148.setTransform(159.0409,88.5496,0.3533,0.3533);

	this.shape_149 = new cjs.Shape();
	this.shape_149.graphics.f("#E0E0E0").s().p("AjejgIG+gBIm/HDg");
	this.shape_149.setTransform(159.138,88.5408,0.3533,0.3533);

	this.shape_150 = new cjs.Shape();
	this.shape_150.graphics.f("#999999").s().p("AjgDdIHAm9IABHBg");
	this.shape_150.setTransform(159.0762,88.6556,0.3533,0.3533);

	this.shape_151 = new cjs.Shape();
	this.shape_151.graphics.f("#2E0402").s().p("AkSEZIAAoxIIlAAIAAIxg");
	this.shape_151.setTransform(159.1115,88.5584,0.3533,0.3533);

	this.shape_152 = new cjs.Shape();
	this.shape_152.graphics.f("#FFFFFF").s().p("AisCwIAAlfIFZAAIAAFfg");
	this.shape_152.setTransform(139.7708,88.5938,0.3533,0.3533);

	this.shape_153 = new cjs.Shape();
	this.shape_153.graphics.f("#E0E0E0").s().p("AjejgIG+AAIm/HCg");
	this.shape_153.setTransform(139.8767,88.5849,0.3533,0.3533);

	this.shape_154 = new cjs.Shape();
	this.shape_154.graphics.f("#999999").s().p("AjgDeIHAm+IABHBg");
	this.shape_154.setTransform(139.8149,88.6997,0.3533,0.3533);

	this.shape_155 = new cjs.Shape();
	this.shape_155.graphics.f("#2E0402").s().p("AkSEZIAAoxIIlAAIAAIxg");
	this.shape_155.setTransform(139.8591,88.5938,0.3533,0.3533);

	this.shape_156 = new cjs.Shape();
	this.shape_156.graphics.f("#FFFFFF").s().p("AisCwIAAlfIFZAAIAAFfg");
	this.shape_156.setTransform(139.7708,68.9527,0.3533,0.3533);

	this.shape_157 = new cjs.Shape();
	this.shape_157.graphics.f("#E0E0E0").s().p("AjejgIG+AAIm/HCg");
	this.shape_157.setTransform(139.8767,68.9439,0.3533,0.3533);

	this.shape_158 = new cjs.Shape();
	this.shape_158.graphics.f("#999999").s().p("AjgDeIHAm+IABHBg");
	this.shape_158.setTransform(139.8149,69.0587,0.3533,0.3533);

	this.shape_159 = new cjs.Shape();
	this.shape_159.graphics.f("#2E0402").s().p("AkSEZIAAoxIIlAAIAAIxg");
	this.shape_159.setTransform(139.8591,68.9527,0.3533,0.3533);

	this.shape_160 = new cjs.Shape();
	this.shape_160.graphics.f("#8B1A11").s().p("AhpBsIAAjXIDTAAIAADXg");
	this.shape_160.setTransform(219.8981,135.2678,0.3533,0.3533);

	this.shape_161 = new cjs.Shape();
	this.shape_161.graphics.f("#E83323").s().p("AiIiJIESAAIkTETg");
	this.shape_161.setTransform(219.9599,135.2678,0.3533,0.3533);

	this.shape_162 = new cjs.Shape();
	this.shape_162.graphics.f("#5C0E08").s().p("AiJCIIESkRIABETg");
	this.shape_162.setTransform(219.9246,135.3384,0.3533,0.3533);

	this.shape_163 = new cjs.Shape();
	this.shape_163.graphics.f("#2E0402").s().p("AioCtIAAlYIFRAAIAAFYg");
	this.shape_163.setTransform(219.9511,135.2678,0.3533,0.3533);

	this.shape_164 = new cjs.Shape();
	this.shape_164.graphics.f("#8B1A11").s().p("AhpBsIAAjXIDTAAIAADXg");
	this.shape_164.setTransform(219.8981,123.2217,0.3533,0.3533);

	this.shape_165 = new cjs.Shape();
	this.shape_165.graphics.f("#E83323").s().p("AiIiKIESAAIkTEUg");
	this.shape_165.setTransform(219.9599,123.2217,0.3533,0.3533);

	this.shape_166 = new cjs.Shape();
	this.shape_166.graphics.f("#5C0E08").s().p("AiJCIIESkRIABETg");
	this.shape_166.setTransform(219.9246,123.2835,0.3533,0.3533);

	this.shape_167 = new cjs.Shape();
	this.shape_167.graphics.f("#2E0402").s().p("AioCsIAAlYIFRAAIAAFYg");
	this.shape_167.setTransform(219.9511,123.2217,0.3533,0.3533);

	this.shape_168 = new cjs.Shape();
	this.shape_168.graphics.f("#8B1A11").s().p("AhpBsIAAjXIDTAAIAADXg");
	this.shape_168.setTransform(219.8981,111.1757,0.3533,0.3533);

	this.shape_169 = new cjs.Shape();
	this.shape_169.graphics.f("#E83323").s().p("AiIiJIESAAIkTETg");
	this.shape_169.setTransform(219.9599,111.158,0.3533,0.3533);

	this.shape_170 = new cjs.Shape();
	this.shape_170.graphics.f("#5C0E08").s().p("AiJCIIESkRIABETg");
	this.shape_170.setTransform(219.9246,111.2375,0.3533,0.3533);

	this.shape_171 = new cjs.Shape();
	this.shape_171.graphics.f("#2E0402").s().p("AioCsIAAlXIFRAAIAAFXg");
	this.shape_171.setTransform(219.9511,111.1757,0.3533,0.3533);

	this.shape_172 = new cjs.Shape();
	this.shape_172.graphics.f("#8B1A11").s().p("AhpBsIAAjXIDTAAIAADXg");
	this.shape_172.setTransform(219.8981,99.1208,0.3533,0.3533);

	this.shape_173 = new cjs.Shape();
	this.shape_173.graphics.f("#E83323").s().p("AiIiJIESAAIkTETg");
	this.shape_173.setTransform(219.9599,99.112,0.3533,0.3533);

	this.shape_174 = new cjs.Shape();
	this.shape_174.graphics.f("#5C0E08").s().p("AiJCIIESkRIABETg");
	this.shape_174.setTransform(219.9246,99.1826,0.3533,0.3533);

	this.shape_175 = new cjs.Shape();
	this.shape_175.graphics.f("#2E0402").s().p("AioCtIAAlZIFRAAIAAFZg");
	this.shape_175.setTransform(219.9511,99.1208,0.3533,0.3533);

	this.shape_176 = new cjs.Shape();
	this.shape_176.graphics.f("#E83323").s().p("AhGBJIAAiRICOAAIAACRg");
	this.shape_176.setTransform(131.1866,145.0883,0.3533,0.3533);

	this.shape_177 = new cjs.Shape();
	this.shape_177.graphics.f("#EC706B").s().p("AhbhcIC3AAIi3C5g");
	this.shape_177.setTransform(131.2308,145.0883,0.3533,0.3533);

	this.shape_178 = new cjs.Shape();
	this.shape_178.graphics.f("#BA271A").s().p("AhcBbIC5i3IAAC5g");
	this.shape_178.setTransform(131.2043,145.1324,0.3533,0.3533);

	this.shape_179 = new cjs.Shape();
	this.shape_179.graphics.f("#2E0402").s().p("AhwB0IAAjnIDhAAIAADng");
	this.shape_179.setTransform(131.222,145.0883,0.3533,0.3533);

	this.shape_180 = new cjs.Shape();
	this.shape_180.graphics.f("#E83323").s().p("AhHBIIAAiPICPAAIAACPg");
	this.shape_180.setTransform(116.4382,145.0883,0.3533,0.3533);

	this.shape_181 = new cjs.Shape();
	this.shape_181.graphics.f("#EC706B").s().p("AhbhcIC3AAIi3C5g");
	this.shape_181.setTransform(116.4823,145.0883,0.3533,0.3533);

	this.shape_182 = new cjs.Shape();
	this.shape_182.graphics.f("#BA271A").s().p("AhcBbIC4i3IABC5g");
	this.shape_182.setTransform(116.4558,145.1324,0.3533,0.3533);

	this.shape_183 = new cjs.Shape();
	this.shape_183.graphics.f("#2E0402").s().p("AhwB0IAAjnIDhAAIAADng");
	this.shape_183.setTransform(116.4735,145.0883,0.3533,0.3533);

	this.shape_184 = new cjs.Shape();
	this.shape_184.graphics.f("#E83323").s().p("AhGBJIAAiRICNAAIAACRg");
	this.shape_184.setTransform(123.7329,137.6699,0.3533,0.3533);

	this.shape_185 = new cjs.Shape();
	this.shape_185.graphics.f("#EC706B").s().p("AhbhcIC3AAIi3C5g");
	this.shape_185.setTransform(123.7771,137.6699,0.3533,0.3533);

	this.shape_186 = new cjs.Shape();
	this.shape_186.graphics.f("#BA271A").s().p("AhcBbIC4i3IABC5g");
	this.shape_186.setTransform(123.7506,137.7141,0.3533,0.3533);

	this.shape_187 = new cjs.Shape();
	this.shape_187.graphics.f("#2E0402").s().p("AhxB0IAAjnIDiAAIAADng");
	this.shape_187.setTransform(123.7683,137.6699,0.3533,0.3533);

	this.shape_188 = new cjs.Shape();
	this.shape_188.graphics.f("#E83323").s().p("AhsBvIAAjdIDZAAIAADdg");
	this.shape_188.setTransform(280.7642,58.7525,0.3533,0.3533);

	this.shape_189 = new cjs.Shape();
	this.shape_189.graphics.f("#EC706B").s().p("AiMiNIEZAAIkZEbg");
	this.shape_189.setTransform(280.8348,58.7436,0.3533,0.3533);

	this.shape_190 = new cjs.Shape();
	this.shape_190.graphics.f("#BA271A").s().p("AiNCLIEakYIAAEbg");
	this.shape_190.setTransform(280.7906,58.8143,0.3533,0.3533);

	this.shape_191 = new cjs.Shape();
	this.shape_191.graphics.f("#2E0402").s().p("AisCxIAAlhIFZAAIAAFhg");
	this.shape_191.setTransform(280.8171,58.7525,0.3533,0.3533);

	this.shape_192 = new cjs.Shape();
	this.shape_192.graphics.f("#E83323").s().p("AhsBuIAAjcIDZAAIAADcg");
	this.shape_192.setTransform(258.2617,58.7525,0.3533,0.3533);

	this.shape_193 = new cjs.Shape();
	this.shape_193.graphics.f("#EC706B").s().p("AiMiNIEZAAIkZEbg");
	this.shape_193.setTransform(258.3324,58.7436,0.3533,0.3533);

	this.shape_194 = new cjs.Shape();
	this.shape_194.graphics.f("#BA271A").s().p("AiMCLIEZkYIAAEbg");
	this.shape_194.setTransform(258.2882,58.8143,0.3533,0.3533);

	this.shape_195 = new cjs.Shape();
	this.shape_195.graphics.f("#2E0402").s().p("AisCxIAAlhIFZAAIAAFhg");
	this.shape_195.setTransform(258.3147,58.7525,0.3533,0.3533);

	this.shape_196 = new cjs.Shape();
	this.shape_196.graphics.f("#E83323").s().p("AhsBuIAAjbIDZAAIAADbg");
	this.shape_196.setTransform(269.3893,70.2686,0.3533,0.3533);

	this.shape_197 = new cjs.Shape();
	this.shape_197.graphics.f("#EC706B").s().p("AiMiNIEZAAIkZEbg");
	this.shape_197.setTransform(269.46,70.2598,0.3533,0.3533);

	this.shape_198 = new cjs.Shape();
	this.shape_198.graphics.f("#BA271A").s().p("AiMCLIEZkXIABEag");
	this.shape_198.setTransform(269.4158,70.3393,0.3533,0.3533);

	this.shape_199 = new cjs.Shape();
	this.shape_199.graphics.f("#2E0402").s().p("AisCxIAAlhIFZAAIAAFhg");
	this.shape_199.setTransform(269.4423,70.2686,0.3533,0.3533);

	this.shape_200 = new cjs.Shape();
	this.shape_200.graphics.f("#E83323").s().p("AhsBvIAAjdIDZAAIAADdg");
	this.shape_200.setTransform(269.3893,47.4306,0.3533,0.3533);

	this.shape_201 = new cjs.Shape();
	this.shape_201.graphics.f("#EC706B").s().p("AiMiNIEZAAIkZEbg");
	this.shape_201.setTransform(269.46,47.4218,0.3533,0.3533);

	this.shape_202 = new cjs.Shape();
	this.shape_202.graphics.f("#BA271A").s().p("AiMCLIEZkYIABEbg");
	this.shape_202.setTransform(269.4158,47.4924,0.3533,0.3533);

	this.shape_203 = new cjs.Shape();
	this.shape_203.graphics.f("#2E0402").s().p("AisCxIAAlhIFZAAIAAFhg");
	this.shape_203.setTransform(269.4423,47.4218,0.3533,0.3533);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_203},{t:this.shape_202},{t:this.shape_201},{t:this.shape_200},{t:this.shape_199},{t:this.shape_198},{t:this.shape_197},{t:this.shape_196},{t:this.shape_195},{t:this.shape_194},{t:this.shape_193},{t:this.shape_192},{t:this.shape_191},{t:this.shape_190},{t:this.shape_189},{t:this.shape_188},{t:this.shape_187},{t:this.shape_186},{t:this.shape_185},{t:this.shape_184},{t:this.shape_183},{t:this.shape_182},{t:this.shape_181},{t:this.shape_180},{t:this.shape_179},{t:this.shape_178},{t:this.shape_177},{t:this.shape_176},{t:this.shape_175},{t:this.shape_174},{t:this.shape_173},{t:this.shape_172},{t:this.shape_171},{t:this.shape_170},{t:this.shape_169},{t:this.shape_168},{t:this.shape_167},{t:this.shape_166},{t:this.shape_165},{t:this.shape_164},{t:this.shape_163},{t:this.shape_162},{t:this.shape_161},{t:this.shape_160},{t:this.shape_159},{t:this.shape_158},{t:this.shape_157},{t:this.shape_156},{t:this.shape_155},{t:this.shape_154},{t:this.shape_153},{t:this.shape_152},{t:this.shape_151},{t:this.shape_150},{t:this.shape_149},{t:this.shape_148},{t:this.shape_147},{t:this.shape_146},{t:this.shape_145},{t:this.shape_144},{t:this.shape_143},{t:this.shape_142},{t:this.shape_141},{t:this.shape_140},{t:this.shape_139},{t:this.shape_138},{t:this.shape_137},{t:this.shape_136},{t:this.shape_135},{t:this.shape_134},{t:this.shape_133},{t:this.shape_132},{t:this.shape_131},{t:this.shape_130},{t:this.shape_129},{t:this.shape_128},{t:this.shape_127},{t:this.shape_126},{t:this.shape_125},{t:this.shape_124},{t:this.shape_123},{t:this.shape_122},{t:this.shape_121},{t:this.shape_120},{t:this.shape_119},{t:this.shape_118},{t:this.shape_117},{t:this.shape_116},{t:this.shape_115},{t:this.shape_114},{t:this.shape_113},{t:this.shape_112},{t:this.shape_111},{t:this.shape_110},{t:this.shape_109},{t:this.shape_108},{t:this.shape_107},{t:this.shape_106},{t:this.shape_105},{t:this.shape_104},{t:this.shape_103},{t:this.shape_102},{t:this.shape_101},{t:this.shape_100},{t:this.shape_99},{t:this.shape_98},{t:this.shape_97},{t:this.shape_96},{t:this.shape_95},{t:this.shape_94},{t:this.shape_93},{t:this.shape_92},{t:this.shape_91},{t:this.shape_90},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84},{t:this.shape_83},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80},{t:this.shape_79},{t:this.shape_78},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75},{t:this.shape_74},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71},{t:this.shape_70},{t:this.shape_69},{t:this.shape_68},{t:this.shape_67},{t:this.shape_66},{t:this.shape_65},{t:this.shape_64},{t:this.shape_63},{t:this.shape_62},{t:this.shape_61},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55},{t:this.shape_54},{t:this.shape_53},{t:this.shape_52},{t:this.shape_51},{t:this.shape_50},{t:this.shape_49},{t:this.shape_48},{t:this.shape_47},{t:this.shape_46},{t:this.shape_45},{t:this.shape_44},{t:this.shape_43},{t:this.shape_42},{t:this.shape_41},{t:this.shape_40},{t:this.shape_39},{t:this.shape_38},{t:this.shape_37},{t:this.shape_36},{t:this.shape_35},{t:this.shape_34},{t:this.shape_33},{t:this.shape_32},{t:this.shape_31},{t:this.shape_30},{t:this.shape_29},{t:this.shape_28},{t:this.shape_27},{t:this.shape_26},{t:this.shape_25},{t:this.shape_24},{t:this.shape_23},{t:this.shape_22},{t:this.shape_21},{t:this.shape_20},{t:this.shape_19},{t:this.shape_18},{t:this.shape_17},{t:this.shape_16},{t:this.shape_15},{t:this.shape_14},{t:this.shape_13},{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape},{t:this.instance}]},3).to({state:[]},1).wait(1));

	// gameOver
	this.gameOverMenu = new lib.GameOverMenu();
	this.gameOverMenu.setTransform(110.7,185,1,1,0,0,0,105.3,176);
	this.gameOverMenu._off = true;

	this.timeline.addTween(cjs.Tween.get(this.gameOverMenu).wait(2).to({_off:false},0).to({_off:true},1).wait(2));

	// playButton
	this.bigPlayButton = new lib.BigPlayButton();
	this.bigPlayButton.setTransform(295.3,116.35,1.2853,1.2853,0,0,0,-0.5,-0.5);
	new cjs.ButtonHelper(this.bigPlayButton, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.bigPlayButton).to({_off:true},1).wait(4));

	// dim
	this.dim = new lib.DimMC();
	this.dim.setTransform(207,154.45,0.4879,0.7881,0,0,0,1754.5,116.9);

	this.timeline.addTween(cjs.Tween.get(this.dim).to({_off:true},1).wait(4));

	// instructions
	this.instructionsMenu = new lib.InstructionsMenu();
	this.instructionsMenu.setTransform(-6709.15,-4031.4,1,1,0,0,0,-6938,-4320.1);

	this.timeline.addTween(cjs.Tween.get(this.instructionsMenu).to({_off:true},1).wait(4));

	// nextShape
	this.nextShapeSymbol = new lib.NextShapeSymbol();
	this.nextShapeSymbol.setTransform(297.45,52.95);

	this.shape_204 = new cjs.Shape();
	this.shape_204.graphics.f("#000000").s().p("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");
	this.shape_204.setTransform(258.7376,15.5953,0.7449,0.7449);

	this.instance_1 = new lib.NextShapeArea("single",0);
	this.instance_1.setTransform(224.25,6,0.929,1);
	this.instance_1.filters = [new cjs.ColorFilter(0.6, 0.6, 0.6, 1, 0, 0, 0, 0)];
	this.instance_1.cache(-11,-2,179,102);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.shape_204},{t:this.nextShapeSymbol}]},2).to({state:[]},1).wait(2));

	// pauseMenu
	this.pauseMenu = new lib.pauseMenu();
	this.pauseMenu.setTransform(110.6,188.2);
	this.pauseMenu._off = true;

	this.timeline.addTween(cjs.Tween.get(this.pauseMenu).wait(2).to({_off:false},0).to({_off:true},1).wait(2));

	// quitMenu
	this.quitMenu = new lib.QuitMenu();
	this.quitMenu.setTransform(108.05,162.1,1,1,0,0,0,0,0.5);
	this.quitMenu._off = true;

	this.timeline.addTween(cjs.Tween.get(this.quitMenu).wait(2).to({_off:false},0).to({_off:true},1).wait(2));

	// gameMenu
	this.shape_205 = new cjs.Shape();
	this.shape_205.graphics.f("#404040").s().p("AAUBfIgDAAIgHAAQgDgCgXgSIgCAAQAAABAAAAQAAABAAAAQgBAAAAABQgBAAAAAAIgBgBIgFgGIAAAAQgDgCAAgCQgFgCgBgIIAAgFQAAAAAAgBQAAAAgBgBQAAAAAAAAQgBAAAAgBQAAgGgFgDIAAgDQgDgFABgDQgCgUABgFIgBgEIABgMIADgGIgDgDIgDADIAAAAIAGgIIAAgCIgDABIADgEIADAAIAIgRQgBAAAAAAQgBgBAAAAQgBgBAAAAQAAAAAAgBIAFgHIAGgIIAGgEIAIgHQAAgBACgEQAGAAACgEQANgIAHAAQAIgEAEABIADgBIAGABQACABABAFIAAAEIAEACIgEAJIgGAIQgBAEgNAGQgDAAgCAEIgEAGQgEACgIAPQgBAEgDAFQAAAIgCASQAAARADAIQAAAEAGAKQADAHADACQACADAFADQAHAIAGACQABACADARQgBABAAAFQgEAGgEAAQgDAAgFgEg");
	this.shape_205.setTransform(244.8757,214.2008,0.8022,0.8022);

	this.shape_206 = new cjs.Shape();
	this.shape_206.graphics.f("#404040").s().p("AmFBnIgCABQgDAAgGgDQgHgCgCgEQgGgBgGgEQgHgBAAgIIAAgGQANgKAEgBQAEAAAFAEIADAFQALAHALACQABABAFAAQADACAAADIAAACQAAAAAAABQgBAAAAAAQAAABAAABQAAAAAAABIAAACQgCAFgEACQgBABgJACgAlKBnQgEgCgCgDIABgBQgCgCAAgCIAAgBQABgCAAgGIABgDQABAAAAgBQAAAAAAAAQABgBAAgBQAAAAAAgBQAGgIAEgDQALgGAAgQIgCgJQgDgBgJgKQgCAAgDgFIABgDIgGABIgDgCIgFABQgHAAgOgDIgDgBQgIgBgCgDQgVgGgBgCIgQgHIgBAAQgDAAgEgCIgGgGQgBgFgDgCQgCgPgCgBIACgUQAGgKADgDQADgHAFAAIAUgNIAMABIAQgBIAFABIAFANIAAAKQgDAGgDABQgDAEgFABIgFADIAAAGIAAAEQAAAEAEADQAFAHAZAAIATACIAbAIQACAFAKABQABADAFADQABAFAJACIAJAfIgBAOQgBADgCASQgBAIgOAJQgDAGgDADIgnALgAgBBfQgFgCgLAAIgEAAIgEABIgLAAQgEAAgCgCIgBgCIADgJIAHgNQADgJAIABQAFgJAAgDIABgDQAAgIAIgFQAAgEAGgIIACgIIAMgXIADgEIAFgJQADgCAMgVQAEgOADAAQADAAADADQAAAFAGAHQAAAEADAGIAKASQACAGADACIAAABQAAACACAEIAHANQABAHAGANQACADADAJQABAEADACIAEALQAAAAgBABQAAABAAAAQAAABgBAAQAAABAAAAIgGABQgaAAgGgCQAAAAgBAAQAAgBAAAAQgBgBAAAAQAAgBAAgBIgCABIAAABIgBADIgFAAQgFAAgHAEQgCABgBADIgCAEQgEADAAAFQAAABAAAAQAAAAgBABQAAAAgBABQgBAAAAAAQgCACgCAEIgCAAQgCAAgCAEQgGABgBgCIgDAAIgCABIgGgBgAgeBKQABAEgFAGQgCAAgBAEIABADIAGAAIAAgBQAAgBAAAAQAAgBgBAAQAAgBgBAAQAAAAgBgBQAMgRABgIIgBAAIgJANgAgPBLIAAADIACAAQABAAABAAQABAAAAAAQAAAAABgBQAAAAAAgBIAAgBIAAgGQgDABgDAFgAAyA9IgBgBIAAABIABAAgABXA6IAFABIABgBIgDgFgAhqBgIgIgFQgDgEAAgLQADgGAAgDQAQgHAGgGIAJgFQAFgEAAgDIAIgLQABgIAGAAIAKACIABAAIAFACQACADAAAGIgCAIIgCADIABABQAAAFgFAJQgEADgEAJQgBAAAAAAQgBAAgBABQAAAAAAAAQgBABAAABIAAABQAAACgGADQgCADgHACQgIAFAAACIgIABgAF6BfQgIACAAgJIABgDQgDgDABgEIgGgDQAAAAAAAAQgBABAAAAQgBAAAAABQAAABAAAAQgBAAAAAAQAAAAAAAAQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAAAAAgBQAAAAAAAAQgBAAAAAAIgIgJIABAAIAAgBQACADABAAIACAAIAAgBIgBgHQgLgDgBgCQgBgEgIgJIgBAAQgBAAAAgBQgBAAAAAAQAAgBAAAAQgBgBAAgBQgDgEABgDIgBgCIgCACIgBgEIACgBQgCgBABgEQgBgGAIgCIAKgEQAMgBADgRQAEgFAAgCQAFgFgDgDIABgDIgCgEQAAgJgFgDQgFgFAAgEIgHgCQAAgBAAgBQAAAAgBgBQAAAAgBgBQAAAAAAAAIgBAAQAAABgBAAQAAABAAAAQAAAAgBAAQAAAAgBAAQgFAAgHgGQgGgBgBgEIgBgDQACgDgBgCQAAgJgCgGIAHgGIAIAAIAFABQAOgDAHAAQAAAAABAAQAAAAABAAQAAABABAAQAAAAAAABIAMgBQACAAAEgBQAIADAFAAQAPgBAHAFQAAAFgCAAIgCAAIAAABIAGADIAAABQAAACADAEIAAACIAFAAQADAHACACQABAIAHARIgCAUIgMAKQgGABAAAFQgEAEgEAAQgBACgFAEIgDgBQgDAAgDAFQAAAEgGAAQAAADgGACIAAABIABAAQABAFADAAIABAAIACgFIAEAHIgCAEIAEABIABgBQABAAABAAQAAAAABABQAAAAABAAQAAAAAAABIAAAAQAAABAAAAQAAAAAAABQAAAAgBAAQAAABgBAAIAFAFQADAJAGABIAFAKIAAABIgDgCIgBABQgBAAAAABQAAAAgBAAQAAABAAAAQAAABAAAAIABACQgBAEAFAEIADABIAAABIACAEQAAAAABABQAAAAABABQAAAAAAABQAAAAAAABQABACgHACIgEAAIgDABIgHgCIgBAAQgCADgGAAIgBADIgCABIgFgFIgEACIAAADIgFABgAGOBNIABAEIAFAAQABAAAAAAQABAAABAAQAAgBAAAAQAAgBAAAAQgDgBgCgCgAD1BeQgBgDgHgCIABADIgBABQgDAAAAgEIACgOQgDgLAAgGIABgGQgBgFADgBIAAAAIgCgCIgDgJIACgCQgCgGACgJIABgBIABAFIABADQgBgQADgEIABgFIgCgCIgDgBIAAgBIAAgHIABgEQgDgHADgIIAAgLQgDgaABgNQAAAAgBAAQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAgJARAAIAaAAQAEAAAJAHIACAFQgBAFgCAJIABACIgDAFQAAAAABABQAAAAAAAAQAAAAABAAQAAABABAAIABACQAAAWgGAGIAAAJQABAIgCAEQAAAAAAABQAAAAABABQAAAAAAABQABAAAAABIAAABQgCABAAAFIABADQABAEgDAIIABAEQgBAFABAIIACAFIAAACIgBAKQABACgCAMIgCALIAAACIgCAEIgBAAQgDAAgBAEIABADQAAAAAAAAQAAAAAAABQAAAAgBAAQAAAAAAAAIgGgCIgBAAQgCADgGAAgADDBaIgEAEIgFgBIgHABQgBgBgGAAIgCgDIgHAEIgCAAQgDAAgFgFIAAgBQgFgEADgCQgHgFADgEQgKgGABgIIgCgHQgEgCgDgKIABgEQAAAAAAAAQAAgBAAAAQAAAAgBAAQAAAAAAAAIgCAAQgFgDAEgDIAAgDIgBAAQgGAAgDgJQgDgDAAgDQgCgBgBgGQgEgFgBgFQgBgBgBgDIAAgEIgCgEQgCgHgDgDQAAAAAAgBQAAAAAAgBQgBAAAAgBQgBAAgBAAIAAgGQAAgBAAAAQAAgBgBAAQAAAAgBAAQAAAAgBAAQgBgBAAgFIgCgEQgEgIAAgEQgFAAgBgIQgBgLgDgFQgDgBgBgGQABgNAVAAIAJABQAJABAFgCIAPACIAFACQgBAAAAABQABAAAAABQAAAAAAABQABABABAAQADADADAJQAEAKADAEIAAABIAGANQANAQAAALIASAhQARAcAAARIACADQAAACAEAFQgBAEgFADQAGAIAAAKIgBAHIgIAEIgFgEgAGwBRQgCgHgDgBIABgCIABAAQADAAACAHIACADIAAAFQAAAAAAAAQAAABAAAAQAAAAAAAAQgBABAAAAQgBAAgCgHgAhDgvQgEAAgEACQgDAAgJgGIgGgIQgGgCgGgJQgCgCgDgKQAAgRAHgDIABAAIAHgBIAUAGQAGAHAEABQACAHADAAQABAGAJAEQADACAAAFQACADABAGQgDAFAAAEQgBACgMAAQgCgCgFAAgAhVg2QAGAHADgBIABAAIgEgDQAAgBgGgEgAg0g3QABADgBAEIABAAQADgCAAgEIgBgFgAjpgyQAAgEADAAIAAABIgBAEIgBABgAkig+QgDgIgTgCIgHgCQgFgIgBgFIAAgCQAHgJAGAAIADABQAEgBAcAMQABAFAIAFIABAIQAAAKgMAAQgDAAgIgEg");
	this.shape_206.setTransform(258.7386,214.6821,0.8022,0.8022);

	this.shape_207 = new cjs.Shape();
	this.shape_207.graphics.f("#404040").s().p("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");
	this.shape_207.setTransform(265.7005,167.925);

	this.shape_208 = new cjs.Shape();
	this.shape_208.graphics.f("#404040").s().p("AlMBpQgBgBgFAAQgFADgYAAQgJAAgFgCIgBgDIgCAAQAAAAAAAAQgBABAAAAQAAABAAABQAAAAAAABQgGAAgBgFQgHAAAAgHQgBgEAAgCQgCgFABgJIgBgDIABgGQACgBAhgEIACAAIANACIAQgBIAEACIABADIACAAIAFACIAEAWQgBAOgCADIgHAAgAlLBnIADACIAEgCIABgKIgDgTIgCAAIACALIgDAPIgBABIgBAAgAgKBnQgEgDgFACQgGAAgBgDIgGgSQAAgHgDgDIgFgJIAAgCQgCgFAAgEQgHgKAAgCQgGgNABgDQgDgCgDgGQgBgIgBgCIgKgTQgJgRgBgGQgBAAAAAAQAAgBAAAAQgBgBAAAAQAAgBAAgBQgCgBgCgEQAAgFgFgEIgCgDIAAgBQgDgGAAgEQgDAAgBgGQgCgJgDgCIAAgDIAMgEIABAAIAIgCIAEgBIACAAIAVgDQACAAAEAEIgBAAIACAFIALAYIAHAUQAHAJAWA5QAFAUATAlIAAABQgBAFAHANQAAAFgJABIgMAAIgEgBIgFAEIgCABIgDgDgAnkBoIgBgDIgFgBQgDgEAAgIIgBgIIgBgLQgEgFACgDQAAgXgBgMQABgNgCgEQAAgLABgFIAAgcQABgWgDgJIABgEIgBgIIAAgCQACgGAEgBIAHACIADgBIAGABIADgBIADABQAAAAABAAQAAgBAAAAQABAAAAAAQABAAABAAQAAAAABABQAAAAABAAQAAABABAAQAAAAABAAIAIgCQAJAAACACIAGgBQABAAAAAAQABAAAAABQAAAAAAAAQAAAAAAABIABAJIADAAQACADAAAMIgBAcIABACIAAAGIAAAJIgBAEIgBgBIgCgXIAAgCIACgGQAAgNgCgHIAAAJIAAARIAAAJQAAAfgBADIAAAEIABASIgBAnIAAAIQABAIgCAEIABADIgDALQgGABgLABIgDgCIgHABQgEAAgCACIgEgBIgCACQgEAAgCgCgAnLBhIABACQAKAAAIgCIAAgGIgKAGIgEgBgAm8hJQADAJABARIgCAGIABACIABAXIABAAIAAgDIAAgPIAAgCIAAgcIgCgPIgDgBgAkpBZQABgGgBgcIACgBIACAPQgBADAAAOIAAAFIACgBQACgEgCgCQACgGACgBIgBgCQADgHAAgEIAAgDQgEAAgBgFQgCgaABgBIAAgJQABgHgDgBQAAABAAAAQAAABgBAAQAAABAAAAQgBABAAAAQgBAAAAgBQAAAAAAAAQAAgBAAAAQAAgBAAAAIAAgEIAAgDIABgCIACACIABgBIgBgEIgDgDIAAgHQAAAAgBgBQAAAAAAAAQAAgBAAAAQAAgBAAAAQAAgEADgCQgCgDAAgfIgBgHQAAAAAAgBQAAAAAAAAQABAAAAgBQAAAAABAAQgCgDADgDQACAAgBgFIgBgBIgBADIgBgCIABgFQgCgBAAgNQAFgIAFAAIAHABQADgBAZAAQAGADAJgDQAJAEgBARIgCAKQABAHgBAPQAAAOACADIAAAHQABAJAHABQAEgCAWAAIATgBQAQABAIgDIALADQAKAHgDASIgEAOIgQACQgDgBgFABQgFACgDgCIgEABIgeAAIgFgBQgEABgLgCQgCADgFABQgHACAAAKQAAAGABACQgCAUADAMQgBAFABAIQAAADgCACIgaADIgCAAIgBAAIgDABQAAgBgBAAQAAAAAAAAQgBAAAAAAQgBABgBAAIgFABIgBAAQgNAAgDgQgAkEBhIgBACIAEABQARAAAAgGQgCgFABgDIgBgDIgDAHIgBAAQAAALgKgGgAjTARIgBACQAAAEAIABIAHABIACgBIAFgBQAAAAgBAAQAAAAAAgBQgBAAgBAAQgBAAgBAAQgDAAgJgGgAjdgHIAAABIAGABIABAAIAAgCIgCgBgAiTBiIgBACIACABQAAABAAAAQAAABgBAAQAAAAgBABQgBAAgBAAQgEAAgLgEIgHAAIgNACIgKgEIAAgCIgBgCQAEgGgFgGIAAgDQACgOAFgGQAIgBAEABIADgBQAbAEAMgBIAGACQADADgCAJQgBAFABAKIACADQAAAAgBABQAAABAAAAQgBABAAAAQgBAAgBAAQAAAFgDACIgDgBIgEACQgDAAgDgGgAFXBkIgBgEIgFgBQgDgEAAgIIgBgIIgBgLQgEgFACgCQAAgYgBgLQABgNgCgEQAAgLABgGIAAgcQABgVgDgKIABgEIgBgHIAAgDQACgFAEgBIAHABIADgBIAGABIADgBIADACQAAgBABAAQAAAAAAAAQABgBAAAAQABAAABAAQAAABABAAQAAAAABABQAAAAABAAQAAAAABAAIAIgBQAJAAACABIAGAAQABAAAAAAQABAAAAAAQAAAAAAABQAAAAAAAAQACAPAAAPIAAAaQAAAggBADIAAADIABASIgBAnIAAAIQABAIgCAFIABADIgDAKQgGACgLAAIgDgBIgHABQgEgBgCACIgEAAIgCABQgEAAgCgBgAFwBdIABACQAKAAAIgDIAAgFIgKAGIgEgCgAF/hOQADAJABARIgCAHIABABIABAXIABABIAAgEIAAgPIAAgCIAAgcIgCgPIgDAAgACDBUQADgHgCgbIACgBIACAPQgCAEAAANIACAFIABgBQACgEgDgCQACgGACgBIAAgCQADgHABgEIgBgDQgEAAgBgFQgCgaAAgBIABgJQgCgCAAgGQAAABgBABQAAAAAAABQAAAAgBAAQAAABAAAAQgBAAAAgBQAAAAgBAAQAAgBAAAAQAAgBAAAAIABgEIgBgDIACgBIACABIABgBIAAgDIgEgEIAAgHQAAAAgBgBQAAAAAAAAQAAgBAAAAQgBgBAAAAQAAgDAEgDQgCgCgBghIAAgGQAAAAAAgBQAAAAAAAAQAAgBABAAQAAAAAAAAQgBgCADgEQACAAAAgFIgCgBIgBADIgCgCIACgFIgDgOQAIgIADAAIAHABIAbgCQAFAFALgEQAIAEAAARIgCAKQABAHgBAPQAAAOACADIAAAHQAAAJAJABQADgCAXAAIATgBQAQABAGgDIAMADQAKAHgEASIgDAOIgQACQgDgBgFABQgGACgDgCIgDAAIgJABIgVAAIgFgBQgGABgKgCQgBADgGABQgGACAAAKQAAAFABADQgCAUADAMQgBAFABAIQAAADgCACIgaADIgBAAIgDAAIgCABQAAgBgBAAQAAAAAAAAQgBAAAAAAQgBABgBAAIgGABIgBAAQgNAAgDgQgACpBcIgBACIAEABQARAAAAgGQgCgFABgDIgBgDQgDAAAAAHIgBAAQAAALgKgGgADaAMIAAACQAAAEAGABIAIABIACgBIAEgBQAAAAAAAAQAAAAgBgBQAAAAgBAAQgBAAAAAAQgEAAgKgGgAEeAKQAAAFgHADIAEABQAGAAAAgEIAAgDIgDgCgADQgNIAAACIAGABIABAAIAAgCIgDgBgAEaBdIgBACIACABQAAABAAAAQAAABgBAAQAAAAgBABQgBAAgBAAIgPgEIgIAAIgMACIgJgEIAAgCIgBgCQACgGgEgGIAAgEIgBAAQAEgOADgFQAIgCAFACIADgBQAcAEAKgBIAHACQADADgCAJQgBAFABAKIABADQAAAAAAABQAAAAAAABQgBAAAAABQgBAAgBAAQgBAFgDACIgCgBIgEACQgDAAgDgGgAHoBgQgCgCgEAAQgFAEgYAAQgKAAgEgCIgCgFQgCAAAAAGQgHgBAAgGQgBgEAAgCQgCgGABgIIgBgDIABgGQACgBAhgEIACAAIANABIAQAAIAEACIAFAVQgCAPgCACIgGABgAHrBEIgBANQACACgCAHIgCADIADADIAFgCIAAgKIgCgUIgEAAQAAAAAAABQAAAAAAAAQAAABAAABQABAAAAABgAAmAlIAAgCQAAgDgBgCIAAgBQgEgDACgEIgDgCIAAgCQgBgDAAgDQgDgEAAgCQgBgGgCgBIgCgGQAAAAABgBQAAAAAAAAQAAgBAAAAQAAAAABAAQgBgKAGgFIAJgPQAGgJAAgFIAFgKQADgGABgDIAJgRQAFgJARgBIADABQADAGAMgGQACAAAEADIAAACIgCAGQgFALgBACIgBADIAAACIgFAGQgHAAgDAZIgIALIgDAJQgBAEgDAHQgCABgGAOQAAADgEAHIgGALQgBAEgGAHgAA3AHIAAACIABgBQABAAABAAQAAAAABgBQAAAAAAgBQABAAAAgBQADgEABgGIgDAEQgCAEgCAAQAAAAgBABQAAAAgBABQAAAAAAABQAAABAAAAgABTg0IgDAHQgDACgDANIgEAMIACgEQACgFADgBIgBgCIAEgHQAEgJAAgGIACgDIgCgBQAAAAAAABQgBAAAAABQAAAAAAABQAAABAAAAgABfhOIgBABIgFALIABADQAIgVAFgFQAAgBAAAAQgBAAAAAAQgBgBgBAAQAAAAgBAAQgIAAgBADQgBAHADgBQABABABAAQAAAAAAABQABABAAAAQAAABAAAAgAiRg4QgCgCgHACIgEgCQAAAAgBAAQAAABgBAAQAAAAAAABQgBAAAAABQgIAAgMgDIgBAAQgDAAgEgDQgEgHAAgFIAAgEIAEgRQAMgKAHAFIAEABQAEAAAIgCIAHgBIAQABQADAFAAAHIgCAIQAAABAAAAQAAABABAAQAAAAAAABQABAAABAAIACAGIgEANIgNADIgDgBgAiIg+IAAABIADAAQAAAAAAAAQAAAAABAAQAAgBAAAAQAAAAAAgBIAAgEIgDgBgAEcg9QgCgBgHABQAAAAgBAAQAAAAgBAAQAAAAgBgBQAAAAgBgBQgCAAgCADQgHAAgMgDIgCAAQgCAAgFgDQgDgHAAgFIAAgEIADgRQAMgKAIAFIAEABQAFAAAGgCIAIgBIAQABQADAEAAAIQAAADgDAFQAAABABAAQAAAAAAABQABAAAAAAQABABAAAAIACAGQAAAEgDAJIgOADgAEkhDIAAABIAEAAIABgCIAAgEIgEgBIgBAGg");
	this.shape_208.setTransform(260.15,122.1,0.7867,0.7867,0,0,0,0.2,0);

	this.pauseBtn = new lib.PauseButton();
	this.pauseBtn.setTransform(322.1,265.95);
	new cjs.ButtonHelper(this.pauseBtn, 0, 1, 2, false, new lib.PauseButton(), 3);

	this.quitBtn = new lib.QuitButton();
	this.quitBtn.setTransform(245.5,265.95);
	new cjs.ButtonHelper(this.quitBtn, 0, 1, 2, false, new lib.QuitButton(), 3);

	this.pointsTxt = new cjs.Text("0", "italic 26px 'flyerfont'", "#FFFFFF");
	this.pointsTxt.name = "pointsTxt";
	this.pointsTxt.textAlign = "right";
	this.pointsTxt.lineHeight = 39;
	this.pointsTxt.lineWidth = 92;
	this.pointsTxt.parent = this;
	this.pointsTxt.setTransform(370.4,194.95,1,0.9984,0,-10.0567,0);

	this.levelTxt = new cjs.Text("0", "italic 26px 'flyerfont'", "#CC0000");
	this.levelTxt.name = "levelTxt";
	this.levelTxt.textAlign = "right";
	this.levelTxt.lineHeight = 39;
	this.levelTxt.lineWidth = 92;
	this.levelTxt.parent = this;
	this.levelTxt.setTransform(370.4,104.95,1,0.9984,0,-10.0567,0);

	this.linesTxt = new cjs.Text("0", "italic 26px 'flyerfont'", "#FF0000");
	this.linesTxt.name = "linesTxt";
	this.linesTxt.textAlign = "right";
	this.linesTxt.lineHeight = 39;
	this.linesTxt.lineWidth = 92;
	this.linesTxt.parent = this;
	this.linesTxt.setTransform(370.4,149.95,1,0.9984,0,-10.0567,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.linesTxt},{t:this.levelTxt},{t:this.pointsTxt},{t:this.quitBtn},{t:this.pauseBtn},{t:this.shape_208},{t:this.shape_207},{t:this.shape_206},{t:this.shape_205}]},2).to({state:[]},1).wait(2));

	// mainMenu
	this.instance_2 = new lib.EmilyLink();
	this.instance_2.setTransform(191,273.4,1,1,0,0,0,113.5,14.8);

	this.shape_209 = new cjs.Shape();
	this.shape_209.graphics.f("#404040").s().p("AAkCMIgGgKQABgHgGgEQgEgBgGAMQADABAAAEIgBAGQgFAAgDgNQgDgMgIAAIgGAJQACADgBACQgBACgFABQgFAAgBACQABgHgIgHQgGAAgFAPQgDAMgNgJQgEgDABgKQACgJgIgDQgEAEgEAKQgFAKgEADQgHAAgDgFQgDgFAEgGQAHgGAEgQQAFgSAEgGQgCgNgEgGQg/ATgcgIQgDAKgEADIgCAGQgHATgMACQgIACgQgBIgKAAQAKgDAHgKQASgcARAKQAFAAACgLQgKgEgIgEIgPgKQgHAJgHAAIgGAGQgVARgPgEQgJgDgTgLQgLgFgBgCQAOAEAPgIQAMgIAOgBQASgCAHAMQAEABAJgHQgkgagYgmQgYglgegWQgigXggAFQgcAHgDAeQgCAQARANQAYALALgOQAIgPgFgFQgDgHgFgCQgGgCgDAIIAFANQgBAFgHgFQgIgGgBgEQgDgUAWgCQAVADAFAVQABAIgEAMQgEALgGAGQgJAHgRAAQgRAAgKgGQgWgKgHgZQgBANgHAMQgHAMgPACQgNACgNgHQgKgHAAgOQAAgOALgFQgCALAFAIQAGAJAMgDQANgEAAgNQAAgMgIgLQgOgTgnAAQgcAAgmATQgtAXAEAeQABALAIAHQAJAGAMgFQAGgDAEgGQAEgHgHgEQgGgEgEAGQgFAGgEAAIgDgLQAAgDAJgEQATgJAKAMQAGAIgBALQgBALgHAIQgPAPgSABQgQAAgMgLQgMgMgCgQQgCgTALgRQgRAFgfAUQgTAKgcAFQABAIgEAGIABAJQgBAdgQAKQgWAIgLAHQgNAGgDgBQAOgIAEgTQAMgvAeADQADgBABgKQhJAKgVglQgJgIgEgQQgGgYAKgbQAPghAmgBQANgCAQAIQARAIAGAMQAEAHgBAOQgBANgFAIQgOATgXgFQgVgNAMgTQACgEALgCQAKgBgCAFIgLALQAAAKAHAAQAGAAAGgFQAHgEgBgSQgEgTgeAAQgXAGgFARQgKAgAZAUQAmAZA/gWQAagJAWgQQAfgXgEgTQgCgJgKgEQgKgEgIAGQgIAEAEAGQAEAFAGgGQAJAJgMAEQgNAEgIgHQgJgJAEgNQAEgNAMgDQAXgIATASQATASgHAWQAfgaBBgBQAvAAATAkQAEAJACAHQAEguAfgKQgHgNgMgFQAMgEAQACQAQADAJAKQAVABAZAOQARgIgKgRQAHACAEANQADAMgCALQAOALAKAKIAlArQgUggATghQgFgKAEgMQAFgMAKgEQgJAHAJASQAdgOAdALIAEADQAagRAKARQgNgDgJASQAHALACAMQAAAJgEAMQgEANgGAEQgcAOgQgTQgNgMAHgVQAIgIALACQAKACAAAHQgEAEgEAAQgFgBgCACQgEAHAFAGQAHAJARgJQAFgHgCgUQgGgQgRAAQgVgDgMAMQgLAPADAUQABAJALAcQAEAOAQAQQAQARATAJQAfANAigLIgEgDQgbgdAKgzQAJAHAEAAQAEgEgBgEIgFgIQALgLgKgNQgJgNALgLQAmgpBAgIQA5gJA6AUIAOAOQAHAIACAJQgagEgJAHIgSASQAFAEAKgGQAMgIAGAAQgNAhAHANIARggQgLAhAAAPQAHgGAGgMIAJgVQgZBEgIAPIAIADQgGAEABACIACACQAFAAACgGQADgIAEgCQgNAWgKAIQApAUApgSQATgJARgQQAPgQAFgOQALgcABgKQADgUgLgOQgMgNgVADQgRAAgGAQQgDATAGAIQAQAKAIgJQAEgGgDgHQgCgDgFABQgEAAgEgEQAAgHAKgBQALgDAIAIQAGAVgLAMQgRATgcgNQgGgEgEgNQgFgNABgJQADgOAHgKQgKgRgMADQAKgRAaAQIADgCQAdgMAcAPQAHgQgIgGQAJADAFALQAFALgDAKQATAhgUAgIAkgqQAJgKAMgJQgDgLADgMQADgOAHgCQgJATATAGQAYgPAWgCQAJgMARgDQARgCAKAJQgKgCgLAOIAFACQAYAJAJAkIABgDQATgkAvAAQBBABAgAaQgHgWASgSQATgSAXAIQAMADAEANQAEANgJAJQgIAHgMgEQgNgEAJgJQAGAGAEgFQAEgGgIgEQgIgGgKAEQgKAEgCAJQgEATAfAXQAWAQAaAJQA/AWAngZQAYgUgKggQgFgRgXgGQgdAAgFATQgBASAHAEQAGAFAGAAQAHAAAAgKQgJgJgBgCQgDgFALABQAKACADAEQALATgVANQgXAFgOgTQgFgIgBgNQgBgOAEgHQAGgMARgIQAQgIANACQAmABAPAhQALAagGAZQgEAPgKAJQgVAlhJgKQABAKAEABQAQgCAMASQAJAMAEAQQAEATAOAIQgCABgNgGQgMgHgVgIQgQgKgCgdIABgJQgEgGABgIQgcgFgTgKIgXgNQgPgJgKgDQALARgCATQgCAQgMAMQgMALgQAAQgSgBgPgPQgHgIgBgLQgBgLAHgIQAJgMATAJQAJAEAAADIgCALQgEAAgGgGQgEgGgGAEQgHAEAEAHQAEAGAGADQAMAFAJgGQAIgHACgLQACgegsgXQgmgTgcAAQgnAAgOATQgIAMABALQAAANANAEQAMADAFgJQAFgIgCgLQALAFAAAOQAAAOgKAHQgNAHgNgCQgPgCgHgMQgEgGgCgHQgJAPgQAHQgJAGgRAAQgQAAgKgHQgGgFgEgMQgEgLABgJQAFgUAVgEQAWACgDAUQgBAFgIAFQgIAFAAgFIAFgOQgEgHgFACQgGACgCAHQgFAFAIAPQALAOAYgKQAQgOgCgQQgCgegdgHQgggFghAYQgfAVgXAmQgfAxgvAbQg2AegvgXQglgTgLgKIgGAEQgKANAFAWQAJAYACALIAAAeIgDAAQgEAAgCgEgAglAyQABAZgEAHQAVALATgLQACgJgIgPQgKgQABgJIgHgHQgRAEACAUgAhQgfQgQAKgKAVQgFAaAMAJQALAEAMgJIATgQIAKgSQAFgMgEgJQgIgMgLAAQgHAAgIAGgAAMgoQgKADgCAKQgGAKAGANIANASQAfAbAggPQAMgFACgPQgegvgegCQgFACgNABgADrByQgIgCgQABQgMgCgHgTIgCgGQgGgEgBgLIADgCQgBACADAGQADAGACAAQASgKARAbQAHALALACIgGABIgFAAgAD2BBIgGgGQgJgBgHgMIAAgFQABAEAHAFQAHAGACgCQAQgXAlAWQAPAIANgEIgMAHQgLAEgRAKIgHABQgNAAgQgOg");
	this.shape_209.setTransform(191.0466,20.8894);

	this.shape_210 = new cjs.Shape();
	this.shape_210.graphics.f("#404040").s().p("AC/CoQgbgNgLgTQgGgMACgWQABgWAJgNQAXgfAlAKQAOAIAFAOQAFAOgJAOQgEAHgRADQgRADAEgJQABgDAQgPQAAgQgLAAQgKAAgKAIQgLAFACAfQAHAeAwABQAkgKAJgbQARg0gpghQhAgohkAjQgpAPgkAaQgyAkAHAfQADAOAQAHQAPAHANgJQANgIgGgIQgHgJgJALQgOgPATgGQAVgHAMAMQAPANgHAVQgGAVgTAGQglALgegcQgegdAKgkQgzAqhpABQgoABgXgLQgagNgRgiQgagxAZgoQAMgTAXgDQAWgDAUAMQARAKAAAVQABAXgTAIQAEgRgIgOQgKgOgSAGQgVAGgBAVQAAASANASQAWAgA/AAQAvgBA8geQBIglgFgwQgCgTgNgLQgPgLgSAIQgLAFgFALQgHAMALAHQAKAGAHgJQAIgLAGABQAFAQgBACQAAAFgNAGQggANgPgSQgLgNACgTQACgTALgMQAZgZAcgBQAaAAAUATQASASADAcQAEAegRAbQAPgEAYgPIAmgVQAggQArgIQgBgPAGgIQgBABABgRQACgvAZgQQAQgKAmgOQAWgKADABQgXAPgHAeQgGAagOAUQgUAbgbgDQgFACgCARQB3gRAiA8QAPAPAHAZQAJApgQApQgaA3g9AAIgIABQgRAAgWgKg");
	this.shape_210.setTransform(261.5983,360.6381,0.6694,0.6694);

	this.shape_211 = new cjs.Shape();
	this.shape_211.graphics.f("#404040").s().p("AjrCxQg8AAgag3QgQgqAJgoQAFgYARgQQAig9B2ASQgBgQgGgDQgwAFgThLQgGgegYgPQAEgBAVAKQAnAOAPAKQAaAQACAvQABARgCgBQAHAJgCAOQAmAIAhAQQAyAgAbAIQgSgbAEgeQADgcATgSQAUgTAZAAQAdABAYAZQAMAMACATQABATgKANQgQASgfgNQgNgGgBgFIAEgSQAHgBAIALQAHAJAJgGQALgHgGgMQgFgLgLgFQgTgIgOALQgOALgCATQgFAwBJAlQA8AeAvABQA/AAAWggQANgSgBgSQAAgVgVgGQgTgGgJAOQgJAOAEARQgSgJAAgWQAAgVARgKQAUgMAWADQAXADAMATQAZAogZAxQgSAigaANQgWALgpgBQhpgBgzgqQALAkgeAdQgfAcgkgLQgTgGgGgVQgHgVAOgNQANgMAUAHQAUAGgOAPQgKgLgGAJQgGAIAMAIQAOAJAPgHQAPgHAEgOQAGgfgxgkQgkgagpgPQhggjhAAoQgpAhASA0QAHAbAmAKQAwgBAHgeQACgfgMgFQgJgIgKAAQgMAAABAQQAPAPACADQADAJgQgDQgRgDgFgHQgIgOAFgOQAFgOAOgIQAlgKAXAfQAIANACAWQACAWgHAMQgKATgbANQgWAKgSAAIgIgBg");
	this.shape_211.setTransform(120.9755,360.6381,0.6694,0.6694);

	this.shape_212 = new cjs.Shape();
	this.shape_212.graphics.f("#404040").s().p("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");
	this.shape_212.setTransform(190.8302,356.804,0.6694,0.6694);

	this.instructionsButton = new lib.Symbol59();
	this.instructionsButton.setTransform(227.95,296.9);

	this.shape_213 = new cjs.Shape();
	this.shape_213.graphics.f("#FFFFFF").s().p("AhJBKIAAiTICTAAIAACTg");
	this.shape_213.setTransform(306.2284,148.6418,0.4605,0.4605);

	this.shape_214 = new cjs.Shape();
	this.shape_214.graphics.f("#FFFFFF").s().p("AgnAoIAAhPIBPAAIAABPg");
	this.shape_214.setTransform(298.5196,140.9037,0.8464,0.8464);

	this.shape_215 = new cjs.Shape();
	this.shape_215.graphics.f("#FFFFFF").s().p("AgfAgIAAhAIA/AAIAABAg");
	this.shape_215.setTransform(298.4624,156.3343,1.052,1.052);

	this.shape_216 = new cjs.Shape();
	this.shape_216.graphics.f("#FFFFFF").s().p("AhJBKIAAiTICTAAIAACTg");
	this.shape_216.setTransform(290.8129,148.6555,0.4605,0.4605);

	this.shape_217 = new cjs.Shape();
	this.shape_217.graphics.f("#7F7F7F").s().p("Ag4A4IAAhvIBxAAIAABvg");
	this.shape_217.setTransform(151.5306,56.89,0.6501,0.6501);

	this.shape_218 = new cjs.Shape();
	this.shape_218.graphics.f("#7F7F7F").s().p("Ag4A4IAAhvIBxAAIAABvg");
	this.shape_218.setTransform(159.77,73.1413,0.6501,0.6501);

	this.shape_219 = new cjs.Shape();
	this.shape_219.graphics.f("#7F7F7F").s().p("Ag4A3IAAhuIBxAAIAABug");
	this.shape_219.setTransform(159.77,65.1131,0.6501,0.6501);

	this.shape_220 = new cjs.Shape();
	this.shape_220.graphics.f("#7F7F7F").s().p("Ag4A3IAAhtIBxAAIAABtg");
	this.shape_220.setTransform(168.0095,57.085,0.6501,0.6501);

	this.shape_221 = new cjs.Shape();
	this.shape_221.graphics.f("#7F7F7F").s().p("Ag4A3IAAhtIBxAAIAABtg");
	this.shape_221.setTransform(159.77,57.085,0.6501,0.6501);

	this.shape_222 = new cjs.Shape();
	this.shape_222.graphics.f("#7F7F7F").s().p("Ag4A4IAAhuIBxAAIAABug");
	this.shape_222.setTransform(159.77,49.0568,0.6501,0.6501);

	this.shape_223 = new cjs.Shape();
	this.shape_223.graphics.f("#FFFFFF").s().p("AiOBQIBUglQgMAgAOAXQAPAYAkAAQAdAAARgTQANgPAAgRQAAhFg4AAQgNAAhLAZIgTgWQgTgcAAggQAAgrAigdQAkgfA9AAQA7AAAwA0IhIAgQACgUgMgPQgNgQgZAAQgRAAgNAMQgPAMAAAUQAAAbAPAQQANAQASAAIBkgfQANAFANAPQAaAdAAAxQAAA2gwAhQgpAbgzAAQhsAAglhPg");
	this.shape_223.setTransform(250.5502,65.0644,0.6501,0.6501);

	this.shape_224 = new cjs.Shape();
	this.shape_224.graphics.f("#FFFFFF").s().p("AAECZIgggjIADhnIgBgHQgBgXgYgGIAAgBIgCAAIABgGIABAAIAAgEIAkgZIAFAAIAiAjIAABtQAAAcAeAFIAAAGIgIAEIAAAAIgkAXgAggh4IBEggIAAArIhEARg");
	this.shape_224.setTransform(234.075,59.5625);

	this.shape_225 = new cjs.Shape();
	this.shape_225.graphics.f("#FFFFFF").s().p("AhGCcIAAjbQgBgigugEIAAgMIA8gpQAQAAAVARQATAQAIATIBGg0QAMgBANAZQAQAbAAAiIhMA8IgJhPQgOACgLAMIAADmg");
	this.shape_225.setTransform(219.4288,64.8206,0.6501,0.6501);

	this.shape_226 = new cjs.Shape();
	this.shape_226.graphics.f("#FFFFFF").s().p("AgRCyQgfgSAAgOIAAjbIg0AAIAAglIBohSIAYAAIAABDIBJAAIAAA0IhJAAIAAC1QAAASAeAIIAeAGIAAAKIhLArg");
	this.shape_226.setTransform(203.3887,62.8867,0.6501,0.6501);

	this.shape_227 = new cjs.Shape();
	this.shape_227.graphics.f("#FFFFFF").s().p("AAGDdQAZgXAVgkQAZgrAAggQAAgvgbgdQgVgXgXAAQghAAgQAMIAADcIhTAAIAAlCQAAhMgZgCIAAgMIBfgtIAUAGQgHASAAAoIAAB7QAWgLATgQIAOgNQAvAAAoAhQA1ArAABQQAAA6g/A/Ig/Azg");
	this.shape_227.setTransform(182.912,60.644,0.6501,0.6501);

	this.shape_228 = new cjs.Shape();
	this.shape_228.graphics.f("#FFFFFF").s().p("AAzCVQgRgKgEgEQgJgNAAgQIhRA1QgRAAgagWQgegaAAgYQAAg0A6gjIBggpIgHgUQgMgUgcAAQgVAAgyAaQgIABgHgJQgGgIADgIIBxhPQBpAoAAAhIAACRQAAAZAQAOIAPAJIAAANIg6AmQgFAAgUgKgAgYASQgZAUAAAdQAAAUAXADQAYADAXgaIAAhDQgZACgUAQg");
	this.shape_228.setTransform(138.0419,65.0644,0.6501,0.6501);

	this.shape_229 = new cjs.Shape();
	this.shape_229.graphics.f("#FFFFFF").s().p("AglCHQhBgnAAhZQAAg/A9g5QAdgeAdgPQAwAfAmAvIiFBwQAPAmAqAJQAfAGAigJIAEAHIg1BMQg1gIgbgQgAgkAHIBBg2IgMgRQgPgSgPAAQgkAAANBZg");
	this.shape_229.setTransform(120.718,65.0806,0.6501,0.6501);

	this.shape_230 = new cjs.Shape();
	this.shape_230.graphics.f("#FFFFFF").s().p("AjgDYIAYgcQAXgjAAghIAAjPQAAg9gygMIAJgTQAiAABDgdQBEgeAwAAQBEAABRBYQBQBYAABJQAAAzhOBTQhXBchQAAQgTAAg+gQQg/gLgrAdgAhAi2QgVAWgBAkIAADrQgBBTBOAAQAwgBAqg9QApg+AAhFQAAhJgshDQgrhBgsAAQgiAAgVAWg");
	this.shape_230.setTransform(97.2997,60.0102,0.6501,0.6501);

	this.shape_231 = new cjs.Shape();
	this.shape_231.graphics.f("#000000").s().p("AhoABQgJgMABgDQCPATBTgBQgqAKilABQgDgDgIgLg");
	this.shape_231.setTransform(87.5318,249.745,0.6501,0.6501);

	this.shape_232 = new cjs.Shape();
	this.shape_232.graphics.f("#000000").s().p("AhaAFIgCgFQgBgEAEgBQAfAGA7gBQBGgDAWADQgDAEgRgCQhIAEgtAAQgcAAgSgBg");
	this.shape_232.setTransform(87.2824,249.0307,0.6501,0.6501);

	this.shape_233 = new cjs.Shape();
	this.shape_233.graphics.f("#000000").s().p("AiIgBQACgEAFABICzABQA7gDAdACIgBADQgsAEgwgCQg6AEh5AAQgEgDACgDg");
	this.shape_233.setTransform(89.7699,245.0874,0.6501,0.6501);

	this.shape_234 = new cjs.Shape();
	this.shape_234.graphics.f("#000000").s().p("AhVAFIgJgDQgGgBABgFQASACCsAAIAGgDQADADgBACIgDACQgmAEg/AAIhQgBg");
	this.shape_234.setTransform(87.0473,247.9721,0.6501,0.6501);

	this.shape_235 = new cjs.Shape();
	this.shape_235.graphics.f("#000000").s().p("AADAHQgkAAhMgDQgEgCABgDQACgFAEABQAnAFBGgBQBQgBAeACQgqAHg8AAIgIAAg");
	this.shape_235.setTransform(87.9105,246.5753,0.6501,0.6501);

	this.shape_236 = new cjs.Shape();
	this.shape_236.graphics.f("#000000").s().p("AiiAKQAAgBAEgFQAigBAMgDQANgDAhgCQDIgEAcgDIABAGQgXAIg6gCQhIgCguADIh6AMg");
	this.shape_236.setTransform(111.4691,273.017,0.6501,0.6501);

	this.shape_237 = new cjs.Shape();
	this.shape_237.graphics.f("#000000").s().p("Ah5AIQAsgNBJgBQBigBATgCQAFAAADADQAEAEgGACQh3gCh5AMg");
	this.shape_237.setTransform(122.3711,261.6877,0.6501,0.6501);

	this.shape_238 = new cjs.Shape();
	this.shape_238.graphics.f("#000000").s().p("AiGAAIENgJQABAHgDACQjBAAhJAKg");
	this.shape_238.setTransform(123.1791,263.2174,0.6501,0.6501);

	this.shape_239 = new cjs.Shape();
	this.shape_239.graphics.f("#000000").s().p("AjRAFIDCgFQCJgBA9gGQACACASAAQAMAAgIAJIlvABIgDADQgigDgMAAg");
	this.shape_239.setTransform(120.9092,264.2737,0.6501,0.6501);

	this.shape_240 = new cjs.Shape();
	this.shape_240.graphics.f("#000000").s().p("AgBAAQAAAAAAgBQABAAAAAAQAAgBAAAAQABAAAAAAQAEACgGADg");
	this.shape_240.setTransform(136.5035,269.764,0.6501,0.6501);

	this.shape_241 = new cjs.Shape();
	this.shape_241.graphics.f("#000000").s().p("AiuAmQAAgIgLADQgfADgjAFQgXAEgogBIAAgCQBOgDBbgOQBggOBHgFQCHgCBMgGIAfAAQATAAAKgGIgGgIQhIgCidAOQg6ACh/AMQhcAJhYgBQA8gJBHgEQBFgDA6gJIAFgFIggAAQgaAAgvAFQgEABgHADQgHACgEgDQgFAEgLAAIgQgBIAdgDQAPgCALgHIgCgBQgBgFAFgBQggABgaAGQgZAEglABQAvgGA+gLQAygKA6gFQDkgHB1AAQgEABgBACQg4AChxAJIgEgDQggAGhCADQAAAAABABQABAAAAAAQAAABABABQAAAAAAABQgBABAAAAQAAABAAAAQABABAAAAQAAABABAAQAEgFADABIAAACIB9gHIABAHQBmgHA4gBQADALgKACIgQABIAFAGQADAJgJADQgKAEgCAEQj0AFh+ASQAJAFASgCQAUgCAHACQCFgNBUAIQghADhQADQhJACgnAFQg4gEhwAHQAFgFAigFg");
	this.shape_241.setTransform(122.144,267.6703,0.6501,0.6501);

	this.shape_242 = new cjs.Shape();
	this.shape_242.graphics.f("#000000").s().p("Ai8AAIgCAAQANgEAJgEQAPAEgVAEIAEACQD1gBCsgPIAHACQAFABgCAFIgEAAQhoAIiWACQibADhlAIg");
	this.shape_242.setTransform(118.7065,271.6681,0.6501,0.6501);

	this.shape_243 = new cjs.Shape();
	this.shape_243.graphics.f("#000000").s().p("AAGAAIgEABQgQgBAUAAg");
	this.shape_243.setTransform(58.8,263.6074,0.6501,0.6501);

	this.shape_244 = new cjs.Shape();
	this.shape_244.graphics.f("#000000").s().p("AAzAAQgOAAhWACQgJgFBtADg");
	this.shape_244.setTransform(64.4174,265.6622,0.6501,0.6501);

	this.shape_245 = new cjs.Shape();
	this.shape_245.graphics.f("#000000").s().p("AgPgDQAGACAYgCIARABIAGACIgOACIgBAAIgPACQhLgCA0gFg");
	this.shape_245.setTransform(68.3221,261.7385,0.6501,0.6501);

	this.shape_246 = new cjs.Shape();
	this.shape_246.graphics.f("#000000").s().p("AgTgCQATAAARgCQAIAEgBABQgFADgrABIAFgHg");
	this.shape_246.setTransform(60.0064,266.0939,0.6501,0.6501);

	this.shape_247 = new cjs.Shape();
	this.shape_247.graphics.f("#000000").s().p("AgCABIABgCIAEABIAAACg");
	this.shape_247.setTransform(316.6283,254.5717,0.6501,0.6501);

	this.shape_248 = new cjs.Shape();
	this.shape_248.graphics.f("#000000").s().p("Ag/ADQgQgNAfAFQBOgCAoAKIgBAEg");
	this.shape_248.setTransform(312.2836,249.1172,0.6501,0.6501);

	this.shape_249 = new cjs.Shape();
	this.shape_249.graphics.f("#000000").s().p("AgCACQgPgEgogCQgBgHAHgBQAmgBASAHQAXAIAeADQABAGgGACQgigEgVgHg");
	this.shape_249.setTransform(311.4247,250.651,0.6501,0.6501);

	this.shape_250 = new cjs.Shape();
	this.shape_250.graphics.f("#000000").s().p("Ag8ABQgBgJASADIBoAKQgNACgSAAQgiAAg4gGg");
	this.shape_250.setTransform(309.4759,246.2943,0.6501,0.6501);

	this.shape_251 = new cjs.Shape();
	this.shape_251.graphics.f("#000000").s().p("AhCAAQATgGApAGQAxgCAYAFIhDABIgGAAQgkAAgYgEg");
	this.shape_251.setTransform(307.9175,247.7432,0.6501,0.6501);

	this.shape_252 = new cjs.Shape();
	this.shape_252.graphics.f("#000000").s().p("AAkABQgugDhIACQg7ABgVgHIABgGQAWACDOAEQAZAHBDADQAEAEgBACIgEADQg7gFg/gHg");
	this.shape_252.setTransform(309.3704,260.6334,0.6501,0.6501);

	this.shape_253 = new cjs.Shape();
	this.shape_253.graphics.f("#000000").s().p("Ah3AAQgFgDAEgDQADgDAFAAQAQACBlABQBJABAsANIAAACQh5gLh4ABg");
	this.shape_253.setTransform(298.4774,248.3938,0.6501,0.6501);

	this.shape_254 = new cjs.Shape();
	this.shape_254.graphics.f("#000000").s().p("AiEAAQgCgCAAgHQCyADBcAGIgBAKQhJgJjCgBg");
	this.shape_254.setTransform(297.6629,249.8913,0.6501,0.6501);

	this.shape_255 = new cjs.Shape();
	this.shape_255.graphics.f("#000000").s().p("AChALQhtgJkCgEQgIgKAMAAQASAAACgCIDGAHQAkAACeAOIAAAEQgOgBgfAFg");
	this.shape_255.setTransform(299.9256,251.4351,0.6501,0.6501);

	this.shape_256 = new cjs.Shape();
	this.shape_256.graphics.f("#000000").s().p("AAAgCQAAAAAAAAQAAAAAAAAQABABAAAAQABAAAAABIAAADQgGgDAEgCg");
	this.shape_256.setTransform(284.3383,257.3642,0.6501,0.6501);

	this.shape_257 = new cjs.Shape();
	this.shape_257.graphics.f("#000000").s().p("AA2A3QiUgEhqgIIgEgBQgCgEAFgBQAGAAABgCQBjAKBtACQCfACAyACIAEgDQgVgEARgDIAVAHIgDABIAGAFIBAAFIgBAGQhjgIidgCgADWAlIAGgBQAOAAgBACIgJACIgBABIgJgEgACHAiQg6gCgfABQhIgIiagFQBSgICHANQAIgCAUACQASACAJgFQiHgTjrgDQgCgEgLgEQgIgEADgIIAFgHQgDgCgNAAQgKgBADgKQBnAHA3AAIABgHIB9AIIAAgDIAGAEQgCgFAHgDQgggFhCgDIgEACIipgLIgFgIQDnAMBxABQA6AFAzAJQA8ALAxAGQgmgBgZgEQgYgFgggCQAEACgBAEIgCACQAFADAxAIIgPABQgLAAgFgEQgEAEgHgCIgLgFQgcABgtgFQgMgDgUADIAFAEQA6AKBFAEQBGADA8AIQhXABhcgIQh/gMg6gDIh0gHQhIgGgpABIgGAIQAJAHATAAIAgAAIDTAIQBEAEBiAOQBbAOBPAEIAAACQhJABg5gMQgLgDAAAHQAiAFAFAEIABACQgZAAg2gDg");
	this.shape_257.setTransform(298.7071,256.0343,0.6501,0.6501);

	this.shape_258 = new cjs.Shape();
	this.shape_258.graphics.f("#000000").s().p("AAZABIgjgBQg0ACAFgLQAkAGBGgDIAKAQQgMgIgWgBg");
	this.shape_258.setTransform(315.7986,253.2065,0.6501,0.6501);

	this.shape_259 = new cjs.Shape();
	this.shape_259.graphics.f("#000000").s().p("AgBABIABgBIACAAIgBABg");
	this.shape_259.setTransform(291.5199,265.5413,0.6501,0.6501);

	this.shape_260 = new cjs.Shape();
	this.shape_260.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_260.setTransform(289.6347,270.1567,0.6501,0.6501);

	this.shape_261 = new cjs.Shape();
	this.shape_261.graphics.f("#000000").s().p("AgFAAIAHAAIAEAAg");
	this.shape_261.setTransform(286.807,269.8317,0.6501,0.6501);

	this.shape_262 = new cjs.Shape();
	this.shape_262.graphics.f("#000000").s().p("AgpAEQgLgNAVAFQAzgDAaAKIAAADg");
	this.shape_262.setTransform(288.683,261.0519,0.6501,0.6501);

	this.shape_263 = new cjs.Shape();
	this.shape_263.graphics.f("#000000").s().p("AgBACQgKgEgagBQgBgIAFgBQAZgBALAHQAQAIAUACQAAAGgEADQgWgEgOgHg");
	this.shape_263.setTransform(288.1021,262.6075,0.6501,0.6501);

	this.shape_264 = new cjs.Shape();
	this.shape_264.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIgBABg");
	this.shape_264.setTransform(283.6542,268.5316,0.6501,0.6501);

	this.shape_265 = new cjs.Shape();
	this.shape_265.graphics.f("#FFFFFF").s().p("AgCAAIAAgBIAFABIAAACg");
	this.shape_265.setTransform(283.9793,265.2163,0.6501,0.6501);

	this.shape_266 = new cjs.Shape();
	this.shape_266.graphics.f("#000000").s().p("AgnACQgBgJAMACIBFAKQgKABgOAAQgWAAgigEg");
	this.shape_266.setTransform(286.8388,258.2718,0.6501,0.6501);

	this.shape_267 = new cjs.Shape();
	this.shape_267.graphics.f("#000000").s().p("AgsAAQAOgGAbAFQAggCAQAFIgtACIgEAAQgYAAgQgEg");
	this.shape_267.setTransform(285.7832,259.7404,0.6501,0.6501);

	this.shape_268 = new cjs.Shape();
	this.shape_268.graphics.f("#FFFFFF").s().p("AgIABIANgCIAEADg");
	this.shape_268.setTransform(280.7777,265.6226,0.6501,0.6501);

	this.shape_269 = new cjs.Shape();
	this.shape_269.graphics.f("#000000").s().p("AAYABQgegDgwACQgnADgOgIIAAgGQAeAFAuAAIBMAAQAQAGAtADQACAEAAABIgDAEQgngFgqgGg");
	this.shape_269.setTransform(286.6147,271.6844,0.6501,0.6501);

	this.shape_270 = new cjs.Shape();
	this.shape_270.graphics.f("#FFFFFF").s().p("AAAAAIACAAIgDABg");
	this.shape_270.setTransform(279.1201,265.5413,0.6501,0.6501);

	this.shape_271 = new cjs.Shape();
	this.shape_271.graphics.f("#FFFFFF").s().p("AghABQACgBABgDQADAEAGgBQAIgBABABQAiAAAMAEQgXgDgsAAg");
	this.shape_271.setTransform(281.314,264.94,0.6501,0.6501);

	this.shape_272 = new cjs.Shape();
	this.shape_272.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_272.setTransform(278.015,265.3788,0.6501,0.6501);

	this.shape_273 = new cjs.Shape();
	this.shape_273.graphics.f("#000000").s().p("AhOABQgEgCACgEQADgDADAAQAMACBBAAQAxAAAdANIAAACQhTgLhMADg");
	this.shape_273.setTransform(279.5027,260.4689,0.6501,0.6501);

	this.shape_274 = new cjs.Shape();
	this.shape_274.graphics.f("#000000").s().p("AhXABQgCgDAAgGQB2ABA9AGIgBAKQgxgJh/ABg");
	this.shape_274.setTransform(278.9706,261.9985,0.6501,0.6501);

	this.shape_275 = new cjs.Shape();
	this.shape_275.graphics.f("#000000").s().p("ABrAJQhTgJihAAQgFgKAIAAQAMAAACgCICCAFQAbAABnAMIgBAEQgHgBgXAFg");
	this.shape_275.setTransform(280.4552,263.4937,0.6501,0.6501);

	this.shape_276 = new cjs.Shape();
	this.shape_276.graphics.f("#000000").s().p("AAAgCQAAAAAAAAQAAAAAAAAQABABAAAAQAAAAABABIgBADQgDgDACgCg");
	this.shape_276.setTransform(270.0228,268.6751,0.6501,0.6501);

	this.shape_277 = new cjs.Shape();
	this.shape_277.graphics.f("#000000").s().p("AAjAvQhigChGgHIgDAAQgCgJAJABQBBAIBIABQBpABAjACIACgDQgOgDALgEIAOAHIgBABIADAFIArAEIgBAFQhCgGhogBgACOAbIADAAQANAAgKAEIgBABIgFgFgABZAaQgmgCgVACQgvgIhmgDQA2gJBZAMQAFgDAOADQAMABAGgFQhXgPifgDQgBgEgHgEQgFgDACgJIADgHQgCgBgJAAQgGgBACgLQBEAHAlgCIAAgGIBTAGIABgDIAEAFQADgDAAgGIhBAAIgDAAIhwAAIgDgHQCZAHBLAAIBIABQApAKAfAFQgZAAgQgEQgSgFgUgBQADABgBAFIgBABQAHAGAKACIATADIgKABQgIABgDgFQgDAEgEgCIgHgEQgTABgegFQgHgDgOADIADAFQAnAJAtADQAwADAnAIQg7ACg9gIQhVgLglgDQgTAAg6gGQgwgEgbABIgEAIQAGAGANAAIAVAAICMAGQAtAEBBANQA9AMA0ADIAAADQgxACglgMQgHgDAAAHQAWAFADAEIABABIgHAAIgugBgACOAbIAAAAg");
	this.shape_277.setTransform(279.5923,267.654,0.6501,0.6501);

	this.shape_278 = new cjs.Shape();
	this.shape_278.graphics.f("#000000").s().p("AgJgBIANAAIAGADQgHgCgMgBg");
	this.shape_278.setTransform(292.8688,264.6963,0.6501,0.6501);

	this.shape_279 = new cjs.Shape();
	this.shape_279.graphics.f("#000000").s().p("AhFACQgDgCAAgGQBhAFAwAGIgtACQgrAAg2gFg");
	this.shape_279.setTransform(168.5925,268.5877,0.6501,0.6501);

	this.shape_280 = new cjs.Shape();
	this.shape_280.graphics.f("#000000").s().p("AhiAEQgEgDABgFQCIgBBDAEQhPAGhWAAIgjgBg");
	this.shape_280.setTransform(142.9051,268.9395,0.6501,0.6501);

	this.shape_281 = new cjs.Shape();
	this.shape_281.graphics.f("#000000").s().p("AiDAHIAAgGQClACBhgMIABACQgVAIhKABQgSAAhCAGQgZACgUAAQgXAAgQgDg");
	this.shape_281.setTransform(143.0636,270.356,0.6501,0.6501);

	this.shape_282 = new cjs.Shape();
	this.shape_282.graphics.f("#FFFFFF").s().p("AAAACQAHgMAKgbIACgBQgKAzgbAaQADgIAPgdg");
	this.shape_282.setTransform(186.926,166.1804,0.6501,0.6501);

	this.shape_283 = new cjs.Shape();
	this.shape_283.graphics.f("#FFFFFF").s().p("AgIASQAEgnAPgZQgIARgDAdQgGAigEANQADgQgBgNg");
	this.shape_283.setTransform(198.9196,132.2801,0.6501,0.6501);

	this.shape_284 = new cjs.Shape();
	this.shape_284.graphics.f("#FFFFFF").s().p("AgJAKQAFgMAMgHIACACIgTARg");
	this.shape_284.setTransform(270.6044,201.0234,0.6501,0.6501);

	this.shape_285 = new cjs.Shape();
	this.shape_285.graphics.f("#FFFFFF").s().p("AgHgLIgBAAIAAgCQAWAOgGANIgPgZg");
	this.shape_285.setTransform(269.3934,200.7959,0.6501,0.6501);

	this.shape_286 = new cjs.Shape();
	this.shape_286.graphics.f("#FFFFFF").s().p("AAAAAIgHgMIADAEQAPAOgEAIQgBgBgGgNg");
	this.shape_286.setTransform(268.5452,197.6268,0.6501,0.6501);

	this.shape_287 = new cjs.Shape();
	this.shape_287.graphics.f("#FFFFFF").s().p("AgRAFIgCABQAEgHAkgJQgSAHgGADIgRALQAAgEADgCg");
	this.shape_287.setTransform(273.04,199.0407,0.6501,0.6501);

	this.shape_288 = new cjs.Shape();
	this.shape_288.graphics.f("#FFFFFF").s().p("AAAgEIABAAIAAAJIgBgJg");
	this.shape_288.setTransform(142.5923,135.6035,0.6501,0.6501);

	this.shape_289 = new cjs.Shape();
	this.shape_289.graphics.f("#FFFFFF").s().p("AARgIQgQAAgKALIgBgBQgDADgDAFQAIgVAZADg");
	this.shape_289.setTransform(136.9856,130.3377,0.6501,0.6501);

	this.shape_290 = new cjs.Shape();
	this.shape_290.graphics.f("#FFFFFF").s().p("AgHgEIAAgCQAFABAKAMQgIgFgHgGg");
	this.shape_290.setTransform(147.874,133.0601,0.6501,0.6501);

	this.shape_291 = new cjs.Shape();
	this.shape_291.graphics.f("#FFFFFF").s().p("AgXAIIADgBQgBAAAAAAQAAAAAAAAQAAgBAAAAQAAgBAAAAQADgDAOgEQAJgIATABQgJADgFABIAAACQgHgDgLAGQgCAAgIAEQAJADACADIgQgCg");
	this.shape_291.setTransform(151.4168,140.7272,0.6501,0.6501);

	this.shape_292 = new cjs.Shape();
	this.shape_292.graphics.f("#000000").s().p("AgFgDIADADIgBgCIAJAEQAAAAgBABQAAAAgBAAQgBABAAAAQgBAAAAAAQgDAAgEgHg");
	this.shape_292.setTransform(113.8111,107.1248,0.6501,0.6501);

	this.shape_293 = new cjs.Shape();
	this.shape_293.graphics.f("#FFFFFF").s().p("AgSAOQAFgEAKgDIgHgCQADgCALgCIgCgBIAGgCIgGgCIANgCIgIgIQAGADAFABQgDAJgMAIQgJAIgHAAIgFgBg");
	this.shape_293.setTransform(140.5446,113.2569,0.6501,0.6501);

	this.shape_294 = new cjs.Shape();
	this.shape_294.graphics.f("#FFFFFF").s().p("AgvAFQAcACANgCQAagJAPgDIAEAAIAJgCQgjATgfAAQgPAAgOgFg");
	this.shape_294.setTransform(185.3984,137.3128,0.6501,0.6501);

	this.shape_295 = new cjs.Shape();
	this.shape_295.graphics.f("#FFFFFF").s().p("AgGAAQAEgKAKgSIAAgBQACgDAHgDIAAACQgIAFgJATIgGARQgIAUgCAIQgBgJALgbg");
	this.shape_295.setTransform(125.1519,107.773,0.6501,0.6501);

	this.shape_296 = new cjs.Shape();
	this.shape_296.graphics.f("#FFFFFF").s().p("AgFgKIACACQAMAGgDANQgGgNgFgIg");
	this.shape_296.setTransform(206.2191,99.4848,0.6501,0.6501);

	this.shape_297 = new cjs.Shape();
	this.shape_297.graphics.f("#FFFFFF").s().p("AAAg2QAHAOgCAoQgCAlgIASQAKhJgFgkg");
	this.shape_297.setTransform(208.7478,111.202,0.6501,0.6501);

	this.shape_298 = new cjs.Shape();
	this.shape_298.graphics.f("#FFFFFF").s().p("AgegGIAhAJQAiALAVABQg/gCgZgTgAg5gNQAFgDATAIIADACIgbgHg");
	this.shape_298.setTransform(175.8589,136.2513,0.6501,0.6501);

	this.shape_299 = new cjs.Shape();
	this.shape_299.graphics.f("#FFFFFF").s().p("AgBANIAAgaQAGATgFAHg");
	this.shape_299.setTransform(240.6637,216.3809,0.6501,0.6501);

	this.shape_300 = new cjs.Shape();
	this.shape_300.graphics.f("#FFFFFF").s().p("AgFAnIAAgEIAFgeIAFgvQACASgCAbQgCAlgIADg");
	this.shape_300.setTransform(235.7045,215.0971,0.6501,0.6501);

	this.shape_301 = new cjs.Shape();
	this.shape_301.graphics.f("#FFFFFF").s().p("AAGgEQgIgTgLAAQAFgDAJAEIgBAAQASAPgGAgQABgMgHgRg");
	this.shape_301.setTransform(241.5672,203.2348,0.6501,0.6501);

	this.shape_302 = new cjs.Shape();
	this.shape_302.graphics.f("#FFFFFF").s().p("AgFAoIAEgqQABgdAGgOQgFAZgBBCg");
	this.shape_302.setTransform(241.6282,214.1057,0.6501,0.6501);

	this.shape_303 = new cjs.Shape();
	this.shape_303.graphics.f("#FFFFFF").s().p("AgKA2IACg9QAAhLAQgdIAEgBIgDADIADACQgTApAABCQAEBLgBAmQgHgVABgmg");
	this.shape_303.setTransform(235.1886,210.2379,0.6501,0.6501);

	this.shape_304 = new cjs.Shape();
	this.shape_304.graphics.f("#FFFFFF").s().p("AACgGQAGgYgDgMQAFANgFAZIgMAvQgBgHAKgqg");
	this.shape_304.setTransform(209.6795,214.5608,0.6501,0.6501);

	this.shape_305 = new cjs.Shape();
	this.shape_305.graphics.f("#FFFFFF").s().p("AAAgDQgCgCAFgBIgFANIACgKg");
	this.shape_305.setTransform(205.8589,211.9281,0.6501,0.6501);

	this.shape_306 = new cjs.Shape();
	this.shape_306.graphics.f("#FFFFFF").s().p("AAEAgQgKgpgJg6IAAgDQANAsADAZQAQAwgBAYQgBgNgLgag");
	this.shape_306.setTransform(158.8152,214.1545,0.6501,0.6501);

	this.shape_307 = new cjs.Shape();
	this.shape_307.graphics.f("#FFFFFF").s().p("AgFgdIAKA4QAAABABAAQAAABAAAAQAAABAAAAQAAAAgBAAQgFgNgFgug");
	this.shape_307.setTransform(158.5799,216.2184,0.6501,0.6501);

	this.shape_308 = new cjs.Shape();
	this.shape_308.graphics.f("#FFFFFF").s().p("AAEg1IAAAEQABAEgDAsQgCAvgDAIQACg2AFg1g");
	this.shape_308.setTransform(166.2462,214.2195,0.6501,0.6501);

	this.shape_309 = new cjs.Shape();
	this.shape_309.graphics.f("#FFFFFF").s().p("AAAhHIAAgCQAGAMgDAWQgDAaAAAKIgDBNQAAgxADhgg");
	this.shape_309.setTransform(165.6756,211.1967,0.6501,0.6501);

	this.shape_310 = new cjs.Shape();
	this.shape_310.graphics.f("#FFFFFF").s().p("AgIAKQAHgEAKgRQADAMgMAJIAAACQgFgDgDABg");
	this.shape_310.setTransform(97.6605,183.0981,0.6501,0.6501);

	this.shape_311 = new cjs.Shape();
	this.shape_311.graphics.f("#FFFFFF").s().p("AgMALIAFgCIAGgVQADAKgGAGQAHADAKgBIABAHIgJAAQgKAAgHgCg");
	this.shape_311.setTransform(262.4624,217.154,0.6501,0.6501);

	this.shape_312 = new cjs.Shape();
	this.shape_312.graphics.f("#FFFFFF").s().p("AgCgCQADgRAAgeIAAgEQAQAFgKAtIgQA5QgDgSAKgmg");
	this.shape_312.setTransform(270.9749,210.5792,0.6501,0.6501);

	this.shape_313 = new cjs.Shape();
	this.shape_313.graphics.f("#FFFFFF").s().p("AgdgKQAHg0AbAEIgCgCIAFABIgTAKQgFAGgCATQgCAYgCAEQgDAJgBAVQgBATgEAIIAChHgAAcg2IAEAAIgBABIgDgBgAAIg7IABgBQAJgCAKAIgAAIg7g");
	this.shape_313.setTransform(265.0139,209.4903,0.6501,0.6501);

	this.shape_314 = new cjs.Shape();
	this.shape_314.graphics.f("#FFFFFF").s().p("AgEALIAEgVIADgEQAHAOgLAPg");
	this.shape_314.setTransform(270.7392,197.4156,0.6501,0.6501);

	this.shape_315 = new cjs.Shape();
	this.shape_315.graphics.f("#FFFFFF").s().p("AAFgPQABgNAFgkQAAghgXgPIgCgDQAcAAABA3IgGBIQgGBlgDADQAAgsAFhXg");
	this.shape_315.setTransform(242.7008,208.8565,0.6501,0.6501);

	this.shape_316 = new cjs.Shape();
	this.shape_316.graphics.f("#FFFFFF").s().p("AgKgMIABAAQABgRAMAMQAMAMgHAMQgCgEgHgGQgCAGgBAUQgEgMgDgXg");
	this.shape_316.setTransform(142.3186,215.1116,0.6501,0.6501);

	this.shape_317 = new cjs.Shape();
	this.shape_317.graphics.f("#FFFFFF").s().p("AgGAAQgEgRAMgEIgCgEQAIAHAAALQgKgDABAOIADAVIgIgZg");
	this.shape_317.setTransform(134.4138,219.6312,0.6501,0.6501);

	this.shape_318 = new cjs.Shape();
	this.shape_318.graphics.f("#FFFFFF").s().p("AgCgMIgDAFIgBgHQgDAAgCAAIAFgCQAMAAAFAMQADAKgDAMIgNgeg");
	this.shape_318.setTransform(89.8647,222.7515,0.6501,0.6501);

	this.shape_319 = new cjs.Shape();
	this.shape_319.graphics.f("#FFFFFF").s().p("AgIAIQAIgHADgMIACAAQAAAAABAAQABgBAAABQABAAAAABQAAAAAAABQgCAPgGAGg");
	this.shape_319.setTransform(109.6995,218.3977,0.6501,0.6501);

	this.shape_320 = new cjs.Shape();
	this.shape_320.graphics.f("#FFFFFF").s().p("AgNAcQAIgRANgkIAAgCQAEAAACACQgBALgIAPIgLAbIgDAAIgEAAg");
	this.shape_320.setTransform(102.7927,220.1404,0.6501,0.6501);

	this.shape_321 = new cjs.Shape();
	this.shape_321.graphics.f("#FFFFFF").s().p("AgJASQgBgRASgSIACADQABAJgHAMQgEALgHAAIgCAAg");
	this.shape_321.setTransform(100.504,214.2245,0.6501,0.6501);

	this.shape_322 = new cjs.Shape();
	this.shape_322.graphics.f("#FFFFFF").s().p("AgNAMQAIgNgPgKQANgEAcAMQgDAGgNAFQgIAFgGAAIgEgBg");
	this.shape_322.setTransform(106.9205,211.8696,0.6501,0.6501);

	this.shape_323 = new cjs.Shape();
	this.shape_323.graphics.f("#FFFFFF").s().p("AgKAEQgIgRASgEQAAAAAAAAQAAABgBAAQAAABABAAQAAABAAAAIgCAAQgEAYATAHIgHABQgLAAgFgOg");
	this.shape_323.setTransform(104.3786,215.5549,0.6501,0.6501);

	this.shape_324 = new cjs.Shape();
	this.shape_324.graphics.f("#FFFFFF").s().p("AAAAUQgCgEgFACQgDgEABgLIARgDIgBgXIADAhIgDANIgBABQgDAAgDgEg");
	this.shape_324.setTransform(173.4699,258.5713,0.6501,0.6501);

	this.shape_325 = new cjs.Shape();
	this.shape_325.graphics.f("#FFFFFF").s().p("AAAgOQADASgBALQgFgGADgXg");
	this.shape_325.setTransform(163.4134,257.6757,0.6501,0.6501);

	this.shape_326 = new cjs.Shape();
	this.shape_326.graphics.f("#FFFFFF").s().p("AgBgaIACANQAEAbgBANQgLgmAGgPg");
	this.shape_326.setTransform(174.8627,258.342,0.6501,0.6501);

	this.shape_327 = new cjs.Shape();
	this.shape_327.graphics.f("#FFFFFF").s().p("AgCgaIAFAaIAAAbg");
	this.shape_327.setTransform(175.7126,257.9682,0.6501,0.6501);

	this.shape_328 = new cjs.Shape();
	this.shape_328.graphics.f("#FFFFFF").s().p("AAAATQAAgFgFAAQgGgBAAgFQAAgEgDgPQgBgNAKAJQgDAKAMADQANADgCAJQgDAAgEAGQgCADgDAAIgDAAg");
	this.shape_328.setTransform(161.7584,257.2143,0.6501,0.6501);

	this.shape_329 = new cjs.Shape();
	this.shape_329.graphics.f("#FFFFFF").s().p("AgEAOIgDgDIACgcQAKABABAOQAAAPACAFIgBAAIgLgEg");
	this.shape_329.setTransform(160.095,256.1173,0.6501,0.6501);

	this.shape_330 = new cjs.Shape();
	this.shape_330.graphics.f("#FFFFFF").s().p("AgDglQACABADAPIACA7IgHhLg");
	this.shape_330.setTransform(176.3464,257.0581,0.6501,0.6501);

	this.shape_331 = new cjs.Shape();
	this.shape_331.graphics.f("#FFFFFF").s().p("AAAAaQAAgIgCgRQgCgQADgKIACAAQAAAgADATg");
	this.shape_331.setTransform(157.7223,255.7255,0.6501,0.6501);

	this.shape_332 = new cjs.Shape();
	this.shape_332.graphics.f("#FFFFFF").s().p("AAGAQQAAgQgEgIQABAhgFAQIgEAAQAFgNgGgZQgFgWAGgMIAFAAIADAVIAEggQAEACgBAIQAAAJACADIgFA/IAAgbg");
	this.shape_332.setTransform(177.6296,256.5706,0.6501,0.6501);

	this.shape_333 = new cjs.Shape();
	this.shape_333.graphics.f("#FFFFFF").s().p("AgDAEQAAgCAFgFQAAABABAAQAAABAAAAQABABAAAAQAAAAgBAAQgCAEgCAAIgCAAg");
	this.shape_333.setTransform(170.4167,252.9687,0.6501,0.6501);

	this.shape_334 = new cjs.Shape();
	this.shape_334.graphics.f("#FFFFFF").s().p("AgCgmQAGAngCAmQgFgkABgpg");
	this.shape_334.setTransform(155.6637,254.4741,0.6501,0.6501);

	this.shape_335 = new cjs.Shape();
	this.shape_335.graphics.f("#FFFFFF").s().p("AgQACIAAgDIAhAAIAAADQgYgFgJAFg");
	this.shape_335.setTransform(170.6909,251.1101,0.6501,0.6501);

	this.shape_336 = new cjs.Shape();
	this.shape_336.graphics.f("#FFFFFF").s().p("AAAgCIABAAIAAAFg");
	this.shape_336.setTransform(161.1351,250.9313,0.6501,0.6501);

	this.shape_337 = new cjs.Shape();
	this.shape_337.graphics.f("#FFFFFF").s().p("AAAADIAAgFIABAAIAAAFg");
	this.shape_337.setTransform(153.4645,248.8349,0.6501,0.6501);

	this.shape_338 = new cjs.Shape();
	this.shape_338.graphics.f("#FFFFFF").s().p("AgFABQAEgDAHADg");
	this.shape_338.setTransform(161.7364,248.583,0.6501,0.6501);

	this.shape_339 = new cjs.Shape();
	this.shape_339.graphics.f("#000000").s().p("AAAAPQgSgDgFABIAAgXIAsgEQAAAAAAAAQAAABAAAAQABABAAAAQABABAAABQgMADAHANQACABAAAFQgFADgJAAIgGAAg");
	this.shape_339.setTransform(170.6422,249.0648,0.6501,0.6501);

	this.shape_340 = new cjs.Shape();
	this.shape_340.graphics.f("#000000").s().p("ABSBjIgpgDIABgBQgJgEgXAAIgcgHQgHgVgDgEQgFADACAGQACAHgBADIADAEQgGACgDgLQgCgDABgLQABgJgGgCQgGAFAEAJQAEALgCAFQglgHgbgOIgMgCQgBgFAAgVQAAgRgGgJQgHAJACAQQAFARAAAIIgSAAQgEgTAAgoQgFgCgDAFQAFAigCAVIgGgCIgDhmIgJgBQAAgMgDgCQgIgDgBAHIAAAKIAAgJIAAgBIAAgIQgIgDgCgLQgCgLgEgDQAvArAqgFQACADgKAJQgKAKACAHQAQAXAHAAQAvgLAFggQAQgBAaAJQAeALALABQAAAHgPARQgMAMAIANIAHALQAFAGAGABQAJAFALgFIATgJQAYgagCgQQBKABAggPQABBCgEAgQgCgMABgfQAAgagEgQIgFAAQAEBEgDAkQgEAFgLABIgRACIgDgLQABAMgLgBQgQgBgDACQgLAEgQAAIgOgBgAjDARIABgPQABAWAHALQACABAFgGQgCgKgBhJIAFBjQgVgDADgagAi2g1g");
	this.shape_340.setTransform(166.7328,254.1514,0.6501,0.6501);

	this.shape_341 = new cjs.Shape();
	this.shape_341.graphics.f("#FFFFFF").s().p("AgcAXIgBgXQgBgNALgDQAaABATgHIAEALQgCALAAAXg");
	this.shape_341.setTransform(170.5743,248.8349,0.6501,0.6501);

	this.shape_342 = new cjs.Shape();
	this.shape_342.graphics.f("#FFFFFF").s().p("AADADQgDACgDgEQgEgDgCABQACgDAEACQADABAAACIAIgCQADAFgDAAIgFgBg");
	this.shape_342.setTransform(171.8198,246.59,0.6501,0.6501);

	this.shape_343 = new cjs.Shape();
	this.shape_343.graphics.f("#FFFFFF").s().p("AAAACIAAgDIABAAIAAADg");
	this.shape_343.setTransform(170.8209,245.7309,0.6501,0.6501);

	this.shape_344 = new cjs.Shape();
	this.shape_344.graphics.f("#000000").s().p("AgUALQgFgKALgRIAlAFIgJAcg");
	this.shape_344.setTransform(161.9531,246.6247,0.6501,0.6501);

	this.shape_345 = new cjs.Shape();
	this.shape_345.graphics.f("#FFFFFF").s().p("AAAACIAAgDIABAAIAAADg");
	this.shape_345.setTransform(170.0246,245.0809,0.6501,0.6501);

	this.shape_346 = new cjs.Shape();
	this.shape_346.graphics.f("#FFFFFF").s().p("AghATQAFgHAFgRQAHgOAKgEQAbACANAFIgFAnQgHABgKAAQgRAAgcgFg");
	this.shape_346.setTransform(161.8014,246.5074,0.6501,0.6501);

	this.shape_347 = new cjs.Shape();
	this.shape_347.graphics.f("#FFFFFF").s().p("AgJgFIACgHQAIgBAHAOQAEAKgCACIgBABQgMAAgGgTg");
	this.shape_347.setTransform(246.1027,245.5683,0.6501,0.6501);

	this.shape_348 = new cjs.Shape();
	this.shape_348.graphics.f("#FFFFFF").s().p("AAPAaQgKABghgxIACgFIAZAUQAIAGAGgCQATATgEAJQgFADgDAAQgBAAgBAAQAAAAgBgBQAAAAgBAAQAAAAgBgBg");
	this.shape_348.setTransform(244.1327,245.4361,0.6501,0.6501);

	this.shape_349 = new cjs.Shape();
	this.shape_349.graphics.f("#FFFFFF").s().p("AgSgcQAAAJAHANIAMATIgRgVQgLgNAAgKIAEAAQAAAAAAABQAAAAAAAAQAAABABAAQAAABABAAQAFAAABgBIAAgCQAHAAAEAIIAHANQAUAdAFANg");
	this.shape_349.setTransform(238.7354,246.316,0.6501,0.6501);

	this.shape_350 = new cjs.Shape();
	this.shape_350.graphics.f("#FFFFFF").s().p("Ag0A8QgCgDAAgLQADABAEgFQAAgUgCgkQABgeATgUQA0ABAVAiQAQAXgGAyQgcAVglAAQgTAAgWgFg");
	this.shape_350.setTransform(176.2208,248.0115,0.6501,0.6501);

	this.shape_351 = new cjs.Shape();
	this.shape_351.graphics.f("#FFFFFF").s().p("AgdgdQAAgHAMACQAhApAOAcg");
	this.shape_351.setTransform(242.002,245.4506,0.6501,0.6501);

	this.shape_352 = new cjs.Shape();
	this.shape_352.graphics.f("#FFFFFF").s().p("AgfgkQAKgJASAcIAjA1QgDgBgDAFIg5hMg");
	this.shape_352.setTransform(240.3443,245.8557,0.6501,0.6501);

	this.shape_353 = new cjs.Shape();
	this.shape_353.graphics.f("#FFFFFF").s().p("AgBgBIADAAQAAAAAAABQAAAAAAAAQgBAAAAABQAAAAgBABg");
	this.shape_353.setTransform(163.6411,243.0657,0.6501,0.6501);

	this.shape_354 = new cjs.Shape();
	this.shape_354.graphics.f("#FFFFFF").s().p("AgEgOQAIANAFAQQgYgYALgFg");
	this.shape_354.setTransform(248.6045,243.8132,0.6501,0.6501);

	this.shape_355 = new cjs.Shape();
	this.shape_355.graphics.f("#FFFFFF").s().p("AgJgOQAMAOAHAPQgSgPgBgOg");
	this.shape_355.setTransform(249.7051,243.6995,0.6501,0.6501);

	this.shape_356 = new cjs.Shape();
	this.shape_356.graphics.f("#FFFFFF").s().p("AgGA2QgYgNgMgDQgLgBADgJQALgDAAgOQAAgQAEgFQAFgdAKAFQAHAEAJgDQAKgFAGgBQAHgFAKgQQALgLALAIIgQAZQgKAPAAANQALADgGAKQgJAAgCADIAAAgQgBATANADIAAAIQgPgCgWgMg");
	this.shape_356.setTransform(166.8394,247.0924,0.6501,0.6501);

	this.shape_357 = new cjs.Shape();
	this.shape_357.graphics.f("#FFFFFF").s().p("AgQgXQABgBAEgBIAcAzQgLgLgWgmg");
	this.shape_357.setTransform(246.6823,243.9433,0.6501,0.6501);

	this.shape_358 = new cjs.Shape();
	this.shape_358.graphics.f("#FFFFFF").s().p("AAGgFQADgLgKgGQAFAAAGAKIgEAHIgDAFQgKASgCAFQADgLAMgRg");
	this.shape_358.setTransform(173.4537,243.537,0.6501,0.6501);

	this.shape_359 = new cjs.Shape();
	this.shape_359.graphics.f("#FFFFFF").s().p("AgEgBIAIABIgEABIgBABQgBAAAAAAQAAgBgBAAQAAgBAAAAQAAAAgBgBg");
	this.shape_359.setTransform(172.4623,242.0117,0.6501,0.6501);

	this.shape_360 = new cjs.Shape();
	this.shape_360.graphics.f("#FFFFFF").s().p("AgCgDIAFAFIAAACg");
	this.shape_360.setTransform(168.4807,242.1394,0.6501,0.6501);

	this.shape_361 = new cjs.Shape();
	this.shape_361.graphics.f("#FFFFFF").s().p("AgTgdIAGAAQATAnAOARQAAAAAAABQAAAAAAAAQgBABAAAAQgBABAAABQgUgjgRgZg");
	this.shape_361.setTransform(247.2105,243.1957,0.6501,0.6501);

	this.shape_362 = new cjs.Shape();
	this.shape_362.graphics.f("#FFFFFF").s().p("AABgCIAAAEIgBABg");
	this.shape_362.setTransform(168.0257,241.0993,0.6501,0.6501);

	this.shape_363 = new cjs.Shape();
	this.shape_363.graphics.f("#FFFFFF").s().p("AgCACQgBgFAGACIAAADg");
	this.shape_363.setTransform(253.3086,240.7354,0.6501,0.6501);

	this.shape_364 = new cjs.Shape();
	this.shape_364.graphics.f("#FFFFFF").s().p("AgFgJQAKAFABAOQgBgKgKgJg");
	this.shape_364.setTransform(167.7982,239.9779,0.6501,0.6501);

	this.shape_365 = new cjs.Shape();
	this.shape_365.graphics.f("#FFFFFF").s().p("AgJAGIATgLIgLALg");
	this.shape_365.setTransform(166.3843,239.5229,0.6501,0.6501);

	this.shape_366 = new cjs.Shape();
	this.shape_366.graphics.f("#FFFFFF").s().p("AgEATQAAgOAHADQgDACACAGQAAABgBABQAAAAAAAAQAAABgBAAQAAAAAAAAIgEAAgAADAIQgCgIgIgSQAPALAAAWIgFgHgAADAIIAAAAg");
	this.shape_366.setTransform(254.0117,239.4062,0.6501,0.6501);

	this.shape_367 = new cjs.Shape();
	this.shape_367.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_367.setTransform(250.0789,237.849,0.6501,0.6501);

	this.shape_368 = new cjs.Shape();
	this.shape_368.graphics.f("#FFFFFF").s().p("AgBACIAAgCIADAAIAAACg");
	this.shape_368.setTransform(165.6042,237.7352,0.6501,0.6501);

	this.shape_369 = new cjs.Shape();
	this.shape_369.graphics.f("#FFFFFF").s().p("AgiBZQgPgDgCgIQgRgCgUgUQgGgGALgjQAHgJAfguQAXgjATgSQAbAPAPAGQAZAJAUgMIAGACQADACgEADQgwAQggA8QgKAGgIASIgOAdQACAMACABIALAAIAAAUIgagFg");
	this.shape_369.setTransform(160.5322,243.602,0.6501,0.6501);

	this.shape_370 = new cjs.Shape();
	this.shape_370.graphics.f("#000000").s().p("AgSAFQgHgIAEgFIAYgIQAPgFAGAPQgZALgIANQAAgDgJgKg");
	this.shape_370.setTransform(242.2635,237.7098,0.6501,0.6501);

	this.shape_371 = new cjs.Shape();
	this.shape_371.graphics.f("#FFFFFF").s().p("AgOgaIADAAIAaA1QgagqgDgLg");
	this.shape_371.setTransform(254.483,237.9465,0.6501,0.6501);

	this.shape_372 = new cjs.Shape();
	this.shape_372.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_372.setTransform(239.7105,236.1101,0.6501,0.6501);

	this.shape_373 = new cjs.Shape();
	this.shape_373.graphics.f("#FFFFFF").s().p("AgZABIgIgIQAOgJAjgJIASAcIgsAXQgCgBgNgYg");
	this.shape_373.setTransform(242.1807,237.6377,0.6501,0.6501);

	this.shape_374 = new cjs.Shape();
	this.shape_374.graphics.f("#FFFFFF").s().p("AgIgJQAEgKAEAKQAJAOAAAKQgJgGgIgSg");
	this.shape_374.setTransform(256.1902,236.7602,0.6501,0.6501);

	this.shape_375 = new cjs.Shape();
	this.shape_375.graphics.f("#FFFFFF").s().p("AgBACIAAgCIADAAIAAACg");
	this.shape_375.setTransform(240.4093,235.395,0.6501,0.6501);

	this.shape_376 = new cjs.Shape();
	this.shape_376.graphics.f("#FFFFFF").s().p("AAHAAIgNAFQAGgRAHAMg");
	this.shape_376.setTransform(241.9532,235.5048,0.6501,0.6501);

	this.shape_377 = new cjs.Shape();
	this.shape_377.graphics.f("#FFFFFF").s().p("AAAABIAAgCIABAAIAAACg");
	this.shape_377.setTransform(241.1081,235.07,0.6501,0.6501);

	this.shape_378 = new cjs.Shape();
	this.shape_378.graphics.f("#FFFFFF").s().p("AgTgiIAEgGIAjBPIgCACQgGAAgfhLg");
	this.shape_378.setTransform(254.9055,236.7173,0.6501,0.6501);

	this.shape_379 = new cjs.Shape();
	this.shape_379.graphics.f("#FFFFFF").s().p("AADAAIgFACQAEgHABAFg");
	this.shape_379.setTransform(240.6693,234.4205,0.6501,0.6501);

	this.shape_380 = new cjs.Shape();
	this.shape_380.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_380.setTransform(246.5848,232.7136,0.6501,0.6501);

	this.shape_381 = new cjs.Shape();
	this.shape_381.graphics.f("#FFFFFF").s().p("AAAACIAAgDIABAAIAAADg");
	this.shape_381.setTransform(239.5805,232.2585,0.6501,0.6501);

	this.shape_382 = new cjs.Shape();
	this.shape_382.graphics.f("#FFFFFF").s().p("AACgFQgFgDgHAIQADgHAHABQAHAAAEAGIgHAIQAEgIgGgFg");
	this.shape_382.setTransform(247.885,232.3061,0.6501,0.6501);

	this.shape_383 = new cjs.Shape();
	this.shape_383.graphics.f("#FFFFFF").s().p("AAAADIAAgFIABAAIAAAFg");
	this.shape_383.setTransform(239.5642,231.8197,0.6501,0.6501);

	this.shape_384 = new cjs.Shape();
	this.shape_384.graphics.f("#FFFFFF").s().p("Ag2A3QgWg1gDggQAUgDAYgXQgCgWAZgCIAlACIgKAkQgFAVAQAJQAKABABAHQAAADgCABQAFAFANAXQAJASAPACIADAEQgIAJgTAGQgWAHgGAFQgNgCghAEQgcgBgFgZg");
	this.shape_384.setTransform(236.6553,236.9064,0.6501,0.6501);

	this.shape_385 = new cjs.Shape();
	this.shape_385.graphics.f("#000000").s().p("AgKAaQgBgKgPgPQAHgBAKgLQAKgMAHgDQABAHASAMQgFAJgZAYg");
	this.shape_385.setTransform(247.4299,232.5998,0.6501,0.6501);

	this.shape_386 = new cjs.Shape();
	this.shape_386.graphics.f("#FFFFFF").s().p("AgGAAQAHgHAGAGIgKAFg");
	this.shape_386.setTransform(245.4635,231.3348,0.6501,0.6501);

	this.shape_387 = new cjs.Shape();
	this.shape_387.graphics.f("#FFFFFF").s().p("AgiADIAngnQAJACAIAMQAIANAFAFIgqApQgWgVgFgNg");
	this.shape_387.setTransform(247.4787,232.5185,0.6501,0.6501);

	this.shape_388 = new cjs.Shape();
	this.shape_388.graphics.f("#FFFFFF").s().p("AgEAHIAHgHIgHgHQAGgDACAHQACAEgDAGQgBACgDAAg");
	this.shape_388.setTransform(241.1894,229.5625,0.6501,0.6501);

	this.shape_389 = new cjs.Shape();
	this.shape_389.graphics.f("#000000").s().p("Ah0CcIg9hQQAGgGAWgDQAUgDAHgKQApgQAEgEIACAUQABALALACQAUABAQgbQAEgdgIgGIAzgoQAGAEAEALQADAMAFAFQAVAAANggQACgQgFgPQAhggAYg7QAPALAJAXIAPAnQgHgPgbgrQgCAAgDAEQADAOAHANQgDgCgFgGQgEgGgFAHQgBAGAEADQgIAIAIANQANAPACAHQAKAfANAGQgCgMgTgoQAUAlAMAPIADgDIgghAQAGACAFAHIAHAOIAIAQQAEAKAGACQgCASgOATIgbAfQguA4h7A/QgIABggAJQgPAEgNAAQgIAAgGgBgACHhsIACgBIgBgBIABAAIAAABIAFAIIgCAAQgDAAgCgHg");
	this.shape_389.setTransform(247.2674,238.8714,0.6501,0.6501);

	this.shape_390 = new cjs.Shape();
	this.shape_390.graphics.f("#FFFFFF").s().p("AgCBNQAGgIgGgMQgMgSAAgDIgZgSIgFgyQgBgbANgTQABA6AYAPQALAJAEAHQAPAdAQgGQAHAFgCAGQgSAUgaAOg");
	this.shape_390.setTransform(244.7922,233.2824,0.6501,0.6501);

	this.shape_391 = new cjs.Shape();
	this.shape_391.graphics.f("#FFFFFF").s().p("AAAgFIABAFIAAAGg");
	this.shape_391.setTransform(243.8709,227.9194,0.6501,0.6501);

	this.shape_392 = new cjs.Shape();
	this.shape_392.graphics.f("#FFFFFF").s().p("AAAACIAAgDIABAAIAAADg");
	this.shape_392.setTransform(243.9034,226.5543,0.6501,0.6501);

	this.shape_393 = new cjs.Shape();
	this.shape_393.graphics.f("#FFFFFF").s().p("AgCABQADgEADABIAAAFIgGgCg");
	this.shape_393.setTransform(244.976,224.9557,0.6501,0.6501);

	this.shape_394 = new cjs.Shape();
	this.shape_394.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_394.setTransform(177.5978,223.8566,0.6501,0.6501);

	this.shape_395 = new cjs.Shape();
	this.shape_395.graphics.f("#FFFFFF").s().p("AgGBGQAMgMgEgFQgLgRgcggQgXgcgFgYQAPgSAMgDQANgQAhAGIAeAQQASAJAHANQAJA4geAfIgMAVQgIAMgLADQgLgMgGAAg");
	this.shape_395.setTransform(250.178,228.4675,0.6501,0.6501);

	this.shape_396 = new cjs.Shape();
	this.shape_396.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_396.setTransform(192.744,204.4037,0.6501,0.6501);

	this.shape_397 = new cjs.Shape();
	this.shape_397.graphics.f("#FFFFFF").s().p("AAAACIAAgDIABAAIAAADg");
	this.shape_397.setTransform(199.9759,202.7948,0.6501,0.6501);

	this.shape_398 = new cjs.Shape();
	this.shape_398.graphics.f("#FFFFFF").s().p("AAGgDIAFgDQgKAGgMAHQAFgFAMgFg");
	this.shape_398.setTransform(183.2207,203.006,0.6501,0.6501);

	this.shape_399 = new cjs.Shape();
	this.shape_399.graphics.f("#FFFFFF").s().p("AgGABIALgFQAAABAAAAQAAAAABABQAAAAAAABQABAAAAABQgEAEgGAAg");
	this.shape_399.setTransform(183.8058,215.5684,0.6501,0.6501);

	this.shape_400 = new cjs.Shape();
	this.shape_400.graphics.f("#FFFFFF").s().p("AAFgGQAGAGgQAHg");
	this.shape_400.setTransform(184.6692,214.382,0.6501,0.6501);

	this.shape_401 = new cjs.Shape();
	this.shape_401.graphics.f("#FFFFFF").s().p("AgCgCQAIgHAHABIgZARQACgFAIgGg");
	this.shape_401.setTransform(184.8621,213.4796,0.6501,0.6501);

	this.shape_402 = new cjs.Shape();
	this.shape_402.graphics.f("#FFFFFF").s().p("AACgFQABgBADAEQgGAHgFABQgDgIAKgDg");
	this.shape_402.setTransform(185.2684,212.1334,0.6501,0.6501);

	this.shape_403 = new cjs.Shape();
	this.shape_403.graphics.f("#FFFFFF").s().p("AgCAAIACgBIADABIgDACg");
	this.shape_403.setTransform(185.6584,211.1155,0.6501,0.6501);

	this.shape_404 = new cjs.Shape();
	this.shape_404.graphics.f("#FFFFFF").s().p("AAAABIAAgBIACAAIAAABg");
	this.shape_404.setTransform(186.146,209.8479,0.6501,0.6501);

	this.shape_405 = new cjs.Shape();
	this.shape_405.graphics.f("#FFFFFF").s().p("AgGAAIAMgDIABACQgEAGgFAAg");
	this.shape_405.setTransform(180.4255,202.0147,0.6501,0.6501);

	this.shape_406 = new cjs.Shape();
	this.shape_406.graphics.f("#FFFFFF").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_406.setTransform(183.8383,201.3322,0.6501,0.6501);

	this.shape_407 = new cjs.Shape();
	this.shape_407.graphics.f("#FFFFFF").s().p("AAFgGQAGAGgQAHg");
	this.shape_407.setTransform(179.6638,201.6897,0.6501,0.6501);

	this.shape_408 = new cjs.Shape();
	this.shape_408.graphics.f("#FFFFFF").s().p("AgCgCQAIgIAGACIgYARQACgFAIgGg");
	this.shape_408.setTransform(178.8979,201.3185,0.6501,0.6501);

	this.shape_409 = new cjs.Shape();
	this.shape_409.graphics.f("#FFFFFF").s().p("AABgGQACABAEAEQgJAHgDABQgDgJAJgEg");
	this.shape_409.setTransform(178.7191,200.4871,0.6501,0.6501);

	this.shape_410 = new cjs.Shape();
	this.shape_410.graphics.f("#FFFFFF").s().p("AgCAAIACgBIADABIgDACg");
	this.shape_410.setTransform(179.4504,199.902,0.6501,0.6501);

	this.shape_411 = new cjs.Shape();
	this.shape_411.graphics.f("#FFFFFF").s().p("AgCACIAAgDIAFAAIAAADg");
	this.shape_411.setTransform(182.3432,198.8782,0.6501,0.6501);

	this.shape_412 = new cjs.Shape();
	this.shape_412.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_412.setTransform(179.9217,199.3982,0.6501,0.6501);

	this.shape_413 = new cjs.Shape();
	this.shape_413.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_413.setTransform(175.5176,198.9432,0.6501,0.6501);

	this.shape_414 = new cjs.Shape();
	this.shape_414.graphics.f("#FFFFFF").s().p("AAFAAIgJADQAGgIADAFg");
	this.shape_414.setTransform(177.159,198.9729,0.6501,0.6501);

	this.shape_415 = new cjs.Shape();
	this.shape_415.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_415.setTransform(177.8415,198.3582,0.6501,0.6501);

	this.shape_416 = new cjs.Shape();
	this.shape_416.graphics.f("#FFFFFF").s().p("AAHgDIgNAIQABgFAMgDg");
	this.shape_416.setTransform(176.5902,198.8619,0.6501,0.6501);

	this.shape_417 = new cjs.Shape();
	this.shape_417.graphics.f("#FFFFFF").s().p("AgCgGQAHAIgEADQAAAAAAAAQgBAAAAAAQAAAAAAAAQgBABgBABg");
	this.shape_417.setTransform(211.834,198.6019,0.6501,0.6501);

	this.shape_418 = new cjs.Shape();
	this.shape_418.graphics.f("#FFFFFF").s().p("AAAABIAAgCIABAAIAAACg");
	this.shape_418.setTransform(177.5003,197.9844,0.6501,0.6501);

	this.shape_419 = new cjs.Shape();
	this.shape_419.graphics.f("#FFFFFF").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_419.setTransform(212.9282,197.7569,0.6501,0.6501);

	this.shape_420 = new cjs.Shape();
	this.shape_420.graphics.f("#FFFFFF").s().p("AgOAJQASgTALACQgPARgMAAIgCAAg");
	this.shape_420.setTransform(175.2413,198.3443,0.6501,0.6501);

	this.shape_421 = new cjs.Shape();
	this.shape_421.graphics.f("#FFFFFF").s().p("AgIAEQAFgEAMgFIgQALg");
	this.shape_421.setTransform(178.8004,197.9356,0.6501,0.6501);

	this.shape_422 = new cjs.Shape();
	this.shape_422.graphics.f("#FFFFFF").s().p("AgCAAIAAgEQAHADgCAFIgBABQgCAAgCgFg");
	this.shape_422.setTransform(211.9506,197.5635,0.6501,0.6501);

	this.shape_423 = new cjs.Shape();
	this.shape_423.graphics.f("#FFFFFF").s().p("AgCgGIAFAFIAAAIg");
	this.shape_423.setTransform(210.1818,197.7244,0.6501,0.6501);

	this.shape_424 = new cjs.Shape();
	this.shape_424.graphics.f("#FFFFFF").s().p("AgFAEIALgIIgJAIg");
	this.shape_424.setTransform(178.4916,197.4643,0.6501,0.6501);

	this.shape_425 = new cjs.Shape();
	this.shape_425.graphics.f("#FFFFFF").s().p("AgCgDIAFAEIAAADg");
	this.shape_425.setTransform(210.0843,196.7005,0.6501,0.6501);

	this.shape_426 = new cjs.Shape();
	this.shape_426.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_426.setTransform(208.4754,196.2617,0.6501,0.6501);

	this.shape_427 = new cjs.Shape();
	this.shape_427.graphics.f("#FFFFFF").s().p("AgMAJQASgSALABQgFABgMAKQgGAGgFAAIgBAAgAgQAHIAEgEQAAABAAABQAAAAAAABQAAAAgBABQgBAAAAAAIACACIgEgCg");
	this.shape_427.setTransform(177.6953,196.7857,0.6501,0.6501);

	this.shape_428 = new cjs.Shape();
	this.shape_428.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_428.setTransform(180.7505,195.6767,0.6501,0.6501);

	this.shape_429 = new cjs.Shape();
	this.shape_429.graphics.f("#FFFFFF").s().p("AgFgIQAKAJAAAIQgJgHgBgKg");
	this.shape_429.setTransform(210.7181,196.1967,0.6501,0.6501);

	this.shape_430 = new cjs.Shape();
	this.shape_430.graphics.f("#FFFFFF").s().p("AAAACIAAgDIABAAIAAADg");
	this.shape_430.setTransform(178.0853,195.4167,0.6501,0.6501);

	this.shape_431 = new cjs.Shape();
	this.shape_431.graphics.f("#FFFFFF").s().p("AAJgGQAAABAAAAQAAABAAAAQAAABABABQAAAAABABQgIABgNAHQAPgLAEgCg");
	this.shape_431.setTransform(179.7592,195.4492,0.6501,0.6501);

	this.shape_432 = new cjs.Shape();
	this.shape_432.graphics.f("#FFFFFF").s().p("AgDAAIADgCIAEACQgCADgDAAg");
	this.shape_432.setTransform(180.8968,194.7829,0.6501,0.6501);

	this.shape_433 = new cjs.Shape();
	this.shape_433.graphics.f("#FFFFFF").s().p("AgDgEIAHAGIAAADg");
	this.shape_433.setTransform(209.1092,194.2466,0.6501,0.6501);

	this.shape_434 = new cjs.Shape();
	this.shape_434.graphics.f("#FFFFFF").s().p("AgRAIQgBgBAHgHQALgKALgBQgJAFAAAEQACACAFgDQAGgEADAEIgSALQgGAEgEAAQgEAAgDgEg");
	this.shape_434.setTransform(179.2705,194.4091,0.6501,0.6501);

	this.shape_435 = new cjs.Shape();
	this.shape_435.graphics.f("#FFFFFF").s().p("AgDAAQADgFAEAFIAAADIgCAAQgCAAgDgDg");
	this.shape_435.setTransform(183.367,193.3315,0.6501,0.6501);

	this.shape_436 = new cjs.Shape();
	this.shape_436.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_436.setTransform(181.6931,192.5239,0.6501,0.6501);

	this.shape_437 = new cjs.Shape();
	this.shape_437.graphics.f("#FFFFFF").s().p("AgFADQAIgLADAIQgDAAgDADIgCABIgDgBg");
	this.shape_437.setTransform(182.6519,192.6962,0.6501,0.6501);

	this.shape_438 = new cjs.Shape();
	this.shape_438.graphics.f("#FFFFFF").s().p("AAIABIgPAHQAIgcAHAVg");
	this.shape_438.setTransform(180.0192,192.6572,0.6501,0.6501);

	this.shape_439 = new cjs.Shape();
	this.shape_439.graphics.f("#FFFFFF").s().p("AAAACIAAgDIABAAIAAADg");
	this.shape_439.setTransform(183.7083,192.0201,0.6501,0.6501);

	this.shape_440 = new cjs.Shape();
	this.shape_440.graphics.f("#FFFFFF").s().p("AgJgNQAJAHAKAUQgQgPgDgMg");
	this.shape_440.setTransform(208.4429,192.5564,0.6501,0.6501);

	this.shape_441 = new cjs.Shape();
	this.shape_441.graphics.f("#FFFFFF").s().p("AgLAFQgCgFAFgCIAJgJQAGAFgCACIAHAFQgCAHgOAEQgGgBgBgGg");
	this.shape_441.setTransform(181.3721,191.3863,0.6501,0.6501);

	this.shape_442 = new cjs.Shape();
	this.shape_442.graphics.f("#FFFFFF").s().p("AgGADQACgBADgEQADgDAEACQABADgEACIgGADg");
	this.shape_442.setTransform(183.2917,190.5724,0.6501,0.6501);

	this.shape_443 = new cjs.Shape();
	this.shape_443.graphics.f("#FFFFFF").s().p("AgHgOIAPAcQgSgRADgLg");
	this.shape_443.setTransform(207.8605,190.5087,0.6501,0.6501);

	this.shape_444 = new cjs.Shape();
	this.shape_444.graphics.f("#FFFFFF").s().p("AgDABQAEgGADAFIAAADIgHgCg");
	this.shape_444.setTransform(184.4721,189.7395,0.6501,0.6501);

	this.shape_445 = new cjs.Shape();
	this.shape_445.graphics.f("#FFFFFF").s().p("AgHACQAKgKAFAEQACAFgKAFQgGgDgBgBg");
	this.shape_445.setTransform(182.7107,190.0275,0.6501,0.6501);

	this.shape_446 = new cjs.Shape();
	this.shape_446.graphics.f("#FFFFFF").s().p("AgBADQgDgGAHABQgDAFgBAAIAAAAg");
	this.shape_446.setTransform(185.2418,189.2667,0.6501,0.6501);

	this.shape_447 = new cjs.Shape();
	this.shape_447.graphics.f("#FFFFFF").s().p("AAGgEQAAAEgLAFQAFgJAGAAg");
	this.shape_447.setTransform(182.3594,189.4029,0.6501,0.6501);

	this.shape_448 = new cjs.Shape();
	this.shape_448.graphics.f("#FFFFFF").s().p("AgGACQAIgLAFAGIgFAIIgCABQgDAAgDgEg");
	this.shape_448.setTransform(183.8058,189.218,0.6501,0.6501);

	this.shape_449 = new cjs.Shape();
	this.shape_449.graphics.f("#FFFFFF").s().p("AgEgBQAGgDACADQAAADgCABIgBABQgCAAgDgFg");
	this.shape_449.setTransform(184.8134,188.6604,0.6501,0.6501);

	this.shape_450 = new cjs.Shape();
	this.shape_450.graphics.f("#FFFFFF").s().p("AgFADQAGgIAFACIgJAIg");
	this.shape_450.setTransform(183.4158,188.6879,0.6501,0.6501);

	this.shape_451 = new cjs.Shape();
	this.shape_451.graphics.f("#FFFFFF").s().p("AgGgHQAJADAEAMg");
	this.shape_451.setTransform(208.1503,188.3636,0.6501,0.6501);

	this.shape_452 = new cjs.Shape();
	this.shape_452.graphics.f("#FFFFFF").s().p("AAEgDQAAACgFAFQgFgEAKgDg");
	this.shape_452.setTransform(184.3884,188.0873,0.6501,0.6501);

	this.shape_453 = new cjs.Shape();
	this.shape_453.graphics.f("#FFFFFF").s().p("AACgGIAEAFIgKAIQgDgDAJgKg");
	this.shape_453.setTransform(183.0845,188.0548,0.6501,0.6501);

	this.shape_454 = new cjs.Shape();
	this.shape_454.graphics.f("#FFFFFF").s().p("AgCgGIAIAGQABAEgHADQgJgGAHgHg");
	this.shape_454.setTransform(188.2558,179.3115,0.6501,0.6501);

	this.shape_455 = new cjs.Shape();
	this.shape_455.graphics.f("#FFFFFF").s().p("AgCgHIAIAHQABAEgHAEQgJgGAHgJg");
	this.shape_455.setTransform(185.3334,187.421,0.6501,0.6501);

	this.shape_456 = new cjs.Shape();
	this.shape_456.graphics.f("#FFFFFF").s().p("AgCgHIAIAHQABADgHAFQgJgHAHgIg");
	this.shape_456.setTransform(183.8029,187.2585,0.6501,0.6501);

	this.shape_457 = new cjs.Shape();
	this.shape_457.graphics.f("#FFFFFF").s().p("AgBABIAAgBIACAAIAAABg");
	this.shape_457.setTransform(185.5284,185.8771,0.6501,0.6501);

	this.shape_458 = new cjs.Shape();
	this.shape_458.graphics.f("#FFFFFF").s().p("AAAgDQAEAFgCACQgHgEAFgDg");
	this.shape_458.setTransform(186.0444,185.6171,0.6501,0.6501);

	this.shape_459 = new cjs.Shape();
	this.shape_459.graphics.f("#FFFFFF").s().p("AABAKQAAgKgBgCQgDgGAIAGIgMgQQAAgBAFAAQAIAKACAKIgCAAQAEANgEAGQgGgBABgJg");
	this.shape_459.setTransform(208.451,186.5109,0.6501,0.6501);

	this.shape_460 = new cjs.Shape();
	this.shape_460.graphics.f("#FFFFFF").s().p("AgCgEQAEAFABADQgFAAAAgIg");
	this.shape_460.setTransform(184.9271,185.2108,0.6501,0.6501);

	this.shape_461 = new cjs.Shape();
	this.shape_461.graphics.f("#FFFFFF").s().p("AgBgCIADAEIgCABQgCAAABgFg");
	this.shape_461.setTransform(185.5505,184.8677,0.6501,0.6501);

	this.shape_462 = new cjs.Shape();
	this.shape_462.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_462.setTransform(186.341,184.3657,0.6501,0.6501);

	this.shape_463 = new cjs.Shape();
	this.shape_463.graphics.f("#FFFFFF").s().p("AgEgMIAIALQADAFgDAIIgDABQgCgHgDgSg");
	this.shape_463.setTransform(209.1254,184.7395,0.6501,0.6501);

	this.shape_464 = new cjs.Shape();
	this.shape_464.graphics.f("#FFFFFF").s().p("AgBABIABgCIACAAIAAADQAAgBgBAAQAAgBgBAAQAAAAAAAAQgBABAAAAg");
	this.shape_464.setTransform(186.0932,183.6507,0.6501,0.6501);

	this.shape_465 = new cjs.Shape();
	this.shape_465.graphics.f("#FFFFFF").s().p("AgBACIAAgDIACAAIAAADg");
	this.shape_465.setTransform(187.2836,182.253,0.6501,0.6501);

	this.shape_466 = new cjs.Shape();
	this.shape_466.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_466.setTransform(208.4754,181.8143,0.6501,0.6501);

	this.shape_467 = new cjs.Shape();
	this.shape_467.graphics.f("#FFFFFF").s().p("AAAgCIABACIAAADg");
	this.shape_467.setTransform(209.2717,181.8305,0.6501,0.6501);

	this.shape_468 = new cjs.Shape();
	this.shape_468.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_468.setTransform(210.3605,180.9854,0.6501,0.6501);

	this.shape_469 = new cjs.Shape();
	this.shape_469.graphics.f("#FFFFFF").s().p("AgCAHQgCgMADgCIABAFQAAAAAAAAQgBABAAAAQgBAAAAABQAAAAAAAAQAGADAAAFIgGgBg");
	this.shape_469.setTransform(172.4741,228.1632,0.6501,0.6501);

	this.shape_470 = new cjs.Shape();
	this.shape_470.graphics.f("#FFFFFF").s().p("AAAAAIAAAAIABAAIAAABg");
	this.shape_470.setTransform(173.1124,227.3344,0.6501,0.6501);

	this.shape_471 = new cjs.Shape();
	this.shape_471.graphics.f("#FFFFFF").s().p("AAAgCIABACIgBADg");
	this.shape_471.setTransform(174.3962,225.563,0.6501,0.6501);

	this.shape_472 = new cjs.Shape();
	this.shape_472.graphics.f("#FFFFFF").s().p("AgBAAIABgEQAEABgCAIQgCAAgBgFg");
	this.shape_472.setTransform(175.1871,224.8641,0.6501,0.6501);

	this.shape_473 = new cjs.Shape();
	this.shape_473.graphics.f("#FFFFFF").s().p("AAAgDIABAFIgBACg");
	this.shape_473.setTransform(176.0539,224.2953,0.6501,0.6501);

	this.shape_474 = new cjs.Shape();
	this.shape_474.graphics.f("#FFFFFF").s().p("AgEgGIAEAEQgBAAgBABQAAAAAAABQgBAAAAAAQAAAAABAAQAGABACAFIgGABQgGgLACgCg");
	this.shape_474.setTransform(187.4125,181.1805,0.6501,0.6501);

	this.shape_475 = new cjs.Shape();
	this.shape_475.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_475.setTransform(188.4374,180.5304,0.6501,0.6501);

	this.shape_476 = new cjs.Shape();
	this.shape_476.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_476.setTransform(187.7386,180.1729,0.6501,0.6501);

	this.shape_477 = new cjs.Shape();
	this.shape_477.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_477.setTransform(190.3063,179.9454,0.6501,0.6501);

	this.shape_478 = new cjs.Shape();
	this.shape_478.graphics.f("#FFFFFF").s().p("AAAAEIAAgHIABAAIAAAHg");
	this.shape_478.setTransform(210.3118,179.214,0.6501,0.6501);

	this.shape_479 = new cjs.Shape();
	this.shape_479.graphics.f("#FFFFFF").s().p("AACgCIAAADQAAAAgBAAQAAAAAAAAQgBAAAAABQAAAAAAAAQgDgEAFAAg");
	this.shape_479.setTransform(210.8227,178.3202,0.6501,0.6501);

	this.shape_480 = new cjs.Shape();
	this.shape_480.graphics.f("#FFFFFF").s().p("AAAgCIABACIAAADg");
	this.shape_480.setTransform(188.4212,178.1252,0.6501,0.6501);

	this.shape_481 = new cjs.Shape();
	this.shape_481.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_481.setTransform(210.8156,177.2639,0.6501,0.6501);

	this.shape_482 = new cjs.Shape();
	this.shape_482.graphics.f("#FFFFFF").s().p("AgCABIAAgFQAFAAAAAIIgBABQgCAAgCgEg");
	this.shape_482.setTransform(188.99,177.1885,0.6501,0.6501);

	this.shape_483 = new cjs.Shape();
	this.shape_483.graphics.f("#FFFFFF").s().p("AgBgDIADAEIgCADg");
	this.shape_483.setTransform(189.6238,176.4188,0.6501,0.6501);

	this.shape_484 = new cjs.Shape();
	this.shape_484.graphics.f("#FFFFFF").s().p("AgBABIAAgCIACAAIAAACg");
	this.shape_484.setTransform(211.6281,175.98,0.6501,0.6501);

	this.shape_485 = new cjs.Shape();
	this.shape_485.graphics.f("#FFFFFF").s().p("AAAABIAAgCIABAAIAAACg");
	this.shape_485.setTransform(211.9857,175.395,0.6501,0.6501);

	this.shape_486 = new cjs.Shape();
	this.shape_486.graphics.f("#FFFFFF").s().p("AgBgIQAEACgBAGIgCAJIgBgRg");
	this.shape_486.setTransform(212.2326,173.8836,0.6501,0.6501);

	this.shape_487 = new cjs.Shape();
	this.shape_487.graphics.f("#FFFFFF").s().p("AAAgCIABACIAAADg");
	this.shape_487.setTransform(212.652,172.4047,0.6501,0.6501);

	this.shape_488 = new cjs.Shape();
	this.shape_488.graphics.f("#FFFFFF").s().p("AACgJQAFgHACABQgEAUgNALQACgPAIgKg");
	this.shape_488.setTransform(190.5826,167.1144,0.6501,0.6501);

	this.shape_489 = new cjs.Shape();
	this.shape_489.graphics.f("#FFFFFF").s().p("AAEgOQAAAYgEAFQgHgIALgVg");
	this.shape_489.setTransform(192.4792,168.8294,0.6501,0.6501);

	this.shape_490 = new cjs.Shape();
	this.shape_490.graphics.f("#FFFFFF").s().p("AgBABIAAgCIACAAIAAACg");
	this.shape_490.setTransform(214.1959,166.5542,0.6501,0.6501);

	this.shape_491 = new cjs.Shape();
	this.shape_491.graphics.f("#FFFFFF").s().p("AAEgMIgGAZQgFgBALgYg");
	this.shape_491.setTransform(191.4853,164.7828,0.6501,0.6501);

	this.shape_492 = new cjs.Shape();
	this.shape_492.graphics.f("#FFFFFF").s().p("AAAgCIABACIAAADg");
	this.shape_492.setTransform(214.7321,164.2465,0.6501,0.6501);

	this.shape_493 = new cjs.Shape();
	this.shape_493.graphics.f("#FFFFFF").s().p("AAGgKIgHARIgDAEg");
	this.shape_493.setTransform(194.0767,163.3689,0.6501,0.6501);

	this.shape_494 = new cjs.Shape();
	this.shape_494.graphics.f("#FFFFFF").s().p("AAMgVIgXArQAGgXARgUg");
	this.shape_494.setTransform(192.9716,161.2725,0.6501,0.6501);

	this.shape_495 = new cjs.Shape();
	this.shape_495.graphics.f("#FFFFFF").s().p("AAAgCIABACIAAADg");
	this.shape_495.setTransform(215.2197,161.5488,0.6501,0.6501);

	this.shape_496 = new cjs.Shape();
	this.shape_496.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_496.setTransform(215.7072,160.9475,0.6501,0.6501);

	this.shape_497 = new cjs.Shape();
	this.shape_497.graphics.f("#FFFFFF").s().p("AACgDQACAFgEACQgEgDAGgEg");
	this.shape_497.setTransform(215.753,160.3624,0.6501,0.6501);

	this.shape_498 = new cjs.Shape();
	this.shape_498.graphics.f("#000000").s().p("AglATQgDgCgEAAQgIAAgFACIgEAEQABgHAGgHIAFgFQAFgEACABQAYANAPgKQgCgJATgRQAVgBAcAJIAAADQgDACgTgCQgNgCgBAOQgDgCgEAAQgFAAgBAEIACAEIgCADQAAAGADAFQgCAAgFgBIgFgBQAAAAgBAAQAAAAgBgBQAAAAAAAAQAAgBgBAAQgCgCgDAAIgLAEIgMABIgGADQgCAAgDgEg");
	this.shape_498.setTransform(144.3149,157.3815,0.6501,0.6501);

	this.shape_499 = new cjs.Shape();
	this.shape_499.graphics.f("#FFFFFF").s().p("Ag2AVQgLACgDAFIAAgGQACgRASgGIABAAIACAAQAVAKAOgHIAAgBQAAgKAQgOIAFgEQAPgBASAGIANAEQAFACAHAIQgHgEgFAEQgCACgNgCQgLgCgCACIAAAAQgEACAAAHIgBAHIgEgGQgCgCgFAAIgBACIABAMQAAAGAGAEIgSgEIgEAAIgCgCIgGABIgIADIgHgBQgJABgDAGQgBgLgPAEg");
	this.shape_499.setTransform(144.6075,157.3949,0.6501,0.6501);

	this.shape_500 = new cjs.Shape();
	this.shape_500.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_500.setTransform(156.0322,150.6929,0.6501,0.6501);

	this.shape_501 = new cjs.Shape();
	this.shape_501.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_501.setTransform(152.5544,149.7503,0.6501,0.6501);

	this.shape_502 = new cjs.Shape();
	this.shape_502.graphics.f("#000000").s().p("AglgVQAIgBAQAKQAPAJALgGQARgLgEgTQAhgIAfAIIAAAEQgVgGgQAUQgCAGAEABQgEAFgHgCQgIgCgCAGQgBACAAAcQgEgDgMgIQgGgBgDAFIgPgIQgJgEgHAEQgFAEgBAKQgDAKgEADQgDgJgWAAQgQANgMAFQAIgSAsgvg");
	this.shape_502.setTransform(154.3908,150.7173,0.6501,0.6501);

	this.shape_503 = new cjs.Shape();
	this.shape_503.graphics.f("#FFFFFF").s().p("AhiArQAJgTAggiIANgNIAGgGIAUALQASALAFgDQAQgLgEgRIAHgHQAfgHAfAIIAQALIgPACIgDgBQgTgFgQARIAAADIABABIADACIgCACQgFAHgJgDQgFgBgCADQgCAFACAJQABAGgBAOIgNgJQgBgDgEACIgIAAIgBACIgKgFQgOgIgHAEQgDACgCAKQgDALgEAEIgDACIgBgEQgDgIgQABIgDAAQgRANgMAFIgGACg");
	this.shape_503.setTransform(154.7808,150.6724,0.6501,0.6501);

	this.shape_504 = new cjs.Shape();
	this.shape_504.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_504.setTransform(145.1113,146.9713,0.6501,0.6501);

	this.shape_505 = new cjs.Shape();
	this.shape_505.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_505.setTransform(143.5674,146.0125,0.6501,0.6501);

	this.shape_506 = new cjs.Shape();
	this.shape_506.graphics.f("#FFFFFF").s().p("AgBABIADgDIAAAFQgCgBgBgBg");
	this.shape_506.setTransform(150.523,145.4599,0.6501,0.6501);

	this.shape_507 = new cjs.Shape();
	this.shape_507.graphics.f("#FFFFFF").s().p("AgBABIAAgCIADAAIAAACg");
	this.shape_507.setTransform(143.2424,144.6149,0.6501,0.6501);

	this.shape_508 = new cjs.Shape();
	this.shape_508.graphics.f("#FFFFFF").s().p("AAAgBIACAAIgDADg");
	this.shape_508.setTransform(151.2055,144.5986,0.6501,0.6501);

	this.shape_509 = new cjs.Shape();
	this.shape_509.graphics.f("#FFFFFF").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_509.setTransform(152.0831,144.2898,0.6501,0.6501);

	this.shape_510 = new cjs.Shape();
	this.shape_510.graphics.f("#FFFFFF").s().p("AgBABIADgBIAAABg");
	this.shape_510.setTransform(143.5999,144.3061,0.6501,0.6501);

	this.shape_511 = new cjs.Shape();
	this.shape_511.graphics.f("#FFFFFF").s().p("AgFAAIALABIgDAAIgDAAQgFAAAAgBg");
	this.shape_511.setTransform(155.7722,140.2456,0.6501,0.6501);

	this.shape_512 = new cjs.Shape();
	this.shape_512.graphics.f("#000000").s().p("AiiBMIAFgMQAGgaAcgZIAugqQAIgBABAMQAAANAIADQAEAEAQAFQADgBAAgGIAAgFQADgBALAFQAKAFAFgCIAJgQIAIALQAFAGAGgFQAJgFgBgMIgEgSQgEgLgLgRQA3gqBbAjIAJALQgKgBgVgFQgTgDgLAHQAHAWAAAMQgJAEgLgMQgSgGgFAAQgHAFAEAYQADAHALAHIgigIQgNAGAJAUQgEAGgQgOQgGgBgFALIAIAmQgGgBgQgUQgZgQgNADQgEAGACANQgCgBgNgCQgLgCgCgHQgOgDgEAMQAFASgDAJQgLgWgYAGQgYAPgNAWQgEgEADgIg");
	this.shape_512.setTransform(148.7776,145.3654,0.6501,0.6501);

	this.shape_513 = new cjs.Shape();
	this.shape_513.graphics.f("#FFFFFF").s().p("AinBaQgEgLAEgJIAEgMQAGgXAtgmQAWgTAHgIIABgBIABAAQAIgEACACQABABAAAOQABAMAGACIAAAAIAAAAQADADAJABIAFABIAEgKIAPAHQAJADAEgBIALgSIADABQACADADAGQAEAGABAAIAFgCQAGgEAAgGQAAgGgCgFQgBgFAAgGIAAgBIgHgLQgIgKgBgHIgFgEQBTgpBIAkIABAAIARAPIgKAAQgIAAgNgDQgagGgLAHIAAABQAAAHADAIIAJARIADABQgOAGgLgKQgEgEgCAAIgHgCQgJgDgGgBQgEAEAAAHIACAMIAAADIADAEIAHAJIAIADIgMAAIgNgDQgFgDgJAAQgEACgCAKQAAABAHAPQABACgLgEQgMgFgEgDQgFAAgEAIQAAAIAFAQIAIAUIgHgEQgJgCgLgPIgEgFIgBgBQgVgOgMADQgDADAAADIADARIgFgEQgDgCgIgBQgNgBgFgJQgLgBgCAIQgCAFADAIQACAKgCAFIABALIgDgGQgNgZgUAFQgXAOgOAWIgBADg");
	this.shape_513.setTransform(149.0441,145.3923,0.6501,0.6501);

	this.shape_514 = new cjs.Shape();
	this.shape_514.graphics.f("#FFFFFF").s().p("AAAABIgCgBQABgBADAAQABABAAAAQgBAAAAABQAAAAAAAAQgBABAAAAIgBgBg");
	this.shape_514.setTransform(122.8002,137.964,0.6501,0.6501);

	this.shape_515 = new cjs.Shape();
	this.shape_515.graphics.f("#000000").s().p("AgDAWQgNgDgOAKQADgUgCgCQgJgIgRAFQgJACgOAKQABgEALgOQgDgCADgFQADgEgFgCQgrAIgUAAQBPgtAwAKQgEAMAEAKQAEAKAKAAQACAMACACIAUgKIADAMQAHABAUgNIAHgXQAZAGAMAFQAVAJADAQQgCATgEABQgFgWgOgGQgWAAgKAQIAAAHQgPgSgMAJQgCACgtAeQAMgYgQABg");
	this.shape_515.setTransform(126.8772,139.4636,0.6501,0.6501);

	this.shape_516 = new cjs.Shape();
	this.shape_516.graphics.f("#FFFFFF").s().p("AAAAgQAAgGgCgBQgBgBgDAAQgNgDgNAJIgEABIACgLQAEgHgDgEQgJgJgQAGIgIAFQgIAHgHAAIgEAAIABgEQADgGAGgHIADgEIgBgCIAAgBQAAgCACgDIABgBIgBgBQgnAHgXAAIAFgJQBHgoAuAKIAKgCIgDALQAGAWAFABIADgBIAAAJIAAACQAAAAAAABQAAAAAAABQAAAAABABQAAAAAAAAIAVgLIAEANQAIAAAMgIIADgCIAIgcIARAGQAvAMAEAUIgCAIQAAAFgCAFIgBABIgIAPQAAgPgGgJQgIgKgFgBQgTAAgKAOIAAAJIgCAAQgEAAgGgGQgJgIgGAEQgIAJgTALIgWAOQgCgDAEgNg");
	this.shape_516.setTransform(127.056,139.5119,0.6501,0.6501);

	this.shape_517 = new cjs.Shape();
	this.shape_517.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_517.setTransform(142.6573,135.3028,0.6501,0.6501);

	this.shape_518 = new cjs.Shape();
	this.shape_518.graphics.f("#FFFFFF").s().p("AAAgBIAIgGQgDACgDAGQgDAHgGAAQAAgFAHgEg");
	this.shape_518.setTransform(161.6064,133.3527,0.6501,0.6501);

	this.shape_519 = new cjs.Shape();
	this.shape_519.graphics.f("#FFFFFF").s().p("AgDACQADgHAEAHg");
	this.shape_519.setTransform(137.7656,132.0119,0.6501,0.6501);

	this.shape_520 = new cjs.Shape();
	this.shape_520.graphics.f("#FFFFFF").s().p("AgFgCIAIgGIACARQgCgFgIgGg");
	this.shape_520.setTransform(160.4038,132.2313,0.6501,0.6501);

	this.shape_521 = new cjs.Shape();
	this.shape_521.graphics.f("#FFFFFF").s().p("AgBACIAAgDIACAAIAAADg");
	this.shape_521.setTransform(159.5587,131.3537,0.6501,0.6501);

	this.shape_522 = new cjs.Shape();
	this.shape_522.graphics.f("#FFFFFF").s().p("AgDABIAEgBIADABg");
	this.shape_522.setTransform(158.5349,131.1425,0.6501,0.6501);

	this.shape_523 = new cjs.Shape();
	this.shape_523.graphics.f("#FFFFFF").s().p("AAAABIAAgBIACAAIAAABg");
	this.shape_523.setTransform(160.6963,130.8662,0.6501,0.6501);

	this.shape_524 = new cjs.Shape();
	this.shape_524.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_524.setTransform(121.7255,130.4437,0.6501,0.6501);

	this.shape_525 = new cjs.Shape();
	this.shape_525.graphics.f("#FFFFFF").s().p("AAQgUIgfAoQADgLAcgdg");
	this.shape_525.setTransform(156.4385,132.0688,0.6501,0.6501);

	this.shape_526 = new cjs.Shape();
	this.shape_526.graphics.f("#FFFFFF").s().p("AAAACIAAgDIABAAIAAADg");
	this.shape_526.setTransform(117.8902,130.3137,0.6501,0.6501);

	this.shape_527 = new cjs.Shape();
	this.shape_527.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_527.setTransform(162.3215,130.4112,0.6501,0.6501);

	this.shape_528 = new cjs.Shape();
	this.shape_528.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_528.setTransform(161.9964,130.1836,0.6501,0.6501);

	this.shape_529 = new cjs.Shape();
	this.shape_529.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_529.setTransform(118.1015,129.8424,0.6501,0.6501);

	this.shape_530 = new cjs.Shape();
	this.shape_530.graphics.f("#FFFFFF").s().p("AAAACIAAgDIABAAIAAADg");
	this.shape_530.setTransform(161.4114,129.9561,0.6501,0.6501);

	this.shape_531 = new cjs.Shape();
	this.shape_531.graphics.f("#FFFFFF").s().p("AAAABIAAgCIABAAIAAACg");
	this.shape_531.setTransform(171.211,129.4686,0.6501,0.6501);

	this.shape_532 = new cjs.Shape();
	this.shape_532.graphics.f("#FFFFFF").s().p("AAAgBIACAAIgDADg");
	this.shape_532.setTransform(158.9899,129.6961,0.6501,0.6501);

	this.shape_533 = new cjs.Shape();
	this.shape_533.graphics.f("#FFFFFF").s().p("AgEABIAAgBIAIAAIAAABg");
	this.shape_533.setTransform(160.4688,129.1598,0.6501,0.6501);

	this.shape_534 = new cjs.Shape();
	this.shape_534.graphics.f("#FFFFFF").s().p("AAAAAIABAAIAAABg");
	this.shape_534.setTransform(170.9184,128.981,0.6501,0.6501);

	this.shape_535 = new cjs.Shape();
	this.shape_535.graphics.f("#000000").s().p("AAPAxQgagdgUAHQgDAEgIAEQgBgHACgRQgBgNgMgFQgPgIgMATQAAAFgCABIgEAAQgCgHADgRQAAgOgOgCQgfADgRAUQgKAAAJgJQAkgzAqgDIA+AJIgBAsQABAaAQAKIAMgFIAGAMQAFADAKgIQAHgFABALIARgNQAJgJABgJQABgEgBgLQgBgJAFgFQAuAFAdAeQACAGgEACQgBAAgPgMQgLgHgQARQADAOgJgFQgEgEgGAAQgIAMABAKQgFABgPgCQgMgBgCAMQgCAHgFgBQgEgFgDACIgJAOQgFAIgGABQgCgVgBgBg");
	this.shape_535.setTransform(141.5131,133.2552,0.6501,0.6501);

	this.shape_536 = new cjs.Shape();
	this.shape_536.graphics.f("#FFFFFF").s().p("AAPBAQAAgLgDgCQgYgbgSAFQgDAFgGABIgGADIAAgDQgBgFABgKQACgUgNgFQgKgGgKAPQAAAEgFADIgIABIgBgCQgCgGACgKQACgRgKgCQgkAGgMANIgBABIAAAEQgEAAgDgIQgDgEAFgFQAlg0AsgDQAMAAAdAGIAWADIAGADIgBAIIgCAeQAAAeANAIIAPgGIgBAJIACACIACAEQADABAHgFQAGgFADABQADABABAGIAGgFQAQgMABgKIABgGIgCgNQAAgHAGgFIAEgEQApAEAhAjIABABIAAAEQAAAFgDACIAAAAIgBAAQgFAAgJgIIgEgEQgJgFgNAOIAAABQAAAHgDACQgEACgEgCIgBAAIAAgBQgCgCgEgBQgEAGAAAGIABAEIADAEIgIACIgMAAQgSgCgCALIAAACQgEAGgGgBIgCAAIAAgBIgDgCIgEAGQgIAQgJABIgDABg");
	this.shape_536.setTransform(141.5394,133.2714,0.6501,0.6501);

	this.shape_537 = new cjs.Shape();
	this.shape_537.graphics.f("#FFFFFF").s().p("AAAACIAAgDIABAAIAAADg");
	this.shape_537.setTransform(169.6833,127.4859,0.6501,0.6501);

	this.shape_538 = new cjs.Shape();
	this.shape_538.graphics.f("#FFFFFF").s().p("AAAgBIABABIAAACg");
	this.shape_538.setTransform(171.0485,127.5184,0.6501,0.6501);

	this.shape_539 = new cjs.Shape();
	this.shape_539.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_539.setTransform(149.1741,125.9908,0.6501,0.6501);

	this.shape_540 = new cjs.Shape();
	this.shape_540.graphics.f("#FFFFFF").s().p("AAAAEIAAgHIABAAIAAAHg");
	this.shape_540.setTransform(157.8848,125.7308,0.6501,0.6501);

	this.shape_541 = new cjs.Shape();
	this.shape_541.graphics.f("#FFFFFF").s().p("AgBAAQgBAAAAAAQgBAAAAgBQABAAAAgBQABgBABAAQADADABAEQgBgCgEgCg");
	this.shape_541.setTransform(127.3442,125.1295,0.6501,0.6501);

	this.shape_542 = new cjs.Shape();
	this.shape_542.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_542.setTransform(143.5674,124.9507,0.6501,0.6501);

	this.shape_543 = new cjs.Shape();
	this.shape_543.graphics.f("#FFFFFF").s().p("AADgDIAEAAIgNAHg");
	this.shape_543.setTransform(138.3669,125.2595,0.6501,0.6501);

	this.shape_544 = new cjs.Shape();
	this.shape_544.graphics.f("#FFFFFF").s().p("AgCgBQADAAACABIAAABIgDABQAAAAgBAAQAAAAAAgBQgBAAAAgBQAAAAAAgBg");
	this.shape_544.setTransform(157.198,124.9193,0.6501,0.6501);

	this.shape_545 = new cjs.Shape();
	this.shape_545.graphics.f("#FFFFFF").s().p("AAAADIAAgFIABAAIAAAFg");
	this.shape_545.setTransform(173.5999,124.2681,0.6501,0.6501);

	this.shape_546 = new cjs.Shape();
	this.shape_546.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_546.setTransform(142.5435,124.0081,0.6501,0.6501);

	this.shape_547 = new cjs.Shape();
	this.shape_547.graphics.f("#000000").s().p("AhcA1QgKgNgPAJQgGADgFALQgFAKgFADQgMgbATgcQAQgUAogQQABAGgGAMQgGAMACAGIAFAEIAbAAQARgBAFgNIAAgEIAOADQAJACAFgGIAAgLQAQAFAKgPIAAgTQAAgKgLgFIgJgCIAAgDQBcgpArApQACAEADgBQgFACgNgEQgMgDgIADQgWAHgGAJQgCAHAIAHQAIAIAAAFIgmgHQgKAJAJAKQAIAGgBAEIgTgCQgOAAgFAGQgCAFAAAfIgegLQgUgIgJAQIgDAJQgVgOgJADQgGAFACAJQADAMgBADIgSgXg");
	this.shape_547.setTransform(125.9161,128.5504,0.6501,0.6501);

	this.shape_548 = new cjs.Shape();
	this.shape_548.graphics.f("#FFFFFF").s().p("AiNBLQgMgcAWgiQAMgOAqgTIAMgCIgDAEIAAADQAAAGgFAKQgEAMAAACIAAACIAEADIAJgBQAaACAFgNIAAgGIACAAIAKACQAMADAEgFIAAgMIAEAAQAOAEAIgMIABgRQAAgKgJgEIgDAAQgGABgCgEIABgHQBjgrAnAlIACAFIADAEIgCAGQgFABgLgDQgNgEgHADIgNAGQgMAFgCAEQgCAFAIAGQAIAJAAAGIAAADIgRgEQgPgFgHABQgEADAAAFQAAAEADAEIADACQAFAEAAAEIAAABIAFACIgRAAQgTgCgFAGQgEAKACAJQgBAGAEALIAAACQgPgBgPgIQgZgMgJAOIABABIAAABQAAACgDADIgBACIAFADIgNgEQgPgLgJACQgDAEAAAEIACAHIABAJIgBAHIgDgCQgHgDgHgNQgHgOgFgBQgFgCgKAHQgGADgEAKQgGALgFADIgBAHg");
	this.shape_548.setTransform(125.9033,128.7092,0.6501,0.6501);

	this.shape_549 = new cjs.Shape();
	this.shape_549.graphics.f("#FFFFFF").s().p("AgCgDQACACACAAQAAAAABAAQAAAAAAABQAAAAAAAAQgBABAAABQAAABgEABg");
	this.shape_549.setTransform(140.5284,123.7481,0.6501,0.6501);

	this.shape_550 = new cjs.Shape();
	this.shape_550.graphics.f("#FFFFFF").s().p("AAAABIAAgBIACAAIAAABg");
	this.shape_550.setTransform(175.03,123.3093,0.6501,0.6501);

	this.shape_551 = new cjs.Shape();
	this.shape_551.graphics.f("#FFFFFF").s().p("AAGgJIAEAEIgTAPQADgIAMgLg");
	this.shape_551.setTransform(139.017,124.0406,0.6501,0.6501);

	this.shape_552 = new cjs.Shape();
	this.shape_552.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_552.setTransform(177.0127,122.383,0.6501,0.6501);

	this.shape_553 = new cjs.Shape();
	this.shape_553.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_553.setTransform(161.7527,122.383,0.6501,0.6501);

	this.shape_554 = new cjs.Shape();
	this.shape_554.graphics.f("#FFFFFF").s().p("AgBAEQgGgDACgFIALAHQAAAAAAABQgBAAAAAAQgBAAgBABQAAAAgBAAIgDgBg");
	this.shape_554.setTransform(179.4265,122.5227,0.6501,0.6501);

	this.shape_555 = new cjs.Shape();
	this.shape_555.graphics.f("#FFFFFF").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_555.setTransform(173.2911,121.7654,0.6501,0.6501);

	this.shape_556 = new cjs.Shape();
	this.shape_556.graphics.f("#FFFFFF").s().p("AgBABIABgBIACABg");
	this.shape_556.setTransform(177.0452,121.5867,0.6501,0.6501);

	this.shape_557 = new cjs.Shape();
	this.shape_557.graphics.f("#FFFFFF").s().p("AgBgBIADAAIgBADg");
	this.shape_557.setTransform(149.6454,121.6679,0.6501,0.6501);

	this.shape_558 = new cjs.Shape();
	this.shape_558.graphics.f("#000000").s().p("AjgBrQAMglAfgeQAfgeAkgJQAJAGgEAFQAiAhAVgIQABgCgCgJQgCgFAGgCQAVAVALgPQAIgGgFgMIgGgHQAEgCAOAJQAKAIADgPQgCgFABgVQAAgQgIgIIgTAAQAMgTAUgCQAMgNA/gbQAjgIAmATQAqAZAWALIAAAFQgJAAgVgKQgTgJgOADQgPgJgYAIQgQAJgBAFQgFAtAbAdIgCAHQgGgBgGgIQgHgJgEgBQgQgOghACQgQATASAeIgCAJQgFgCgIgJQgIgHgJADQgNAHgDAWQABAHANAZQgIAAgVgSIgDADQgBgHgKgFQgKgEgIAFIgMAIIgBAMQgEgBgLgKQgIgIgIAEQgRAMgIASIgFAHQgDAEgFgCQAIgfgfgWQgLgFgNAKQgOAOgGAEQgGAEgKAOQgJAMgIAEg");
	this.shape_558.setTransform(168.5132,128.2037,0.6501,0.6501);

	this.shape_559 = new cjs.Shape();
	this.shape_559.graphics.f("#FFFFFF").s().p("AjiBrIAAgBQAMgmAggfQAhggAlgIIADgFIAEAGQADAEAAADIACAGQAdAcAPgFIAAgBIgDgKIACgDQABgDAFgBIABAAIACABQALAMAIAAQAFgBAEgGIAAAAIABAAQAGgEgFgKIgCgCQgEgFAAgBIAAgCIABAAQAGgFAMAJQAFAFADAAQADgDABgFIgCgMIABgPQAAgMgGgHIgHAAQgHACgFgDIgDgBIACgCQAKgUAWgDQAQgRApgPIATgIQAqgJBBAmIAfASIABAAIAAALIgCAAQgKgBgRgIQgVgLgOADIgBAAIgBAAQgIgFgNADQgLACgFgBIgFACQgJAEgBAGIgBAMQAAAkAWAYIABABIAAADIAAABQAAAFgEABIgBABIgBAAQgHgCgHgKQgFgHgEgCIgBAAIAAAAQgOgMgfABQgHAIABAJQgBANAKAPIABACIAAAEQAAAFgFACIgBABIgKgIQgKgLgJADQgLAGgDAVQACAIAHAPIAOAOIgLgCQgMgBgOgNIgEgDIgEAEIgBgFQgBgGgIgDQgJgFgIAFQgLADAGAPQgIAGgOgNQgKgJgGACQgSAMgGASIgBABIgDAEQgFAJgIgEIgCgBIABgCQAIgdgdgVQgMgFgUASIgLAJQgFAEgIAMQgLAOgIAFIgDABg");
	this.shape_559.setTransform(168.497,128.253,0.6501,0.6501);

	this.shape_560 = new cjs.Shape();
	this.shape_560.graphics.f("#FFFFFF").s().p("AAAAAIAAAAIAEACQgEgBgCAEIACgFgAgBgEIADAAIgCADIgBgDg");
	this.shape_560.setTransform(148.1503,121.1154,0.6501,0.6501);

	this.shape_561 = new cjs.Shape();
	this.shape_561.graphics.f("#FFFFFF").s().p("AACgHQAAABAAABQAAAAAAABQAAAAAAABQABAAAAABIAEgDQgCAJgGACIgFABg");
	this.shape_561.setTransform(147.3215,121.0504,0.6501,0.6501);

	this.shape_562 = new cjs.Shape();
	this.shape_562.graphics.f("#FFFFFF").s().p("AgEAFIgFAAQAAgGAPgHIAEAAQgNACAHAGQAFABgCADQgCADAAACQgDgHgGADg");
	this.shape_562.setTransform(145.5501,120.6278,0.6501,0.6501);

	this.shape_563 = new cjs.Shape();
	this.shape_563.graphics.f("#FFFFFF").s().p("AgTALIAngVIgeAVg");
	this.shape_563.setTransform(144.1849,120.5141,0.6501,0.6501);

	this.shape_564 = new cjs.Shape();
	this.shape_564.graphics.f("#000000").s().p("Ai6A5QgOgMgQADIgvAaQAAgKALgQIASgZQBZhMAzgFQgFAHADAGQAEAGABAEQAZATA2ARQACgBABgNQAAgLAIgBQAJAMAGAEQAJAJAKgEQAMgFAEgOQADgIADgRIACAAIARAgQAegLATgvQAAgEgHgGQgFgHADgEQAzADALAGQA+AOAaAlQgVgRgrgBQgMAHAVAQQAOAOAAAHQgMgCgXgPQgWgNgOgBQgNAAgFANQgDARgDAHQAJAMABAIQgDABgWgFQgRgEgIAKQgJAMgKAcIACARQgJABgHgKIgLgRQgTgMgFgCQgPgFgFARIgYgNQgPgFgLAJQgHAGACAOQACARgGAMQgHgFgPgTQgPgPgNgDQgjANgGAZQAFAHgFAFQgVgggPgHg");
	this.shape_564.setTransform(153.7895,122.1555,0.6501,0.6501);

	this.shape_565 = new cjs.Shape();
	this.shape_565.graphics.f("#FFFFFF").s().p("AicBXQgQgagRgIQgNgKgMACQgMADgXATIgQAIIAAgGQAAgMARgXIAMgRIALgKQBLhAAwgFIAAgBIAKgHQgFAXAOAGQAeAXAoAOQABgCAAgJQAAgOAFgMIANASQAQARALgFQAMgFAFgZIAEgVIAVAnQAZgHAJgQQAFgLAGgWIgEgHQgGgEAAgFQAAgCACgDIABgBIAOAAQAlABANAIQBAAOAZAlIgDAFQgTgQgrgCQgEACAAACQAAAEALAJIADABIABABQANANABAKIAAADIgDgBQgMgCgWgOQgYgNgNgDQgNABgFAXIgDALIAEAGQAFAJAAAGIABACIgDABQgHAAgLgDIgPgGIgKAHQgKAEgFATQgDALgFAGIACAHIgBANIgCAAQgLACgLgSIgGgLIgGgEQgTgMgHACQgFACgEAJIACAIIgNgKQgagQgNAKQgGAGACAPQADAOgEAMIADAOIgbgcQgXgXgJgCQgcALgGATQABgCABgBQAAAAAAAAQAAAAAAABQgBABgBADIAAgCIgCAEQgDAFABABQAAAAAAABQABAAAAABQAAAAAAABQAAABAAAAQAAADgCADIgCAHg");
	this.shape_565.setTransform(153.7895,122.383,0.6501,0.6501);

	this.shape_566 = new cjs.Shape();
	this.shape_566.graphics.f("#FFFFFF").s().p("AgBgCIADADIAAACg");
	this.shape_566.setTransform(148.394,114.7123,0.6501,0.6501);

	this.shape_567 = new cjs.Shape();
	this.shape_567.graphics.f("#FFFFFF").s().p("AADgIIAAAGIgFALg");
	this.shape_567.setTransform(136.108,114.9074,0.6501,0.6501);

	this.shape_568 = new cjs.Shape();
	this.shape_568.graphics.f("#FFFFFF").s().p("AABgBIAAACIgBABg");
	this.shape_568.setTransform(148.9141,113.7698,0.6501,0.6501);

	this.shape_569 = new cjs.Shape();
	this.shape_569.graphics.f("#FFFFFF").s().p("AgCACQAAgDAEAAQABABgDACg");
	this.shape_569.setTransform(144.3818,113.7698,0.6501,0.6501);

	this.shape_570 = new cjs.Shape();
	this.shape_570.graphics.f("#FFFFFF").s().p("AgBgEIADAGIgDADg");
	this.shape_570.setTransform(136.4005,113.4935,0.6501,0.6501);

	this.shape_571 = new cjs.Shape();
	this.shape_571.graphics.f("#FFFFFF").s().p("AgBABIAAgBIACAAIAAABg");
	this.shape_571.setTransform(150.783,112.5834,0.6501,0.6501);

	this.shape_572 = new cjs.Shape();
	this.shape_572.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_572.setTransform(146.4926,112.5834,0.6501,0.6501);

	this.shape_573 = new cjs.Shape();
	this.shape_573.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_573.setTransform(145.4363,112.0146,0.6501,0.6501);

	this.shape_574 = new cjs.Shape();
	this.shape_574.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_574.setTransform(142.1698,110.9745,0.6501,0.6501);

	this.shape_575 = new cjs.Shape();
	this.shape_575.graphics.f("#FFFFFF").s().p("AAAgBIABAAIgBADg");
	this.shape_575.setTransform(131.5576,111.1533,0.6501,0.6501);

	this.shape_576 = new cjs.Shape();
	this.shape_576.graphics.f("#FFFFFF").s().p("AgEAAIACgCIAGAFg");
	this.shape_576.setTransform(138.887,110.9908,0.6501,0.6501);

	this.shape_577 = new cjs.Shape();
	this.shape_577.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_577.setTransform(123.3994,110.747,0.6501,0.6501);

	this.shape_578 = new cjs.Shape();
	this.shape_578.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_578.setTransform(133.5565,110.1457,0.6501,0.6501);

	this.shape_579 = new cjs.Shape();
	this.shape_579.graphics.f("#FFFFFF").s().p("AADgDIACACIgIAFg");
	this.shape_579.setTransform(132.3539,110.3732,0.6501,0.6501);

	this.shape_580 = new cjs.Shape();
	this.shape_580.graphics.f("#FFFFFF").s().p("AgGAAIAPgGQgBAEgGADQgIADgCADg");
	this.shape_580.setTransform(137.6844,110.3407,0.6501,0.6501);

	this.shape_581 = new cjs.Shape();
	this.shape_581.graphics.f("#FFFFFF").s().p("AgTAQIAngfQAAAGgPAQQgFgDgGAGQgIAGgEAAIgBAAg");
	this.shape_581.setTransform(145.5018,110.6993,0.6501,0.6501);

	this.shape_582 = new cjs.Shape();
	this.shape_582.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_582.setTransform(131.4601,109.3169,0.6501,0.6501);

	this.shape_583 = new cjs.Shape();
	this.shape_583.graphics.f("#FFFFFF").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_583.setTransform(147.6302,109.1869,0.6501,0.6501);

	this.shape_584 = new cjs.Shape();
	this.shape_584.graphics.f("#FFFFFF").s().p("AAAgBIABAAIAAADg");
	this.shape_584.setTransform(124.8946,109.2194,0.6501,0.6501);

	this.shape_585 = new cjs.Shape();
	this.shape_585.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_585.setTransform(131.7039,108.8618,0.6501,0.6501);

	this.shape_586 = new cjs.Shape();
	this.shape_586.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_586.setTransform(178.9954,108.6181,0.6501,0.6501);

	this.shape_587 = new cjs.Shape();
	this.shape_587.graphics.f("#FFFFFF").s().p("AAAABIAAgCIABAAIAAACg");
	this.shape_587.setTransform(123.8545,108.6993,0.6501,0.6501);

	this.shape_588 = new cjs.Shape();
	this.shape_588.graphics.f("#FFFFFF").s().p("AgBABIAAgBIACAAIAAABg");
	this.shape_588.setTransform(128.1936,108.3906,0.6501,0.6501);

	this.shape_589 = new cjs.Shape();
	this.shape_589.graphics.f("#FFFFFF").s().p("AgBABIAAgBIACAAIAAABg");
	this.shape_589.setTransform(171.5523,108.163,0.6501,0.6501);

	this.shape_590 = new cjs.Shape();
	this.shape_590.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_590.setTransform(182.4732,107.6917,0.6501,0.6501);

	this.shape_591 = new cjs.Shape();
	this.shape_591.graphics.f("#FFFFFF").s().p("AgBgFIABACQgBACABADQABAFgGABQgEgEAIgJgAACgFIgCABIAAABIAAAAIAAgBIACgDIAFAHIgCABIgDgGg");
	this.shape_591.setTransform(164.3727,108.293,0.6501,0.6501);

	this.shape_592 = new cjs.Shape();
	this.shape_592.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_592.setTransform(167.5869,107.4642,0.6501,0.6501);

	this.shape_593 = new cjs.Shape();
	this.shape_593.graphics.f("#FFFFFF").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_593.setTransform(166.4168,107.3667,0.6501,0.6501);

	this.shape_594 = new cjs.Shape();
	this.shape_594.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_594.setTransform(180.068,107.1067,0.6501,0.6501);

	this.shape_595 = new cjs.Shape();
	this.shape_595.graphics.f("#FFFFFF").s().p("AgCAAQgCgEADgDIAFAMIgDADIgDgIg");
	this.shape_595.setTransform(165.1641,107.5617,0.6501,0.6501);

	this.shape_596 = new cjs.Shape();
	this.shape_596.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_596.setTransform(165.6042,106.8792,0.6501,0.6501);

	this.shape_597 = new cjs.Shape();
	this.shape_597.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_597.setTransform(125.7559,106.7492,0.6501,0.6501);

	this.shape_598 = new cjs.Shape();
	this.shape_598.graphics.f("#FFFFFF").s().p("AAAgCIABACIAAADg");
	this.shape_598.setTransform(133.7678,106.4404,0.6501,0.6501);

	this.shape_599 = new cjs.Shape();
	this.shape_599.graphics.f("#FFFFFF").s().p("AgEgDQAGADADAEIgBAAQgFAAgDgHg");
	this.shape_599.setTransform(126.2597,106.4435,0.6501,0.6501);

	this.shape_600 = new cjs.Shape();
	this.shape_600.graphics.f("#FFFFFF").s().p("AgBAAIABAAIACABg");
	this.shape_600.setTransform(123.2369,106.2129,0.6501,0.6501);

	this.shape_601 = new cjs.Shape();
	this.shape_601.graphics.f("#FFFFFF").s().p("AgBAAIACgEIACAHIgDABQAAAAgBgBQAAAAgBgBQAAAAAAgBQABAAAAgBg");
	this.shape_601.setTransform(166.5069,105.2865,0.6501,0.6501);

	this.shape_602 = new cjs.Shape();
	this.shape_602.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_602.setTransform(179.9217,104.669,0.6501,0.6501);

	this.shape_603 = new cjs.Shape();
	this.shape_603.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_603.setTransform(167.0019,104.539,0.6501,0.6501);

	this.shape_604 = new cjs.Shape();
	this.shape_604.graphics.f("#FFFFFF").s().p("AgFAAIAEgBIAHADg");
	this.shape_604.setTransform(133.3453,104.6202,0.6501,0.6501);

	this.shape_605 = new cjs.Shape();
	this.shape_605.graphics.f("#FFFFFF").s().p("AAAAEIAAgHIABAAIAAAHg");
	this.shape_605.setTransform(169.6508,104.4577,0.6501,0.6501);

	this.shape_606 = new cjs.Shape();
	this.shape_606.graphics.f("#FFFFFF").s().p("AgCAAIAEAAIABABg");
	this.shape_606.setTransform(127.8848,104.214,0.6501,0.6501);

	this.shape_607 = new cjs.Shape();
	this.shape_607.graphics.f("#FFFFFF").s().p("AAAABIAAgCIABAAIAAACg");
	this.shape_607.setTransform(134.3854,103.7264,0.6501,0.6501);

	this.shape_608 = new cjs.Shape();
	this.shape_608.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_608.setTransform(156.406,103.6127,0.6501,0.6501);

	this.shape_609 = new cjs.Shape();
	this.shape_609.graphics.f("#FFFFFF").s().p("AgQAAIAJABIgXAKQgCgDAQgIgAAPgFQgNAEgCgBIgBABIgCgCIAigHQgGADACAHQgDgIgJADg");
	this.shape_609.setTransform(118.8093,104.3765,0.6501,0.6501);

	this.shape_610 = new cjs.Shape();
	this.shape_610.graphics.f("#FFFFFF").s().p("AgRAAIAggEQgCAGAFACg");
	this.shape_610.setTransform(122.9769,103.5314,0.6501,0.6501);

	this.shape_611 = new cjs.Shape();
	this.shape_611.graphics.f("#FFFFFF").s().p("AgEgCIgMgFQAVgEAMAUQgEgBgRgKg");
	this.shape_611.setTransform(162.4352,103.5264,0.6501,0.6501);

	this.shape_612 = new cjs.Shape();
	this.shape_612.graphics.f("#FFFFFF").s().p("AgCACQACgGACAEQABAAAAAAQAAAAAAABQgBAAAAAAQAAABgBAAg");
	this.shape_612.setTransform(157.8794,103.1774,0.6501,0.6501);

	this.shape_613 = new cjs.Shape();
	this.shape_613.graphics.f("#FFFFFF").s().p("AAAACQgFACgEgEIATgCQAAAFgGAAIgEgBg");
	this.shape_613.setTransform(125.4822,103.1942,0.6501,0.6501);

	this.shape_614 = new cjs.Shape();
	this.shape_614.graphics.f("#FFFFFF").s().p("AgqgCQAZgFA8ALIhVgGg");
	this.shape_614.setTransform(129.4612,103.3062,0.6501,0.6501);

	this.shape_615 = new cjs.Shape();
	this.shape_615.graphics.f("#FFFFFF").s().p("AAAgFIACAAIAAALQgGgBAEgKg");
	this.shape_615.setTransform(156.8645,103.1576,0.6501,0.6501);

	this.shape_616 = new cjs.Shape();
	this.shape_616.graphics.f("#FFFFFF").s().p("AgHACIAIgDIAHADg");
	this.shape_616.setTransform(159.8675,102.7838,0.6501,0.6501);

	this.shape_617 = new cjs.Shape();
	this.shape_617.graphics.f("#FFFFFF").s().p("AgDACIgCABIADgHQAIAAAAAJQgCgDgHAAg");
	this.shape_617.setTransform(168.2532,102.6701,0.6501,0.6501);

	this.shape_618 = new cjs.Shape();
	this.shape_618.graphics.f("#FFFFFF").s().p("AAAgDIABAAIAAAGg");
	this.shape_618.setTransform(157.1698,102.2963,0.6501,0.6501);

	this.shape_619 = new cjs.Shape();
	this.shape_619.graphics.f("#000000").s().p("AAIBQQAJgVgZgcQgHgKgNAFIgUAJIgSAUQgMAOgCALIgHAHQgBgLAGgfQAEgbgDgQQgLgHgjgBQgrAbgVAeIgJAFQAXg/gFgdQgMgTgbgMQgLgEgsAKQgQAEghAEQAtgbAZgJQApgPAogFQBXgNBPAaIALgBQAGAIgBABQgGABgBAKQgBAJgGgCQgIAWATAlIAPALQAJAGAIgEQAJgKALgIQAEADgCAJQgBAIACADQAVAWAOgHQAHgBAFgJQAHgKAIgDQgCACgCAaQAYAGAlgoQAJgIAOAHQAQAIAIACQBCA1AiARIgEAEQgMACgXgMQgWgLgOAEQgOAFgOASQgPAUgNAEIAAgSQgBgMgIgEQgHgFgSgCQgGADgJAMQgJALgHABIgKgWQgGgOgMADQgPASgkAOQgsARgJAHIAKgjg");
	this.shape_619.setTransform(135.0029,109.5117,0.6501,0.6501);

	this.shape_620 = new cjs.Shape();
	this.shape_620.graphics.f("#FFFFFF").s().p("AAABXQAEgIAAgEIAAAAIABgHQAGgPgYgZQgEgGgDAAIgKAFQgIAEgLADIgHAPQgWAZgBACIAAACIgQAOIAAgOIACgJQABgKAFgQQADgOAAgNIgBgQQgHgEgUAAIgJAAQg7AlgLAPIgFACIgEADIgNAIIATgnQAJgiAAgPQAAgHgBgGQgMgQgZgNQgVgEgdAHQgiAKgVAAQgFAMAJAEQAGABABgEQABgEgFgEIAJACQAAAGgJANIgFgCQgDgGgHgDIACgQIAVgOQAjgVAsgOQAbgIAagEQAnAAATgFQAEgBAyAHIAtAKQALAFADAAIALgDIACABIACACQAMAJgBABIgIABIAGABQgDABgCAIQgBAHgDACQAAAAgBAAQAAAAgBABQAAAAgBAAQgBAAAAAAQgBAFAAAGQAAAfAGAMIAHAFQANAMAIgEQAIgLALgIIAMgJIAAAMQABAGgCAIQgBAGABACIABABQAQASAMgGQADgBAHgJIATgVQADgEgDAZIgCAMQAAAFAIgBQASgCAbgeIACgDQATgNAVALIALAFIAFAFIAkAdQAsAjALAGIAPACIgQAIQgNADgXgMQgRgJgLADQgNAEgPATQgOASgNAGIgLAAIAAgMIAAgEQAAgQgIgEQgFgEgLgBIgHgBIgMARQgJANgGABIgEABIgCgGQgEgEgEgMQgGgRgNADQgOAPgtARQgZAJgOALIgCABIgNALQACgUALgRg");
	this.shape_620.setTransform(135.1167,109.7841,0.6501,0.6501);

	this.shape_621 = new cjs.Shape();
	this.shape_621.graphics.f("#FFFFFF").s().p("AgCgGQAGgBgBAFIgCAJIgBAAQgBAAgBgNg");
	this.shape_621.setTransform(155.679,102.201,0.6501,0.6501);

	this.shape_622 = new cjs.Shape();
	this.shape_622.graphics.f("#FFFFFF").s().p("AAAACIAAgCIABAAIAAACg");
	this.shape_622.setTransform(169.0983,101.4187,0.6501,0.6501);

	this.shape_623 = new cjs.Shape();
	this.shape_623.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_623.setTransform(169.5696,101.2887,0.6501,0.6501);

	this.shape_624 = new cjs.Shape();
	this.shape_624.graphics.f("#FFFFFF").s().p("AAAAFQgDgCACgDQABgDADgBIgCAJg");
	this.shape_624.setTransform(157.5338,101.435,0.6501,0.6501);

	this.shape_625 = new cjs.Shape();
	this.shape_625.graphics.f("#FFFFFF").s().p("AgBACQgNgJAAgKQAGACAHAPQAGALAKAAIgCAHQgBgDgNgNg");
	this.shape_625.setTransform(168.9706,101.9388,0.6501,0.6501);

	this.shape_626 = new cjs.Shape();
	this.shape_626.graphics.f("#FFFFFF").s().p("AgDgCQAEgCADAEIAAACQAAAAgBABQAAAAgBAAQAAAAAAABQgBAAAAAAQgCAAgCgGg");
	this.shape_626.setTransform(166.9531,100.5653,0.6501,0.6501);

	this.shape_627 = new cjs.Shape();
	this.shape_627.graphics.f("#FFFFFF").s().p("AgCACQgBgFAGADIgCACg");
	this.shape_627.setTransform(154.1427,100.4182,0.6501,0.6501);

	this.shape_628 = new cjs.Shape();
	this.shape_628.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_628.setTransform(152.8957,100.1186,0.6501,0.6501);

	this.shape_629 = new cjs.Shape();
	this.shape_629.graphics.f("#FFFFFF").s().p("AABACQgHgFABgEQAJAAACAMIgBADQAAgDgEgDg");
	this.shape_629.setTransform(166.0593,100.6061,0.6501,0.6501);

	this.shape_630 = new cjs.Shape();
	this.shape_630.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_630.setTransform(152.3106,100.0211,0.6501,0.6501);

	this.shape_631 = new cjs.Shape();
	this.shape_631.graphics.f("#FFFFFF").s().p("AAAgCQAAAAAAAAQAAAAAAAAQAAABABAAQAAABABAAIAAACIgCABQgCAAACgFg");
	this.shape_631.setTransform(158.2726,99.8058,0.6501,0.6501);

	this.shape_632 = new cjs.Shape();
	this.shape_632.graphics.f("#FFFFFF").s().p("AgKAAIgBgFIAXADQgCABgBADQABABAAAAQAAABABAAQAAABAAAAQAAAAAAABQgLgLgKAFg");
	this.shape_632.setTransform(164.2229,99.7448,0.6501,0.6501);

	this.shape_633 = new cjs.Shape();
	this.shape_633.graphics.f("#FFFFFF").s().p("AgBABIAAgBIACAAIAAABg");
	this.shape_633.setTransform(160.3713,98.721,0.6501,0.6501);

	this.shape_634 = new cjs.Shape();
	this.shape_634.graphics.f("#FFFFFF").s().p("AAAACIAAgDIABAAIAAADg");
	this.shape_634.setTransform(157.316,98.591,0.6501,0.6501);

	this.shape_635 = new cjs.Shape();
	this.shape_635.graphics.f("#000000").s().p("AAKB/QgBgKAVgOQATgNgDgQQACgbgXgOQgFgBgKgEQgJgCgFAFIAAADQgBABgIgCQAAAIgJABQgMAAgBABQgJAEgSASQgRAPgMABQABgHALgIQAMgJADgGQANgGAIgkQgDgHgCgPQgDgMgLgGQgogPgWAGQgRAKgTAWQgUAZgJALQgDgOANgXIACgkQgCgXgPgIQgWgEgiAFIg4AKQgLAIAAAFQAEAEAFgBIAFgFIgFAHQgIADgFgJQgGgHgHAGIgMAEQANgKAqgTQAngRAPgPIA9gPQC8AGBPAhQAFAIgKADQgLAFgCADQgfAnATAkQADAMAMAAQASgMACAAQAGAEgBAVQAAAQANgGQADgMAWgOQACACgBAMQAAAKAIgBQArgbgLgqQgHgEACgHQBBgGAlAMQARARANABQAjAkAFAXQgNgDgXgPQgWgQgJADQgQAGgCALQgDACgCAQQgBALgKAAQABgJgPgPQgUgEgVASQgWAXgLAJQgBgCgCgKQgCgHgHAAQgMACgoAhIgoAVQgXALgUAAIgBAAg");
	this.shape_635.setTransform(166.6118,106.246,0.6501,0.6501);

	this.shape_636 = new cjs.Shape();
	this.shape_636.graphics.f("#FFFFFF").s().p("AAMCDIgDAAIAAgCQAAgMATgMQASgNAAgMIAAgFIAAgCQAAgYgUgMIgKgDQgKgEgFAEIAAADIgBAAQgCAEgGgDQAAABAAABQAAAAgBABQAAAAAAABQgBAAAAABQgDADgKAAQgHAAgCABQgIAEgOANQgVATgOACIgDABIABgEQABgIANgKQALgIACgFIAAgBIABAAQANgFAFgbIACgIIgDgLQgEgUgLgGIgCgBQgqgPgMADQgRAJggAnIgcAiIABgNIAIgWQAGgJgBgGIABgMQAEghgTgKQgtgKgiAHIgeAFIgCABQgGAEgBAEQADACADAAIAJgJIAAAGQAAADgFAEIgBACIgBAAIgBABQgJAEgHgKIgDgEQgCAAgFADIgCABIgTAEIAQgMQALgIAjgQQAlgPASgQIABAAIBMgTQCiAGBbAlIABABIAAAAQACAEAAADIgBADQgBAEgJACQgIADgBADQgSAWAAAbQAAAOAFAKQAEAJAKAAIAEgDQAIgIAHAAIABAAIABABQAHAEAAATQgBALABACIAIgCQACgHAPgLIAIgHIACgCIABACQADACAAAKQgBAIABACIAEAAQAggVAAgfIgCgNQgFgEgBgGIABgEIABgBIABgBQBAgGAnANIAOAJQAJAJAHAAIABAAIADADQAhAiAFAYIABAEIgEgBQgGgBgNgJQgLgHgGgBIAAAAIgGgFQgOgLgIADQgDADgHADQgHAEgBAFIAAAAIgBABQgDADgBAJQgBASgMABIgDAAIAAgDIAAgCQABgHgLgLIgDgCQgXgEgfAhIgSASIgBgBQgEgDgBgIQAAgIgGAAQgPADgXAVIgNALIgVALQglAWgaAAIgCgBg");
	this.shape_636.setTransform(166.4493,106.133,0.6501,0.6501);

	this.shape_637 = new cjs.Shape();
	this.shape_637.graphics.f("#FFFFFF").s().p("AAAABIAAgCIABAAIAAACg");
	this.shape_637.setTransform(158.2424,117.4751,0.6501,0.6501);

	this.shape_638 = new cjs.Shape();
	this.shape_638.graphics.f("#FFFFFF").s().p("AgBABIAAgCIADAAIAAACg");
	this.shape_638.setTransform(158.1449,116.89,0.6501,0.6501);

	this.shape_639 = new cjs.Shape();
	this.shape_639.graphics.f("#FFFFFF").s().p("AAAgHIABALIAAAEg");
	this.shape_639.setTransform(157.7548,115.9962,0.6501,0.6501);

	this.shape_640 = new cjs.Shape();
	this.shape_640.graphics.f("#FFFFFF").s().p("AAGgKQgIANgCAIQgEgIAOgNg");
	this.shape_640.setTransform(191.8287,155.7796,0.6501,0.6501);

	this.shape_641 = new cjs.Shape();
	this.shape_641.graphics.f("#FFFFFF").s().p("AEyBVQgLgGgsgFQgjgEgPgTQgmgEhLAHQhOAIgjgCQggAHg/gGQg/gGgfAHQgfAChKgEQhJgEgjACIAOg4QAlgCBtAGQBYAGA1gOQA6gIB6APQB1APA/gOQAVgKAbgcQAhgiANgKIBTgIQAEgBgCAEQgEAKgLADQgPAFgEAEQAbgCAOABQARAHgSAHQgIADgrgCQgggCgJAWQAIAEASAAQAUgBAHACQAHAOgUAAQgJADgegDQgaAAgFARQAAACAEAGIAjABQgGAFgMACIgVACQACgCgEgFQgIgCgBAIQgHARANAPQANATAUgMQAOgJAFACQAIADgJAJQgMAOgSAAIgHgBg");
	this.shape_641.setTransform(244.7363,155.1756,0.6501,0.6501);

	this.shape_642 = new cjs.Shape();
	this.shape_642.graphics.f("#FFFFFF").s().p("AADgLIAAADIACAAIgJAUg");
	this.shape_642.setTransform(193.1991,149.8478,0.6501,0.6501);

	this.shape_643 = new cjs.Shape();
	this.shape_643.graphics.f("#FFFFFF").s().p("AAAgEIAEAAIAAADIgGAGg");
	this.shape_643.setTransform(193.7841,148.4827,0.6501,0.6501);

	this.shape_644 = new cjs.Shape();
	this.shape_644.graphics.f("#FFFFFF").s().p("AgBAIIABgUQAEAQgDAKg");
	this.shape_644.setTransform(208.2441,146.0775,0.6501,0.6501);

	this.shape_645 = new cjs.Shape();
	this.shape_645.graphics.f("#FFFFFF").s().p("AAPgmIgJAmQgGAUgOATIAdhNg");
	this.shape_645.setTransform(197.5219,148.1414,0.6501,0.6501);

	this.shape_646 = new cjs.Shape();
	this.shape_646.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABIgBAAg");
	this.shape_646.setTransform(210.2143,144.6799,0.6501,0.6501);

	this.shape_647 = new cjs.Shape();
	this.shape_647.graphics.f("#FFFFFF").s().p("AgBgJIADAAIAAATg");
	this.shape_647.setTransform(204.6075,145.5574,0.6501,0.6501);

	this.shape_648 = new cjs.Shape();
	this.shape_648.graphics.f("#FFFFFF").s().p("AgGATQAAgUANgaQgHAPgGAog");
	this.shape_648.setTransform(205.1921,142.1284,0.6501,0.6501);

	this.shape_649 = new cjs.Shape();
	this.shape_649.graphics.f("#FFFFFF").s().p("AAAACIAAgDIABAAIAAADg");
	this.shape_649.setTransform(196.3356,142.0309,0.6501,0.6501);

	this.shape_650 = new cjs.Shape();
	this.shape_650.graphics.f("#FFFFFF").s().p("AATgmQgLArgaAig");
	this.shape_650.setTransform(193.9954,142.9735,0.6501,0.6501);

	this.shape_651 = new cjs.Shape();
	this.shape_651.graphics.f("#FFFFFF").s().p("AAFgSIgEAXIgEAOg");
	this.shape_651.setTransform(197.0019,139.8532,0.6501,0.6501);

	this.shape_652 = new cjs.Shape();
	this.shape_652.graphics.f("#FFFFFF").s().p("AgBABIAAgBIACAAIAAABg");
	this.shape_652.setTransform(223.0366,138.3418,0.6501,0.6501);

	this.shape_653 = new cjs.Shape();
	this.shape_653.graphics.f("#FFFFFF").s().p("AgHgGIAag6QgcBNgFArIgEAJQAFgMAGg7g");
	this.shape_653.setTransform(202.1373,142.4372,0.6501,0.6501);

	this.shape_654 = new cjs.Shape();
	this.shape_654.graphics.f("#FFFFFF").s().p("AgCAAQABgHACgDIAAABIAAAAIABgCIABAAIAAACIgCABIgBAFQgCAKABAFQgCgEABgIg");
	this.shape_654.setTransform(211.9083,137.25);

	this.shape_655 = new cjs.Shape();
	this.shape_655.graphics.f("#FFFFFF").s().p("AoNCnQgZgVAAgYQgCgKAIgKIAQgOQA5gUBkgIQCDgLAggGQAeACA3gRQA2gRAgABQAlgDBbAAQBUABAtgGQBVgCAigRQAXgRAVgyQAUg0AUgPQAHgFAQgHQAPgGADABQANAEgMALQgcAPgKAMQgOAQAEAVQgCABAAAFQADAGAGgFQAZgqAYgFQAXAAAKgBQAggFANAFQAAAMgPAEIgZAGQgUgGACAPQANAAAPACQALgBAAAFQAAALgUAAIgPgBIgGABQARAEgBALQgEACgkABQgZABgCAVQgIARAGAEQAMAJAXADQAFgCACABQAGgEAMgNQAKgIACAEQADAFgHAMIgWAVQgIAHgRgCQgSgDgIAEQggAegtgQIASgUQgOAFgTANQgzAChnAUQhjASg0ABIhfARQg6ALgogCQgWAEhSAKQg/AJgnAKQhYAJgkAcQgEgFgJAFQgIADgEgGQgIAGgDAAIgCAAg");
	this.shape_655.setTransform(241.8697,144.8352,0.6501,0.6501);

	this.shape_656 = new cjs.Shape();
	this.shape_656.graphics.f("#FFFFFF").s().p("AhYg8QAIgaABgHQABAQAEAEQAQgJAEgHIAPgbQAFAJAAATQgBAWACAHQAcgeAXgJQAEAIACAGIgCACIAGAQQAEAKgEAHQgjgCgGAJQAFACALARQAIAMANgFQABgFgGgEQgHgFgBgDIAfAAQgFAMALALQAIACAGgLQAGgLAJADQAHgKgBgFQgSgGgfAAQAFgEASgKQAOgHAGgKQAGAFAFASQAEAQAFgBQgNAlANAgQADAVgKADQgPAFgGAFQgFAKADANQgZAGgIAHQABAEAFAAQAFAAAAADIhrAMQg1gxAbiAg");
	this.shape_656.setTransform(219.2049,140.5683,0.6501,0.6501);

	this.shape_657 = new cjs.Shape();
	this.shape_657.graphics.f("#FFFFFF").s().p("ABXBDQAAgUgDgDQgGgLgEAQQgNAogCAAQgEgagMgJIgFAHQgCAJgHAKQgEgkgEgCQgJgFgGAhQgCgBgDgOQgDgNgIAEQgNAggBgBQgGgmgEAFQgEgBgLAPQAAgogBAAQgIAGgjAdQANgcACgOQgFgGgJAKIgXAPQgDgBAIgQQAIgPgCgDQgDgGgHAFQgJAFgDgEQgEAEgJACQgJACgFAFQABgDALgOQAJgNAAgGQgJgEgQAHQACgDAHgVQgEAAgFgDQgFgCgLAJQATgoAggFQgRAZAGABIAhgPIgRAbQAWgPAMACIgMAPQgGAIABAJQACABAQgEIAXgJIgQASQgIAKAHAGQATgDADgKQABgDAEABQAEACADgEQgLAgADACQAEABAJgGQAJgGABgFQAAAcAGACQAEAAALgbQAMAiADgCQAHgBAKgjIAUAsQAKgQADgUQAGAVAJAGQAMgFgBgRQALAQAHANQAHgDAAgQIAAgKIASAaIAGgXQACgDADAFQAAAQAGACQAIgJABgHQAHAAABACQAQAbgGAVQgEgCgIgaQgGAEAAAhIgFgQQgDgLgDAEQgCABgEAkQgEgfgIgDQgBAXgKALIgDgQQgDgKgFABQgJABgCAhQgEgDgBgVg");
	this.shape_657.setTransform(218.3281,121.8304,0.6501,0.6501);

	this.shape_658 = new cjs.Shape();
	this.shape_658.graphics.f("#000000").s().p("AoyRoQiAARiXguQgSgMgjgCQgpgCgOgFQgLgVgBgkQgCgsgEgQQAAggAEgJQAOgBADgRQAEgYACgDQAuhFAmguIAhAEQBVhyC3iSQAvgxAMgmQAFgKA9iWQgUACglgJQgBAEgGABQgHAAgCACQgEAAgKAIQgIAHgHgGIgGgHQAIgIgJgHQgOgKAAgCQgGAAgbAJQgUAHgNgJQgBgIAGAAQAIABADgCQAWgPAAgIQgBgCgFAAIgCgMQgBgIgIACIgjgCQgTgBgIgNQAMgFAJABIAagSQAPgMAEgNQCFioBLjFIAIgVQABgGgGgDIgHAJQADgZgIgGQgQAXgDABQgIACgDACIgOAQQgHAIgJAFIAVgjQARgbACgXQgLAIgNAaQgMAYgOAGQgPAagoAUIgDAAQAFgMATgTIAQgbQgJgdAFg+QAFgOAFgdQAHgaAMgNQAIgdAfgpQAmgwAJgTIgCgCQhKBLgRA9QgBgKADghQgIAXgKAGQgBgXARgaQAKgPAYgfQBrh4AfiJQAFgFABgPQACgPAGgGQAojGCChAQApgKAVgEQAkgHAbAGQBcAKA6AnQBPAwgGCRQgWBPgXAlQgKANgFADQgBgFABgLQABgJgDgEQggAwARAoQAKAZgVAIQgNAFgGAEQgDACAEAPQgBALgJACQgIACABAFQCFgHAvgUQA/gIB0gCQB6gEA5gFIA8gIQAjgJANgcQAQgfAdg/QAcgbAhgFQAOADADAIQAEAJgNAMIgLAHIgJAFQgWANADARQARgZALgFIAzgFQASgEAJAAQAXAAACAGQABADgIAVQgCAEgIADQgJADAAADQAGACgBAHQgBAIgKAFIgOAHQAGAIgIAFQgHAEgfgBQgYgBgHAUQgDAIACAEQASAIAJAAIAXgPQATgMAGAKQAFAIgQATQgOASgPAHQgFADgQgBQgQgCgIAFQgQASgZAAQgPABgggFQgXgDgZAFQgIAAguAKQi8AjjjARQgRAGghAEQgjAEgQAFQggADg7ALQgIAFADAFQCHAOBLgCQBngcBfATQCpAQAsgFQAagLAXgPQA8g7AIgGQAMABAkgFQAdgEASAGQAIAEgEAKIgGAJQAPACACANQACAJgMAGQgQAGgagDQgZgEgRAHQADACAdACQATAAgCATQgKAOgdgBQgfAAgIAHQAEACARAAQAMgBACAMQgEAJgiAFQgYAEAWATQAFABARgJQAMgGAJAJQAIAGgGAOQgOARgUAGQgcgJgcgEIgZgCQgVgCgbgWQgggChGAHQhLAIgfgBQgNgBg4ADQguACgbgHQhYAGi2gDIgIANQgCAVgMAtQgMApgBAXQgDgBgDAFQgcBtgLA4QgYA2gMBlQgEAVATAdQAYAmADALQAJAIAPAGQAIgMAKAEQgDAMgRALQgUAMgFAJQAHAJANALQAXAVAyA9QAtA2AgAZQASBBBGCIIAiA6QAVAjAWASQAFAAADgFQAEgHACgBIAiAAQAUABAMgIQAPgbAOgHQANAFAQgVQAAgOAOgPIAYgYQAQAIAagTQAagSAUAKQAcAMANAHQAYAMACAXQgBAQATAVQAUAYADAMIAcBIQgBAYgUAbQgZAegKAQQg5AqgdATQgzAigqANQg2APgUgDQgXgkg6hEQgJAAACgHQgUgWgMgnQgGgWgKgtIAGgDQgCgEgNgRQhqijg7h6QgbgmhnhNQgYgYg1gpQgkAFhNARQgJACgdgBQgYgCgNAIQgdA8gKAfQggA8hQB7QgTAMhUBFQh3Bfg7BBQAIgCAEADQABAGAIACQALADACACQAbAdgGATQAIALAQgGQAEAAAKgLQAIgIAIAFIASAFQALAEAEAIIAAAJQAAAGAFAAQAqAAAaAiQAYAjgNA3QAEAagEAfQACA+gRAaIAAAHg");
	this.shape_658.setTransform(215.5156,187.5747,0.6501,0.6501);

	this.shape_659 = new cjs.Shape();
	this.shape_659.graphics.f("#FFFFFF").s().p("ApNRpQgbABhGgKQgXgDgvAAQgZgFgugKIhYgNQgdgEgFgHQgEgEgBggQgCgWgIgrQgBgkAhg6IAqhGQASgZANgJQAIgFARgEQASgEAHgGQAIgFANgZQAEgKATgSIAegdQgZAdgYAeQglAwgJAUQgIAUASgEQARgEAKgMQAFgGAHgOIAUgSIAxgvQAfgdBPhBIAbgWQAzgqAagQIAAAAIAAgBQBKhvAmhIQAGgSAPgdQAPggADgLQAHgFAMgBQALgCASABQAXABAKgCIALgCIgSADQgJADgYgBQgNgCgJABQgIACgEADQgIAZgHAOIgeA/QhBB4gmAzIgMAKIgQAIQgPAJglAgIgbAWQh3Bhg3A7QAFgBADACIABABIAAABQABAEAJADQAHABAEADIADADQAVAYAAAPIgBAIQAGAHAOgEQADgBAHgHQALgMAKAGIAKADQATAEAGALQgBAMABACQARADAGACQARAIAOATQAhAvgBAQQgIAggBAQQAAAqgCAVQgCAagGAVQgEAOgDABIgHAAIgMAAgAFkPHIgCgBIAAgBQgMgRgcgiQgbgggNgUQgFAAgCgDQAAAAgBgBQAAAAAAgBQAAgBAAAAQgBgBAAAAIAAgCQgYgbgQhDIgJgmIAEABIACAAIAAgBQgDgGgGgIIACgGIAAAAQg3hWgphHQAnBAA6BbIgBACIAEAEQAHAJADAGIgBAAIgBABIgFgBIAKAlQAPBDAZAcIAAABQAAABAAAAQAAABAAAAQAAABABABQAAAAAAABQADADAEAAQAMARAcAiQAcAhAMATIABABIABAAQARACAhgIQgeAIgTAAIgHAAgAGmO9IAIgDQA0gPBahCIAngcIAAAAQAJgOAMgNQAWgbAIgVQADgMABgMIABgCIABACIAAABQgBAKgFANQgGAZgSAWQgNAPgHAMIgBAAIgmAcQhYBBg2AQIgJACIgLADIAFgBgAKNLLIgNgnQgCgHgTgWQgYgaABgRQgDgbgogQQgLgEgJgGQgWgLgaASQgPAKgOgCQALgCANgJQAdgUAVALIAXAKQArARADAdQgBAQAVAWQASAUADAOQAGAOAJAaIALAcgADUJmQgOgZgIgMIgGgMQhAh+gSg+IAAgBIAAgBQghgZg0g/Qgqg0gXgUIAAgBIgBAAQgIAAgHgNIgCgEQAFgJAPgIQAUgNAEgNIAAgCIgCgBIgEgBQAFgDAGADIACABIgBACQgDANgVAMIgUAOIATASQANAMAzBAIBUBUIADAAQAXBRA5BxIAGAMQAJANAOAYQAdAyAXAUQgDAEgCAAQgXgUgfg1gAEPKrIAAgBQADgGAEgCIABAAIAEAAIgFAHQgDAEgCAAIgCgCgAEuKiQgMgBgHABIABgBIABAAQAIgBAQABQAMABAJgBQAJgCAFgDIAAgBQAPgbAOgHIABAAIABAAIABABQgMAIgOAYIAAABQgHAEgNACQgIABgNAAIgHAAgAqzJqQAYgcAlgfIAbgVIAIgGIAZgWQAQgQAVgcQADgPARghQAghCALgkQAEgQANgdQgMAAgNgHQgPgDgTANQgRAMgLgEIgPgQIACgBQADgEAAgCQAAgDgIgFQgHgFgCgDIgFAAQAHgCAEAAQADAEAGAFQAIAEABADIAAABQAAACgEADIgCACIAJAJQAJAIAMgKQAGgGAEAAIABABIABgBIAFgCQAHAAADgFIAUAEQAOAHALAAQgLAZgGATQgLAlggBCQgQAhgEAPQgZAggLAMIgMAKIgUANQgeAZgQAQQgdAcgkAnIAPgWgAF4J6IADgCIACAAIAEABIgGABIgDAAgAGBJ5QAHgDAHgLIABgBQACgRAZgYIANgNIACABIACABIgKAKQgaAXgBASIgBABQgKAPgJAAIgCAAgAG8I2IADgDIABABIAIACIgFABIgHgBgAG8I2IAAAAgAAuGgQgKgPgwgmQg4gsgGgHQgIgIgDgBIAAAAIgBAAQgNgNgcgWQgYgTgLgKIAHgBQARAPASAOQAcAWANAMIAAABIABAAQAEACAGAHQALALAGAAQAMANAhAbQAqAiAOAUQAcA5ApBHQg1hXgUgpgAp6D5IgBgBIAAgBQAAgGACgDQACgCAFABIgBAAQgDACABAGIAAACIACAAQAKAHAQgCQgIACgGAAQgLAAgIgFgApxDtIgBAAQABgCAGAAIACABQgCABgDAAIgDAAgAppDrIAEgDQAQgIAAgIIgBgBIgDABIgBgCQgCgDAAgHQAAgFgCgBQAAgBAAAAQgBAAAAAAQgBAAAAAAQgBAAgBABIgBAAQgIgCgQAAQgfAAgKgQIgDgGQAIgEAIAAIgKACIAEAHQAJAPAfAAQAQAAAIACIABAAIAFAAQABACAAAFQAAAHADADIAAABIAEAAQAAAIgPAJIgFADQgCACgEAAgAqPCoIAKgHQAPgKATgWQAQgSAXgfIglAyQgOATgPAKIgNAJIgEAAgAhBCRQgFgNgPgZQgWgiAAgRIABgIQANhmAWg0QAGgeAOgyQAPg8AFgZIACgCIACgBIACgCQABgUANgvQALgnACgXIAGgLIBMAAIhDAEIgHALQgCATgLArQgPAzgBALIgBACIgCAAIgBABIAAAHQgHAlgNAwQgNAxgHAfQgWA1gNBlIgBAIQAAATAWAgQAQAZACAIQAIAGALAFIgDADQgNgFgJgIgAgoCbQAGgHAGACQgEABgFAFIgDgBgAgoCbIAAAAgAoHAAIAcgzQAvhSAkheIAHgVIgFgEIADgTQAAgDgCgDQgNAXgLAAIgJANQgJALgUAHQADgFAGgOIAEgGIADgLQAHgKADgOQAIgRAHgHIgFARIgHARQgJAQgHAJQgEAOgFAGQAPgLADgEQADgGAHgHQALAAAOgVIACgEIADAEIABgBIADgEQAEAEAAAGIgDATIAIAAQgKAXAAACQghBZgyBXQgkA9gVAeQALgQAMgXgAn9j5IANgZIABADIADgLIgEAIQgHgWAAgaIABgeIABAUQAAAMAHAVIADAKIABgCIgDgNQABgFAAgKQAAgNAGgCIABgBIAAgCQAEgrAbgdIgCAHIgDAMQgGADgNAxIAAACIgBAGQgCAFAAAMIACAFIAOgdQAGgMALgjIgGAFIgBgHIABAAQALgZAPgXQgJAPgKAfIgBAEIABgBIAUgoQgGANgHAXQgMAmgHANIgXAuIABgBIABgHQACgEgBgEIgLAUQADAFADgEIgTAlQgFAKgTATQgSASgEAKIACAAIgIACQAngtAHgNgAn9jXQALgHAJgJIANgQQAOgHAOgbQAEgJADAGIAAABIgBABQgOAegNAGQgRAdgiAQIgRAHIgKABQAPgFAXgRgAmGj9IABAAIgBgEIgBAAIACgDIAAAAIADADQAAACgEAEIAAgCgAmIj9QAAgFACAFgAntmDQAKgwAHgIIADgJQgDACgDgBQgDgCgHAOIgGgRIAAgEQAAgXAXgeQBWhxAMgVIAXgnIgXArQgNAYhSBqQgVAbAAAeIAAADIAAAFIAEgDQAGgDAFgMIACgGIAAACIgCAMIAAAEIADAAQAEgJAGgJIADgFQAFgPAEgHQAMgTAjgjIAKgKIgJAPQgpAogQAfIgBADIAFgHIAdgjIAYggIAGgGIAKgKQgKAQgYAfQgqA3gHAaQgRARgHAkIgFARIAFgVgAnLmDIAAgDQACgBACAFgALzmGQgfgJgYgDIgGgBQgMgCgHABQgWgCgagVIgBgBQgdgChQAHQhCAHggAAQgRgCglACQg7ADgdgHQg/AFhygBIgQAAIAXgCQB3ABA5gEQAcAHA9gDQApgBAMABQAlAAA+gHQBIgHAkABIACACQAaAVAVACQAHgBAMACIAGAAQAZAEAeAJIgEABIgBABgAL5mHQASgHANgPIAAgBIAAAAQAHgRgJgGQgGgHgJABIgHAEQgJAFgGAAIAIgEQAIgEAGgBQANgEAIAIQAJAHgGAQIAAABIgBAAQgPASgUAGgALqmxQgKgJAAgEIAAAAQABgCAKgBQgBAAgBAAQAAAAgBAAQAAABgBAAQAAAAAAABIgBAAQAAAEALAJIgFABIgCAAgAMTnSIAAgCQgBgPgUACIgJAAIAJgDIgDABIAKABQATgBACAOIAAABQgEAKgWAFQAQgFADgIgAM+nyIABgBIAAgBQABgLgFgGQgGgGgTABIgOgBIAGgBIAOAAQAVAAAFAGQAFAGgCALIAAABIgBAAQgGAKgQADQALgEAFgHgAHfnyIgtgFQhNgPhRAPQBUgRBQAQIAtAFQBoALA6gEIgBAAQgUACgYAAQgzAAhIgIgAKHnsIAAAAIAAAAgAK1oGIAVgVQAdgdATgPIAAAAIABAAIAEAAIABgBIABAAIABAAQAKABAcgEQAngFATAGQAFADABAFIAAACQAAAHgFAHQANAEACAMIABACQAAAKgNAGIgKADIAEgBQAMgHAAgKIAAgCQgDgNgNgDQAGgHAAgGIAAgCQgBgFgFgDQgVgHgmAFQgXADgLAAQgPALggAgIgVAVQgWAPgZALIgFABQAbgMATgOgABen1IhDgFIAEgEIAGgBIgBACIgDACIBDAFQBUAIA2gBIgEABIgMAAQgwAAhQgHgAM1oMQgPgCgMACQANgEAVADQATACANgCQgJADgLAAIgTgCgAMaoMIAAAAgALzpeIgQgCQgSgCgUADQAWgFAWADIARACQAXADASgDQAQgFAKgKIAHgCIgBAAQgLANgVAEQgLADgOAAQgLAAgMgCgABupmQAMgBABgOIAAgBIgCgMIAAgCQAEgDAHgCIAIgDQAQgHAAgOIgDgPIgBgBQgHgQAAgPQAAgWATgcIAAABIgBAKQgLAUAAASQAAANAHARIAAACQAEAKAAAHQAAANgOAFIgLAEQgGABgDADIAAABIAAAOIAAABQgBANgMACIgEACIAMgBQAogCAggDQgjAEgrACIgNABgANVpxQgKAAgGABQAIgEAOACIANAAQgEACgGAAIgJgBgANqpzQAggOAJgfQACgGgDgEQgDgFgFgCIgBAAQgJADgNAKIgNAIIgDAAIAJgHQATgOAKAAQAEgBADAAQAFABAEAGQACADgCAHQgIAdghAQQgCACgGAAIACgBgALrq+IASgoQAPgjAMgTQAegbAggGIABAAQgcAGgdAaQgMATgOAjIgTAoQgLAYgaAJQgKAEgVADQAwgKAOgdgANHqiIAAgBIABgEIABgGIAAABQAFgOATgCQgOADgEAMIAAgBIgBAKIAAABQANAGAIABIgDABQgHAAgSgHgANjqcIAAAAgAlAr3IAKggIABAAIgNAqQgJAegQAbIgDAFQAWgtAIgbgAOMrAQAFgEABgFIAAgBIgCgEIAIgEQAPgHABgKIAAgCQAAgEgDgEIAFgCQAKgDACgGIADgGQAHgLgCgJQgCgHgaAAQgEgBgNADIgEAAIgGABIgWACQgRAAgIACIAJgHQALgJAAgJIgBgGQgFgJgOgCIgBgBIAGgBIAAAAIACAAQAOACAEAKIABAGQAAAJgKAJQgDADgHADIAagCIAVgBIAKgCIARgCQAaAAACAIQADAJgHALIgDAFQgCAGgLADIgFADQAEAEAAADIAAACQgBAMgQAFIgHAEIABAEIAAACQAAAFgFAEQgEACgHABIAEgCgACjrxIAAgGIAHgMIABABIgCAPIABAHIABAEIADgCIAFgFIgEAGIgLAIgAC1r2IACgDQAYglAUhOIABgDQAHiShQgxQg7gohdgKIgXgEQARAAANADQBcAJA7ApQBRAxgHCSIgBADQgVBNgXAmIgDADIgIAIIACgHgACjr3IAAAAgAkuszQAEgSAKgJQAThfAlhAIgDAHQgLAagWBtQgdAsgJATIAEgTgAiHxRIAHgIIApgLIgVAIIgNACIgGAGIATgIIAagEIgvANQg/AfgoBHQAdhDBEghg");
	this.shape_659.setTransform(215.9227,187.1528,0.6501,0.6501);

	this.shape_660 = new cjs.Shape();
	this.shape_660.graphics.f("#000000").s().p("AAAAEIAAgHIABAAIAAAHg");
	this.shape_660.setTransform(197.9607,138.8131,0.6501,0.6501);

	this.shape_661 = new cjs.Shape();
	this.shape_661.graphics.f("#FFFFFF").s().p("AAAABIAAgCIACAAIAAACg");
	this.shape_661.setTransform(200.1872,116.89,0.6501,0.6501);

	this.shape_662 = new cjs.Shape();
	this.shape_662.graphics.f("#FFFFFF").s().p("AgDgDIAGAFIgDADg");
	this.shape_662.setTransform(197.5544,116.955,0.6501,0.6501);

	this.shape_663 = new cjs.Shape();
	this.shape_663.graphics.f("#000000").s().p("AgZAuQgLgEgDgLIgDgVIADgHQABgDAFABQAZAZAMAAQgEgJgQgMIAIAAIAIAIQAGAFAFgDQgEgFgIgJQAFgBAKAJQAHAHAFgLIgIgQIAEAAIgCgJQAEABADAHQAEAIABABQAJgRgTgOQAAgEgJgCQgGgBAGgFQAWAHAGAcQAHAXgnAcQgJAHgMAAQgGAAgHgBg");
	this.shape_663.setTransform(199.3767,115.8699,0.6501,0.6501);

	this.shape_664 = new cjs.Shape();
	this.shape_664.graphics.f("#000000").s().p("AgGAPIAFgFQgKgBgEgJIAPgCQAAgCgFgCQgEgCABgEIAOAHIgDgLQADgBAKAJIgGAOQgDAKgIABg");
	this.shape_664.setTransform(200.4634,99.5626,0.6501,0.6501);

	this.shape_665 = new cjs.Shape();
	this.shape_665.graphics.f("#000000").s().p("AgCAAIACAAIADABg");
	this.shape_665.setTransform(203.795,98.1522,0.6501,0.6501);

	this.shape_666 = new cjs.Shape();
	this.shape_666.graphics.f("#000000").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_666.setTransform(202.4299,97.6809,0.6501,0.6501);

	this.shape_667 = new cjs.Shape();
	this.shape_667.graphics.f("#FFFFFF").s().p("AAAABIAAgBIACAAIAAABg");
	this.shape_667.setTransform(164.2066,93.7156,0.6501,0.6501);

	this.shape_668 = new cjs.Shape();
	this.shape_668.graphics.f("#000000").s().p("AgeADQAEgDAJAKQAIAMAJgHQAAgCgGgFQgEgEABgEIAPAMQADgDgDgDQgEgEACgCIANAGQAFgGgHgJQgJgMAAgGQAEgEAJAHQAHAFAFAXQgCADgHATQgGgFgSAJIgBAAQgMAAgPgbg");
	this.shape_668.setTransform(176.0539,93.1557,0.6501,0.6501);

	this.shape_669 = new cjs.Shape();
	this.shape_669.graphics.f("#FFFFFF").s().p("AgCgBIAagPQgdAWgSALQAFgJAQgJg");
	this.shape_669.setTransform(166.7256,91.8792,0.6501,0.6501);

	this.shape_670 = new cjs.Shape();
	this.shape_670.graphics.f("#FFFFFF").s().p("AApgLQgcAKg1ANQA2gUAbgDg");
	this.shape_670.setTransform(175.7451,87.4913,0.6501,0.6501);

	this.shape_671 = new cjs.Shape();
	this.shape_671.graphics.f("#FFFFFF").s().p("Ag6F9Qh1gbgtgpIhrh/QgEgEABgNQABgJgLgCQg0hrAAg/QAAgnAbhwQALgPAOgcIAAgFQBDhJBHglQAKgMAYgJQAcgIAMgGQAJgGAfgIQAagHALgLQADABAOAAQAJgBABAMQADABAEgEQgEgGABgCIAKAAQABAGAIACIAMAFIABgJQCLAIA3AqQAMAEAPAMIAZATQA8A7AXAkIgGgBIgCACQAOACAGAQQAHAUAHAFQAZAgABA7QgEBEABAeQgbBhhCBuQgXAngwAjQABACAEAAQgQARg7AYQgKgDgPAKQgLABhUAUQgcAHgWAAQgZAAgTgIg");
	this.shape_671.setTransform(182.7654,111.6736,0.6501,0.6501);

	this.shape_672 = new cjs.Shape();
	this.shape_672.graphics.f("#000000").s().p("AjDFeQghgagmgsIg9hMQgDgNgUgVQgTgUgCgOQgNgXgWhaQACgNgBglQAAggAGgQQgDgCACgFQADgFgCgCIADgDQAKiKCdhoQANgEAYgPQAXgOAOgDIAAgEQAGACAHgEIAMgHQBBgcCIARIAgAIQAyAHAUAMQApAbAWAJQBnBMA+CbQAYB6hNCdQgQAfgBAOIACgCQgmAwgTAVQghAkgjAUQguAYhOALQgYAFgFAJQggAFgfAAQhiAAhZgzg");
	this.shape_672.setTransform(182.7714,111.6258,0.6501,0.6501);

	this.shape_673 = new cjs.Shape();
	this.shape_673.graphics.f("#FFFFFF").s().p("AgFgCQADgDADABQAEABABAEQgEAEgCAAQgEAAgBgHg");
	this.shape_673.setTransform(103.3452,182.3216,0.6501,0.6501);

	this.shape_674 = new cjs.Shape();
	this.shape_674.graphics.f("#FFFFFF").s().p("AgFADQACgMAJAJQgBAEgEABIgBAAQgDAAgCgCg");
	this.shape_674.setTransform(105.1979,182.2715,0.6501,0.6501);

	this.shape_675 = new cjs.Shape();
	this.shape_675.graphics.f("#000000").s().p("AABA4QAAAAgBABQAAABAAAAQAAABAAAAQAAABAAAAQAAgJgDgBQACAEgDAFIgBgGIgCAFIAAgHQgDABgBAHQgDgDADgHIgDgFIgCgHQgDgIgCgGQgBgGAAgNQABgIgBgEQgCgOAAgEIACgIQABgDgDgLIAHAGIAHgCQAGgCAJAAIAIAAQAEgBABgCQAEgLADgBIAAABIAAAQIAAATQAAAJgEAGIgDAHIgGAcIgDANIgFAMIACAGIgCAFQAAgBAAAAQAAgBAAAAQAAgBAAAAQgBgBAAAAQAAADgCACQACgDgCgDg");
	this.shape_675.setTransform(104.3041,184.0244,0.6501,0.6501);

	this.shape_676 = new cjs.Shape();
	this.shape_676.graphics.f("#FFFFFF").s().p("AACA7IgRgHQgCgDgDgHIgFgPQgBgHAAgOQABgIgBgEQgCgPAAgFIACgIIAAgLIAIAGIAIgBQAJgDAGAAIAGgBQAGgBABgCQAEgMADgBIAAABIABARQADAJAAAIQAAALgEAGIgFAHIgGAeIgEAOQgGAMABAGIgDgCg");
	this.shape_676.setTransform(104.3821,183.6344,0.6501,0.6501);

	this.shape_677 = new cjs.Shape();
	this.shape_677.graphics.f("#000000").s().p("AhiAEQgJgBArgIIAAACQAngEB+AIQhoAFg0AAQgeAAgNgCg");
	this.shape_677.setTransform(89.936,250.7186,0.6501,0.6501);

	this.shape_678 = new cjs.Shape();
	this.shape_678.graphics.f("#000000").s().p("Ag2AFQgHAAABgFQBSgIAnAEIhoAKIgLgBg");
	this.shape_678.setTransform(75.5838,271.9498,0.6501,0.6501);

	this.shape_679 = new cjs.Shape();
	this.shape_679.graphics.f("#000000").s().p("AhCABQAZgFApABQAuABAVAAQgYAFgxgCQgTADgPAAQgPAAgLgDg");
	this.shape_679.setTransform(74.0115,270.5373,0.6501,0.6501);

	this.shape_680 = new cjs.Shape();
	this.shape_680.graphics.f("#000000").s().p("AAKAHIAAAAIAbAAQAGAAgZADIgBAAQgEAAgDgDgAAIAHQgmgBALgGQgqgDA7gGIAAACQgMAEgFADIAfAAQgFADADAEIgCAAg");
	this.shape_680.setTransform(72.7402,269.8828,0.6501,0.6501);

	this.shape_681 = new cjs.Shape();
	this.shape_681.graphics.f("#000000").s().p("AgHAHQgbgCAdgEIgCAGIAGAAIAUABQACABgdABIABgDgAgFABIAFAAIgFAAgAAFAAIAAAAIAQAAIgTABIADgBgAABAAQgtgCAwgHIABAJIgEAAg");
	this.shape_681.setTransform(72.2139,268.3528,0.6501,0.6501);

	this.shape_682 = new cjs.Shape();
	this.shape_682.graphics.f("#000000").s().p("AgyANQgGAAgBgDQA6ACgfADQgDgCgRAAgAg+AKIgmgBQgLAAAWgBIAggBIACgEQA8gBgFgCQgHgFA/gFIADgEQAiAEALAAIABAEQhuAJg0AEQAAAAAAABQgBAAAAABQAAAAAAAAQAAABABAAIgFAAg");
	this.shape_682.setTransform(72.8937,266.8414,0.6501,0.6501);

	this.shape_683 = new cjs.Shape();
	this.shape_683.graphics.f("#000000").s().p("AgBADQgBgHADACIABADQAAAAgBABQAAAAAAABQgBAAAAAAQAAAAAAAAIgBAAg");
	this.shape_683.setTransform(67.1632,261.8045,0.6501,0.6501);

	this.shape_684 = new cjs.Shape();
	this.shape_684.graphics.f("#000000").s().p("AgSgCQBwgEAkADIAAACQgyAEjRACQgBgEBwgDg");
	this.shape_684.setTransform(114.428,267.8805,0.6501,0.6501);

	this.shape_685 = new cjs.Shape();
	this.shape_685.graphics.f("#000000").s().p("AgLBZQAeAABDgJQBAgIAjABIAFgEQg3gDgrADQgjAIg6gDQhGgFgXADIAAgEQAKgDASABQAUACAJgEQgGgCgSgBQgPgBgIgFQANgDAWABQAWACALgEQBLAAAdgIQgGAAgKgJQgUAJgxABQgNgDggADQggADgQgEQAtgEAUgGQgVAChAgDQgzgCggAIQhLAGgTgIQAzAHBggNIgIAAIh4gGIAAgDQBeAFBagKIg0gGIkWAJQAAgBB5gHIAHgEQADgCACAFICfgGIBDgFQgZgEhTABQhTABgXgEIAAgEQAgAEC5gIIhPgBQgYgGgvACQgzACgVgDIAAgEIAxgDIglgFIBHgDIAEADIgCAEQAQgCAXACIAlAFQABgCAJAAQAIAAABgEQhGgCgVgKIAcgDQgZgHhTAHIA2gHQAFgCAQgBQANgBAHgGQgBgEgHABQgGABAAgEQAcAAAdgIQg7gDgygEICHgGIACACQAAAOAXgCIAkgBIgBAGQgkAEhMgCIgGAIIACABQAngHASAHICCgEIAAAEQgLADgqAAQgqAAgLAGQgBAHAYgBQAagCADADQgnAFgCACIArACQA2gDAWAGQAxgDAfAGIABAFQgMABgEAEIACAHIggAFQABAEACACIAPAAQAKAAACgGIAEAEQARgEAhABIA1ABIC9AuQgigFg+AGQhEAHgegCQgHAEgVAAQgVAAgHAGQA9AJApgIIgCAPQglAAhnAJQhDAHgqAAIgbgBg");
	this.shape_685.setTransform(298.9305,262.6154,0.6501,0.6501);

	this.shape_686 = new cjs.Shape();
	this.shape_686.graphics.f("#FFFFFF").s().p("AgMgpIAQAjQAKAWgBAaQgBgUgYg/g");
	this.shape_686.setTransform(210.3181,102.9138,0.6501,0.6501);

	this.shape_687 = new cjs.Shape();
	this.shape_687.graphics.f("#000000").s().p("AgMBgQAeABBDgGQBBgGAiABIAFgEQg+gEgkACQgiAHg7gFQhFgHgYACIAAgEQAKgDATACQATACAJgDQgGgCgRgCQgQgBgHgFQAMgDAXACQAWACALgEQAOgBAnAAQAjAAARgEIgRgJQgSAIgzAAQgMgDgiACQgfACgQgFQAtgCAUgFQgeABgzgEQg1gDggABQgcABg1gCQg4gCAagEQAdAFBEgEIA6gFIAAAAIAAAAQAAAAgBgBQAAAAAAgBQAAgBAAAAQAAgBAAgBQABgCgEgCQg6ABg6gHIAAgDQBdAIBcgIQgOgCiJgDQiNgCgnABQgJgEB7gCIAdgBQBhACA1AAIA8gHQgZgFhQAAQhPAAgXgFIAAgEQAnAGCygEIhPgDQgYgGguAAQgzABgWgEIAAgEIAygBIglgGIBHgCIAEAEQgBABAAABQgBAAAAAAQAAABAAAAQgBABABAAQAQgCAWADIAlAFQACgCAJABQAHAAACgEQhzgHgfgOQBHABAJgEIhQgGIAYAAQAlAAAKgEQgCgEgSgBQgSgCAAgEQA7AEAWgGIhsgKICHgCIABACQAAAOAXgBIAlAAQgBACAgAGQgkAChXgDIgdAFIACACQAogGASAHICBAAIAAAEQgMADgrACQguABgNAEQBSAAADAFQg2gBgCACIAjAGQA0AAAWAHQAxgCAfAHIAAAFQgMAAgEAEQABABABAHIggADIADAHIAPAAQAKABACgGIAEAEQASgEAfACQAkADARAAIC8BBQgjgFg9AEQhEAEgegCQgHADgWAAQgUAAgIAFQA9AKAqgHIgEAQQgjgChoAHQgzAEglAAQgeAAgSgDg");
	this.shape_687.setTransform(302.6299,229.7484,0.6501,0.6501);

	this.shape_688 = new cjs.Shape();
	this.shape_688.graphics.f("#000000").s().p("AhBgGQBaABAoAFQABABgGAGQgbgBhigMg");
	this.shape_688.setTransform(251.7704,273.927,0.6501,0.6501);

	this.shape_689 = new cjs.Shape();
	this.shape_689.graphics.f("#000000").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_689.setTransform(284.6131,271.7331,0.6501,0.6501);

	this.shape_690 = new cjs.Shape();
	this.shape_690.graphics.f("#FFFFFF").s().p("AgSAAQAJgDANADIAOADg");
	this.shape_690.setTransform(247.9012,271.2737,0.6501,0.6501);

	this.shape_691 = new cjs.Shape();
	this.shape_691.graphics.f("#FFFFFF").s().p("AgqAFIACgHIAggBQAIADASAAQARAAAIAFg");
	this.shape_691.setTransform(254.1742,270.238,0.6501,0.6501);

	this.shape_692 = new cjs.Shape();
	this.shape_692.graphics.f("#FFFFFF").s().p("AAMACQgdAAgOgDQAmABAZACIgUAAg");
	this.shape_692.setTransform(278.0963,269.7342,0.6501,0.6501);

	this.shape_693 = new cjs.Shape();
	this.shape_693.graphics.f("#000000").s().p("AgBABIAAgBIACAAIAAABg");
	this.shape_693.setTransform(253.3942,268.3691,0.6501,0.6501);

	this.shape_694 = new cjs.Shape();
	this.shape_694.graphics.f("#000000").s().p("AhXgCICvACIAAADQg6gBh1gEg");
	this.shape_694.setTransform(260.9186,268.6128,0.6501,0.6501);

	this.shape_695 = new cjs.Shape();
	this.shape_695.graphics.f("#000000").s().p("AkwAqIgHAEQhbgHgTgGIDUgbQgFgGgQgBQA7ABDOAEQgUgFgnABQguAAgNgCQAHgBCOgDIAEgDQAfAEAMgFQgOAAgfgFQgcgDgOACQAMgEAeABQAggBANgCQACgDAHACQAFADACgFIg5gGIBdgFIgHgHQgMADgSgCIgdgCQA6ADAhgIQASgCAxACQApACAXgGIACAJIA7ABQADAKAOgBQASAAAFADQgwAFhrgIQgXgMg4AKIAfAFIAAAEQAgAFBmgDQAkgBANAMIgEAKQgPAEgYgBIgngDIgGAIQAGABBSADQAAAFgDAAQADAEADAAIAAAIQgCABgLgEQgJgCgBAJQgbAAgygEIAAABQAAAJATAAIAAAFQgTAEgugCIgFgEIhHAAIApgFQgKgEgUAAQgVABgKgEIA4AAQArABASgCIgEgFIhmgFQgGgDgHAGQgHAFgFgDQgJAGgOgDIgWgDIgEAIIg4ABQABABABAAQAAABABAAQAAAAABAAQAAAAAAAAIAAAEQgfgFjwgLIgHAJQCbADBHALIAAAHIgogDQgJgDhAgGQgWAAhNgEQg9gEgiAGIAEADQBTgCCYALQABAEgDACIgGACQhKgKiWgDg");
	this.shape_695.setTransform(273.5134,269.3279,0.6501,0.6501);

	this.shape_696 = new cjs.Shape();
	this.shape_696.graphics.f("#000000").s().p("AgGACIgLgBIAigDQgGAFgLAAIgGgBg");
	this.shape_696.setTransform(249.4288,270.7075,0.6501,0.6501);

	this.shape_697 = new cjs.Shape();
	this.shape_697.graphics.f("#000000").s().p("AhcBWQhngHglACIg0gSQg8gRgnAHIEqg4QACgCAYAAIgggEQABgHABAAQgFgEgMAAIAAgFQARgEAYAAQAbABANgCQAMgEAYAAIAogCIArgDQgDgCgmgEQACgDAbABQAYABgBgIQgMgFgpACQgrABgKgDIAAgEICBAAQAKgEASABQAWACAHgBIACgBIgHgIQgogChHAEQgEgBACgGQAbACAOgBQAagJAOAAQAaAAANgBQAJgCBPAEQgGAFgWgBIgegCQgSACgsABQAeAHAbgBQAAAEgGgBQgHAAgBAEQAHAGAQgBQATAAAGACIARAAQgIACghgBQgZAAgMAKIAdACQgVAJhGAFQABAEAIAAQAIgBADACQAvgKAcADQAAAAAAgBQAAAAAAgBQAAAAgBAAQAAgBgBAAIAEgEIBHABIglAGIBcADQgVADhJABQhDACgYAGIhQADQC9ACAcgEIAAAEQgWAFhTABQhUACgYAEIBDAEQBngBA4ACQACgEAEACIAHACQABABA7ACQhKgBiQABIgMABQBIABBIgBQg5ADg7gBQgBAAAAABQgBAAAAABQAAAAAAABQAAAAAAABQABADgCACQgDgBgFAEQBhAQAzgJQgTAJhLgEQghgHgzADQhBAFgTgBQAFACA7AGQgPAFgggDQghgCgOADQggAAA0AHQAMAEAWgCQAWgCAMACQgHAFgPACQgSABgGADQAKADATgCQATgCAJADIAAAEQgXgChFAGQg7AGgigHQglgCg+AEIAGAEQAigCBAAGQBDAHAfgBQgTADgbAAQglAAg1gEg");
	this.shape_697.setTransform(100.6475,264.2661,0.6501,0.6501);

	this.shape_698 = new cjs.Shape();
	this.shape_698.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_698.setTransform(121.8881,270.6118,0.6501,0.6501);

	this.shape_699 = new cjs.Shape();
	this.shape_699.graphics.f("#FFFFFF").s().p("AALgBIAMAAIgsADg");
	this.shape_699.setTransform(127.446,269.6854,0.6501,0.6501);

	this.shape_700 = new cjs.Shape();
	this.shape_700.graphics.f("#FFFFFF").s().p("AgqAFQAHgFASAAQASAAAIgEIAgACQgBAGADABg");
	this.shape_700.setTransform(141.5035,269.7179,0.6501,0.6501);

	this.shape_701 = new cjs.Shape();
	this.shape_701.graphics.f("#FFFFFF").s().p("AAWgBIABAAIgtADQAOgDAeAAg");
	this.shape_701.setTransform(117.809,269.4238,0.6501,0.6501);

	this.shape_702 = new cjs.Shape();
	this.shape_702.graphics.f("#FFFFFF").s().p("AgHACQAHgGAIAGg");
	this.shape_702.setTransform(114.2987,268.5397,0.6501,0.6501);

	this.shape_703 = new cjs.Shape();
	this.shape_703.graphics.f("#000000").s().p("AgBABIAAgBIACAAIAAABg");
	this.shape_703.setTransform(142.2998,267.654,0.6501,0.6501);

	this.shape_704 = new cjs.Shape();
	this.shape_704.graphics.f("#000000").s().p("AhEABQBZgHAwAFQg8ABhNAEg");
	this.shape_704.setTransform(135.978,267.849,0.6501,0.6501);

	this.shape_705 = new cjs.Shape();
	this.shape_705.graphics.f("#000000").s().p("ACNA6QgDgCAAgEQCOgLA4ACIAFgFQgjgFgqADQg5AGgXgBQhCAHgIADQgOgCgZAFIAAgHQAVgDCngNIgGgKQjBALgrAGIAAgEIAEgBIg3gCIgEgIIgWADQgNADgJgGQgFADgIgHQgHgGgFAEQgjAGhEAAIgDAEIB1ABQgKAFgUAAQgWAAgKAEIAqAGIhIAAIgEAEIghAAQgWAAgLgDIAAgGIAIAAQAMgCgBgIIAAgBQgXgCg1AIQgCgKgIACQgMADgCgBIAAgJIAGgDQgDgBAAgFIAuAAQAaAAAQgEIgEgJIgpADQgYABgOgEIgFgMQAOgNAjABQBmAEAhgGIAAgEIAegGIgogEQgZgCgOAIQhqAJgwgFQAFgFASACQANAAAEgLIA6gCIACgKQAYAIApgDQAxgCASADQATAFAcgCQAjAAAIABQgFABgUAFQgOAFgLgEIgPADIBcAGQgQADgpADQADAGAFgDQAGgCACADQBAgCAXAHQgbgDg8ALQANAGAegFIAEAEIBNgBQAuABAaAEQgMACgvAAQgngBgVAGQCSgDBTgDQgPABgGAHIB1AeQgTAHAOAEIAEABQAAABgNABIgIgEQhmAChVAMIgFgDg");
	this.shape_705.setTransform(120.3279,268.7104,0.6501,0.6501);

	this.shape_706 = new cjs.Shape();
	this.shape_706.graphics.f("#000000").s().p("AgGACIgJAAIAegEQAGAFgQAAIgLgBg");
	this.shape_706.setTransform(144.1747,270.2411,0.6501,0.6501);

	this.shape_707 = new cjs.Shape();
	this.shape_707.graphics.f("#000000").s().p("AAAABIAAgCIABAAIAAACg");
	this.shape_707.setTransform(129.0224,273.4558,0.6501,0.6501);

	this.shape_708 = new cjs.Shape();
	this.shape_708.graphics.f("#000000").s().p("Ag0ABQA3gEAyAEg");
	this.shape_708.setTransform(128.0798,272.9113,0.6501,0.6501);

	this.shape_709 = new cjs.Shape();
	this.shape_709.graphics.f("#000000").s().p("AgFABIACgBIAJABg");
	this.shape_709.setTransform(165.6205,272.5782,0.6501,0.6501);

	this.shape_710 = new cjs.Shape();
	this.shape_710.graphics.f("#FFFFFF").s().p("Ag3ADQAEgGAOABIBdAAQgsAFgzAAIgQAAg");
	this.shape_710.setTransform(262.3324,272.3301,0.6501,0.6501);

	this.shape_711 = new cjs.Shape();
	this.shape_711.graphics.f("#FFFFFF").s().p("AAAACIAAgCIABAAIAAACg");
	this.shape_711.setTransform(293.6651,263.7699,0.6501,0.6501);

	this.shape_712 = new cjs.Shape();
	this.shape_712.graphics.f("#FFFFFF").s().p("AgKABIACgBIATABg");
	this.shape_712.setTransform(170.1221,262.6486,0.6501,0.6501);

	this.shape_713 = new cjs.Shape();
	this.shape_713.graphics.f("#000000").s().p("AgwAAQAggBBRgDQg7AHhGACQACgGAOABg");
	this.shape_713.setTransform(285.9457,248.9649,0.6501,0.6501);

	this.shape_714 = new cjs.Shape();
	this.shape_714.graphics.f("#000000").s().p("Ah5ABQgDgBABgDID3AFIjwACIgFgDg");
	this.shape_714.setTransform(293.0556,246.3972,0.6501,0.6501);

	this.shape_715 = new cjs.Shape();
	this.shape_715.graphics.f("#000000").s().p("AhkACQA2gGCTAAQgbAChJACQg/AAgjAFg");
	this.shape_715.setTransform(293.4538,244.187,0.6501,0.6501);

	this.shape_716 = new cjs.Shape();
	this.shape_716.graphics.f("#000000").s().p("AAAACIAAgDIABAAIAAADg");
	this.shape_716.setTransform(301.0757,242.5781,0.6501,0.6501);

	this.shape_717 = new cjs.Shape();
	this.shape_717.graphics.f("#000000").s().p("AhDAEQAjgJBkABQhAABg8AIIgDABQgEAAgEgCg");
	this.shape_717.setTransform(297.1916,243.1632,0.6501,0.6501);

	this.shape_718 = new cjs.Shape();
	this.shape_718.graphics.f("#000000").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_718.setTransform(297.6792,241.083,0.6501,0.6501);

	this.shape_719 = new cjs.Shape();
	this.shape_719.graphics.f("#000000").s().p("AgBABIAAgBIACAAIAAABg");
	this.shape_719.setTransform(298.1504,240.9693,0.6501,0.6501);

	this.shape_720 = new cjs.Shape();
	this.shape_720.graphics.f("#000000").s().p("AgIAAQBBgIANAGQghAEhqADQAcgGAhABg");
	this.shape_720.setTransform(297.5654,241.2948,0.6501,0.6501);

	this.shape_721 = new cjs.Shape();
	this.shape_721.graphics.f("#000000").s().p("AhdgBQCVgGAmACQgWAAgnAKIgkABQgsAAgugHg");
	this.shape_721.setTransform(300.9619,240.5381,0.6501,0.6501);

	this.shape_722 = new cjs.Shape();
	this.shape_722.graphics.f("#000000").s().p("AADAFIiLgFIgIgDIADgBQC/AMBbgIIADACQgoADg0AAIgxAAg");
	this.shape_722.setTransform(279.3639,263.5299,0.6501,0.6501);

	this.shape_723 = new cjs.Shape();
	this.shape_723.graphics.f("#000000").s().p("AAAACQhPgCg2ADIAAgFQAvgDAtADQA2AEAogBIBSAEIiHgDg");
	this.shape_723.setTransform(295.5502,252.3858,0.6501,0.6501);

	this.shape_724 = new cjs.Shape();
	this.shape_724.graphics.f("#000000").s().p("AAjAJIhzgDQgGgGgTABQgSADgDgIQgEgBgKAFQgIADgBgHIAfgFQgFACgCADQA5AGBTACICHACQgfAEgtAAIgngBg");
	this.shape_724.setTransform(294.9489,250.6736,0.6501,0.6501);

	this.shape_725 = new cjs.Shape();
	this.shape_725.graphics.f("#000000").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_725.setTransform(286.872,259.2521,0.6501,0.6501);

	this.shape_726 = new cjs.Shape();
	this.shape_726.graphics.f("#000000").s().p("AgTAFQg+gEgaACIhIgBIADgDIDeAEQAGgGANgBQAQAAAGgCIBdAAQgQAEgqgBQglAAgSAFIAAADQgQACgYAAIgugCg");
	this.shape_726.setTransform(285.0193,258.1025,0.6501,0.6501);

	this.shape_727 = new cjs.Shape();
	this.shape_727.graphics.f("#000000").s().p("AA9ADQAMgCAEgDQhEgBhDAFQgGgBgPACQgMAAgDgHQCBgCA8ACQgHAGgQABIgbADIAQgDg");
	this.shape_727.setTransform(277.1862,256.6193,0.6501,0.6501);

	this.shape_728 = new cjs.Shape();
	this.shape_728.graphics.f("#000000").s().p("AhgAEIgCgIQBrAIBagCQgwADhRAAIhCgBg");
	this.shape_728.setTransform(279.0876,255.1375,0.6501,0.6501);

	this.shape_729 = new cjs.Shape();
	this.shape_729.graphics.f("#FFFFFF").s().p("AgXAEIAvgHQgNAHgbAAIgHAAg");
	this.shape_729.setTransform(171.9098,261.4169,0.6501,0.6501);

	this.shape_730 = new cjs.Shape();
	this.shape_730.graphics.f("#FFFFFF").s().p("AAAABIAAgCIACAAIAAACg");
	this.shape_730.setTransform(297.0129,260.2921,0.6501,0.6501);

	this.shape_731 = new cjs.Shape();
	this.shape_731.graphics.f("#FFFFFF").s().p("AgQABIAhgCQgGADgMAAIgPgBg");
	this.shape_731.setTransform(164.7104,260.5197,0.6501,0.6501);

	this.shape_732 = new cjs.Shape();
	this.shape_732.graphics.f("#FFFFFF").s().p("AgBABIAAgBIACAAIAAABg");
	this.shape_732.setTransform(160.6638,259.9346,0.6501,0.6501);

	this.shape_733 = new cjs.Shape();
	this.shape_733.graphics.f("#FFFFFF").s().p("AgYABIAegBIATABg");
	this.shape_733.setTransform(155.3171,260.0809,0.6501,0.6501);

	this.shape_734 = new cjs.Shape();
	this.shape_734.graphics.f("#FFFFFF").s().p("AgHACQAKgGAFADQgEAEgHAAIgEgBg");
	this.shape_734.setTransform(167.0181,260.1058,0.6501,0.6501);

	this.shape_735 = new cjs.Shape();
	this.shape_735.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_735.setTransform(163.4428,259.8046,0.6501,0.6501);

	this.shape_736 = new cjs.Shape();
	this.shape_736.graphics.f("#FFFFFF").s().p("Ag4AFQAUgGAhABQAlACAOgCIgNgDQALgGALAGIgFAFQgvAFgcAAQgVAAgMgCg");
	this.shape_736.setTransform(172.6248,259.2838,0.6501,0.6501);

	this.shape_737 = new cjs.Shape();
	this.shape_737.graphics.f("#FFFFFF").s().p("AAYAAIgvACQAPgFAgADg");
	this.shape_737.setTransform(166.7418,259.1025,0.6501,0.6501);

	this.shape_738 = new cjs.Shape();
	this.shape_738.graphics.f("#FFFFFF").s().p("Ag0gBIAAgCIBpACQgIABgEAEIhdgFg");
	this.shape_738.setTransform(247.0886,258.9758,0.6501,0.6501);

	this.shape_739 = new cjs.Shape();
	this.shape_739.graphics.f("#FFFFFF").s().p("AAAABIAAgCIABAAIAAACg");
	this.shape_739.setTransform(296.5578,258.407,0.6501,0.6501);

	this.shape_740 = new cjs.Shape();
	this.shape_740.graphics.f("#FFFFFF").s().p("AATgBIAAACIglACQAPgFAWABg");
	this.shape_740.setTransform(253.3779,258.6624,0.6501,0.6501);

	this.shape_741 = new cjs.Shape();
	this.shape_741.graphics.f("#000000").s().p("AhAAAICCgGQhtANgQAAQgGgGABgBg");
	this.shape_741.setTransform(232.5228,258.862,0.6501,0.6501);

	this.shape_742 = new cjs.Shape();
	this.shape_742.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_742.setTransform(162.8578,258.1957,0.6501,0.6501);

	this.shape_743 = new cjs.Shape();
	this.shape_743.graphics.f("#FFFFFF").s().p("AgDABIACgBIAFABg");
	this.shape_743.setTransform(164.0604,258.2282,0.6501,0.6501);

	this.shape_744 = new cjs.Shape();
	this.shape_744.graphics.f("#FFFFFF").s().p("AgOABIAAgBIAcAAIAAABg");
	this.shape_744.setTransform(244.9435,257.9682,0.6501,0.6501);

	this.shape_745 = new cjs.Shape();
	this.shape_745.graphics.f("#FFFFFF").s().p("AAAACIAAgDIABAAIAAADg");
	this.shape_745.setTransform(160.8751,257.7244,0.6501,0.6501);

	this.shape_746 = new cjs.Shape();
	this.shape_746.graphics.f("#FFFFFF").s().p("AgKABIAAgBIAVABg");
	this.shape_746.setTransform(163.8816,257.7569,0.6501,0.6501);

	this.shape_747 = new cjs.Shape();
	this.shape_747.graphics.f("#FFFFFF").s().p("AgxAAIBjgCQgQABgiADIgSABQgSAAgNgDg");
	this.shape_747.setTransform(168.6108,257.9015,0.6501,0.6501);

	this.shape_748 = new cjs.Shape();
	this.shape_748.graphics.f("#FFFFFF").s().p("AAXAAQgFABgnABQAGgHAmAFg");
	this.shape_748.setTransform(166.8068,257.0803,0.6501,0.6501);

	this.shape_749 = new cjs.Shape();
	this.shape_749.graphics.f("#000000").s().p("Ag5AAIAIgBIAAgGQBMADAIgBIAPgDQAJgBABAEIgdAGQANgBADAHQgkgChEAEQgEgIAEgBg");
	this.shape_749.setTransform(150.8561,257.2398,0.6501,0.6501);

	this.shape_750 = new cjs.Shape();
	this.shape_750.graphics.f("#FFFFFF").s().p("AAaAAIgzADQAkgJAPAGg");
	this.shape_750.setTransform(245.7885,256.5066,0.6501,0.6501);

	this.shape_751 = new cjs.Shape();
	this.shape_751.graphics.f("#FFFFFF").s().p("AgJgEIA3AAIhaAJg");
	this.shape_751.setTransform(208.6704,256.213,0.6501,0.6501);

	this.shape_752 = new cjs.Shape();
	this.shape_752.graphics.f("#FFFFFF").s().p("AgoABQAZgCA4AAIAAADIhRgBg");
	this.shape_752.setTransform(255.6206,256.148,0.6501,0.6501);

	this.shape_753 = new cjs.Shape();
	this.shape_753.graphics.f("#FFFFFF").s().p("AgDAAQANgDAJADIgkADIAOgDg");
	this.shape_753.setTransform(236.3952,256.225,0.6501,0.6501);

	this.shape_754 = new cjs.Shape();
	this.shape_754.graphics.f("#000000").s().p("ACPA8QgBgCAFgCQAGgCAAgDQhxAEgQAAQgEgEAAgDIAdgCQABgCgEgDQgWgCgmAHQgnAIgWgDIgEgFQAkgBAQgEIAhgIIh1AEIAAgFQAGgCAWAAQASAAAIgGQAMAFANgFIgEgDQgsgDhXAJQgDgBgGgMIgYgDQgNgDgEgJQgHgGgaABQgVABgDgQICBAAQAAgFgEgEQAEgBANADQALACAFgHIAZABQAPACAEgJQANADARgFQAUgGAJABQARAEAagHQAggJAMgBQANgCAgAEQAWADAMgCIgEACQAEAFAHgCIALgDIgCgBQBBgDAQADQgGAGgNAAQgQAAgFACQhXAFgHABQAaAEAlAAIA+AAQABADgFAEQhNgDhJAOQADABAsACQAOgDAmAAQAiABARgGQAZAAAEAIQABAEgEAAQgFAAgBACQgdAAgJAHQADAFAFgBIAJgCQAGABANAAQAPgCAFABQgOAFgkAGIASAEQgHACAAAFQADAFAFgCIAJgDQAAAAAAABQAAAAABABQAAAAAAABQABAAABAAQgWAAAFANQALAFAVgJQABAFgFACIgIACQgSABgqAKQggAHgUAAIgEAAg");
	this.shape_754.setTransform(164.1254,259.8189,0.6501,0.6501);

	this.shape_755 = new cjs.Shape();
	this.shape_755.graphics.f("#000000").s().p("Ag3gBQAWgFAhACQAmADASAAQgSADgkAAQgjgBgTAEQgEgFABgBg");
	this.shape_755.setTransform(152.1298,256.0708,0.6501,0.6501);

	this.shape_756 = new cjs.Shape();
	this.shape_756.graphics.f("#FFFFFF").s().p("AgCgBIAOgCIAFAFIghADQAEgFAKgBg");
	this.shape_756.setTransform(242.6358,255.9043,0.6501,0.6501);

	this.shape_757 = new cjs.Shape();
	this.shape_757.graphics.f("#FFFFFF").s().p("AAdgCIgBACIg4ACg");
	this.shape_757.setTransform(209.2229,255.2867,0.6501,0.6501);

	this.shape_758 = new cjs.Shape();
	this.shape_758.graphics.f("#FFFFFF").s().p("AAMgCIATAAIg9AFg");
	this.shape_758.setTransform(213.5783,255.2217,0.6501,0.6501);

	this.shape_759 = new cjs.Shape();
	this.shape_759.graphics.f("#FFFFFF").s().p("AgqAEQAHgEASAAQASAAAIgEIAgADQgBAFADAAg");
	this.shape_759.setTransform(230.1385,255.1567,0.6501,0.6501);

	this.shape_760 = new cjs.Shape();
	this.shape_760.graphics.f("#FFFFFF").s().p("AgFAEQgCgGAHgBIAHAAQgEABgBACIAAAEg");
	this.shape_760.setTransform(257.4814,254.8479,0.6501,0.6501);

	this.shape_761 = new cjs.Shape();
	this.shape_761.graphics.f("#FFFFFF").s().p("AgSABIAQgBIAUABg");
	this.shape_761.setTransform(249.0713,254.6204,0.6501,0.6501);

	this.shape_762 = new cjs.Shape();
	this.shape_762.graphics.f("#FFFFFF").s().p("AAsgDQgWAGhCABIBYgHg");
	this.shape_762.setTransform(205.4201,254.7829,0.6501,0.6501);

	this.shape_763 = new cjs.Shape();
	this.shape_763.graphics.f("#FFFFFF").s().p("AADAFIgIgBQgKgBAKgFQAFgGALAIQgCAFgFAAIgBAAg");
	this.shape_763.setTransform(191.0539,254.7413,0.6501,0.6501);

	this.shape_764 = new cjs.Shape();
	this.shape_764.graphics.f("#FFFFFF").s().p("AgdAAQAEgCAXABQAYAAAIAEg");
	this.shape_764.setTransform(201.9261,254.2118,0.6501,0.6501);

	this.shape_765 = new cjs.Shape();
	this.shape_765.graphics.f("#FFFFFF").s().p("Ag2AGQBGgOAnAEQgFAEACAFIhiABIgIAAg");
	this.shape_765.setTransform(195.6693,254.4013,0.6501,0.6501);

	this.shape_766 = new cjs.Shape();
	this.shape_766.graphics.f("#000000").s().p("Ag3AAIBvgBIhvADg");
	this.shape_766.setTransform(221.3302,253.5966,0.6501,0.6501);

	this.shape_767 = new cjs.Shape();
	this.shape_767.graphics.f("#FFFFFF").s().p("Ag6ACIgPACQALgEAogFQAAAFAGABIAJADQArgGAmAAQgCABgEADIhAADIgUABQgZAAgRgEg");
	this.shape_767.setTransform(194.6129,253.2414,0.6501,0.6501);

	this.shape_768 = new cjs.Shape();
	this.shape_768.graphics.f("#FFFFFF").s().p("AgPgCIAjACIgnADg");
	this.shape_768.setTransform(79.0982,252.9628,0.6501,0.6501);

	this.shape_769 = new cjs.Shape();
	this.shape_769.graphics.f("#FFFFFF").s().p("AAPAAIgdACQAIgGAVAEg");
	this.shape_769.setTransform(191.6227,251.7333,0.6501,0.6501);

	this.shape_770 = new cjs.Shape();
	this.shape_770.graphics.f("#000000").s().p("AgUABIAAgDIApAFg");
	this.shape_770.setTransform(125.6096,250.2975,0.6501,0.6501);

	this.shape_771 = new cjs.Shape();
	this.shape_771.graphics.f("#000000").s().p("AhQCUQgpAAgQADIgPgBQgKAAAKgIIBIgCQgCgrAFgJQhtAEg9gBIgFgBIBWgGQgpgCipgDIgBgBIiEABQgFgEB5AAQifgEArgBIBwgBQAAgFAJgDQCJADgHABIDVgJQAFgEAFgBIBDgLIgDAAIAAgBImXATIgFABQADgDABgCQBFgCAUgEQAVgGAigHQBGADg3gFIABAAQAfgEgXgBQgGgCgLABQg6gDAjgFQAgACA5gCQA+gDAXABICJgEIgFgBIAEgGIgdAAIACABIgVABIAFgCQifADhcAJIgHgCQgFgBACgFIAEgBQBngHCtgCIgJgDQgZAAgGgBQgJgBAOgFIgGgCIAAgBIg8ACQkSAGgOABIgBgGQAcgLBwAFQA0ACCegCIABgIIgDABQgQgGgMgMQgQgQAGgOQACgFAfgQIg6gHIBEgBIAMgLIgHgBIgNgCIABgCQhhAAhdgLQAfgDCkAFIABgBQADgFAYgGQARgGAGAAQAJAFAGABQARgBAIACQATAFAJABIgEACQATADAJAAIgCACIBRABIAJAAIAGgGQhAgCgYACQgFAAgDgDQgDgEAFgDQAxADAyAAQgRgIAWgFQAhgHALAMIgKAGQAJgCAVADIBKgDIAAACQgTAFgUACQALADAEAFIBjgCIADgEQAiAGALgBIAAAEIiQAIIAAAEIAcABIgdACQAAADAEACQAvAAAsgEIABAKIgrACIAMAFQArgBAggDIAAADQgeAIghABIAJAGIAsABIglABIAjAKQAQAFACADIglAAQgKABgFADQABAEACACIgHAFQAGAIAQAAIAYAAIAAABIAOAAIgOAAIgBABQARAAAIAFIgbAIQgTAAgLADIgpAJIApgFQASgCgBAJQgUAAgtADIgCAIIAbAAIgBAFIAbABQAcgDARAFIgJACIAAARIgXABIAAAOQgPACgSABIABABIA/gBIABASIg8ABIAAAJQgbAEg7AEIAAAAIgIAAIgOADIgfACIAKgDIguABQgIADgFADIADgFIhtADQgNAAgIgHIglgBQgLAFgKgEQADALgLABIgTAAIAEgJQAEgFAFgBIgMgCQAigKAugBIAAgBIgmADIAAAAIgBAAIgxADIgEADIACgDIgoADIhCA3IAugBIAAAEQgVAFgjABIgEAEg");
	this.shape_771.setTransform(84.1791,259.7348,0.6501,0.6501);

	this.shape_772 = new cjs.Shape();
	this.shape_772.graphics.f("#000000").s().p("AiIAAIgIgCIADgCQC/ANBagJIAEADQgSACgtAAQhKAAiPgFg");
	this.shape_772.setTransform(104.9216,250.1846,0.6501,0.6501);

	this.shape_773 = new cjs.Shape();
	this.shape_773.graphics.f("#FFFFFF").s().p("Ag5ACQBOgJAlAHQg2AEggAAQgSAAgLgCg");
	this.shape_773.setTransform(82.5597,250.072,0.6501,0.6501);

	this.shape_774 = new cjs.Shape();
	this.shape_774.graphics.f("#FFFFFF").s().p("AgHABIACgBIANABg");
	this.shape_774.setTransform(297.0941,248.5424,0.6501,0.6501);

	this.shape_775 = new cjs.Shape();
	this.shape_775.graphics.f("#000000").s().p("AgsAAIAAgIIAdAKIA8AGQgQgBgbABIgCABQgdAAgPgJg");
	this.shape_775.setTransform(125.5934,249.047,0.6501,0.6501);

	this.shape_776 = new cjs.Shape();
	this.shape_776.graphics.f("#000000").s().p("AgBACQhOgCg3AEIAAgFQAygEBUADQBkAEAigBIAAAEQgvAAhYgDg");
	this.shape_776.setTransform(93.4482,250.0494,0.6501,0.6501);

	this.shape_777 = new cjs.Shape();
	this.shape_777.graphics.f("#000000").s().p("AlWBZQAfABBEgHQBAgGAjACIAFgEQg7gEgnACQgiAHg8gGQhGgGgXACIAAgEQAKgDATACQATACAJgDQgFgCgSgCQgQgBgHgFQAMgDAXACQAVACAMgEQAOgCAoABQAjAAAQgEQgHAAgJgJQgTAIgyAAQgOgEghADQggABgPgEQA8gGAFgCQgUABhBgEQgzgEghAHQhKAEgTgJQA1AJBegQQgGgEgBABQgBgBAAAAQAAgBAAAAQgBgBAAAAQABgBAAgBQABgDgEgBQg1ABg/gHIAAgDQBcAIBcgIIg0gGIkWABQAAgBB4gEIAHgDQAEgCACAFICfgCIAJgDQgYgFg3gCQg1gBgXgFIAAgEQAcAFAqgCIBEgDIAAgBQgYgGguAAQg0AAgVgDIAAgEIAxgBIglgGIBIgCIADAEIgCAEQAQgDAXAEIAkAFQADgCAIABQAIAAABgEQhIgFgTgJIAdgCQgHgFgKAAIAEAAQgBgDgHABQgFAAgBgEQAeABAbgHIhsgKICHgCIACACQAAAOAWgBIAlgBIgCAHQgkAChLgDIgHAEIACAAQAngBASABIA0AAQgBAHAKAAQAMAAACAEQAAADgCACIAEAEQA4gCAVAHQAygDAfAIIAAAFQgMAAgFAEIADAHIggAEIADAHIAPAAQAJAAACgFIAEADQASgDAgACQAkADARAAIAAACQgMAFgXgCQgagDgJACQACACASABQAOABgBAMIAagBQADAEAMgBQAMAAADAGQAIgEATADQARACAIgHIgDgDIhIgGIDZgDQgFgGgPgBQA8ACDOAEQgVgGgnABQguAAgOgCQAHgBCPgDIAEgDQAfAEAMgGQgNAAgggEQgcgEgPACQANgEAeABQAhAAAMgCQADgDAGACQAFACADgFIg6gFIBdgFIgHgIQgEACgqgDQAxACAdgGQASgCAxACQApABAXgGIACAJIA7ABQADAKAOAAQASgBAEAEQgrAEhvgIQgXgLg3AKIAeAFIAAAEQAiAFBlgEIAZADQAPABAIAHIgEALQgPAFgYgCIgogDIgFAJQAKABBOABQAAAFgCABQADAEACgBIAAAIQgCABgLgDQgJgCgBAJQgbAAgygFIAAABQAAAJAUAAIAAAFQgUAFgugCIgEgEIhIAAIApgFQgKgEgUAAQgVAAgKgEIA4AAQAsACARgDIgEgEIhmgFQgFgDgHAFQgHAGgGgDQgJAFgNgCIgXgDIgDAHIg4ACQAAAAABABQABAAAAAAQABAAAAAAQABAAAAAAIAAAEQgzgHhVgEIiJgFIgHAJQCbADBHAMIAAAGIgogDQgIgDhBgFQgTAAhQgFQg8gDgjAFIAEAEQBZgDCSAMQABADgDACIgFACQhLgJiVgDIgIADIg3gDQgfgCgWgHQgMgOgiAKQAPAFAIgEQgEAMATgBQASAAgDALICAAAQAVgCAlAEQAmAEATgCIAGAHQgOAEgXgEQgZgEgLACQgjgGg+ABQhLAAgbgCQgkAGgOAKQAeAFAdgFIAAAUQglgChTAHQgnADgeAAQgbAAgVgDg");
	this.shape_777.setTransform(283.2479,269.0153,0.6501,0.6501);

	this.shape_778 = new cjs.Shape();
	this.shape_778.graphics.f("#000000").s().p("AlWBZQAfABBEgHQBAgGAjACIAFgEQg7gEgnACQgiAHg8gGQhGgGgXACIAAgEQAKgDATACQATACAJgDQgFgCgTgCQgPgBgHgFQAMgDAXACQAVACAMgEQAOgCAoABQAjAAAQgEQgHAAgJgJQgTAIgyAAQgOgEghADQggABgPgEQA8gGAFgCQgUABhBgEQgzgEggAHQhMAEgSgJQA1AJBegQQgGgEgBABQgBgBAAAAQAAgBgBAAQAAgBAAAAQAAgBABgBQABgDgEgBQg1ABg/gHIAAgDQBcAIBcgIIg0gGIkWABQAAgBB5gEIAGgDQAEgCACAFICfgCIAJgDQgYgFg3gCQg1gBgXgFIAAgEQAcAFAqgCIBDgDIAAgBQgXgGguAAQg0AAgVgDIAAgEIAxgBIglgGIBIgCIADAEIgCAEQAQgDAXAEIAkAFQADgCAJABQAHAAACgEQhKgFgSgJIAdgCQgHgFgKAAIAEAAQgBgDgHABQgFAAgBgEQAeABAcgHIhsgKICGgCIACACQAAAOAWgBIAlgBIgCAHQgkAChLgDIgHAEIACAAQAngBASABIA0AAQgBAHAKAAQAMAAACAEQAAADgCACIAEAEQA4gCAVAHQAxgDAgAIIAAAFQgMAAgFAEIADAHIggAEIADAHIAPAAQAJAAACgFIAEADQASgDAgACQAkADARAAIAAACQgMAFgXgCQgagDgJACQACACASABQAOABgBAMIAagBQADAEAMgBQAMAAADAGQAIgEATADQARACAIgHIgDgDIhIgGIDZgDQgFgGgPgBQA8ACDOAEQgVgGgnABQguAAgOgCQAHgBCPgDIAEgDQAfAEAMgGQgNAAgggEQgcgEgOACQAMgEAeABQAhAAAMgCQADgDAGACQAFACADgFIg6gFIBdgFIgHgIQgEACgqgDQAxACAdgGQASgCAxACQApABAXgGIACAJIA7ABQADAKAOAAQASgBAEAEQgrAEhvgIQgXgLg4AKIAfAFIAAAEQAiAFBlgEIAZADQAPABAIAHIgEALQgPAFgYgCIgngDIgGAJQAKABBOABQAAAFgCABQADAEACgBIAAAIQgCABgLgDQgJgCgBAJQgbAAgygFIAAABQAAAJAUAAIAAAFQgUAFgvgCIgDgEIhIAAIApgFQgKgEgVAAQgUAAgKgEIB1gBIgEgEIhmgFQgFgEgHAGQgHAGgGgDQgIAFgOgCIgXgDIgDAHIg4ACQAAAAABABQABAAAAAAQABAAAAAAQABAAAAAAIAAAEQgzgHhVgEIiJgFIgHAJQCbADBHAMIAAAGIgogDQgIgDhBgFQgTAAhQgFQg8gDgjAFIAEAEQBZgDCSAMQABADgDACIgFACQhLgJiVgDIgIADIg3gDQgfgCgWgHQgMgOgiAKQAPAFAIgEQgEAMATgBQATAAgEALICAAAQAVgCAlAEQAmAEATgCIAGAHQgOAEgXgEQgYgEgLACQgkgGg+ABQhLAAgbgCQgjAGgPAKQAeAFAdgFIAAAUQglgChTAHQgnADgeAAQgbAAgVgDg");
	this.shape_778.setTransform(250.5827,269.0153,0.6501,0.6501);

	this.shape_779 = new cjs.Shape();
	this.shape_779.graphics.f("#000000").s().p("AlWBZQAfABBEgHQBAgGAiACIAGgEQg+gEglACQgiAHg8gGQhFgGgYACIAAgEQAKgDATACQAUACAJgDQgGgDgSgBQgPgCgHgFQAMgDAWACQAWADALgEQBLACAfgHQgCAAgOgJQgTAHgzAAQgNgDghACQggADgPgFQA7gGAFgCQgTABhBgFQgzgDghAHQhLAEgTgJQAzAJBhgQQgFgEgDABQgCgCABgDQABgBgBAAQAAgBAAAAQAAgBgBAAQAAgBgBAAQg8ABg4gHIAAgDQBcAIBcgIIg0gHIkWACQAAgCB4gDIAHgDQAEgCACAFICfgCIAJgEQgYgEg3gCQg2gBgWgFIAAgEQAcAFAqgCIBDgDIAAgBQgXgGgvAAQgzAAgWgDIAAgEIAygCIglgGIBHgBIAEAEQAAAAgBABQgBAAAAAAQAAABAAAAQAAABAAAAQAQgCAWAEIAlAFQADgCAIABQAIAAABgEQhGgFgVgJQAUABAJgDQgMgKgZAAQgiABgHgCIARAAQAGgCATAAQAQABAHgGQgBgEgHAAQgGABAAgEQAdACAcgFIgYAAIAzgBIABABIAXAAIAlAAQABAFgDABQgkAChLgEIgIAIIADABQAngGASAIICCAAIAAADQgLAEgcgCQgbgCgMAEQgBAIAKAAQAMAAACADQAAAEgCACIAEADQA3gBAWAHQAxgDAfAIIAAAFQgLAAgFAEQABAAABAHIggAEIADAHIAQAAQAJAAACgGIAEAEQAHgBBgADIAAACQgXAIgvgHQACADASABQAOABgBAMIAZgBQAEADAMAAQALAAAEAGQAHgEAUADQARACAIgHIgEgDIhHgGQATgCDGgBQgFgGgPgCQBGAEDEADQglgKhTADQAOgCCIgCIAEgEQAdAGAOgHQgOAAgfgEQgcgEgPACQANgEAdABQAhAAANgCQACgDAGACQAGACACgFIg5gFIBdgFIgHgIQgMADgSgBIgdgDQA6ADAhgHQASgDAwADQAqABAXgGIACAJIA7ABQADAKAOAAQASgBAEAEQgsAEhugIQgYgLg3AKIAfAFIAAAEQAiAFBkgEIAZADQAQABAIAHIgEALQgPAFgYgCIgogDIgFAJQAEABBUABQAAAFgCABIAFADIAAAIQgCABgMgDQgIgCgBAJQgbAAgygFIAAABQAAAJATAAIAAAFQgTAFgvgCIgEgEIhHAAIApgFQgKgFgVABQgVAAgJgEIA4AAQAsACARgDIgEgEIhmgFQgGgEgHAGQgHAGgFgDQgJAFgNgCIgXgDIgEAHIg3ACQAAAAABABQAAAAABAAQAAABABAAQAAAAAAgBIAAAEQgzgHhUgEIiJgFIgHAJQCbADBHAMIAAAGIgogDQgFgChEgHQgUABhPgFQg8gDgjAFIAEAEQBZgDCSAMQABADgDACIgGACQhTgKiNgCIgHADQhcgHgQgFQgNgPgiALQAPAFAIgEQgDAMATgBQASgBgDAMICAAAQAUgDAmAFQAlAEATgCQAHAFgBACQgNAEgXgEQgZgEgLACQgjgGg+AAQhMABgagCQgkAFgPALQAeAFAegFIAAAUQgkgChUAHQgnADgeAAQgbAAgVgDg");
	this.shape_779.setTransform(216.4873,270.4779,0.6501,0.6501);

	this.shape_780 = new cjs.Shape();
	this.shape_780.graphics.f("#000000").s().p("AEoBgQhTgHglACIAAgUQAeAFAegFQgPgKgkgGQgbAChLAAQg/gBgiAGQgLgCgZAEQgXAEgOgEIAHgHQASACAmgEQAlgEAVACICAAAQgDgLATABQASAAgEgMQAKAEAOgFQgigLgMAPQgXAHgeACIg5ADIgHgDQiVADhKAJIgGgCQgDgCABgDQCTgMBXADIAEgEQg8gJiFAMQhBAFgIADQgPgCgZAFIAAgGQAqgHBHgDIBxgFIgHgJQgqACheADQhVAEgzAHIAAgEIAEgBIg4gCIgEgHIgWADQgOACgJgFQgFADgHgGQgIgFgFADIhmAFIgDAEIB0ABQgJAFgVgBQgVAAgKAEIApAFIhHAAIgEAEIhCgDIAAgFQATAAAAgJIAAgBQgYgCg1AHQAAgJgJACQgMADgCgBIAAgIIAFgDQgCgBAAgFQBOgBAKgCIgFgIQgNAAgbADQgYABgPgEIgEgLQAIgHAQgBQARgBAIgCQBkAEAjgFIAAgEIAegFIgogDQgZgCgOAGQhxAIgpgEQAFgEARABQAOAAADgKIA7gBIACgJQAXAGApgBQAxgCATACQASAEAdgBQAiAAAJABQg2ADgFgCIgHAIIBdAFQgRADgpACQADAFAFgCQAHgCACADQBBgCAXAHQgbgEg9AKQAMAGAfgEIAEADICWAEQgOABgtAAQgoAAgUAFQDLgEBAgCQgRABgFAHQDOACALABIhIAGIgDADQAIAHASgCQASgDAIAEQAEgGALAAQAMABADgEQATgCAHADQgBgNAOgBQASgBADgCQgJgBgaABQgXACgNgDIAAgCQBJgHAeAFIAEgDQACAFAJAAIAQAAIACgHIgfgEIACgHQgEgEgNAAIAAgFQARgEAZABQAZAAAOgCQAMgEAZAAQAfAAAKgBIADgEQgCgCAAgDQACgEAMAAQAKAAgBgIQgMgEgbACQgcACgLgDIAAgEICCAAQAKgEASACQAVACAIgBIADgCIgHgHQgpgDhHAEIgCgHIAlABQAXABAAgOIABgCICHACIhsAKQAbAHAegBQAAAEgGAAQgHgBgBAEQAHAGAQAAQAUgBAFACIARAAQgIACghgBQgZAAgMAKIAeACQgTAJhJAFQABAEAIAAQAJgBACACQAwgKAbAEIgCgEIADgEIBIACIglAGIAyABIAAAEQgWADgzAAQgvAAgXAGIAAABIBDADQAqACAcgFIAAAEQgXAFg1ABQg2ACgZAFIAJADQAnABAIADQAGABgnAAQgQAFgkACQB1AKgxgBQgDABABADQAAABAAABQAAAAAAABQAAAAgBABQAAAAAAABQgCgBgFAEQBPAOgagCQghgHgyAEQhBAEgVgBQAFACA8AGQgPAEgggBQghgDgNAEQgyAAgUgIIgQAJQARAEAiAAQAogBAOACQAMAEAWgCQAXgCAMADQgIAEgPACQgSACgGACQAJADAUgCQATgCAKADIAAAEQgXgChGAHQg8AFgjgHQgngCg7AEIAGAEQAigCBBAGQBDAHAfgBQgUADgcAAQgeAAgngDg");
	this.shape_780.setTransform(227.1645,254.2265,0.6501,0.6501);

	this.shape_781 = new cjs.Shape();
	this.shape_781.graphics.f("#000000").s().p("AgtAEIgDgHQBBgBAfAFQgOgBgcACQgXACgPAAIgNAAg");
	this.shape_781.setTransform(125.0083,247.0923,0.6501,0.6501);

	this.shape_782 = new cjs.Shape();
	this.shape_782.graphics.f("#000000").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_782.setTransform(298.8655,246.4135,0.6501,0.6501);

	this.shape_783 = new cjs.Shape();
	this.shape_783.graphics.f("#000000").s().p("AAFAGIh6gDQgNgCgJgEQAHgEAQABQAeAFALABQAmABAkABIBIAAIBFACQgfADgwAAIg4gBg");
	this.shape_783.setTransform(101.8176,247.1889,0.6501,0.6501);

	this.shape_784 = new cjs.Shape();
	this.shape_784.graphics.f("#000000").s().p("AgTAFQg9gEgbACIhIgBIAEgDIDdAEQAGgGANgBQAQgBAGgBIBdAAQgQADgpAAQgmAAgRAFIAAADQgRACgXAAIgvgCg");
	this.shape_784.setTransform(103.7028,245.7027,0.6501,0.6501);

	this.shape_785 = new cjs.Shape();
	this.shape_785.graphics.f("#FFFFFF").s().p("AgEAAIAIgBIAAADg");
	this.shape_785.setTransform(75.0516,245.2271,0.6501,0.6501);

	this.shape_786 = new cjs.Shape();
	this.shape_786.graphics.f("#000000").s().p("AAAABIAAgCIABAAIAAACg");
	this.shape_786.setTransform(295.9728,243.8458,0.6501,0.6501);

	this.shape_787 = new cjs.Shape();
	this.shape_787.graphics.f("#000000").s().p("AAAAAIAGAAIgLABg");
	this.shape_787.setTransform(296.9803,243.7807,0.6501,0.6501);

	this.shape_788 = new cjs.Shape();
	this.shape_788.graphics.f("#FFFFFF").s().p("AAKgCIAPAAIgyAFQAVgFAOAAg");
	this.shape_788.setTransform(76.4167,243.8608,0.6501,0.6501);

	this.shape_789 = new cjs.Shape();
	this.shape_789.graphics.f("#000000").s().p("AgjgCQAkADAkgDIgeADIgPACQgQAAgLgFg");
	this.shape_789.setTransform(116.8826,243.4269,0.6501,0.6501);

	this.shape_790 = new cjs.Shape();
	this.shape_790.graphics.f("#000000").s().p("AA8ADQANgCAEgDQhEgChDAGIgVABQgMgBgDgFQCBgDA8ADQgHAFgRACIgaACIAPgDg");
	this.shape_790.setTransform(101.4601,243.3257,0.6501,0.6501);

	this.shape_791 = new cjs.Shape();
	this.shape_791.graphics.f("#000000").s().p("AgxAAIAAgFQBDAFAgAGQgcAAhHgGg");
	this.shape_791.setTransform(207.5165,243.1794,0.6501,0.6501);

	this.shape_792 = new cjs.Shape();
	this.shape_792.graphics.f("#FFFFFF").s().p("AgFAAIgCAAQALgDAEADQgCADgEAAQgCAAgFgDg");
	this.shape_792.setTransform(84.8512,242.5429,0.6501,0.6501);

	this.shape_793 = new cjs.Shape();
	this.shape_793.graphics.f("#FFFFFF").s().p("AAvABIhcABQAhgGA7AFg");
	this.shape_793.setTransform(80.8371,242.4102,0.6501,0.6501);

	this.shape_794 = new cjs.Shape();
	this.shape_794.graphics.f("#000000").s().p("AACADQgsgDgYAAIgCgFQBbAAAuALIgEAAQgTAAgsgDg");
	this.shape_794.setTransform(203.7137,242.2712,0.6501,0.6501);

	this.shape_795 = new cjs.Shape();
	this.shape_795.graphics.f("#FFFFFF").s().p("AgHgBIAbABIgmACQABgCAKgBg");
	this.shape_795.setTransform(75.5716,242.0256,0.6501,0.6501);

	this.shape_796 = new cjs.Shape();
	this.shape_796.graphics.f("#000000").s().p("AhFgDQBIAFBDABIiJACg");
	this.shape_796.setTransform(101.4763,241.7981,0.6501,0.6501);

	this.shape_797 = new cjs.Shape();
	this.shape_797.graphics.f("#000000").s().p("Ag9ACQA8gGBAABIh6AIg");
	this.shape_797.setTransform(121.2705,240.5914,0.6501,0.6501);

	this.shape_798 = new cjs.Shape();
	this.shape_798.graphics.f("#000000").s().p("AApAEQgjgEgVAEQgIgCgeADQgVADgIgIQAFgDAMgBIgCAEQASACAxgCQArgCAYAIQAEgCAKAEIACABIgqgFgAhBgEIADgEIgCAEIgBAAg");
	this.shape_798.setTransform(201.3248,240.6442,0.6501,0.6501);

	this.shape_799 = new cjs.Shape();
	this.shape_799.graphics.f("#000000").s().p("Ag4AAQAFgNAWAJIBWACQg9AFgXgBIgCAHQgagGgBgDg");
	this.shape_799.setTransform(109.9433,240.3262,0.6501,0.6501);

	this.shape_800 = new cjs.Shape();
	this.shape_800.graphics.f("#000000").s().p("AhiACQAEgEAKgCIC3AEQgeAChFAAQg9gBgjADQAAAAAAAAQAAAAAAgBQgBAAAAgBQAAAAgBAAg");
	this.shape_800.setTransform(98.7949,240.0104,0.6501,0.6501);

	this.shape_801 = new cjs.Shape();
	this.shape_801.graphics.f("#FFFFFF").s().p("AgbABIAHgBIAwABg");
	this.shape_801.setTransform(98.1448,238.8891,0.6501,0.6501);

	this.shape_802 = new cjs.Shape();
	this.shape_802.graphics.f("#000000").s().p("AgSADQhwgDABgEQDRACAyAEIAAACQgQABgdAAQgnAAhAgCg");
	this.shape_802.setTransform(298.7186,238.8659,0.6501,0.6501);

	this.shape_803 = new cjs.Shape();
	this.shape_803.graphics.f("#000000").s().p("AgcAAQAnACASgDQgNADgQAAQgNAAgPgCg");
	this.shape_803.setTransform(139.537,238.3422,0.6501,0.6501);

	this.shape_804 = new cjs.Shape();
	this.shape_804.graphics.f("#FFFFFF").s().p("AAJAEIgpgCIB9gCQgiAFgjAAIgPgBgAhQAAIgMAAQAXgBAdgDIAHAGIgvgCg");
	this.shape_804.setTransform(81.8934,238.1989,0.6501,0.6501);

	this.shape_805 = new cjs.Shape();
	this.shape_805.graphics.f("#000000").s().p("AhKAAQAJgFAQACQAWADAEAAQALAAA+AAQAqABgeACIg+ABQg1AAgVgEg");
	this.shape_805.setTransform(116.4304,238.0093,0.6501,0.6501);

	this.shape_806 = new cjs.Shape();
	this.shape_806.graphics.f("#000000").s().p("AgaAAIACgBIAzAAIgDADg");
	this.shape_806.setTransform(153.5782,237.7677,0.6501,0.6501);

	this.shape_807 = new cjs.Shape();
	this.shape_807.graphics.f("#000000").s().p("AADgBIAFAAIgPADg");
	this.shape_807.setTransform(160.6151,237.524,0.6501,0.6501);

	this.shape_808 = new cjs.Shape();
	this.shape_808.graphics.f("#000000").s().p("AgMABIALgBIAPABg");
	this.shape_808.setTransform(137.9119,237.4752,0.6501,0.6501);

	this.shape_809 = new cjs.Shape();
	this.shape_809.graphics.f("#000000").s().p("AhMgFICCABIAOADQAIABABAGQgygGhngFg");
	this.shape_809.setTransform(297.5329,237.719,0.6501,0.6501);

	this.shape_810 = new cjs.Shape();
	this.shape_810.graphics.f("#000000").s().p("AAAACIAAgDIABAAIAAADg");
	this.shape_810.setTransform(300.1331,236.9714,0.6501,0.6501);

	this.shape_811 = new cjs.Shape();
	this.shape_811.graphics.f("#000000").s().p("AgLADIAAgFIAXAFg");
	this.shape_811.setTransform(86.8988,236.9064,0.6501,0.6501);

	this.shape_812 = new cjs.Shape();
	this.shape_812.graphics.f("#000000").s().p("AgtADIAAgDQARAABKgEQgOACgfAFQgOACgLAAQgMAAgJgCg");
	this.shape_812.setTransform(152.3594,236.557,0.6501,0.6501);

	this.shape_813 = new cjs.Shape();
	this.shape_813.graphics.f("#000000").s().p("AgNAGQgFgFgNABIglgHQBEAKBFgFQgeAGgjAAIgRAAg");
	this.shape_813.setTransform(125.6584,236.6269,0.6501,0.6501);

	this.shape_814 = new cjs.Shape();
	this.shape_814.graphics.f("#000000").s().p("AhrgDIAAgEQAeAHBMABQBYABAVADQggADgkAAQhDAAhQgLg");
	this.shape_814.setTransform(96.4059,236.5236,0.6501,0.6501);

	this.shape_815 = new cjs.Shape();
	this.shape_815.graphics.f("#FFFFFF").s().p("AACACQgSgCgHABIAXgDIAYABQgEAEgMAAIgGgBg");
	this.shape_815.setTransform(302.0833,235.2748,0.6501,0.6501);

	this.shape_816 = new cjs.Shape();
	this.shape_816.graphics.f("#000000").s().p("AgaABQAHgHAUAGIAaAAQgMADgPAAQgLAAgPgCg");
	this.shape_816.setTransform(139.1308,234.9812,0.6501,0.6501);

	this.shape_817 = new cjs.Shape();
	this.shape_817.graphics.f("#000000").s().p("AglACQABgFALABIA/AAQgfAFgZAAIgTgBg");
	this.shape_817.setTransform(110.4958,235.0225,0.6501,0.6501);

	this.shape_818 = new cjs.Shape();
	this.shape_818.graphics.f("#000000").s().p("AAAABIAAgBIACAAIAAABg");
	this.shape_818.setTransform(248.1612,233.3636,0.6501,0.6501);

	this.shape_819 = new cjs.Shape();
	this.shape_819.graphics.f("#000000").s().p("AgkgCIBJAAQgIACgbAAQgZAAgLADQgCgBAAgEg");
	this.shape_819.setTransform(245.3172,233.5099,0.6501,0.6501);

	this.shape_820 = new cjs.Shape();
	this.shape_820.graphics.f("#FFFFFF").s().p("AgEABIAEgBIAFABg");
	this.shape_820.setTransform(72.9227,233.2986,0.6501,0.6501);

	this.shape_821 = new cjs.Shape();
	this.shape_821.graphics.f("#000000").s().p("AAAgBIAoAAIAAABIhQACQAQgDAYAAg");
	this.shape_821.setTransform(213.2858,232.9718,0.6501,0.6501);

	this.shape_822 = new cjs.Shape();
	this.shape_822.graphics.f("#000000").s().p("AguACIgFgCIACgCIBlACQgSADgnAAIgpgBg");
	this.shape_822.setTransform(226.8557,232.8419,0.6501,0.6501);

	this.shape_823 = new cjs.Shape();
	this.shape_823.graphics.f("#FFFFFF").s().p("AgEABQABgBAAAAQABAAAAAAQABAAAAAAQABAAAAAAQABAAABAAQAAAAABAAQAAAAABAAQAAAAAAABg");
	this.shape_823.setTransform(129.7537,232.6973,0.6501,0.6501);

	this.shape_824 = new cjs.Shape();
	this.shape_824.graphics.f("#000000").s().p("AilAQQASgDAoAAQAlAAASgEQgFgCgNgBQgQAEghgEQgggDgQAEQgBgBAAgEQAdgGArABQAwABAXgBIAagHQg4gRhHAPIgOAAQgJABgBgHQAxgJBVAGIADADICFAIQhPgDhRAPIBTALQALAAAzgJQAmgGAaAFQgZgCg0ALQAFAFALgCQALgCACADQgLACgqgBQghAAgTAGIAAgEIAFgCQgegFgxADQg/AFgRgBQgJADgUADQAEgCgCgHg");
	this.shape_824.setTransform(92.7006,234.3196,0.6501,0.6501);

	this.shape_825 = new cjs.Shape();
	this.shape_825.graphics.f("#000000").s().p("AAngBQgVABg4AEQAjgKAqAFg");
	this.shape_825.setTransform(195.653,232.7515,0.6501,0.6501);

	this.shape_826 = new cjs.Shape();
	this.shape_826.graphics.f("#FFFFFF").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_826.setTransform(305.2523,232.3398,0.6501,0.6501);

	this.shape_827 = new cjs.Shape();
	this.shape_827.graphics.f("#000000").s().p("AgFABQAIgEADAEg");
	this.shape_827.setTransform(298.703,232.3479,0.6501,0.6501);

	this.shape_828 = new cjs.Shape();
	this.shape_828.graphics.f("#000000").s().p("AheAQQgEgBAygGQAOAAAFgDQgagJg4ADIgEAEIASAEQg1gBgvgDQAAAAAAgBQAAAAAAAAQgBgBAAgBQAAAAgBgBQAeAAATADQADgDgCgGQB0AADngJIACACIAAAEQgEADgJgFQgBAEgGAAQgGgBgBACIADACIggAEQAFgCAJgCIgDgEQggADg9ABQgGACAAACQgbgFgUALQAcABAMADQgVAFg+gCQgcADgTAAIgNAAgAAqAEIAHAAQAGAAABgEIBBAAQg8AEgPAAIgEAAg");
	this.shape_828.setTransform(118.9141,233.0844,0.6501,0.6501);

	this.shape_829 = new cjs.Shape();
	this.shape_829.graphics.f("#000000").s().p("AivAEQgPgBABgGQAaADClAAQCnACAVACg");
	this.shape_829.setTransform(276.2578,232.226,0.6501,0.6501);

	this.shape_830 = new cjs.Shape();
	this.shape_830.graphics.f("#000000").s().p("AggABIgEgDQAzgCAWAFQgLACgRAAQgQAAgZgCg");
	this.shape_830.setTransform(255.8156,232.2265,0.6501,0.6501);

	this.shape_831 = new cjs.Shape();
	this.shape_831.graphics.f("#000000").s().p("AgxADIAFgDQAVAEAUgGIgMgDIAMACQBDADgRABIgXACQgLAAgZADIgNAAQgPAAgJgDg");
	this.shape_831.setTransform(97.5351,231.8708,0.6501,0.6501);

	this.shape_832 = new cjs.Shape();
	this.shape_832.graphics.f("#000000").s().p("AguACQAAAAAAAAQAAgBgBAAQAAgBAAAAQgBAAAAAAQBOgEAUAEQgPgBghACIggACIgQgBg");
	this.shape_832.setTransform(92.7981,231.5451,0.6501,0.6501);

	this.shape_833 = new cjs.Shape();
	this.shape_833.graphics.f("#000000").s().p("AgVAAQAUgDAXADQgHAAgJABIgLABQgJAAgHgCg");
	this.shape_833.setTransform(243.0745,231.3424,0.6501,0.6501);

	this.shape_834 = new cjs.Shape();
	this.shape_834.graphics.f("#000000").s().p("AgkgCIBQAAIhWAFQgDgHAJACg");
	this.shape_834.setTransform(217.0164,231.1722,0.6501,0.6501);

	this.shape_835 = new cjs.Shape();
	this.shape_835.graphics.f("#000000").s().p("Ai0ABIABgEQEhgCBIAFQhGgDkeAIg");
	this.shape_835.setTransform(279.4614,230.9573,0.6501,0.6501);

	this.shape_836 = new cjs.Shape();
	this.shape_836.graphics.f("#000000").s().p("AglgBQAOABATAAQAhAAAJABIgfABQgaAAgSgDg");
	this.shape_836.setTransform(256.0919,231.047,0.6501,0.6501);

	this.shape_837 = new cjs.Shape();
	this.shape_837.graphics.f("#000000").s().p("AiWAHIBmgIIB/gCIgHgCQgBgGAGABQAIABABgCIA2ABIgtAFQAJAEATAAQAVAAAHABQgNAAg0ADIAAAEQhNgGifALg");
	this.shape_837.setTransform(120.7017,231.2509,0.6501,0.6501);

	this.shape_838 = new cjs.Shape();
	this.shape_838.graphics.f("#000000").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_838.setTransform(168.2045,230.2271,0.6501,0.6501);

	this.shape_839 = new cjs.Shape();
	this.shape_839.graphics.f("#000000").s().p("AAAABIAAgCIABAAIAAACg");
	this.shape_839.setTransform(169.6021,230.0971,0.6501,0.6501);

	this.shape_840 = new cjs.Shape();
	this.shape_840.graphics.f("#000000").s().p("Ah0ABQBggHA/ADQAyACAYADIjpADg");
	this.shape_840.setTransform(212.3594,230.1505,0.6501,0.6501);

	this.shape_841 = new cjs.Shape();
	this.shape_841.graphics.f("#000000").s().p("AgwAAIAAgCIBhACQghADgYAAQgZAAgPgDg");
	this.shape_841.setTransform(193.3778,230.0483,0.6501,0.6501);

	this.shape_842 = new cjs.Shape();
	this.shape_842.graphics.f("#000000").s().p("AhIAEIAAgEQBKgGBHAKQhKgEhHAEg");
	this.shape_842.setTransform(255.8806,229.9633,0.6501,0.6501);

	this.shape_843 = new cjs.Shape();
	this.shape_843.graphics.f("#000000").s().p("AgrAAQAIgBBPgBIhRAFg");
	this.shape_843.setTransform(232.5274,230.0808,0.6501,0.6501);

	this.shape_844 = new cjs.Shape();
	this.shape_844.graphics.f("#000000").s().p("AAAACIAAgCIABAAIAAACg");
	this.shape_844.setTransform(290.106,229.187,0.6501,0.6501);

	this.shape_845 = new cjs.Shape();
	this.shape_845.graphics.f("#000000").s().p("AggADIASgFIAvAFg");
	this.shape_845.setTransform(213.5133,228.8295,0.6501,0.6501);

	this.shape_846 = new cjs.Shape();
	this.shape_846.graphics.f("#000000").s().p("AhBABQBWgHAtAEQgsABhTAFg");
	this.shape_846.setTransform(206.2002,229.3296,0.6501,0.6501);

	this.shape_847 = new cjs.Shape();
	this.shape_847.graphics.f("#000000").s().p("AAFAEIg8gDIAAgBQASgEAlAEQAiAEATgHIADABQgNAGgbAAIgLAAg");
	this.shape_847.setTransform(219.9813,229.0647,0.6501,0.6501);

	this.shape_848 = new cjs.Shape();
	this.shape_848.graphics.f("#000000").s().p("AhKAAQAwgFBlAEIiSAFg");
	this.shape_848.setTransform(181.8881,229.1406,0.6501,0.6501);

	this.shape_849 = new cjs.Shape();
	this.shape_849.graphics.f("#000000").s().p("AAtACQgcgCgOACIhXgCIADgEIAGAEQA2gDBpAFQgGADgKAAQgKAAgNgDg");
	this.shape_849.setTransform(254.3692,228.732,0.6501,0.6501);

	this.shape_850 = new cjs.Shape();
	this.shape_850.graphics.f("#000000").s().p("AhHADIAAgEIBZgFQAJACARgBQARgCAKACQh5AJgKADIgLgEg");
	this.shape_850.setTransform(145.7451,228.5695,0.6501,0.6501);

	this.shape_851 = new cjs.Shape();
	this.shape_851.graphics.f("#000000").s().p("AhTAQIAYgHQgOgBhbAEQAIgFgFgEQgGgFABgFQgbACgzgFIAAgJQAgAGA8gBQBAAAAeAEQBogGAwAGQgVgBgxADIgLADQAjAHA6gDQBDgFAYADQgTgBgGAFQAIAFARgCQATgCAGABQANgEAKABQg3ANhagGIgBAFIgHgEQgEgDgDAEIhDAAQgogBgXAEIgTAGIgJACQgGAAgEgEg");
	this.shape_851.setTransform(120.7017,229.3938,0.6501,0.6501);

	this.shape_852 = new cjs.Shape();
	this.shape_852.graphics.f("#000000").s().p("AgngCIBPACIhLACg");
	this.shape_852.setTransform(204.5263,228.0494,0.6501,0.6501);

	this.shape_853 = new cjs.Shape();
	this.shape_853.graphics.f("#000000").s().p("AgngCIBPACIhOADg");
	this.shape_853.setTransform(294.8514,227.7081,0.6501,0.6501);

	this.shape_854 = new cjs.Shape();
	this.shape_854.graphics.f("#000000").s().p("Ag7ACQAGgBBxgDQgzAFgoAAIgcgBg");
	this.shape_854.setTransform(180.5068,227.762,0.6501,0.6501);

	this.shape_855 = new cjs.Shape();
	this.shape_855.graphics.f("#000000").s().p("AhJgBIAYAAQBAgFAZAFQARgFARAFQgyAGgkAAQgkAAgZgGg");
	this.shape_855.setTransform(266.6715,227.761,0.6501,0.6501);

	this.shape_856 = new cjs.Shape();
	this.shape_856.graphics.f("#000000").s().p("Ag6AAIAEgCQBOgDAjAFQhiACgPACg");
	this.shape_856.setTransform(255.0356,227.6123,0.6501,0.6501);

	this.shape_857 = new cjs.Shape();
	this.shape_857.graphics.f("#000000").s().p("AgagBIA1gBQgVACgcADg");
	this.shape_857.setTransform(246.081,227.5294,0.6501,0.6501);

	this.shape_858 = new cjs.Shape();
	this.shape_858.graphics.f("#000000").s().p("AgdABQAlgFAWAEIgeACIgMABQgKAAgHgCg");
	this.shape_858.setTransform(229.5534,227.2295,0.6501,0.6501);

	this.shape_859 = new cjs.Shape();
	this.shape_859.graphics.f("#000000").s().p("AgfgCIBLACIhYADQAAgHANACg");
	this.shape_859.setTransform(236.2002,227.1094,0.6501,0.6501);

	this.shape_860 = new cjs.Shape();
	this.shape_860.graphics.f("#000000").s().p("AgpADIAAgGQAFABBOACQgcAEgaAAIgdgBg");
	this.shape_860.setTransform(191.899,226.8433,0.6501,0.6501);

	this.shape_861 = new cjs.Shape();
	this.shape_861.graphics.f("#000000").s().p("Ag+ACIAAgCQBVgGAoAGQgRgBgtAEQgRABgPAAQgRAAgOgCg");
	this.shape_861.setTransform(178.4916,226.908,0.6501,0.6501);

	this.shape_862 = new cjs.Shape();
	this.shape_862.graphics.f("#FFFFFF").s().p("AgHgBQAWABAKgCQABABAPABIhRADQANgEAUAAg");
	this.shape_862.setTransform(116.7039,226.7656,0.6501,0.6501);

	this.shape_863 = new cjs.Shape();
	this.shape_863.graphics.f("#FFFFFF").s().p("AgSgBQAbgCAKACIAAAEg");
	this.shape_863.setTransform(111.6984,226.8387,0.6501,0.6501);

	this.shape_864 = new cjs.Shape();
	this.shape_864.graphics.f("#FFFFFF").s().p("AgVABIAFgBIAmABg");
	this.shape_864.setTransform(128.9249,226.5055,0.6501,0.6501);

	this.shape_865 = new cjs.Shape();
	this.shape_865.graphics.f("#000000").s().p("AgrgBIBXABQgKABhNABg");
	this.shape_865.setTransform(228.6596,226.3918,0.6501,0.6501);

	this.shape_866 = new cjs.Shape();
	this.shape_866.graphics.f("#000000").s().p("AACAEQhWgFgxACQgDAAgBgDQgCgDADgCQCSAACBAPIgUAAQgqAAhLgEg");
	this.shape_866.setTransform(213.6271,226.7753,0.6501,0.6501);

	this.shape_867 = new cjs.Shape();
	this.shape_867.graphics.f("#FFFFFF").s().p("AgOABIASgBIALABg");
	this.shape_867.setTransform(102.1426,226.278,0.6501,0.6501);

	this.shape_868 = new cjs.Shape();
	this.shape_868.graphics.f("#FFFFFF").s().p("AgBACIAAgCIADAAIAAACg");
	this.shape_868.setTransform(109.602,226.0342,0.6501,0.6501);

	this.shape_869 = new cjs.Shape();
	this.shape_869.graphics.f("#FFFFFF").s().p("AgmADQA0gKAZAGQgIAAgcADQgPACgMAAIgOgBg");
	this.shape_869.setTransform(80.9183,226.3542,0.6501,0.6501);

	this.shape_870 = new cjs.Shape();
	this.shape_870.graphics.f("#FFFFFF").s().p("AACAAIADgBQgCgBgJgBIANABIgCABQAAABAAAAQAAAAAAAAQgBAAAAABQgBAAgBABQgBAAgBAAQAAAAAAABQAAAAAAAAQAAABAAAAQgEgCAGgCg");
	this.shape_870.setTransform(302.3944,225.9042,0.6501,0.6501);

	this.shape_871 = new cjs.Shape();
	this.shape_871.graphics.f("#000000").s().p("AAqACQizgFgPgCQgMgBgkACQgfACgQgFIAEgHQBVAAChAHQC/AIA2ALQgDAAgJgCQgHgBgCAFIACABQgTgJiogEg");
	this.shape_871.setTransform(273.1721,226.6355,0.6501,0.6501);

	this.shape_872 = new cjs.Shape();
	this.shape_872.graphics.f("#FFFFFF").s().p("AgBACIAAgDIACAAIAAADg");
	this.shape_872.setTransform(173.8274,225.5467,0.6501,0.6501);

	this.shape_873 = new cjs.Shape();
	this.shape_873.graphics.f("#FFFFFF").s().p("AgFAOQgJgTgGgTIADAAIgBAEQADgBACABIAHALQgCAPANgBIAAAEIADgBIABAJQAGABAGAHQgJgDgRgIg");
	this.shape_873.setTransform(107.8631,166.6192,0.6501,0.6501);

	this.shape_874 = new cjs.Shape();
	this.shape_874.graphics.f("#FFFFFF").s().p("AAAADIACADQgJgJgCgEIAAgCQARAQACADg");
	this.shape_874.setTransform(110.9021,193.5965,0.6501,0.6501);

	this.shape_875 = new cjs.Shape();
	this.shape_875.graphics.f("#FFFFFF").s().p("AADAAQgMgVgPgCIAEAAQATACAaAtQgJgDgNgVg");
	this.shape_875.setTransform(105.4417,189.6637,0.6501,0.6501);

	this.shape_876 = new cjs.Shape();
	this.shape_876.graphics.f("#FFFFFF").s().p("AgNgEIAAgCQAYAJADAEQgLAAgQgLg");
	this.shape_876.setTransform(99.9975,186.8847,0.6501,0.6501);

	this.shape_877 = new cjs.Shape();
	this.shape_877.graphics.f("#FFFFFF").s().p("AgGAOQAJgOADgNIABAAQADAbgPAAIgBAAg");
	this.shape_877.setTransform(97.6677,183.3105,0.6501,0.6501);

	this.shape_878 = new cjs.Shape();
	this.shape_878.graphics.f("#FFFFFF").s().p("AAAgDIABACIAAAFg");
	this.shape_878.setTransform(121.1242,229.4958,0.6501,0.6501);

	this.shape_879 = new cjs.Shape();
	this.shape_879.graphics.f("#FFFFFF").s().p("AAAAGIAAgLIABAAIAAALg");
	this.shape_879.setTransform(119.9541,224.9292,0.6501,0.6501);

	this.shape_880 = new cjs.Shape();
	this.shape_880.graphics.f("#FFFFFF").s().p("AAAgBIABAAIAAADg");
	this.shape_880.setTransform(119.7916,223.564,0.6501,0.6501);

	this.shape_881 = new cjs.Shape();
	this.shape_881.graphics.f("#FFFFFF").s().p("AAHAFQgOgFgFABIgMgHQAKAEAnAFQgEAEgFAAIgJgCg");
	this.shape_881.setTransform(126.926,223.4698,0.6501,0.6501);

	this.shape_882 = new cjs.Shape();
	this.shape_882.graphics.f("#FFFFFF").s().p("AAAAFIABgJIgBAJg");
	this.shape_882.setTransform(115.7775,222.849,0.6501,0.6501);

	this.shape_883 = new cjs.Shape();
	this.shape_883.graphics.f("#FFFFFF").s().p("AAAACIAAgCIABAAIAAACg");
	this.shape_883.setTransform(117.2727,219.8912,0.6501,0.6501);

	this.shape_884 = new cjs.Shape();
	this.shape_884.graphics.f("#FFFFFF").s().p("AAAADIgEgDIAEAAQAEAAABgDIAAAGIgCABIgDgBgAgEAAIAAAAIAAAAg");
	this.shape_884.setTransform(122.1806,215.776,0.6501,0.6501);

	this.shape_885 = new cjs.Shape();
	this.shape_885.graphics.f("#FFFFFF").s().p("AgEgFQAFAGAEgBQAAACgDAEg");
	this.shape_885.setTransform(122.0363,214.772,0.6501,0.6501);

	this.shape_886 = new cjs.Shape();
	this.shape_886.graphics.f("#FFFFFF").s().p("AABgeQAEAKgCAPQgDAQABAIIgEAMQAFg0gBgJg");
	this.shape_886.setTransform(117.8727,215.8121,0.6501,0.6501);

	this.shape_887 = new cjs.Shape();
	this.shape_887.graphics.f("#FFFFFF").s().p("AAAADQgDgDABgDIAGAFQgBABAAAAQAAAAgBABQAAAAAAAAQAAAAgBAAIgBgBg");
	this.shape_887.setTransform(122.0506,213.6307,0.6501,0.6501);

	this.shape_888 = new cjs.Shape();
	this.shape_888.graphics.f("#FFFFFF").s().p("AAAgFIABAFIAAAGg");
	this.shape_888.setTransform(117.809,212.9844,0.6501,0.6501);

	this.shape_889 = new cjs.Shape();
	this.shape_889.graphics.f("#FFFFFF").s().p("AAAACIAAgDIABAAIAAADg");
	this.shape_889.setTransform(121.5143,211.8793,0.6501,0.6501);

	this.shape_890 = new cjs.Shape();
	this.shape_890.graphics.f("#FFFFFF").s().p("AAAADIAAgFIABAAIAAAFg");
	this.shape_890.setTransform(117.7115,211.9118,0.6501,0.6501);

	this.shape_891 = new cjs.Shape();
	this.shape_891.graphics.f("#FFFFFF").s().p("AAAAEIABgHIgBAHg");
	this.shape_891.setTransform(121.0917,211.343,0.6501,0.6501);

	this.shape_892 = new cjs.Shape();
	this.shape_892.graphics.f("#FFFFFF").s().p("AgEgWQAQAggNANQACgQgFgdg");
	this.shape_892.setTransform(120.6554,209.5066,0.6501,0.6501);

	this.shape_893 = new cjs.Shape();
	this.shape_893.graphics.f("#FFFFFF").s().p("AAAAAQgCgmgGgWQAGAVAFANIgBgCQgFAFADAIQAEAMgBADIAFAKQgBABAAANQgBAAgBAAQAAAAgBAAQAAAAgBABQAAAAAAABQAIAUgGAPQgDgUgCgpg");
	this.shape_893.setTransform(117.2077,207.1501,0.6501,0.6501);

	this.shape_894 = new cjs.Shape();
	this.shape_894.graphics.f("#FFFFFF").s().p("AAAAEQgHgVAAgNIACAAQAHAdAGAgIgIgbg");
	this.shape_894.setTransform(119.5966,204.4362,0.6501,0.6501);

	this.shape_895 = new cjs.Shape();
	this.shape_895.graphics.f("#FFFFFF").s().p("AAAgCIABABIAAAFg");
	this.shape_895.setTransform(118.8653,201.2021,0.6501,0.6501);

	this.shape_896 = new cjs.Shape();
	this.shape_896.graphics.f("#FFFFFF").s().p("AgEgCIAFABIADAFg");
	this.shape_896.setTransform(118.4103,201.4297,0.6501,0.6501);

	this.shape_897 = new cjs.Shape();
	this.shape_897.graphics.f("#FFFFFF").s().p("AAAACIAAgCIABAAIAAACg");
	this.shape_897.setTransform(115.9726,200.8771,0.6501,0.6501);

	this.shape_898 = new cjs.Shape();
	this.shape_898.graphics.f("#FFFFFF").s().p("AAFgHIACACIgNANQgBgIAMgHg");
	this.shape_898.setTransform(120.2605,196.5705,0.6501,0.6501);

	this.shape_899 = new cjs.Shape();
	this.shape_899.graphics.f("#FFFFFF").s().p("AgCgCIAFACIgCADg");
	this.shape_899.setTransform(111.6172,195.8554,0.6501,0.6501);

	this.shape_900 = new cjs.Shape();
	this.shape_900.graphics.f("#FFFFFF").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_900.setTransform(122.2618,194.5553,0.6501,0.6501);

	this.shape_901 = new cjs.Shape();
	this.shape_901.graphics.f("#FFFFFF").s().p("AgDgBIAHABQgBACgEAAg");
	this.shape_901.setTransform(113.9086,195.2866,0.6501,0.6501);

	this.shape_902 = new cjs.Shape();
	this.shape_902.graphics.f("#FFFFFF").s().p("AABADQgFgBgDgEIAPACQgBADgEAAIgCAAg");
	this.shape_902.setTransform(112.5923,195.0858,0.6501,0.6501);

	this.shape_903 = new cjs.Shape();
	this.shape_903.graphics.f("#FFFFFF").s().p("AAAgBIABAAIAAADg");
	this.shape_903.setTransform(122.8794,193.3852,0.6501,0.6501);

	this.shape_904 = new cjs.Shape();
	this.shape_904.graphics.f("#FFFFFF").s().p("AgUAkIgQAAIATgIQAMgEAFAKQAHAAABgFIACgKQAKgMAEgSIAEAHIgGAEQAEADgEADQgEAEACAFQgGADgBAIIABAOQgGgHgIAGQgIAHgFgIQgHACAAAIgAAYgMIABAAIAGgjQAGAGAAAIIgFARQgDgBgEAFIgBAAIAAABg");
	this.shape_904.setTransform(117.7451,192.532,0.6501,0.6501);

	this.shape_905 = new cjs.Shape();
	this.shape_905.graphics.f("#FFFFFF").s().p("AgCABQAGgHgBAIg");
	this.shape_905.setTransform(132.0005,188.4965,0.6501,0.6501);

	this.shape_906 = new cjs.Shape();
	this.shape_906.graphics.f("#FFFFFF").s().p("AgFgBIASgYQgCAFgNAUQgMARAEAJQgGgMALgPg");
	this.shape_906.setTransform(124.4336,190.0862,0.6501,0.6501);

	this.shape_907 = new cjs.Shape();
	this.shape_907.graphics.f("#FFFFFF").s().p("AgKACIgIgDQAFgFAIAHIAFADQgGAAgEgCgAAJAAIAKgBQgCACgKACIgBABIADgEg");
	this.shape_907.setTransform(128.0636,187.9273,0.6501,0.6501);

	this.shape_908 = new cjs.Shape();
	this.shape_908.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_908.setTransform(134.1578,187.1935,0.6501,0.6501);

	this.shape_909 = new cjs.Shape();
	this.shape_909.graphics.f("#FFFFFF").s().p("AAAgBIABAAIAAADg");
	this.shape_909.setTransform(119.3691,187.2585,0.6501,0.6501);

	this.shape_910 = new cjs.Shape();
	this.shape_910.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_910.setTransform(134.6779,186.6734,0.6501,0.6501);

	this.shape_911 = new cjs.Shape();
	this.shape_911.graphics.f("#FFFFFF").s().p("AgIgOQAIAPAJAFIgEAJQgMgGgBgXg");
	this.shape_911.setTransform(122.4243,187.4047,0.6501,0.6501);

	this.shape_912 = new cjs.Shape();
	this.shape_912.graphics.f("#FFFFFF").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_912.setTransform(119.0116,186.0396,0.6501,0.6501);

	this.shape_913 = new cjs.Shape();
	this.shape_913.graphics.f("#FFFFFF").s().p("AgHABIgIAEQgCgEAEgDIAGgGQAPAJAJACQgDABAAAFQgFgKgQACg");
	this.shape_913.setTransform(125.0984,185.8283,0.6501,0.6501);

	this.shape_914 = new cjs.Shape();
	this.shape_914.graphics.f("#FFFFFF").s().p("AgDAEIACgHIAFAHg");
	this.shape_914.setTransform(121.2868,185.5033,0.6501,0.6501);

	this.shape_915 = new cjs.Shape();
	this.shape_915.graphics.f("#FFFFFF").s().p("AgCgBIACgCIADAHg");
	this.shape_915.setTransform(118.0527,184.8858,0.6501,0.6501);

	this.shape_916 = new cjs.Shape();
	this.shape_916.graphics.f("#FFFFFF").s().p("AgJgTQADAAAGARQAHARADABIAAAEQgIAAgLgng");
	this.shape_916.setTransform(117.2402,182.4318,0.6501,0.6501);

	this.shape_917 = new cjs.Shape();
	this.shape_917.graphics.f("#FFFFFF").s().p("AgBABIAAgCIADAAIAAACg");
	this.shape_917.setTransform(115.5663,180.6604,0.6501,0.6501);

	this.shape_918 = new cjs.Shape();
	this.shape_918.graphics.f("#FFFFFF").s().p("AADAGQgDgGgFAAIgGgJQAUAGADAMIgDABQgDAAgDgEg");
	this.shape_918.setTransform(118.654,180.6424,0.6501,0.6501);

	this.shape_919 = new cjs.Shape();
	this.shape_919.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_919.setTransform(115.3062,179.6366,0.6501,0.6501);

	this.shape_920 = new cjs.Shape();
	this.shape_920.graphics.f("#FFFFFF").s().p("AAAACIAAgCIABAAIAAACg");
	this.shape_920.setTransform(116.8826,178.8728,0.6501,0.6501);

	this.shape_921 = new cjs.Shape();
	this.shape_921.graphics.f("#FFFFFF").s().p("AAAAGIAAgLIABAAIAAALg");
	this.shape_921.setTransform(115.4038,177.4589,0.6501,0.6501);

	this.shape_922 = new cjs.Shape();
	this.shape_922.graphics.f("#FFFFFF").s().p("AAAgEIABACIAAAHg");
	this.shape_922.setTransform(131.1026,178.239,0.6501,0.6501);

	this.shape_923 = new cjs.Shape();
	this.shape_923.graphics.f("#FFFFFF").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_923.setTransform(132.9552,174.1436,0.6501,0.6501);

	this.shape_924 = new cjs.Shape();
	this.shape_924.graphics.f("#FFFFFF").s().p("AAAAAQgOgJgFgGIAVAOQANAIAFAJQgFgJgPgHg");
	this.shape_924.setTransform(113.6324,171.5596,0.6501,0.6501);

	this.shape_925 = new cjs.Shape();
	this.shape_925.graphics.f("#FFFFFF").s().p("AgBADQABgJADgFQABAEgGATIAAAAQgBAAACgJg");
	this.shape_925.setTransform(116.7355,170.8616,0.6501,0.6501);

	this.shape_926 = new cjs.Shape();
	this.shape_926.graphics.f("#FFFFFF").s().p("AACgKQACAHgDAGIgDAIg");
	this.shape_926.setTransform(118.2315,169.6745,0.6501,0.6501);

	this.shape_927 = new cjs.Shape();
	this.shape_927.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_927.setTransform(111.3734,168.7482,0.6501,0.6501);

	this.shape_928 = new cjs.Shape();
	this.shape_928.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_928.setTransform(112.9498,156.7059,0.6501,0.6501);

	this.shape_929 = new cjs.Shape();
	this.shape_929.graphics.f("#000000").s().p("AjPJ5IgNACIAUgIQAIgCAKgKQAMgMAGgDQAGgbAWgJQAzgLAaAIQASgQgCgNQAmgqgFhXQgDgwgLhhQgCgKgOgVQgLgQAHgNQADgGgHgsQgbgSgNAFQgGAGgGgCIgMgEQgDgJgcgeQgggjgigYQgngdgygTQgKgUgNgFQAAgLgSgIQgSgJgDgLQAMAIAEAAIAMAHQAGABACgLQAAgWgVgfQgXgigDgPQAFABAGAMQAHAPAEAEQAOAJAHAUQAKAaAEAGIAHgUQgOhMguhQQgCgIgJgSQgIgQAAgJQAfAsALAZQAIgHAAgQIgBgbQAGAOgCApQgCAiAQARQAcBPAAAYIgLAgQgBABAJAJIAJAIQAKAGAMAFIAYAIQAUAAAHAFIAPAJIAxArIAvApIAWARQALAHAEgBQAjgTAXAEQAAAAAAAAQAAABAAAAQAAABAAAAQABABAAABIACAAQAvhPgsgxQgGgXgrg6QgBgGADglQADghgFgTQgHgZgXgUQgOgMgjgXIgagQQgbgVgGgeQgbgTgUggQgWgkAHgZQAYBaAwAJQAFgLgSgsQgGgQACgeIAEgpQgDAwAIAUQAWgSACgdQAGAQgGALQgCAFgQASQgIAXATAZQADAiAIAMQAHAHA1AiQAvAfARAbQAVgfAAgqQAAgsgXgeQgDgcgmgpQgmgnAAggQgDgmgJgWQANAcAHANIAEgVQAGASgMAZIAJAZQAGAPANACQAYgeAEg6QgZgoADgYQAAAUAQATQAEgYADAOIAAALQABgEAIAPQAHgIAAgRQAAgVACgFQAJAhgFAQQgTAUAAAXQgDAdgOAfQgBASAZASQAZARgBARIACADQAJgOAYgcQATgbgLgYIADADQAGgOgMghQgDgIAGgNIAEAAQgEARAJAfQAJAggEAPQAVgNAEgxQAAAEAEADQAEgDgCgKQAKAcgPAeQgIAQgcAhQACANgVAXQgSAVAHARQANAcAKANQALgHADgZQADgaAJgHQgCAQgBABIAFADQAMgLAGgWQAGAPgTAWQgUAXADAQQgfAXAEAgQgSAVgFAkQgCAPAAAyQACAQATAKQAXAKAEALQAbBJAQAUQADgCAHgXQAFgQAQADQAJAMAYACQAbACAIAFQAJgSAFg1QgFgJABgEQANgKgGgVQgFgWAOgKIAUgfQgZgsALgWQAEgBAAAEIACAGQAFAlANAGQAPgdgLhAIACgCQAKAxACAZQAEAtggASQgLAcANAPQAbgEALgDQAVgGAIgSQAJgOgBgnQgCgtADgLQAAA3AHAKQAIgEACgMQACgOACgDQAFANgJATQgMAVAAAJQACAcgjAPQgEADgbAEQgTAEgGAPQgFAOgCAaQgBAZgIAPIACAMQgBAAAAAAQAAAAgBAAQAAAAgBAAQAAABgBAAQAYANAKgFQAEgGAVgMQAQgJACgOQARgGgIgQQgIgRALgIQgDgLAJgGIASgIIAQgcQABAEgFAUQAHAGAKgKIABAAQACADgGAFIAKACQgIAGgWgBQgSAAgGAPQAEAfAMAMQAGgIAYgBQAVAAAEgPIAWgWQAAAIgLAMIgSATQAGAEAIgCIANgDQgKALgkAAQghAAgKASQgKAKgOAYQgOAagLAJQgFgBgkgRQgYgMgSAIQgDABgZgFQgRgEgEASIgPAzQgJAbgYAQQgbArgQAMQACAjAWB0QABAPAOAOQAPANAAAPQACAIgBAoQAAAcAMAMQAAAkAXAWQAMAKAkAEQAfACANAWQAVAAAKgFQAIAGAFgBIAAABIgvAKQgHgKgSgLQgIgFgMAPIgegGQgTgDgIgNIgCAWIgWgYIgCAWQgPgEgBAAQgDABgGAOQgHASAGAfIgUggIgKguQgPgBgRAIIgeAOIgLAEQgKAFgGgCIAAADIgjgEQgUgCgOAMQgHgBgFAJQgFAMgDAEQgGABgSASQgJAJgIAAQgEAAgDgDg");
	this.shape_929.setTransform(117.9715,187.6035,0.6501,0.6501);

	this.shape_930 = new cjs.Shape();
	this.shape_930.graphics.f("#FFFFFF").s().p("AAxJ+QACAIgBAEIgOgYIgFgDQgCgCABgKQAAgJgGgDQAAgJgEgVIgDgKIAAgHQgBgDgFgBIgDAAQgIADgMAJQgJAEgTACQgKADgPAHIgkACIgTAAQgHABgEACQgQAJgCgBQgEADgDgEQgGgKAagKIABgBIAAAAIAGABIAAgBIACAAIAXgDQARgDAMAAQAGAAAJABIABAAQANgLAAgMIAAgDIAAgBQAhgkAAhDQAAgYgHhBIgKhOQgDgQgHgLQgOgSAAgFIAHgNQACgEAAgHIgFgYQgCgKgCgBIgEgEQgOgKgFgBIgEACQgHAGgHgCQgFABgGgDIgLgDQgCgIgbgfQgggkgigZQgWgPgsgTQgWgKgBgDQgLgTgLgFIgBgBIAAgBQgBgJgOgHQgUgIgDgJIgEgQIAKAJIAIAEQAJAJAHgEIADACIABgEQAAgXgYgjQgTgdgEgPIgFgRQAVAUACAJQAGAUAIgBQANAKAHASIAHAZIAFgKIABgCQgOhKguhRIgBAAQgCgKgHgNQgJgUAAgJIgJgUIASASIAQAdQAGAJAOAaQAEgKAAgEIgBgWIAAgYQAJAQACAKQADARgEAaQgBAIAFAVIAKATIAPAuQANAzADAIQAEAHgPAdQAOASAqAPQA1ATAHAFIA9A3QAwAoAKADIATgHQAUgJAMABIAIAAQATglAAgfQAAgfgSgUIAAgBIAAAAQgDgKgZglQgRgWgFgMIgBAAIAAgBIAAgHIABgYIACgiQAAgSgDgLQgHgggyghIgUgOIgBgBQgygVgJgtQgYgSgTgbQgVggAAgZQAAgHACgGIAFgTIAGATQAVBOApARIABgFQAAgKgKgWIgFgMQgFgMAAgTIADgjIABgWIAGgPQACAFAAAdIACASIAAAMQAAAIADACQAQgSADgfQANASgBALQgCAKgPATIgEAFIgBAJQAAAVALAOIABABIAAAFQADAeAIAKQAIAJAhAVQA5AkATAaQAQgdAAgjQAAgrgWgdIAAAAIAAgBQgDgbgkgnQgogqgBggQgCgmgKgYIAAgLQAVAbAEAJIAAAAIgBgDIADgNQAHAXAAAFQAAATgEAIIAGAPQAFASAJAEQAVgeAEg0QgXgiAAgWIACgVIAIAUIAMAUIABABIABgBIACABIABgBIACABIAAAAIABgBIAFABIAAAJIADACQACgHAAgFIgBgOQAAgJACgFIADgHQAAgLABgBIAFAMIACAHQACAFAAAdQAEALgBAFIAAABIgHAEQgOAQAAAXQgDAbgKAXIgGAJQAAANAbATQAVAPADANIAKgNQAbgdAAgUQAAgJgEgIIADgCIABgFQAAgHgEgLIgEgUIAAAAIAAgFIACgLIACgGIAGgMIACAEIAAgBIAAACIACAEIgCAIIAAAEIABAPQAIAPADALQABAFAAAfIACABQAOgOABgiIAAgGIAAgBQADgDADADIABgCIAAAAIAAgaIAEAOIgBgHIAGATQACAFAAAVQAAAVgKAPIgZAfIgGAMIAAACQAAAKgSAUQgSATAAAMIAGAJQAEAGAGAOIAIAOQAGgIACgSQADgZAJgHIAJgLIgEAaIAJgJQAEgHACgMIABgFIAAgJQAGACAAAWQAAAPgKAMQgRATAAAQIgDAHIAEgBIgBABQgSAMgIASIgJAjQgOARgEAWQgCAKAAAlIACANIACALIgEACQABAMAZAKQAVAKAEAMQAIAOAJAYQAPAmAGAJIADgJQAFgZATACIAIAAIABAAIABABQAJANAbABQAPABAHACQAIgRAEgmIAAgJIAAgBQgEgIAAgCIAAgEIABgBQAJgHAAgJIgCgMIgCgOQAAgMALgJQAIgGAGgOIAFgJIgCgDQgQgdAAgQQAAgJAEgKIAAgCIAIgMIAIAkQABAMAKALQAHgRAAgUQAAgPgFggIAAgBIAHgKIACgUIABAdIAJAlQAHAfAAAQQAAAlgeAQIgEAWQAAAJAFAHIAMgCQAlgFAJgVQAIgLAAgbIgCgvQAAgOACgKIACgYIAFASIAFAGQABADABAXIACAdIACgJQABgLADgEIADgDIACAEIAAABIAEgFIACAEQACAFAAAHQAAALgJAQQgJAPAAAJIAAACQAAAcgiAQQgHAEgRACQgaADgFAPQgGAPgBAWQgCAbgHAPIACAOQAJAFAHABIAEgBQAFgIAPgHQAUgMABgMIABgCIABAAQAJgDABgFIABgCQAAgDgDgHQgEgIAAgFQAAgHAGgGIgBgEQAAgKARgHIAMgHIATglIAFANIAAADQAAAFgDALIgBADIAGgEIABgBIAEAAIABABIABgBIAEAAIABACIABADQAAABAAAAQAAABgBAAQAAABAAAAQAAABgBAAIALACIgFAEQgJAHgQgBIgMAAQgMABgEALIAFARQADAOAEAFQAGgDAPgBQAXAAAEgNIAAgBIAVgUIAMgHIAAAHQAAAHgSARIgNAOIAjgGIgHAHQgMAMgfgBIgIAAQgdABgIAQIAAABIgBAAQgJAIgPAaIgMAVIgMARQgHAEghgTQgVgLgLgBQgFAAgIADQgEACgFgBQgFABgNgEIgLgDIgDABQgEADgCAJQgFANgFASQgLAugcASQgIAHgOAVQgNAUgHAGQACAoAOBKIAMAxQARARAEAIQAIAQgCAnIAAAOQAAAaALAKIABABIAAABQAAAjAWAVQANALAbABQAlADAOAVIAHgBQANAAAEgCIADABIADgBQARAFgLADQgEACgLgBIgVAGIgHAAIgCACQgRgHgKgIQgBgCgEABIgJAEIgPABQgSAAgDgBQgTgGgFgKQAAAbgEADIgIgRQgDgCgEgJIgEgCQgCADAAAHIABAHIAFAKQgBAAgIgIQgEAAgFgCIgDgBQgBAAgBAAQAAAAgBAAQAAAAAAAAQgBAAAAgBIgCAAIgDAFIgBADQgEAPAAAiQAJAQAAAIQgCgBgGgLg");
	this.shape_930.setTransform(118.004,187.2422,0.6501,0.6501);

	this.shape_931 = new cjs.Shape();
	this.shape_931.graphics.f("#FFFFFF").s().p("AgNAAIApAAIg2ABg");
	this.shape_931.setTransform(124.1307,225.5142,0.6501,0.6501);

	this.shape_932 = new cjs.Shape();
	this.shape_932.graphics.f("#FFFFFF").s().p("AgPABIAMgBIATABg");
	this.shape_932.setTransform(121.303,225.5955,0.6501,0.6501);

	this.shape_933 = new cjs.Shape();
	this.shape_933.graphics.f("#FFFFFF").s().p("AgNAAQABgCAMABIABAAIAOAEQgKgDgSAAg");
	this.shape_933.setTransform(103.329,225.4797,0.6501,0.6501);

	this.shape_934 = new cjs.Shape();
	this.shape_934.graphics.f("#000000").s().p("AhMACQACgHAQADQAZgCAqADQAuACAWgBQgfAEguAAQghAAgrgCg");
	this.shape_934.setTransform(244.0984,225.5184,0.6501,0.6501);

	this.shape_935 = new cjs.Shape();
	this.shape_935.graphics.f("#FFFFFF").s().p("Ag8ABQAYgHAoAEIA5ADIg5ADIgUAAQgaAAgSgDg");
	this.shape_935.setTransform(157.121,225.5941,0.6501,0.6501);

	this.shape_936 = new cjs.Shape();
	this.shape_936.graphics.f("#FFFFFF").s().p("Ag2gBIBtABQgPACgVAAQgeAAgrgDg");
	this.shape_936.setTransform(114.1361,225.5415,0.6501,0.6501);

	this.shape_937 = new cjs.Shape();
	this.shape_937.graphics.f("#FFFFFF").s().p("AgIABIALgBIAGABg");
	this.shape_937.setTransform(132.8415,225.1079,0.6501,0.6501);

	this.shape_938 = new cjs.Shape();
	this.shape_938.graphics.f("#FFFFFF").s().p("AgEgBQAHgBABACQgEgBgBADg");
	this.shape_938.setTransform(108.3994,225.1729,0.6501,0.6501);

	this.shape_939 = new cjs.Shape();
	this.shape_939.graphics.f("#FFFFFF").s().p("AgBABIgCgBIAHABg");
	this.shape_939.setTransform(213.367,224.7829,0.6501,0.6501);

	this.shape_940 = new cjs.Shape();
	this.shape_940.graphics.f("#000000").s().p("AhSADQAfgJArAAQAvACAYgBIAUAEQhBgHhgAPg");
	this.shape_940.setTransform(241.1894,224.8796,0.6501,0.6501);

	this.shape_941 = new cjs.Shape();
	this.shape_941.graphics.f("#FFFFFF").s().p("AgSAAQgaAAgUAAQAzgDBOAEIgNABIhGgCg");
	this.shape_941.setTransform(207.4678,224.6399,0.6501,0.6501);

	this.shape_942 = new cjs.Shape();
	this.shape_942.graphics.f("#000000").s().p("AgzACQA8ACAdgGIAOACQgYADgnAAIgogBg");
	this.shape_942.setTransform(194.3042,224.5862,0.6501,0.6501);

	this.shape_943 = new cjs.Shape();
	this.shape_943.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_943.setTransform(179.6292,223.9216,0.6501,0.6501);

	this.shape_944 = new cjs.Shape();
	this.shape_944.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_944.setTransform(178.9629,223.9216,0.6501,0.6501);

	this.shape_945 = new cjs.Shape();
	this.shape_945.graphics.f("#FFFFFF").s().p("AlMATIAFgDIAgAAQASAAAJgJQAcgIA5gCQA9gBAXgFQApgCBNACQBUABAlgBQAIgFATAAQAUABAJgFQASAAABAIQAAAGAEADQBpgFAJABQgIACgXAAQgUAAgKADQACAFAEACQgBABgOAAQgNAAgBAIQgTgGgqgCIACgHIgQgEIjWgCIgLAIQg1AHgxgCIAmgHQgRgDghADQgjAEgRgEQgBAJgSgDQgOgDAHAPg");
	this.shape_945.setTransform(153.562,225.2217,0.6501,0.6501);

	this.shape_946 = new cjs.Shape();
	this.shape_946.graphics.f("#FFFFFF").s().p("AgFAAIALAAIgLABg");
	this.shape_946.setTransform(180.6693,223.9378,0.6501,0.6501);

	this.shape_947 = new cjs.Shape();
	this.shape_947.graphics.f("#FFFFFF").s().p("AgPAHQgEgHAIgBQAKgEABgBIAJABQgDAEADAEQADAEAFAAg");
	this.shape_947.setTransform(177.8207,224.3604,0.6501,0.6501);

	this.shape_948 = new cjs.Shape();
	this.shape_948.graphics.f("#FFFFFF").s().p("AAAACIAAgDIACAAIAAADg");
	this.shape_948.setTransform(123.8382,223.564,0.6501,0.6501);

	this.shape_949 = new cjs.Shape();
	this.shape_949.graphics.f("#FFFFFF").s().p("AgRACIAjgEQgIAFgSAAIgJgBg");
	this.shape_949.setTransform(106.6118,223.8332,0.6501,0.6501);

	this.shape_950 = new cjs.Shape();
	this.shape_950.graphics.f("#FFFFFF").s().p("AgBgBIAEABQAAABgFAAg");
	this.shape_950.setTransform(123.0419,223.6615,0.6501,0.6501);

	this.shape_951 = new cjs.Shape();
	this.shape_951.graphics.f("#000000").s().p("AkmgGQgKABgWgFQAqAHAPgMQBHgBDkAMIEpAPIgDAFQndgciNAGg");
	this.shape_951.setTransform(269.223,224.3714,0.6501,0.6501);

	this.shape_952 = new cjs.Shape();
	this.shape_952.graphics.f("#FFFFFF").s().p("AgDgBIAHABIgFABg");
	this.shape_952.setTransform(98.5673,223.0765,0.6501,0.6501);

	this.shape_953 = new cjs.Shape();
	this.shape_953.graphics.f("#FFFFFF").s().p("AEMAPQgGgIgLgCIAaABQgEgHgFgBQAJAAADABQgDAEAGAEQAFAEAHAAQALAAgCABIgKACQgPADAFADgADLAEIgZgEQAAAAABAAQAAAAABgBQAAAAAAgBQAAAAAAgBQgOgEgSAEIAKACIguABQgdAAgQgJIlygJQBRgDGwAJIAtAIIhHABQAAADAFABIAHABIAtADIgDAAIgTABQgMAAgEgCg");
	this.shape_953.setTransform(283.453,224.0014,0.6501,0.6501);

	this.shape_954 = new cjs.Shape();
	this.shape_954.graphics.f("#FFFFFF").s().p("AgHgDIATAFIgXACg");
	this.shape_954.setTransform(115.745,222.7352,0.6501,0.6501);

	this.shape_955 = new cjs.Shape();
	this.shape_955.graphics.f("#FFFFFF").s().p("AAAACIAAgDIABAAIAAADg");
	this.shape_955.setTransform(110.5446,222.3939,0.6501,0.6501);

	this.shape_956 = new cjs.Shape();
	this.shape_956.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_956.setTransform(234.1688,222.2964,0.6501,0.6501);

	this.shape_957 = new cjs.Shape();
	this.shape_957.graphics.f("#FFFFFF").s().p("AAAgBQAcACAPAAQgLABhKAAQARgEAZABg");
	this.shape_957.setTransform(179.4342,222.4535,0.6501,0.6501);

	this.shape_958 = new cjs.Shape();
	this.shape_958.graphics.f("#FFFFFF").s().p("AABABIgUgCIAnABQgEACgHAAIgIgBg");
	this.shape_958.setTransform(255.2468,222.2802,0.6501,0.6501);

	this.shape_959 = new cjs.Shape();
	this.shape_959.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_959.setTransform(136.1893,222.0689,0.6501,0.6501);

	this.shape_960 = new cjs.Shape();
	this.shape_960.graphics.f("#FFFFFF").s().p("AgxgCIAxAAQAeAAAUAEIgYABQgdAAgugFg");
	this.shape_960.setTransform(296.0865,222.3527,0.6501,0.6501);

	this.shape_961 = new cjs.Shape();
	this.shape_961.graphics.f("#FFFFFF").s().p("AARACIh5gDQCMgFBFAIQgUACgWAAQgWAAgYgCg");
	this.shape_961.setTransform(243.9359,222.3906,0.6501,0.6501);

	this.shape_962 = new cjs.Shape();
	this.shape_962.graphics.f("#FFFFFF").s().p("AgggBQgOABgIgDIBtACIhCAFQgDgHgSACg");
	this.shape_962.setTransform(230.3335,222.5077,0.6501,0.6501);

	this.shape_963 = new cjs.Shape();
	this.shape_963.graphics.f("#FFFFFF").s().p("AgwAFQAKgHAaAEQAXAEAKgLIAPAAQAJAAAFAFQgkAGglAAIgZgBg");
	this.shape_963.setTransform(146.9802,222.268,0.6501,0.6501);

	this.shape_964 = new cjs.Shape();
	this.shape_964.graphics.f("#FFFFFF").s().p("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");
	this.shape_964.setTransform(188.0636,246.2835,0.6501,0.6501);

	this.shape_965 = new cjs.Shape();
	this.shape_965.graphics.f("#FFFFFF").s().p("AgjgEQAHABAQgBQASgCAGAJIAYACIgKAAQgdAAgggJg");
	this.shape_965.setTransform(218.3075,222.0719,0.6501,0.6501);

	this.shape_966 = new cjs.Shape();
	this.shape_966.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_966.setTransform(185.4634,221.6139,0.6501,0.6501);

	this.shape_967 = new cjs.Shape();
	this.shape_967.graphics.f("#FFFFFF").s().p("AgnACIADgEQAygBAZAGQgbgDgzACg");
	this.shape_967.setTransform(264.2501,221.7888,0.6501,0.6501);

	this.shape_968 = new cjs.Shape();
	this.shape_968.graphics.f("#FFFFFF").s().p("AglAAIAEgCIBHACIAAADIgNAAQgXAAgngDg");
	this.shape_968.setTransform(258.3346,221.6414,0.6501,0.6501);

	this.shape_969 = new cjs.Shape();
	this.shape_969.graphics.f("#FFFFFF").s().p("ABHgEIACABIiRAIQBKgIBFgBg");
	this.shape_969.setTransform(155.6097,221.9226,0.6501,0.6501);

	this.shape_970 = new cjs.Shape();
	this.shape_970.graphics.f("#FFFFFF").s().p("AAAABIAAgCIACAAIAAACg");
	this.shape_970.setTransform(136.4168,220.6713,0.6501,0.6501);

	this.shape_971 = new cjs.Shape();
	this.shape_971.graphics.f("#FFFFFF").s().p("AgfAAQAUgCAIACIAjAAQgPACgOAAQgRAAgRgCg");
	this.shape_971.setTransform(223.9467,220.864,0.6501,0.6501);

	this.shape_972 = new cjs.Shape();
	this.shape_972.graphics.f("#FFFFFF").s().p("AgKABIACgBIATABg");
	this.shape_972.setTransform(219.9163,220.6875,0.6501,0.6501);

	this.shape_973 = new cjs.Shape();
	this.shape_973.graphics.f("#FFFFFF").s().p("AgEABIABgBIAIABg");
	this.shape_973.setTransform(218.6,220.6875,0.6501,0.6501);

	this.shape_974 = new cjs.Shape();
	this.shape_974.graphics.f("#FFFFFF").s().p("AgHAAQAUgJAOABQgKAHgQADIgbAHQAFgGAOgDg");
	this.shape_974.setTransform(143.6811,220.6519,0.6501,0.6501);

	this.shape_975 = new cjs.Shape();
	this.shape_975.graphics.f("#FFFFFF").s().p("AgBABQABgBAAAAQAAAAAAAAQAAAAABAAQAAAAABAAIAAABg");
	this.shape_975.setTransform(267.1916,219.8912,0.6501,0.6501);

	this.shape_976 = new cjs.Shape();
	this.shape_976.graphics.f("#FFFFFF").s().p("AAKgBIABABQgGACgPAAQAIgCAMgBg");
	this.shape_976.setTransform(154.6996,223.2715,0.6501,0.6501);

	this.shape_977 = new cjs.Shape();
	this.shape_977.graphics.f("#FFFFFF").s().p("AgkABIACgCQArAAAcADQgbgCguABg");
	this.shape_977.setTransform(160.7613,219.81,0.6501,0.6501);

	this.shape_978 = new cjs.Shape();
	this.shape_978.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_978.setTransform(266.2165,219.5012,0.6501,0.6501);

	this.shape_979 = new cjs.Shape();
	this.shape_979.graphics.f("#FFFFFF").s().p("AAAgEIADAIQgJgDAGgFg");
	this.shape_979.setTransform(145.7219,219.0787,0.6501,0.6501);

	this.shape_980 = new cjs.Shape();
	this.shape_980.graphics.f("#FFFFFF").s().p("AgBABIAAgBIADAAIAAABg");
	this.shape_980.setTransform(144.965,218.7861,0.6501,0.6501);

	this.shape_981 = new cjs.Shape();
	this.shape_981.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_981.setTransform(165.4255,218.4611,0.6501,0.6501);

	this.shape_982 = new cjs.Shape();
	this.shape_982.graphics.f("#FFFFFF").s().p("AAAAEIAAgHIABAAIAAAHg");
	this.shape_982.setTransform(164.5804,218.4449,0.6501,0.6501);

	this.shape_983 = new cjs.Shape();
	this.shape_983.graphics.f("#FFFFFF").s().p("AguAAQAmgFA2AFQgOADgXAAQgWAAghgDg");
	this.shape_983.setTransform(247.2511,218.1767,0.6501,0.6501);

	this.shape_984 = new cjs.Shape();
	this.shape_984.graphics.f("#FFFFFF").s().p("AAAgBIAAACIAAABg");
	this.shape_984.setTransform(145.225,218.0711,0.6501,0.6501);

	this.shape_985 = new cjs.Shape();
	this.shape_985.graphics.f("#FFFFFF").s().p("AADgQQAEAGgEAKQgFAMgCAFg");
	this.shape_985.setTransform(104.686,218.5749,0.6501,0.6501);

	this.shape_986 = new cjs.Shape();
	this.shape_986.graphics.f("#FFFFFF").s().p("AgCAEQgBgJAGADQgDADAAADg");
	this.shape_986.setTransform(110.6498,217.4789,0.6501,0.6501);

	this.shape_987 = new cjs.Shape();
	this.shape_987.graphics.f("#FFFFFF").s().p("AAAABIAAgCIABAAIAAACg");
	this.shape_987.setTransform(265.6477,216.9335,0.6501,0.6501);

	this.shape_988 = new cjs.Shape();
	this.shape_988.graphics.f("#FFFFFF").s().p("AgEgXQACAHAFABQAFAVgGASQADgQgJgfg");
	this.shape_988.setTransform(141.8262,218.5099,0.6501,0.6501);

	this.shape_989 = new cjs.Shape();
	this.shape_989.graphics.f("#FFFFFF").s().p("AAAADIAAgFIABAAIAAAFg");
	this.shape_989.setTransform(164.2554,216.9172,0.6501,0.6501);

	this.shape_990 = new cjs.Shape();
	this.shape_990.graphics.f("#FFFFFF").s().p("AAAABQAEgEgDgEQAFADAAAHIgLAFQAAgCAFgFg");
	this.shape_990.setTransform(144.8837,216.9497,0.6501,0.6501);

	this.shape_991 = new cjs.Shape();
	this.shape_991.graphics.f("#FFFFFF").s().p("AAAgEIACAAIgDAIg");
	this.shape_991.setTransform(266.9478,216.2509,0.6501,0.6501);

	this.shape_992 = new cjs.Shape();
	this.shape_992.graphics.f("#FFFFFF").s().p("AgBgEIADAFIAAAEg");
	this.shape_992.setTransform(104.044,215.8771,0.6501,0.6501);

	this.shape_993 = new cjs.Shape();
	this.shape_993.graphics.f("#FFFFFF").s().p("AABgEIAAAHIgBACg");
	this.shape_993.setTransform(267.9391,215.2271,0.6501,0.6501);

	this.shape_994 = new cjs.Shape();
	this.shape_994.graphics.f("#FFFFFF").s().p("AADgMQACAEgEAIQgDAJABAEQgEgJAIgQg");
	this.shape_994.setTransform(265.9396,215.6821,0.6501,0.6501);

	this.shape_995 = new cjs.Shape();
	this.shape_995.graphics.f("#FFFFFF").s().p("AAAACIAAgEIABAAIAAAEg");
	this.shape_995.setTransform(107.1481,214.8858,0.6501,0.6501);

	this.shape_996 = new cjs.Shape();
	this.shape_996.graphics.f("#FFFFFF").s().p("AAAAEIAAgHIABAAIAAAHg");
	this.shape_996.setTransform(206.8665,214.4308,0.6501,0.6501);

	this.shape_997 = new cjs.Shape();
	this.shape_997.graphics.f("#FFFFFF").s().p("AgLACQADgFACgKQALgCAGAJQACAKgJAKIgCAAQgGAAgHgMg");
	this.shape_997.setTransform(105.8755,215.0385,0.6501,0.6501);

	this.shape_998 = new cjs.Shape();
	this.shape_998.graphics.f("#FFFFFF").s().p("AACgEIAAAFIgDADg");
	this.shape_998.setTransform(101.1188,214.2683,0.6501,0.6501);

	this.shape_999 = new cjs.Shape();
	this.shape_999.graphics.f("#FFFFFF").s().p("AABgCIAAADIgBACg");
	this.shape_999.setTransform(264.8839,214.057,0.6501,0.6501);

	this.shape_1000 = new cjs.Shape();
	this.shape_1000.graphics.f("#FFFFFF").s().p("AAAACIAAgDIABAAIAAADg");
	this.shape_1000.setTransform(264.4614,213.5532,0.6501,0.6501);

	this.shape_1001 = new cjs.Shape();
	this.shape_1001.graphics.f("#FFFFFF").s().p("AABAMQgCgJgIgBQgCgBADgFQACgFgEgBIAGgJQALATACAHIACANIgBAAQgHAAgCgIg");
	this.shape_1001.setTransform(144.6725,214.678,0.6501,0.6501);

	this.shape_1002 = new cjs.Shape();
	this.shape_1002.graphics.f("#FFFFFF").s().p("AgBACIAAgCIADAAIAAACg");
	this.shape_1002.setTransform(166.1243,212.8706,0.6501,0.6501);

	this.shape_1003 = new cjs.Shape();
	this.shape_1003.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_1003.setTransform(243.1396,212.7569,0.6501,0.6501);

	this.shape_1004 = new cjs.Shape();
	this.shape_1004.graphics.f("#FFFFFF").s().p("AgFABQAHgHAEAJg");
	this.shape_1004.setTransform(144.77,212.7956,0.6501,0.6501);

	this.shape_1005 = new cjs.Shape();
	this.shape_1005.graphics.f("#FFFFFF").s().p("AAAACIAAgDIABAAIAAADg");
	this.shape_1005.setTransform(265.4039,212.3831,0.6501,0.6501);

	this.shape_1006 = new cjs.Shape();
	this.shape_1006.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_1006.setTransform(108.3344,211.9281,0.6501,0.6501);

	this.shape_1007 = new cjs.Shape();
	this.shape_1007.graphics.f("#FFFFFF").s().p("AACgQIgCAfIgBACg");
	this.shape_1007.setTransform(208.1991,211.8956,0.6501,0.6501);

	this.shape_1008 = new cjs.Shape();
	this.shape_1008.graphics.f("#FFFFFF").s().p("AgBABIAAgBIACAAIAAABg");
	this.shape_1008.setTransform(165.0517,208.5478,0.6501,0.6501);

	this.shape_1009 = new cjs.Shape();
	this.shape_1009.graphics.f("#FFFFFF").s().p("AACgfQADAsgGATIADg/g");
	this.shape_1009.setTransform(243.2176,210.3842,0.6501,0.6501);

	this.shape_1010 = new cjs.Shape();
	this.shape_1010.graphics.f("#FFFFFF").s().p("AAEgEIAAAFQgEAAAAABIgDADQgBAAAIgJg");
	this.shape_1010.setTransform(268.5235,208.1289,0.6501,0.6501);

	this.shape_1011 = new cjs.Shape();
	this.shape_1011.graphics.f("#FFFFFF").s().p("AAAAHIAAgNIABAAIAAANg");
	this.shape_1011.setTransform(241.0106,208.304,0.6501,0.6501);

	this.shape_1012 = new cjs.Shape();
	this.shape_1012.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_1012.setTransform(241.1569,206.8089,0.6501,0.6501);

	this.shape_1013 = new cjs.Shape();
	this.shape_1013.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_1013.setTransform(240.8156,205.0537,0.6501,0.6501);

	this.shape_1014 = new cjs.Shape();
	this.shape_1014.graphics.f("#FFFFFF").s().p("AgCgLIAFAOIAAAJg");
	this.shape_1014.setTransform(243.2371,203.6724,0.6501,0.6501);

	this.shape_1015 = new cjs.Shape();
	this.shape_1015.graphics.f("#000000").s().p("AwZJzIgBgJQgfgGg/AFQg9AHghgJQgLgDgkACQgfADgPgKQgOAAgQgKIgcgSQgQgPgkgHQgsgIgMgGQgkgJg8AHQgMAFgYgBQgYAAgMAEQgBgFgWAHIgwgLIgDgEIAHgCQAEgCABgEQgEgFgNABQgMAAgCgGQARgCgIgIQgCgCgFgSQgEgLgNAFQgHgJALgCQAEABAJgEQAAgDgGgEQgSAHgpgEIAAgHQAOgCABgCIAAgDIAQAAIAIAAIANgHQgQgCgkAFIAAgFIA2gJQABgHAEgCIgdgEQgBgIALACQALAAgDgKQADgBASAAQANAAADgLQgLAEgHgLQgHgJgMAHQgVADgHgFIAAgDQAHgEAbgBQAWAAAJgKQAQgCgBgFIgYABIgagDQgCgGgJAAQgJABgDgEIA6gKQgFgEgNACQgLABgCgIQADgCAKAAQAIgBAEgEQgKAAADgKIABgBIgagEQgBgCAEgGQAyAAAPgGQgVgBgJgDQAAgFgrgFQgqgFABgFQAKgCAAgCQACgFgHgDIgCAAIAAgGIAmgCQAAgBgGgGIguAAQgDgHAGgBIAJgCIAWgCIgHgFQgEgCACgEQALgJAFAFQAAAFACABQACAAAFgEIAAgQIgbgEIAAgFQAIgDATgBQADgIgvgFQgtgEAKgMQACAAABgLQgBgEgGADQgEAAABgFQAHgLgCgCIgQgCQAGgKgMgLQARACgEgLQAFgHALACQgCgCgIgBQgGAAgBgEQgDgIAGgKQABgCAFAAQAFAAAAgEQgCgBgKAAQgIAAAAgGIAAgFQAKACANgFQAPgGAHgCIgdgEQABgKgGABQgDABADgFQgEgEgKgBQgKgCgEgFIAAgHQADAAAOAEQAKAEAFgIQABgCgHgIQgJAEgIgHIgNgLQACgDANAAQAJAAgIgKQAAgCAEgCQAFgBAHgGQAGgGAGAEIADgIIgJgBQgFgJAKgEQALgDgEgKQAHgHgBgLIgJgCQgCgFAIgFIAMgEQgHgDAEgMIANgDQgEgJAEgJQgBADAFADQABgMAKACQAOABAEgCQB3gBA6AEQAJgDATAAQAVABAHgEQgPgiAPgPQASgIAOAWIAJAaQAJAAA1gTQAmgNAZAPQAFABAFgIQAFgIAGACQAdg2AIgRQgDgKgYgIQgCAAgRADQgMADgFgKQAJgyAbgLQACASAKADQAeAKAMgNQAAgFAGgHIgJgNQgEgHAHgFQAOgOAiARQAMAOgCAIQgZASACAJQACACACAUIAbAQQAQAKAOgIQAAANgRAmQgNACgUgNQgUgOgOACQgMARgMAtQAOAGgCAHIAqgFQAagFAOgNQAfgJAtALQA4AOATAAIADADQACABAYAAIAaACIA4ABQAhAAAYgCIAagDQAPgEgBgIIgCgNQgDgbADgQQAKgYAYAKQARAogBAWQAEALAMgEIATgFQAWgTAAgCQABgNgCgqQgCgfAHgWIAJgGQAAgMAXgHQAFADAYAGQASAEAFAOQAMA3gDAfQAEgBAPAFQAMADAIgEQAbgJAlgCIBFAAIADgDQgKgwgNhjQAggyAxgLQAsgGAPAPQASAWADAnQABAKgCA5QgDAwABAXQgCABgBALQAIAGARABQAUACAHACQA3AGBdgIQBxgHAkAAQAfgCBHgTQBAgQApABIATAAQAOhRAMgVQAsgUAaAbQAJAXgGAeQgLAjgDAQQAxANBIAIIB+AMQADgEAMAEQAbAGAggIIA2gSQgBgngEhSQgBhHASgvQAJgSAWgLQANgHAagLIAAgBIAGAAQACAFAGgDQAHgFAEADQARAKAIAIQAIABAFAKIAJARQAGAlgEBBQgEBCADAfQAxgBBGAYQBTAdAfAEQADgDACgLQABgJAHgBQAQgBADgSIAEghQgHgJAJgVIAJhGQAEgJAGgWQAIgSAQgDQALAFAJgJQALgMAFgBQAGgJAOgZIgLgEQAAgLgHgYQgIgVACgOQgDgMgNgXIAIAAQAjAmANAUQAFgFAGgUQAGgPAKgEQANAJgDATIgDAhQALgKAbgFQAbgGAKgKIAGAAQgCANgUANQgYAPgEALQgDAMgeASQABAFgCAPQgBALAIAFQgHARAQAKQAHAEgDAMIgGAUQgCAdgPAmQgUApgIAWIgGAMQgEAJAIADQALAAAEAGQgDABAAAEIAEAEQC5AMAhgLIAFAEQA+AFA/gKIAEAFIgBABQAEADAYgBQASAAAGAOQAhACAWALQgFACAOADQAEgBAPAFQAIAAAhALQALABgCAEQgGAGAJALIANAEQgKAPANACQALgCAKAKQg5AbA8AEIAxADQAfAGAIATQhAA0gBAGQAAAFARAPQAOANgLAMIAaAJQAPAGAEAMQgMANgmADQhlAKAlAWQgIAMgTACQAJgBAJAJQAKAIAHAAIAAAEQgegEgKALIAiAGQgDAFgKABIgSADQADAEAHgBQAIgBABAEQgLADgbACQABAEAQAAQAOgBgEAMQACAHAJACIgEAJQAaADAGAIQgKABgDAGQAEAFAGABIAMADQABAFAPANQgJAIgWgBQgXAAgJAFQAGACAbgBQAVAAAJAKIASAEQABABgGAEIgGAAQgEANAPADIgFAIIAJACQABAFgFACQgGABgBABIACAIQgDACgIADIAKADQAGABACAFQgEAEgPAAQgNgBgEAJIgSABIAFAFQAmgGASAEIgiAMIgFAGIgOAGQAAAJgOADQgQADgDAEQARAAAEAIQgFAFgMAEQgPADgFAEQAZgDAGAKQgTADACALQgZADgHADIAOAAQABAAAAAAQAAAAAAAAQAAABgBAAQgBAAgBABIgGADQgLgDgIAKQgJALgIgCQAEAGgBACIgFAFQAEAEgBADQgKADgdACQgZABgNAFIADAEIBAgCIAFAFQgCAFgJAAQgLABgDABQAFACAAAHIAAALQggAOgfAAQghAAgKAIIiWAKQgHgEgKABIgTADQgfAEi3ACQg0AIhjABQi9gEjEgLQgMAJgWgBIgmgEQgQgBhFACQg1ACgigKQgPgCgZAEQgcAGgNgBIgFgJQgaAGgrAAQgtgBgYAEQgXADg9ACQg0ABgeAHIgMgCIAAgCQgiAAj9ANQgsAMhpAAQgHgDgNAAQgOAAgHgFQgTADg3gCQgvgCgaAIQAgAHAQgDQgeAKgagEQgigEgWADQgHgFgQgDQgRgCgHgGQgnAGgHAIQgJAKglAFIgOAAQgKABgFAEQg7AAiAgFg");
	this.shape_1015.setTransform(190.1601,235.33,0.6501,0.6501);

	this.shape_1016 = new cjs.Shape();
	this.shape_1016.graphics.f("#FFFFFF").s().p("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");
	this.shape_1016.setTransform(190.2738,233.3425,0.6501,0.6501);

	this.shape_1017 = new cjs.Shape();
	this.shape_1017.graphics.f("#FFFFFF").s().p("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");
	this.shape_1017.setTransform(189.5588,233.3425,0.6501,0.6501);

	this.playButton = new lib.PlayButton();
	this.playButton.setTransform(138.3,294.35,0.6501,0.6501);
	new cjs.ButtonHelper(this.playButton, 0, 1, 2, false, new lib.PlayButton(), 3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.playButton},{t:this.shape_1017},{t:this.shape_1016},{t:this.shape_1015},{t:this.shape_1014},{t:this.shape_1013},{t:this.shape_1012},{t:this.shape_1011},{t:this.shape_1010},{t:this.shape_1009},{t:this.shape_1008},{t:this.shape_1007},{t:this.shape_1006},{t:this.shape_1005},{t:this.shape_1004},{t:this.shape_1003},{t:this.shape_1002},{t:this.shape_1001},{t:this.shape_1000},{t:this.shape_999},{t:this.shape_998},{t:this.shape_997},{t:this.shape_996},{t:this.shape_995},{t:this.shape_994},{t:this.shape_993},{t:this.shape_992},{t:this.shape_991},{t:this.shape_990},{t:this.shape_989},{t:this.shape_988},{t:this.shape_987},{t:this.shape_986},{t:this.shape_985},{t:this.shape_984},{t:this.shape_983},{t:this.shape_982},{t:this.shape_981},{t:this.shape_980},{t:this.shape_979},{t:this.shape_978},{t:this.shape_977},{t:this.shape_976},{t:this.shape_975},{t:this.shape_974},{t:this.shape_973},{t:this.shape_972},{t:this.shape_971},{t:this.shape_970},{t:this.shape_969},{t:this.shape_968},{t:this.shape_967},{t:this.shape_966},{t:this.shape_965},{t:this.shape_964},{t:this.shape_963},{t:this.shape_962},{t:this.shape_961},{t:this.shape_960},{t:this.shape_959},{t:this.shape_958},{t:this.shape_957},{t:this.shape_956},{t:this.shape_955},{t:this.shape_954},{t:this.shape_953},{t:this.shape_952},{t:this.shape_951},{t:this.shape_950},{t:this.shape_949},{t:this.shape_948},{t:this.shape_947},{t:this.shape_946},{t:this.shape_945},{t:this.shape_944},{t:this.shape_943},{t:this.shape_942},{t:this.shape_941},{t:this.shape_940},{t:this.shape_939},{t:this.shape_938},{t:this.shape_937},{t:this.shape_936},{t:this.shape_935},{t:this.shape_934},{t:this.shape_933},{t:this.shape_932},{t:this.shape_931},{t:this.shape_930},{t:this.shape_929},{t:this.shape_928},{t:this.shape_927},{t:this.shape_926},{t:this.shape_925},{t:this.shape_924},{t:this.shape_923},{t:this.shape_922},{t:this.shape_921},{t:this.shape_920},{t:this.shape_919},{t:this.shape_918},{t:this.shape_917},{t:this.shape_916},{t:this.shape_915},{t:this.shape_914},{t:this.shape_913},{t:this.shape_912},{t:this.shape_911},{t:this.shape_910},{t:this.shape_909},{t:this.shape_908},{t:this.shape_907},{t:this.shape_906},{t:this.shape_905},{t:this.shape_904},{t:this.shape_903},{t:this.shape_902},{t:this.shape_901},{t:this.shape_900},{t:this.shape_899},{t:this.shape_898},{t:this.shape_897},{t:this.shape_896},{t:this.shape_895},{t:this.shape_894},{t:this.shape_893},{t:this.shape_892},{t:this.shape_891},{t:this.shape_890},{t:this.shape_889},{t:this.shape_888},{t:this.shape_887},{t:this.shape_886},{t:this.shape_885},{t:this.shape_884},{t:this.shape_883},{t:this.shape_882},{t:this.shape_881},{t:this.shape_880},{t:this.shape_879},{t:this.shape_878},{t:this.shape_877},{t:this.shape_876},{t:this.shape_875},{t:this.shape_874},{t:this.shape_873},{t:this.shape_872},{t:this.shape_871},{t:this.shape_870},{t:this.shape_869},{t:this.shape_868},{t:this.shape_867},{t:this.shape_866},{t:this.shape_865},{t:this.shape_864},{t:this.shape_863},{t:this.shape_862},{t:this.shape_861},{t:this.shape_860},{t:this.shape_859},{t:this.shape_858},{t:this.shape_857},{t:this.shape_856},{t:this.shape_855},{t:this.shape_854},{t:this.shape_853},{t:this.shape_852},{t:this.shape_851},{t:this.shape_850},{t:this.shape_849},{t:this.shape_848},{t:this.shape_847},{t:this.shape_846},{t:this.shape_845},{t:this.shape_844},{t:this.shape_843},{t:this.shape_842},{t:this.shape_841},{t:this.shape_840},{t:this.shape_839},{t:this.shape_838},{t:this.shape_837},{t:this.shape_836},{t:this.shape_835},{t:this.shape_834},{t:this.shape_833},{t:this.shape_832},{t:this.shape_831},{t:this.shape_830},{t:this.shape_829},{t:this.shape_828},{t:this.shape_827},{t:this.shape_826},{t:this.shape_825},{t:this.shape_824},{t:this.shape_823},{t:this.shape_822},{t:this.shape_821},{t:this.shape_820},{t:this.shape_819},{t:this.shape_818},{t:this.shape_817},{t:this.shape_816},{t:this.shape_815},{t:this.shape_814},{t:this.shape_813},{t:this.shape_812},{t:this.shape_811},{t:this.shape_810},{t:this.shape_809},{t:this.shape_808},{t:this.shape_807},{t:this.shape_806},{t:this.shape_805},{t:this.shape_804},{t:this.shape_803},{t:this.shape_802},{t:this.shape_801},{t:this.shape_800},{t:this.shape_799},{t:this.shape_798},{t:this.shape_797},{t:this.shape_796},{t:this.shape_795},{t:this.shape_794},{t:this.shape_793},{t:this.shape_792},{t:this.shape_791},{t:this.shape_790},{t:this.shape_789},{t:this.shape_788},{t:this.shape_787},{t:this.shape_786},{t:this.shape_785},{t:this.shape_784},{t:this.shape_783},{t:this.shape_782},{t:this.shape_781},{t:this.shape_780},{t:this.shape_779},{t:this.shape_778},{t:this.shape_777},{t:this.shape_776},{t:this.shape_775},{t:this.shape_774},{t:this.shape_773},{t:this.shape_772},{t:this.shape_771},{t:this.shape_770},{t:this.shape_769},{t:this.shape_768},{t:this.shape_767},{t:this.shape_766},{t:this.shape_765},{t:this.shape_764},{t:this.shape_763},{t:this.shape_762},{t:this.shape_761},{t:this.shape_760},{t:this.shape_759},{t:this.shape_758},{t:this.shape_757},{t:this.shape_756},{t:this.shape_755},{t:this.shape_754},{t:this.shape_753},{t:this.shape_752},{t:this.shape_751},{t:this.shape_750},{t:this.shape_749},{t:this.shape_748},{t:this.shape_747},{t:this.shape_746},{t:this.shape_745},{t:this.shape_744},{t:this.shape_743},{t:this.shape_742},{t:this.shape_741},{t:this.shape_740},{t:this.shape_739},{t:this.shape_738},{t:this.shape_737},{t:this.shape_736},{t:this.shape_735},{t:this.shape_734},{t:this.shape_733},{t:this.shape_732},{t:this.shape_731},{t:this.shape_730},{t:this.shape_729},{t:this.shape_728},{t:this.shape_727},{t:this.shape_726},{t:this.shape_725},{t:this.shape_724},{t:this.shape_723},{t:this.shape_722},{t:this.shape_721},{t:this.shape_720},{t:this.shape_719},{t:this.shape_718},{t:this.shape_717},{t:this.shape_716},{t:this.shape_715},{t:this.shape_714},{t:this.shape_713},{t:this.shape_712},{t:this.shape_711},{t:this.shape_710},{t:this.shape_709},{t:this.shape_708},{t:this.shape_707},{t:this.shape_706},{t:this.shape_705},{t:this.shape_704},{t:this.shape_703},{t:this.shape_702},{t:this.shape_701},{t:this.shape_700},{t:this.shape_699},{t:this.shape_698},{t:this.shape_697},{t:this.shape_696},{t:this.shape_695},{t:this.shape_694},{t:this.shape_693},{t:this.shape_692},{t:this.shape_691},{t:this.shape_690},{t:this.shape_689},{t:this.shape_688},{t:this.shape_687},{t:this.shape_686},{t:this.shape_685},{t:this.shape_684},{t:this.shape_683},{t:this.shape_682},{t:this.shape_681},{t:this.shape_680},{t:this.shape_679},{t:this.shape_678},{t:this.shape_677},{t:this.shape_676},{t:this.shape_675},{t:this.shape_674},{t:this.shape_673},{t:this.shape_672},{t:this.shape_671},{t:this.shape_670},{t:this.shape_669},{t:this.shape_668},{t:this.shape_667},{t:this.shape_666},{t:this.shape_665},{t:this.shape_664},{t:this.shape_663},{t:this.shape_662},{t:this.shape_661},{t:this.shape_660},{t:this.shape_659},{t:this.shape_658},{t:this.shape_657},{t:this.shape_656},{t:this.shape_655},{t:this.shape_654},{t:this.shape_653},{t:this.shape_652},{t:this.shape_651},{t:this.shape_650},{t:this.shape_649},{t:this.shape_648},{t:this.shape_647},{t:this.shape_646},{t:this.shape_645},{t:this.shape_644},{t:this.shape_643},{t:this.shape_642},{t:this.shape_641},{t:this.shape_640},{t:this.shape_639},{t:this.shape_638},{t:this.shape_637},{t:this.shape_636},{t:this.shape_635},{t:this.shape_634},{t:this.shape_633},{t:this.shape_632},{t:this.shape_631},{t:this.shape_630},{t:this.shape_629},{t:this.shape_628},{t:this.shape_627},{t:this.shape_626},{t:this.shape_625},{t:this.shape_624},{t:this.shape_623},{t:this.shape_622},{t:this.shape_621},{t:this.shape_620},{t:this.shape_619},{t:this.shape_618},{t:this.shape_617},{t:this.shape_616},{t:this.shape_615},{t:this.shape_614},{t:this.shape_613},{t:this.shape_612},{t:this.shape_611},{t:this.shape_610},{t:this.shape_609},{t:this.shape_608},{t:this.shape_607},{t:this.shape_606},{t:this.shape_605},{t:this.shape_604},{t:this.shape_603},{t:this.shape_602},{t:this.shape_601},{t:this.shape_600},{t:this.shape_599},{t:this.shape_598},{t:this.shape_597},{t:this.shape_596},{t:this.shape_595},{t:this.shape_594},{t:this.shape_593},{t:this.shape_592},{t:this.shape_591},{t:this.shape_590},{t:this.shape_589},{t:this.shape_588},{t:this.shape_587},{t:this.shape_586},{t:this.shape_585},{t:this.shape_584},{t:this.shape_583},{t:this.shape_582},{t:this.shape_581},{t:this.shape_580},{t:this.shape_579},{t:this.shape_578},{t:this.shape_577},{t:this.shape_576},{t:this.shape_575},{t:this.shape_574},{t:this.shape_573},{t:this.shape_572},{t:this.shape_571},{t:this.shape_570},{t:this.shape_569},{t:this.shape_568},{t:this.shape_567},{t:this.shape_566},{t:this.shape_565},{t:this.shape_564},{t:this.shape_563},{t:this.shape_562},{t:this.shape_561},{t:this.shape_560},{t:this.shape_559},{t:this.shape_558},{t:this.shape_557},{t:this.shape_556},{t:this.shape_555},{t:this.shape_554},{t:this.shape_553},{t:this.shape_552},{t:this.shape_551},{t:this.shape_550},{t:this.shape_549},{t:this.shape_548},{t:this.shape_547},{t:this.shape_546},{t:this.shape_545},{t:this.shape_544},{t:this.shape_543},{t:this.shape_542},{t:this.shape_541},{t:this.shape_540},{t:this.shape_539},{t:this.shape_538},{t:this.shape_537},{t:this.shape_536},{t:this.shape_535},{t:this.shape_534},{t:this.shape_533},{t:this.shape_532},{t:this.shape_531},{t:this.shape_530},{t:this.shape_529},{t:this.shape_528},{t:this.shape_527},{t:this.shape_526},{t:this.shape_525},{t:this.shape_524},{t:this.shape_523},{t:this.shape_522},{t:this.shape_521},{t:this.shape_520},{t:this.shape_519},{t:this.shape_518},{t:this.shape_517},{t:this.shape_516},{t:this.shape_515},{t:this.shape_514},{t:this.shape_513},{t:this.shape_512},{t:this.shape_511},{t:this.shape_510},{t:this.shape_509},{t:this.shape_508},{t:this.shape_507},{t:this.shape_506},{t:this.shape_505},{t:this.shape_504},{t:this.shape_503},{t:this.shape_502},{t:this.shape_501},{t:this.shape_500},{t:this.shape_499},{t:this.shape_498},{t:this.shape_497},{t:this.shape_496},{t:this.shape_495},{t:this.shape_494},{t:this.shape_493},{t:this.shape_492},{t:this.shape_491},{t:this.shape_490},{t:this.shape_489},{t:this.shape_488},{t:this.shape_487},{t:this.shape_486},{t:this.shape_485},{t:this.shape_484},{t:this.shape_483},{t:this.shape_482},{t:this.shape_481},{t:this.shape_480},{t:this.shape_479},{t:this.shape_478},{t:this.shape_477},{t:this.shape_476},{t:this.shape_475},{t:this.shape_474},{t:this.shape_473},{t:this.shape_472},{t:this.shape_471},{t:this.shape_470},{t:this.shape_469},{t:this.shape_468},{t:this.shape_467},{t:this.shape_466},{t:this.shape_465},{t:this.shape_464},{t:this.shape_463},{t:this.shape_462},{t:this.shape_461},{t:this.shape_460},{t:this.shape_459},{t:this.shape_458},{t:this.shape_457},{t:this.shape_456},{t:this.shape_455},{t:this.shape_454},{t:this.shape_453},{t:this.shape_452},{t:this.shape_451},{t:this.shape_450},{t:this.shape_449},{t:this.shape_448},{t:this.shape_447},{t:this.shape_446},{t:this.shape_445},{t:this.shape_444},{t:this.shape_443},{t:this.shape_442},{t:this.shape_441},{t:this.shape_440},{t:this.shape_439},{t:this.shape_438},{t:this.shape_437},{t:this.shape_436},{t:this.shape_435},{t:this.shape_434},{t:this.shape_433},{t:this.shape_432},{t:this.shape_431},{t:this.shape_430},{t:this.shape_429},{t:this.shape_428},{t:this.shape_427},{t:this.shape_426},{t:this.shape_425},{t:this.shape_424},{t:this.shape_423},{t:this.shape_422},{t:this.shape_421},{t:this.shape_420},{t:this.shape_419},{t:this.shape_418},{t:this.shape_417},{t:this.shape_416},{t:this.shape_415},{t:this.shape_414},{t:this.shape_413},{t:this.shape_412},{t:this.shape_411},{t:this.shape_410},{t:this.shape_409},{t:this.shape_408},{t:this.shape_407},{t:this.shape_406},{t:this.shape_405},{t:this.shape_404},{t:this.shape_403},{t:this.shape_402},{t:this.shape_401},{t:this.shape_400},{t:this.shape_399},{t:this.shape_398},{t:this.shape_397},{t:this.shape_396},{t:this.shape_395},{t:this.shape_394},{t:this.shape_393},{t:this.shape_392},{t:this.shape_391},{t:this.shape_390},{t:this.shape_389},{t:this.shape_388},{t:this.shape_387},{t:this.shape_386},{t:this.shape_385},{t:this.shape_384},{t:this.shape_383},{t:this.shape_382},{t:this.shape_381},{t:this.shape_380},{t:this.shape_379},{t:this.shape_378},{t:this.shape_377},{t:this.shape_376},{t:this.shape_375},{t:this.shape_374},{t:this.shape_373},{t:this.shape_372},{t:this.shape_371},{t:this.shape_370},{t:this.shape_369},{t:this.shape_368},{t:this.shape_367},{t:this.shape_366},{t:this.shape_365},{t:this.shape_364},{t:this.shape_363},{t:this.shape_362},{t:this.shape_361},{t:this.shape_360},{t:this.shape_359},{t:this.shape_358},{t:this.shape_357},{t:this.shape_356},{t:this.shape_355},{t:this.shape_354},{t:this.shape_353},{t:this.shape_352},{t:this.shape_351},{t:this.shape_350},{t:this.shape_349},{t:this.shape_348},{t:this.shape_347},{t:this.shape_346},{t:this.shape_345},{t:this.shape_344},{t:this.shape_343},{t:this.shape_342},{t:this.shape_341},{t:this.shape_340},{t:this.shape_339},{t:this.shape_338},{t:this.shape_337},{t:this.shape_336},{t:this.shape_335},{t:this.shape_334},{t:this.shape_333},{t:this.shape_332},{t:this.shape_331},{t:this.shape_330},{t:this.shape_329},{t:this.shape_328},{t:this.shape_327},{t:this.shape_326},{t:this.shape_325},{t:this.shape_324},{t:this.shape_323},{t:this.shape_322},{t:this.shape_321},{t:this.shape_320},{t:this.shape_319},{t:this.shape_318},{t:this.shape_317},{t:this.shape_316},{t:this.shape_315},{t:this.shape_314},{t:this.shape_313},{t:this.shape_312},{t:this.shape_311},{t:this.shape_310},{t:this.shape_309},{t:this.shape_308},{t:this.shape_307},{t:this.shape_306},{t:this.shape_305},{t:this.shape_304},{t:this.shape_303},{t:this.shape_302},{t:this.shape_301},{t:this.shape_300},{t:this.shape_299},{t:this.shape_298},{t:this.shape_297},{t:this.shape_296},{t:this.shape_295},{t:this.shape_294},{t:this.shape_293},{t:this.shape_292},{t:this.shape_291},{t:this.shape_290},{t:this.shape_289},{t:this.shape_288},{t:this.shape_287},{t:this.shape_286},{t:this.shape_285},{t:this.shape_284},{t:this.shape_283},{t:this.shape_282},{t:this.shape_281},{t:this.shape_280},{t:this.shape_279},{t:this.shape_278},{t:this.shape_277},{t:this.shape_276},{t:this.shape_275},{t:this.shape_274},{t:this.shape_273},{t:this.shape_272},{t:this.shape_271},{t:this.shape_270},{t:this.shape_269},{t:this.shape_268},{t:this.shape_267},{t:this.shape_266},{t:this.shape_265},{t:this.shape_264},{t:this.shape_263},{t:this.shape_262},{t:this.shape_261},{t:this.shape_260},{t:this.shape_259},{t:this.shape_258},{t:this.shape_257},{t:this.shape_256},{t:this.shape_255},{t:this.shape_254},{t:this.shape_253},{t:this.shape_252},{t:this.shape_251},{t:this.shape_250},{t:this.shape_249},{t:this.shape_248},{t:this.shape_247},{t:this.shape_246},{t:this.shape_245},{t:this.shape_244},{t:this.shape_243},{t:this.shape_242},{t:this.shape_241},{t:this.shape_240},{t:this.shape_239},{t:this.shape_238},{t:this.shape_237},{t:this.shape_236},{t:this.shape_235},{t:this.shape_234},{t:this.shape_233},{t:this.shape_232},{t:this.shape_231},{t:this.shape_230},{t:this.shape_229},{t:this.shape_228},{t:this.shape_227},{t:this.shape_226},{t:this.shape_225},{t:this.shape_224},{t:this.shape_223},{t:this.shape_222},{t:this.shape_221},{t:this.shape_220},{t:this.shape_219},{t:this.shape_218},{t:this.shape_217},{t:this.shape_216},{t:this.shape_215},{t:this.shape_214},{t:this.shape_213},{t:this.instructionsButton},{t:this.shape_212},{t:this.shape_211},{t:this.shape_210},{t:this.shape_209},{t:this.instance_2}]}).to({state:[]},1).wait(4));

	// mm_highscores
	this.highScoresButton = new lib.HighScoresButton();
	this.highScoresButton.setTransform(159.7,319.5,0.6501,0.6501);
	new cjs.ButtonHelper(this.highScoresButton, 0, 1, 2, false, new lib.HighScoresButton(), 3);

	this.timeline.addTween(cjs.Tween.get(this.highScoresButton).to({_off:true},1).wait(4));

	// diffMenu
	this.shape_1018 = new cjs.Shape();
	this.shape_1018.graphics.f("#404040").s().p("AAwC9IgIgOQACgJgIgGQgGgCgJARQAEACAAAFIAAAIQgHgBgEgRQgEgQgLAAIgJANQAEADgCADQgCADgGABQgHAAgCADQACgKgKgKQgJAAgGAVQgFAQgRgMQgGgEACgNQADgNgLgDQgGAFgFANQgGANgHAFQgIgBgEgFQgFgHAFgIQAKgJAGgVQAGgZAFgIQgCgRgGgIQhUAZgngLQgDAOgFAEIgDAIQgKAZgQAEQgKACgWgBQgNAAgBgBQAOgDAJgOQAYglAYANQAGAAADgPQgOgFgKgGIgVgNQgJAMgJAAIgJAJQgbAWgVgGQgMgDgagPQgPgHgBgDQATAGAUgLQARgKASgCQAYgDAKAQQAFACAMgJQgwgjghg0QgfgygpgdQgugggrAHQglAJgEApQgDAVAWASQAhAOAOgSQALgVgGgHQgEgJgHgCQgIgDgEAKIAGASQgBAHgKgHQgLgHgBgGQgDgcAdgCQAcAEAHAdQABALgFAPQgFAQgJAHQgMAJgXABQgWAAgNgIQgfgOgJghQgBARgJAQQgKARgUACQgSADgRgKQgOgJAAgSQAAgTAPgHQgDAPAHALQAIAMAQgFQARgFAAgSQABgPgLgPQgSgag1AAQgmAAgzAaQg8AeAEApQACAPALAJQAMAJAPgHQAJgEAFgIQAFgKgJgGQgIgFgFAIQgHAJgFgBQgEgNAAgCQAAgEALgFQAagMANAQQAJAKgCAQQgBAPgJAKQgVAVgXABQgWAAgQgPQgRgQgCgWQgDgaAPgWQgXAGgqAcQgaANglAGQABAMgFAHIABANQgCAngVAOQgdALgQAJQgRAIgEgBQATgMAGgZQAQg/AoAEQAEgCACgNQhiANgdgxQgNgMgFgVQgIggAOglQAUgsAzgBQARgDAXALQAWAKAJAQQAFAKgBATQgCARgGALQgUAZgegHQgdgRAQgZQADgGAPgCQANgCgDAHIgOAPQAAANAKAAQAIAAAIgHQAJgEgCgaQgFgZgoAAQgfAIgHAXQgOArAiAbQA0AiBVgeQAigMAegWQApgegFgZQgDgNgNgFQgNgGgLAIQgLAGAFAHQAGAHAIgIQAMAMgRAGQgRAFgKgKQgMgLAFgSQAFgRAQgFQAfgKAaAYQAZAYgJAeQAqgjBXgBQA/AAAaAwQAGAMADAKQAFg+ApgOQgIgSgRgGQARgGAUAEQAWADAMANQAcACAiATQAXgKgNgYQAKADAFARQAEARgDAOQATAPAOAOIAxA6QgbgrAZgtQgGgNAGgQQAGgQANgGQgMAJANAZQAngUAnAQIAGADQAigWAOAXQgRgEgNAYQAJAOADARQABAMgGARQgGARgIAGQgmASgVgaQgRgQAJgcQALgLAOADQAOADAAAJQgFAFgGAAQgHgBgDADQgEAKAGAIQAKAMAWgNQAHgKgDgaQgIgWgXAAQgcgEgQARQgPATAEAcQACAMAOAmQAGATAWAWQAVAWAaAMQApASAugPIgFgEQglgoAOhEQAMAKAFgBQAGgGgCgFIgHgLQAPgPgNgRQgMgRAPgPQAyg3BXgMQBNgLBOAbIATASQAKALADAMQgjgFgMAJIgZAYQAHAHAOgJQAQgLAIABQgSAsAJARIAYgqQgPArAAAUQAJgHAHgRIANgcQgiBcgKAUIAKAEQgIAGABADIADADQAHgBADgIQAEgKAFgDQgRAdgOALQA3AcA4gZQAagMAWgWQAVgWAGgTQAOgmACgMQAEgcgOgTQgRgSgcAFQgXAAgIAWQgEAaAIAJQAWAOAKgMQAGgIgEgKQgDgDgGABQgHAAgFgGQAAgIAOgDQAOgDALALQAJAcgQAQQgWAagmgSQgIgFgGgSQgGgRABgMQAEgTAJgOQgNgWgQADQAOgWAjAVIADgCQAngQAnATQAJgWgLgIQAMAEAHAPQAHAPgEANQAZAugaAqIAwg5QAMgNAQgMQgEgOAEgRQAEgTAKgCQgMAZAZAIQAhgUAdgDQAMgQAXgDQAXgEAOANQgOgDgPATIAHADQAgAMAMAxIACgFQAagwA/AAQBXABArAjQgKgeAZgYQAagYAfAKQAQAFAFARQAFASgLALQgLAKgRgFQgRgGANgMQAIAIAFgHQAFgHgKgGQgMgIgNAGQgNAFgDANQgFAZApAeQAeAWAiAMQBVAeA1giQAhgbgOgrQgHgXgegIQgoAAgGAZQgCAaAKAEQAHAHAJAAQAJAAAAgNQgMgMgCgDQgDgHAOACQAOACAEAGQAPAagcAQQggAHgSgZQgHgKgBgSQgCgTAGgKQAIgQAXgKQAWgLARADQAzABAVAsQAOAkgIAhQgFAUgOANQgcAxhigNQABANAFACQAWgDAQAYQAMAQAFAWQAGAZATAMQgDABgRgIQgQgJgdgLQgWgOgCgnIABgNQgFgHABgMQglgGgagNIgfgTQgUgLgOgEQAPAWgDAaQgCAWgRAQQgQAPgVAAQgYgBgUgVQgKgKgBgPQgCgQAJgKQANgQAaAMQALAFABAEIgEAPQgFABgHgJQgGgIgIAFQgJAGAFAKQAFAIAJAEQAPAHAMgJQALgJACgPQAEgpg8geQgygagnAAQg0AAgTAaQgKAPAAAPQABASARAFQAQAFAHgMQAHgLgDgPQAPAHAAATQAAASgOAJQgRAKgSgDQgTgCgKgRQgGgHgDgLQgMAVgVAKQgNAIgWAAQgWgBgNgJQgIgHgFgPQgGgQACgLQAGgcAcgFQAeADgEAbQgBAGgLAHQgKAHAAgHIAGgSQgFgLgIAEQgHADgDAIQgHAHALAUQAOATAhgOQAWgSgDgVQgDgpgmgKQgrgHguAhQgpAcgfAzQgqBDhAAkQhHAohAgfQgygYgOgOQgEABgFAFQgOAQAIAeQALAhAEAPIAAAnIgFABQgFAAgDgFgAgzBDQACAigFAKQAbAOAagOQADgNgLgUQgNgWABgMIgJgKQgXAHACAagAhsgrQgWAPgNAcQgHAiAPANQAPAGAQgMQAKgHAQgPQADgIALgRQAHgQgGgNQgLgPgNAAQgKAAgLAHgAAQg2QgOAEgDANQgHAOAIARIARAZQAqAkArgVQAQgFADgVQgphAgogDQgHADgRACgAE8CZQgLgCgVABQgQgDgKgZIgDgIQgIgGgBgOIAEgEQgCADAEAIQAEAIADABQAYgOAXAlQAKAPAOADIgHAAIgHAAgAFLBYIgIgIQgNgCgJgQIABgGQABAFAJAHQAKAHADgCQAUgfAyAdQAUALATgFQgBABgPAJQgPAFgYANIgIABQgSAAgWgSg");
	this.shape_1018.setTransform(191.0536,20.8831,0.7423,0.7423);

	this.shape_1019 = new cjs.Shape();
	this.shape_1019.graphics.f("#404040").s().p("AC/CoQgbgNgLgTQgGgMACgWQABgWAJgNQAXgfAlAKQAOAIAFAOQAFAOgJAOQgEAHgRADQgRADAEgJQABgDAQgPQAAgQgLAAQgKAAgKAIQgLAFACAfQAHAeAwABQAkgKAJgbQARg0gpghQhAgohkAjQgpAPgkAaQgyAkAHAfQADAOAQAHQAPAHANgJQANgIgGgIQgHgJgJALQgOgPATgGQAVgHAMAMQAPANgHAVQgGAVgTAGQglALgegcQgegdAKgkQgzAqhpABQgoABgXgLQgagNgRgiQgagxAZgoQAMgTAXgDQAWgDAUAMQARAKAAAVQABAXgTAIQAEgRgIgOQgKgOgSAGQgVAGgBAVQAAASANASQAWAgA/AAQAvgBA8geQBIglgFgwQgCgTgNgLQgPgLgSAIQgLAFgFALQgHAMALAHQAKAGAHgJQAIgLAGABQAFAQgBACQAAAFgNAGQggANgPgSQgLgNACgTQACgTALgMQAZgZAcgBQAaAAAUATQASASADAcQAEAegRAbQAPgEAYgPIAmgVQAggQArgIQgBgPAGgIQgBABABgRQACgvAZgQQAQgKAmgOQAWgKADABQgXAPgHAeQgGAagOAUQgUAbgbgDQgFACgCARQB3gRAiA8QAPAPAHAZQAJApgQApQgaA3g9AAIgIABQgRAAgWgKg");
	this.shape_1019.setTransform(261.5983,360.6381,0.6694,0.6694);

	this.shape_1020 = new cjs.Shape();
	this.shape_1020.graphics.f("#404040").s().p("AjrCxQg8AAgag3QgQgqAJgoQAFgYARgQQAig9B2ASQgBgQgGgDQgwAFgThLQgGgegYgPQAEgBAVAKQAnAOAPAKQAaAQACAvQABARgCgBQAHAJgCAOQAmAIAhAQQAyAgAbAIQgSgbAEgeQADgcATgSQAUgTAZAAQAdABAYAZQAMAMACATQABATgKANQgQASgfgNQgNgGgBgFIAEgSQAHgBAIALQAHAJAJgGQALgHgGgMQgFgLgLgFQgTgIgOALQgOALgCATQgFAwBJAlQA8AeAvABQA/AAAWggQANgSgBgSQAAgVgVgGQgTgGgJAOQgJAOAEARQgSgJAAgWQAAgVARgKQAUgMAWADQAXADAMATQAZAogZAxQgSAigaANQgWALgpgBQhpgBgzgqQALAkgeAdQgfAcgkgLQgTgGgGgVQgHgVAOgNQANgMAUAHQAUAGgOAPQgKgLgGAJQgGAIAMAIQAOAJAPgHQAPgHAEgOQAGgfgxgkQgkgagpgPQhggjhAAoQgpAhASA0QAHAbAmAKQAwgBAHgeQACgfgMgFQgJgIgKAAQgMAAABAQQAPAPACADQADAJgQgDQgRgDgFgHQgIgOAFgOQAFgOAOgIQAlgKAXAfQAIANACAWQACAWgHAMQgKATgbANQgWAKgSAAIgIgBg");
	this.shape_1020.setTransform(120.9755,360.6381,0.6694,0.6694);

	this.shape_1021 = new cjs.Shape();
	this.shape_1021.graphics.f("#404040").s().p("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");
	this.shape_1021.setTransform(190.8302,356.804,0.6694,0.6694);

	this.shape_1022 = new cjs.Shape();
	this.shape_1022.graphics.f("#FFFFFF").s().p("Ag4hKQAAgxgxgMIAAgVIBHgyIALAAIBFBGIAADdQAAA2A8ALIAAAMIheAtg");
	this.shape_1022.setTransform(275.7509,125.5504,0.6509,0.6509,-178.2173);

	this.shape_1023 = new cjs.Shape();
	this.shape_1023.graphics.f("#FFFFFF").s().p("ACmDJQAWgVASggQAWgmAAgcQAAgqgXgaQgTgTgUAAIgYAAQgKACgLAIIAADDIhJAAIAAkdQAAgrgLgRQgGgJgFAAIAAgLIBUgnIARAFQgGAQAAAjIAABtQAUgKARgOIANgMQApABAjAdQAvAmAABGQAAA0g3A3QgcAcgcARgAyzC7QAKgKALgPQAUgeAAgdIAAi3QAAgigWgTQgLgJgLgDIAIgRQAeAAA7gaQA8gaArAAQA9AABHBOQBIBOAABAQAAATgUAhQgTAjgfAgQhMBShJAAQgQAAg3gPQg4gKgmAagAwmilQgTAUgBAgIAADQQAABJBFAAQArAAAlg3QAkg3AAg7QAAhCgmg7Qgng6gnAAIAAAAQgeAAgTATgAMzANQAAgggigIIAAgOIAxgiIAHAAIAwAvIAACWQAAAkAoAIIAAAIIhAAhgAGnDBQgcgQAAgMIAAjDIguAAIAAgfIBdhKIAWAAIAAA8IBAAAIAAAtIhAAAIAACgQAAAQAaAIIAaAFIAAAJIhCAngArPC5Qg6giAAhPQAAg5A2gyQAQgQAUgOIARgKQAqAdAiApIh3BjQANAhAmAIQAcAGAegIIAEAGIgwBEQgwgIgXgOgArOBIIA6gxIgLgPQgNgPgPABIAAAAQgeAAALBOgAO6CIIBLghQgLAcAMAVQANAVAgAAQAaAAAPgRQAMgNAAgPQAAg9gyAAQgMAAhCAWIgQgUQgRgZAAgcQAAglAdgaQAggcA3AAQA0AAArAuIhAAdQACgSgLgNQgLgOgXAAQgPAAgMAKQgNALAAASQAAAWANAPQALAOARAAIBZgbQAMAEALANQAXAaAAAsQAAAwgrAdQgkAYgtAAIAAAAQhhAAgghGgAmVDEQgPgIgDgDQgIgMAAgOIhJAvQgOAAgYgUQgagWAAgWQAAguAzgfQAFgDBQgiIgFgRQgLgRgaAAQgSAAgtAVQgHACgGgIQgFgIADgGIBjhGQBeAkAAAdIAACBQAAAVAOAMIAOAJIAAALIg0AiQgFAAgRgKgAnYBRQgWASAAAZQAAASAUADQAWADAUgYIAAg8QgWADgSAOgAJSDIIAAjCQAAgegpgDIAAgLIA1glQAOAAASAQQARAOAIAQIA+guQALAAAMAWQANAYAAAdIhDA1IgIhFQgNACgJAKIAADMgAMriiIBegrIAAA7IheAXg");
	this.shape_1023.setTransform(191.0125,119.025);

	this.shape_1024 = new cjs.Shape();
	this.shape_1024.graphics.f("#7F7F7F").s().p("AgyDVIAAhiIBkAAIAABigAgyBoIAAhiIBkAAIAABigAA+gEIAAhiIBlAAIAABigAgygEIAAhiIBkAAIAABigAiigHIAAhjIBlAAIAABjgAgyhyIAAhiIBkAAIAABig");
	this.shape_1024.setTransform(175.5125,120.1375);

	this.shape_1025 = new cjs.Shape();
	this.shape_1025.graphics.f("#404040").s().p("AhGBgIgBgEIgEgBQgBgGgDgGIgBgIQACgEgDgHIgCgIIgBgjQgCgDABgOQACgEAAgMQgCgbABgBQgCgKAAgVIABgEIgBgIIABgCQACgFADgCIAHACIADgBIAGABIADgBIADABQAAAAABAAQAAgBABAAQAAAAABAAQAAAAABAAQACACADAAIAHgCQAJAAADACIAGgBQAAAAAAAAQABAAAAABQAAAAAAAAQABAAAAABIABA4QAAAggBADIABADIAAASIAAAnQACAFgDADQABAIgBAEIABADQgBAIgDADQgGABgLABIgDgCQgGgBgBACQgDgBgCADIgFgBIgCACIgGgBgAgtBYIABACQALAAAHgCIAAgGIgKAGIgEgBgAgehSQAEAJAAARQgCAEAAACIABACIABAXIABABIABgEIAAgPIgBgCIABgcQAAgMgDgDIgCAAgABKBbQgBgBgFAAIgdADQgEgCgKAAIgBgEQgDAAAAAFQgHAAAAgHIgBgGQgCgFABgJIgBgDIACgFQAEgFAfAAIABAAIANABIAQgBIAFACQABAQADAGIgEARIgFAAgABOA/IgCAOIABAIIgCAEIADACIAEgCIABgKIgDgTIgDgBQgBABAAAAQAAABAAAAQAAABABAAQAAABABAAg");
	this.shape_1025.setTransform(266.955,201.5247,0.6194,0.6194);

	this.shape_1026 = new cjs.Shape();
	this.shape_1026.graphics.f("#404040").s().p("AhUBXQACgGgCgcIACgBIACAQQgCAEAAANQACADAAACIABgBQACgFgCgBQABgGACgCIAAgBQAAgFAEgGIgBgDQgEgBAAgFIgCgbIAAgJQgBgCgBgFQAAABAAAAQAAABgBAAQAAABAAAAQgBAAAAAAQgBAAAAAAQAAAAAAgBQgBAAAAAAQAAgBAAgBIABgDIAAgDIABgDIACADIABgBIAAgEIgEgEIAAgGQAAAAAAgBQgBAAAAgBQAAAAAAgBQAAAAAAgBIADgGQgCgCAAggQABgCgCgEQAAgBAAAAQAAAAABgBQAAAAAAAAQAAAAAAAAQgBgCADgEQACgBAAgEIgCgCIgBAEIgBgCIABgFIgDgPQAIgIADAAIAHACQAEgCAYAAQAEAEALgEQAJAFAAARIgDAJIAAAWQAAAOACADIABAIQAAAJAIAAQADgCAWAAIATAAQAQAAAHgCQAIgBADADQAGAFAAAIIABAMQgCANgCABIgQADQgDgCgFACQgCgDgGACIgDABIgfAAIgFgBQgCABgNgBQgGAAgBADQgGADAAAJQAAAFACAEQgDAUADAMIABAMQAAAEgCACIgaACIgCABIgDgBIgCABQAAAAAAAAQgBAAAAAAQgBAAAAAAQgBAAAAABIgHAAIgBABQgMAAgDgRgAACAQIgBACQAAAFAGAAIAIABIACgBIAFgBQAAAAgBAAQAAAAAAgBQgBAAgBAAQAAAAgBAAQgEAAgJgGgAA+AWIAFAAQAFAAAAgDIAAgEIgDgBQgGAEgBAEgAgHgJIAAACIAFAAIABAAIAAgCIgCgBgABBBgIAAACIABACQAAABAAAAQAAABgBAAQAAAAgBAAQgBAAgBAAIgPgEIgHABIgNABQgCAAgHgDIAAgCIgBgDQADgFgFgGIAAgEIgBAAQAEgOAEgFQAHgCAFABIAEAAQAbAEALgBQAFgBACACIABANQABAKgBAFIABACQAAABAAABQgBAAAAABQAAAAgBAAQAAABgBAAQAAAEgFADIgCgBIgEABQgDAAgDgGgABDg6QgCgBgHACQAAAAgBAAQAAAAgBgBQAAAAAAAAQgBgBAAAAQgCAAgDACQgHAAgMgDIgBAAQgDABgEgDIgDgNIAAgDQAAgGADgMQALgJAIAFIAEAAQAFAAAHgCIAHgBQAKAAAGACQADAEAAAHQgCAGAAADQAAAAAAABQAAAAABAAQAAABAAAAQABABABAAIACAFIgEANIgNADIgDgBgABLhAIABABIADABIABgCIAAgFIgDAAIgCAFgAAYhJQACAGAHADIAAgGQAAgCgHgCg");
	this.shape_1026.setTransform(254.7399,201.0141,0.6194,0.6194);

	this.shape_1027 = new cjs.Shape();
	this.shape_1027.graphics.f("#404040").s().p("AgLBkQgDgDgFACQgCgCgGAAIgFgTQgEgCABgHIgFgKIAAgCIgCgJIgHgMQgGgNAAgDQgCgCgDgGQgBgIgCgCIgJgTQAAgFgKgSQgBAAAAAAQAAgBgBAAQAAgBAAAAQAAgBAAgBQgDgBgBgEQAAgFgFgEIgCgDIAAgBQAAgEgDgGQgEAAAAgGQgDgJgCgCIAAgDIAMgEIABAAIAIgBIADgCIACAAIAWgDQACAAADAEIAAAAIACAFQAJAWACACQAGANABAHQAaBBADABQASAmAFATIAAABQAGAMAAAHQAAAEgIABIgMAAIgEgBIgFAEIgCABIgEgDgAAmAiIAAgCQAAgDgCgCIABgBQAAgDgDgEIgCgCIAAgCIgBgGQgDgEAAgCQgCgCgBgFIgCgGIABgCIAGgPQACgGAHgJQABgFAFgJIAFgKQAAgDAEgGQAFgFADgMQAGgJARgBIADABQADAGAMgGQACAAADADIAAACQgDAEACADQgFAHgBAFQAAAAAAABQAAAAAAAAQgBABAAAAQAAABAAAAIgBACQgEADAAADQgHAAgDAZIgIALIgDAJQgFAHABAEQgCABgHAOQgDAGAAAEIgGALQgBAFgGAGgAA3AEIAAACIABAAQACAAACgEQADgDABgHIgEAFQgBADgCAAQgCACAAACgABSg3IgDAHQgCACgDANIgFAMIACgEQACgFAEgBIgBgCIAEgHQAAgFAEgJIACgEIgCgBQAAAAgBABQAAAAAAABQAAAAgBABQAAABAAAAgABZhbIADAGQABABAAAAQABAAAAABQAAAAABABQAAABAAAAIgBABQgDAIgCADIAAADQAJgVAFgFQgBgCgEAAQgHAAgCADg");
	this.shape_1027.setTransform(241.3299,201.4317,0.6194,0.6194);

	this.shape_1028 = new cjs.Shape();
	this.shape_1028.graphics.f("#404040").s().p("AhUBXQABgFgBgdIACgBIACAQQgCADABAOQABADAAACIABgBQADgFgDgBQACgHABgBIAAgBQAAgFAEgGIgBgDQgEgBgBgFQgDgZACgCIAAgJQgCgCAAgFQAAABAAAAQAAABgBAAQAAABAAAAQgBAAAAAAQgBAAAAAAQAAAAAAAAQAAgBAAAAQgBgBAAAAIABgEIgBgDIACgDIACADIABgBIAAgEIgEgEIAAgGQAAAAgBgBQAAAAAAgBQAAAAAAgBQgBAAAAgBQAAgDAEgDQgDgCAAggQACgCgCgEQAAgBAAAAQAAAAAAgBQABAAAAAAQAAAAABAAQgCgDADgDQABgBABgEIgCgCIgBAEIgBgCIABgFQgDgBAAgOQAGgIAFAAIAHACQAEgCAXAAQAGAEAKgEQAJAFgBARIgCAJIAAAWQAAAPACACIAAAIQAAAJAJAAQADgCAWAAIATAAQAQAAAGgCQAJgBADADQAGAFAAAIIABAMQgCANgCABIgQADQgDgCgFACQgDgDgFACIgEABIgeAAIgFgBQgCABgNgBQgGAAAAADQgHADAAAJQAAAGABADQgCAUADAMIAAAMQAAAEgCACQgTADgHgBIgBABIgCgBIgDABQAAAAgBAAQAAAAAAAAQgBAAAAAAQgBAAgBABIgGAAIAAABQgNAAgDgRgAgvBgIgBACIAEAAQARAAAAgGIgBgHIgBgEIgDAHIgBAAQgBAAgCAFQgCAEgFgDgAABAQIgBACQAAAFAIAAIAHABIACgBIAEgBQAAAAAAAAQAAAAgBgBQAAAAgBAAQgBAAAAAAQgDAAgLgGgAA+AWIAFAAQAFAAAAgDIAAgEIgDgBQgHAEAAAEgAgIgJIAAACIAGAAIABAAIAAgCIgDgBgAAvBiIgIABIgMABQgDAAgGgDIAAgCIgBgDQADgGgFgFIAAgEQACgOAEgFQAIgCAFABIADAAQAbAEAMgBQAFgBABACIABANQABAKgBAFIABACQAAABAAABQAAAAAAABQgBAAAAABQgBAAgBAAQAAAEgDADIgDgBIgDABQgEAAgDgGIgBACIACACQAAABAAAAQAAABgBAAQAAAAgBAAQgBAAgBAAIgBABQgEAAgKgFgABDg6QgCgBgHACQAAAAgBAAQAAAAgBgBQAAAAgBAAQAAgBgBAAQAAAAAAAAQgBAAAAABQgBAAAAAAQgBABAAAAQgIAAgMgDIgBAAQgDABgFgDIgDgNIAAgDIAEgSQAMgJAHAFIAEAAIALgBIAIgCQAKAAAGACQADAEAAAHIgCAJQAAAAAAABQAAAAABABQAAAAAAAAQABABAAAAIADAFIgEANIgNADIgDgBgABLhAIAAABIAEABQAAAAAAAAQAAAAABgBQAAAAAAAAQAAgBAAAAIAAgFIgEAAgAAYhJQABAGAIADIAAgGQAAgCgHgCg");
	this.shape_1028.setTransform(228.1212,201.3238,0.6194,0.6194);

	this.shape_1029 = new cjs.Shape();
	this.shape_1029.graphics.f("#404040").s().p("AhGBgIgBgEIgEgBIgEgMIgBgIQABgEgDgHIgBgIQgBgLAAgXQgCgEABgOQACgEgBgMIAAgcQgCgKABgVIAAgEIgBgIIABgCQADgGACgBIAHACIADgBIAFABIADgBIAEACQAAgBABAAQAAAAAAgBQABAAAAAAQABAAAAAAQADACADAAIAHgCQAJAAADACIAGgBQAAAAAAAAQABAAAAABQAAAAAAAAQABAAAAABIABA4QAAAggBADIABADIAAA5IgBAIQABAIgBAEIABADIgFALQgFABgLABIgDgCIgIABQgDgBgBADIgFAAIgDABIgFgBgAgtBYIABACQAKAAAIgCIgBgGIgKAGIgDgBIgFABgAgehSQAEAHgBATIgBAGIAAACIABAXIABABIACgEIAAgJQgCgCACgEIgBgCIABgcQgBgMgCgDIgCAAgABKBbQgCgBgEAAQgFADgYAAQgEgCgKAAIgCgEQgCAAAAAFQgHAAAAgGIgBgGQgCgIACgHQgBAAAAgBQgBAAAAAAQAAgBAAAAQAAAAAAgBIACgFQADgFAgAAIABAAIAMABIARAAIAFABQAAARAEAFQgCAOgBADIgHAAgABNA/QAAAJgBAFIABAIIgCAEIADACIAEgCIABgKIgDgTIgDgBQgBABAAAAQAAAAAAABQAAABABAAQAAABAAAAg");
	this.shape_1029.setTransform(216.1049,202.1131,0.6194,0.6194);

	this.shape_1030 = new cjs.Shape();
	this.shape_1030.graphics.f("#404040").s().p("AgTBgIAAgBQACgDAGgDIAAgBIgDgBQgBADgFACIgDACIgIACIgDAAIgBgMQAAgFABgBIABgHIgCgUQAAgIABgCQgBgEABgIQABgGAAgRIgBgHIAAgKQgBgHAEgDQgDgIgBgPIAAgEIgDgBQgIAEgOgBQgCgCgEABIgDAAIgHgDQgBgEABgCIgBgMQgBgRAFgDQADgCATgBQAGgCADABQAHAAAAgCIALgBIAWABIAagBQANAEAIgFQADABAEAAIAPAAQAKAAACAPIAAATIgEAKIgCADQAAAAgBAAQAAAAAAgBQAAAAAAgBQAAgBAAAAQAAgBgBAAQAAAAAAAAQgBgBAAAAQgBAAAAAAQgBAHABADIgEAFIgFAAIgNgGQgFgDgBgDIgBAAIgCABIgIAAQgIAGADAeIgCARQgIAQAAAWIAAAKIgBAEIACACQAFAAAAgHQACACAAADQgBACAAAQIgBARIgDABIAAgEIgBgCQAAAAgBAAQAAAAgBABQAAAAgBAAQAAABgBAAQAAACgJACIgEAAQgDgBgDACQgFACgCABIgEABgAgeAWQAAANgCAXIACACQACgCAAgDIABAAQAAAAAAgBQAAAAABAAQAAAAAAAAQAAAAAAAAIAAgFQgBgBAAgFQgCgFACgNQABgNgDgFQgBAEAAALg");
	this.shape_1030.setTransform(198.8841,202.0976,0.6194,0.6194);

	this.shape_1031 = new cjs.Shape();
	this.shape_1031.graphics.f("#404040").s().p("AhTBjQgGgBgLAAIgDAAIgFABIgLAAQgEABgCgDIAAgCQgBgEAEgFIAHgOQADgJAHABQABgIAEgDIABgDQAAgHAIgGQABgDAFgJIADgIIAMgXIAEgEIAEgJQAGgFAJgSQAEgOAEAAQADgBACAEQABAFAFAHQAFAFgBAEIAKATQACAFACADIAAAAIADAFIAHAPQAEAMABAIQACAJAEACQAAAEADADQAEAGAAAEQAAABgBABQAAABAAAAQAAABAAAAQgBABAAAAIgGABQgZAAgGgCQAAAAgBAAQAAgBAAAAQgBgBAAAAQAAgBAAgBIgBAAIAAABQgBABgBAAQAAABAAABQgBAAABABQAAAAAAABIgFgBQgGAAgFAEQgDABgBACIgCAFQgDACAAAGIgEADQgCACgCAEIgBAAQgDAAgCADQgCgCgFABIgDAAIgCACgAhwBPQgFAFAAAFQgCABAAADIAAADIAGAAIABgBQAAgBgBAAQAAgBAAAAQgBgBAAAAQgBgBAAAAQAAgIAMgSIAAAAIgJAOgAhhBQIAAADIACAAQAAAAABAAQABAAAAAAQABgBAAAAQAAAAAAgBIAAgIQgDACgCAFgAghBBIACABIAAAAIgBgCgAgKA+IAGADIAEgCIAAgBIgDgDQgDAAgEADgABGBeIAAgBQgFgEADgCQAAgEgEgFQgIgHAAgHQgCgCgBgGQgEgBgDgLIABgDIgBgCIgCAAQgEgDADgCIAAgDIgBAAQgGAAgDgIIgCgHQgDgCAAgFIgFgKIgDgFIABgDIgDgEQgEgCAAgIQAAAAAAAAQgBgBAAAAQAAgBgBAAQgBgBAAgBIgBgGQAAAAAAAAQAAgBgBAAQAAAAAAAAQgBgBAAAAQgCAAAAgGQAAAAAAgBQAAAAAAgBQgBAAAAAAQAAAAgBgBQgEgIAAgEQgEgBgBgHQgEgFAAgLQgDgBgBgGQACgNATAAIAJABQAKAAAEgBIAQABIAEACQACADAAADQADAHAEADQADAJAEAGIgBABQAGAHAAAFQAMAOACANIARAiQASAaAAATIACACQADAFAAACQgFAEgBAEQAHAGAAAMIgBAHQgEABgFACIgFgDQAAABgBAAQAAABAAAAQgBABAAAAQgBAAAAAAIgFAAIgHAAQgCAAgFAAIgDgDQgGABgBACIgCABQgDAAgFgFgAgHhYQAAAGAEAAIAAgBIABgDQgCgEgCAAg");
	this.shape_1031.setTransform(186.4027,202.0666,0.6194,0.6194);

	this.shape_1032 = new cjs.Shape();
	this.shape_1032.graphics.f("#404040").s().p("AgRBgIAAgBIAJgGIgBgBIgCgBQgCAEgEABIgEADIgIABIgCAAIgBgLQAAgFABgCIAAgHIgCgUQAAgJABgBQgBgEABgIQACgGgBgRIgBgHIABgKQgBgHADgDQgDgIAAgQQgBAAAAAAQgBgBAAAAQAAgBAAAAQAAgBABgBIgEABIgDAAQgIADgPgBQgCgCgDABIgEABIgGgDQgBgFABgCIgCgLQAAgSAFgDQADgCATAAIAJgBQAHgBADgCQAIgBAFABIAVABIAbgCQAMAEAIgFQADACAFgBIAOAAQALAAABAOIAAAUIgDALIgCACQgBAAAAAAQAAAAgBgBQAAAAAAgBQAAgBAAgBQAAAAAAAAQAAAAgBgBQAAAAgBAAQAAAAgBgBQAAAIABADIgEAFIgFAAIgNgHQgFgCgBgDIgBAAIgDABIgIABQgHAFACAeIgBASQgIAQAAAVIAAAKIgBADIACAEQAEAAAAgIQADACAAACQgCADAAAPIAAARIgDACIAAgEIgBgBQgBgBAAAAQgBABAAAAQgBAAAAAAQgBABAAAAQAAACgKACIgDgBQgDAAgDACQgGABgBACIgFABgAgcAXQABANgCAWIACACQABgBAAgFIABAAQAAAAABAAQAAAAAAAAQAAAAAAAAQABAAAAgBIAAgEQgBgBAAgFQgCgFABgNQACgNgDgFQgCAFAAALg");
	this.shape_1032.setTransform(166.7063,202.4692,0.6194,0.6194);

	this.shape_1033 = new cjs.Shape();
	this.shape_1033.graphics.f("#404040").s().p("AArBhIgFgBQgDAAAAgFIACgEQAAgCgDgEIgGgDQAAAAAAAAQgBAAAAAAQAAABgBAAQAAABAAABQAAAAgBAAQAAgBAAAAQAAAAAAgBQAAAAAAgBQAAAAAAgBQAAAAgBAAQAAAAAAAAQAAAAgBAAQgIgHAAgCIABgBIAAgBQACAEACAAIABAAIAAgCIgBgGIgMgGQAAgFgJgIIAAAAQgBAAAAAAQgBAAAAgBQAAAAAAgBQAAgBAAgBQAAgCgDgEIgBgCIgCACIgBgFIACgBQgBAAAAgFQAAgJAQgCQAKgBAGgSIADgGQAAgEADgFIAAgDIgCgEQgCgJgCgCQAAgEgGgGIgGgCQgBgBAAAAQAAgBAAAAQgBgBAAAAQgBAAAAAAIgBAAQAAAAAAABQAAAAgBAAQAAABAAAAQgBAAAAAAQgFAAgHgGQgFgBgCgEIgBgDIACgGQAAgJgCgFIAGgGIAIgBIAFABIAUgDQAAAAABAAQABABAAAAQABAAAAABQAAAAABABIALgCIAGAAQAIACAFAAQAPgBAHAFQgBAFgCAAIAAABIAAABIAGADIAAAAQADAEgBADIABABIAFAAQACAHACADQAIAQAAAJIgCATIgMALQgFABgBAFQgDACgEAAQgHAEAAAEIgDgBQgCAAgEAFQAAADgGAAQgGACAAADIABABIAAAAQABAFADAAIABAAIACgEIAEAGIgCAFIAEAAIACAAIADABIABABIgCACIAEAFQAEAKAFABQADAHADACIgBACIgEgCIAAAAQgBABAAAAQAAAAAAABQgBAAAAABQAAAAAAABIABABQAEAFABADIACABIAAACIACAEQABAAAAAAQABABAAAAQAAABABAAQAAABAAAAQAAADgHACIgEAAIgDAAIgHgBIgBAAQgBADgIAAIAAADIgCAAQgCAAgDgFIgDACIgBAEIgFABgABABTIAFABQABAAAAAAQABgBABAAQAAAAABAAQAAgBAAAAQAAgCgFgBgAhhBbIABADIgBACQgDgBAAgEIACgNIgDgRIABgGQAAgGACAAIAAgBIgCgCIgCgIIAAgCQAAgHABgJIABAAQABAAAAAFIABACQgBgQAEgDIAAgGIgBgCIgEgBIAAgBIAAgGIABgFIAAgOQgCgEABgIIgBgmQAAAAAAgBQgBAAAAAAQAAgBAAAAQAAgBAAAAQAAgKARAAIAZABQAEAAAJAHIACAFQgDAJAAAFIABABIgCAGQAAAAAAAAQAAABAAAAQABAAAAAAQABAAAAAAIAAACQAAAXgFAGIABAIQAAAJgCADQABABAAAAQABABAAAAQAAABABAAQAAABAAAAIAAAAQgDACABAGIABACQgDAIAAAFIABAEQACAJgBAEIABAFIAAABIgBALQgDAJADAFIgDALIAAABIgCAFIAAAAQgDAAgBAEIABACQAAABAAAAQAAAAgBAAQAAABAAAAQgBAAAAAAQgDAAgDgCIgBAAQgCADgFAAIgNAAQgBgDgHgDgABcBMIACgCIAAAAQAEAAAAAHIADACIABAFQAAABAAAAQAAAAgBAAQAAABAAAAQAAAAgBAAQgDAAgFgOg");
	this.shape_1033.setTransform(154.1803,202.7635,0.6194,0.6194);

	this.shape_1034 = new cjs.Shape();
	this.shape_1034.graphics.f("#404040").s().p("AhUBjQgFgBgLAAIgDAAIgFABIgLAAQgDABgDgDIgBgCQAAgEAEgFIAHgOQADgJAHABQABgIAEgDIABgDQAAgFAIgIQABgFAFgHIADgIQAHgQAFgHIADgEIAFgJQADgDAMgUQAEgOAEAAQACgBADAEQAAAEAGAIQAEAFAAAEIAJATQACAFADADIAAAAIADAFIAGAPQAFAMABAIQACAJAEACQAAAFADACQAEAGAAAEQAAABAAABQAAAAgBABQAAAAAAABQgBAAAAABIgGABQgZAAgGgCQgBAAAAAAQAAgBAAAAQgBgBAAAAQAAgBAAgBIgCAAIAAABQgBABAAAAQAAABgBABQAAAAAAABQAAAAABABIgFgBQgGAAgGAEQAAAAgBAAQAAABgBAAQAAABAAAAQgBABAAAAIgCAFQgEADAAAFIgDADQgCACgCAEIgBAAQgDAAgCADQgCgCgFABIgDAAQAAABAAAAQAAAAAAABQgBAAAAAAQAAAAgBAAgAhxBPQgEAFAAAFQgCABgBADIABADIAGAAIAAgBQAAgBAAgBQAAAAAAgBQgBAAAAAAQgBgBgBAAQABgIAMgSIAAAAIgKAOgAhiBQIABADIABAAQABAAABAAQABAAAAAAQABgBAAAAQAAAAAAgBIAAgBIAAgHQgDACgDAFgAgLA+IAGADIAFgCIAAgBIgEgDIgHADgABGBeIAAgBQgFgEADgCQAAgEgEgFQgJgIABgGIgDgIQgFgBgCgLIABgDQAAAAAAgBQAAAAAAAAQAAAAAAAAQgBgBAAAAIgCAAQgEgDADgCIAAgDIgBAAQgHAAgCgIQAAgDgCgEQgDgCAAgFQgBgEgEgGQgCgBgBgEIABgDIgDgEQgEgCAAgIQAAgBgEgDIAAgGQAAAAAAAAQAAgBgBAAQAAAAAAAAQgBgBgBAAQgBgBAAgFQAAAAAAAAQAAgBgBAAQAAgBAAAAQAAAAgBgBQgEgHAAgEQgEgCgBgHQgEgFAAgLQgDgBgBgGQABgNAUAAIAJABQAJAAAFgBIAPABIAFACQACADgBADQAEAHADADQADAJAEAGIAAABQAGAHAAAFQANAWAAAFIASAiQASAbAAASQAAABAAAAQAAAAAAABQAAAAABAAQAAAAAAAAQAEAFAAACQgFAEgBAEQAFAFACANIgCAHIgIADIgFgDQgBABAAAAQAAABgBAAQAAABgBAAQAAAAgBAAIgFAAIgHAAQgBAAgGAAIgCgDIgHADIgCABQgDAAgFgFgAgHhYQAAAGADAAIABgBIABgDQgCgEgCAAg");
	this.shape_1034.setTransform(138.5715,202.6241,0.6194,0.6194);

	this.shape_1035 = new cjs.Shape();
	this.shape_1035.graphics.f("#404040").s().p("AgRBgIAAgBIAJgGIgBgBIgDgBQgBAEgFABIgDACIgIACIgCAAIgBgMQAAgFABgBIAAgHIgCgUQAAgIABgCQgBgEABgIQACgGgBgRIgBgHQACgDgCgHIABAAQgBgHADgDQgDgIAAgPQgBgBAAAAQAAAAgBgBQAAAAAAgBQAAgBAAgBIgDABIgDgBQgIAEgPgBQgCgBgDAAIgEAAIgGgCQgBgFABgCIgCgMQAAgQAFgEQADgCATgBQAGgCADABQAHAAADgCIANgBQAMACAJgBIAbgBIAKAAIAKgBQADABAFAAIAOAAQAMAAAAAPIAAATIgDALIgCACQgBAAAAAAQAAAAgBgBQAAAAAAgBQAAgBAAAAQAAgBAAAAQAAAAgBAAQAAgBgBAAQAAAAgBAAIABAKQgCAEgDABIgEAAIgNgGQgFgCgBgEIgCAAIgCABIgIAAQgFAEAAAgIgBARQgIAQgBAWIABAKIgBAEIACACQADAAABgHQADACAAADQgCACAAAQIAAARIgDABIAAgEIgBgCQgBAAgBAAQAAAAgBABQAAAAgBAAQAAABgBAAQAAACgJACIgEAAIgGABIgHADIgEABgAgcAWQABANgCAXIACACIABgFIABAAQAAAAABgBQAAAAAAAAQAAAAAAAAQABAAAAAAIAAgFQgBgBAAgFQgCgFABgNQACgNgDgFQgCAEAAALg");
	this.shape_1035.setTransform(127.0957,202.9338,0.6194,0.6194);

	this.shape_1036 = new cjs.Shape();
	this.shape_1036.graphics.f("#404040").s().p("AgmBkIgCABQgDgBgFgDQgBgEgJgBQgFgBgIgFQAAgEgGgEIABgHQALgKAFAAQAEAAAGAEIACAEQASAJAEAAQACACAEAAQADABAAAEIAAACIgBAEIgBACQAAAEgFACQgBACgJACgAAVBkQgFgDgBgCIAAgBIgCgFIAAAAQACgCAAgHIAAgDQAAAAABAAQAAAAABgBQAAAAAAgBQAAgBAAAAQAGgJAEgCQALgGAAgRIgCgIQgDgCgJgJQgCAAgDgFIABgDIgFABIgEgDIgFACQgGgBgNgDIgEgBQgCgDgJgBQgTgEgCgDIgQgHIgBAAQgCAAgFgDIgGgGQgCgBgBgGIgEgPIACgVQAFgJADgEQAEgGAEgBQAAgCAUgKIAMABQADgBANAAIAGABIAEAMIAAAKQgEAIgCAAQgDAEgFABIgEADIAAAGIgBADQAFAFgBACQAGAIAXAAIATABIAcAJQAJABACAFQAAACAHADQAIAEABAEQAJAVAAAKIAAANQgCAEgCARQgBAJgNAIIgHAJIgmAMgAA8hCQgCgHgUgCQgBgCgFAAIgHgOIAAgCQAHgIAGgBIAEABQACAAAdALQAIAGABAEIACAIQAAAKgNAAIgLgEg");
	this.shape_1036.setTransform(115.6537,203.0886,0.6194,0.6194);

	this.downButton = new lib.ArrowButton();
	this.downButton.setTransform(158.1,244,1,1,180);
	new cjs.ButtonHelper(this.downButton, 0, 1, 2, false, new lib.ArrowButton(), 3);

	this.upButton = new lib.ArrowButton();
	this.upButton.setTransform(225.1,244,1,1,0,180,0);
	new cjs.ButtonHelper(this.upButton, 0, 1, 2, false, new lib.ArrowButton(), 3);

	this.okButton = new lib.OK2Button();
	this.okButton.setTransform(182.7,292);
	new cjs.ButtonHelper(this.okButton, 0, 1, 2, false, new lib.OK2Button(), 3);

	this.diffTxt = new cjs.Text("1", "italic 27px 'flyerfont'", "#333333");
	this.diffTxt.name = "diffTxt";
	this.diffTxt.textAlign = "center";
	this.diffTxt.lineHeight = 40;
	this.diffTxt.lineWidth = 57;
	this.diffTxt.parent = this;
	this.diffTxt.setTransform(187.45,223.95,1,0.9995,0,-10.0561,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.diffTxt},{t:this.okButton},{t:this.upButton},{t:this.downButton},{t:this.shape_1036},{t:this.shape_1035},{t:this.shape_1034},{t:this.shape_1033},{t:this.shape_1032},{t:this.shape_1031},{t:this.shape_1030},{t:this.shape_1029},{t:this.shape_1028},{t:this.shape_1027},{t:this.shape_1026},{t:this.shape_1025},{t:this.shape_1024},{t:this.shape_1023},{t:this.shape_1022},{t:this.shape_1021},{t:this.shape_1020},{t:this.shape_1019},{t:this.shape_1018}]},1).to({state:[]},1).wait(3));

	// logo
	this.shape_1037 = new cjs.Shape();
	this.shape_1037.graphics.f("#FFFFFF").s().p("AhJBKIAAiTICTAAIAACTg");
	this.shape_1037.setTransform(354.0935,354.054,0.4377,0.4377);

	this.shape_1038 = new cjs.Shape();
	this.shape_1038.graphics.f("#FFFFFF").s().p("AgnAoIAAhPIBPAAIAABPg");
	this.shape_1038.setTransform(346.8018,346.7199,0.8046,0.8046);

	this.shape_1039 = new cjs.Shape();
	this.shape_1039.graphics.f("#FFFFFF").s().p("AgfAgIAAg/IA/AAIAAA/g");
	this.shape_1039.setTransform(346.7,361.3875);

	this.shape_1040 = new cjs.Shape();
	this.shape_1040.graphics.f("#FFFFFF").s().p("AhJBKIAAiTICTAAIAACTg");
	this.shape_1040.setTransform(339.4462,354.0825,0.4377,0.4377);

	this.shape_1041 = new cjs.Shape();
	this.shape_1041.graphics.f("#000000").s().p("Ak8AeIJag/IAfA4Ik9ALg");
	this.shape_1041.setTransform(262.2382,372.3891,0.5441,0.5441);

	this.shape_1042 = new cjs.Shape();
	this.shape_1042.graphics.f("#7F7F7F").s().p("AgzAyIAAhjIBnAAIAABjg");
	this.shape_1042.setTransform(285.2108,306.7492,0.5441,0.5441);

	this.shape_1043 = new cjs.Shape();
	this.shape_1043.graphics.f("#7F7F7F").s().p("AgzAyIAAhjIBnAAIAABjg");
	this.shape_1043.setTransform(291.4402,319.0176,0.5441,0.5441);

	this.shape_1044 = new cjs.Shape();
	this.shape_1044.graphics.f("#7F7F7F").s().p("AgzAyIAAhjIBnAAIAABjg");
	this.shape_1044.setTransform(291.4402,312.9514,0.5441,0.5441);

	this.shape_1045 = new cjs.Shape();
	this.shape_1045.graphics.f("#7F7F7F").s().p("AgyAyIAAhjIBlAAIAABjg");
	this.shape_1045.setTransform(297.656,306.8852,0.5441,0.5441);

	this.shape_1046 = new cjs.Shape();
	this.shape_1046.graphics.f("#7F7F7F").s().p("AgzAyIAAhjIBnAAIAABjg");
	this.shape_1046.setTransform(291.4402,306.8852,0.5441,0.5441);

	this.shape_1047 = new cjs.Shape();
	this.shape_1047.graphics.f("#7F7F7F").s().p("AgzAyIAAhjIBnAAIAABjg");
	this.shape_1047.setTransform(291.4402,300.8191,0.5441,0.5441);

	this.shape_1048 = new cjs.Shape();
	this.shape_1048.graphics.f("#FFFFFF").s().p("AiABIIBMghQgLAdAMAUQAOAWAhAAQAaAAAOgRQAMgOAAgPQAAg+gyAAIhPAXQgigcAAguQAAgnAegaQAhgdA2AAQA1AAAsAwIhAAdQABgTgKgNQgNgOgVAAQgQAAgMAKQgOAMAAARQAAAYAOAPQALAOARAAQAJAABRgbIAYARQAXAaAAAtQAAAxgrAdQglAZgvAAQhhAAghhIg");
	this.shape_1048.setTransform(359.9907,312.9106,0.5441,0.5441);

	this.shape_1049 = new cjs.Shape();
	this.shape_1049.graphics.f("#FFFFFF").s().p("AgmANQAAgggigJIAAgPIAxgiIAHAAIAwAxIAACYQAAAmApAHIAAAIIhBAhgAguilIBegsIAAA8IheAXg");
	this.shape_1049.setTransform(347.5999,309.3199,0.5441,0.5441);

	this.shape_1050 = new cjs.Shape();
	this.shape_1050.graphics.f("#FFFFFF").s().p("Ag/CNIAAjFQgBgTgUgKQgLgFgLgBIAAgKIA3gmQAPAAASAPQASAPAHARIA/gvQAKAAAMAWQAOAYABAfIhFA2IgJhIQgMACgJALIAADQg");
	this.shape_1050.setTransform(336.4877,312.7338,0.5441,0.5441);

	this.shape_1051 = new cjs.Shape();
	this.shape_1051.graphics.f("#FFFFFF").s().p("AgrCEIAAjGIgvAAIAAghIBehKIAWAAIAAA9IBBAAIAAAuIhBAAIAACjQAAAaA1ADIAAAKIhDAnQg3gXAAgUg");
	this.shape_1051.setTransform(324.3689,311.2649,0.5441,0.5441);

	this.shape_1052 = new cjs.Shape();
	this.shape_1052.graphics.f("#FFFFFF").s().p("AAGDHQAWgUATghQAWgnAAgcQAAgrgYgaQgTgVgUABQgeAAgOALIAADGIhMAAIAAkjQAAgrgLgSIgLgJIAAgLIBWgpIASAGIgHA0IAABwQAUgLASgOIAMgMQArAAAjAdQAwAoAABHQAAA1g5A5QgcAcgdASg");
	this.shape_1052.setTransform(308.9178,309.5783,0.5441,0.5441);

	this.shape_1053 = new cjs.Shape();
	this.shape_1053.graphics.f("#FFFFFF").s().p("AAvCGIgUgMQgIgMAAgPQhDAxgGAAQgPAAgYgVQgbgWAAgXQAAguA1ggIBWglQAAgJgGgJQgKgSgaAAQgTAAguAXQgHACgGgIQgGgIAEgHIBlhIIAvAWQAwAaAAASIAACEQAAAjAcAHIAAAMIg1AjQgEAAgRgKgAgWARQgWASAAAaQAAASAVACQAWADAUgXIAAg9QgWACgTAPg");
	this.shape_1053.setTransform(275.0234,312.9106,0.5441,0.5441);

	this.shape_1054 = new cjs.Shape();
	this.shape_1054.graphics.f("#FFFFFF").s().p("AgiB6Qg6giAAhRQAAg5A3g0IA1gpIAZAUQAfAZAVAaIh4BlQANAiAmAIQAcAGAfgHIAEAFIgxBFQgvgIgZgOgAghAHIA7gxQgEgHgHgIQgOgQgNAAQgfAAAKBQg");
	this.shape_1054.setTransform(261.9525,312.9242,0.5441,0.5441);

	this.shape_1055 = new cjs.Shape();
	this.shape_1055.graphics.f("#FFFFFF").s().p("AjKDCQAqgmAAgvIAAi7QAAgjgWgTIgXgMIAJgRQAeAAA9gbQA9gbAsAAQA9AABIBQQBJBQAABBQAAAuhHBLQhOBThJAAQgQAAg5gPQg4gJgnAagAg5ikQgUAUgBAhIAADTQAABLBGAAQArAAAmg4QAlg4AAg+QAAhCgog8Qgmg7goAAQgeAAgTAUg");
	this.shape_1055.setTransform(244.2572,309.1022,0.5441,0.5441);

	this.shape_1056 = new cjs.Shape();
	this.shape_1056.graphics.f("#FFFFFF").s().p("AATgmQgKAzgbAag");
	this.shape_1056.setTransform(250.7723,368.948,0.5441,0.5441);

	this.shape_1057 = new cjs.Shape();
	this.shape_1057.graphics.f("#FFFFFF").s().p("AgIAaQAEgnAOgYQgLAZgIAyIABgMg");
	this.shape_1057.setTransform(260.878,340.1132,0.5441,0.5441);

	this.shape_1058 = new cjs.Shape();
	this.shape_1058.graphics.f("#FFFFFF").s().p("AABgJQAGgHACABQgEAUgNALQAIgJABgQg");
	this.shape_1058.setTransform(253.8598,369.706,0.5441,0.5441);

	this.shape_1059 = new cjs.Shape();
	this.shape_1059.graphics.f("#FFFFFF").s().p("AAAAAQADgIAAgFQAAAWgDAFQgEgEAEgKg");
	this.shape_1059.setTransform(255.4443,371.233,0.5441,0.5441);

	this.shape_1060 = new cjs.Shape();
	this.shape_1060.graphics.f("#FFFFFF").s().p("AgBABIAAgCIADAAIAAACg");
	this.shape_1060.setTransform(273.5952,369.2336,0.5441,0.5441);

	this.shape_1061 = new cjs.Shape();
	this.shape_1061.graphics.f("#FFFFFF").s().p("AAAgCIABACIAAADg");
	this.shape_1061.setTransform(274.0577,367.3158,0.5441,0.5441);

	this.shape_1062 = new cjs.Shape();
	this.shape_1062.graphics.f("#FFFFFF").s().p("AAGgKIgHASIgEADg");
	this.shape_1062.setTransform(256.7704,366.5678,0.5441,0.5441);

	this.shape_1063 = new cjs.Shape();
	this.shape_1063.graphics.f("#FFFFFF").s().p("AAMgVIgXAsQAFgXASgVg");
	this.shape_1063.setTransform(255.8319,364.8268,0.5441,0.5441);

	this.shape_1064 = new cjs.Shape();
	this.shape_1064.graphics.f("#FFFFFF").s().p("AAAgCIABACIAAADg");
	this.shape_1064.setTransform(274.4657,365.0716,0.5441,0.5441);

	this.shape_1065 = new cjs.Shape();
	this.shape_1065.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_1065.setTransform(274.8738,364.5684,0.5441,0.5441);

	this.shape_1066 = new cjs.Shape();
	this.shape_1066.graphics.f("#FFFFFF").s().p("AACgDIgCAHQgEgCAGgFg");
	this.shape_1066.setTransform(274.8987,364.0515,0.5441,0.5441);

	this.shape_1067 = new cjs.Shape();
	this.shape_1067.graphics.f("#FFFFFF").s().p("AAGgKQAAAJgKAMQgEgHAOgOg");
	this.shape_1067.setTransform(254.8885,360.2431,0.5441,0.5441);

	this.shape_1068 = new cjs.Shape();
	this.shape_1068.graphics.f("#FFFFFF").s().p("AEzBVQgMgGgrgFQgkgFgPgSQgmgEhKAHQhOAIgkgCQggAHg/gGQg/gGgeAHQggAChKgEQhJgEgjACQAMg0ACgEQAmgCBsAGQBYAGA1gOQA6gJB7AQQB1APA+gOQAVgLAcgbQAhgiAMgKIBTgJQAAABAAAAQAAABAAAAQAAABABAAQAAABABAAQgEAKgLADQgOAEgFAFQAbgCAOABQARAGgRAIQgIADgsgCQgggCgJAWQAIAEASAAQAUgBAHACQADAGgEAEQgFAEgGAAQgJADgegDQgbAAgEARQgBAEAEAEIAjABQgJAIgdABQABgCgEgFQgHgCgCAIQgHAQAOAQQALAUAVgNQAOgJAGACQAIADgKAJQgLAOgRAAIgIgBg");
	this.shape_1068.setTransform(299.1555,359.7203,0.5441,0.5441);

	this.shape_1069 = new cjs.Shape();
	this.shape_1069.graphics.f("#FFFFFF").s().p("AADgLIAAADIACAAIgJAUg");
	this.shape_1069.setTransform(256.036,355.2787,0.5441,0.5441);

	this.shape_1070 = new cjs.Shape();
	this.shape_1070.graphics.f("#FFFFFF").s().p("AABgEIACAAIAAADIgGAGg");
	this.shape_1070.setTransform(256.512,354.1362,0.5441,0.5441);

	this.shape_1071 = new cjs.Shape();
	this.shape_1071.graphics.f("#FFFFFF").s().p("AAPgmIgJAmQgGAUgOATQAahCADgLg");
	this.shape_1071.setTransform(259.6403,353.8505,0.5441,0.5441);

	this.shape_1072 = new cjs.Shape();
	this.shape_1072.graphics.f("#FFFFFF").s().p("AABAJIAAgCIABAAIAAACIgBAAgAAAgIIABARQgEgBADgQg");
	this.shape_1072.setTransform(270.1915,350.5046,0.5441,0.5441);

	this.shape_1073 = new cjs.Shape();
	this.shape_1073.graphics.f("#FFFFFF").s().p("AgBgJIADAAIAAATg");
	this.shape_1073.setTransform(265.5977,351.6879,0.5441,0.5441);

	this.shape_1074 = new cjs.Shape();
	this.shape_1074.graphics.f("#FFFFFF").s().p("AgHAUQAAgVAOgbQgIARgFAog");
	this.shape_1074.setTransform(266.0873,348.75,0.5441,0.5441);

	this.shape_1075 = new cjs.Shape();
	this.shape_1075.graphics.f("#FFFFFF").s().p("AAAACIAAgDIABAAIAAADg");
	this.shape_1075.setTransform(258.6474,348.7228,0.5441,0.5441);

	this.shape_1076 = new cjs.Shape();
	this.shape_1076.graphics.f("#FFFFFF").s().p("AATgnQgKArgaAkg");
	this.shape_1076.setTransform(256.7024,349.5117,0.5441,0.5441);

	this.shape_1077 = new cjs.Shape();
	this.shape_1077.graphics.f("#FFFFFF").s().p("AAEgSIgDAXIgEAOg");
	this.shape_1077.setTransform(259.2187,346.9003,0.5441,0.5441);

	this.shape_1078 = new cjs.Shape();
	this.shape_1078.graphics.f("#FFFFFF").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_1078.setTransform(281.008,345.6217,0.5441,0.5441);

	this.shape_1079 = new cjs.Shape();
	this.shape_1079.graphics.f("#FFFFFF").s().p("AgGgFIAag8QgdBOgEAsIgGAJQAEgwAJgXg");
	this.shape_1079.setTransform(263.5031,349.0765,0.5441,0.5441);

	this.shape_1080 = new cjs.Shape();
	this.shape_1080.graphics.f("#FFFFFF").s().p("AgDAAQACgLADgFIAAAAIABgBIABgBIAAADIgCACIABgCIgBAAIgBACIABAAIgCAJQgEANACAKQgCgIABgLg");
	this.shape_1080.setTransform(271.6911,345.3089,0.5441,0.5441);

	this.shape_1081 = new cjs.Shape();
	this.shape_1081.graphics.f("#FFFFFF").s().p("AoNCmQgZgUAAgZQgCgKAIgKIAPgOQA5gUBlgIQCBgLAigGQAeACA3gRQA3gRAfACQAlgEBbABQBTAAAugGQBUgBAigRQAYgRAVgzQAUgzATgPQAIgGAQgGQAPgGADABQAMAEgLAKQgGAFggAWQgOAQAEAVQgCACAAAEQADAGAGgEQAZgrAYgFQAXABAKgCQAggFANAFQAAAMgPAEIgaAGQgCABgKAAQgHgBABAJQAOAAAOACIAMAEQAAAMgUAAIgQgCIgFACQABACAIADQAHADAAAGQgFACgjACQgZABgCAUQgJARAHAFQANAJAWACIAHgBIARgQQAKgJADAEQADAGgIAMQgCAEgUARQgIAGgQgCQgTgCgHADQghAegsgQQAQgKACgJQgOAEgTAOQgzABhnAUQhjATg1ABQgNABhSAPQg6ALgngCQgWAEhSALQg/AIgnALQhXAHglAdQgFgEgIAEQgIAEgEgGIgGAGIgCABQgBAAAAgBQgBAAAAAAQgBAAAAgBQgBAAgBAAg");
	this.shape_1081.setTransform(296.7751,351.1139,0.5441,0.5441);

	this.shape_1082 = new cjs.Shape();
	this.shape_1082.graphics.f("#FFFFFF").s().p("AhYg8QAHgVACgMQACAQADAEQAQgIAEgIIAQgbQAIAQgCApQAbgeAXgJIAGAOIgCACQABAGAGAKQADAKgDAHQgkgCgGAJQAFACALARQAJAMAMgFQABgFgGgEQgHgFgBgEIAfAAQgFAMAMAMQAHACAHgLQAFgLAKADQAHgKgCgFQgRgGgfAAQAggPALgQQAFAEAFATQAEAQAFgBQgNAkANAhQADAVgKADQgGAEgPAGQgFALADAMQgIAGgZAHQABAEAGAAQAFgBAAAEIhrAMQg2gwAbiBg");
	this.shape_1082.setTransform(277.7957,347.5123,0.5441,0.5441);

	this.shape_1083 = new cjs.Shape();
	this.shape_1083.graphics.f("#FFFFFF").s().p("ABYBEQgBgVgCgDQgGgKgFAPQgJAogGAAQgEgagMgJIgFAHQgDAMgFAHQgFgkgEgCQgFgCgFAPIgFAPIgFgPQgDgNgIAEIgOAfQgDgEgHgdQgEAAgLAOQABgDgCglQgJAGgiAdQAOgdABgNQgDgEgEADIgHAFIgXAQQgDgCAIgPQAIgQgCgDQgCgGgIAFQgIAFgDgEQgFAEgJACQgJACgFAFQAVgZAAgLQgJgEgQAHQAGgRAEgHQgFAAgFgDQgFgBgLAIQASgnAhgGQAAAEgHAMQgHAJADABIAhgPIgRAbQAWgQAMADIgMAQQgGAHABAJQADABAPgEIAXgJIgQASQgIAKAHAHQATgFADgJQABgDAEABQAFACACgDQgKAfACACQAEABAJgHQAJgFACgFQgEAaAJAEQADABAMgcQAMAhADAAQAEgBAFgPIAIgUIAVArQAGgcAGgIIAPAbQANgFgCgRIASAdQAHgDAAgQIAAgKIATAaIAFgXQACgDADAFQADAFADAOQAJgLAAgGIAJACQAQAcgHAUQgJgZgCgDQgHAEAAAiIgFgRQgDgLgDADQgCACgDAkQgGgggHgCQgBAYgKAKIgDgPQgCgKgGAAQgJACgCAgQgEgEAAgTgAgxA6IAAAAIAAAAg");
	this.shape_1083.setTransform(277.0739,331.8164,0.5441,0.5441);

	this.shape_1084 = new cjs.Shape();
	this.shape_1084.graphics.f("#000000").s().p("AgaBKQgEhCAKgEQAEgwAhgfQAAAJgHAVQAPgiATgbIABACQgUBUgzBeIACARIgVAQIATghg");
	this.shape_1084.setTransform(249.9834,367.8055,0.5441,0.5441);

	this.shape_1085 = new cjs.Shape();
	this.shape_1085.graphics.f("#000000").s().p("AABACQANgaALgHQgDAXgQAaIgeAOQAOgHALgXg");
	this.shape_1085.setTransform(250.7179,371.0698,0.5441,0.5441);

	this.shape_1086 = new cjs.Shape();
	this.shape_1086.graphics.f("#000000").s().p("AgLAJIARgXQAJAFgEAYg");
	this.shape_1086.setTransform(252.8255,371.6954,0.5441,0.5441);

	this.shape_1087 = new cjs.Shape();
	this.shape_1087.graphics.f("#000000").s().p("ArWFRQAIg8AVgVQAHgdAggpQAlgxAJgTIgBgBQhKBLgRA8QADgjgBgHQgEAEgFALQgEAKgFADQgBgXARgaQAXgdALgRQBqh2AfiJQAFgGACgPQACgPAGgFQAnjHCDg/QAogLAVgEQAkgHAdAGQBbAJA7ApQBPAwgHCQQgWBQgWAlIgPAPQAEgWgGgGQggAuARAoQAJAagUAIIgTAJQgCABADAQQgBALgJACQgIABABAFQCEgGAvgVQBAgHBygDQB8gDA4gGIA8gHQAigJAOgcQAahAASgeQAegaAfgFQAOACAEAIQAEAJgNAMQgDADgJAEIgIAGQgWAMADARQAQgXAMgHIAzgEQASgEAJAAQAXAAACAGQABACgJAVQgCAIgQAFQAGADgCAGQgBAOgXAGQAGAHgJAGQgGAEgfgBQgZAAgGASIgCANQATAHAIAAIAYgPQASgLAHAKQAEAIgPATQgOASgPAHQgFADgQgCQgQgBgIAEQgQASgaABIgugFQgXgCgZAFQgJAAgtAJQi9AkjhAQQgRAGghAEQgjAFgQAFQggACg7AMIgGAKQCIANBJgBQBogcBfASQCkAQAxgEQAYgLAYgQQA8g7AJgGQALABAlgFQAdgDASAGQAHAEgEAJIgGAJQAQADACAMQACAJgNAHQgQAGgZgEQgagDgQAGQAEADAcABQATABgDASQgJAOgdAAQgfgBgIAIQAEABARAAQAMAAABALQgDAJgjAGQgXADAWAUQAFAAARgIQAMgHAJAJQAHAFgFAPQgPARgUAHQgcgKgbgDQgVgDgEABQgVgCgbgWQghgChFAHQhNAHgdAAQgOgBg4ACQgtACgbgHQhXAHi3gDIgHAMQgCAWgNAsQgMAqgBAXInSAVQgMgdAGhFg");
	this.shape_1087.setTransform(287.7236,348.8515,0.5441,0.5441);

	this.shape_1088 = new cjs.Shape();
	this.shape_1088.graphics.f("#FFFFFF").s().p("AAIgIQgHAHgIAKQACgJANgIg");
	this.shape_1088.setTransform(320.8734,344.4792,0.5441,0.5441);

	this.shape_1089 = new cjs.Shape();
	this.shape_1089.graphics.f("#FFFFFF").s().p("AgdBDIgDgNQACgGAAgJQAAgOAFgCIACAAIAAgCQADgpAbgeIgDAHIgDAPIAGABQAKgYAQgZQgRAcgUBFIgcA4g");
	this.shape_1089.setTransform(249.9562,366.9622,0.5441,0.5441);

	this.shape_1090 = new cjs.Shape();
	this.shape_1090.graphics.f("#FFFFFF").s().p("AraF6IABggQAFgOAEgTQAJgvAIgJIADgIQAEgCAFgMIAEgKQgJAMgEAMQgDABgDgBQgDgCgIAOIgBgHIgEgKIAAgDQAAgYAXgdQBRhqAQgdIAcgtQAPgaAKgeIAOgxQAigwAGgRQAWhtAKgaQAehIBHgjIAHgHIApgMQApgLAyALQBdALA7AnQBQAxgICSIgBADQgTBNgYAnIgCACQgDAEgEAJIgKAIIgCgQIACgPIAAgBQgTAcAAAWQAAAPAHAOIAAACQAEAHAAAHQAAAOgRAHIgHADIgLAFIAAADIACAMIAAABQgCAMgLADIgFACIANgBQBzgGAwgVQBAgHB+gDQBwgDA4gGIATgCQBGgFARgjQAIgPALgaQAQglALgRQAdgbAhgFIACAAQAOADAEAJIABAFQAAAJgKAKQgCACgHAEQAIgCARAAIAggDQAJgCAIAAQAZABADAGQACAIgHAMIgDAGQgBAEgLAFIgGADQAEAEAAADIAAACQgBALgQAGIgHAEQAAABAAAAQABAAAAABQAAAAAAABQAAABAAAAIAAACQgBAGgEACQgKAFgVgCQgegBgGASIAAgBIgCAKIAAAAQARAHAHAAQACAAALgHQAUgQAKACQAFABADAFQACAEgBAHQgKAdgfAQQgHAEgOgCQgSgBgHADQgWAYgzgIIgQgCQgWgCgaAFQgPAAgXAGIgPAEQi7AjjgAQQgOAFgqAGQghAEgQAFQgVACglAHIggAFIgEAFIBCAFQBbAIAxgBQBogcBfATIAuAEQBvAMA3gFQAZgLAXgPIAUgVQAigiAOgKIABgBIABAAQALABAbgDQAmgFAVAGQAEADABAFIAAACQAAAGgFAHQANAEADAMIAAADQAAAKgNAGQgRAHgZgEQgUgDgNAEIAOAAQATgBAGAHQAFAFgCAMIAAAAIAAABQgLAPgigBQgUgBgIAEIAJAAQAUgBABAPIAAAAIAAABQgFAMgdADQgQACgBADIAAABQAAADAKAKQAFAAAKgGQASgKALALQAIAHgGAQIAAABIAAAAQgPARgVAHIAAAAIgBAAQgcgJgbgEIgGgBQgNgCgGABQgYgCgYgVIgBgBQgegChPAIQhDAHgfgBQgRgBglACQg7ADgdgIQgyAEh+AAIhcAAIgGALQgDAUgLArQgNApgCAaInWAEQgHgWAAgdgAp2CTQgjAjgMATIgKAYIAEgGQAUgWAKgMQAWgcALgUg");
	this.shape_1090.setTransform(287.4321,348.3284,0.5441,0.5441);

	this.shape_1091 = new cjs.Shape();
	this.shape_1091.graphics.f("#FFFFFF").s().p("AgHAIQAIgRAHgHIgFAQIgHARg");
	this.shape_1091.setTransform(251.4115,370.6617,0.5441,0.5441);

	this.shape_1092 = new cjs.Shape();
	this.shape_1092.graphics.f("#FFFFFF").s().p("ArLGTQgIAHgIg1QgCgQABgHIAIgcQAIgkAQgRQAHgaArg3QAXgdAKgTIgKAKQg+A9gLAoIgFAAIAAgEIABgMIABgCIgDAGQgFAMgFADIgEADIAAgFIgBgDQAAgdAWgdQBPhkAQgdQAphKANgpIAKghQADgGAFgWQAEgRAKgKQAojJB3g7IAHgHIAogGQA4gOAlAIQBdALA6AoQBQAxgICSIAAADQgVBOgWAlIgDACQgJALgEADIgDACIgBgEIgBgHIABgPIAAgBQgSAaAAAYQAAAPAHAPIAAABQAEAKAAAHQAAAMgOAGIgLADIgLAGIACAAIAAAOIAAAAIAAABQgBANgMACIgEACIAMgBQBzgGAxgUQBFgIB4gDQBxgDA4gGIASgBQBHgGARgjQAJgSAJgWQAPgjAMgTQAdgcAhgFIABAAIACAAQAOADAEAJIABAFQAAAJgLAKIgJAGIAagCIAVgBIAKgCIARgCQAaAAACAIQADAIgHALIgEAGQgBAGgLADIgFADQAEADAAAEIgBACQgBAMgPAFIgIAEIACAEIAAACQgBAFgFAEQgIAFgWgBQgfgDgGASIAAgBIgCAKIAAABQAUAGAFAAQACAAAKgHQAVgPAJACQAFAAADAFQADAEgCAHQgJAdggAQQgGADgPgBQgQgCgIAEQgWAYg0gHIgQgCQgYgDgYAFQgLAAgbAGIgPAEQi7AjjjARQgTAGghAEQgiAEgPAFQgQABgrAIIggAFIgCADIgCACIBDAFQBfAIAsgBQBogcBgATIAtAFQBtALA6gFQAZgLAWgPIAVgVQAegfASgNIABgBIAAAAQAQABAXgDQAlgFAVAGQAFADABAFIAAACQAAAFgFAJQANADACANIAAACQAAAKgMAGQgQAGgbgDQgUgCgNADIAOAAQAUAAAFAGQAFAFgBAMIAAABIgBAAQgKAPgjgBQgVAAgHADIAJABQAUgCACAPIAAABIgBAAQgEALgdAFQgRACgBACIAAABQAAAEALAJQAFAAAKgFQASgLAKALQAJAHgGAQIgBABIAAAAQgOARgVAHIgCAAQgagJgdgEIgGAAQgLgDgIACQgVgCgagVIgCgCQgggChNAIQhHAHgbgBQgQgBgmACQg7ADgdgHQg4AEh4gBIhaAGIgGALQgCAWgMAoQgQA3AAAHInkAbIASgkgArEFfIAAABIgBAGQgDAHAAALQAAAFACAIIgBAGIAWgsQARg7APgdIgUApIgIAGQgBgMgDAAQgGAAgNA1g");
	this.shape_1092.setTransform(287.6019,348.9429,0.5441,0.5441);

	this.shape_1093 = new cjs.Shape();
	this.shape_1093.graphics.f("#000000").s().p("AAAAFIAAgIIABAAIAAAIg");
	this.shape_1093.setTransform(260.0348,346.0298,0.5441,0.5441);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_1093},{t:this.shape_1092},{t:this.shape_1091},{t:this.shape_1090},{t:this.shape_1089},{t:this.shape_1088},{t:this.shape_1087},{t:this.shape_1086},{t:this.shape_1085},{t:this.shape_1084},{t:this.shape_1083},{t:this.shape_1082},{t:this.shape_1081},{t:this.shape_1080},{t:this.shape_1079},{t:this.shape_1078},{t:this.shape_1077},{t:this.shape_1076},{t:this.shape_1075},{t:this.shape_1074},{t:this.shape_1073},{t:this.shape_1072},{t:this.shape_1071},{t:this.shape_1070},{t:this.shape_1069},{t:this.shape_1068},{t:this.shape_1067},{t:this.shape_1066},{t:this.shape_1065},{t:this.shape_1064},{t:this.shape_1063},{t:this.shape_1062},{t:this.shape_1061},{t:this.shape_1060},{t:this.shape_1059},{t:this.shape_1058},{t:this.shape_1057},{t:this.shape_1056},{t:this.shape_1055},{t:this.shape_1054},{t:this.shape_1053},{t:this.shape_1052},{t:this.shape_1051},{t:this.shape_1050},{t:this.shape_1049},{t:this.shape_1048},{t:this.shape_1047},{t:this.shape_1046},{t:this.shape_1045},{t:this.shape_1044},{t:this.shape_1043},{t:this.shape_1042},{t:this.shape_1041},{t:this.shape_1040},{t:this.shape_1039},{t:this.shape_1038},{t:this.shape_1037}]},2).to({state:[]},1).wait(2));

	// gameArea
	this.gameArea = new lib.GameArea();
	this.gameArea.setTransform(3.4,369,1.0476,1);
	this.gameArea._off = true;
	this.gameArea.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.gameArea).wait(2).to({_off:false},0).to({_off:true},1).wait(2));

	// background
	this.shape_1094 = new cjs.Shape();
	this.shape_1094.graphics.f("#CC0000").s().p("AAAgHIABAAIAAAPIgBgPg");
	this.shape_1094.setTransform(103.5668,92.032,0.5647,0.5647);

	this.shape_1095 = new cjs.Shape();
	this.shape_1095.graphics.f("#CC0000").s().p("AgFgIQAQgJARACQgbABgRATIAAgCQgHAGgEAHQAFgQARgIg");
	this.shape_1095.setTransform(95.3368,84.3286,0.5647,0.5647);

	this.shape_1096 = new cjs.Shape();
	this.shape_1096.graphics.f("#CC0000").s().p("AgCgCIAAgEQADAFACAIIgFgJg");
	this.shape_1096.setTransform(109.5523,90.7051,0.5647,0.5647);

	this.shape_1097 = new cjs.Shape();
	this.shape_1097.graphics.f("#CC0000").s().p("AgMgHIAAgDQAFABAUAUQgPgJgKgJg");
	this.shape_1097.setTransform(111.2745,88.3052,0.5647,0.5647);

	this.shape_1098 = new cjs.Shape();
	this.shape_1098.graphics.f("#CC0000").s().p("AAAgFQgWgIgOABQAPgFAYAJQAZAJAJAOQgOgMgXgIg");
	this.shape_1098.setTransform(111.698,86.8731,0.5647,0.5647);

	this.shape_1099 = new cjs.Shape();
	this.shape_1099.graphics.f("#990000").s().p("AgmANIAEgCQgBABAAAAQAAgBgBAAQAAAAAAgBQAAgBAAgBQAGgGAXgHQAQgNAfACQgOAFgKABIABAFQgMgGgTALQgEAAgMAGQAPAFADAGQgEgCgWgCg");
	this.shape_1099.setTransform(116.3847,99.4925,0.5647,0.5647);

	this.shape_1100 = new cjs.Shape();
	this.shape_1100.graphics.f("#000000").s().p("AgJgGIAFAGIgBgEIAPAHQgEAEgDAAQgGAAgGgNg");
	this.shape_1100.setTransform(61.5415,50.4318,0.5647,0.5647);

	this.shape_1101 = new cjs.Shape();
	this.shape_1101.graphics.f("#FF0000").s().p("AgeAXQASgGAHgGQgFABgIgDQAHgEARgEIgCgCIAKgEIgKgDQAOgCAHgCIgMgMQAMAFAGABQgFAQgVAOQgPANgNAAIgHgCg");
	this.shape_1101.setTransform(100.5599,59.4049,0.5647,0.5647);

	this.shape_1102 = new cjs.Shape();
	this.shape_1102.graphics.f("#FFFFFF").s().p("AhRAJQAxADAWgDQAsgQAYgFIAHAAQAMgCAFgCQg9Ahg1AAQgZAAgYgIg");
	this.shape_1102.setTransform(166.0189,94.4981,0.5647,0.5647);

	this.shape_1103 = new cjs.Shape();
	this.shape_1103.graphics.f("#FF0000").s().p("AgKgBQAUggAEgPIAAgBQAGgHAIgDIAAADQgLAHgRAiQgFAKgGASQgLAagFAVQgCgQATgtg");
	this.shape_1103.setTransform(78.083,51.376,0.5647,0.5647);

	this.shape_1104 = new cjs.Shape();
	this.shape_1104.graphics.f("#FFFFFF").s().p("AgKgSIAFAEQAUAKgFAXQgKgXgKgOg");
	this.shape_1104.setTransform(196.3922,39.278,0.5647,0.5647);

	this.shape_1105 = new cjs.Shape();
	this.shape_1105.graphics.f("#FFFFFF").s().p("AgxgLIA4AQQA2ARAjADQhogFgpgfgAhfgXQAGgDARAFIARAGIAGAEIgugMg");
	this.shape_1105.setTransform(151.9587,92.9479,0.5647,0.5647);

	this.shape_1106 = new cjs.Shape();
	this.shape_1106.graphics.f("#000000").s().p("AhbAPQAFgFAEgDQAGgHAFACQAnAVAagQQgCgSAggaQAlgDAsAPIAAAGQgEADgfgEQgXgDgCAZQgEgFgIAAQgJAAAAAHQAAABADAGIgCAGQgDAJAGAJQgCABgKgDIgHgBQgCAAgDgDQgEgEgFAAQgHABgLAFIgVACIgKAFQgDAAgFgGQgEgDgIAAQgPAAgHADIgIAHQADgOAKgKg");
	this.shape_1106.setTransform(106.0513,123.8086,0.5647,0.5647);

	this.shape_1107 = new cjs.Shape();
	this.shape_1107.graphics.f("#990000").s().p("AhzAkQADgbAfgLIACgBIACABQAkASAXgNIAAgBQABgSAcgXIAHgHQAbgCAdAKIAWAHQAKAEAKAMQgKgGgJAGQgFAEgVgEQgTgDgEAEQgFAEgBALIAAAMIgIgJQgFgFgFABIgDADQAGAHgFANQACAMAIAFIgfgGIgFgBIgEgDQgCgBgJADQgHAEgGAAIgMAAQgOABgFAKQgDgQgaAEQgSAEgFAIg");
	this.shape_1107.setTransform(106.4748,123.8412,0.5647,0.5647);

	this.shape_1108 = new cjs.Shape();
	this.shape_1108.graphics.f("#990000").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_1108.setTransform(123.1325,114.0399,0.5647,0.5647);

	this.shape_1109 = new cjs.Shape();
	this.shape_1109.graphics.f("#990000").s().p("AgBADIAAgFIADAAIAAAFg");
	this.shape_1109.setTransform(118.0364,112.6706,0.5647,0.5647);

	this.shape_1110 = new cjs.Shape();
	this.shape_1110.graphics.f("#000000").s().p("AhAgkQANgCAcARQAZAPAUgJQAcgUgIgfQA3gOA2AOIAAAGQgkgIgcAgQgCAKAHACQgGAIgOgDQgMgDgFAJQgEAMAAAOIADAaQgEgFgXgOQgKgBgEAHQgJgDgQgJQgQgHgMAHQgIAGgDAQQgEARgHAGQgFgPglAAQgZAWgVAIQAMgcBKhSg");
	this.shape_1110.setTransform(120.7609,114.0611,0.5647,0.5647);

	this.shape_1111 = new cjs.Shape();
	this.shape_1111.graphics.f("#990000").s().p("AilBJQAPgiA1g4IAVgXIAKgJQAXAKAMAIIATANQALAGAJgGQAbgSgHgcIAMgMQAygMA3ANIAZATIgYACIgGgBQgggHgaAdIAAAEQAAABAAAAQAAAAAAAAQAAABABAAQAAAAAAAAIAFACIgDAFQgHAKgRgEQgJgCgDAGQgDAKADANQACAKgCAXQgUgJgBgEQgBgGgIADIgNAAIgCADIgRgJQgXgMgMAHQgGAEgDAQQgFASgGAGIgGAFIgCgHQgEgNgbABIgFAAQgcAYgTAGIgKAEg");
	this.shape_1111.setTransform(121.3256,114.0114,0.5647,0.5647);

	this.shape_1112 = new cjs.Shape();
	this.shape_1112.graphics.f("#990000").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_1112.setTransform(107.223,108.605,0.5647,0.5647);

	this.shape_1113 = new cjs.Shape();
	this.shape_1113.graphics.f("#990000").s().p("AgBADIAAgFIADAAIAAAFg");
	this.shape_1113.setTransform(104.9785,107.2216,0.5647,0.5647);

	this.shape_1114 = new cjs.Shape();
	this.shape_1114.graphics.f("#990000").s().p("AgDACIAHgFIAAAHQgGAAgBgCg");
	this.shape_1114.setTransform(115.0719,106.4169,0.5647,0.5647);

	this.shape_1115 = new cjs.Shape();
	this.shape_1115.graphics.f("#990000").s().p("AgCADIAAgFIAFAAIAAAFg");
	this.shape_1115.setTransform(104.4985,105.1888,0.5647,0.5647);

	this.shape_1116 = new cjs.Shape();
	this.shape_1116.graphics.f("#990000").s().p("AAAgCIADAAIgFAFg");
	this.shape_1116.setTransform(116.0601,105.1464,0.5647,0.5647);

	this.shape_1117 = new cjs.Shape();
	this.shape_1117.graphics.f("#990000").s().p("AgCADIAAgFIAEAAIAAAFg");
	this.shape_1117.setTransform(117.3729,104.6806,0.5647,0.5647);

	this.shape_1118 = new cjs.Shape();
	this.shape_1118.graphics.f("#990000").s().p("AgCACQADgDACAAIAAADg");
	this.shape_1118.setTransform(105.0208,104.7229,0.5647,0.5647);

	this.shape_1119 = new cjs.Shape();
	this.shape_1119.graphics.f("#990000").s().p("AAEABQgHgEgFADQAEgEAEADIAJADQAAAAAAABQAAAAAAAAQAAAAAAAAQAAAAAAAAIgFgCg");
	this.shape_1119.setTransform(120.6282,101.6083,0.5647,0.5647);

	this.shape_1120 = new cjs.Shape();
	this.shape_1120.graphics.f("#990000").s().p("AgKgCIAVADIgMACQgJAAAAgFg");
	this.shape_1120.setTransform(122.7796,98.8302,0.5647,0.5647);

	this.shape_1121 = new cjs.Shape();
	this.shape_1121.graphics.f("#990000").s().p("AgRAAIAjgCIgRAEIgGABQgHAAgFgDg");
	this.shape_1121.setTransform(120.4503,98.6904,0.5647,0.5647);

	this.shape_1122 = new cjs.Shape();
	this.shape_1122.graphics.f("#000000").s().p("AkRB/QAIgOABgHQALgrAvgrQA3gsAWgaQAOgCABAUQABAXAMAFQAFAEAeALQAFgBgBgKQAAgKABAAQAFgCARAJQARAJAIgDIARgdIANATQAIALALgIQAOgJgDgUQgGgWABgKQgXgbgDgTQAugjBKAAQBAAAA+AYIAPARQgRAAgkgJQgggGgSANQgCAVAPAkQgJAEgJgIQgMgKgEgBQgjgJgEAAQgNAJAHAnQAFANATAMQgPgDgqgLQgIAFgCAPQgBAOAEAKQgGALgagYQgKgBgKASQAAAXAPApQgLgCgLgNIgRgVQgogcgWAGQgIAKAEAXQgEgDgWgDQgRgDgFgMQgXgEgHATQgCAIAEAQQAEAPgDAHQgHgPgRgIQgRgJgRAFQgpAagVAkQgIgHAFgNg");
	this.shape_1122.setTransform(112.5309,106.346,0.5647,0.5647);

	this.shape_1123 = new cjs.Shape();
	this.shape_1123.graphics.f("#990000").s().p("AkZCVQgGgTAGgNIAHgVQAIggAagbIAzgsQAjgdAPgRIAAgCIACAAQAPgGADADQABABAAAYQABAUAKADIABABIABAAQAEAFAPADIAIABQAEgQAEgCQAEgCAIAGIANAJQAOAFAHgBIATggIAEADQAEACAGALQAFALAEAAQACABAGgEQAKgHgBgLQAAgGgDgMIgCgTIAAgBQgCgFgJgNQgNgRgCgLIgIgIQA9gfBJgCQBHgCA2AbIABAAIAdAZIgRABQgMgBgXgFQgrgKgUAMIAAACQAAAKAGAPQADAJAMAUIAEACQgIADgOgDQgOgDgEgEQgHgHgFAAIgKgEQgRgGgJAAQgGAHAAAMIACATIABAFIAGAHIALAOQAAABAOAGIgVAAQgQgCgFgDQgJgFgQgBQgFAEgFAQQgCAJAOASQAEAFgwgWQgGAAgHAOQAAAPAJAaIALAiIgLgHQgOgEgUgZIgHgIIgCgCQglgYgSAFQgFAGAAAFIAFAcIgJgHQgEgDgOgCQgXgCgGgOQgSgCgGAOQgBAIADAOQAFAPgEAKIABASIgFgKQgUgrgjAKQgpAZgVAjIgCAFg");
	this.shape_1123.setTransform(112.9403,106.3988,0.5647,0.5647);

	this.shape_1124 = new cjs.Shape();
	this.shape_1124.graphics.f("#CC0000").s().p("AgDAAQACgCAFAAQABAFgDAAQgCAAgDgDg");
	this.shape_1124.setTransform(74.6473,95.4749,0.5647,0.5647);

	this.shape_1125 = new cjs.Shape();
	this.shape_1125.graphics.f("#000000").s().p("AgGAlQgWgFgXAQIAEgRQADgLgFgIQgQgPgdAKQgFACgNAKQgMAIgJAAQACgFAUgaQgFgEAFgHQAFgHgKgEQhDANglAAQA/gkAkgMQA8gVA1ALQgHAUAHAQQAIARAQABIAAAOQAAAFAHAFIAigSIAEAVQAPACAfgXIAMgmQAqAKAVAJQAjAPAEAbIgBASQgCANgGACQgLgmgWgJQgkAAgSAbIAAAMQgCAAgSgNQgNgLgMAJQgTAUg7AiQATgpgbACg");
	this.shape_1125.setTransform(80.6131,97.6344,0.5647,0.5647);

	this.shape_1126 = new cjs.Shape();
	this.shape_1126.graphics.f("#CC0000").s().p("AgBA3QAAgKgCgDQgDgCgGABQgUgFgWAPIgHACIAEgSQAFgOgFgHQgMgNgdAJQgEACgJAHQgOAMgNAAIgGAAIADgGQADgKALgOIAGgHIgCgCIAAgCQAAgDADgGIABgCIgBgBQhEAMglAAIAJgPQA7ghAggLQA4gSAyALIAQgDIgFARIAHAcQAEALAJABIAEgBIAAAOIAAAEQAAADADACIAkgTIAFAXQANABAVgPIAFgEIAOgvIAcAKQAqALALAGQAcAOAEAYIgDAOQABAHgDAJIgBACIgPAZQAAgWgLgSQgNgQgHgEQghABgQAXIAAAQIgFAAQgGgBgLgJQgPgOgJAHQgNAOghATIglAYQgEgEAHgWg");
	this.shape_1126.setTransform(80.8672,97.6899,0.5647,0.5647);

	this.shape_1127 = new cjs.Shape();
	this.shape_1127.graphics.f("#FFFFFF").s().p("AgCACIAAgDIAEAAIAAADg");
	this.shape_1127.setTransform(103.6515,91.5662,0.5647,0.5647);

	this.shape_1128 = new cjs.Shape();
	this.shape_1128.graphics.f("#FF0000").s().p("AAAgDIANgJQgFAEgFAJQgFAMgKAAQAAgIAMgIg");
	this.shape_1128.setTransform(131.2355,88.7287,0.5647,0.5647);

	this.shape_1129 = new cjs.Shape();
	this.shape_1129.graphics.f("#CC0000").s().p("AgFADQAFgLAGALg");
	this.shape_1129.setTransform(96.5226,86.7877,0.5647,0.5647);

	this.shape_1130 = new cjs.Shape();
	this.shape_1130.graphics.f("#FF0000").s().p("AgJgEIAPgKIADAdQgCgFgQgOg");
	this.shape_1130.setTransform(129.485,87.0912,0.5647,0.5647);

	this.shape_1131 = new cjs.Shape();
	this.shape_1131.graphics.f("#FF0000").s().p("AgCADIAAgFIAFAAIAAAFg");
	this.shape_1131.setTransform(128.2427,85.8207,0.5647,0.5647);

	this.shape_1132 = new cjs.Shape();
	this.shape_1132.graphics.f("#FF0000").s().p("AgFACIAIgDIADADg");
	this.shape_1132.setTransform(126.7605,85.5101,0.5647,0.5647);

	this.shape_1133 = new cjs.Shape();
	this.shape_1133.graphics.f("#FF0000").s().p("AgBADIAAgFIADAAIAAAFg");
	this.shape_1133.setTransform(129.9367,85.1149,0.5647,0.5647);

	this.shape_1134 = new cjs.Shape();
	this.shape_1134.graphics.f("#CC0000").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_1134.setTransform(73.0889,84.4937,0.5647,0.5647);

	this.shape_1135 = new cjs.Shape();
	this.shape_1135.graphics.f("#FF0000").s().p("AAbgiIg1BEQAGgSAvgyg");
	this.shape_1135.setTransform(123.6972,86.8371,0.5647,0.5647);

	this.shape_1136 = new cjs.Shape();
	this.shape_1136.graphics.f("#CC0000").s().p("AgBADIAAgFIADAAIAAAFg");
	this.shape_1136.setTransform(67.4705,84.282,0.5647,0.5647);

	this.shape_1137 = new cjs.Shape();
	this.shape_1137.graphics.f("#FF0000").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_1137.setTransform(132.3083,84.4373,0.5647,0.5647);

	this.shape_1138 = new cjs.Shape();
	this.shape_1138.graphics.f("#FF0000").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_1138.setTransform(131.8143,84.0843,0.5647,0.5647);

	this.shape_1139 = new cjs.Shape();
	this.shape_1139.graphics.f("#CC0000").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_1139.setTransform(67.7952,83.6044,0.5647,0.5647);

	this.shape_1140 = new cjs.Shape();
	this.shape_1140.graphics.f("#FF0000").s().p("AgBACIAAgEIADAAIAAAEg");
	this.shape_1140.setTransform(130.9673,83.7597,0.5647,0.5647);

	this.shape_1141 = new cjs.Shape();
	this.shape_1141.graphics.f("#FF0000").s().p("AgCACIAAgDIAFAAIAAADg");
	this.shape_1141.setTransform(145.2674,83.0538,0.5647,0.5647);

	this.shape_1142 = new cjs.Shape();
	this.shape_1142.graphics.f("#FF0000").s().p("AAAgCIADAAIgFAFg");
	this.shape_1142.setTransform(127.4381,83.3785,0.5647,0.5647);

	this.shape_1143 = new cjs.Shape();
	this.shape_1143.graphics.f("#FF0000").s().p("AgHACIAAgDIAOAAIAAADg");
	this.shape_1143.setTransform(129.5979,82.6021,0.5647,0.5647);

	this.shape_1144 = new cjs.Shape();
	this.shape_1144.graphics.f("#FF0000").s().p("AAAgBIABAAIAAADg");
	this.shape_1144.setTransform(144.8581,82.348,0.5647,0.5647);

	this.shape_1145 = new cjs.Shape();
	this.shape_1145.graphics.f("#CC0000").s().p("AATgLIglAXQAEgJAhgOg");
	this.shape_1145.setTransform(69.3056,82.4186,0.5647,0.5647);

	this.shape_1146 = new cjs.Shape();
	this.shape_1146.graphics.f("#000000").s().p("AAdBlQAAgNgFgFQgsgwgiALQgCAEgRAJQACgbgBgOQAAgWgVgJQgYgOgVAiQAAAIgDABIgHAAIACgoQABgZgYgCQg2AGgbAgQgGAAAAgGQAAgFADgEQA+hVBGgFIBnAPQADAWgDAzQACAsAcARIATgIQgBAFALAQQAJAEAQgNQAMgJACAUQAUgPAJgIQAPgOABgQQACgHgDgTQgBgPAIgHQBOAIAwAzIgCAMQgHABgIgIIgNgNQgSgLgaAdQADAVgOgGQgGgIgKABQgPATADASQgJACgYgEQgVgBgEAUQgDALgJgBQgGgIgGACIgNAYQgJANgLACIAAgSg");
	this.shape_1146.setTransform(102.014,88.5734,0.5647,0.5647);

	this.shape_1147 = new cjs.Shape();
	this.shape_1147.graphics.f("#CC0000").s().p("AAZBrQABgRgFgFQgqgtgfAKQgEAFgKAFIgKAEIgBgFQgBgGABgTQAEgjgWgJQgRgKgRAaQAAAIgIAEIABAAIgCACIABgCIgOACIgBgEQgCgGACgUQADgUgBgDQgCgHgNgBQg+AHgUAYIgBABIABAGQgIAAgFgMQgDgJAHgIIAAABQA+hXBKgFQAXAAAtAIIAnAHIAJAFQAAAFgCAIIgBAZIgCAaQAAAzAWAOQADAAAXgKIgCAPIADADIAEAGQAGACALgJQAKgIAFACQAFACACAIIAJgGQAbgVACgTIABgIIgBgLIgBgMQAAgLAJgIIABgCIAGgGQBEAGA4A9IABADIABAFQAAAJgFACIgBABIgBAAQgKABgNgPIgHgHQgPgJgWAZIAAACQAAAKgFAFQgFAEgIgEIgBAAIgBgBQgDgFgHAAQgHAJAAALIACAGIAEAHIgMADQgIACgNgCQgdgEgEAUIgBABQgFANgLgCIgCAAIgCgCQgCgEgCgBIgHAMQgPAagOACIgFABg");
	this.shape_1147.setTransform(102.0027,88.6158,0.5647,0.5647);

	this.shape_1148 = new cjs.Shape();
	this.shape_1148.graphics.f("#FF0000").s().p("AgBADIAAgFIADAAIAAAFg");
	this.shape_1148.setTransform(143.0511,80.1599,0.5647,0.5647);

	this.shape_1149 = new cjs.Shape();
	this.shape_1149.graphics.f("#FF0000").s().p("AgBgEIADAEIAAAEg");
	this.shape_1149.setTransform(145.0275,80.2023,0.5647,0.5647);

	this.shape_1150 = new cjs.Shape();
	this.shape_1150.graphics.f("#FF0000").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_1150.setTransform(113.152,77.9718,0.5647,0.5647);

	this.shape_1151 = new cjs.Shape();
	this.shape_1151.graphics.f("#FF0000").s().p("AgBAGIAAgLIADAAIAAALg");
	this.shape_1151.setTransform(125.8147,77.5907,0.5647,0.5647);

	this.shape_1152 = new cjs.Shape();
	this.shape_1152.graphics.f("#CC0000").s().p("AAAADQgEgDAEgDQgBACAEAFIgDgBg");
	this.shape_1152.setTransform(81.1105,76.5884,0.5647,0.5647);

	this.shape_1153 = new cjs.Shape();
	this.shape_1153.graphics.f("#FF0000").s().p("AgBgBIADAAIAAABIgDACg");
	this.shape_1153.setTransform(104.9785,76.4613,0.5647,0.5647);

	this.shape_1154 = new cjs.Shape();
	this.shape_1154.graphics.f("#FF0000").s().p("AAGgFIAGACIgXAJg");
	this.shape_1154.setTransform(97.3837,76.7719,0.5647,0.5647);

	this.shape_1155 = new cjs.Shape();
	this.shape_1155.graphics.f("#FF0000").s().p("AgDgCQAFAAADACIAAADIgEAAQgGAAACgFg");
	this.shape_1155.setTransform(124.8178,76.402,0.5647,0.5647);

	this.shape_1156 = new cjs.Shape();
	this.shape_1156.graphics.f("#FF0000").s().p("AgBAFIAAgIIADAAIAAAIg");
	this.shape_1156.setTransform(148.7684,75.459,0.5647,0.5647);

	this.shape_1157 = new cjs.Shape();
	this.shape_1157.graphics.f("#FF0000").s().p("AACgRIgCAjQgDgZAFgKg");
	this.shape_1157.setTransform(112.4254,76.2355,0.5647,0.5647);

	this.shape_1158 = new cjs.Shape();
	this.shape_1158.graphics.f("#FF0000").s().p("AgBACIAAgFIADACIAAAFg");
	this.shape_1158.setTransform(103.468,75.0073,0.5647,0.5647);

	this.shape_1159 = new cjs.Shape();
	this.shape_1159.graphics.f("#000000").s().p("AibBZQgSgWgYAPQgLAGgJARQgIASgJAEQgTgtAggvQAaghBEgcQACAKgKAVQgKAUADAKIAJAHIAtAAQAcgCAIgWIAAgGIAYAFQAQADAHgLIAAgSQAeAIAPgZQABgVAAgKQgBgSgSgJIgPgCIAAgGQCbhEBIBEQADAHAFgBQgIABgWgFQgVgFgNAFQgFAEgUAIQgQAGgGAKQgDAKANANQAOANAAAJIgggJQgTgGgNACQgRAPAOASIANARIghgDQgWAAgJAKQgDAIAAA1QgQgBgkgTQghgMgQAaQAFADgEAEIgFAIQgkgYgPAFQgJAJADAQQAEATgBAFIgegmg");
	this.shape_1159.setTransform(79.1851,81.7057,0.5647,0.5647);

	this.shape_1160 = new cjs.Shape();
	this.shape_1160.graphics.f("#CC0000").s().p("AjuB/QgJgTAGggQAFgfAPgVQARgWAZgNIAwgVIATgEIgEAHIABAFQAAAKgJASQgIAQAAAHIABADIAGAFQAHgBAJAAQArACAIgWIAAgJIAFAAQAGgBAKAEQAVAGAGgJIAAgWIAGACQAZAGANgVIABgcQAAgRgPgHIgFAAQgKACgDgHIACgMQBLggAqgHQBIgLAqAoIAFAKIAEAGIgDAJQgIACgTgFQgXgGgLAEQgHAGgOAFQgUAGgFAIQgCAJANALQAOAOgBAKIAAAGIgcgIQgagIgMACQgFAFAAAIQAAAIAEAGIAFAEQAIAHAAAHIAAACIAIACIgbAAQgfgEgKALQgFAPACASIAEAbIAAAEQgUgBgfgOQgpgVgQAYIACACIAAABQAAAEgEAFIgCADIAIAGIgVgHQgagSgOAEQgGAFAAAHQAAAFADAHQADAKAAAFIgDAMIgFgDQgNgIgKgTQgNgXgIgDQgHgDgRALQgJAFgJASQgIARgKAFIgCAOg");
	this.shape_1160.setTransform(79.2392,81.8668,0.5647,0.5647);

	this.shape_1161 = new cjs.Shape();
	this.shape_1161.graphics.f("#FF0000").s().p("AgEAEIAAgKQAEAFADgBQACAAgBAGQAAABgBAAQAAABAAAAQgBAAAAABQAAAAgBAAQgBAAgEgDg");
	this.shape_1161.setTransform(100.5216,74.6262,0.5647,0.5647);

	this.shape_1162 = new cjs.Shape();
	this.shape_1162.graphics.f("#FF0000").s().p("AgCACIAAgDIAFAAIAAADg");
	this.shape_1162.setTransform(150.8576,74.0615,0.5647,0.5647);

	this.shape_1163 = new cjs.Shape();
	this.shape_1163.graphics.f("#FF0000").s().p("AALgQIAGAHIgPAOQgJALgJABQAXgVAEgMg");
	this.shape_1163.setTransform(98.3154,74.965,0.5647,0.5647);

	this.shape_1164 = new cjs.Shape();
	this.shape_1164.graphics.f("#FF0000").s().p("AADgKIgDAVQgHgFAKgQg");
	this.shape_1164.setTransform(117.3859,74.118,0.5647,0.5647);

	this.shape_1165 = new cjs.Shape();
	this.shape_1165.graphics.f("#FF0000").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_1165.setTransform(153.7657,72.7063,0.5647,0.5647);

	this.shape_1166 = new cjs.Shape();
	this.shape_1166.graphics.f("#FF0000").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_1166.setTransform(131.4613,72.7063,0.5647,0.5647);

	this.shape_1167 = new cjs.Shape();
	this.shape_1167.graphics.f("#FF0000").s().p("AgIgFIATALIgHAAQgSAAAGgLg");
	this.shape_1167.setTransform(157.2587,72.8293,0.5647,0.5647);

	this.shape_1168 = new cjs.Shape();
	this.shape_1168.graphics.f("#FF0000").s().p("AgCACIAAgEIAFAAIAAAEg");
	this.shape_1168.setTransform(148.3166,71.8169,0.5647,0.5647);

	this.shape_1169 = new cjs.Shape();
	this.shape_1169.graphics.f("#FF0000").s().p("AgCABIACgBIADABg");
	this.shape_1169.setTransform(153.7939,71.5487,0.5647,0.5647);

	this.shape_1170 = new cjs.Shape();
	this.shape_1170.graphics.f("#FF0000").s().p("AgCgCIAFAAQABACgDADg");
	this.shape_1170.setTransform(113.8641,71.6617,0.5647,0.5647);

	this.shape_1171 = new cjs.Shape();
	this.shape_1171.graphics.f("#000000").s().p("Al5C1QAUg/A0gzQA1gyA8gPIAHAIQAGAGgFAEQA5A3AkgMQACgFgFgNQgDgKAMgCQAiAjATgaQAOgJgJgVQgJgLAAgBQAGgEAXAQQARANAHgZQgEgJABgkQABgagPgNQgDAAgNACQgJACgHgEQAUggAigEQAWgXAmgRQAtgRAWgJQA6gOBAAfQBHArAkARIAAAKQgOAAgkgRQgggPgXAFQgOgJgUAEQgYAEgIgCQgGAEgLAFQgKAFgBAKQgJBMAuAxIAAAHQAAAEgFACQgJgCgKgOQgLgPgIgCQgZgXg5ACQgbAhAfAzIgEAPQgIgEgOgPQgOgLgPAFQgVAKgFAnQABAGAWAwQgMgBgmgdIgDADQgCgLgRgIQgSgHgOAHQgCABgQAPIgDASQgFgBgUgRQgOgMgMAFQgeAUgMAgIgJALQgGAHgHgEQANgzgzgnQgUgHgWARIghAdQgKAHgRAYQgQAVgNAGg");
	this.shape_1171.setTransform(141.3148,81.216,0.5647,0.5647);

	this.shape_1172 = new cjs.Shape();
	this.shape_1172.graphics.f("#FF0000").s().p("Al+C0IABgCQAUg/A3g1QA3g1A+gOIAFgJIAHALQAFAJAAADIADAJIAiAgQAUAOAUgGIAAgCQABgEgDgEIgCgJIACgFQACgFAJgCIACAAIACACQAUAUAMgBQAIAAAHgKIABgBIAAAAQAKgHgHgRIgEgEQgGgGAAgEIAAgCIACgCQALgHATAPQAMAKACgCQAEAAADgMQgEgLABgLIABgZQAAgVgMgLIgKABQgNADgJgFIgDgCIACgEQATggAkgGQAbgcBFgaIAfgNQAwgLAxARQAeALA1AgQAiAUATAJIACACIAAARIgEAAQgRgBgbgOQgkgSgZAFIgBAAIgBAAQgOgIgWAEQgTADgIgBIgIAEQgQAHgBAJIgBAVQAAA9AkAnIABADIAAAEIABADQAAAHgHADIgBAAIgCAAQgKgCgNgRQgJgMgGgDIgCgBQgXgUg1ABQgLAOAAARQAAAXAQAXIABADIAAAIQAAAHgHAEIgBACIgSgOQgSgSgOAFQgSAJgFAjQACAPAOAYIAVAZIgTgFQgSgBgZgWIgHgFIgGAGIgCgIQgCgJgNgGQgQgHgNAHQgLADADAOIACANQgRALgXgWQgQgQgJAFQgdATgNAeIgBACIgFAHQgJAOgMgFIgDgCIABgEQAMgwgwgkQgUgIggAeIgTAQQgLAHgNATQgSAagOAGIgEACg");
	this.shape_1172.setTransform(141.3148,81.2519,0.5647,0.5647);

	this.shape_1173 = new cjs.Shape();
	this.shape_1173.graphics.f("#FF0000").s().p("AgCAAIABAAQABABAHACQgIgCgFAGIAEgHgAgDgHIAFAAIgDAEIgCgEg");
	this.shape_1173.setTransform(111.7403,70.8288,0.5647,0.5647);

	this.shape_1174 = new cjs.Shape();
	this.shape_1174.graphics.f("#FF0000").s().p("AADgMQgCAFAFACIAGgFQgCAQgMADIgJAEg");
	this.shape_1174.setTransform(110.4557,70.7582,0.5647,0.5647);

	this.shape_1175 = new cjs.Shape();
	this.shape_1175.graphics.f("#FF0000").s().p("AALAPIgBgEQAGAGgBAAIgEgCgAAKALIgCgBQgHgHgIAEIgJAAQAAgHALgFQAOgJACgCIAGAAQgTAGAJAJQAIABgDAEIgCAHIAAAAg");
	this.shape_1175.setTransform(107.8441,70.2571,0.5647,0.5647);

	this.shape_1176 = new cjs.Shape();
	this.shape_1176.graphics.f("#FF0000").s().p("AggASIBBgjIgyAjg");
	this.shape_1176.setTransform(105.8678,69.9535,0.5647,0.5647);

	this.shape_1177 = new cjs.Shape();
	this.shape_1177.graphics.f("#000000").s().p("Ak5BfQgXgTgcAEQgdAJgyAkQABgTASgaQAWgcAIgPQBIg8AlgZQBFgtA6gGQgJAMAFAKIAIARQArAhBZAcQAEgDABgVQABgRANgDQAQAUAKAHQAQAOARgHQATgHAHgYIAKgqIADAAIAeA2QAxgTAghQQAAgGgLgKQgKgKAGgHIA4ABQAfACASAMQBoAXAsA+QgjgchJgCQgVAMAkAaQAXAYABANQgVgFgngYQglgWgXgDQgWABgIAWQgEANgGAaIAQAkQgGABgkgIQgcgHgNAQQgQATgQAwQgBAOADAQQgOACgLgSIgUgdQgigVgFgCQgZgIgKAcIgpgVQgZgJgSAPQgLALADAXQADAdgJAVQgLgKgbgfQgagbgVgDQg7AVgKApQgCAEAEAHQADAGgFAEQghg1gbgNg");
	this.shape_1177.setTransform(119.8716,72.3957,0.5647,0.5647);

	this.shape_1178 = new cjs.Shape();
	this.shape_1178.graphics.f("#FF0000").s().p("AkHCSQgcgrgbgNQgUgSgWAEQgWAHgmAdIgaAOIAAgLQAAgTAdgnIAUgcIATgRQA7gzAjgXQA6glA2gFIAAgCIARgLQACAEAAAXQAAAPAOAGQAyAoBCAVIACgRQAAgXAJgVIAKAQIAMANQAaAdASgIQAVgIAIgqIAHgkIAkBCQApgMAPgcQALgjAIgTQAAgEgHgHQgKgJAAgHQAAgDADgGIABgBIAYAAQA+ABAXAOQBqAXAsA/IgHAHQghgbhGgCQgGAEAAADQAAAGASAOIAFAEIACACQAWAVABAQIAAAGIgFgBQgXgFgjgWQgngYgXgDQgWABgIAmIgFASIAGAMQAKAQAAAIIAAAEIgDABQgLACgVgHQgGgCgEgDQgCgCgMgBIgJAEIgIAFQgQAIgJAgQgFASgIAKQADAHAAAGIgBAVIgEABQgUACgRgfQgIgOgEgDIgJgGQgfgVgNAEQgJADgGAPIAEAMIgWgRQgugYgUAQQgJAJACAZQAFAZgHATIAFAYIgsgvIgYgaQgOgNgPgCQgvARgKAfIgEAHQgFAJABACQACADABAFQgBAEgEAEIgCAMgAjwB9IABgBQAEgGgGALIABgEg");
	this.shape_1178.setTransform(119.8857,72.7063,0.5647,0.5647);

	this.shape_1179 = new cjs.Shape();
	this.shape_1179.graphics.f("#FF0000").s().p("AgCgEIAFAFIAAAEg");
	this.shape_1179.setTransform(112.0227,61.5118,0.5647,0.5647);

	this.shape_1180 = new cjs.Shape();
	this.shape_1180.graphics.f("#FF0000").s().p("AAEgOIAAAJIgHAUg");
	this.shape_1180.setTransform(94.0663,61.7941,0.5647,0.5647);

	this.shape_1181 = new cjs.Shape();
	this.shape_1181.graphics.f("#FF0000").s().p("AABgDIAAAFIgBACg");
	this.shape_1181.setTransform(112.7567,60.1425,0.5647,0.5647);

	this.shape_1182 = new cjs.Shape();
	this.shape_1182.graphics.f("#FF0000").s().p("AgEAEQAAgHAIAAQABABgGAGg");
	this.shape_1182.setTransform(106.1652,60.1425,0.5647,0.5647);

	this.shape_1183 = new cjs.Shape();
	this.shape_1183.graphics.f("#FF0000").s().p("AgCgIIAFALIgFAGg");
	this.shape_1183.setTransform(94.4898,59.7472,0.5647,0.5647);

	this.shape_1184 = new cjs.Shape();
	this.shape_1184.graphics.f("#FF0000").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_1184.setTransform(115.453,58.4061,0.5647,0.5647);

	this.shape_1185 = new cjs.Shape();
	this.shape_1185.graphics.f("#FF0000").s().p("AgCACIAAgDIAFAAIAAADg");
	this.shape_1185.setTransform(109.2276,58.4061,0.5647,0.5647);

	this.shape_1186 = new cjs.Shape();
	this.shape_1186.graphics.f("#FF0000").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_1186.setTransform(107.7171,57.5591,0.5647,0.5647);

	this.shape_1187 = new cjs.Shape();
	this.shape_1187.graphics.f("#FF0000").s().p("AgCgJQABADADAGQACAGgEAEg");
	this.shape_1187.setTransform(85.6497,57.9544,0.5647,0.5647);

	this.shape_1188 = new cjs.Shape();
	this.shape_1188.graphics.f("#FF0000").s().p("AgMACQAOgGAKACQgEAAgHADQgEACgDAAIgGgBg");
	this.shape_1188.setTransform(104.3573,57.3519,0.5647,0.5647);

	this.shape_1189 = new cjs.Shape();
	this.shape_1189.graphics.f("#FF0000").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_1189.setTransform(102.9457,56.0345,0.5647,0.5647);

	this.shape_1190 = new cjs.Shape();
	this.shape_1190.graphics.f("#FF0000").s().p("AgBgCIADAAQAAACgDADg");
	this.shape_1190.setTransform(87.4314,56.3168,0.5647,0.5647);

	this.shape_1191 = new cjs.Shape();
	this.shape_1191.graphics.f("#FF0000").s().p("AgGAAIACgEIALAJg");
	this.shape_1191.setTransform(98.146,56.0627,0.5647,0.5647);

	this.shape_1192 = new cjs.Shape();
	this.shape_1192.graphics.f("#FF0000").s().p("AAAABIAAgBIABAAIAAABg");
	this.shape_1192.setTransform(75.517,55.7098,0.5647,0.5647);

	this.shape_1193 = new cjs.Shape();
	this.shape_1193.graphics.f("#FF0000").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_1193.setTransform(90.3536,54.8346,0.5647,0.5647);

	this.shape_1194 = new cjs.Shape();
	this.shape_1194.graphics.f("#FF0000").s().p("AAFgFIACACIgNAJg");
	this.shape_1194.setTransform(88.6031,55.1452,0.5647,0.5647);

	this.shape_1195 = new cjs.Shape();
	this.shape_1195.graphics.f("#FF0000").s().p("AgKAHQACgEgEgCQAIACAGgFIANgIQgCAHgLAEQgMAGgEAEIAEgEg");
	this.shape_1195.setTransform(96.3814,55.1028,0.5647,0.5647);

	this.shape_1196 = new cjs.Shape();
	this.shape_1196.graphics.f("#FF0000").s().p("AggAbIBBg2QABAMgJAKQgFAGgMALQgIgGgLAKQgOAMgHAAIAAgBg");
	this.shape_1196.setTransform(107.7885,55.6398,0.5647,0.5647);

	this.shape_1197 = new cjs.Shape();
	this.shape_1197.graphics.f("#FF0000").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_1197.setTransform(87.2903,53.6347,0.5647,0.5647);

	this.shape_1198 = new cjs.Shape();
	this.shape_1198.graphics.f("#FF0000").s().p("AgBADIAAgFIADAAIAAAFg");
	this.shape_1198.setTransform(110.9357,53.4653,0.5647,0.5647);

	this.shape_1199 = new cjs.Shape();
	this.shape_1199.graphics.f("#FF0000").s().p("AAAgDIABAAIAAAIg");
	this.shape_1199.setTransform(77.7192,53.4935,0.5647,0.5647);

	this.shape_1200 = new cjs.Shape();
	this.shape_1200.graphics.f("#FF0000").s().p("AgBADIAAgFIADAAIAAAFg");
	this.shape_1200.setTransform(87.6432,52.9571,0.5647,0.5647);

	this.shape_1201 = new cjs.Shape();
	this.shape_1201.graphics.f("#FF0000").s().p("AgCACIAAgDIAFAAIAAADg");
	this.shape_1201.setTransform(156.6455,52.6183,0.5647,0.5647);

	this.shape_1202 = new cjs.Shape();
	this.shape_1202.graphics.f("#FF0000").s().p("AgBACIAAgEIADAAIAAAEg");
	this.shape_1202.setTransform(76.1946,52.7594,0.5647,0.5647);

	this.shape_1203 = new cjs.Shape();
	this.shape_1203.graphics.f("#FF0000").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_1203.setTransform(82.533,52.2795,0.5647,0.5647);

	this.shape_1204 = new cjs.Shape();
	this.shape_1204.graphics.f("#FF0000").s().p("AgCACIAAgDIAFAAIAAADg");
	this.shape_1204.setTransform(145.7756,51.9407,0.5647,0.5647);

	this.shape_1205 = new cjs.Shape();
	this.shape_1205.graphics.f("#FF0000").s().p("AgCADIAAgEIAFAAIAAAEg");
	this.shape_1205.setTransform(161.7275,51.2631,0.5647,0.5647);

	this.shape_1206 = new cjs.Shape();
	this.shape_1206.graphics.f("#FF0000").s().p("AgIACQAGgIAAgEIACAEQgDADACAGQACAJgKABQgDgEAEgHgAADgKIgCACIgBACIAAAAIABgCIACgEIAJALIgEADQgDgKgCgCg");
	this.shape_1206.setTransform(135.3002,52.1524,0.5647,0.5647);

	this.shape_1207 = new cjs.Shape();
	this.shape_1207.graphics.f("#FF0000").s().p("AgCADIAAgFIAEAAIAAAFg");
	this.shape_1207.setTransform(139.9878,50.9102,0.5647,0.5647);

	this.shape_1208 = new cjs.Shape();
	this.shape_1208.graphics.f("#FF0000").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_1208.setTransform(138.2797,50.7831,0.5647,0.5647);

	this.shape_1209 = new cjs.Shape();
	this.shape_1209.graphics.f("#FF0000").s().p("AgBADIAAgFIADAAIAAAFg");
	this.shape_1209.setTransform(158.1983,50.4161,0.5647,0.5647);

	this.shape_1210 = new cjs.Shape();
	this.shape_1210.graphics.f("#FF0000").s().p("AgDAAQgEgHAGgFQAEADABAHIACAKIgEAFIgFgNg");
	this.shape_1210.setTransform(136.4558,51.0654,0.5647,0.5647);

	this.shape_1211 = new cjs.Shape();
	this.shape_1211.graphics.f("#FF0000").s().p("AgCACIAAgDIAFAAIAAADg");
	this.shape_1211.setTransform(137.0798,50.0773,0.5647,0.5647);

	this.shape_1212 = new cjs.Shape();
	this.shape_1212.graphics.f("#FF0000").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_1212.setTransform(78.9614,49.8938,0.5647,0.5647);

	this.shape_1213 = new cjs.Shape();
	this.shape_1213.graphics.f("#FF0000").s().p("AAAgEIABAEIAAAFg");
	this.shape_1213.setTransform(90.65,49.4279,0.5647,0.5647);

	this.shape_1214 = new cjs.Shape();
	this.shape_1214.graphics.f("#FF0000").s().p("AgIgHQAEAIANAGIgDABQgIAAgGgPg");
	this.shape_1214.setTransform(79.6955,49.4339,0.5647,0.5647);

	this.shape_1215 = new cjs.Shape();
	this.shape_1215.graphics.f("#FF0000").s().p("AgCAAIACAAIADABg");
	this.shape_1215.setTransform(75.277,49.075,0.5647,0.5647);

	this.shape_1216 = new cjs.Shape();
	this.shape_1216.graphics.f("#FF0000").s().p("AgCgGQAHAGgCAHg");
	this.shape_1216.setTransform(135.4253,49.2867,0.5647,0.5647);

	this.shape_1217 = new cjs.Shape();
	this.shape_1217.graphics.f("#FF0000").s().p("AAAAHQgFgDADgEQADgEABgDIACAMQgCADgCAAIAAgBg");
	this.shape_1217.setTransform(138.3973,47.7359,0.5647,0.5647);

	this.shape_1218 = new cjs.Shape();
	this.shape_1218.graphics.f("#FF0000").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_1218.setTransform(158.0007,46.8446,0.5647,0.5647);

	this.shape_1219 = new cjs.Shape();
	this.shape_1219.graphics.f("#FF0000").s().p("AgBADIAAgFIADAAIAAAFg");
	this.shape_1219.setTransform(139.1408,46.6893,0.5647,0.5647);

	this.shape_1220 = new cjs.Shape();
	this.shape_1220.graphics.f("#FF0000").s().p("AgIABIAGgDIALAFg");
	this.shape_1220.setTransform(90.043,46.774,0.5647,0.5647);

	this.shape_1221 = new cjs.Shape();
	this.shape_1221.graphics.f("#FF0000").s().p("AAAAHIAAgNIABAAIAAANg");
	this.shape_1221.setTransform(143.0229,46.534,0.5647,0.5647);

	this.shape_1222 = new cjs.Shape();
	this.shape_1222.graphics.f("#FF0000").s().p("AgFAAIAIAAIADABg");
	this.shape_1222.setTransform(82.0671,46.1811,0.5647,0.5647);

	this.shape_1223 = new cjs.Shape();
	this.shape_1223.graphics.f("#FF0000").s().p("AgBADIAAgFIADAAIAAAFg");
	this.shape_1223.setTransform(91.5676,45.4752,0.5647,0.5647);

	this.shape_1224 = new cjs.Shape();
	this.shape_1224.graphics.f("#FF0000").s().p("AgCABQADgEABgDQADADgCADIgDAHQgEgCACgEg");
	this.shape_1224.setTransform(139.7573,45.7576,0.5647,0.5647);

	this.shape_1225 = new cjs.Shape();
	this.shape_1225.graphics.f("#FF0000").s().p("AgCACIAAgDIAFAAIAAADg");
	this.shape_1225.setTransform(123.6548,45.2917,0.5647,0.5647);

	this.shape_1226 = new cjs.Shape();
	this.shape_1226.graphics.f("#FF0000").s().p("Ag1ANIAQgKQAHABAIgBIgnASQgCgDAKgFgAgOAAQAAAAAAgBQAAgBAAAAQAAgBAAAAQgBgBAAAAQBGgPAHgBQgBADgSAEQgMAEADALQgEgOgPAGQgUAGgEgCIgFACQgBABgFACIgCAAg");
	this.shape_1226.setTransform(69.395,46.294,0.5647,0.5647);

	this.shape_1227 = new cjs.Shape();
	this.shape_1227.graphics.f("#FF0000").s().p("AgdAAQAugHAIABQgCAJAHAFg");
	this.shape_1227.setTransform(74.8958,45.1896,0.5647,0.5647);

	this.shape_1228 = new cjs.Shape();
	this.shape_1228.graphics.f("#FF0000").s().p("AgHgEIgUgIQAjgHAUAhIgjgSg");
	this.shape_1228.setTransform(132.4495,45.1737,0.5647,0.5647);

	this.shape_1229 = new cjs.Shape();
	this.shape_1229.graphics.f("#FF0000").s().p("AgDAEQgDgEAEgCQAEgEADAFQAAABgDAEg");
	this.shape_1229.setTransform(125.7895,44.6581,0.5647,0.5647);

	this.shape_1230 = new cjs.Shape();
	this.shape_1230.graphics.f("#FF0000").s().p("AAAAEQgLACgEgHIAfgCQACAHgNAAIgFAAg");
	this.shape_1230.setTransform(78.574,44.6837,0.5647,0.5647);

	this.shape_1231 = new cjs.Shape();
	this.shape_1231.graphics.f("#FF0000").s().p("AAAgBQgsgFgaACQAlgIBoATg");
	this.shape_1231.setTransform(84.354,44.846,0.5647,0.5647);

	this.shape_1232 = new cjs.Shape();
	this.shape_1232.graphics.f("#FF0000").s().p("AgCgJIAGAAIgBATQgIgCADgRg");
	this.shape_1232.setTransform(124.3623,44.6282,0.5647,0.5647);

	this.shape_1233 = new cjs.Shape();
	this.shape_1233.graphics.f("#FF0000").s().p("AgMADIAOgFIALAFg");
	this.shape_1233.setTransform(128.7086,44.0918,0.5647,0.5647);

	this.shape_1234 = new cjs.Shape();
	this.shape_1234.graphics.f("#FF0000").s().p("AgFAAIgEAMQgDgKAHgCgAgFAAIACgLQAEAAAFAGQAFAFAAAGQgDgGgNAAg");
	this.shape_1234.setTransform(140.914,44.0918,0.5647,0.5647);

	this.shape_1235 = new cjs.Shape();
	this.shape_1235.graphics.f("#FF0000").s().p("AAAgEIABAAIAAAKg");
	this.shape_1235.setTransform(124.7842,43.386,0.5647,0.5647);

	this.shape_1236 = new cjs.Shape();
	this.shape_1236.graphics.f("#000000").s().p("AAIChQAGgQABgMQAQgjguguQgLgSgVAIIgiAQQgIAMgXAXQgTAWgEASIgMAMQgBgRAKg0QAHgugGgbQgQgKgTgDQgNgBgdAAQhIAtgjAyIgQAKQAohqgJgyQgVgggtgUQgUgJhIATQgbAHg4AGQBLgsArgPQBEgaBFgJQCUgVCBAtIAVgEIAHAGQAEAEgCAFQgKACgDASQgCAPgKgEQgOAnAhA8QAQAPAJAFQAPAKAOgHQAQgVARgLQAHAGgDAPQgCAOAEAFQAjAmAXgMQALgDAJgOQAMgRANgFQgJAwACgBQAdAIAegXQAOgLAeghQAQgMAXALQAbAPANADQBuBZA6AcIgHAHQgUAEgngUQglgTgYAHQgWAHgYAgQgaAggUAIQAAgUgBgLQgCgUgNgHIgqgLQgJAFgRAVQgOASgLABIgRgmQgLgWgUAFQgZAeg9AXQhJAdgRAMIAMggg");
	this.shape_1236.setTransform(92.4429,53.9321,0.5647,0.5647);

	this.shape_1237 = new cjs.Shape();
	this.shape_1237.graphics.f("#FF0000").s().p("AAACTQAHgNABgHIAAgBIACgMQAKgYgpgqQgHgLgFAAIgRAJQgKAFgVAHIgMAaQgHAIgQANQgOALgDAMIgBADIgaAZIAAgZIAFgOQAHgeADgOQAEgeAAgPQABgMgEgQQgLgHgKAAIgYABIgQAAIg7AjQglAZgTAbIgKAEIgFAFIgXAOIAghDQAPg4AAgaQAAgMgCgKQgUgdgrgTQgjgHgvAMQg+AQgfABQgJAUAQAFQAKADABgHQABgHgHgGQAFABAJADQACAKgFAHIgMAOIgIgDQgFgLgMgFQAEgRgBgJQAVgOAOgJQA+glBJgXQAwgOAogGQBCgBAfgHQARgEAcAFQAgAHAOACQAeAFAVAFIAYAHQATAIAFgBIATgEIADABIAFAFIAMAGQAJAFgDAFIgNACIALAAQgHACgCAOQgDAMgFADQgCACgFgBQgCAMAAAHQAAA0AKAUIAMAKQAXATANgGQAQgVARgLIATgPIAAATQABAKgDAOQgCALACADIACACQARASAFADQAKAHAOgIQAHgBAKgPQAZgYAJgNIAAAkQgBAIgDAMQgBAJAOgCQAfgDAsgzIAFgFQAWgQARACQAJAAATALIAQAIIALAIQAmAhAWAQQBPA/AMAGIAZAEIgXAMIgDABQgWAFgngUIgWgLQgKgEgPAFQgWAHgXAfQgaAhgVAHIgSABIAAgbQAAgbgOgHQgHgFgTgDIgMgCQgJAEgKAZQgRAWgJABIgIABIgDgKQgGgGgHgUQgKgcgXAFQgXAZhKAcQgpAPgbASIgYAVQAEggARgeg");
	this.shape_1237.setTransform(92.584,54.2662,0.5647,0.5647);

	this.shape_1238 = new cjs.Shape();
	this.shape_1238.graphics.f("#FF0000").s().p("AgEgLQALgCgCAJQgEAOABACIgBAAQgEAAgBgXg");
	this.shape_1238.setTransform(122.5903,43.2448,0.5647,0.5647);

	this.shape_1239 = new cjs.Shape();
	this.shape_1239.graphics.f("#FF0000").s().p("AgBADIAAgFIADAAIAAAFg");
	this.shape_1239.setTransform(142.2041,42.0872,0.5647,0.5647);

	this.shape_1240 = new cjs.Shape();
	this.shape_1240.graphics.f("#FF0000").s().p("AgCACIAAgDIAFAAIAAADg");
	this.shape_1240.setTransform(142.8676,41.9037,0.5647,0.5647);

	this.shape_1241 = new cjs.Shape();
	this.shape_1241.graphics.f("#FF0000").s().p("AgCAIQgFgEADgFQADgFAEgBQAFADgDAEIgEAIg");
	this.shape_1241.setTransform(125.3792,42.1155,0.5647,0.5647);

	this.shape_1242 = new cjs.Shape();
	this.shape_1242.graphics.f("#FF0000").s().p("AgDAEQgWgRgBgQQALAEAMAYQAJAUASAAQAFAAgDAEIgFAHQgCgGgWgUg");
	this.shape_1242.setTransform(142.0686,42.8637,0.5647,0.5647);

	this.shape_1243 = new cjs.Shape();
	this.shape_1243.graphics.f("#FF0000").s().p("AgGgEQAIgDAFAHIAAADQgCADgDAAQgEAAgEgKg");
	this.shape_1243.setTransform(139.0561,40.8367,0.5647,0.5647);

	this.shape_1244 = new cjs.Shape();
	this.shape_1244.graphics.f("#FF0000").s().p("AgDADQgDgIALAEQABABgEADg");
	this.shape_1244.setTransform(120.3593,40.6408,0.5647,0.5647);

	this.shape_1245 = new cjs.Shape();
	this.shape_1245.graphics.f("#FF0000").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_1245.setTransform(118.5305,40.2097,0.5647,0.5647);

	this.shape_1246 = new cjs.Shape();
	this.shape_1246.graphics.f("#FF0000").s().p("AACAEQgMgJAAgHQATAAACAVIgCAEQgBgEgGgFg");
	this.shape_1246.setTransform(137.7427,40.8873,0.5647,0.5647);

	this.shape_1247 = new cjs.Shape();
	this.shape_1247.graphics.f("#FF0000").s().p("AgBACIAAgDIADAAIAAADg");
	this.shape_1247.setTransform(117.6835,40.0262,0.5647,0.5647);

	this.shape_1248 = new cjs.Shape();
	this.shape_1248.graphics.f("#FF0000").s().p("AgBgEQACgBACAFIAAAEIgDABQgDAAACgJg");
	this.shape_1248.setTransform(126.3845,39.7326,0.5647,0.5647);

	this.shape_1249 = new cjs.Shape();
	this.shape_1249.graphics.f("#FF0000").s().p("AgDACQgLgGgKAFIgCgJIA1AGQACACgHgBQgLgDgCAHQADAFAAABIgBAAQgEAAgKgHg");
	this.shape_1249.setTransform(135.4326,39.6482,0.5647,0.5647);

	this.shape_1250 = new cjs.Shape();
	this.shape_1250.graphics.f("#FF0000").s().p("AgCACIAAgDIAFAAIAAADg");
	this.shape_1250.setTransform(129.4568,38.1628,0.5647,0.5647);

	this.shape_1251 = new cjs.Shape();
	this.shape_1251.graphics.f("#FF0000").s().p("AgCACIAAgDIAEAAIAAADg");
	this.shape_1251.setTransform(124.9959,37.9934,0.5647,0.5647);

	this.shape_1252 = new cjs.Shape();
	this.shape_1252.graphics.f("#000000").s().p("AAQDWQAAgRAigYQAggWgFgbQACgugmgXQgIgBgRgHQgPgEgIAIIAAAGQgBACgOgEQAAAOgPABQgWABgCABQgNAGggAeQgcAZgVADQADgLATgPQAUgPADgKQATgHAIgWIAKgpIgJglQgGgWgSgJQhEgZgjAKQgcAQggAmIgzA8QgCgMAJgUQAKgVABgKQAFgngCgVQgCgmgZgNQgogIg4AJIhdARQgSAMAAAJQAHAIAIgCIAJgJQAAAFgJAHQgMAFgKgOQgJgNgOAKIgTAHQAXgRBGggQBAgdAagZIBngZQCcAFBIAIQCAAPBcAmQAHAOgOAFQgUAHgDAFQgzBCAeA+QAHATAUAAIAPgMQAKgHAIAAQAKAGgCAkQgBAbAXgLQAEgMAPgMQARgMAGgHQADADgBAVQAAARAOgCQBHgvgShGQgMgHAEgMQBrgLBAAWQAHADASAOQANAMANABQA6A+AJAlQgMgCgSgNQgTgNgLgCIgXgSQgOgIgPAFQgDAFgPAGQgMAGgCAKQgEAFgEAZQgCATgPABQABgQgZgZQgjgGgiAeQgUARgjAlQgEgDgCgRQgCgNgNAAQgXAFgXAUIgoAjQgXALguAYQgmATghAAIgDAAg");
	this.shape_1252.setTransform(138.5903,49.147,0.5647,0.5647);

	this.shape_1253 = new cjs.Shape();
	this.shape_1253.graphics.f("#FF0000").s().p("AAUDdIgFAAIAAgFQAAgTAggVQAegXAAgTIAAgMQAAgogigVIgQgEQgSgHgIAGIAAAFIgBACQgDAGgLgFQgCAGgCABQgGAGgQAAQgLAAgEACQgMAGgaAXQghAggYADIgGABIABgGQADgOAWgQQASgNACgJIABgCIACgBQAWgIAJgtIACgNIgEgUQgHgigSgJIgFgCQgOgFgdgNQgZgIgVAFQgdAQg2BCIgvA5IACgVQgBgJAFgLIAKgSQAIgQABgJIABgVQAGg3gggRQhPgQg2AKIgxAJIgEADQgJAGgCAGQAFAEADAAIAQgPIAAALQAAAFgHAGIgEAEIgBAAQgQAHgLgRQgFgGgCAAQgEAAgGAEIgDADIghAGIAbgUQAYgSA1gWQBAgbAagZIACgBICCgeQESAJCWA+IABABIABACQAEAGAAAEIgBAFQgDAHgOAFQgNAEgDAFQgeAlAAAtQAAAWAKATQAFAPAQABIAIgGQAPgNALAAIABAAIABABQAOAIgDAgQgBASAEACQACACAJgEQAFgOAXgRIASgOIACACQAGAEgBARQgBAOACACQABABAEAAQA2gkAAg0QAAgKgDgMQgKgHAAgKIABgGIABgDIAEgBQBtgKBAAWQAJAEAMALQARAOAMABIACAAIAEAFQA4A7AIAmIACAHIgHgBQgNgCgUgOQgRgMgKgCIgBgBIgJgHQgXgTgPAFQgGAGgKAFQgNAFgCAIIAAACIgBABQgEAFgBAPQgDAegUABIgFAAIAAgFIAAgCQAAgNgRgSIgEgDQglgHg2A4IgeAeIgEgCQgGgGgBgNQgCgNgIAAQgaAGgmAjIgVATIgkASQhBAkgqAAIgCAAg");
	this.shape_1253.setTransform(138.3503,49.0052,0.5647,0.5647);

	this.shape_1254 = new cjs.Shape();
	this.shape_1254.graphics.f("#FFFFFF").s().p("AgCADIAAgFIAFAAIAAAFg");
	this.shape_1254.setTransform(187.5892,64.688,0.5647,0.5647);

	this.shape_1255 = new cjs.Shape();
	this.shape_1255.graphics.f("#FFFFFF").s().p("AgFgHIALALQgCgBgEAFg");
	this.shape_1255.setTransform(183.7354,64.7586,0.5647,0.5647);

	this.shape_1256 = new cjs.Shape();
	this.shape_1256.graphics.f("#000000").s().p("AgrBNQgRgGgFgTIgFgjIAEgMQADgGAIADQAIAEAYAVQATAQAMABQgEgJgNgKQgPgLgEgGIAPAAIAOAOQAKAIAIgFQgTgMgBgLQAIgCARAPQAMALAIgSIgNgbIAHAAQADgCgDgFIgEgIQAHABAFALQAHAOACACQAOgdgfgWQgBgIgPgDQgLgCAMgJQAlANAKAvQALAohBAvQgQAMgVAAQgKAAgMgDg");
	this.shape_1256.setTransform(186.4026,63.1917,0.5647,0.5647);

	this.shape_1257 = new cjs.Shape();
	this.shape_1257.graphics.f("#000000").s().p("AgLAaIAJgJQgRgCgHgPIAagDQAAgEgJgEQgHgEABgGIAYALQAFgDgDgFIgFgJQAHgDAFAFIAJAKQgEAEgGAVQgFARgOACg");
	this.shape_1257.setTransform(187.9845,39.3611,0.5647,0.5647);

	this.shape_1258 = new cjs.Shape();
	this.shape_1258.graphics.f("#000000").s().p("AgDAAIAEAAIADABg");
	this.shape_1258.setTransform(192.8547,37.344,0.5647,0.5647);

	this.shape_1259 = new cjs.Shape();
	this.shape_1259.graphics.f("#000000").s().p("AgCADIAAgFIAFAAIAAAFg");
	this.shape_1259.setTransform(190.836,36.6382,0.5647,0.5647);

	this.shape_1260 = new cjs.Shape();
	this.shape_1260.graphics.f("#FFFFFF").s().p("AgBADIAAgFIADAAIAAAFg");
	this.shape_1260.setTransform(135.0187,30.8504,0.5647,0.5647);

	this.shape_1261 = new cjs.Shape();
	this.shape_1261.graphics.f("#000000").s().p("AgEAyQgWACgagvQAJgGAOASQAOAUAPgLQgBgEgKgJQgHgHACgGIAaAUQAFgEgFgGQgGgHAEgDIAUALQAJgLgMgQQgPgVAAgJQAHgHAOALQAMAKAKAnQgIAHgIAeQgFgFgOAFQgOAGgGAAIgCAAg");
	this.shape_1261.setTransform(152.354,30.0224,0.5647,0.5647);

	this.shape_1262 = new cjs.Shape();
	this.shape_1262.graphics.f("#FFFFFF").s().p("AAEgIIAcgOQgaARglAcQAJgQAagPg");
	this.shape_1262.setTransform(138.2515,28.4788,0.5647,0.5647);

	this.shape_1263 = new cjs.Shape();
	this.shape_1263.graphics.f("#FFFFFF").s().p("ABFgUQgpAQhgAYQBegjArgFg");
	this.shape_1263.setTransform(151.9164,21.7592,0.5647,0.5647);

	this.shape_1264 = new cjs.Shape();
	this.shape_1264.graphics.f("#FFFFFF").s().p("AhjKBQhjgXgsgRQhNgcg0gwIhbhoQg5hBgggrQgGgHABgVQABgRgRgCQgshbgQguQgchPAAhIQAAg6APhHIAeh7QAYgvATgaIAAgJQBwh5B3g/QARgUAogPIBDgZQAQgJA0gOQArgLATgTQAFACAYgBQAOAAACATQAFACAHgHQgGgKABgDIARAAQACAKANAEIAUAHIADgPQBxAHA7AMQBcATA9AuQAVAHAZAUQAcAXAOAKQBiBfAoBAQgCgBgGAAIgEACQAYAEAJAcQAMAhANAIQAqA2ABBkQABA4gFBsQgvCihuC7QgnBChRA6QABACAIAAQgXAYglASIhDAcQgRgFgZARQghACgvAMIhPAWQgtALgmAAQgqAAgigNg");
	this.shape_1264.setTransform(162.1518,57.0585,0.5647,0.5647);

	this.shape_1265 = new cjs.Shape();
	this.shape_1265.graphics.f("#000000").s().p("AlIJNQg4gsg+hKQgkgphEhVQgFgXghgjQggghgDgYQgVglgQg3IgXhjQAEgWgBg+QgCg1ALgbQgGgEAFgIQAFgIgEgDIAGgHQARjnEHivQAWgGAogZQAngYAXgFIAAgHQAKADAMgGQAMgIAIgEQBFgeBjgBQA9gBBvAOIA1AMQBTANAjAUQBFAuAkAPQCuCBBoEDQAoDMiCEJQgDAMgNAbQgLAXgBANIADgCIhgB0Qg3A8g7AiQhQAoiAASQgGAEgVAHQgRAFgFAHQg3AJg0AAQilAAiVhWg");
	this.shape_1265.setTransform(162.1395,56.9512,0.5647,0.5647);

	this.shape_1266 = new cjs.Shape();
	this.shape_1266.graphics.f("#660000").s().p("AgBgJIADAGIAAANg");
	this.shape_1266.setTransform(80.5143,268.7727,0.5647,0.5647);

	this.shape_1267 = new cjs.Shape();
	this.shape_1267.graphics.f("#660000").s().p("AAAAQIAAgfIABAAIAAAfg");
	this.shape_1267.setTransform(77.9168,258.7358,0.5647,0.5647);

	this.shape_1268 = new cjs.Shape();
	this.shape_1268.graphics.f("#660000").s().p("AAAgPQACABAAAeQgGgNAEgSg");
	this.shape_1268.setTransform(79.8314,257.9311,0.5647,0.5647);

	this.shape_1269 = new cjs.Shape();
	this.shape_1269.graphics.f("#660000").s().p("AgBgEIADAAIAAAJg");
	this.shape_1269.setTransform(77.5498,255.7289,0.5647,0.5647);

	this.shape_1270 = new cjs.Shape();
	this.shape_1270.graphics.f("#660000").s().p("AgCgHQAFAAABAPg");
	this.shape_1270.setTransform(83.5494,255.5454,0.5647,0.5647);

	this.shape_1271 = new cjs.Shape();
	this.shape_1271.graphics.f("#660000").s().p("AASANQgkgMgMACIgggUQAdANBgANQgJAJgOAAQgKAAgMgFg");
	this.shape_1271.setTransform(93.2475,255.5122,0.5647,0.5647);

	this.shape_1272 = new cjs.Shape();
	this.shape_1272.graphics.f("#660000").s().p("AgDAMIAHgXIgEAXg");
	this.shape_1272.setTransform(68.741,254.162,0.5647,0.5647);

	this.shape_1273 = new cjs.Shape();
	this.shape_1273.graphics.f("#660000").s().p("AgGgEQAGgCAIALQgPAAABgJg");
	this.shape_1273.setTransform(74.8801,253.1691,0.5647,0.5647);

	this.shape_1274 = new cjs.Shape();
	this.shape_1274.graphics.f("#660000").s().p("AgBAEIAAgHIADAAIAAAHg");
	this.shape_1274.setTransform(72.0443,247.6542,0.5647,0.5647);

	this.shape_1275 = new cjs.Shape();
	this.shape_1275.graphics.f("#660000").s().p("AAAAJIgNgJQAVAIAGgRIAAAPQgEAEgEAAQgDAAgDgBg");
	this.shape_1275.setTransform(82.8012,238.641,0.5647,0.5647);

	this.shape_1276 = new cjs.Shape();
	this.shape_1276.graphics.f("#660000").s().p("AgLgNQAEgBAHAJQAHAGAFgBQABAEgIAKg");
	this.shape_1276.setTransform(82.4655,236.4173,0.5647,0.5647);

	this.shape_1277 = new cjs.Shape();
	this.shape_1277.graphics.f("#660000").s().p("AAEhOQAJAZgGAnQgHAqAEAUIgNAfQAQh+gDgfg");
	this.shape_1277.setTransform(73.3329,238.6901,0.5647,0.5647);

	this.shape_1278 = new cjs.Shape();
	this.shape_1278.graphics.f("#660000").s().p("AgBAIQgHgHAAgLQAFAKAMAGQgDAFgDAAQgCAAgCgDg");
	this.shape_1278.setTransform(82.5188,233.8922,0.5647,0.5647);

	this.shape_1279 = new cjs.Shape();
	this.shape_1279.graphics.f("#660000").s().p("AgBgNIADANIAAAOg");
	this.shape_1279.setTransform(73.1877,232.4788,0.5647,0.5647);

	this.shape_1280 = new cjs.Shape();
	this.shape_1280.graphics.f("#660000").s().p("AgCAEIAAgHIAFAAIAAAHg");
	this.shape_1280.setTransform(81.3754,230.0507,0.5647,0.5647);

	this.shape_1281 = new cjs.Shape();
	this.shape_1281.graphics.f("#660000").s().p("AgBAHIAAgNIADAAIAAANg");
	this.shape_1281.setTransform(72.9901,230.1072,0.5647,0.5647);

	this.shape_1282 = new cjs.Shape();
	this.shape_1282.graphics.f("#660000").s().p("AgDAKIAHgTIgEATg");
	this.shape_1282.setTransform(80.4296,228.8931,0.5647,0.5647);

	this.shape_1283 = new cjs.Shape();
	this.shape_1283.graphics.f("#660000").s().p("AgIgxQAEASAKAbQAKAjgUASQAFgigJhAg");
	this.shape_1283.setTransform(79.4979,225.2934,0.5647,0.5647);

	this.shape_1284 = new cjs.Shape();
	this.shape_1284.graphics.f("#660000").s().p("AgCAAQgGhjgMg1QANAzAPAhIgEgGQgNAMAJAXQAKAcgCALIANAaQgIADACAMIADASQgIAAgCAFQAVA0gPAlQgLgygFhng");
	this.shape_1284.setTransform(71.8749,219.6749,0.5647,0.5647);

	this.shape_1285 = new cjs.Shape();
	this.shape_1285.graphics.f("#660000").s().p("AgBAFQgSg1AAgiIAEAAQAWBQANBVQgFgbgQgzg");
	this.shape_1285.setTransform(77.1827,213.9436,0.5647,0.5647);

	this.shape_1286 = new cjs.Shape();
	this.shape_1286.graphics.f("#660000").s().p("AgBgIIADAEIAAANg");
	this.shape_1286.setTransform(75.5311,206.5606,0.5647,0.5647);

	this.shape_1287 = new cjs.Shape();
	this.shape_1287.graphics.f("#660000").s().p("AgKgIIAMAFIAJALg");
	this.shape_1287.setTransform(74.5288,207.0829,0.5647,0.5647);

	this.shape_1288 = new cjs.Shape();
	this.shape_1288.graphics.f("#660000").s().p("AgCAEIAAgHIAFAAIAAAHg");
	this.shape_1288.setTransform(69.1645,205.8547,0.5647,0.5647);

	this.shape_1289 = new cjs.Shape();
	this.shape_1289.graphics.f("#660000").s().p("AgFAAQAPgKACgIIAGADIgjAiQgBgLANgIg");
	this.shape_1289.setTransform(78.5925,196.4389,0.5647,0.5647);

	this.shape_1290 = new cjs.Shape();
	this.shape_1290.graphics.f("#660000").s().p("AgGgGIANAHIgEAGg");
	this.shape_1290.setTransform(59.5793,194.8155,0.5647,0.5647);

	this.shape_1291 = new cjs.Shape();
	this.shape_1291.graphics.f("#660000").s().p("AgDAEIAAgHIAHAAIAAAHg");
	this.shape_1291.setTransform(82.9988,191.978,0.5647,0.5647);

	this.shape_1292 = new cjs.Shape();
	this.shape_1292.graphics.f("#660000").s().p("AgIgEQAPgEACAIQgCAGgMAAg");
	this.shape_1292.setTransform(64.633,193.5088,0.5647,0.5647);

	this.shape_1293 = new cjs.Shape();
	this.shape_1293.graphics.f("#660000").s().p("AACAIQgPgDgGgMIAnAGQgCAJgKAAIgGAAg");
	this.shape_1293.setTransform(61.7391,193.1559,0.5647,0.5647);

	this.shape_1294 = new cjs.Shape();
	this.shape_1294.graphics.f("#660000").s().p("AgCgDIAFAAIAAAHg");
	this.shape_1294.setTransform(84.3822,189.4794,0.5647,0.5647);

	this.shape_1295 = new cjs.Shape();
	this.shape_1295.graphics.f("#660000").s().p("Ag0BYIgoAAQAfgQARgFQAdgJAPAaQASgBACgNQADgWABgCQAZgeAMgwIAKAUIgPAIQAKAJgKAKQgLAJAFALQgQAKgBASIACAjQgOgTgVARQgWARgMgTQgKACgBALQgCAMgFAEgAA8ghIABgBIAQhXQASAOgDAVIgKArQgJgCgMALIAAACg");
	this.shape_1295.setTransform(73.0554,187.7148,0.5647,0.5647);

	this.shape_1296 = new cjs.Shape();
	this.shape_1296.graphics.f("#660000").s().p("AgHABIAGgDQAJgGgBANg");
	this.shape_1296.setTransform(104.4164,178.8115,0.5647,0.5647);

	this.shape_1297 = new cjs.Shape();
	this.shape_1297.graphics.f("#660000").s().p("AgOgDQAjgpALgVQgEAOgjA1QgdApAKAXQgOgfAagmg");
	this.shape_1297.setTransform(87.7525,182.1811,0.5647,0.5647);

	this.shape_1298 = new cjs.Shape();
	this.shape_1298.graphics.f("#660000").s().p("AgcAFIgTgJQALgNAXASQAIAHAGACIgBAAQgQAAgMgFgAAWABIAagFQgGAHgZAFIgEABQAFgDAEgFg");
	this.shape_1298.setTransform(95.7603,177.426,0.5647,0.5647);

	this.shape_1299 = new cjs.Shape();
	this.shape_1299.graphics.f("#660000").s().p("AgDAEIAAgHIAHAAIAAAHg");
	this.shape_1299.setTransform(109.1429,175.8286,0.5647,0.5647);

	this.shape_1300 = new cjs.Shape();
	this.shape_1300.graphics.f("#660000").s().p("AgCgEIAFAAIAAAJg");
	this.shape_1300.setTransform(76.6322,176.0121,0.5647,0.5647);

	this.shape_1301 = new cjs.Shape();
	this.shape_1301.graphics.f("#660000").s().p("AgCAEIAAgHIAFAAIAAAHg");
	this.shape_1301.setTransform(110.3004,174.6851,0.5647,0.5647);

	this.shape_1302 = new cjs.Shape();
	this.shape_1302.graphics.f("#660000").s().p("AgXgmQAWApAYAMIgLAYQgegPgFg+g");
	this.shape_1302.setTransform(83.3235,176.2944,0.5647,0.5647);

	this.shape_1303 = new cjs.Shape();
	this.shape_1303.graphics.f("#660000").s().p("AgDAEIAAgHIAHAAIAAAHg");
	this.shape_1303.setTransform(75.8558,173.3017,0.5647,0.5647);

	this.shape_1304 = new cjs.Shape();
	this.shape_1304.graphics.f("#660000").s().p("AgSACQgDADgTAIQgFgLAKgHQANgLAEgFQANgBARANQAVAPAKACQgHACAAANQgMgagqAFg");
	this.shape_1304.setTransform(89.2179,172.8358,0.5647,0.5647);

	this.shape_1305 = new cjs.Shape();
	this.shape_1305.graphics.f("#660000").s().p("AgJAKIAFgTIAOATg");
	this.shape_1305.setTransform(80.8531,172.1441,0.5647,0.5647);

	this.shape_1306 = new cjs.Shape();
	this.shape_1306.graphics.f("#660000").s().p("AgGgDIAEgGIAJATg");
	this.shape_1306.setTransform(73.7524,170.7466,0.5647,0.5647);

	this.shape_1307 = new cjs.Shape();
	this.shape_1307.graphics.f("#660000").s().p("AgCAEQgSgzgEgDQAHABARArQASAsAHADIAAAKQgLAAgQgvg");
	this.shape_1307.setTransform(71.9737,165.3681,0.5647,0.5647);

	this.shape_1308 = new cjs.Shape();
	this.shape_1308.graphics.f("#660000").s().p("AgDAEIAAgHIAHAAIAAAHg");
	this.shape_1308.setTransform(68.2892,161.486,0.5647,0.5647);

	this.shape_1309 = new cjs.Shape();
	this.shape_1309.graphics.f("#660000").s().p("AAIAPQgKgRgNACIgPgZQAzASAKAeQgEADgEAAQgIAAgHgLg");
	this.shape_1309.setTransform(75.0652,161.4407,0.5647,0.5647);

	this.shape_1310 = new cjs.Shape();
	this.shape_1310.graphics.f("#660000").s().p("AgDADIAAgFIAHAAIAAAFg");
	this.shape_1310.setTransform(67.6963,159.2415,0.5647,0.5647);

	this.shape_1311 = new cjs.Shape();
	this.shape_1311.graphics.f("#660000").s().p("AgDAEIAAgHIAHAAIAAAHg");
	this.shape_1311.setTransform(71.169,157.5616,0.5647,0.5647);

	this.shape_1312 = new cjs.Shape();
	this.shape_1312.graphics.f("#660000").s().p("AgHgCQAMAAADAFg");
	this.shape_1312.setTransform(103.5668,158.8886,0.5647,0.5647);

	this.shape_1313 = new cjs.Shape();
	this.shape_1313.graphics.f("#660000").s().p("AgBAPIAAgcIADAAIAAAcg");
	this.shape_1313.setTransform(67.9363,154.4277,0.5647,0.5647);

	this.shape_1314 = new cjs.Shape();
	this.shape_1314.graphics.f("#660000").s().p("AgBgLIADAEIAAATg");
	this.shape_1314.setTransform(102.4233,156.164,0.5647,0.5647);

	this.shape_1315 = new cjs.Shape();
	this.shape_1315.graphics.f("#660000").s().p("AgEAEIAAgHIAIAAIAAAHg");
	this.shape_1315.setTransform(106.5031,147.1294,0.5647,0.5647);

	this.shape_1316 = new cjs.Shape();
	this.shape_1316.graphics.f("#660000").s().p("AAAgBQgmgVgMgTIA3AmQAhAVANAYQgPgWgkgVg");
	this.shape_1316.setTransform(64.0401,141.4686,0.5647,0.5647);

	this.shape_1317 = new cjs.Shape();
	this.shape_1317.graphics.f("#660000").s().p("AgEAIQAEgYAIgNQADAQgHAPIgKAcIgBAAQgCAAAFgWg");
	this.shape_1317.setTransform(70.8609,139.9042,0.5647,0.5647);

	this.shape_1318 = new cjs.Shape();
	this.shape_1318.graphics.f("#660000").s().p("AgTgPIAZARIAOAOg");
	this.shape_1318.setTransform(63.419,138.6876,0.5647,0.5647);

	this.shape_1319 = new cjs.Shape();
	this.shape_1319.graphics.f("#660000").s().p("AAGgcQAFAPgJASIgJAXg");
	this.shape_1319.setTransform(74.1011,137.403,0.5647,0.5647);

	this.shape_1320 = new cjs.Shape();
	this.shape_1320.graphics.f("#660000").s().p("AgEADIAAgFIAIAAIAAAFg");
	this.shape_1320.setTransform(59.0428,135.2714,0.5647,0.5647);

	this.shape_1321 = new cjs.Shape();
	this.shape_1321.graphics.f("#660000").s().p("AgEgCQAFgCAEAHg");
	this.shape_1321.setTransform(69.7856,120.5599,0.5647,0.5647);

	this.shape_1322 = new cjs.Shape();
	this.shape_1322.graphics.f("#660000").s().p("AgDAEIAAgHIAHAAIAAAHg");
	this.shape_1322.setTransform(62.5296,108.8309,0.5647,0.5647);

	this.shape_1323 = new cjs.Shape();
	this.shape_1323.graphics.f("#000000").s().p("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");
	this.shape_1323.setTransform(73.5548,176.7167,0.5647,0.5647);

	this.shape_1324 = new cjs.Shape();
	this.shape_1324.graphics.f("#660000").s().p("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");
	this.shape_1324.setTransform(73.5689,175.9274,0.5647,0.5647);

	this.shape_1325 = new cjs.Shape();
	this.shape_1325.graphics.f("#000000").s().p("An2VtQiSgGhWAFIgEgWQhOgTgdAQQgcAPhRgWQgbgHhZAGQhLAGgmgXQghgCgpgaQgsgfgXgMQgpgohYgQQhrgSgegQQhegZiRATQgZAJglABIg/AAQgIl1AvoWQA8pbAXkvQBQgBAKgEQgjhWAjgnQAugVAhA5QAEALAEAYQAEAVAKALQAhgDAtgQIBMgeQBcggBAAkQALACANgUQAMgTAQAFQBHiJASgqQgIgbg6gSQgGgCgpAJQgdAHgNgXQAWh9BDgdQAEAGAHAYQAFASAOAGQBIAYAfghQAMgTAEgLQgGgKgQgVQgKgSAQgOQAigkBVAtQAdAigDAUIgpAbQgVASAEAXQAHAIACAQIABAeQANAEAUAOIAgAYQApAZAjgWQgBAggrBhQggAGgwghQgygigiADQggAtgaBwIAWAKQAMAIgGAOQBFgIAkgGQBAgLAigiQBLgVBvAcQCKAjAvAAIjwAHQAKAIA0gEIBCAEQBKAEA/AAQBQAAA9gHQAkgEAdgFIAbgGQAIgFgBgRIgEggQgKhEAIgqQAKgZAYgKQAZgLAaALQArBpgFAzQALAaAdgGQAigOAOgCIAegWQARgNAHgPQADgjgGhoQgFhOARg4QAGADAGgHIAJgLQABgSAVgLIAjgTQAMAIA6APQAtAMAMAgQAeCLgIBOQALgDAkALQAfAKATgLQBBgWBegDQBuAAA6gBIAJgJQgPhHgQhyIgai3QBOh/B4gbQA1gGAZACQAsADAZAYQAsA4AHBgQACAegFCNQACAXgEA9QgEA/ACAdQgJADAAAMQB7ggA+gPQBtgZBWACIAwAAQANhYAJgsQAOhLAagxQAtgUAsACQA0ADAgAiQAYA3gRBNQgKArgXBVQBxAgCfATQAXCvAABbQgIFmAaImQAkL0ADCOIAAAfQhFgDg2gSQglgHg+AMQhFAOgfgCIgNgWQhBAPhogBQhygBg5AJQg6AIiNAEQh+ADhGAOQF2ASiFAHQg+ASh2AEQiRAEgqAGQgRgJgjAAQghABgSgLQguAGiIgFQhzgEhBASQBPATApgGQhLAYhAgJQhTgMg3AHQgQgLgpgHQgogHgSgNQheANgTAVQgWAXhcAQQgJABgagCQgXAAgMAKQgtAAi3gIg");
	this.shape_1325.setTransform(107.7122,294.5639,0.5647,0.5647);

	this.shape_1326 = new cjs.Shape();
	this.shape_1326.graphics.f("#330000").s().p("EAAPAyGIUviKMgxTAAoIgn1NIBE9LMgAngv8IM6B2IkdiUIOwBFIfUg7IBZCdIBiY5IiJQTMABsA4qg");
	this.shape_1326.setTransform(110.0181,190.9757,0.5647,0.5647);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_1326},{t:this.shape_1325},{t:this.shape_1324},{t:this.shape_1323},{t:this.shape_1322},{t:this.shape_1321},{t:this.shape_1320},{t:this.shape_1319},{t:this.shape_1318},{t:this.shape_1317},{t:this.shape_1316},{t:this.shape_1315},{t:this.shape_1314},{t:this.shape_1313},{t:this.shape_1312},{t:this.shape_1311},{t:this.shape_1310},{t:this.shape_1309},{t:this.shape_1308},{t:this.shape_1307},{t:this.shape_1306},{t:this.shape_1305},{t:this.shape_1304},{t:this.shape_1303},{t:this.shape_1302},{t:this.shape_1301},{t:this.shape_1300},{t:this.shape_1299},{t:this.shape_1298},{t:this.shape_1297},{t:this.shape_1296},{t:this.shape_1295},{t:this.shape_1294},{t:this.shape_1293},{t:this.shape_1292},{t:this.shape_1291},{t:this.shape_1290},{t:this.shape_1289},{t:this.shape_1288},{t:this.shape_1287},{t:this.shape_1286},{t:this.shape_1285},{t:this.shape_1284},{t:this.shape_1283},{t:this.shape_1282},{t:this.shape_1281},{t:this.shape_1280},{t:this.shape_1279},{t:this.shape_1278},{t:this.shape_1277},{t:this.shape_1276},{t:this.shape_1275},{t:this.shape_1274},{t:this.shape_1273},{t:this.shape_1272},{t:this.shape_1271},{t:this.shape_1270},{t:this.shape_1269},{t:this.shape_1268},{t:this.shape_1267},{t:this.shape_1266},{t:this.shape_1265},{t:this.shape_1264},{t:this.shape_1263},{t:this.shape_1262},{t:this.shape_1261},{t:this.shape_1260},{t:this.shape_1259},{t:this.shape_1258},{t:this.shape_1257},{t:this.shape_1256},{t:this.shape_1255},{t:this.shape_1254},{t:this.shape_1253},{t:this.shape_1252},{t:this.shape_1251},{t:this.shape_1250},{t:this.shape_1249},{t:this.shape_1248},{t:this.shape_1247},{t:this.shape_1246},{t:this.shape_1245},{t:this.shape_1244},{t:this.shape_1243},{t:this.shape_1242},{t:this.shape_1241},{t:this.shape_1240},{t:this.shape_1239},{t:this.shape_1238},{t:this.shape_1237},{t:this.shape_1236},{t:this.shape_1235},{t:this.shape_1234},{t:this.shape_1233},{t:this.shape_1232},{t:this.shape_1231},{t:this.shape_1230},{t:this.shape_1229},{t:this.shape_1228},{t:this.shape_1227},{t:this.shape_1226},{t:this.shape_1225},{t:this.shape_1224},{t:this.shape_1223},{t:this.shape_1222},{t:this.shape_1221},{t:this.shape_1220},{t:this.shape_1219},{t:this.shape_1218},{t:this.shape_1217},{t:this.shape_1216},{t:this.shape_1215},{t:this.shape_1214},{t:this.shape_1213},{t:this.shape_1212},{t:this.shape_1211},{t:this.shape_1210},{t:this.shape_1209},{t:this.shape_1208},{t:this.shape_1207},{t:this.shape_1206},{t:this.shape_1205},{t:this.shape_1204},{t:this.shape_1203},{t:this.shape_1202},{t:this.shape_1201},{t:this.shape_1200},{t:this.shape_1199},{t:this.shape_1198},{t:this.shape_1197},{t:this.shape_1196},{t:this.shape_1195},{t:this.shape_1194},{t:this.shape_1193},{t:this.shape_1192},{t:this.shape_1191},{t:this.shape_1190},{t:this.shape_1189},{t:this.shape_1188},{t:this.shape_1187},{t:this.shape_1186},{t:this.shape_1185},{t:this.shape_1184},{t:this.shape_1183},{t:this.shape_1182},{t:this.shape_1181},{t:this.shape_1180},{t:this.shape_1179},{t:this.shape_1178},{t:this.shape_1177},{t:this.shape_1176},{t:this.shape_1175},{t:this.shape_1174},{t:this.shape_1173},{t:this.shape_1172},{t:this.shape_1171},{t:this.shape_1170},{t:this.shape_1169},{t:this.shape_1168},{t:this.shape_1167},{t:this.shape_1166},{t:this.shape_1165},{t:this.shape_1164},{t:this.shape_1163},{t:this.shape_1162},{t:this.shape_1161},{t:this.shape_1160},{t:this.shape_1159},{t:this.shape_1158},{t:this.shape_1157},{t:this.shape_1156},{t:this.shape_1155},{t:this.shape_1154},{t:this.shape_1153},{t:this.shape_1152},{t:this.shape_1151},{t:this.shape_1150},{t:this.shape_1149},{t:this.shape_1148},{t:this.shape_1147},{t:this.shape_1146},{t:this.shape_1145},{t:this.shape_1144},{t:this.shape_1143},{t:this.shape_1142},{t:this.shape_1141},{t:this.shape_1140},{t:this.shape_1139},{t:this.shape_1138},{t:this.shape_1137},{t:this.shape_1136},{t:this.shape_1135},{t:this.shape_1134},{t:this.shape_1133},{t:this.shape_1132},{t:this.shape_1131},{t:this.shape_1130},{t:this.shape_1129},{t:this.shape_1128},{t:this.shape_1127},{t:this.shape_1126},{t:this.shape_1125},{t:this.shape_1124},{t:this.shape_1123},{t:this.shape_1122},{t:this.shape_1121},{t:this.shape_1120},{t:this.shape_1119},{t:this.shape_1118},{t:this.shape_1117},{t:this.shape_1116},{t:this.shape_1115},{t:this.shape_1114},{t:this.shape_1113},{t:this.shape_1112},{t:this.shape_1111},{t:this.shape_1110},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1107},{t:this.shape_1106},{t:this.shape_1105},{t:this.shape_1104},{t:this.shape_1103},{t:this.shape_1102},{t:this.shape_1101},{t:this.shape_1100},{t:this.shape_1099},{t:this.shape_1098},{t:this.shape_1097},{t:this.shape_1096},{t:this.shape_1095},{t:this.shape_1094}]},2).to({state:[]},1).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(144.3,-160.2,311.2,578.5999999999999);
// library properties:
lib.properties = {
	id: '4D84B53DE80A2048AFA0B2FAA91023E1',
	width: 382,
	height: 380,
	fps: 60,
	color: "#000000",
	opacity: 1.00,
	manifest: [
		{src:"https://cdn.shopify.com/s/files/1/0636/8873/6998/files/CachedBmp_1343.png?v=1681898291", id:"CachedBmp_1343"},
		{src:"https://cdn.shopify.com/s/files/1/0636/8873/6998/files/CachedBmp_1342.png?v=1681898291", id:"CachedBmp_1342"},
		{src:"https://cdn.shopify.com/s/files/1/0636/8873/6998/files/DeathrisHTML5_atlas.png?v=1681898290", id:"DeathrisHTML5_atlas_"},
		{src:"https://cdn.shopify.com/s/files/1/0636/8873/6998/files/DeathrisHTML5_atlas_2.png?v=1681898290", id:"DeathrisHTML5_atlas_2"},
		{src:"https://cdn.shopify.com/s/files/1/0636/8873/6998/files/DeathrisHTML5_atlas_3.png?v=1681898290", id:"DeathrisHTML5_atlas_3"},
		{src:"https://cdn.shopify.com/s/files/1/0636/8873/6998/files/DeathrisHTML5_atlas_4.png?v=1681898291", id:"DeathrisHTML5_atlas_4"},
		{src:"https://cdn.shopify.com/s/files/1/0636/8873/6998/files/sfx_click.mp3?v=1681897006", id:"sfx_click"},
		{src:"https://cdn.shopify.com/s/files/1/0636/8873/6998/files/sfx_theme.mp3?v=1681897007", id:"sfx_theme"},
		{src:"https://cdn.shopify.com/s/files/1/0636/8873/6998/files/sfx_gameover.mp3?v=1681897006", id:"sfx_gameover"},
		{src:"https://cdn.shopify.com/s/files/1/0636/8873/6998/files/sfx_glassbreak.mp3?v=1681897006", id:"sfx_glassbreak"},
		{src:"https://cdn.shopify.com/s/files/1/0636/8873/6998/files/sfx_glassbreak2.mp3?v=1681897006", id:"sfx_glassbreak2"},
		{src:"https://cdn.shopify.com/s/files/1/0636/8873/6998/files/sfx_latch.mp3?v=1681897006", id:"sfx_latch"},
		{src:"https://cdn.shopify.com/s/files/1/0636/8873/6998/files/sfx_lever.mp3?v=1681897006", id:"sfx_lever"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.StageGL();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['4D84B53DE80A2048AFA0B2FAA91023E1'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = window.innerWidth, ih=window.innerHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}			
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;			
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});			
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;			
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
var createjs, AdobeAn;